/*! pace 1.0.2 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X=[].slice,Y={}.hasOwnProperty,Z=function(a,b){function c(){this.constructor=a}for(var d in b)Y.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},$=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};for(u={catchupTime:100,initialRate:.03,minTime:250,ghostTime:100,maxProgressPerFrame:20,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnRequestAfter:500,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10,sampleCount:3,lagThreshold:3},ajax:{trackMethods:["GET"],trackWebSockets:!0,ignoreURLs:[]}},C=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance.now():void 0)?a:+new Date},E=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,t=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==E&&(E=function(a){return setTimeout(a,50)},t=function(a){return clearTimeout(a)}),G=function(a){var b,c;return b=C(),(c=function(){var d;return d=C()-b,d>=33?(b=C(),a(d,function(){return E(c)})):setTimeout(c,33-d)})()},F=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?X.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},v=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?X.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)Y.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?v(b[a],e):b[a]=e);return b},q=function(a){var b,c,d,e,f;for(c=b=0,e=0,f=a.length;f>e;e++)d=a[e],c+=Math.abs(d),b++;return c/b},x=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},g=function(){function a(){}return a.prototype.on=function(a,b,c,d){var e;return null==d&&(d=!1),null==this.bindings&&(this.bindings={}),null==(e=this.bindings)[a]&&(e[a]=[]),this.bindings[a].push({handler:b,ctx:c,once:d})},a.prototype.once=function(a,b,c){return this.on(a,b,c,!0)},a.prototype.off=function(a,b){var c,d,e;if(null!=(null!=(d=this.bindings)?d[a]:void 0)){if(null==b)return delete this.bindings[a];for(c=0,e=[];c<this.bindings[a].length;)e.push(this.bindings[a][c].handler===b?this.bindings[a].splice(c,1):c++);return e}},a.prototype.trigger=function(){var a,b,c,d,e,f,g,h,i;if(c=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],null!=(g=this.bindings)?g[c]:void 0){for(e=0,i=[];e<this.bindings[c].length;)h=this.bindings[c][e],d=h.handler,b=h.ctx,f=h.once,d.apply(null!=b?b:this,a),i.push(f?this.bindings[c].splice(e,1):e++);return i}},a}(),j=window.Pace||{},window.Pace=j,v(j,g.prototype),D=j.options=v({},u,window.paceOptions,x()),U=["ajax","document","eventLag","elements"],Q=0,S=U.length;S>Q;Q++)K=U[Q],D[K]===!0&&(D[K]=u[K]);i=function(a){function b(){return V=b.__super__.constructor.apply(this,arguments)}return Z(b,a),b}(Error),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;if(null==this.el){if(a=document.querySelector(D.target),!a)throw new i;this.el=document.createElement("div"),this.el.className="pace pace-active",document.body.className=document.body.className.replace(/pace-done/g,""),document.body.className+=" pace-running",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)}return this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive",document.body.className=document.body.className.replace("pace-running",""),document.body.className+=" pace-done"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){try{this.getElement().parentNode.removeChild(this.getElement())}catch(a){i=a}return this.el=void 0},a.prototype.render=function(){var a,b,c,d,e,f,g;if(null==document.querySelector(D.target))return!1;for(a=this.getElement(),d="translate3d("+this.progress+"%, 0, 0)",g=["webkitTransform","msTransform","transform"],e=0,f=g.length;f>e;e++)b=g[e],a.children[0].style[b]=d;return(!this.lastRenderedProgress||this.lastRenderedProgress|0!==this.progress|0)&&(a.children[0].setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?c="99":(c=this.progress<10?"0":"",c+=0|this.progress),a.children[0].setAttribute("data-progress",""+c)),this.lastRenderedProgress=this.progress},a.prototype.done=function(){return this.progress>=100},a}(),h=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),P=window.XMLHttpRequest,O=window.XDomainRequest,N=window.WebSocket,w=function(a,b){var c,d,e;e=[];for(d in b.prototype)try{e.push(null==a[d]&&"function"!=typeof b[d]?"function"==typeof Object.defineProperty?Object.defineProperty(a,d,{get:function(){return b.prototype[d]},configurable:!0,enumerable:!0}):a[d]=b.prototype[d]:void 0)}catch(f){c=f}return e},A=[],j.ignore=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("ignore"),c=b.apply(null,a),A.shift(),c},j.track=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("track"),c=b.apply(null,a),A.shift(),c},J=function(a){var b;if(null==a&&(a="GET"),"track"===A[0])return"force";if(!A.length&&D.ajax){if("socket"===a&&D.ajax.trackWebSockets)return!0;if(b=a.toUpperCase(),$.call(D.ajax.trackMethods,b)>=0)return!0}return!1},k=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){return J(d)&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new P(b),a(c),c};try{w(window.XMLHttpRequest,P)}catch(d){}if(null!=O){window.XDomainRequest=function(){var b;return b=new O,a(b),b};try{w(window.XDomainRequest,O)}catch(d){}}if(null!=N&&D.ajax.trackWebSockets){window.WebSocket=function(a,b){var d;return d=null!=b?new N(a,b):new N(a),J("socket")&&c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d};try{w(window.WebSocket,N)}catch(d){}}}return Z(b,a),b}(h),R=null,y=function(){return null==R&&(R=new k),R},I=function(a){var b,c,d,e;for(e=D.ajax.ignoreURLs,c=0,d=e.length;d>c;c++)if(b=e[c],"string"==typeof b){if(-1!==a.indexOf(b))return!0}else if(b.test(a))return!0;return!1},y().on("request",function(b){var c,d,e,f,g;return f=b.type,e=b.request,g=b.url,I(g)?void 0:j.running||D.restartOnRequestAfter===!1&&"force"!==J(f)?void 0:(d=arguments,c=D.restartOnRequestAfter||0,"boolean"==typeof c&&(c=0),setTimeout(function(){var b,c,g,h,i,k;if(b="socket"===f?e.readyState<2:0<(h=e.readyState)&&4>h){for(j.restart(),i=j.sources,k=[],c=0,g=i.length;g>c;c++){if(K=i[c],K instanceof a){K.watch.apply(K,d);break}k.push(void 0)}return k}},c))}),a=function(){function a(){var a=this;this.elements=[],y().on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d,e;return d=a.type,b=a.request,e=a.url,I(e)?void 0:(c="socket"===d?new n(b):new o(b),this.elements.push(c))},a}(),o=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2},!1),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100},!1);else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),n=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100},!1)}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},D.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d,e,f=this;this.progress=0,a=0,e=[],d=0,c=C(),b=setInterval(function(){var g;return g=C()-c-50,c=C(),e.push(g),e.length>D.eventLag.sampleCount&&e.shift(),a=q(e),++d>=D.eventLag.minSamples&&a<D.eventLag.lagThreshold?(f.progress=100,clearInterval(b)):f.progress=100*(3/(a+3))},50)}return a}(),m=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=D.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=F(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=F(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/D.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,D.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+D.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),L=null,H=null,r=null,M=null,p=null,s=null,j.running=!1,z=function(){return D.restartOnPushState?j.restart():void 0},null!=window.history.pushState&&(T=window.history.pushState,window.history.pushState=function(){return z(),T.apply(window.history,arguments)}),null!=window.history.replaceState&&(W=window.history.replaceState,window.history.replaceState=function(){return z(),W.apply(window.history,arguments)}),l={ajax:a,elements:d,document:c,eventLag:f},(B=function(){var a,c,d,e,f,g,h,i;for(j.sources=L=[],g=["ajax","elements","document","eventLag"],c=0,e=g.length;e>c;c++)a=g[c],D[a]!==!1&&L.push(new l[a](D[a]));for(i=null!=(h=D.extraSources)?h:[],d=0,f=i.length;f>d;d++)K=i[d],L.push(new K(D));return j.bar=r=new b,H=[],M=new m})(),j.stop=function(){return j.trigger("stop"),j.running=!1,r.destroy(),s=!0,null!=p&&("function"==typeof t&&t(p),p=null),B()},j.restart=function(){return j.trigger("restart"),j.stop(),j.start()},j.go=function(){var a;return j.running=!0,r.render(),a=C(),s=!1,p=G(function(b,c){var d,e,f,g,h,i,k,l,n,o,p,q,t,u,v,w;for(l=100-r.progress,e=p=0,f=!0,i=q=0,u=L.length;u>q;i=++q)for(K=L[i],o=null!=H[i]?H[i]:H[i]=[],h=null!=(w=K.elements)?w:[K],k=t=0,v=h.length;v>t;k=++t)g=h[k],n=null!=o[k]?o[k]:o[k]=new m(g),f&=n.done,n.done||(e++,p+=n.tick(b));return d=p/e,r.update(M.tick(b,d)),r.done()||f||s?(r.update(100),j.trigger("done"),setTimeout(function(){return r.finish(),j.running=!1,j.trigger("hide")},Math.max(D.ghostTime,Math.max(D.minTime-(C()-a),0)))):c()})},j.start=function(a){v(D,a),j.running=!0;try{r.render()}catch(b){i=b}return document.querySelector(".pace")?(j.trigger("start"),j.go()):setTimeout(j.start,50)},"function"==typeof define&&define.amd?define(["pace"],function(){return j}):"object"==typeof exports?module.exports=j:D.startOnPageLoad&&j.start()}).call(this);
//-------------------------------------------------------------
/*!
* country-region-selector
* ------------------------
* 0.5.0
* @author Ben Keen
* @repo https://github.com/benkeen/country-region-selector
* @licence MIT
*/

!function(a,n){if("function"==typeof define&&define.amd)define([],n);else if("object"==typeof exports)try{module.exports=n(require())}catch(a){module.exports=n()}else a.crs=n()}(this,function(){"use strict";var m=!0,h=!0,l=[],t={},s=[["Afghanistan","AF","Badakhshan~BDS|Badghis~BDG|Baghlan~BGL|Balkh~BAL|Bamyan~BAM|Daykundi~DAY|Farah~FRA|Faryab~FYB|Ghazni~GHA|Ghor~GHO|Helmand~HEL|Herat~HER|Jowzjan~JOW|Kabul~KAB|Kandahar~KAN|Kapisa~KAP|Khost~KHO|Kunar~KNR|Kunduz~KDZ|Laghman~LAG|Logar~LOW|Maidan Wardak~WAR|Nangarhar~NAN|Nimruz~NIM|Nuristan~NUR|Paktia~PIA|Paktika~PKA|Panjshir~PAN|Parwan~PAR|Samangan~SAM|Sar-e Pol~SAR|Takhar~TAK|Urozgan~ORU|Zabul~ZAB"],["Åland Islands","AX","Brändö~BR|Eckerö~EC|Finström~FN|Föglö~FG|Geta~GT|Hammarland~HM|Jomala~JM|Kumlinge~KM|Kökar~KK|Lemland~LE|Lumparland~LU|Mariehamn~MH|Saltvik~SV|Sottunga~ST|Sund~SD|Vårdö~VR"],["Albania","AL","Berat~01|Dibër~09|Durrës~02|Elbasan~03|Fier~04|Gjirokastër~05|Korçë~06|Kukës~07|Lezhë~08|Shkodër~10|Tirana~11|Vlorë~12"],["Algeria","DZ","Adrar~01|Aïn Defla~44|Aïn Témouchent~46|Algiers~16|Annaba~23|Batna~05|Béchar~08|Béjaïa~06|Biskra~07|Blida~09|Bordj Bou Arréridj~34|Bouïra~10|Boumerdès~35|Chlef~02|Constantine~25|Djelfa~17|El Bayadh~32|El Oued~39|El Tarf~36|Ghardaïa~47|Guelma~24|Illizi~33|Jijel~18|Khenchela~40|Laghouat~03|Mascara~29|Médéa~26|Mila~43|Mostaganem~27|Msila~28|Naâma~45|Oran~31|Ouargla~30|Oum el Bouaghi~04|Relizane~48|Saïda~20|Sétif~19|Sidi Bel Abbès~22|Skikda~21|Souk Ahras~41|Tamanghasset~11|Tébessa~12|Tiaret~14|Tindouf~37|Tipaza~42|Tissemsilt~38|Tizi Ouzou~15|Tlemcen~13"],["American Samoa","AS","Tutuila~01|Aunu'u~02|Ta'ū~03|Ofu‑Olosega~04|Rose Atoll~21|Swains Island~22"],["Andorra","AD","Andorra la Vella~07|Canillo~02|Encamp~03|Escaldes-Engordany~08|La Massana~04|Ordino~05|Sant Julià de Lòria~06"],["Angola","AO","Bengo~BGO|Benguela~BGU|Bié~BIE|Cabinda~CAB|Cuando Cubango~CCU|Cuanza Norte~CNO|Cuanza Sul~CUS|Cunene~CNN|Huambo~HUA|Huíla~HUI|Luanda~LUA|Lunda Norte~LNO|Lunda Sul~LSU|Malanje~MAL|Moxico~MOX|Namibe~NAM|Uíge~UIG|Zaire~ZAI"],["Anguilla","AI","Anguilla~01|Anguillita Island~02|Blowing Rock~03|Cove Cay~04|Crocus Cay~05|Deadman's Cay~06|Dog Island~07|East Cay~08|Little Island~09|Little Scrub Island~10|Mid Cay~11|North Cay~12|Prickly Pear Cays~13|Rabbit Island~14|Sandy Island/Sand Island~15|Scilly Cay~16|Scrub Island~17|Seal Island~18|Sombrero/Hat Island~19|South Cay~20|South Wager Island~21|West Cay~22"],["Antarctica","AQ","Antarctica~AQ"],["Antigua and Barbuda","AG","Antigua Island~01|Barbuda Island~02|Bird Island~04|Bishop Island~05|Blake Island~06|Crump Island~09|Dulcina Island~10|Exchange Island~11|Five Islands~12|Great Bird Island~13|Green Island~14|Guiana Island~15|Hawes Island~17|Hells Gate Island~16|Henry Island~18|Johnson Island~19|Kid Island~20|Lobster Island~22|Maiden Island~24|Moor Island~25|Nanny Island~26|Pelican Island~27|Prickly Pear Island~28|Rabbit Island~29|Red Head Island~31|Redonda Island~03|Sandy Island~32|Smith Island~33|The Sisters~34|Vernon Island~35|Wicked Will Island~36|York Island~37"],["Argentina","AR","Buenos Aires~B|Capital Federal~C|Catamarca~K|Chaco~H|Chubut~U|Córdoba~X|Corrientes~W|Entre Ríos~E|Formosa~P|Jujuy~Y|La Pampa~L|La Rioja~F|Mendoza~M|Misiones~N|Neuquén~Q|Río Negro~R|Salta~A|San Juan~J|San Luis~D|Santa Cruz~Z|Santa Fe~S|Santiago del Estero~G|Tierra del Fuego~V|Tucumán~T"],["Armenia","AM","Aragatsotn~AG|Ararat~AR|Armavir~AV|Gegharkunik~GR|Kotayk~KT|Lori~LO|Shirak~SH|Syunik~SU|Tavush~TV|Vayots Dzor~VD|Yerevan~ER"],["Aruba","AW","Aruba~AW"],["Australia","AU","Australian Capital Territory~ACT|New South Wales~NSW|Northern Territory~NT|Queensland~QLD|South Australia~SA|Tasmania~TAS|Victoria~VIC|Western Australia~WA"],["Austria","AT","Burgenland~1|Kärnten~2|Niederösterreich~3|Oberösterreich~4|Salzburg~5|Steiermark~6|Tirol~7|Vorarlberg~8|Wien~9"],["Azerbaijan","AZ","Abşeron~ABS|Ağcabədi~AGC|Ağdam~AGM|Ağdaş~AGS|Ağstafa~AGA|Ağsu~AGU|Astara~AST|Babək~BAB|Balakən~BAL|Bərdə~BAR|Beyləqan~BEY|Biləsuvar~BIL|Cəbrayıl~CAB|Cəlilabad~CAL|Culfa~CUL|Daşkəsən~DAS|Füzuli~FUZ|Gədəbəy~GAD|Goranboy~GOR|Göyçay~GOY|Göygöl~GYG|Hacıqabul~HAC|İmişli~IMI|İsmayıllı~ISM|Kəlbəcər~KAL|Kǝngǝrli~KAN|Kürdəmir~KUR|Laçın~LAC|Lənkəran~LAN|Lerik~LER|Masallı~MAS|Neftçala~NEF|Oğuz~OGU|Ordubad~ORD|Qəbələ~QAB|Qax~QAX|Qazax~QAZ|Qobustan~QOB|Quba~QBA|Qubadli~QBI|Qusar~QUS|Saatlı~SAT|Sabirabad~SAB|Şabran~SBN|Sədərək~SAD|Şahbuz~SAH|Şəki~SAK|Salyan~SAL|Şamaxı~SMI|Şəmkir~SKR|Samux~SMX|Şərur~SAR|Siyəzən~SIY|Şuşa~SUS|Tərtər~TAR|Tovuz~TOV|Ucar~UCA|Xaçmaz~XAC|Xızı~XIZ|Xocalı~XCI|Xocavənd~XVD|Yardımlı~YAR|Yevlax~YEV|Zəngilan~ZAN|Zaqatala~ZAQ|Zərdab~ZAR"],["Bahamas","BS","Acklins Island~01|Berry Islands~22|Bimini~02|Black Point~23|Cat Island~03|Central Abaco~24|Crooked Island and Long Cay~28|East Grand Bahama~29|Exuma~04|Freeport~05|Fresh Creek~06|Governor's Harbour~07|Green Turtle Cay~08|Harbour Island~09|High Rock~10|Inagua~11|Kemps Bay~12|Long Island~13|Marsh Harbour~14|Mayaguana~15|Moore’s Island~40|New Providence~16|Nichollstown and Berry Islands~17|North Abaco~42|North Andros~41|North Eleuthera~33|Ragged Island~18|Rock Sound~19|San Salvador and Rum Cay~20|Sandy Point~21|South Abaco~35|South Andros~36|South Eleuthera~37|West Grand Bahama~39"],["Bahrain","BH","Al Janūbīyah~14|Al Manāmah~13|Al Muḩarraq~15|Al Wusţá~16|Ash Shamālīyah~17"],["Bangladesh","BD","Barisal~A|Chittagong~B|Dhaka~C|Khulna~D|Mymensingh~M|Rajshahi~E|Rangpur~F|Sylhet~G"],["Barbados","BB","Christ Church~01|Saint Andrew~02|Saint George~03|Saint James~04|Saint John~05|Saint Joseph~06|Saint Lucy~07|Saint Michael~08|Saint Peter~09|Saint Philip~10|Saint Thomas~11"],["Belarus","BY","Brest voblast~BR|Gorod Minsk~HO|Homiel voblast~HO|Hrodna voblast~HR|Mahilyow voblast~MA|Minsk voblast~MI|Vitsebsk voblast~VI"],["Belgium","BE","Bruxelles-Capitale~BRU|Région Flamande~VLG|Région Wallonië~WAL"],["Belize","BZ","Belize District~BZ|Cayo District~CY|Corozal District~CZL|Orange Walk District~OW|Stann Creek District~SC|Toledo District~TOL"],["Benin","BJ","Alibori~AL|Atakora~AK|Atlantique~AQ|Borgou~BO|Collines Department~CO|Donga~DO|Kouffo~KO|Littoral Department~LI|Mono Department~MO|Ouémé~OU|Plateau~PL|Zou~ZO"],["Bermuda","BM","City of Hamilton~03|Devonshire Parish~01|Hamilton Parish~02|Paget Parish~04|Pembroke Parish~05|Sandys Parish~08|Smith's Parish~09|Southampton Parish~10|St. George's Parish~07|Town of St. George~06|Warwick Parish~11"],["Bhutan","BT","Bumthang~33|Chhukha~12|Dagana~22|Gasa~GA|Haa~13|Lhuntse~44|Mongar~42|Paro~11|Pemagatshel~43|Punakha~23|Samdrup Jongkhar~45|Samtse~14|Sarpang~31|Thimphu~15|Trashigang~41|Trashiyangtse~TY|Trongsa~32|Tsirang~21|Wangdue Phodrang~24|Zhemgang~34"],["Bolivia","BO","Beni~B|Chuquisaca~H|Cochabamba~C|La Paz~L|Oruro~O|Pando~N|Potosí~P|Santa Cruz~S|Tarija~T"],["Bonaire, Sint Eustatius and Saba","BQ","Bonaire~BO|Saba Isand~SA|Sint Eustatius~SE"],["Bosnia and Herzegovina","BA","Brčko Distrikt~BRC|Federacija Bosne i Hercegovine~BIH|Republika Srpska~SRP"],["Botswana","BW","Central~CE|Ghanzi~GH|Kgalagadi~KG|Kgatleng~KL|Kweneng~KW|North West~NW|North-East~NE|South East~SE|Southern~SO"],["Bouvet Island","BV","Bouvet Island~BV"],["Brazil","BR","Acre~AC|Alagoas~AL|Amapá~AP|Amazonas~AM|Bahia~BA|Ceará~CE|Distrito Federal~DF|Espírito Santo~ES|Goiás~GO|Maranhão~MA|Mato Grosso~MT|Mato Grosso do Sul~MS|Minas Gerais~MG|Pará~PA|Paraíba~PB|Paraná~PR|Pernambuco~PE|Piauí~PI|Rio de Janeiro~RJ|Rio Grande do Norte~RN|Rio Grande do Sul~RS|Rondônia~RO|Roraima~RR|Santa Catarina~SC|São Paulo~SP|Sergipe~SE|Tocantins~TO"],["British Indian Ocean Territory","IO","British Indian Ocean Territory~IO"],["Brunei Darussalam","BN","Belait~BE|Brunei Muara~BM|Temburong~TE|Tutong~TU"],["Bulgaria","BG","Blagoevgrad~01|Burgas~02|Dobrich~08|Gabrovo~07|Jambol~28|Khaskovo~26|Kjustendil~10|Kurdzhali~09|Lovech~11|Montana~12|Pazardzhik~13|Pernik~14|Pleven~15|Plovdiv~16|Razgrad~17|Ruse~18|Shumen~27|Silistra~19|Sliven~20|Smoljan~21|Sofija~23|Sofija-Grad~22|Stara Zagora~24|Turgovishhe~25|Varna~03|Veliko Turnovo~04|Vidin~05|Vraca~06"],["Burkina Faso","BF","Balé~BAL|Bam/Lake Bam~BAM|Banwa Province~BAN|Bazèga~BAZ|Bougouriba~BGR|Boulgou Province~BLG|Boulkiemdé~BLK|Comoé/Komoe~COM|Ganzourgou Province~GAN|Gnagna~GNA|Gourma Province~GOU|Houet~HOU|Ioba~IOB|Kadiogo~KAD|Kénédougou~KEN|Komondjari~KMD|Kompienga~KMP|Kossi Province~KOS|Koulpélogo~KOP|Kouritenga~KOT|Kourwéogo~KOW|Léraba~LER|Loroum~LOR|Mouhoun~MOU|Namentenga~NAM|Naouri/Nahouri~NAO|Nayala~NAY|Noumbiel~NOU|Oubritenga~OUB|Oudalan~OUD|Passoré~PAS|Poni~PON|Sanguié~SNG|Sanmatenga~SMT|Séno~SEN|Sissili~SIS|Soum~SOM|Sourou~SOR|Tapoa~TAP|Tui/Tuy~TUI|Yagha~YAG|Yatenga~YAT|Ziro~ZIR|Zondoma~ZON|Zoundwéogo~ZOU"],["Burundi","BI","Bubanza~BB|Bujumbura Mairie~BM|Bujumbura Rural~BL|Bururi~BR|Cankuzo~CA|Cibitoke~CI|Gitega~GI|Karuzi~KR|Kayanza~KY|Kirundo~KI|Makamba~MA|Muramvya~MU|Muyinga~MY|Mwaro~MW|Ngozi~NG|Rutana~RT|Ruyigi~RY"],["Cambodia","KH","Baat Dambang~2|Banteay Mean Chey~1|Kampong Chaam~3|Kampong Chhnang~4|Kampong Spueu~5|Kampong Thum~6|Kampot~7|Kandaal~8|Kaoh Kong~9|Kracheh~10|Krong Kaeb~23|Krong Pailin~24|Krong Preah Sihanouk~18|Mondol Kiri~11|Otdar Mean Chey~22|Phnom Penh~12|Pousaat~15|Preah Vihear~13|Prey Veaeng~14|Rotanah Kiri~16|Siem Reab~17|Stueng Treng~19|Svaay Rieng~20|Taakaev~21|Tbong Khmum~25"],["Cameroon","CM","Adamaoua~AD|Centre~CE|Est~ES|Extrême-Nord~EN|Littoral~LT|Nord~NO|Nord-Ouest~NW|Ouest~OU|Sud~SU|Sud-Ouest~SW"],["Canada","CA","Alberta~AB|British Columbia~BC|Manitoba~MB|New Brunswick~NB|Newfoundland and Labrador~NL|Northwest Territories~NT|Nova Scotia~NS|Nunavut~NU|Ontario~ON|Prince Edward Island~PE|Quebec~QC|Saskatchewan~SK|Yukon~YT"],["Cape Verde","CV","Boa Vista~BV|Brava~BR|Calheta de São Miguel~CS|Maio~MA|Mosteiros~MO|Paúl~PA|Porto Novo~PN|Praia~PR|Ribeira Brava~RB|Ribeira Grande~RG|Sal~SL|Santa Catarina~CA|Santa Cruz~CR|São Domingos~SD|São Filipe~SF|São Nicolau~SN|São Vicente~SV|Tarrafal~TA|Tarrafal de São Nicolau~TS"],["Cayman Islands","KY","Creek|Eastern|Midland|South Town|Spot Bay|Stake Bay|West End|Western"],["Central African Republic","CF","Bamingui-Bangoran~BB|Bangui~BGF|Basse-Kotto~BK|Haute-Kotto~HK|Haut-Mbomou~HM|Kémo~KG|Lobaye~LB|Mambéré-Kadéï~HS|Mbomou~MB|Nana-Grebizi~10|Nana-Mambéré~NM|Ombella-M'Poko~MP|Ouaka~UK|Ouham~AC|Ouham Péndé~OP|Sangha-Mbaéré~SE|Vakaga~VK"],["Chad","TD","Bahr el Ghazal~BG|Batha~BA|Borkou~BO|Chari-Baguirmi~CB|Ennedi-Est~EE|Ennedi-Ouest~EO|Guéra~GR|Hadjer Lamis~HL|Kanem~KA|Lac~LC|Logone Occidental~LO|Logone Oriental~LR|Mondoul~MA|Mayo-Kébbi-Est~ME|Moyen-Chari~MC|Ouaddai~OD|Salamat~SA|Sila~SI|Tandjilé~TA|Tibesti~TI|Ville de Ndjamena~ND|Wadi Fira~WF"],["Chile","CL","Aisén del General Carlos Ibáñez del Campo~AI|Antofagasta~AN|Araucanía~AR|Arica y Parinacota~AP|Atacama~AT|Bío-Bío~BI|Coquimbo~CO|Libertador General Bernardo O'Higgins~LI|Los Lagos~LL|Los Ríos~LR|Magallanes y Antartica Chilena~MA|Marga-Marga~|Maule~ML|Región Metropolitana de Santiago~RM|Tarapacá~TA|Valparaíso~VS"],["China","CN","Anhui~34|Beijing~11|Chongqing~50|Fujian~35|Gansu~62|Guangdong~44|Guangxi~45|Guizhou~52|Hainan~46|Hebei~13|Heilongjiang~23|Henan~41|Hong Kong~91|Hubei~42|Hunan~43|Inner Mongolia~15|Jiangsu~32|Jiangxi~36|Jilin~22|Liaoning~21|Macau~92|Ningxia~64|Qinghai~63|Shaanxi~61|Shandong~37|Shanghai~31|Shanxi~14|Sichuan~51|Tianjin~12|Tibet~54|Xinjiang~65|Yunnan~53|Zhejiang~33"],["Christmas Island","CX","Christmas Island~CX"],["Cocos (Keeling) Islands","CC","Direction Island~DI|Home Island~HM|Horsburgh Island~HR|North Keeling Island~NK|South Island~SI|West Island~WI"],["Colombia","CO","Amazonas~AMA|Antioquia~ANT|Arauca~ARA|Archipiélago de San Andrés~SAP|Atlántico~ATL|Bogotá D.C.~DC|Bolívar~BOL|Boyacá~BOY|Caldas~CAL|Caquetá~CAQ|Casanare~CAS|Cauca~CAU|Cesar~CES|Chocó~CHO|Córdoba~COR|Cundinamarca~CUN|Guainía~GUA|Guaviare~GUV|Huila~HUI|La Guajira~LAG|Magdalena~MAG|Meta~MET|Nariño~NAR|Norte de Santander~NSA|Putumayo~PUT|Quindío~QUI|Risaralda~RIS|Santander~SAN|Sucre~SUC|Tolima~TOL|Valle del Cauca~VAC|Vaupés~VAU|Vichada~VID"],["Comoros","KM","Andjazîdja~G|Andjouân~A|Moûhîlî~M"],["Congo, Republic of the (Brazzaville)","CG","Bouenza~11|Brazzaville~BZV|Cuvette~8|Cuvette-Ouest~15|Kouilou~5|Lékoumou~2|Likouala~7|Niari~9|Plateaux~14|Pointe-Noire~16|Pool~12|Sangha~13"],["Congo, the Democratic Republic of the (Kinshasa)","CD","Bandundu~BN|Bas-Congo~BC|Équateur~EQ|Kasaï-Occidental~KE|Kasaï-Oriental~KW|Katanga~KA|Kinshasa~KN|Maniema~MA|Nord-Kivu~NK|Orientale~OR|Sud-Kivu~SK"],["Cook Islands","CK","Aitutaki|Atiu|Avarua|Mangaia|Manihiki|Ma'uke|Mitiaro|Nassau|Palmerston|Penrhyn|Pukapuka|Rakahanga"],["Costa Rica","CR","Alajuela~2|Cartago~3|Guanacaste~5|Heredia~4|Limón~7|Puntarenas~6|San José~1"],["Côte d'Ivoire, Republic of","CI","Agnéby~16|Bafing~17|Bas-Sassandra~09|Denguélé~10|Dix-Huit Montagnes~06|Fromager~18|Haut-Sassandra~02|Lacs~07|Lagunes~01|Marahoué~12|Moyen-Cavally~19|Moyen-Comoé~05|N'zi-Comoé~11|Savanes~03|Sud-Bandama~15|Sud-Comoé~13|Vallée du Bandama~04|Worodougou~14|Zanzan~08"],["Croatia","HR","Bjelovarsko-Bilogorska Županija~07|Brodsko-Posavska Županija~12|Dubrovačko-Neretvanska Županija~19|Grad Zagreb~21|Istarska Županija~18|Karlovačka Županija~04|Koprivničko-Krizevačka Županija~06|Krapinsko-Zagorska Županija~02|Ličko-Senjska Županija~09|Međimurska Županija~20|Osječko-Baranjska Županija~14|Požeško-Slavonska Županija~11|Primorsko-Goranska Županija~08|Sisačko-Moslavačka Županija~03|Splitsko-Dalmatinska Županija~17|Sibensko-Kninska Županija~15|Varaždinska Županija~05|Virovitičko-Podravska Županija~10|Vukovarsko-Srijemska Županija~16|Zadarska Županija~13|Zagrebacka Zupanija~01"],["Cuba","CU","Artemisa~15|Camagüey~09|Ciego de Ávila~08|Cienfuegos~06|Granma~12|Guantánamo~14|Holguín~11|Isla de la Juventud~99|La Habana~03|Las Tunas~10|Matanzas~04|Mayabeque~16|Pinar del Río~01|Sancti Spíritus~07|Santiago de Cuba~13|Villa Clara~05"],["Curaçao","CW","Curaçao~CW"],["Cyprus","CY","Ammochostos~04|Keryneia~05|Larnaka~03|Lefkosia~01|Lemesos~02|Pafos~05"],["Czech Republic","CZ","Hlavní město Praha~PR|Jihočeský kraj~JC|Jihomoravský kraj~JM|Karlovarský kraj~KA|Královéhradecký kraj~KR|Liberecký kraj~LI|Moravskoslezský kraj~MO|Olomoucký kraj~OL|Pardubický kraj~PA|Plzeňský kraj~PL|Středočeský kraj~ST|Ústecký kraj~US|Vysočina~VY|Zlínský kraj~ZL"],["Denmark","DK","Hovedstaden~84|Kujalleq~GL-KU|Midtjylland~82|Norderøerne~FO-01|Nordjylland~81|Østerø~FO-06|Qaasuitsup~GL-QA|Qeqqata~GL-QE|Sandø~FO-02|Sermersooq~GL-SM|Sjælland~85|Strømø~FO-03|Suderø~FO-04|Syddanmark~83|Vågø~FO-05"],["Djibouti","DJ","Ali Sabieh~AS|Arta~AR|Dikhil~DI|Obock~OB|Tadjourah~TA"],["Dominica","DM","Saint Andrew Parish~02|Saint David Parish~03|Saint George Parish~04|Saint John Parish~05|Saint Joseph Parish~06|Saint Luke Parish~07|Saint Mark Parish~08|Saint Patrick Parish~09|Saint Paul Parish~10|Saint Peter Parish~11"],["Dominican Republic","DO","Cibao Central~02|Del Valle~37|Distrito Nacional~01|Enriquillo~38|Norcentral~04|Nordeste~34|Noroeste~34|Norte~35|Valdesia~42"],["Ecuador","EC","Azuay~A|Bolívar~B|Cañar~F|Carchi~C|Chimborazo~H|Cotopaxi~X|El Oro~O|Esmeraldas~E|Galápagos~W|Guayas~G|Imbabura~I|Loja~L|Los Ríos~R|Manabí~M|Morona-Santiago~S|Napo~N|Orellana~D|Pastaza~Y|Pichincha~P|Santa Elena~SE|Santo Domingo de los Tsáchilas~SD|Sucumbíos~U|Tungurahua~T|Zamora-Chinchipe~Z"],["Egypt","EG","Alexandria~ALX|Aswan~ASN|Asyout~AST|Bani Sueif~BNS|Beheira~BH|Cairo~C|Daqahlia~DK|Dumiat~DT|El Bahr El Ahmar~BA|El Ismailia~IS|El Suez~SUZ|El Wadi El Gedeed~WAD|Fayoum~FYM|Gharbia~GH|Giza~SUZ|Helwan~HU|Kafr El Sheikh~KFS|Luxor~LX|Matrouh~MT|Menia~MN|Menofia~MNF|North Sinai~SIN|Port Said~PTS|Qalubia~KB|Qena~KN|Sharqia~SHR|Sixth of October~SU|Sohag~SHG|South Sinai~JS"],["El Salvador","SV","Ahuachapán~AH|Cabañas~CA|Cuscatlán~CU|Chalatenango~CH|La Libertad~LI|La Paz~PA|La Unión~UN|Morazán~MO|San Miguel~SM|San Salvador~SS|Santa Ana~SA|San Vicente~SV|Sonsonate~SO|Usulután~US"],["Equatorial Guinea","GQ","Annobón~AN|Bioko Norte~BN|Bioko Sur~BS|Centro Sur~CS|Kié-Ntem~KN|Litoral~LI|Wele-Nzas~WN"],["Eritrea","ER","Anseba~AN|Debub~DU|Debub-Keih-Bahri~DK|Gash-Barka~GB|Maekel~MA|Semien-Keih-Bahri~SK"],["Estonia","EE","Harjumaa (Tallinn)~37|Hiiumaa (Kardla)~39|Ida-Virumaa (Johvi)~44|Järvamaa (Paide)~41|Jõgevamaa (Jogeva)~49|Läänemaa~57|Lääne-Virumaa (Rakvere)~59|Pärnumaa (Parnu)~67|Põlvamaa (Polva)~65|Raplamaa (Rapla)~70|Saaremaa (Kuessaare)~74|Tartumaa (Tartu)~78|Valgamaa (Valga)~82|Viljandimaa (Viljandi)~84|Võrumaa (Voru)~86"],["Ethiopia","ET","Addis Ababa~AA|Afar~AF|Amhara~AM|Benshangul-Gumaz~BE|Dire Dawa~DD|Gambela~GA|Harari~HA|Oromia~OR|Somali~SO|Southern Nations Nationalities and People's Region~SN|Tigray~TI"],["Falkland Islands (Islas Malvinas)","FK","Falkland Islands (Islas Malvinas)"],["Faroe Islands","FO","Bordoy|Eysturoy|Mykines|Sandoy|Skuvoy|Streymoy|Suduroy|Tvoroyri|Vagar"],["Fiji","FJ","Ba~01|Bua~01|Cakaudrove~03|Kadavu~04|Lau~05|Lomaiviti~06|Macuata~07|Nadroga and Navosa~08|Naitasiri~09|Namosi~10|Ra~011|Rewa~12|Rotuma~R|Serua~12|Tailevu~14"],["Finland","FI","Ahvenanmaan lääni~AL|Etelä-Suomen lääni~ES|Itä-Suomen lääni~IS|Länsi-Suomen lääni~LS|Lapin lääni~LL|Oulun lääni~OL"],["France","FR","Auvergne-Rhône-Alpes~ARA|Bourgogne-Franche-Comté~BFC|Bretagne~BRE|Centre-Val de Loire~CVL|Corse~COR|Grand Est~GES|Hauts-de-France~HDF|Île-de-France~IDF|Normandie~NOR|Nouvelle-Aquitaine~NAQ|Occitanie~OCC|Pays de la Loire~PDL|Provence-Alpes-Cote d'Azur~PAC|Clipperton~CP|Guadeloupe~GP|Guyane~GF|Martinique~MQ|Mayotte~YT|Novelle-Calédonie~NC|Polynésie~PF|Saint-Pierre-et-Miquelon~PM|Saint Barthélemy~BL|Saint Martin~MF|Réunion~RE|Terres Australes Françaises~TF|Wallis-et-Futuna~WF"],["French Guiana","GF","French Guiana"],["French Polynesia","PF","Archipel des Marquises|Archipel des Tuamotu|Archipel des Tubuai|Iles du Vent|Iles Sous-le-Vent"],["French Southern and Antarctic Lands","TF","Adelie Land|Ile Crozet|Iles Kerguelen|Iles Saint-Paul et Amsterdam"],["Gabon","GA","Estuaire~1|Haut-Ogooué~2|Moyen-Ogooué~3|Ngounié~4|Nyanga~5|Ogooué-Ivindo~6|Ogooué-Lolo~7|Ogooué-Maritime~8|Woleu-Ntem~9"],["Gambia, The","GM","Banjul~B|Central River~M|Lower River~L|North Bank~N|Upper River~U|Western~W"],["Georgia","GE","Abkhazia (Sokhumi)~AB|Ajaria (Bat'umi)~AJ|Guria~GU|Imereti~IM|K'akheti~KA|Kvemo Kartli~KK|Mtshkheta-Mtianeti~MM|Rach'a-Lexhkumi-KvemoSvaneti~RL|Samegrelo-Zemo Svaneti~SZ|Samtskhe-Javakheti~SJ|Shida Kartli~SK|Tbilisi~TB"],["Germany","DE","Baden-Württemberg~BW|Bayern~BY|Berlin~BE|Brandenburg~BB|Bremen~HB|Hamburg~HH|Hessen~HE|Mecklenburg-Vorpommern~MV|Niedersachsen~NI|Nordrhein-Westfalen~NW|Rheinland-Pfalz~RP|Saarland~SL|Sachsen~SN|Sachsen-Anhalt~ST|Schleswig-Holstein~SH|Thüringen~TH"],["Ghana","GH","Ashanti~AH|Brong-Ahafo~BA|Central~CP|Eastern~EP|Greater Accra~AA|Northern~NP|Upper East~UE|Upper West~UW|Volta~TV|Western~WP"],["Gibraltar","GI","Gibraltar"],["Greece","GR","Anatolikí Makedonía kai Thráki~A|Attikḯ~I|Dytikí Elláda~G|Dytikí Makedonía~C|Ionía Nísia~F|Kentrikí Makedonía~B|Krítí~M|Notío Aigaío~L|Peloponnísos~J|Stereá Elláda~H|Thessalía~E|Voreío Aigaío~K|Ípeiros~D|Ágion Óros~69"],["Greenland","GL","Kommune Kujalleq~KU|Kommuneqarfik Sermersooq~SM|Qaasuitsup Kommunia~QA|Qeqqata Kommunia~QE"],["Grenada","GD","Saint Andrew~01|Saint David~02|Saint George~03|Saint John~04|Saint Mark~05|Saint Patrick~06|Southern Grenadine Islands~10"],["Guadeloupe","GP","Guadeloupe"],["Guam","GU","Guam"],["Guatemala","GT","Alta Verapaz~AV|Baja Verapaz~BV|Chimaltenango~CM|Chiquimula~CQ|El Progreso~PR|Escuintla~ES|Guatemala~GU|Huehuetenango~HU|Izabal~IZ|Jalapa~JA|Jutiapa~JU|Petén~PE|Quetzaltenango~QZ|Quiché~QC|Retalhuleu~Re|Sacatepéquez~SA|San Marcos~SM|Santa Rosa~SR|Sololá~SO|Suchitepéquez~SU|Totonicapán~TO|Zacapa~ZA"],["Guernsey","GG","Castel|Forest|St. Andrew|St. Martin|St. Peter Port|St. Pierre du Bois|St. Sampson|St. Saviour|Torteval|Vale"],["Guinea","GN","Boké~B|Conakry~C|Faranah~F|Kankan~K|Kindia~D|Labé~L|Mamou~M|Nzérékoré~N"],["Guinea-Bissau","GW","Bafatá~BA|Biombo~BM|Bissau~BS|Bolama-Bijagos~BL|Cacheu~CA|Gabú~GA|Oio~OI|Quinara~QU|Tombali~TO"],["Guyana","GY","Barima-Waini~BA|Cuyuni-Mazaruni~CU|Demerara-Mahaica~DE|East Berbice-Corentyne~EB|Essequibo Islands-West Demerara~ES|Mahaica-Berbice~MA|Pomeroon-Supenaam~PM|Potaro-Siparuni~PT|Upper Demerara-Berbice~UD|Upper Takutu-Upper Essequibo~UT"],["Haiti","HT","Artibonite~AR|Centre~CE|Grand'Anse~GA|Nippes~NI|Nord~ND|Nord-Est~NE|Nord-Ouest~NO|Ouest~OU|Sud~SD|Sud-Est~SE"],["Heard Island and McDonald Islands","HM","Heard Island and McDonald Islands"],["Holy See (Vatican City)","VA","Holy See (Vatican City)~01"],["Honduras","HN","Atlántida~AT|Choluteca~CH|Colón~CL|Comayagua~CM|Copán~CP|Cortés~CR|El Paraíso~EP|Francisco Morazan~FM|Gracias a Dios~GD|Intibucá~IN|Islas de la Bahía~IB|La Paz~LP|Lempira~LE|Ocotepeque~OC|Olancho~OL|Santa Bárbara~SB|Valle~VA|Yoro~YO"],["Hong Kong","HK","Hong Kong"],["Hungary","HU","Bács-Kiskun~BK|Baranya~BA|Békés~BE|Békéscsaba~BC|Borsod-Abauj-Zemplen~BZ|Budapest~BU|Csongrád~CS|Debrecen~DE|Dunaújváros~DU|Eger~EG|Érd~ER|Fejér~FE|Győr~GY|Győr-Moson-Sopron~GS|Hajdú-Bihar~HB|Heves~HE|Hódmezővásárhely~HV|Jász-Nagykun-Szolnok~N|Kaposvár~KV|Kecskemét~KM|Komárom-Esztergom~KE|Miskolc~MI|Nagykanizsa~NK|Nógrád~NO|Nyíregyháza~NY|Pécs~PS|Pest~PE|Salgótarján~ST|Somogy~SO|Sopron~SN|Szabolcs-á-Bereg~SZ|Szeged~SD|Székesfehérvár~SF|Szekszárd~SS|Szolnok~SK|Szombathely~SH|Tatabánya~TB|Tolna~TO|Vas~VA|Veszprém~VE|Veszprém (City)~VM|Zala~ZA|Zalaegerszeg~ZE"],["Iceland","IS","Austurland~7|Höfuðborgarsvæði utan Reykjavíkur~1|Norðurland eystra~6|Norðurland vestra~5|Suðurland~8|Suðurnes~2|Vestfirðir~4|Vesturland~3"],["India","IN","Andaman and Nicobar Islands~AN|Andhra Pradesh~AP|Arunachal Pradesh~AR|Assam~AS|Bihar~BR|Chandigarh~CH|Chhattisgarh~CT|Dadra and Nagar Haveli~DN|Daman and Diu~DD|Delhi~DL|Goa~GA|Gujarat~GJ|Haryana~HR|Himachal Pradesh~HP|Jammu and Kashmir~JK|Jharkhand~JH|Karnataka~KA|Kerala~KL|Lakshadweep~LD|Madhya Pradesh~MP|Maharashtra~MH|Manipur~MN|Meghalaya~ML|Mizoram~MZ|Nagaland~NL|Odisha~OR|Puducherry~PY|Punjab~PB|Rajasthan~RJ|Sikkim~WK|Tamil Nadu~TN|Telangana~TG|Tripura~TR|Uttarakhand~UT|Uttar Pradesh~UP|West Bengal~WB"],["Indonesia","ID","Aceh~AC|Bali~BA|Bangka Belitung~BB|Banten~BT|Bengkulu~BE|Gorontalo~GO|Jakarta Raya~JK|Jambi~JA|Jawa Barat~JB|Jawa Tengah~JT|Jawa Timur~JI|Kalimantan Barat~KB|Kalimantan Selatan~KS|Kalimantan Tengah~KT|Kalimantan Timur~KI|Kalimantan Utara~KU|Kepulauan Riau~KR|Lampung~LA|Maluku~MA|Maluku Utara~MU|Nusa Tenggara Barat~NB|Nusa Tenggara Timur~NT|Papua~PA|Papua Barat~PB|Riau~RI|Sulawesi Selatan~SR|Sulawesi Tengah~ST|Sulawesi Tenggara~SG|Sulawesi Utara~SA|Sumatera Barat~SB|Sumatera Selatan~SS|Sumatera Utara~SU|Yogyakarta~YO"],["Iran, Islamic Republic of","IR","Alborz~32|Ardabīl~03|Āz̄arbāyjān-e Gharbī~02|Āz̄arbāyjān-e Sharqī~01|Būshehr~06|Chahār Maḩāl va Bakhtīārī~08|Eşfahān~04|Fārs~14|Gīlān~19|Golestān~27|Hamadān~24|Hormozgān~23|Īlām~05|Kermān~15|Kermānshāh~17|Khorāsān-e Jonūbī~29|Khorāsān-e Raẕavī~30|Khorāsān-e Shomālī~61|Khūzestān~10|Kohgīlūyeh va Bowyer Aḩmad~18|Kordestān~16|Lorestān~20|Markazi~22|Māzandarān~21|Qazvīn~28|Qom~26|Semnān~12|Sīstān va Balūchestān~13|Tehrān~07|Yazd~25|Zanjān~11"],["Iraq","IQ","Al Anbār~AN|Al Başrah~BA|Al Muthanná~MU|Al Qādisīyah~QA|An Najaf~NA|Arbīl~AR|As Sulaymānīyah~SU|Bābil~BB|Baghdād~BG|Dohuk~DA|Dhī Qār~DQ|Diyālá~DI|Karbalā'~KA|Kirkuk~KI|Maysān~MA|Nīnawá~NI|Şalāḩ ad Dīn~SD|Wāsiţ~WA"],["Ireland","IE","Carlow~CW|Cavan~CN|Clare~CE|Cork~CO|Donegal~DL|Dublin~D|Galway~G|Kerry~KY|Kildare~KE|Kilkenny~KK|Laois~LS|Leitrim~LM|Limerick~LK|Longford~LD|Louth~LH|Mayo~MO|Meath~MH|Monaghan~MN|Offaly~OY|Roscommon~RN|Sligo~SO|Tipperary~TA|Waterford~WD|Westmeath~WH|Wexford~WX|Wicklow~WW"],["Isle of Man","IM","Isle of Man"],["Israel","IL","HaDarom~D|HaMerkaz~M|HaTsafon~Z|H̱efa~HA|Tel-Aviv~TA|Yerushalayim~JM"],["Italy","IT","Abruzzo~65|Basilicata~77|Calabria~78|Campania~72|Emilia-Romagna~45|Friuli-Venezia Giulia~36|Lazio~62|Liguria~42|Lombardia~25|Marche~57|Molise~67|Piemonte~21|Puglia~75|Sardegna~88|Sicilia~82|Toscana~52|Trentino-Alto Adige~32|Umbria~55|Valle d'Aosta~23|Veneto~34"],["Jamaica","JM","Clarendon~13|Hanover~09|Kingston~01|Manchester~12|Portland~04|Saint Andrew~02|Saint Ann~06|Saint Catherine~14|Saint Elizabeth~11|Saint James~08|Saint Mary~05|Saint Thomas~03|Trelawny~07|Westmoreland~10"],["Japan","JP","Aichi~23|Akita~05|Aomori~02|Chiba~12|Ehime~38|Fukui~18|Fukuoka~40|Fukushima~07|Gifu~21|Gunma~10|Hiroshima~34|Hokkaido~01|Hyogo~28|Ibaraki~08|Ishikawa~17|Iwate~03|Kagawa~37|Kagoshima~46|Kanagawa~14|Kochi~39|Kumamoto~43|Kyoto~26|Mie~24|Miyagi~04|Miyazaki~45|Nagano~20|Nagasaki~42|Nara~29|Niigata~15|Oita~44|Okayama~33|Okinawa~47|Osaka~27|Saga~41|Saitama~11|Shiga~25|Shimane~32|Shizuoka~22|Tochigi~09|Tokushima~36|Tokyo~13|Tottori~31|Toyama~16|Wakayama~30|Yamagata~06|Yamaguchi~35|Yamanashi~19"],["Jersey","JE","Jersey"],["Jordan","JO","‘Ajlūn~AJ|Al 'Aqabah~AQ|Al Balqā’~BA|Al Karak~KA|Al Mafraq~MA|Al ‘A̅şimah~AM|Aţ Ţafīlah~AT|Az Zarqā’~AZ|Irbid~IR|Jarash~JA|Ma‘ān~MN|Mādabā~MD"],["Kazakhstan","KZ","Almaty~ALA|Aqmola~AKM|Aqtobe~AKT|Astana~AST|Atyrau~ATY|Batys Qazaqstan~ZAP|Bayqongyr|Mangghystau~MAN|Ongtustik Qazaqstan~YUZ|Pavlodar~PAV|Qaraghandy~KAR|Qostanay~KUS|Qyzylorda~KZY|Shyghys Qazaqstan~VOS|Soltustik Qazaqstan~SEV|Zhambyl~ZHA"],["Kenya","KE","Baringo~01|Bomet~02|Bungoma~03|Busia~04|Eleyo/Marakwet~05|Embu~06|Garissa~07|Homa Bay~08|Isiolo~09|Kajiado~10|Kakamega~11|Kericho~12|Kiambu~13|Kilifi~14|Kirinyaga~15|Kisii~16|Kisumu~17|Kitui~18|Kwale~19|Laikipia~20|Lamu~21|Machakos~22|Makueni~23|Mandera~24|Marsabit~25|Meru~26|Migori~27|Mombasa~28|Murang'a~29|Nairobi City~30|Nakuru~31|Nandi~32|Narok~33|Nyamira~34|Nyandarua~35|Nyeri~36|Samburu~37|Siaya~38|Taita/Taveta~39|Tana River~40|Tharaka-Nithi~41|Trans Nzoia~42|Turkana~43|Uasin Gishu~44|Vihiga~45|Wajir~46|West Pokot~47"],["Kiribati","KI","Abaiang|Abemama|Aranuka|Arorae|Banaba|Beru|Butaritari|Central Gilberts|Gilbert Islands~G|Kanton|Kiritimati|Kuria|Line Islands~L|Maiana|Makin|Marakei|Nikunau|Nonouti|Northern Gilberts|Onotoa|Phoenix Islands~P|Southern Gilberts|Tabiteuea|Tabuaeran|Tamana|Tarawa|Teraina"],["Korea, Democratic People's Republic of","KP","Chagang-do (Chagang Province)~04|Hamgyong-bukto (North Hamgyong Province)~09|Hamgyong-namdo (South Hamgyong Province)~08|Hwanghae-bukto (North Hwanghae Province)~06|Hwanghae-namdo (South Hwanghae Province)~05|Kangwon-do (Kangwon Province)~07|Nasŏn (Najin-Sŏnbong)~13|P'yongan-bukto (North P'yongan Province)~03|P'yongan-namdo (South P'yongan Province)~02|P'yongyang-si (P'yongyang City)~01|Yanggang-do (Yanggang Province)~10"],["Korea, Republic of","KR","Ch'ungch'ongbuk-do~43|Ch'ungch'ongnam-do~44|Cheju-do~49|Chollabuk-do~45|Chollanam-do~46|Inch'on-Kwangyokhi~28|Kang-won-do~42|Kwangju-Kwangyokshi~28|Kyonggi-do~41|Kyongsangbuk-do~47|Kyongsangnam-do~48|Pusan-Kwangyokshi~26|Seoul-T'ukpyolshi~11|Sejong~50|Taegu-Kwangyokshi~27|Taejon-Kwangyokshi~30|Ulsan-Kwangyokshi~31"],["Kuwait","KW","Al Aḩmadi~AH|Al Farwānīyah~FA|Al Jahrā’~JA|Al ‘Āşimah~KU|Ḩawallī~HA|Mubārak al Kabir~MU"],["Kyrgyzstan","KG","Batken Oblasty~B|Bishkek Shaary~GB|Chuy Oblasty (Bishkek)~C|Jalal-Abad Oblasty~J|Naryn Oblasty~N|Osh Oblasty~O|Talas Oblasty~T|Ysyk-Kol Oblasty (Karakol)~Y"],["Laos","LA","Attapu~AT|Bokèo~BK|Bolikhamxai~BL|Champasak~CH|Houaphan~HO|Khammouan~KH|Louang Namtha~LM|Louangphabang~LP|Oudômxai~OU|Phôngsali~PH|Salavan~SL|Savannakhét~SV|Vientiane~VI|Xaignabouli~XA|Xékong~XE|Xaisomboun~XS|Xiangkhouang~XI"],["Latvia","LV","Aglona~001|Aizkraukle~002|Aizpute~003|Aknīste~004|Aloja~005|Alsunga~06|Alūksne~007|Amata~008|Ape~009|Auce~010|Ādaži~011|Babīte~012|Baldone~013|Baltinava~014|Balvi~015|Bauska~016|Beverīna~017|Brocēni~018|Burtnieki~019|Carnikava~020|Cesvaine~021|Cēsis~022|Cibla~023|Dagda~024|Daugavpils~025|Daugavpils (City)~DGV|Dobele~026|Dundaga~027|Durbe~028|Engure~029|Ērgļi~030|Garkalne~031|Grobiņa~032|Gulbene~033|Iecava~034|Ikšķile~035|Ilūkste~036|Inčukalns~037|Jaunjelgava~038|Jaunpiebalga~039|Jaunpils~040|Jelgava~041|Jelgava (City)~JEL|Jēkabpils~042|Jēkabpils (City)~JKB|Jūrmala (City)~JUR|Kandava~043|Kārsava~044|Kocēni~045|Koknese~046|Krāslava~047|Krimulda~048|Krustpils~049|Kuldīga~050|Ķegums~051|Ķekava~052|Lielvārde~053|Liepāja~LPX|Limbaži~054|Līgatne~055|Līvāni~056|Lubāna~057|Ludza~058|Madona~059|Mazsalaca~060|Mālpils~061|Mārupe~062|Mērsrags~063|Naukšēni~064|Nereta~065|Nīca~066|Ogre~067|Olaine~068|Ozolnieki~069|Pārgauja~070|Pāvilosta~071|Pļaviņas~072|Preiļi~073|Priekule~074|Priekuļi~075|Rauna~076|Rēzekne~077|Rēzekne (City)~REZ|Riebiņi~078|Rīga~RIX|Roja~079|Ropaži~080|Rucava~081|Rugāji~082|Rundāle~083|Rūjiena~084|Sala~085|Salacgrīva~086|Salaspils~087|Saldus~088|Saulkrasti~089|Sēja~090|Sigulda~091|Skrīveri~092|Skrunda~093|Smiltene~094|Stopiņi~095|Strenči~096|Talsi~097|Tērvete~098|Tukums~099|Vaiņode~100|Valka~101|Valmiera~VMR|Varakļāni~102|Vārkava~103|Vecpiebalga~104|Vecumnieki~105|Ventspils~106|Ventspils (City)~VEN|Viesīte~107|Viļaka~108|Viļāni~109|Zilupe~110"],["Lebanon","LB","Aakkâr~AK|Baalbelk-Hermel~BH|Béqaa~BI|Beyrouth~BA|Liban-Nord~AS|Liban-Sud~JA|Mont-Liban~JL|Nabatîyé~NA"],["Lesotho","LS","Berea~D|Butha-Buthe~B|Leribe~C|Mafeteng~E|Maseru~A|Mohales Hoek~F|Mokhotlong~J|Qacha's Nek~H|Quthing~G|Thaba-Tseka~K"],["Liberia","LR","Bomi~BM|Bong~BG|Gbarpolu~GP|Grand Bassa~GB|Grand Cape Mount~CM|Grand Gedeh~GG|Grand Kru~GK|Lofa~LO|Margibi~MG|Maryland~MY|Montserrado~MO|Nimba~NI|River Cess~RI|River Geee~RG|Sinoe~SI"],["Libya","LY","Al Buţnān~BU|Al Jabal al Akhḑar~JA|Al Jabal al Gharbī~JG|Al Jafārah~JA|Al Jufrah~JU|Al Kufrah~FK|Al Marj~MJ|Al Marquab~MB|Al Wāḩāt~WA|An Nuqaţ al Khams~NQ|Az Zāwiyah~ZA|Banghāzī~BA|Darnah~DR|Ghāt~GH|Mişrātah~MI|Murzuq~MQ|Nālūt~NL|Sabhā~SB|Surt~SR|Ţarābulus~TB|Yafran~WD|Wādī ash Shāţiʾ~WS"],["Liechtenstein","LI","Balzers~01|Eschen~02|Gamprin~03|Mauren~04|Planken~05|Ruggell~06|Schaan~07|Schellenberg~08|Triesen~09|Triesenberg~10|Vaduz~11"],["Lithuania","LT","Alytaus~AL|Kauno~KU|Klaipėdos~KL|Marijampolės~MR|Panevėžio~PN|Šiaulių~SA|Tauragės~TA|Telšių~TE|Utenos~UT|Vilniaus~VL"],["Luxembourg","LU","Capellen~CA|Clevaux~CL|Diekirch~DI|Echternach~EC|Esch-sur-Alzette~ES|Grevenmacher~GR|Luxembourg~LU|Mersch~ME|Redange~RD|Remich~RM|Vianden~VD|Wiltz~WI"],["Macao","MO","Macao"],["Macedonia, Republic of","MK","Aračinovo~02|Berovo~03|Bitola~04|Bogdanci~05|Bogovinje~06|Bosilovo~07|Brvenica~08|Centar Župa~78|Čaška~08|Češinovo-Obleševo~81|Čučer Sandevo~82|Debar~21|Debarca~22|Delčevo~23|Demir Hisar~25|Demir Kapija~24|Doran~26|Dolneni~27|Gevgelija~18|Gostivar~19|Gradsko~20|Ilinden~34|Jegunovce~35|Karbinci~37|Kavadarci~36|Kičevo~40|Kočani~42|Konče~41|Kratovo~43|Kriva Palanka~44|Krivogaštani~45|Kruševo~46|Kumanovo~47|Lipkovo~48|Lozovo~49|Makedonska Kamenica~51|Makedonski Brod~52|Mavrovo i Rostuša~50|Mogila~53|Negotino~54|Novaci~55|Novo Selo~56|Ohrid~58|Pehčevo~60|Petrovec~59|Plasnica~61|Prilep~62|Probištip~63|Radoviš~|Rankovce~65|Resen~66|Rosoman~67|Skopje~85|Sopište~70|Staro Nagoričane~71|Struga~72|Strumica~73|Studeničani~74|Sveti Nikole~69|Štip~83|Tearce~75|Tetovo~76|Valandovo~10|Vasilevo~11|Veles~13|Vevčani~12|Vinica~14|Vrapčište~16|Zelenikovo~32|Zrnovci~33|Želino~30"],["Madagascar","MG","Antananarivo~T|Antsiranana~D|Fianarantsoa~F|Mahajanga~M|Toamasina~A|Toliara~U"],["Malawi","MW","Balaka~BA|Blantyre~BL|Chikwawa~CK|Chiradzulu~CR|Chitipa~CT|Dedza~DE|Dowa~DO|Karonga~KR|Kasungu~KS|Likoma~LK|Lilongwe~LI|Machinga~MH|Mangochi~MG|Mchinji~MC|Mulanje~MU|Mwanza~MW|Mzimba~MZ|Nkhata Bay~NE|Nkhotakota~NB|Nsanje~NS|Ntcheu~NU|Ntchisi~NI|Phalombe~PH|Rumphi~RU|Salima~SA|Thyolo~TH|Zomba~ZO"],["Malaysia","MY","Johor~01|Kedah~02|Kelantan~03|Melaka~04|Negeri Sembilan~05|Pahang~06|Perak~08|Perlis~09|Pulau Pinang~07|Sabah~12|Sarawak~13|Selangor~10|Terengganu~11|Wilayah Persekutuan (Kuala Lumpur)~14|Wilayah Persekutuan (Labuan)~15|Wilayah Persekutuan (Putrajaya)~16"],["Maldives","MV","Alifu Alifu~02|Alifu Dhaalu~00|Baa~20|Dhaalu~17|Faafu~14|Gaafu Alifu~27|Gaafu Dhaalu~28|Gnaviyani~29|Haa Alifu~07|Haa Dhaalu~23|Kaafu~29|Laamu~05|Lhaviyani~03|Malé~MLE|Meemu~12|Noonu~25|Raa~13|Seenu~01|Shaviyani~24|Thaa~08|Vaavu~04"],["Mali","ML","Bamako~BKO|Gao~7|Kayes~1|Kidal~8|Koulikoro~2|Mopti~5|Segou~4|Sikasso~3|Tombouctou~6"],["Malta","MT","Attard~01|Balzan~02|Birgu~03|Birkirkara~04|Birżebbuġa~05|Bormla~06|Dingli~07|Fgura~08|Floriana~09|Fontana~10|Guda~11|Gżira~12|Għajnsielem~13|Għarb~14|Għargħur~15|Għasri~16|Għaxaq~17|Ħamrun~18|Iklin~19|Isla~20|Kalkara~21|Kerċem~22|Kirkop~23|Lija~24|Luqa~25|Marsa~26|Marsaskala~27|Marsaxlokk~28|Mdina~29|Mellieħa~30|Mġarr~31|Mosta~32|Mqabba~33|Msida~34|Mtarfa~35|Munxar~36|Nadur~37|Naxxar~38|Paola~39|Pembroke~40|Pietà~41|Qala~42|Qormi~43|Qrendi~44|Rabat Għawdex~45|Rabat Malta~46|Safi~47|San Ġiljan~48|San Ġwann~49|San Lawrenz~50|San Pawl il-Baħar~51|Sannat~52|Santa Luċija~53|Santa Venera~54|Siġġiewi~55|Sliema~56|Swieqi~57|Tai Xbiex~58|Tarzien~59|Valletta~60|Xagħra~61|Xewkija~62|Xgħajra~63|Żabbar~64|Żebbuġ Għawde~65|Żebbuġ Malta~66|Żejtun~67|Żurrieq~68"],["Marshall Islands","MH","Ailinglaplap~ALL|Ailuk~ALK|Arno~ARN|Aur~AUR|Bikini and Kili~KIL|Ebon~EBO|Jabat~JAB|Jaluit~JAL|Kwajalein~KWA|Lae~LAE|Lib~LIB|Likiep~LIK|Majuro~MAJ|Maloelap~MAL|Mejit~MEJ|Namdrik~NMK|Namu~NMU|Rongelap~RON|Ujae~UJA|Utrik~UTI|Wotho~WTH|Wotje~WTJ"],["Martinique","MQ","Martinique"],["Mauritania","MR","Adrar~07|Assaba~03|Brakna~05|Dakhlet Nouadhibou~08|Gorgol~04|Guidimaka~10|Hodh Ech Chargui~01|Hodh El Gharbi~02|Inchiri~12|Nouakchott Nord~14|Nouakchott Ouest~13|Nouakchott Sud~15|Tagant~09|Tiris Zemmour~11|Trarza~06"],["Mauritius","MU","Agalega Islands~AG|Beau Bassin-Rose Hill~BR|Black River~BL|Cargados Carajos Shoals~CC|Curepipe~CU|Flacq~FL|Grand Port~GP|Moka~MO|Pamplemousses~PA|Plaines Wilhems~PW|Port Louis (City)~PU|Port Louis~PL|Riviere du Rempart~RR|Rodrigues Island~RO|Savanne~SA|Vacoas-Phoenix~CP"],["Mayotte","YT","Dzaoudzi~01|Pamandzi~02|Mamoudzou~03|Dembeni~04|Bandrélé~05|Kani-Kéli~06|Bouéni~07|Chirongui~08|Sada~09|Ouangani~10|Chiconi~11|Tsingoni~12|M'Tsangamouji~13|Acoua~14|Mtsamboro~15|Bandraboua~16|Koungou~17"],["Mexico","MX","Aguascalientes~AGU|Baja California~BCN|Baja California Sur~BCS|Campeche~CAM|Ciudad de México~DIF|Chiapas~CHP|Chihuahua~CHH|Coahuila de Zaragoza~COA|Colima~COL|Durango~DUR|Estado de México~MEX|Guanajuato~GUA|Guerrero~GRO|Hidalgo~HID|Jalisco~JAL|Michoacán de Ocampo~MIC|Morelos~MOR|Nayarit~NAY|Nuevo León~NLE|Oaxaca~OAX|Puebla~PUE|Querétaro de Arteaga~QUE|Quintana Roo~ROO|San Luis Potosí~SLP|Sinaloa~SIN|Sonora~SON|Tabasco~TAB|Tamaulipas~TAM|Tlaxcala~TLA|Veracruz~VER|Yucatán~YUC|Zacatecas~ZAC"],["Micronesia, Federated States of","FM","Chuuk (Truk)~TRK|Kosrae~KSA|Pohnpei~PNI|Yap~YAP"],["Moldova","MD","Aenii Noi~AN|Basarabeasca~BS|Bălți~BA|Bender~BD|Briceni~BR|Cahul~CA|Cantemir~CT|Călărași~CL|Căușeni~CS|Chișinău~CU|Cimișlia~CM|Criuleni~CR|Dondușeni~DO|Drochia~DR|Dubăsari~DU|Edineț~ED|Fălești~FA|Florești~FL|Găgăuzia~GA|Glodeni~GL|Hîncești~HI|Ialoveni~IA|Leova~LE|Nisporeni~NI|Ocnița~OC|Orhei~OR|Rezina~RE|Rîșcani~RI|Sîngerei~SI|Soroca~SO|Stînga Nistrului~SN|Strășeni~ST|Șoldănești~SD|Ștefan Vodă~SV|Taraclia~TA|Telenești~TE|Ungheni~UN"],["Monaco","MC","Colle~CL|Condamine~CO|Fontvieille~FO|Gare~GA|Jardin Exotique~JE|Larvotto~LA|Malbousquet~MA|Monaco-Ville~MO|Moneghetti~MG|Monte-Carlo~MC|Moulins~MU|Port-Hercule~PH|Saint-Roman~SR|Sainte-Dévote~SD|Source~SO|Spélugues~SP|Vallon de la Rousse~VR"],["Mongolia","MN","Arhangay~073|Bayan-Olgiy~071|Bayanhongor~069|Bulgan~067|Darhan~037|Dornod~061|Dornogovi~063|Dundgovi~059|Dzavhan~065|Govi-Altay~065|Govi-Sumber~064|Hovd~043|Hovsgol~041|Omnogovi~053|Ovorhangay~055|Selenge~049|Suhbaatar~051|Tov~047|Ulaanbaatar~1|Uvs~046"],["Montenegro","ME","Andrijevica~01|Bar~02|Berane~03|Bijelo Polje~04|Budva~05|Cetinje~06|Danilovgrad~07|Gusinje~22|Herceg Novi~08|Kolašin~09|Kotor~10|Mojkovac~11|Nikšić~12|Petnica~23|Plav~13|Plužine~14|Pljevlja~15|Podgorica~16|Rožaje~17|Šavnik~18|Tivat~19|Ulcinj~20|Žabljak~21"],["Montserrat","MS","Saint Anthony|Saint Georges|Saint Peter's"],["Morocco","MA","Chaouia-Ouardigha~09|Doukhala-Abda~10|Fès-Boulemane~05|Gharb-Chrarda-Beni Hssen~02|Grand Casablanca~08|Guelmim-Es Semara~14|Laâyoune-Boujdour-Sakia el Hamra~15|Marrakech-Tensift-Al Haouz~11|Meknès-Tafilalet~06|Oriental~04|Oued ed Dahab-Lagouira~16|Souss-Massa-Drâa~13|Tadla-Azilal~12|Tanger-Tétouan~01|Taza-Al Hoceima-Taounate~03"],["Mozambique","MZ","Cabo Delgado~P|Gaza~G|Inhambane~I|Manica~B|Maputo~L|Maputo (City)~MPM|Nampula~N|Niassa~A|Sofala~S|Tete~T|Zambezia~Q"],["Myanmar","MM","Ayeyarwady~07|Bago~02|Chin~14|Kachin~11|Kayah~12|Kayin~13|Magway~03|Mandalay~04|Mon~15|Nay Pyi Taw~18|Rakhine~16|Sagaing~01|Shan~17|Tanintharyi~05|Yangon~06"],["Namibia","NA","Erongo~ER|Hardap~HA|Kavango East~KE|Kavango West~KW|Karas~KA|Khomas~KH|Kunene~KU|Ohangwena~OW|Omaheke~OH|Omusati~OS|Oshana~ON|Oshikoto~OT|Otjozondjupa~OD|Zambezi~CA"],["Nauru","NR","Aiwo~01|Anabar~02|Anetan~03|Anibare~04|Baiti~05|Boe~06|Buada~07|Denigomodu~08|Ewa~09|Ijuw~10|Meneng~11|Nibok~12|Uaboe~13|Yaren~14"],["Nepal","NP","Bagmati~BA|Bheri~BH|Dhawalagiri~DH|Gandaki~GA|Janakpur~JA|Karnali~KA|Kosi~KO|Lumbini~LU|Mahakali~MA|Mechi~ME|Narayani~NA|Rapti~RA|Sagarmatha~SA|Seti~SE"],["Netherlands","NL","Drenthe~DR|Flevoland~FL|Friesland~FR|Gelderland~GE|Groningen~GR|Limburg~LI|Noord-Brabant~NB|Noord-Holland~NH|Overijssel~OV|Utrecht~UT|Zeeland~ZE|Zuid-Holland~ZH"],["New Caledonia","NC","Iles Loyaute|Nord|Sud"],["New Zealand","NZ","Auckland~AUK|Bay of Plenty~BOP|Canterbury~CAN|Gisborne~GIS|Hawke's Bay~HKB|Marlborough~MBH|Manawatu-Wanganui~MWT|Northland~NTL|Nelson~NSN|Otago~OTA|Southland~STL|Taranaki~TKI|Tasman~TAS|Waikato~WKO|Wellington~WGN|West Coast~WTC|Chatham Islands Territory~CIT"],["Nicaragua","NI","Boaco~BO|Carazo~CA|Chinandega~CI|Chontales~CO|Estelí~ES|Granada~GR|Jinotega~JI|León~LE|Madriz~MD|Managua~MN|Masaya~MS|Matagalpa~MT|Nueva Segovia~NS|Río San Juan~SJ|Rivas~RI|Atlántico Norte~AN|Atlántico Sur~AS"],["Niger","NE","Agadez~1|Diffa~2|Dosso~3|Maradi~4|Niamey~8|Tahoua~5|Tillabéri~6|Zinder~7"],["Nigeria","NG","Abia~AB|Abuja Federal Capital Territory~FC|Adamawa~AD|Akwa Ibom~AK|Anambra~AN|Bauchi~BA|Bayelsa~BY|Benue~BE|Borno~BO|Cross River~CR|Delta~DE|Ebonyi~EB|Edo~ED|Ekiti~EK|Enugu~EN|Gombe~GO|Imo~IM|Jigawa~JI|Kaduna~KD|Kano~KN|Katsina~KT|Kebbi~KE|Kogi~KO|Kwara~KW|Lagos~LA|Nassarawa~NA|Niger~NI|Ogun~OG|Ondo~ON|Osun~OS|Oyo~OY|Plateau~PL|Rivers~RI|Sokoto~SO|Taraba~TA|Yobe~YO|Zamfara~ZA"],["Niue","NU","Niue"],["Norfolk Island","NF","Norfolk Island"],["Northern Mariana Islands","MP","Northern Islands|Rota|Saipan|Tinian"],["Norway","NO","Akershus~02|Aust-Agder~09|Buskerud~06|Finnmark~20|Hedmark~04|Hordaland~12|Møre og Romsdal~15|Nordland~18|Nord-Trøndelag~17|Oppland~05|Oslo~03|Rogaland~11|Sogn og Fjordane~14|Sør-Trøndelag~16|Telemark~08|Troms~19|Vest-Agder~10|Vestfold~07|Østfold~01|Jan Mayen~22|Svalbard~21"],["Oman","OM","Ad Dakhiliyah~DA|Al Buraymi~BU|Al Wusta~WU|Az Zahirah~ZA|Janub al Batinah~BS|Janub ash Sharqiyah~SS|Masqat~MA|Musandam~MU|Shamal al Batinah~BJ|Shamal ash Sharqiyah~SJ|Zufar~ZU"],["Pakistan","PK","Āzād Kashmīr~JK|Balōchistān~BA|Gilgit-Baltistān~GB|Islāmābād~IS|Khaībar Pakhtūnkhwās~KP|Punjāb~PB|Sindh~SD|Federally Administered Tribal Areas~TA"],["Palau","PW","Aimeliik~002|Airai~004|Angaur~010|Hatobohei~050|Kayangel~100|Koror~150|Melekeok~212|Ngaraard~214|Ngarchelong~218|Ngardmau~222|Ngatpang~224|Ngchesar~226|Ngeremlengui~227|Ngiwal~228|Peleliu~350|Sonsoral~350"],["Palestine, State of","PS","Ak Khalīl~HBN|Al Quds~JEM|Arīḩā wal Aghwār~JRH|Bayt Laḩm~BTH|Dayr al Balaḩ~DEB|Ghazzah~GZA|Janīn~JEN|Khān Yūnis~KYS|Nāblus~NBS|Qalqīyah~QQA|Rafaḩ~RFH|Rām Allāh wal Bīrah~RBH|Salfīt~SLT|Shamāl Ghazzah~NGZ|Ţūbās~TBS|Ţūlkarm~TKM"],["Panama","PA","Bocas del Toro~1|Chiriquí~4|Coclé~2|Colón~3|Darién~5|Emberá~EM|Herrera~6|Kuna Yala~KY|Los Santos~7|Ngäbe-Buglé~NB|Panamá~8|Panamá Oeste~10|Veraguas~9"],["Papua New Guinea","PG","Bougainville~NSB|Central~CPM|Chimbu~CPK|East New Britain~EBR|East Sepik~ESW|Eastern Highlands~EHG|Enga~EPW|Gulf~GPK|Hela~HLA|Jiwaka~JWK|Madang~MOM|Manus~MRL|Milne Bay~MBA|Morobe~MPL|Port Moresby~NCD|New Ireland~NIK|Northern~NPP|Southern Highlands~SHM|West New Britain~WBK|West Sepik~SAN|Western~WPD|Western Highlands~WHM"],["Paraguay","PY","Alto Paraguay~16|Alto Parana~10|Amambay~13|Asuncion~ASU|Caaguazu~5|Caazapa~6|Canindeyu~14|Central~11|Concepcion~1|Cordillera~3|Guaira~4|Itapua~7|Misiones~8|Neembucu~12|Paraguari~9|Presidente Hayes~15|San Pedro~2"],["Peru","PE","Amazonas~AMA|Ancash~ANC|Apurimac~APU|Arequipa~ARE|Ayacucho~AYA|Cajamarca~CAJ|Callao~CAL|Cusco~CUS|Huancavelica~HUV|Huanuco~HUC|Ica~ICA|Junin~JUN|La Libertad~LAL|Lambayeque~LAM|Lima~LIM|Loreto~LOR|Madre de Dios~MDD|Moquegua~MOQ|Municipalidad Metropolitana de Lima~LMA|Pasco~PAS|Piura~PIU|Puno~PUN|San Martin~SAM|Tacna~TAC|Tumbes~TUM|Ucayali~UCA"],["Philippines","PH","Abra~ABR|Agusan del Norte~AGN|Agusan del Sur~AGS|Aklan~AKL|Albay~ALB|Antique~ANT|Apayao~APA|Aurora~AUR|Basilan~BAS|Bataan~BAN|Batanes~BTN|Batangas~BTG|Benguet~BEN|Biliran~BIL|Bohol~BOH|Bukidnon~BUK|Bulacan~BUL|Cagayan~CAG|Camarines Norte~CAN|Camarines Sur~CAS|Camiguin~CAM|Capiz~CAP|Catanduanes~CAT|Cavite~CAV|Cebu~CEB|Compostela~COM|Cotabato~NCO|Davao del Norte~DAV|Davao del Sur~DAS|Davao Occidental~DVO|Davao Oriental~DAO|Dinagat Islands~DIN|Eastern Samar~EAS|Guimaras~GUI|Ifugao~IFU|Ilocos Norte~ILN|Ilocos Sur~ILS|Iloilo~ILI|Isabela~ISA|Kalinga~KAL|La Union~LUN|Laguna~LAG|Lanao del Norte~LAN|Lanao del Sur~LAS|Leyte~LEY|Maguindanao~MAG|Masbate~MAS|Metro Manila~00|Mindoro Occidental~MDC|Mindoro Oriental~MDR|Misamis Occidental~MSC|Misamis Oriental~MSR|Mountain Province~MOU|Negros Occidental~NEC|Negros Oriental~NER|Northern Samar~NSA|Nueva Ecija~NUE|Nueva Vizcaya~NUV|Palawan~PLW|Pampanga~PAM|Pangasinan~PAN|Quezon~QUE|Quirino~QUI|Rizal~RIZ|Romblon~ROM|Samar~WSA|Sarangani~SAR|Siquijor~SIG|Sorsogon~SOR|Southern Leyte~SLE|Sultan Kudarat~AUK|Sulu~SLU|Surigao del Norte~SUN|Surigao del Sur~SUR|Tarlac~TAR|Tawi-Tawi~TAW|Zambales~ZMB|Zamboanga del Norte~ZAN|Zamboanga del Sur~ZAS|Zamboanga Sibugay~ZSI"],["Pitcairn","PN","Pitcairn Islands"],["Poland","PL","Dolnośląskie~DS|Kujawsko-pomorskie~KP|Łódzkie~LD|Lubelskie~LU|Lubuskie~LB|Malopolskie~MA|Mazowieckie~MZ|Opolskie~OP|Podkarpackie~PK|Podlaskie~PD|Pomorskie~PM|Śląskie~SL|Świętokrzyskie~SK|Warmińsko-mazurskie~WN|Wielkopolskie~WP|Zachodniopomorskie~ZP"],["Portugal","PT","Acores~20|Aveiro~01|Beja~02|Braga~03|Braganca~04|Castelo Branco~05|Coimbra~06|Evora~07|Faro~08|Guarda~09|Leiria~10|Lisboa~11|Madeira~30|Portalegre~12|Porto~13|Santarem~14|Setubal~15|Viana do Castelo~16|Vila Real~17|Viseu~18"],["Puerto Rico","PR","Adjuntas|Aguada|Aguadilla|Aguas Buenas|Aibonito|Anasco|Arecibo|Arroyo|Barceloneta|Barranquitas|Bayamon|Cabo Rojo|Caguas|Camuy|Canovanas|Carolina|Cat|Ceiba|Ciales|Cidra|Coamo|Comerio|Corozal|Culebra|Dorado|Fajardo|Florida|Guanica|Guayama|Guayanilla|Guaynabo|Gurabo|Hatillo|Hormigueros|Humacao|Isabe|Juana Diaz|Juncos|Lajas|Lares|Las Marias|Las oiza|Luquillo|Manati|Maricao|Maunabo|Mayaguez|Moca|Morovis|Naguabo|Naranjito|Orocovis|Patillas|Penuelas|Ponce|Quebradillas|Rincon|Rio Grande|Sabana linas|San German|San Juan|San Lorenzo|San Sebastian|Santa Isabel|Toa Alta|Toa Baja|Trujillo Alto|Utuado|Vega Alta|Vega ues|Villalba|Yabucoa|Yauco"],["Qatar","QA","Ad Dawḩah~DA|Al Khawr wa adh Dhakhīrah~KH|Al Wakrah~WA|Ar Rayyān~RA|Ash Shamāl~MS|Az̧ Za̧`āyin~ZA|Umm Şalāl~US"],["Réunion","RE","Réunion"],["Romania","RO","Alba~AB|Arad~AR|Arges~AG|Bacau~BC|Bihor~BH|Bistrita-Nasaud~BN|Botosani~BT|Braila~BR|Brasov~BV|Bucuresti~B|Buzau~BZ|Calarasi~CL|Caras-Severin~CS|Cluj~CJ|Constanta~CT|Covasna~CV|Dambovita~DB|Dolj~DJ|Galati~GL|Giurgiu~GR|Gorj~GJ|Harghita~HR|Hunedoara~HD|Ialomita~IL|Iasi~IS|Maramures~MM|Mehedinti~MH|Mures~MS|Neamt~NT|Olt~OT|Prahova~PH|Salaj~SJ|Satu Mare~SM|Sibiu~SB|Suceava~SV|Teleorman~TR|Timis~TM|Tulcea~TL|Valcea~VL|Vaslui~VS|Vrancea~VN"],["Russian Federation","RU","Republic of Adygea~AD|Republic of Altai (Gorno-Altaysk)~AL|Altai Krai~ALT|Amur Oblast~AMU|Arkhangelsk Oblast~ARK|Astrakhan Oblast~AST|Republic of Bashkortostan~BA|Belgorod Oblast~BEL|Bryansk Oblast~BRY|Republic of Buryatia~BU|Chechen Republic~CE|Chelyabinsk Oblast~CHE|Chukotka Autonomous Okrug~CHU|Chuvash Republic~CU|Republic of Dagestan~DA|Republic of Ingushetia~IN|Irkutsk Oblast~IRK|Ivanovo Oblast~IVA|Jewish Autonomous Oblast~JEW|Kabardino-Balkar Republic~KB|Kaliningrad Oblast~KLN|Republic of Kalmykia~KL|Kaluga Oblast~KLU|Kamchatka Krai~KAM|Karachay-Cherkess Republic~KC|Republic of Karelia~KR|Khabarovsk Krai~KHA|Republic of Khakassia~KK|Khanty-Mansi Autonomous Okrug - Yugra~KHM|Kemerovo Oblast~KEM|Kirov Oblast~KIR|Komi Republic~KO|Kostroma Oblast~KOS|Krasnodar Krai~KDA|Krasnoyarsk Krai~KYA|Kurgan Oblast~KGN|Kursk Oblast~KRS|Leningrad Oblast~LEN|Lipetsk Oblast~LIP|Magadan Oblast~MAG|Mari El Republic~ME|Republic of Mordovia~MO|Moscow Oblast~MOS|Moscow~MOW|Murmansk Oblast~MU|Nenets Autonomous Okrug~NEN|Nizhny Novgorod Oblast~NIZ|Novgorod Oblast~NGR|Novosibirsk Oblast~NVS|Omsk Oblast~OMS|Orenburg Oblast~ORE|Oryol Oblast~ORL|Penza Oblast~PNZ|Perm Krai~PER|Primorsky Krai~PRI|Pskov Oblast~PSK|Rostov Oblast~ROS|Ryazan Oblast~RYA|Saint Petersburg~SPE|Sakha (Yakutia) Republic~SA|Sakhalin Oblast~SAK|Samara Oblast~SAM|Saratov Oblast~SAR|Republic of North Ossetia-Alania~NOA|Smolensk Oblast~SMO|Stavropol Krai~STA|Sverdlovsk Oblast~SVE|Tambov Oblast~TAM|Republic of Tatarstan~TA|Tomsk Oblast~TOM|Tuva Republic~TU|Tula Oblast~TUL|Tver Oblast~TVE|Tyumen Oblast~TYU|Udmurt Republic~UD|Ulyanovsk Oblast~ULY|Vladimir Oblast~VLA|Volgograd Oblast~VGG|Vologda Oblast~VLG|Voronezh Oblast~VOR|Yamalo-Nenets Autonomous Okrug~YAN|Yaroslavl Oblast~YAR|Zabaykalsky Krai~ZAB"],["Rwanda","RW","Kigali~01|Eastern~02|Northern~03|Western~04|Southern~05"],["Saint Barthélemy","BL","Au Vent~02|Sous le Vent~01"],["Saint Helena, Ascension and Tristan da Cunha","SH","Ascension~AC|Saint Helena~HL|Tristan da Cunha~TA"],["Saint Kitts and Nevis","KN","Saint Kitts~K|Nevis~N"],["Saint Lucia","LC","Anse-la-Raye~01|Canaries~12|Castries~02|Choiseul~03|Dennery~05|Gros Islet~06|Laborie~07|Micoud~08|Soufriere~10|Vieux Fort~11"],["Saint Martin","MF","Saint Martin"],["Saint Pierre and Miquelon","PM","Miquelon|Saint Pierre"],["Saint Vincent and the Grenadines","VC","Charlotte~01|Grenadines~06|Saint Andrew~02|Saint David~03|Saint George~04|Saint Patrick~05"],["Samoa","WS","A'ana~AA|Aiga-i-le-Tai~AL|Atua~AT|Fa'asaleleaga~FA|Gaga'emauga~GE|Gagaifomauga~GI|Palauli~PA|Satupa'itea~SA|Tuamasaga~TU|Va'a-o-Fonoti~VF|Vaisigano~VS"],["San Marino","SM","Acquaviva~01|Borgo Maggiore~06|Chiesanuova~02|Domagnano~03|Faetano~04|Fiorentino~05|Montegiardino~08|San Marino~07|Serravalle~09"],["Sao Tome and Principe","ST","Principe~P|Sao Tome~S"],["Saudi Arabia","SA","'Asir~14|Al Bahah~11|Al Hudud ash Shamaliyah~08|Al Jawf~12|Al Madinah al Munawwarah~03|Al Qasim~05|Ar Riyad~01|Ash Sharqiyah~04|Ha'il~06|Jazan~09|Makkah al Mukarramah~02|Najran~10|Tabuk~07"],["Senegal","SN","Dakar~DK|Diourbel~DB|Fatick~FK|Kaffrine~KA|Kaolack~KL|Kedougou~KE|Kolda~KD|Louga~LG|Matam~MT|Saint-Louis~SL|Sedhiou~SE|Tambacounda~TC|Thies~TH|Ziguinchor~ZG"],["Serbia","RS","Beograd (Belgrade)~00|Borski~14|Braničevski~11|Jablanički~23|Južnobački~06|Južnobanatski~04|Kolubarski~09|Kosovski~25|Kosovsko-Mitrovački~28|Kosovsko-Pomoravski~29|Mačvanski~08|Moravički~17|Nišavski~20|Pčinjski~24|Pećki~26|Pirotski~22|Podunavski~10|Pomoravski~13|Prizrenski~27|Rasinski~19|Raški~18|Severnobački~01|Severnobanatski~03|Srednjebanatski~02|Sremski~07|Šumadijski~12|Toplički~21|Zaječarski~15|Zapadnobački~05|Zlatiborski~16"],["Seychelles","SC","Anse aux Pins~01|Anse Boileau~02|Anse Etoile~03|Anse Royale~05|Anu Cap~04|Baie Lazare~06|Baie Sainte Anne~07|Beau Vallon~08|Bel Air~09|Bel Ombre~10|Cascade~11|Glacis~12|Grand'Anse Mahe~13|Grand'Anse Praslin~14|La Digue~15|La Riviere Anglaise~16|Les Mamelles~24|Mont Buxton~17|Mont Fleuri~18|Plaisance~19|Pointe La Rue~20|Port Glaud~21|Roche Caiman~25|Saint Louis~22|Takamaka~23"],["Sierra Leone","SL","Eastern~E|Northern~N|Southern~S|Western~W"],["Singapore","SG","Central Singapore~01|North East~02|North West~03|South East~04|South West~05"],["Sint Maarten (Dutch part)","SX","Sint Maarten"],["Slovakia","SK","Banskobystricky~BC|Bratislavsky~BL|Kosicky~KI|Nitriansky~NI|Presovsky~PV|Trenciansky~TC|Trnavsky~TA|Zilinsky~ZI"],["Slovenia","SI","Ajdovscina~001|Apace~195|Beltinci~002|Benedikt~148|Bistrica ob Sotli~149|Bled~003|Bloke~150|Bohinj~004|Borovnica~005|Bovec~006|Braslovce~151|Brda~007|Brezice~009|Brezovica~008|Cankova~152|Celje~011|Cerklje na Gorenjskem~012|Cerknica~013|Cerkno~014|Cerkvenjak~153|Cirkulane~196|Crensovci~015|Crna na Koroskem~016|Crnomelj~017|Destrnik~018|Divaca~019|Dobje~154|Dobrepolje~020|Dobrna~155|Dobrova-Polhov Gradec~021|Dobrovnik~156|Dol pri Ljubljani~022|Dolenjske Toplice~157|Domzale~023|Dornava~024|Dravograd~025|Duplek~026|Gorenja Vas-Poljane~027|Gorisnica~028|Gorje~207|Gornja Radgona~029|Gornji Grad~030|Gornji Petrovci~031|Grad~158|Grosuplje~032|Hajdina~159|Hoce-Slivnica~160|Hodos~161|Horjul~162|Hrastnik~034|Hrpelje-Kozina~035|Idrija~036|Ig~037|Ilirska Bistrica~038|Ivancna Gorica~039|Izola~040s|Jesenice~041|Jursinci~042|Kamnik~043|Kanal~044|Kidricevo~045|Kobarid~046|Kobilje~047|Kocevje~048|Komen~049|Komenda~164|Koper~050|Kodanjevica na Krki~197|Kostel~165|Kozje~051|Kranj~052|Kranjska Gora~053|Krizevci~166|Krsko~054|Kungota~055|Kuzma~056|Lasko~057|Lenart~058|Lendava~059|Litija~068|Ljubljana~061|Ljubno~062|Ljutomer~063|Log-Dragomer~208|Logatec~064|Loska Dolina~065|Loski Potok~066|Lovrenc na Pohorju~167|Lukovica~068|Luce~067|Majsperk~069|Makole~198|Maribor~070|Markovci~168|Medvode~071|Menges~072|Metlika~073|Mezica~074|Miklavz na Dravskem Polju~169|Miren-Kostanjevica~075|Mirna~212|Mirna Pec~170|Mislinja~076|Mokronog-Trebelno~199|Moravce~077|Moravske Toplice~078|Mozirje~079|Murska Sobota~080|Naklo~082|Nazarje~083|Nova Gorica~084|Novo Mesto~085|Odranci~086|Ormoz~087|Osilnica~088|Pesnica~089|Piran~090|Pivka~091|Podcetrtek~092|Podlehnik~172|Podvelka~093|Poljcane~200|Postojna~094|Prebold~174|Preddvor~095|Prevalje~175|Ptuj~096|Race-Fram~098|Radece~099|Radenci~100|Radlje ob Dravi~101|Radovljica~102|Ravne na Koroskem~103|Razkrizje~176|Recica ob Savinji~209|Rence-Vogrsko~201|Ribnica~104|Ribnica na Poboriu~177|Rogaska Slatina~106|Rogasovci~105|Rogatec~107|Ruse~108|Salovci~033|Selnica ob Dravi~178|Semic~109|Sempeter-Vrtojba~183|Sencur~117|Sentilj~118|Sentjernej~119|Sentjur~120|Sentrupert~211|Sevnica~110|Sezana~111|Skocjan~121|Skofja Loka~122|Skofljica~123|Slovenj Gradec~112|Slovenska Bistrica~113|Slovenske Konjice~114|Smarje pri elsah~124|Smarjeske Toplice~206|Smartno ob Paki~125|Smartno pri Litiji~194|Sodrazica~179|Solcava~180|Sostanj~126|Sredisce ob Dravi~202|Starse~115|Store~127|Straza~203|Sveta Ana~181|Sveta Trojica v Slovenskih Goricah~204|Sveta Andraz v Slovenskih Goricah~182|Sveti Jurij~116|Sveti Jurij v Slovenskih Goricah~210|Sveti Tomaz~205|Tabor~184|Tisina~128|Tolmin~128|Trbovlje~129|Trebnje~130|Trnovska Vas~185|Trzin~186|Trzic~131|Turnisce~132|Velenje~133|Velika Polana~187|Velike Lasce~134|Verzej~188|Videm~135|Vipava~136|Vitanje~137|Vodice~138|Vojnik~139|Vransko~189|Vrhnika~140|Vuzenica~141|Zagorje ob Savi~142|Zavrc~143|Zrece~144|Zalec~190|Zelezniki~146|Zetale~191|Ziri~147|Zirovnica~192|Zuzemberk~193"],["Solomon Islands","SB","Central~CE|Choiseul~CH|Guadalcanal~GU|Honiara~CT|Isabel~IS|Makira-Ulawa~MK|Malaita~ML|Rennell and Bellona~RB|Temotu~TE|Western~WE"],["Somalia","SO","Awdal~AW|Bakool~BK|Banaadir~BN|Bari~BR|Bay~BY|Galguduud~GA|Gedo~GE|Hiiraan~HI|Jubbada Dhexe~JD|Jubbada Hoose~JH|Mudug~MU|Nugaal~NU|Sanaag~SA|Shabeellaha Dhexe~SD|Shabeellaha Hoose~SH|Sool~SO|Togdheer~TO|Woqooyi Galbeed~WO"],["South Africa","ZA","Eastern Cape~EC|Free State~FS|Gauteng~GT|KwaZulu-Natal~NL|Limpopo~LP|Mpumalanga~MP|Northern Cape~NC|North West~NW|Western Cape~WC"],["South Georgia and South Sandwich Islands","GS","Bird Island|Bristol Island|Clerke Rocks|Montagu Island|Saunders Island|South Georgia|Southern Thule|Traversay Islands"],["South Sudan","SS","Central Equatoria~CE|Eastern Equatoria~EE|Jonglei~JG|Lakes~LK|Northern Bahr el Ghazal~BN|Unity~UY|Upper Nile~NU|Warrap~WR|Western Bahr el Ghazal~BW|Western Equatoria~EW"],["Spain","ES","Albacete~CM|Alicante~VC|Almería~AN|Araba/Álava~VI|Asturias~O|Ávila~AV|Badajoz~BA|Barcelona~B|Bizkaia~BI|Burgos~BU|Cáceres~CC|Cádiz~CA|Cantabria~S|Castellón~CS|Cueta~CU|Ciudad Real~CR|Córdoba~CO|A Coruña~C|Cuenca~CU|Gipuzkoa~SS|Girona~GI|Granada~GR|Guadalajara~GU|Huelva~H|Huesca~HU|Illes Balears~PM|Jaén~J|León~LE|Lleida~L|Lugo~LU|Madrid~M|Málaga~MA|Melilla~ML|Murcia~MU|Navarre~NA|Ourense~OR|Palencia~P|Las Palmas~GC|Pontevedra~PO|La Rioja~LO|Salamanca~SA|Santa Cruz de Tenerife~TF|Segovia~SG|Sevilla~SE|Soria~SO|Tarragona~T|Teruel~TE|Toledo~TO|Valencia~V|Valladolid~VA|Zamora~ZA|Zaragoza~Z"],["Sri Lanka","LK","Basnahira~1|Dakunu~3|Madhyama~2|Naegenahira~5|Sabaragamuwa~9|Uturu~4|Uturumaeda~7|Vayamba~6|Uva~8"],["Sudan","SD","Al Bahr al Ahmar~RS|Al Jazirah~GZ|Al Khartum~KH|Al Qadarif~GD|An Nil al Abyad~NW|An Nil al Azraq~NB|Ash Shamaliyah~NO|Gharb Darfur~DW|Gharb Kurdufan~GK|Janub Darfur~DS|Janub Kurdufan~KS|Kassala~KA|Nahr an Nil~NR|Shamal Darfur~DN|Sharq Darfur~DE|Shiamal Kurdufan~KN|Sinnar~SI|Wasat Darfur Zalinjay~DC"],["Suriname","SR","Brokopondo~BR|Commewijne~CM|Coronie~CR|Marowijne~MA|Nickerie~NI|Para~PR|Paramaribo~PM|Saramacca~SA|Sipaliwini~SI|Wanica~WA"],["Swaziland","SZ","Hhohho~HH|Lubombo~LU|Manzini~MA|Shiselweni~SH"],["Sweden","SE","Blekinge~K|Dalarnas~W|Gotlands~X|Gavleborgs~I|Hallands~N|Jamtlands~Z|Jonkopings~F|Kalmar~H|Kronobergs~G|Norrbottens~BD|Orebro~T|Ostergotlands~E|Skane~M|Sodermanlands~D|Stockholm~AB|Varmlands~S|Vasterbottens~AC|Vasternorrlands~Y|Vastmanlands~U|Vastra Gotalands~O"],["Switzerland","CH","Aargau~AG|Appenzell Ausserrhoden~AR|Appenzell Innerhoden~AI|Basel-Landschaft~BL|Basel-Stadt~BS|Bern~BE|Fribourg~FR|Genève~GE|Glarus~GL|Graubünden~GR|Jura~JU|Luzern~LU|Neuchâtel~NE|Nidwalden~NW|Obwalden~OW|Sankt Gallen~SG|Schaffhausen~SH|Schwyz~SZ|Solothurn~SO|Thurgau~TG|Ticino~TI|Uri~UR|Valais~VS|Vaud~VD|Zug~ZG|Zürich~ZH"],["Syrian Arab Republic","SY","Al Hasakah~HA|Al Ladhiqiyah~LA|Al Qunaytirah~QU|Ar Raqqah~RA|As Suwayda'~SU|Dar'a~DR|Dayr az Zawr~DY|Dimashq~DI|Halab~HL|Hamah~HM|Hims~HI|Idlib~ID|Rif Dimashq~RD|Tartus~TA"],["Taiwan","TW","Chang-hua~CHA|Chia-i~CYQ|Hsin-chu~HSQ|Hua-lien~HUA|Kao-hsiung~KHH|Keelung~KEE|Kinmen~KIN|Lienchiang~LIE|Miao-li~MIA|Nan-t'ou~NAN|P'eng-hu~PEN|New Taipei~NWT|P'ing-chung~PIF|T'ai-chung~TXG|T'ai-nan~TNN|T'ai-pei~TPE|T'ai-tung~TTT|T'ao-yuan~TAO|Yi-lan~ILA|Yun-lin~YUN"],["Tajikistan","TJ","Dushanbe~DU|Kŭhistoni Badakhshon~GB|Khatlon~KT|Sughd~SU"],["Tanzania, United Republic of","TZ","Arusha~01|Coast~19|Dar es Salaam~02|Dodoma~03|Iringa~04|Kagera~05|Kigoma~08|Kilimanjaro~09|Lindi~12|Manyara~26|Mara~13|Mbeya~14|Morogoro~16|Mtwara~17|Mwanza~18|Pemba North~06|Pemba South~10|Rukwa~20|Ruvuma~21|Shinyanga~22|Singida~23|Tabora~24|Tanga~25|Zanzibar North~07|Zanzibar Central/South~11|Zanzibar Urban/West~15"],["Thailand","TH","Amnat Charoen~37|Ang Thong~15|Bueng Kan~38|Buri Ram~31|Chachoengsao~24|Chai Nat~18|Chaiyaphum~36|Chanthaburi~22|Chiang Mai~50|Chiang Rai~57|Chon Buri~20|Chumphon~86|Kalasin~46|Kamphaeng Phet~62|Kanchanaburi~71|Khon Kaen~40|Krabi~81|Krung Thep Mahanakhon (Bangkok)~10|Lampang~52|Lamphun~51|Loei~42|Lop Buri~16|Mae Hong Son~58|Maha Sarakham~44|Mukdahan~49|Nakhon Nayok~26|Nakhon Phathom~73|Nakhon Phanom~48|Nakhon Ratchasima~30|Nakhon Sawan~60|Nakhon Si Thammarat~80|Nan~55|Narathiwat~96|Nong Bua Lam Phu~39|Nong Khai~43|Nonthaburi~12|Pathum Thani~13|Pattani~94|Phangnga~82|Phatthalung~93|Phayao~56|Phetchabun~76|Phetchaburi~76|Phichit~66|Phitsanulok~65|Phra Nakhon Si Ayutthaya~14|Phrae~54|Phuket~83|Prachin Buri~25|Prachuap Khiri Khan~77|Ranong~85|Ratchaburi~70|Rayong~21|Roi Et~45|Sa Kaeo~27|Sakon Nakhon~47|Samut Prakan~11|Samut Sakhon~74|Samut Songkhram~75|Saraburi~19|Satun~91|Sing Buri~17|Si Sa ket~33|Songkhla~90|Sukhothai~64|Suphan Buri~72|Surat Thani~84|Surin~32|Tak~63|Trang~92|Trat~23|Ubon Ratchathani~34|Udon Thani~41|Uthai Thani~61|Uttaradit~53|Yala~95|Yasothon~35"],["Timor-Leste","TL","Aileu~AL|Ainaro~AN|Baucau~BA|Bobonaro~BO|Cova Lima~CO|Dili~DI|Ermera~ER|Lautem~LA|Liquica~LI|Manatuto~MT|Manufahi~MF|Oecussi~OE|Viqueque~VI"],["Togo","TG","Centre~C|Kara~K|Maritime~M|Plateaux~P|Savannes~S"],["Tokelau","TK","Atafu|Fakaofo|Nukunonu"],["Tonga","TO","'Eua~01|Ha'apai~02|Niuas~03|Tongatapu~04|Vava'u~05"],["Trinidad and Tobago","TT","Arima~ARI|Chaguanas~CHA|Couva-Tabaquite-Talparo~CTT|Diefo Martin~DMN|Mayaro-Rio Claro~MRC|Penal-Debe~PED|Point Fortin~PTF|Port-of-Spain~POS|Princes Town~PRT|San Fernando~SFO|San Juan-Laventille~SJL|Sangre Grande~SGE|Siparia~SIP|Tobago~TOB|Tunapuna-Piarco~TUP"],["Tunisia","TN","Ariana~12|Beja~31|Ben Arous~13|Bizerte~23|Gabes~81|Gafsa~71|Jendouba~32|Kairouan~41|Kasserine~42|Kebili~73|Kef~33|Mahdia~53|Medenine~82|Monastir~52|Nabeul~21|Sfax~61|Sidi Bouzid~43|Siliana~34|Sousse~51|Tataouine~83|Tozeur~72|Tunis~11|Zaghouan~22"],["Turkey","TR","Adana~01|Adiyaman~02|Afyonkarahisar~03|Agri~04|Aksaray~68|Amasya~05|Ankara~06|Antalya~07|Ardahan~75|Artvin~08|Aydin~09|Balikesir~10|Bartin~74|Batman~72|Bayburt~69|Bilecik~11|Bingol~12|Bitlis~13|Bolu~14|Burdur~15|Bursa~16|Canakkale~17|Cankiri~18|Corum~19|Denizli~20|Diyarbakir~21|Duzce~81|Edirne~22|Elazig~23|Erzincan~24|Erzurum~25|Eskisehir~26|Gaziantep~27|Giresun~28|Gumushane~29|Hakkari~30|Hatay~31|Igdir~76|Isparta~32|Istanbul~34|Izmir~35|Kahramanmaras~46|Karabuk~78|Karaman~70|Kars~36|Kastamonu~37|Kayseri~38|Kilis~79|Kirikkale~71|Kirklareli~39|Kirsehir~40|Kocaeli~41|Konya~42|Kutahya~43|Malatya~44|Manisa~45|Mardin~47|Mersin~33|Mugla~48|Mus~49|Nevsehir~50|Nigde~51|Ordu~52|Osmaniye~80|Rize~53|Sakarya~54|Samsun~55|Sanliurfa~63|Siirt~56|Sinop~57|Sirnak~73|Sivas~58|Tekirdag~59|Tokat~60|Trabzon~61|Tunceli~62|Usak~64|Van~65|Yalova~77|Yozgat~66|Zonguldak~67"],["Turkmenistan","TM","Ahal~A|Asgabat~S|Balkan~B|Dashoguz~D|Lebap~L|Mary~M"],["Turks and Caicos Islands","TC","Turks and Caicos Islands"],["Tuvalu","TV","Funafuti~FUN|Nanumanga~NMG|Nanumea~NMA|Niutao~NIT|Nui~NUI|Nukufetau~NKF|Nukulaelae~NKL|Vaitupu~VAU"],["Uganda","UG","Abim~317|Adjumani~301|Amolatar~314|Amuria~216|Amuru~319|Apac~302|Arua~303|Budaka~217|Bududa~223|Bugiri~201|Bukedea~224|Bukwa~218|Buliisa~419|Bundibugyo~401|Bushenyi~402|Busia~202|Butaleja~219|Dokolo~318|Gulu~304|Hoima~403|Ibanda~416|Iganga~203|Isingiro~417|Jinja~204|Kaabong~315|Kabale~404|Kabarole~405|Kaberamaido~213|Kalangala~101|Kaliro~220|Kampala~102|Kamuli~205|Kamwenge~413|Kanungu~414|Kapchorwa~206|Kasese~406|Katakwi~207|Kayunga~112|Kibaale~407|Kiboga~103|Kiruhura~418|Kisoro~408|Kitgum~305|Koboko~316|Kotido~306|Kumi~208|Kyenjojo~415|Lira~307|Luwero~104|Lyantonde~116|Manafwa~221|Maracha~320|Masaka~105|Masindi~409|Mayuge~214|Mbale~209|Mbarara~410|Mityana~114|Moroto~308|Moyo~309|Mpigi~106|Mubende~107|Mukono~108|Nakapiripirit~311|Nakaseke~115|Nakasongola~109|Namutumba~222|Nebbi~310|Ntungamo~411|Oyam~321|Pader~312|Pallisa~210|Rakai~110|Rukungiri~412|Sembabule~111|Sironko~215|Soroti~211|Tororo~212|Wakiso~113|Yumbe~313"],["Ukraine","UA","Cherkasy~71|Chernihiv~74|Chernivtsi~77|Dnipropetrovsk~12|Donetsk~14|Ivano-Frankivsk~26|Kharkiv~63|Kherson~65|Khmelnytskyi~68|Kiev~32|Kirovohrad~35|Luhansk~09|Lviv~46|Mykolaiv~48|Odessa~51|Poltava~53|Rivne~56|Sumy~59|Ternopil~61|Vinnytsia~05|Volyn~07|Zakarpattia~21|Zaporizhia~23|Zhytomyr~18|Avtonomna Respublika Krym~43|Kyïv~30|Sevastopol~40"],["United Arab Emirates","AE","Abu Dhabi~AZ|Ajman~AJ|Dubai~DU|Fujairah~FU|Ras al Khaimah~RK|Sharjah~SH|Umm Al Quwain~UQ"],["United Kingdom","GB","Avon~AVN|Bedfordshire~BDF|Berkshire~BRK|Bristol, City of~COB|Buckinghamshire~BKM|Cambridgeshire~CAM|Cheshire~CHS|Cleveland~CLV|Cornwall~CON|Cumbria~CMA|Derbyshire~DBY|Devon~DEV|Dorset~DOR|Durham~DUR|East Sussex~SXE|Essex~ESS|Gloucestershire~GLS|Greater London~LND|Greater Manchester~GTM|Hampshire (County of Southampton)~HAM|Hereford and Worcester~HWR|Herefordshire~HEF|Hertfordshire~HRT|Isle of Wight~IOW|Kent~KEN|Lancashire~LAN|Leicestershire~LEI|Lincolnshire~LIN|London~LDN|Merseyside~MSY|Middlesex~MDX|Norfolk~NFK|Northamptonshire~NTH|Northumberland~NBL|North Humberside~NHM|North Yorkshire~NYK|Nottinghamshire~NTT|Oxfordshire~OXF|Rutland~RUT|Shropshire~SAL|Somerset~SOM|South Humberside~SHM|South Yorkshire~SYK|Staffordshire~STS|Suffolk~SFK|Surrey~SRY|Tyne and Wear~TWR|Warwickshire~WAR|West Midlands~WMD|West Sussex~SXW|West Yorkshire~WYK|Wiltshire~WIL|Worcestershire~WOR|Antrim~ANT|Armagh~ARM|Belfast, City of~BLF|Down~DOW|Fermanagh~FER|Londonderry~LDY|Derry, City of~DRY|Tyrone~TYR|Aberdeen, City of~AN|Aberdeenshire~ABD|Angus (Forfarshire)~ANS|Argyll~AGB|Ayrshire~ARG|Banffshire~BAN|Berwickshire~BEW|Bute~BUT|Caithness~CAI|Clackmannanshire~CLK|Cromartyshire~COC|Dumfriesshire~DFS|Dunbartonshire (Dumbarton)~DNB|Dundee, City of~DD|East Lothian (Haddingtonshire)~ELN|Edinburgh, City of~EB|Fife~FIF|Glasgow, City of~GLA|Inverness-shire~INV|Kincardineshire~KCD|Kinross-shire~KRS|Kirkcudbrightshire~KKD|Lanarkshire~LKS|Midlothian (County of Edinburgh)~MLN|Moray (Elginshire)~MOR|Nairnshire~NAI|Orkney~OKI|Peeblesshire~PEE|Perthshire~PER|Renfrewshire~RFW|Ross and Cromarty~ROC|Ross-shire~ROS|Roxburghshire~ROX|Selkirkshire~SEL|Shetland (Zetland)~SHI|Stirlingshire~STI|Sutherland~SUT|West Lothian (Linlithgowshire)~WLN|Wigtownshire~WIG|Clwyd~CWD|Dyfed~DFD|Gwent~GNT|Gwynedd~GWN|Mid Glamorgan~MGM|Powys~POW|South Glamorgan~SGM|West Glamorgan~WGM"],["United States","US","Alabama~AL|Alaska~AK|American Samoa~AS|Arizona~AZ|Arkansas~AR|California~CA|Colorado~CO|Connecticut~CT|Delaware~DE|District of Columbia~DC|Micronesia~FM|Florida~FL|Georgia~GA|Guam~GU|Hawaii~HI|Idaho~ID|Illinois~IL|Indiana~IN|Iowa~IA|Kansas~KS|Kentucky~KY|Louisiana~LA|Maine~ME|Marshall Islands~MH|Maryland~MD|Massachusetts~MA|Michigan~MI|Minnesota~MN|Mississippi~MS|Missouri~MO|Montana~MT|Nebraska~NE|Nevada~NV|New Hampshire~NH|New Jersey~NJ|New Mexico~NM|New York~NY|North Carolina~NC|North Dakota~ND|Northern Mariana Islands~MP|Ohio~OH|Oklahoma~OK|Oregon~OR|Palau~PW|Pennsylvania~PA|Puerto Rico~PR|Rhode Island~RI|South Carolina~SC|South Dakota~SD|Tennessee~TN|Texas~TX|Utah~UT|Vermont~VT|Virgin Islands~VI|Virginia~VA|Washington~WA|West Virginia~WV|Wisconsin~WI|Wyoming~WY|Armed Forces Americas~AA|Armed Forces Europe, Canada, Africa and Middle East~AE|Armed Forces Pacific~AP"],["United States Minor Outlying Islands","UM","Baker Island~81|Howland Island~84|Jarvis Island~86|Johnston Atoll~67|Kingman Reef~89|Midway Islands~71|Navassa Island~76|Palmyra Atoll~95|Wake Island~79|Bajo Nuevo Bank~BN|Serranilla Bank~SB"],["Uruguay","UY","Artigas~AR|Canelones~CA|Cerro Largo~CL|Colonia~CO|Durazno~DU|Flores~FS|Florida~FD|Lavalleja~LA|Maldonado~MA|Montevideo~MO|Paysandú~PA|Río Negro~RN|Rivera~RV|Rocha~RO|Salto~SA|San José~SJ|Soriano~SO|Tacuarembó~TA|Treinta y Tres~TT"],["Uzbekistan","UZ","Toshkent shahri~TK|Andijon~AN|Buxoro~BU|Farg‘ona~FA|Jizzax~JI|Namangan~NG|Navoiy~NW|Qashqadaryo (Qarshi)~QA|Samarqand~SA|Sirdaryo (Guliston)~SI|Surxondaryo (Termiz)~SU|Toshkent wiloyati~TO|Xorazm (Urganch)~XO|Qoraqalpog‘iston Respublikasi (Nukus)~QR"],["Vanuatu","VU","Malampa~MAP|Pénama~PAM|Sanma~SAM|Shéfa~SEE|Taféa~TAE|Torba~TOB"],["Venezuela, Bolivarian Republic of","VE","Dependencias Federales~W|Distrito Federal~A|Amazonas~Z|Anzoátegui~B|Apure~C|Aragua~D|Barinas~E|Bolívar~F|Carabobo~G|Cojedes~H|Delta Amacuro~Y|Falcón~I|Guárico~J|Lara~K|Mérida~L|Miranda~M|Monagas~N|Nueva Esparta~O|Portuguesa~P|Sucre~R|Táchira~S|Trujillo~T|Vargas~X|Yaracuy~U|Zulia~V"],["Vietnam","VN","Đồng Nai~39|Đồng Tháp~45|Gia Lai~30|Hà Giang~03|Hà Nam~63|Hà Tây~15|Hà Tĩnh~23|Hải Dương~61|Hậu Giang~73|Hòa Bình~14|Hưng Yên~66|Khánh Hòa~34|Kiên Giang~47|Kon Tum~28|Lai Châu~01|Lâm Đồng~35|Lạng Sơn~09|Lào Cai~02|Long An~41|Nam Định~67|Nghệ An~22|Ninh Bình~18|Ninh Thuận~36|Phú Thọ~68|Phú Yên~32|Quảng Bình~24|Quảng Nam~27|Quảng Ngãi~29|Quảng Ninh~13|Quảng Trị~25|Sóc Trăng~52|Sơn La~05|Tây Ninh~37|Thái Bình~20|Thái Nguyên~69|Thanh Hóa~21|Thừa Thiên–Huế~26|Tiền Giang~46|Trà Vinh~51|Tuyên Quang~07|Vĩnh Long~49|Vĩnh Phúc~70|Yên Bái~06|Cần Thơ~CT|Đà Nẵng~DN|Hà Nội~HN|Hải Phòng~HP|Hồ Chí Minh (Sài Gòn)~SG"],["Virgin Islands, British","VG","Anegada~ANG|Jost Van Dyke~JVD|Tortola~TTA|Virgin Gorda~VGD"],["Virgin Islands, U.S.","VI","St. Thomas~STH|St. John~SJO|St. Croix~SCR"],["Wallis and Futuna","WF","Alo~ALO|Sigave~SIG|Wallis~WAL"],["Western Sahara","EH","Es Smara~ESM|Boujdour~BOD|Laâyoune~LAA|Aousserd~AOU|Oued ed Dahab~OUD"],["Yemen","YE","Abyān~AB|'Adan~AD|Aḑ Ḑāli'~DA|Al Bayḑā'~BA|Al Ḩudaydah~HU|Al Jawf~JA|Al Mahrah~MR|Al Maḩwīt~MW|'Amrān~AM|Dhamār~DH|Ḩaḑramawt~HD|Ḩajjah~HJ|Ibb~IB|Laḩij~LA|Ma'rib~MA|Raymah~RA|Şā‘dah~SD|Şan‘ā'~SN|Shabwah~SH|Tā‘izz~TA"],["Zambia","ZM","Central~02|Copperbelt~08|Eastern~03|Luapula~04|Lusaka~09|Northern~05|North-Western~06|Southern~07|Western~01"],["Zimbabwe","ZW","Bulawayo~BU|Harare~HA|Manicaland~MA|Mashonaland Central~MC|Mashonaland East~ME|Mashonaland West~MW|Masvingo~MV|Matabeleland North~MN|Matabeleland South~MS|Midlands~MI"]],a=function(){l=s;for(var a=document.getElementsByClassName("crs-country"),n=0;n<a.length;n++)e(a[n])},e=function(a){if("true"!==a.getAttribute("data-crs-loaded")){a.length=0;var n=a.getAttribute("data-default-option"),e=n||"Select country",i=a.getAttribute("data-show-default-option");m=null===i||"true"===i;var r=a.getAttribute("data-default-value"),o=a.getAttribute("data-value"),l=0;m&&(a.options[0]=new Option(e,"")),B();var t=b(a);console.log(o);for(var s=0;s<t.length;s++){var u="shortcode"===o||"2-char"===o?t[s][1]:t[s][0];t[s][4]&&(u=""),a.options[a.length]=new Option(t[s][0],u),null!=r&&r===u&&(l=s,m&&l++)}a.selectedIndex=l;var d=a.getAttribute("data-region-id");if(d){var h=document.getElementById(d);if(h)if(M(h),a.onchange=function(){c(a,h)},null!==r&&0<a.selectedIndex){c(a,h);var S=h.getAttribute("data-default-value"),A="shortcode"===h.getAttribute("data-value");if(null!==S){var g=t[m?a.selectedIndex-1:a.selectedIndex][3];k(h,g,S,A)}}else!1===m&&c(a,h);else console.error("Region dropdown DOM node with ID "+d+" not found.");a.setAttribute("data-crs-loaded","true")}else console.error("Missing data-region-id on country-region-selector country field.")}},M=function(a){var n=a.getAttribute("data-blank-option"),e=n||"-",i=a.getAttribute("data-show-default-option");h=null===i||"true"===i,a.length=0,h&&(a.options[0]=new Option(e,""),a.selectedIndex=0)},B=function(){for(var a=0;a<l.length;a++){for(var n={hasShortcodes:/~/.test(l[a][2]),regions:[]},e=l[a][2].split("|"),i=0;i<e.length;i++){var r=e[i].split("~");n.regions.push([r[0],r[1]])}l[a][3]=n}},k=function(a,n,e,i){for(var r=0;r<n.regions.length;r++){if((i&&n.hasShortcodes&&n.regions[r][1]?n.regions[r][1]:n.regions[r][0])===e){a.selectedIndex=h?r+1:r;break}}},c=function(a,n){var e=m?a.selectedIndex-1:a.selectedIndex,i=n.getAttribute("data-default-option"),r=n.getAttribute("data-value"),o=i||"Select region";if(""===a.value)M(n);else{n.length=0,h&&(n.options[0]=new Option(o,""));var l=b(a)[e][3],t="shortcode"===r&&l.hasShortcodes,s=t?1:0;l.regions.sort(function(a,n){var e=a[s].toLowerCase(),i=n[s].toLowerCase();return e<i?-1:i<e?1:0});for(var u=0;u<l.regions.length;u++){var d=t?l.regions[u][1]:l.regions[u][0];n.options[n.length]=new Option(l.regions[u][0],d)}n.selectedIndex=0}},b=function(a){var n=a.getAttribute("data-whitelist"),e=a.getAttribute("data-blacklist"),i=a.getAttribute("data-preferred"),r=a.getAttribute("data-preferred-delim"),o=l;return(n||e)&&(o=function(a){var n=a.whitelist+"|"+a.blacklist,e=0;if(!t.hasOwnProperty(n))if(t[n]=[],a.whitelist){var i=a.whitelist.split(",");for(e=0;e<s.length;e++)-1!==i.indexOf(s[e][1])&&t[n].push(e)}else if(a.blacklist){var r=a.blacklist.split(",");for(e=0;e<s.length;e++)-1===r.indexOf(s[e][1])&&t[n].push(e)}var o=[];for(e=0;e<t[n].length;e++)o.push(s[t[n][e]]);return o}({whitelist:n,blacklist:e})),i&&(o=u(o,i,r)),o},u=function(a,n,e){var i=n.split(",").reverse(),r={},o=!1,l=a.filter(function(a){return-1===i.indexOf(a[1])||(r[a[1]]=a,!(o=!0))});o&&e&&l.unshift([e,"","",{},!0]);for(var t=0;t<i.length;t++){var s=i[t];l.unshift(r[s])}return l};return function(n,e){var i=!1,a=!0,r=n.document,o=r.documentElement,l=r.addEventListener?"addEventListener":"attachEvent",t=r.addEventListener?"removeEventListener":"detachEvent",s=r.addEventListener?"":"on",u=function(a){"readystatechange"==a.type&&"complete"!=r.readyState||(("load"==a.type?n:r)[t](s+a.type,u,!1),!i&&(i=!0)&&e.call(n,a.type||a))},d=function(){try{o.doScroll("left")}catch(a){return void setTimeout(d,50)}u("poll")};if("complete"==r.readyState)e.call(n,"lazy");else{if(r.createEventObject&&o.doScroll){try{a=!n.frameElement}catch(a){}a&&d()}r[l](s+"DOMContentLoaded",u,!1),r[l](s+"readystatechange",u,!1),n[l](s+"load",u,!1)}}(window,a),{init:a}});
//-------------------------------------------------------------
const is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
const is_chrome = !!window.chrome && !is_opera;
const is_explorer = typeof document !== 'undefined' && !!document.documentMode;
const is_firefox = typeof window.InstallTrigger !== 'undefined';
const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const pixelActive = () => typeof fbq === "function";
const gaActive = () => typeof gtag === "function"; //&& typeof ga ==="function";
const pinActive = () => typeof pntrk === "function";
const hasCustomShopProductScripts = () => typeof _mptShopProductCustomScript === "function";
const hasCustomShopDeliveryScripts = () => typeof _mptShopDeliveryCustomScript === "function";
const hasCustomLoginScripts = () => typeof _mptUserLoginCustomScript === "function";
const hasCustomMenuScripts = () => typeof _mptShopMenuCustomScript === "function";
const hasCustomStoreProductsScripts = () => typeof _mptStoreProductsCustomScript === "function";
const hasCustomConfirmationScripts = () => typeof _mptConfirmationCustomScript === "function";
const hasCustomReviewCheckoutScripts = () => typeof _mptReviewCheckoutCustomScript === "function";
const hasCustomProductScripts = () => typeof _mptCustomProductCustomScript === "function";
const hasCustomChefsChoiceProductScripts = () => typeof _mptChefsChoiceProductCustomScript === "function";
const hasCustomSubscriptionEditScripts = () => typeof _mptSubscriptionEditCustomScript === "function";
const hasCustomPackageScripts = () => typeof _mptShopPackageCustomScript === "function";
const hasCustomFeaturedProductRoute = () => typeof _mptCustomFeaturedProductScript === "function";
const hasCustomInitBuyScripts = () => typeof _mptCustomInitBuyScript === "function";
const hasCustomOrderProductsScripts = () => typeof _mptCustomOrderProductsScript === "function";
const getCookie = (key) => decodeURIComponent(document.cookie).replace(/\s/g, "").split(";").map(x => x.split("=")).filter(x => x[0] === key).map(x => x[1]).firstOrDefault();
const enforceSubEdits = () => mptapi.companyInfo && mptapi.user && mptapi.user.hasActiveSubscriptions && mptapi.companyInfo.enforceSubscriptionOverwrite;

jMPT.fn.extend({
    ffCustomValidate: function (options) {
        let thisElem = jMPT(this);
        if (thisElem.length === 0 || typeof options === 'undefined' || options == null || !options) {
            return {isValid: true, errors: []};
        }
        else {
            let isValid = true;
            let currentValid = true;
            let errors = [];
            let value = thisElem.val().trim();

            if (options.digitsOnly) {
                value = value.replace(/[^0-9]/g, '');
                thisElem.val(value);
            }

            if (options.required) {
                if (thisElem.is('[type="checkbox"]')) {
                    currentValid = thisElem.is(':checked');
                    if (!currentValid)
                        errors.push('You must agree to continue.');
                }
                else if (thisElem.is('[type="date"]')) {
                    currentValid = value.length > 0;
                    if (!currentValid)
                        errors.push('Please enter a valid date.');
                }
                else {
                    currentValid = value.length > 0;
                    if (!currentValid)
                        errors.push('This field is required.');
                }

                isValid = isValid && currentValid;
            }

            if (options.maxLength && options.maxLength > 0) {
                currentValid = value.length <= options.maxLength;
                isValid = isValid && currentValid;

                if (!currentValid)
                    errors.push('Must be ' + options.maxLength + ' or less ' + (options.digitsOnly ? 'digits' : 'characters') + ' long.');
            }

            if (options.minLength && options.minLength > 0) {
                currentValid = value.length >= options.minLength;
                isValid = isValid && currentValid;

                if (!currentValid)
                    errors.push('Must be ' + options.minLength + ' or more ' + (options.digitsOnly ? 'digits' : 'characters') + ' long.');
            }

            if (options.inList && options.inList.length > 0) {
                currentValid = options.inList.includes(value);
                isValid = isValid && currentValid;

                if (!currentValid)
                    errors.push('Invalid option.');
            }

            if (options.isEmail) {
                let emailRegExCheck = new RegExp(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,7})$/);
                currentValid = emailRegExCheck.test(value);
                isValid = isValid && currentValid;

                if (!currentValid)
                    errors.push('Oops! Looks like this isn\'t a valid email.');

            }


            if (options.isPhone) {
                if (value.length > 0) {
                    value = value.replace(/[^0-9]/g, '');
                    currentValid = value.length === 10 || value.length === 11;
                } else currentValid = false;

                isValid = isValid && currentValid;

                if (!currentValid)
                    errors.push('Oops! Looks like this isn\'t a valid phone number.');
                else {
                    if (value.length === 10) {
                        value = '(' + value.substr(0, 3) + ') ' + value.substr(3, 3) + '-' + value.substr(6, 4);
                        thisElem.val(value);
                    }
                    else if (value.length === 11) {
                        value = '+' + value.substr(0, 1) + ' (' + value.substr(1, 3) + ') ' + value.substr(4, 3) + '-' + value.substr(7, 4);
                        thisElem.val(value);
                    }
                }
            }

            if (options.isPostal) {
                if (value.length > 0) {
                    value = value.replace(' ', '');
                    currentValid = value.length === 5 || value.length === 6;
                } else currentValid = false;

                if (!currentValid)
                    errors.push('Oops! Looks like this isn\'t a valid postal code.');
            }

            thisElem.css('border-color', '');
            let existingError = thisElem.next('.mpt-error');
            if(existingError.length > 0)
                existingError.remove();

            if (errors.length > 0) {
                let error = jMPT('<span>', {'class': 'mpt-error', text: errors[0]});
                error.css('color', '#f7a8a8');

                thisElem.css('border-color', '#f7a8a8');
                error.insertAfter(thisElem);
            }

            return {isValid, errors};
        }
    }
});

function ffCustomModalsAreClosed()
{
    try {
        let getStartedModalState = getSafeAPIValue('mptapi.orderVues.ffCustomGetStarted.vueApp.getStartedModal.state');
        if(getStartedModalState === 'open') return false;
    } catch { }

    try {
        let userAccountModalState = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp.userAccountModal.state');
        if(userAccountModalState === 'open') return false;
    } catch { }

    try {
        let registerModalState = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp.registerModal.state');
        if(registerModalState === 'open') return false;
    } catch { }

    return true;
}

function ffSetCustomModalState(modalName, state, customBox){
    switch(modalName)
    {
        case 'userAccountModal':
            try {
                let userAccountModal = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp.userAccountModal');
                if(userAccountModal)
                {
                    if(state === 'open' && customBox)
                    {
                        userAccountModal.modal = customBox;
                        userAccountModal.state = 'open';
                    }
                    else {
                        userAccountModal.state = 'closed';
                        if(userAccountModal.modal) userAccountModal.modal._close();

                    }
                }
            } catch { }
            break;
        case 'registerModal':
            try {
                let registerModal = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp.registerModal');
                if(registerModal)
                {
                    if(state === 'open' && customBox)
                    {
                        registerModal.modal = customBox;
                        registerModal.state = 'open';
                    }
                    else {
                        registerModal.state = 'closed';
                        if(registerModal.modal) registerModal.modal._close();

                    }
                }
            } catch { }
            break;
        default:
            try {
                let getStartedModal = getSafeAPIValue('mptapi.orderVues.ffCustomGetStarted.vueApp.getStartedModal');
                if(getStartedModal)
                {
                    if(state === 'open')
                    {
                        getStartedModal.modal = customBox;
                        getStartedModal.state = 'open';
                    }
                    else {
                        getStartedModal.state = 'closed';
                        if(getStartedModal.modal) getStartedModal.modal._close();

                    }
                }
            } catch { }
            break;
    }

}

function shortWindowStringFromDates(/*Date*/ date1, /*Date*/ date2, /*string*/ separator)
{
    return date1.toLocaleTimeString('en-US').replaceAll(':00', '').replaceAll(' ', '') + (separator || ' - ') + date2.toLocaleTimeString('en-US').replaceAll(':00', '').replaceAll(' ', '');
}

function updateGlobalCartObjects(cart){
    if(cart) {
        let deliveries = getSafeAPIValue('mptapi.cart.deliveries');
        let cartCount = -1;
        if(deliveries)
        {
            cartCount = deliveries.map(x => {
                if(x.products)
                    return x.products.map(y => y.qty).sum();
                else return 0;
            }).sum();
        }

        let ffCustomCart = getSafeAPIValue('mptapi.ffCustomCartVue.vueApp');
        if(ffCustomCart)
        {
            ffCustomCart.updateCart(cart);
        }

        let bottomCheckoutBar = getSafeAPIValue('mptapi.storeVues.mptBottomCheckoutBar.vueApp');
        if(bottomCheckoutBar)
        {
            let cartModel = new MPTCartModel(context.cart);
            bottomCheckoutBar.updateCart(cartModel);
        }

        if(cartCount > -1) {
            let ffBottomNav = getSafeAPIValue('mptapi.ffBottomNavVue.vueApp');
            if (ffBottomNav) {
                ffBottomNav.cartCount = cartCount;
            }

            let ffTopNav = getSafeAPIValue('mptapi.ffTopNavVue.vueApp');
            if (ffTopNav) {
                ffTopNav.cartCount = cartCount;
            }

            let ffOrder = getSafeAPIValue('mptapi.orderVues.mptOrder.vueApp');
            if (ffOrder) {
                let cartDelivery = deliveries.filter(d => d.id === ffOrder.deliveryId);
                if(cartDelivery && cartDelivery.length > 0)
                    ffOrder.updateQtys(cartDelivery[0].products);

            }
        }
    }
}

function trueViewPortOffset(){
    if(typeof(_viewPortOverride) === 'number')
        return _viewPortOverride;

    let lastHeader = jMPT('.mpt-current-date-container');

    if(lastHeader.length > 0) return lastHeader.offset().top + lastHeader.height() - jMPT(document).scrollTop();
    else return 0;
}

function updateCopyright(){
    try {
        let copyrightElem = jMPT('.mpt-copyright-year');
        if (copyrightElem.length > 0)
            copyrightElem.text(new Date().getFullYear().toString());
    }catch(err)
    {
        console.error(err);
    }
}

function getSafeAPIValue(/*string*/ variable) {
    try {
        let result = false;
        if (typeof(mptapi) !== 'undefined') {
            result = mptapi;
            if (variable && result) {
                if (variable.startsWith('mptapi.'))
                    variable = variable.replace('mptapi.', '');

                let accessors = variable.split('.');

                if (accessors.length > 0) {
                    for (let i = 0; i < accessors.length; i++) {
                        let thisAccessor = accessors[i];
                        if (thisAccessor) {
                            let bracketMatches = thisAccessor.match(/\[.*?\]/g);
                            if(bracketMatches && bracketMatches.length > 0)
                            {
                                for(let j = 0; j < bracketMatches.length; j++) {
                                    let bracketContents = bracketMatches[j].replace('[', '').replace(']', '');
                                    thisAccessor = thisAccessor.split('[')[0];

                                    try {
                                        let index = parseInt(bracketContents);
                                        if (result.hasOwnProperty(thisAccessor)) {
                                            result = result[thisAccessor];

                                            if (result.length > index) {
                                                result = result[index];
                                            } else return false;
                                        } else return false;
                                    }
                                    catch {
                                        accessors.splice(i + 1, 0, bracketContents);
                                    }
                                }
                            }
                            else {
                                if (result.hasOwnProperty(thisAccessor)) {
                                    result = result[thisAccessor];
                                } else return false;
                            }
                        } else return false;
                    }
                } else return false;

            } else return false;
        } else return false;

        return result;
    }catch(err)
    { return false; }
}


function getSafeValue(/*Object*/ obj, /*String*/ variable) {
    try {
        let result = false;
        if (typeof(obj) !== 'undefined') {
            result = obj;
            if (variable && result) {
                let accessors = variable.split('.');

                if (accessors.length > 0) {
                    for (let i = 0; i < accessors.length; i++) {
                        let thisAccessor = accessors[i];
                        if (thisAccessor) {
                            let bracketMatches = thisAccessor.match(/\[.*?\]/g);
                            if(bracketMatches && bracketMatches.length > 0)
                            {
                                for(let j = 0; j < bracketMatches.length; j++) {
                                    let bracketContents = bracketMatches[j].replace('[', '').replace(']', '');
                                    thisAccessor = thisAccessor.split('[')[0];

                                    try {
                                        let index = parseInt(bracketContents);
                                        if (result.hasOwnProperty(thisAccessor)) {
                                            result = result[thisAccessor];

                                            if (result.length > index) {
                                                result = result[index];
                                            } else return false;
                                        } else return false;
                                    }
                                    catch {
                                        accessors.splice(i + 1, 0, bracketContents);
                                    }
                                }
                            }
                            else {
                                if (result.hasOwnProperty(thisAccessor)) {
                                    result = result[thisAccessor];
                                } else return false;
                            }
                        } else return false;
                    }
                } else return false;

            } else return false;
        } else return false;

        return result;
    }catch(err)
    { return false; }
}

function setAlertTop(){
    let alertTop = 0, headerTop = 0, catTop = 0;

    let headerMain = jMPT('.header-main');
    if(headerMain.length > 0)
        headerTop = headerMain.position().top + headerMain.outerHeight() - 1;

    let catSlider = jMPT('.mpt-category-slider-section');
    if(catSlider.length > 0)
        catTop = catSlider.position().top + catSlider.outerHeight() - 1;

    alertTop = Math.max(headerTop, catTop);

    let alertContainer = jMPT('FFCustomAlertContainer');
    if(alertContainer.length > 0)
    {
        alertContainer.css({top : `${alertTop}px`});
    }
}

function locationParamsToJSON(location)
{
    let searchString = location.search.substr(1);
    if(searchString.length > 0) {
        let paramArray = searchString.split('&');

        let currObj = {};
        for(let i = 0; i < paramArray.length; i++)
        {
            try{
                let currParam = paramArray[i].split('=');
                currObj[currParam[0]] = decodeURIComponent(currParam[1]);
            } catch (e) {
                let err = {location, e};
                console.error(err);
            }
        }

        return currObj;
    }
    else return null;
}

function getAllCookies() {
    return document.cookie.split(';').reduce(
        (cookies, cookie) => {
            const [name, val] = cookie.split(
                '=').map(c => c.trim());

            cookies[name] = val;
            return cookies;
        }, {});
}

function subscriptionEditMode(/*string*/displayName, /*string*/editType, /*string*/recurrence) {
    jMPT('#editing-subscription-alert').remove();
    jMPT('body').addClass('editing-subscription');
    jMPT('#main').addClass('editing-subscription');
    jMPT('.mpt-stop-editing-btn').off();
    jMPT('.mpt-confirm-stop-subedit').off();
    jMPT('.page-top').hide();

    let buttonText = 'Stop Editing';

    let messageText = null;
    if(displayName)
        messageText = 'Currently editing ' + displayName + '\'s subscription.';
    else messageText = 'Currently editing your active subscription.';

    let handler = null;

    let finalizeStopEdit = function(){
        jMPT('#editing-subscription-alert').remove();
        jMPT('body').removeClass('editing-subscription');
        jMPT('#main').removeClass('editing-subscription');
        jMPT('.page-top').show();
        let stopReq = new StopEnforcedSubEdit();
        stopReq.send().then((res) => {
            mptapi.cartDropdown.getCart(false, res);
        });
    };

    let removeSubEditMessageHandler = function(){
        if(mptapi.cart.deliveries && mptapi.cart.deliveries.length > 0)
        {
            let removedProducts = mptapi.cart.deliveries.reduce((a, b) => { return a.products.concat(b.products);}).filter(p => p.recurrence !== null && p.recurrenceOptions.filter(ro => ro.recurrence === "null" || ro.recurrence === null).length === 0);
            if(removedProducts.length > 0) {
                MPTUI.generateModal('#stopEnforcedSubEditModal', {content: {width: "85%"}}, {content: {width: "100%"}});
                setTimeout(function(){
                    jMPT('.mpt-confirm-stop-subedit').on('click', function () {
                        finalizeStopEdit();
                    });
                }, 250);
            } else finalizeStopEdit();
        }
        else finalizeStopEdit();
    };



    recurrence = recurrence || 'weekly';


    switch (editType) {
        case 'inferred-shop': //logged in with an existing active subscription and clicked a recurring option while on the shop page
            buttonText = 'Place One-time Order';
            if(displayName)
                messageText = 'This order will edit the existing subscription for ' + displayName;
            else messageText = 'This order will edit your existing subscription.';

            handler = function () {
                removeSubEditMessageHandler();
                if(jMPT('#recurrenceOptions option[value="null"]').length > 0)
                    jMPT('#recurrenceOptions').val("null").change();
            };
            break;
        case 'explicit-shop': //logged into account and explicitly clicked "Edit Subscription" and is currently on the shop page
            handler = function () {
                removeSubEditMessageHandler();
                if(jMPT('#recurrenceOptions option[value="null"]').length > 0)
                    jMPT('#recurrenceOptions').val("null").change();

                jMPT('#recurrenceOptions').removeClass('editing-sub-hide').closest('.form-group').removeClass('editing-sub-hide');

                mptapi.router.data.editingSubscription = false;
            };

            jMPT('#recurrenceOptions').addClass('editing-sub-hide').closest('.form-group').addClass('editing-sub-hide');
            if(jMPT('#recurrenceOptions option[value="' + recurrence + '"]').length > 0)
                jMPT('#recurrenceOptions').val(recurrence).change();

            break;
        case 'explicit-deliveries': //logged into account and explicitly clicked "Edit Subscription" and is currently on the deliveries page
            handler = function () {
                removeSubEditMessageHandler();
                mptapi.router.data.editingSubscription = false;
                mptapi.router.redirect('shop', '#deliveries', {editingSubscription: false});
            };
            break;
        case 'checkout':
            buttonText = null;
            if(displayName)
                messageText = 'This order will edit the existing subscription for ' + displayName;
            else messageText = 'This order will edit your existing subscription.';
            handler = null;

            break;
        default: //packages or custom page - will always be explicit
            handler = function () {
                removeSubEditMessageHandler();
                mptapi.router.data.editingSubscription = false;
            };
            break;
    }

    let editingSubAlert = jMPT('<div>', {
        id: 'editing-subscription-alert',
        class: 'alert alert-info text-center',
        role: "alert",
        html: '<span class="mpt-editing-sub-alert-text"><i class="fa fa-repeat p-2"></i><strong>' + messageText + '.</strong></span>' + (buttonText ? ('<button type="button" class="btn btn-info pull-right mpt-stop-editing-btn">' + buttonText + '</button>') : ''),
        style: 'margin-bottom:0;padding-left:10px;'
    });

    editingSubAlert.appendTo('.header-main');

    if (buttonText && handler)
        setTimeout(function () {
            jMPT('.mpt-stop-editing-btn').on('click', handler);
        }, 150);
}

function locationParamsToKVArray(location)
{
    if(!location)
        location = window.location;

    if(location) {
        let searchString = location.search.substr(1);
        if (searchString.length > 0) {
            let paramArray = searchString.split('&');

            let currArr = [];
            for (let i = 0; i < paramArray.length; i++) {
                try {
                    let currParam = paramArray[i].split('=');
                    currArr.push({Key: decodeURIComponent(currParam[0]), Value: decodeURIComponent(currParam[1])});
                } catch (e) {
                    let err = {location, e};
                    console.error(err);
                }
            }

            return currArr;
        }
        else return null;
    }else return null;
}


function handleExitSubEditor(e) { e.returnValue = 'Are you sure you want to leave the subscription editor? Your changes may not be saved.'; }

function paginateArray(array, pageSize){
    let pages = [];
    let length = array.length;

    if (!!(array && pageSize)) {
        if (array.constructor !== Array) {
            throw new TypeError("Invalid object passed into paginate function. Need array, passed " + typeof array);
        }
        if (array.length === 0) {
            return "";
        }
        let currentPageNum = 0;
        let currentPage = [];
        for (let i = 0; i < array.length; i++) {
            currentPage.push(array[i]);
            if (currentPageNum + 1 === pageSize || length === 1) {

                pages.push(currentPage);
                currentPage = [];
                currentPageNum = 0;
                length--;
            } else {
                currentPageNum++;
                length--;
            }
        }
        return pages;
    }
    return array;
}

function extendPrototype(prototype, handlers, safe = true){
	for(let key in handlers){
		if(!safe || (safe && !prototype[key])){
			prototype[key] = handlers[key];
			/*Object.defineProperty(prototype, key, {
			    value: handlers[key],
                enumerable: false,
                writable: false,
            });*/
		}
	}
}

/*(function(){
	let originalLog = console.log;
	console.log = function(){
		try{
			if(!!mptapi && !!mptapi.options.debugConsole){
				originalLog.apply(this, arguments);
			}
		}catch (e) {
			originalLog.apply(this, arguments);
		}
	};

	let originalError = console.error;
})();*/

/*Object.defineProperty(Object.prototype, "nullAccessor", {
    value: function(key){

    },
    enumerable: false,
    writable: false,
    configurable: false
});*/

/**
 * String Prototypes
 */
extendPrototype(String.prototype, {
    decHTML() {
        return this.valueOf().replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    },
    format() {
        let a = this;
        for (let k in arguments) {
            a = a.replace(new RegExp("\\{" + k + "\\}", 'g'), arguments[k]);
        }
        return a;
    },
    eval(func) {
        if (typeof func === "undefined")
            throw new TypeError("Function is not set.");
        return func(this.valueOf());
    },
    stripSlashes() {
        return this.replace(/\\(.)/mg, "$1");
    },
    capitalize() {
        return this.toLowerCase().split('').map((x, i, a) => {
            if (i === 0 || (i - 1 != -1 && /\s/.test(a[i - 1]))) a[i] = a[i].toUpperCase();
            return a[i];
        }).join('');
    },
    padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length >= targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    }
});

/**
 * Date Prototypes
 */
extendPrototype(Date.prototype, {
    toISOString() {
        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        return this.getUTCFullYear() +
            '-' + pad(this.getUTCMonth() + 1) +
            '-' + pad(this.getUTCDate()) +
            'T' + pad(this.getUTCHours()) +
            ':' + pad(this.getUTCMinutes()) +
            ':' + pad(this.getUTCSeconds()) +
            '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
            'Z';
    },
    addHours(h) {
        this.setTime(this.getTime() + (h * 60 * 60 * 1000));
        return this;
    },
    toShortDateString() {
        return this.toLocaleDateString('en-US', { weekday: 'short' }) + ' ' + (this.getMonth() + 1).toString() + '/' + this.getDate().toString();
    }
});

extendPrototype(Array.prototype, {
	/**
	 * 2-in-1 function to get sum of an array.
	 * If summing a key from an array of objects, provide a callback function.
	 * No parameters needed if summing array of numbers.
	 * @param callbackFunc
	 * @returns {*}
	 */
	sum(callbackFunc){
		if(callbackFunc){
			if(this != null && this.length > 0) {
				return Array
					.from(this, callbackFunc)
					.reduce((agg, val) => agg + val);
			}else{
				return 0;
			}
		}else{
			let sum = 0;
			for(let i = 0; i < this.length; i++){
				sum += ~~this[i];
			}
			return sum;
		}
	},
	/**
	 * Checks the general equivalency of two arrays
	 * @param arr
	 * @returns {boolean}
	 */
	equals(arr){
		return JSON.stringify(this) === JSON.stringify(arr);
	},
	/**
	 * Joins two arrays and removes duplicates
	 * @param arr Array
	 * @returns Array
	 */
	union(arr) {
		let _this = this;
		return this.concat(arr.filter(x => _this.indexOf(x) < 0));
	},
	/**
	 * Joins two arrays, removing values not seen in the other array
	 * @param arr
	 */
	intersect(arr) {
		return this.filter(x => arr.indexOf(x) >= 0);
	},
	/**
	 * C# like query to get first or return the default value (default is null)
	 * @param defaultVal
	 * @returns {*}
	 */
	firstOrDefault(defaultVal = null){
		return this.length > 0 ? this[0] : defaultVal;
	},
    first(){
	    return this[0];
    },
    substringIndexOf(value){
	    let index = -1;
	    for(let i = 0; i < this.length; i++){
	        if(this[i].includes(value)){
	            index = i;
            }
	    }
	    return index;
    },
    selectMany(callBackMap){
	    return this.map(callBackMap).reduce(function(a, b) {return a.concat(b); });
    }
});

/**
 * Forward port jQuery.live()
 * Wrapper for newer jQuery.on()
 * Uses optimized selector context
 * Only add if live() not already existing.
 */
if (typeof jMPT.fn.live == 'undefined' || !(jMPT.isFunction(jMPT.fn.live))) {
    jMPT.fn.extend({
        live: function (event, callback) {
            if (this.selector) {
                jMPT(document).on(event, this.selector, callback);
            }
        }
    });
}

/**
 * Joins array of arrays
 * @param arrs
 * @returns {*}
 */
window.intersectAll = function (arrs) {
    return arrs.reduce((acc, val) => acc.intersect(val));
};

/**
 * Safely checks if a string is a parsable JSON string
 * @param str
 * @returns {boolean}
 * @constructor
 */
function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

/*
Object.prototype.hasMultiple = function(arr, all = true){
    let validMap = {};
    if(arr.constructor === String){
        validMap[arr] = this.hasOwnProperty(arr);
    }
    else if(arr.constructor === Object){
        let keys = Object.keys(arr);
        let thisKeys = Object.keys(this);
        for(let i = 0; i < keys.length; i++){
            validMap[keys[i]] = thisKeys.includes(keys[i])
        }
    }
    else if(arr.constructor === Array){
        let thisKeys = Object.keys(this);

        for(let i = 0; i < arr.length; i++){
            validMap[arr[i]] = thisKeys.includes(arr[i]);
        }
    }

    if(all){
        return !(Object.values(validMap).includes(false));
    }else{
        return (Object.values(validMap).includes(true))
    }
};*/

Object.defineProperty(Object.prototype, "hasAllProps", {
    value: function (arr) {
        for (var i = 0; i < arr.length; i++) {
            if (!this.hasOwnProperty(arr[i])) {
                return false;
            }
        }
        return true;
    },
    enumerable: false
});

Object.defineProperty(Object.prototype, "accessOrDefault", {
    value: function(key, def = null){
        if(!this[key]) return def;
        else return this[key];
    },
    enumerable: false,
    writable: false,
    configurable: false
});

/*Object.defineProperty(Object.prototype, "propertyHasValue", {
    value: function (prop) {
        return (typeof this !== 'undefined' && this !== null && this.hasOwnProperty(prop) && this.prop !== null);
    },
    enumerable: false
});*/

let validations = {
    alpha: new RegExp(/[a-zA-Z]+/),
    numeric: new RegExp(/[\d]+/),
    onlyNumbers: new RegExp(/^\d+$/),
    hasSpecial: new RegExp(/[~`!#$%^&*+=\[\]\\';/{}|":<>?]/),
    email: new RegExp(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,7})$/),
    zipcode: new RegExp(/^((\d{5}-\d{4})|(\d{5})|([a-zA-Z]\d[a-zA-Z]\s?\d[a-zA-Z]\d))$/),
    ccexp: new RegExp(/^(0[1-9]{1}|1[0-2]{1})\d{2}$/)
};

jMPT.fn.extend({
    inViewPort(){
        return jMPT(this).filter(function() {
            let $this = jMPT(this);
            let elementTop = $this.offset().top;
            let elementBottom = elementTop + $this.height();
            let viewportTop = jMPT(document).scrollTop();
            let viewportBottom = viewportTop + jMPT(window).height();

            return (elementBottom < viewportBottom && elementBottom > viewportTop) || (elementTop < viewportBottom && elementTop > viewportTop);
        });
    },
    belowViewPort(){
        return jMPT(this).filter(function() {
            let $this = jMPT(this);
            let elementTop = $this.offset().top;
            let viewportTop = jMPT(document).scrollTop();
            let viewportBottom = viewportTop + jMPT(window).height();

            return elementTop > viewportBottom;
        });
    },
    aboveViewPort(){
        return jMPT(this).filter(function() {
            let $this = jMPT(this);
            let elementTop = $this.offset().top;
            let elementBottom = elementTop + $this.height();
            let viewportTop = jMPT(document).scrollTop();

            return elementBottom < viewportTop;
        });
    },
    firstBelowViewPort(){
        let sorted = jMPT(this).belowViewPort().toArray().map(elemBelow => {
            let $elemBelow = jMPT(elemBelow);

            let x = {
                $elem: $elemBelow,
                top: $elemBelow.offset().top
            };

            return x;
        }).sort((a, b) => { return a.top - b.top; });

        if(sorted.length > 0)
            return sorted[0].$elem;
        else return [];
    },
    firstAboveViewPort(){
        let sorted = jMPT(this).aboveViewPort().toArray().map(elemAbove => {
            let $elemAbove = jMPT(elemAbove);

            let x = {
                $elem: $elemAbove,
                top: $elemAbove.offset().top
            };

            return x;
        }).sort((a, b) => { return b.top - a.top; });

        if(sorted.length > 0)
            return sorted[0].$elem;
        else return [];
    },
    showPage(duration) {

        try { mptapi.track('page-view', null); } catch(errMessage){ console.error(errMessage); }

        if (duration) {
            this.fadeIn(duration, function () {
                this.addClass("visible");
            });
        } else {
            let page = this;
            this.fadeIn({
                complete: function () {
                    page.addClass("visible");
                }
            });
        }
        jMPT('.mpt-page-loader').remove();
    },
    hidePage(duration) {
        if (duration) {
            this.fadeOut(duration, function () {
                this.removeClass("visible");
            });
        } else {
            let page = this;
            this.fadeOut({
                complete: function () {
                    page.removeClass("visible");
                }
            });
        }
        jMPT('.mpt-content').append('<i>', {
            class: "fa fa-spin fa-spinner fa-2x mpt-page-loader",
            css: {positon: "fixed", top: "45%", left: "50%"}
        });
    },
    setDisableAll(disable = true) {

        let toggleFunction = null;

        if(disable){
            toggleFunction = function(thisElem){
                thisElem.addClass('mpt-disable').find('*').addClass('mpt-disable');
                thisElem.find('button').attr('disabled', true);
            };
        }
        else{
            toggleFunction = function(thisElem){
                thisElem.removeClass('mpt-disable').find('*').removeClass('mpt-disable');
                thisElem.find('button').removeAttr('disabled');
            };
        }

        return jMPT(this).each((i, e) => {
            let $this = jMPT(this);
            toggleFunction($this);
        });
    },
    switchToggleClass(first, second, callback) {
        if (jMPT(this).hasClass(first)) {
            jMPT(this).removeClass(first);
            jMPT(this).addClass(second);
        } else {
            jMPT(this).removeClass(second);
            jMPT(this).addClass(first);
        }
        if (callback) {
            callback(this);
        }
        return this;
    },
    generateError(text, reset = true, container = '.mpt-content', prepend = false, insertAfter = false) {
        return jMPT(this).each((i, e) => {
            if (reset) {
                jMPT(this).resetError();
            }

            var id = jMPT(this).attr("id");
            if (typeof jMPT(this).data(text) !== "undefined") {
                text = jMPT(this).data(text);
            }
            var error = jMPT('<span>', {'class': 'd-block text-danger error-' + id, text: text});
            let appendElement = jMPT(this).parent();
            if (container) {
                if (typeof container === "function") {
                    appendElement = jMPT(container());
                } else {
                    appendElement = jMPT(container);
                }
            }
            jMPT(this).css('border-color', '#f7a8a8');

            if (jMPT(this).prop("type") === 'checkbox') {
                jMPT(this).css('outline-color', '#f7a8a8');
                jMPT(this).css('outline-style', 'solid');
                jMPT(this).css('outline-width', '3px');
            }

            if (insertAfter) {
                error.insertAfter(appendElement);
            } else if (prepend) {
                appendElement.prepend(error);
            } else {
                appendElement.append(error);
            }

        });
    },
    resetError() {
        return jMPT(this).each((i, e) => {
            var id = jMPT(this).attr("id");
            jMPT(".error-" + id).remove();
            jMPT(this).css('border-color', '');
        });
    },
    /**
     * Validation Functions
     */
    waitButton(text, classOverride) {
        return jMPT(this).each((i, e) => {
            var elem = jMPT(this);

            elem.data('original-text', elem.text());

            elem.resetError()
                .removeClass('mpt-btn-primary')
                .removeClass('mpt-btn-success')
                .removeClass('mpt-btn-danger')
                .addClass('mpt-btn-info')
                .attr('disabled', true).text(text || 'Please wait...');



            if(classOverride)
                elem.addClass(classOverride);
            else elem.addClass('mpt-btn-info');

            elem.addClass('mpt-wait-button');

            elem.find('i').remove();
            elem.append(jMPT('<i class="ml-2 fas fa-sync fa-spin"></i>'));
        });
    },
    doneButton(text, failed = false, message, classOverride) {
        return jMPT(this).each((i, e) => {
            var elem = jMPT(this);

            let buttonText = text || elem.data('original-text') || 'Done!';

            elem.removeClass('mpt-btn-primary')
                .removeClass('mpt-btn-success')
                .removeClass('mpt-btn-danger')
                .removeClass('mpt-btn-info')
                .removeClass('mpt-wait-button')
                .attr('disabled', false).text(buttonText);

            elem.find('i').remove();

            if(!classOverride) {
                if (failed) {
                    elem.addClass('mpt-btn-danger').append($('<i class="ml-2 fa fa-times-square"></i>'));
                }
                else {
                    elem.addClass('mpt-btn-success');
                }
            } else elem.addClass(classOverride);
        });
    },
    hasAlpha: function () {
        return validations.alpha.test(jMPT(this.val()));
    },
    onlyAlpha: function (allowSpaces = false) {
        return (allowSpaces) ? /^[a-zA-Z\s]+$/g.test(jMPT(this).val()) : /^[a-zA-Z]+$/g.test(jMPT(this).val());
    },
    hasNumeric: function () {
        return validations.numeric.test(jMPT(this).val());
    },
    onlyNumeric: function () {
        return validations.onlyNumbers.test(jMPT(this).val());
    },
    hasSpecial: function () {
        return validations.hasSpecial.test(jMPT(this).val());
    },
    isEmail: function () {
        return validations.email.test(jMPT(this).val());
    },
    isZipcode: function () {
        return validations.zipcode.test(jMPT(this).val());
    },
    hasSelections: function () {
        if (jMPT(this).data().hasOwnProperty("tagsinput")) {
            return jMPT(this).tagsinput("items").length !== 0;
        } else {
            return jMPT(this).val().length !== 0;
        }
    },
    blank() {
        let valid = true;
        jMPT(this).each((i, e) => {
            let space = /^[\s]+$/;
            let val = jMPT(this).val();
            valid = (val === "" || val === false || val === null || space.test(val));
        });
        return valid;
    },
    checked() {
        return jMPT(this).is(':checked');
    },
    customCollapse() {
        return jMPT(this).each((i, e) => {
            let target = jMPT(jMPT(this).data("target"));
            let icon = jMPT(this).find("i[class^=fa-chevron]");
            if (target.data("collapsed")) {
                target.slideDown();
                target.data("collapsed", false);
            } else {
                target.slideUp();
                target.data("collapsed", true);
            }
        });
    },
    addTimedClass(addClass, time = 1000) {
        return jMPT(this).each(function () {
            let el = jMPT(this);
            jMPT(this).addClass(addClass);
            setTimeout(function () {
                el.removeClass(addClass);
            }, time);
        });
    },
    ajaxButton(ajaxRequest, options = {}) {
        return jMPT(this).each(function() {
            let _$ = jMPT(this);
            Object.assign(options, {
                loading: {
                    text: "Loading...",
                    class: "btn-success"
                },
                complete: {
                    text: "Success <i class='fa fa-check'></i>",
                    class: "btn-success"
                },
                error:{
                    text: "Error <i>",
                    class: "btn-danger"
                },
                animate: true,
                once: true,
                html: true,
                returnButton: false
            });

            if (_$.data("toggle") == "ajax-button") {
                let originalText = _$.text();
                let loadingText = _$.data("loading") || options.loading.text;
                let completeText = _$.data("complete") || options.complete.text;
                let errorText = _$.data("error") || options.error.text;

                if (options.animate) {
                    options.html = true;
                    loadingText = loadingText.replace(/([\.])/g, "<span>.</span>");
                }

                if (options.html) {
                    _$.html(loadingText);
                }

                ajaxRequest.then(function(){
                    if(options.returnButton){
                        setTimeout(function(){

                        }, options.returnButton);
                    }
                }).done(function(data) {
                    if (options.html) {
                        _$.html(completeText);
                    }

                    _$[0].classList = _$[0].classList.toString().replace(/(btn-\w+)/g, options.complete.class)

                    if(options.once){
                        _$.prop("disabled", true).addClass("disabled");
                    }
                    console.log(data);
                }).catch(function(error){
                    if (options.html) {
                        _$.html(errorText);

                    }
                    _$[0].classList = _$[0].classList.toString().replace(/(btn-\w+)/g, options.error.class)
                });
            }
        });
    }
});

let timers = {};

function Timer(tickFunction, actionTime) {
    this.startTime = new Date().getTime();
    this.time = actionTime != null ? (this.startTime - new Date(actionTime).getTime())/1000 : 0;

    var timefunc = function (timer) {
        return function () {
            timer.time++;
            if (typeof tickFunction == "function") tickFunction.call(timer);
        }
    };
    this.interval = setInterval(timefunc(this), 1000);

    this.start = function () {
        this.interval = setInterval(timefunc(this), 1000);
    };
    this.stop = function () {
        clearTimeout(this.interval);
        console.log("Timer stopped");
    }
}

function pluralize(qty, text) {
    if (qty === 1) {
        return text;
    } else {
        return text + "s";
    }
}

function encryptText(str, key) {
    let encrypted_str = [], encrypted_key = [], result = [];
    //Pad Card
    str = str.padStart(key.length, "0");
    let plain_chars = str.split('');
    let key_chars = key.split('');
    for (let i = 0; i < plain_chars.length; i++) {
        encrypted_str.push((+plain_chars[i].charCodeAt(0)).toString(2).padStart(7, "0"));
        encrypted_key.push((+key_chars[i].charCodeAt(0)).toString(2).padStart(7, "0"));
    }

    for (let i = 0; i < encrypted_str.length; i++) {
        let string = "";
        for (let j = 0; j < 7; j++) {
            string += (+encrypted_str[i][j]) ^ (+encrypted_key[i][j]);
        }
        result.push(string);
    }

    return result.join(" ");
}

jMPT.extend({
    toast: function (icon, type, title, body, persist = 5000, actionTime = new Date().getTime()) {
        var id = guid();
        var timeout = 5000;
        var target = "#" + id + "Toast";
        let t = Handlebars.compile(jMPT('#toastTemplate').html());
        let toast = t({ id, icon, title, body, type });
        jMPT('#toast-container').append(toast);
        jMPT(target).toast({
            delay: timeout,
            animation: true,
            autohide: persist > 0
        }).toast('show');
        function timerTick() {
            var unit = "seconds";
            var num = 0;
            var text = "just now";
            if (this.time >= 31104000) {
                num = Math.round(this.time / 31104000);
                unit = pluralize(num, "year");
            } else if (this.time >= 2592000) {
                num = Math.round(this.time / 2592000);
                unit = pluralize(num, "month");
            } else if (this.time >= 86400) {
                num = Math.round(this.time / 86400);
                unit = pluralize(num, "day");
            } else if (this.time >= 3600) {
                num = Math.round(this.time / 3600);
                unit = pluralize(num, "hour");
            } else if (this.time >= 60) {
                num = Math.round(this.time / 60)
                unit = pluralize(num, "minute");
            } else if (this.time > 1) {
                num = Math.round(this.time);
                unit = pluralize(num, "second");
            }

            if (this.time > 1) {
                text = num + " " + unit + " ago";
            }
            jMPT(target + " .time-text").text(text)
        }
        timers[id] = new Timer(timerTick, actionTime);
        jMPT(target).on({
            "hidden.bs.toast": function () {
                timers[id].stop();
                delete timers[id];
            },
            "shown.bs.toast": function () {
                timers[id] = new Timer(timerTick, actionTime);
            }
        });
        return id;
    },
    /**
     * Creates a notification that pops on the screen for a specified duration
     * @param title
     * @param message
     * @param type
     * @param icon
     * @param duration
     * @returns {*}
     */
    createNotification: function (title, message, type, icon, duration) {
        return jQuery.notify({
            icon: icon || "far fa-exclamation-circle",
            title: title || mptsettings.shopName || "Success!",
            message: message || "Action was successful."
        }, {
            element: "body",
            type: type || "success",
            placement: {
                from: "bottom",
                align: "center"
            },
            icon_type: "class",
            delay: duration || 4000
        });
    },
    /**
     * Provide an object as the first argument or fill in the arguments normally
     * {
     *     title : "Success!",
     *     message : "Action was successful.",
     *     element : ".mpt-content",
     *     type : "success,
     *     icon: "fa fa-check
     * }
     * @param {string|object} context
     *
     * @param {string} message
     * @param {string} element
     * @param {string} type
     * @param {string} icon
     * @param {number} timeout
     * @param {string} id
     * @returns {createAlert}
     */
    createAlert: function (context, message, element, type, icon, timeout, id) {
        let useObject = typeof context !== "string";
        let options = {
            id: useObject ? context.id : id,
            title: useObject ? context.title : context,
            message: useObject ? context.message : message,
            element: useObject ? context.element : element,
            type: useObject ? context.type : type,
            icon: useObject ? context.icon : icon
        };

        let title = options.title;
        let style = null;

        message = options.message || "Action was successful.";
        element = options.element || ".mpt-content";
        type = options.type || "success";
        icon = options.icon || "fa fa-check";
        id = options.id || "mpt-alert-" + (jMPT('div[role="alert"].mpt-alert').length + 1);

        if (title == null) {

            if (options.type === "danger mpt-danger")
                title = "";
            else if (options.type === "warning mpt-warning")
                title = "";
            else
                title = "";
        }

        //desktop floating styling
        /*if(element !== '.mpt-content')
        {
            let isMobile = false;
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                    navigator.userAgent
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([-\s_agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([\s-\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([\s\/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([-\sov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([\-\s])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
                    navigator.userAgent.substr(0, 4)
                ) ||
                jMPT(window).width() <= 600
            ) {
                isMobile = true;
            }

            if(!isMobile) {
                height = jMPT(element)[0].getBoundingClientRect().height;

                style = 'position:absolute;top:101%;left:0;padding-top:3px;height:' + Math.floor(jMPT(element)[0].getBoundingClientRect().height) + 'px;';
            }
        }*/

        let alert = jMPT('<div>', {
            id,
            class: `alert alert-${type} mpt-alert`,
            role: "alert",
            html: `<i class="${icon} p-2"></i><strong>${title}</strong> ${message}`,
            style: style
        });

        jMPT(element).before(alert);

        if (timeout) {
            setTimeout(function () {
                jMPT(element).find('.alert').fadeOut(500, function () {
                    jMPT(element).find('.alert').remove();
                });
            }, timeout);
        }

        return this;
    },
    clearAlerts: function () {
        jMPT('div[role="alert"].mpt-alert').remove();
    },
    validateFields: function (options, parent) {
        let invalid = [];
        return new Promise((resolve, reject) => {
            let valid = true;
            let example = {
                "#input": {
                    "blank": {
                        required: false,
                        message: "Input can not be blank"
                    }
                }
            };
            if (typeof options === "object") {
                for (let key in options) {
                    let element = null;
                    if (key.split("!").length > 1) {
                        //use the data property to select
                        let dataProperty = key.split("!")[0];
                        let value = key.split("!")[1];
                        element = jMPT('[data-' + dataProperty + '=' + value + "]");
                    } else {
                        element = jMPT(key);
                    }
                    element.resetError();
                    for (let validation in options[key]) {
                        if (jMPT.fn.hasOwnProperty(validation)) {
                            let validField = element[validation]();
                            if (validField !== options[key][validation].required) {
                                element.generateError(options[key][validation].message, true, options[key][validation].errorElem ? options[key][validation].errorElem : null, false);
                                invalid.push(Object.assign({field: key, val: jMPT(key).val()}, options[key]));
                                valid = false;
                            }
                        } else {
                            console.error("Cannot find validator: " + validation);
                        }
                    }
                }
            }
            if (parent) {
                jMPT(parent).data("valid", valid);
            }
            if (valid) {
                resolve();
            }else{
                reject();
            }
        });
    }
});

function regenerateSelectionModal(context, productId, callbacks) {
    if (mptapi.router.action === "#product") {
        mptapi.router.render();
        return;
    }
    let modalTemplate = Handlebars.compile(jMPT('#productSelectionsTemplate').html().decHTML());

    let delivery = context.cart.deliveries.find(x => x.id === mptapi.router.data.deliveryId);
    let products = delivery.products.filter(x => x.productId === productId);
    let variations = products.length > 0 ? products[0].variations : mptapi.router.data.shopPage.products.find(x => x.id === productId).variations;
    let obj = {
        id: "variations",
        variations: variations,
        productId: productId,
        deliveryId: delivery.id
    };
    products.push(obj);

    if (products != null && products.length > 0) {
        let html = modalTemplate(products);
        jMPT("#productSelectionsSection" + productId).html(html);
        if (typeof callbacks !== "undefined" && callbacks.constructor === Array) {
            for (let i = 0; i < callbacks.length; i++) {
                let callback = callbacks[i];
                if (typeof callback === "function") {
                    callback();
                }
            }
        }
    } else {
        console.error("Product could not be found.");
    }
    return products;
}

function sortProductImage(images) {
    return images.sort((aImage, bImage) => {
        let aImageTimestamp = null;
        let bImageTimestamp = null;

        if (aImage[0]?.url) {
            const aSearchParams = new URLSearchParams(aImage[0]?.url);
            if (aSearchParams.has('se')) {
                aImageTimestamp = decodeURIComponent(aSearchParams.get('se'));
            }
        }

        if (bImage[0]?.url) {
            const bSearchParams = new URLSearchParams(bImage[0]?.url);
            if (bSearchParams.has('se')) {
                bImageTimestamp = decodeURIComponent(bSearchParams.get('se'));
            }
        }

        if (bImageTimestamp && aImageTimestamp) {
            try {
                const aDatetime = new Date(aImageTimestamp).getTime();
                const bDatetime = new Date(bImageTimestamp).getTime();

                if (aDatetime > bDatetime) {
                    return 1;
                } else if (bDatetime > aDatetime) {
                    return -1;
                }
            } catch {
                return 0;
            }
        }

        return 0;
    });
}

(function () {
    /*let cssOrig = jMPT.fn.css;
    jMPT.fn.css = function() {
        var ev = new jMPT.Event('style', {...arguments});
        cssOrig.apply(this, arguments);
        jMPT(this).trigger(ev);
        return this;
    };*/

    let toggleOrig = jMPT.fn.slideToggle;
    jMPT.fn.slideToggle = function () {
        let ev = new jMPT.Event('slideToggle');
        toggleOrig.apply(this, arguments);
        jMPT(this).trigger(ev);
        return this;
    };

    let upOrig = jMPT.fn.slideUp;
    jMPT.fn.slideUp = function () {
        let ev = new jMPT.Event('slideUp', arguments);
        upOrig.apply(this, arguments);
        jMPT(this).trigger(ev);
        return this;
    };

    let downOrig = jMPT.fn.slideDown;
    jMPT.fn.slideDown = function () {
        let ev = new jMPT.Event('slideDown');
        downOrig.apply(this, arguments);
        jMPT(this).trigger(ev);
        return this;
    };

    /*let valOrig = jMPT.fn.val;
    jMPT.fn.val = function () {

    }*/

    /*let scrollTopOrig = jMPT.fn.scrollTop;
    jMPT.fn.scrollTop = function () {
        var ev = new jMPT.Event('scrollTop');
        scrollTopOrig.apply(this, arguments);
        jMPT(this).trigger(ev);
        return this;
    }*/
})();

/**
 * Handlebars Helpers
 */

Handlebars.registerHelpers = function (helpers) {
    for (let key in helpers) {
        Handlebars.registerHelper(key, helpers[key]);
    }
};

Handlebars.registerPartials = function (partials) {
    for (let key in partials) {
        Handlebars.registerPartial(key, partials[key]);
    }
};

Handlebars.registerHelpers({
    //#region Math Helpers
    not: (context) => !context,
    stringify: (context) => JSON.stringify(context),
    equals: (a, b) => a === b,
    lte: (a, b) => a <= b,
    gte: (a, b) => a >= b,
    lt: (a, b) => a < b,
    gt: (a, b) => a > b,
    and: (a, b) => a && b,
    or: (a, b) => a || b,
    isnull: (context) => context == null,
    isempty: (context) => {
        if(context == null){
            return true;
        }
        return (!context.hasOwnProperty("length")) ? true : context.length === 0;
    },
    isfirst: (a, b) => Array.isArray(b) && b.length > 0 && b[0] === a,
    add: (a, b) => a + b,
    divide: (a, b) => a / b,
    //endregion
    /*----------------------------------------------------------------------------------------------------------------*/
    //region Date Helpers

    /**
     * Converts int to day of week
     * @param context
     * @returns {string}
     */
    dayOfWeek(context) {
        let date = new Date(context);
        let map = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        return map[date.getDay()];
    },
    dayOfWeekInt(context) {
        try {
            let date = new Date(context);
            return date.getDay().toString();
        }catch{
            return -1;
        }
    },
	/**
	 * Formats a string with date replacements
	 * Available replacements:
	 *    "hh:mm aa" : AM PM time,
	 *    "mmm" : Short Month (Jan),
	 *    "mm" : Month Num with pad start,
	 *    "dd" : Day Num with pad start,
	 *    "yyyy" : Full year,
	 *    "yy" : Short year
	 *
	 * @param formatString
	 * @param date
	 * @returns {*}
	 */
	formatDate() {
		let formatString = arguments[0];
		let date = arguments[1];
		if(date == null){
		    return "";
        }

        let monthMap = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        try {
            date = new Date(date);
            let formatMap = {
                "hh:mm aa": formatAMPM(date),
                MM: (date.getMonth() + 1).toString().padStart(2, "0"),
                mmm: monthMap[date.getMonth()].substr(0, 3),
                mm: (date.getMonth() + 1).toString().padStart(2, "0"),
                dd: date.getDate().toString().padStart(2, "0"),
                yyyy: date.getFullYear(),
                yy: date.getFullYear().toString().substr(2),
                short: (date.getMonth() + 1).toString().padStart(2, "0") + "/" + date.getDate().toString().padStart(2, "0") + "/" + date.getFullYear()
            };
            for (let k in formatMap) {
                formatString = formatString.replace(new RegExp(k, 'g'), formatMap[k]);
            }
            return formatString;
        } catch (ex) {
            console.error(ex);
        }
    },
    //endregion
    /*----------------------------------------------------------------------------------------------------------------*/
    //region Shop Helpers
    selected(context) {
        if (!!context) {
            return " selected=\"selected\"";
        }
        return "";
    },

    //Generates options for dropdown
    //Selected parameter allows for preselected value
    incrementOptions(context, step = 1, selected = 0) {
        let num = parseInt(context),
            html = "";
        if (typeof num != "number") {
            num = 15;
        } else {
            num++;
        }
        if (typeof selected !== "number") {
            selected = 0;
        }
        if(step === 1){
            for (let i = 0; i < num; i++) {
                html += "<option value=\"" + i + "\"" + (typeof selected !== "object" && i === selected ? " selected" : "") + ">" + i + "</option>";
            }
        }else{
            for (let i = 0; i < num; i += step) {
                html += "<option value=\"" + i + "\"" + (typeof selected !== "object" && i === selected ? " selected" : "") + ">" + i + "</option>";
            }
        }

        return html;
    },

    //Parses number to float and fixes to 2 digit places
    formatMoney(money) {
        let hash = arguments[arguments.length-1].hash;
        let currency = hash.currency || "$";
        try {
            let formatted = parseFloat(money);
            return formatted.toFixed(2);
        } catch (err) {
            console.warn("[Handlebars] Tried to parse an invalid price.").toFixed(2);
            return money;
        }
    },

    //Shows the recurrence with icon if populated
    formatRecurrence(recurrence) {
        if (recurrence) {
            return "<span><i class='fa fa-repeat'></i>" + recurrence + "</span>";
        } else return "";
    },

    getCartItems(deliveryId, productId, variations) {
        let obj = {id: "variations", variations, productId, deliveryId};
        let delivery = mptapi.cart.deliveries.find(x => x.id === deliveryId);
        if (delivery != null) {
            let products = delivery.products.filter(x => x.productId === productId);
            products.push(obj);

            return products;
        }
        console.error("Data error");
        return [obj];
    },

    //shows the current product total for the cart across all deliveries, before taxes and fees
    getProductTotal(deliveries) {
        if(deliveries.length > 0) {
            return deliveries.map(d => d.products).reduce((a, b) => a.concat(b)).map(p => p.productTotal).reduce((a, b) => a + b);
        }
        else return 0;
    },

    //shows the subscribe-all status of the cart
    getSubscribedStatus(deliveries) {

        if(typeof(deliveries) !== 'undefined' && deliveries.length > 0 && deliveries.map(d => {return d.products;}).reduce((agg, thisProdList) => agg.concat(thisProdList)).length > 0) {
            return deliveries.map(d => d.products).reduce((a, b) => a.concat(b)).every(p => p.recurrence !== null) ? 'subscribed' : 'unsubscribed';
        }
        else return 'empty';

    },

    getActivePrice(context, recurrenceOptions) {
        if (recurrenceOptions != null) {
            let selectedRecurrence = recurrenceOptions.firstOrDefault();
            if (selectedRecurrence != null) {
                switch (selectedRecurrence.name) {
                    case "weekly":
                        return context.weeklyPrice;
                    case "null":
                        return context.price;
                }
            }
        }
    },
    getVisibleProductAttributes(context) {
        if(context && context.length > 0)
        {
            return context.filter(att => !att.visibility && att.type !== 'nutritionLabel');
        }
        else return [];
    },
    getCollapsedProductAttributes(context) {
        if(context && context.length > 0)
        {
            return context.filter(att => att.visibility === 'collapsed' || att.type === 'nutritionLabel');
        }
        else return [];
    },
    getMinPrice(context) {
        let options = [];
        if(context.price > 0) options.push(context.price);
        if(context.weeklyPrice > 0) options.push(context.weeklyPrice);
        if(context.biweeklyPrice > 0) options.push(context.biweeklyPrice);
        if(context.monthlyPrice > 0) options.push(context.monthlyPrice);

        let minPrice = Math.min(...options);
        console.log('after min calc: ');
        console.log(minPrice);

        try{
            minPrice = minPrice.toFixed(2);
            console.log('after to fixed');
            console.log(minPrice.toString());
            return minPrice.toString();
        } catch(err) {
            console.log('catch');
            console.log(minPrice.toString());
            return minPrice.toString();
        }
    },
    //endregion
    /*----------------------------------------------------------------------------------------------------------------*/
	//region Variation Helpers
    defaultOptions(options)
    {
        let defaultOpts = [];

        if(options)
        {
            defaultOpts = options.filter(o => o.default);
        }

        return defaultOpts;
    },
    standardOptions(options)
    {
        let standardOpts = [];

        if(options)
        {
            standardOpts = options.filter(o => !o.default);
        }

        return standardOpts;
    },
    //endregion
    /*----------------------------------------------------------------------------------------------------------------*/
    //region Account Setting Helpers
    settingValue(settings, settingId, currentOptionId){
        if(settings != null){
            let userSetting = settings.find(x => x.id === settingId);
            currentOptionId = currentOptionId || null;
            let option = {};
            if(userSetting != null){
                switch(userSetting.type) {
                    case "free-form":
                        option = userSetting.options.firstOrDefault();
                        if (option != null) {
                            return option.text;
                        }
                        break;
                    case "multiselect":
                        if (currentOptionId !== null && userSetting.options) {
                            option = userSetting.options.filter(x => x.id === currentOptionId).firstOrDefault();
                            return option !== null;
                        } else return false;
                        break;
                    case "drop-down":
                        if (currentOptionId !== null && userSetting.options) {
                            option = userSetting.options.filter(x => x.id === currentOptionId).firstOrDefault();
                            return option !== null;
                        } else return false;
                        break;
                }
            }
        }
        return null;
    },
    //endregion
    /*----------------------------------------------------------------------------------------------------------------*/
    //region Array Helpers
    //Checks if context value is null or blank
    //Returns value if not blank, returns body of helper if blank
    arrayOr(value, options) {
        if (!value) {
            return options.fn(this);
        } else {
            return value;
        }
    },

	//Gets length of array
	count: (context) => {
	    if(!context) return 0;
		return context.length;
	},

	obo: num => typeof num === "number" ? num + 1 : "",
    any(){
        if(arguments.length <= 1){
            return false;
        }
        let context = Array.from(arguments).slice(0, arguments.length - 1);
        return context.filter(x => !!x).length !== 0;
    },
    //Gets last item of collection
    lastItem(context, options) {
        let attr = options.hash;
        console.log(context, options);
        if (context.length > 0) {
            if (!attr.hasOwnProperty('key')) {
                return context[context.length - 1];
            } else {
                if (context[context.length - 1].hasOwnProperty(attr.key)) {
                    return context[context.length - 1][attr.key];
                }
                console.log(context[context.length - 1]);
                return context[context.length - 1];

            }
        }

        return "";
    },
    //Filters subtotals
    getSubtotals(context) {
        if (context.length > 0) {
            let filteredTotals = context.filter(lineItem => lineItem.name.includes("Total") || lineItem.name.includes("Shipping"));
            if (filteredTotals.length > 0) {
                return filteredTotals;
            }
        }

        return "";
    },

    //endregion
    /*----------------------------------------------------------------------------------------------------------------*/
    //region String Helpers

    kebabCase(options) {
        let string = options.fn(this);
        if (options.hash.removeSpecial) {
            return string.replace(/\s+/g, '-').replace(/&amp;/g, '').replace(/-{2,}/g, '-').toLowerCase();
        }
        return string.replace(/\s+/g, '-').toLowerCase();
    },
    titleCase: (context) => {
        function titleCase(str) {
            return str.toLowerCase().split(' ').map(function (word) {
                return word.replace(word[0], word[0].toUpperCase());
            }).join(' ');
        }

        return titleCase(context);
    },
    capitalize(context) {
        return context.toLowerCase().split('').map((x, i, a) => {
            if (i === 0 || (i - 1 != -1 && /\s/.test(a[i - 1]))) a[i] = a[i].toUpperCase();
            return a[i];
        }).join('');
    },

    //Returns a string representation of the context
    toString: (context) => context.toString(),

    //Truncates the string to the desired length
    truncate(str, len) {
        if (str.length > len && str.length > 0) {
            var new_str = str + " ";
            new_str = str.substr(0, len);
            new_str = str.substr(0, new_str.lastIndexOf(" "));
            new_str = (new_str.length > 0) ? new_str : str.substr(0, len);

            return new Handlebars.SafeString(new_str + '...');
        }
        return str;
    },


    //Checks if a string is a substring of another string
    strIncludes(subject, string) {
        if (!!(subject && string)) {
            return subject.indexOf(string) >= 0;
        }
        throw new TypeError("Subject or search string is empty");
    },

    textOverride(label){
        let options = arguments[arguments.length - 1];
        let defaultLabel = options.fn(this);
        if(mptapi.companyInfo.hasOwnProperty("uiSettings") && mptapi.companyInfo.uiSettings.textOverrides != null){
            if(mptapi.companyInfo.uiSettings.textOverrides[label]){
                return mptapi.companyInfo.uiSettings.textOverrides[label];
            }else{
                return defaultLabel;
            }
        }else{
            return defaultLabel;
        }

    },
    //endregion
    /*----------------------------------------------------------------------------------------------------------------*/
    //region Misc. Helpers


    //Paginates a long array to the pageSize
    //Returns an array of arrays
    paginate() {
        let array = arguments[0];
        let pageSize = arguments[1];
        let options = arguments[arguments.length - 1];

        return options.fn(paginateArray(array, pageSize));

        /*if (!!(array && pageSize)) {
            if (array.constructor !== Array) {
                throw new TypeError("Invalid object passed into paginate function. Need array, passed " + typeof array);
            }
            if (array.length === 0) {
                return "";
            }
            let currentPageNum = 0;
            let currentPage = [];
            for (let i = 0; i < array.length; i++) {
                currentPage.push(array[i]);
                if (currentPageNum + 1 === pageSize || currentPageNum === array.length - 1) {

                    pages.push(currentPage);
                    currentPage = [];
                    currentPageNum = 0;
                } else {
                    currentPageNum++;
                }

            }
            return options.fn(pages);
        }*/
    },
    generateModal(context) {
        let options = arguments[arguments.length - 1];
        let hash = options.hash;


        Handlebars.registerPartial("closeButton", '<button type="button" class="ubtn mpt-btn mpt-btn-outline-secondary" onclick="MPTUI.closeModal()">Close</button>');

        let newContext = {
            id: hash.id,
            body: options.fn(context),
            //buttons: options.inverse(context),
            title: false
        };

        if(typeof hash.title !== "undefined"){
			let title = Handlebars.compile(hash.title || "Meal Prep Tech");
			newContext.title = title(context);
		}

		if(typeof hash.id !== "undefined"){
		    let id = Handlebars.compile(hash.id || guid());
		    newContext.id = id(context);
        }

		if(options.inverse.name === "i"){ // No "else" block defined. Just render close button.
		    let closeButton = Handlebars.compile("{{> closeButton}}");
		    newContext.buttons = closeButton(context);
        }else{
		    newContext.buttons = options.inverse(context);
        }

		let t = Handlebars.compile(jMPT('#mptModalTemplate').html());
		return t(newContext);
	},
    validateCheckoutClasses(context){
        let options = arguments[arguments.length - 1];
        let defaultClasses = options.fn(this);
        let disabledAtts = '';

        if(!context.cart.isValid) {
            options = 'mpt-disabled-submit mpt-btn-secondary ubtn';
            if(typeof context.messages !== 'undefined' && context.messages.length > 0) {
                try {
                    let firstMessage = context.messages.sort(function(a, b){ return a.type - b.type; })[0];
                    disabledAtts += '" data-toggle="popover" data-trigger="click" data-content="' + firstMessage.message;
                    return new Handlebars.SafeString(options + disabledAtts);
                }catch{ new Handlebars.SafeString(options + disabledAtts); }
            }
        }
        else return defaultClasses;
    },
	guid: () => guid(),
	log() {
		console.log(...arguments);
		console.log(arguments[arguments.length - 1].fn(this));
	},
    getMatchingSubs(context) {

	    let newContext = {};
	    let matchingSubs =  context.filter(x => x.cartMatch);

	    if(matchingSubs.length > 0)
        {
            newContext.primarySub = matchingSubs[0];
            newContext.altSubs = [];

            for(let i = 1; i < matchingSubs.length; i++)
            {
                newContext.altSubs.push(matchingSubs[i]);
            }
        }

        return newContext;
    },
    hasMatchingSubs: (context, uiSettings) => uiSettings.length > 0 && uiSettings.allowSubscriptionCartMatch && Array.isArray(context) && context.filter(x => x.cartMatch).length > 0,
    groupOptions(context, variationId, variationType) {

        let groupBy = function(xs, key) {
            return xs.reduce(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };

        if (context != null && Array.isArray(context)) {
            context = groupBy(context, 'category');
            for (let key in context) {
                context[key].map(function(o) {
                    o.variationId = variationId;
                    o.variationType = variationType;
                    return o;
                });
                if (context.hasOwnProperty(key)) {
                    if (key === 'undefined' || key == null) {
                        Object.defineProperty(context, ' ',
                            Object.getOwnPropertyDescriptor(context, key));
                        delete context[key];
                    }
                }
            }
        }

        return context;
    },
    extendObject: (context, options) => {
        let hash = options.hash;
        let key = hash.key;
        let value = hash.value;
        Object.defineProperty(context, key, {
            value,
            configurable: false,
            enumerable: false,
            writable: true
        });
        return context;
    },
    customDeliveryDisplay: (deliveryName, shippingLocationType) => {
        if (shippingLocationType === 'pickup' && deliveryName) {
            return `${deliveryName.replace('04:00 PM', '03:30PM')}`;
        } else {
            return `${deliveryName}`;
        }
    },
    getTipValue: (cartTotals) => {
        if (cartTotals && cartTotals.length) {
            const foundTip = cartTotals.find(type => type.name === 'Tip');
            if (foundTip) {
                return foundTip.amount;
            }
        }

        return '';
    }
	//endregion
});


Handlebars.registerPartial("nutritionLabel", jMPT('#nutritionLabelTemplate').html());
Handlebars.registerPartial("cartTotals", jMPT('#cartTotals').html());
Handlebars.registerPartial("contactForm", jMPT('#contactFormTemplate').html());
Handlebars.registerPartial("pageControls", jMPT('#pageControllerTemplate').html());

//-------------------------------------------------------------
function setFinixError(errorOn, errorMsg) {
   document.getElementById('finix-submit-button').disabled = false;
}

function onFinixSubmit() {
   document.getElementById('finix-submit-button').disabled = true;
   setFinixError(false);

   FINIX_API.form.submit(FINIX_API.finixEnv, FINIX_API.applicationId, function (err, res) {
      let payload = {};

      if (err) {
         setFinixError(true, err);
      } else {
         const tokenData = res.data || {};

         payload.ccToken = tokenData.id;
         payload.acctType = 'credit';
         payload.onCheckout = true;

         let req = new AddBillingProfile(payload);

         const customBox = document.querySelectorAll('.custombox-content');
         if (customBox && customBox.length > 0) {
            MPTUI && MPTUI.closeModal();
         }

         req.send().then(() => {
            jMPT.createNotification('Success!', 'Added billing profile', 'success', 'fa fa-plus', 3000);
            if (typeof callback === 'function') {
               callback();
            } else {
               mptapi.router.render(null);
            }
         });
      }
   });
}

const FINIX_STATES = {
   billing: 'Save Billing Info',
   checkout: 'Submit',
};

const FINIX_API = {
   state: '',
   form: null,
   finixEnv: 'live',
   applicationId: 'APeLbnkceyrnMKMku7NRKbu2',
   options: {
      // show address fields in the form (default is false)
      showAddress: true,
      //show labels in the form (default is true)
      showLabels: true,
      // set custom labels for each field
      labels: {
         // Supported Fields: "name", "number", "expiration_date", "security_code", "address_line1", "address_line2", "address_city", "address_state","address_region", "address_country", "address_postal_code"
         name: 'Cardholder Name',
      },
      // turn on or off placeholder text in the fields (default is true)
      showPlaceholders: false,
      // set custom placeholders for each field, you can specify them here
      placeholders: {
         // Supported Fields: "name", "number", "expiration_date", "security_code", "address_line1", "address_line2", "address_city","address_state", "address_region", "address_country", "address_postal_code"
         name: 'Cardholder Name',
      },
      // hide specific fields that you do not need
      hideFields: [
         // Supported Fields: "name", "security_code", "address_line1", "address_line2", "address_city", "address_state","address_region", "address_country", "address_postal_code", "address_country"
         // "name",
         // "address_line1",
         // "address_line2",
         // "address_city",
          "address_region",
         //"address_state",
         //'address_country',
         'address_country',
      ],
      // require any specific fields that are not required by default, you can specify them here
      requiredFields: [
         // Supported Fields: "name", "address_line1", "address_line2", "address_city", "address_state","address_region", "address_country", "address_postal_code"
         'name',
         'address_line1',
         'address_city',
//         "address_region",
         "address_state",
         'address_postal_code',
      ],
      // if you want to require a field, but not hide input error messages (default is false)
      hideErrorMessages: false,
      // set custom error messages for each field if you are showing error messages
      errorMessages: {
         // Supported Fields: "name", "number", "expiration_date", "security_code", "address_line1", "address_line2", "address_city", "address_state","address_region", "address_country", "address_postal_code"
         // name: "Please enter a valid name",
         // address_city: "Please enter a valid city",
      },
      // custom styles for the form inputs (optional but recommended)
      styles: {
         // default styling for all fields
         default: {
            color: '#000',
            border: '1px solid #CCCDCF',
            borderRadius: '8px',
            padding: '8px 16px',
            fontFamily: 'Helvetica',
            fontSize: '16px',
            boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 2px 4px rgba(0, 0, 0, 0.03)',
            width: 'calc(100% - 5px)',
         },
         // specific styling if the field is valid
         success: {
            // color: "#5cb85c",
         },
         // specific styling if the field has errors
         error: {
            // color: "#d9534f",
            border: '1px solid rgba(255,0,0, 0.3)',
         },
      },
      // optional callback function that will trigger when form state changes (can be called frequently)
      onUpdate: function (state, binInformation, formHasErrors) {
         // console.log(state);
         // console.log(binInformation);
         // console.log(formHasErrors);
      },
      // optional callback function that will trigger after the form has loaded
      onLoad: function () {
         console.log('done loading form fields')
         // hide loading spinners or anything else you want to do
      },
      // optional callback function that will be called when the form is submitted
      // NOTE: adding this option will automatically create a submit button for you.
      // If you do not want to use the default button and create your own,
      // do not supply this function and instead create your own submit button
      // and attach the onSubmit function to it manually.
      onSubmit: onFinixSubmit,
      // optional param to set the label for the submit button that is auto generated
      submitLabel: 'Submit',
   },
   initForm() {
      if (mptapi.companyInfo.currency === 'CAD') {
         FINIX_API.options.defaultCountry = 'CAN';
         FINIX_API.options.placeholders = {...FINIX_API.options.placeholders, address_postal_code: 'Postal Code', address_region: 'Region'};
         FINIX_API.options.labels = {...FINIX_API.options.labels, address_postal_code: 'Postal Code'};
      } else {
         FINIX_API.options.defaultCountry = 'USA';
         FINIX_API.options.hideFields.push('address_country');
         FINIX_API.options.placeholders = {...FINIX_API.options.placeholders, address_postal_code: 'Zip Code'};
      }

      if (mptapi.companyInfo?.finixObject?.env) {
         FINIX_API.finixEnv = mptapi.companyInfo.finixObject.env;
      }

      if (mptapi.companyInfo?.finixObject?.applicationId) {
         FINIX_API.applicationId = mptapi.companyInfo.finixObject.applicationId;
      }

      if (mptapi.companyInfo?.finixObject?.mid) {
         FINIX_API.form = window.Finix.CardTokenForm('checkout-form', FINIX_API.options);
      }
   },
};

//-------------------------------------------------------------
let _testResponse = null;

class MPTVueComponent
{
    constructor(/*string*/componentName, /*object*/model, /*object*/reqOptions, /*string*/appendToSelector, /*object*/appendOptions, /*string*/templateSuffix)
    {
        this.componentName = componentName || null;
        if(componentName === null || typeof(componentName) !== 'string')
            throw "componentName cannot be null. - mptvue.js";

        this.templateSuffix = templateSuffix;
        this.reqOptions = reqOptions || null;
        this.model = model || null;

        this.loadTemplate(appendToSelector, appendOptions);
    }

    loadTemplate(/*string*/appendToSelector, /*object*/appendOptions)
    {
        this.templateObj = jMPT('#' + this.componentName + (this.templateSuffix || ''));
        this.template = this.templateObj.html();

        if(appendToSelector) //selector provided to append template to different element
        {
            if(appendOptions && appendOptions.prepend)
            {
                delete appendOptions.prepend;
                jMPT('<' + this.componentName + '/>', appendOptions || {}).html(this.template).prependTo(appendToSelector);
            }
            else {
                jMPT('<' + this.componentName + '/>', appendOptions || {}).html(this.template).appendTo(appendToSelector);
            }
        }
        jMPT(this.componentName).html(this.template);
    }

    doneLoad()
    {
        jMPT(this.componentName).removeClass('d-none');
    }

    updateUrl(commitStateLvl) //commitStateLvl = 0 => replaceState; commitStateLvl = 1 => pushState; commitStateLvl = 2 => update location and navigate
    {
        let options = {};
        if (this.model && this.model.reqOptions)
            options = this.model.reqOptions;
        else if(this.reqOptions) options = this.reqOptions;

        let base = document.location.pathname;
        let search = '';
        let keys = Object.keys(options);
        let firstValid = true;

        console.log(keys);
        if(keys.length > 0) {
            for (let i = 0; i < keys.length; i++) {
                if(options[keys[i]] && keys[i] !== 'clientCartId' && keys[i] !== 'page') {
                    if(firstValid) {
                        console.log('first valid: ' + keys[i] + ' = ' + options[keys[i]]);
                        search += '?' + keys[i] + '=' + options[keys[i]];
                        firstValid = false;
                    }else
                        search += '&' + keys[i] + '=' + options[keys[i]];
                }
            }
        }

        if(commitStateLvl === 2)
            window.location = base + search;
        else if(commitStateLvl === 1)
            history.pushState(null, null, base + search);
        else
            history.replaceState(null, null, base + search);
    }
}

class MPTCheckout extends MPTVueComponent {
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'MPTCheckout';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);

        this.model = {
            checkoutSteps: [
                {
                    type: 'select-location',
                },
                {
                    type: 'select-payment',
                },
                {
                    type: 'review-order',
                }
            ],
            defaultBilling: null,
            defaultShipping: null,
            selectedShipping: {
                id: null,
                locationId: null,
                firstName: null,
                lastName: null,
                address: null,
                address2: null,
                city: null,
                region: null,
                postal:null,
                phone:null
            },
            selectedBilling: {
                id: null,
                firstName: null,
                lastName: null,
                address: null,
                address2: null,
                city: null,
                region: null,
                postal:null,
                phone: null,
                method: null
            },
            deliveryLocations: [{
                type: null,
                isFirst: false,
                locations: [{
                    clicked: false,
                    description: null,
                    id: null,
                    name: 'temp',
                    profileId: null,
                    type: null,
                    attributes: {
                        address: null,
                        address2: null,
                        city: null,
                        region: null,
                        postal: null
                    }
                }]
            }],
            shippingProfiles: [],
            cart: {},
            cartTaskId: null,
            fullProfileTaskId: null,
            currentStep: 1
        };

        this.render();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                changeSelectedLocation(){
                    let thisVue = this;
                    jMPT('.mpt-cancel-change-shipping').fadeIn();
                    jMPT('.mpt-change-shipping').fadeOut();
                    if(!thisVue.deliveryLocations || thisVue.deliveryLocations.length === 0 || thisVue.deliveryLocations.filter(dl => dl.locations.filter(loc => loc.id || loc.locationId).length > 0).length === 0)
                    {
                        mptapi.buyVues.locationSelectorVue.vueApp.loadLocations();
                    }
                },
                cancelChangeSelectedLocation(){
                    jMPT('.mpt-change-shipping').fadeIn();
                    jMPT('.mpt-cancel-change-shipping').fadeOut();
                },
                /*selectLocation(response){
                    let thisVue = this;

                    //thisVue.defaultShipping = response.defaultShipping;
                    console.log('SETTING SHIPPING IN VUE', thisVue.selectedShipping);

                    if(thisVue.selectedShipping)
                    {
                        thisVue.selectedShipping.id = response.defaultShipping.id;
                        thisVue.selectedShipping.locationId = response.defaultShipping.locationId;
                        thisVue.selectedShipping.firstName = response.defaultShipping.firstName;
                        thisVue.selectedShipping.lastName = response.defaultShipping.lastName;
                        thisVue.selectedShipping.address = response.defaultShipping.address;
                        thisVue.selectedShipping.address2 = response.defaultShipping.address2;
                        thisVue.selectedShipping.city = response.defaultShipping.city;
                        thisVue.selectedShipping.region = response.defaultShipping.region;
                        thisVue.selectedShipping.postal = response.defaultShipping.postal;
                        thisVue.selectedShipping.phone = response.defaultShipping.phone;

                    }else  thisVue.selectedShipping = response.defaultShipping;

                    console.log('DONE SETTING SHIPPING', thisVue.selectedShipping);
                }*/
            }
        });


        this.doneLoad();
        this.compileSubVues();
        this.sendRequest();
        this.bindExternalUI();
    }


    bindExternalUI(){
        let thisApp = this;



    }


    sendRequest(){
        let thisApp = this;
        //thisApp.render();

        let initRequest = new V3InitCheckout();
        initRequest.send().then(function(response){
            thisApp.model = Object.assign((thisApp.model || {}), response);

            if(response.hasOwnProperty('checkoutSteps') && response.checkoutSteps) {
                thisApp.model.checkoutSteps = response.checkoutSteps;

                console.log('***CHECKOUT STEPS:',thisApp.model.checkoutSteps);
                if(response.defaultShipping)
                {
                    thisApp.model.defaultShipping = response.defaultShipping;
                    thisApp.model.selectedShipping = response.defaultShipping;
                    jMPT('.mpt-checkout-step[data-stepnumber=1]').show();
                }
                else {
                    thisApp.vueApp.changeSelectedLocation();
                }//TODO: load location selector
            }


            if(response.hasOwnProperty('fullProfileTaskId') && response.fullProfileTaskId)
            {
                console.log('***FULLPROFILETASKID:',response.fullProfileTaskId);
                let fullProfReq = new CheckTask(response.fullProfileTaskId);
                fullProfReq.send().then(checkTaskRes => {
                    console.log('***FULLPROFILETASK_RESULT:', checkTaskRes);
                    if(checkTaskRes.success)
                    {
                        if(checkTaskRes.taskResult && Object.keys(checkTaskRes.taskResult).length > 0)
                        {
                            thisApp.vueApp.defaultBilling = thisApp.model.defaultBilling = checkTaskRes.taskResult;
                            thisApp.vueApp.selectedBilling = thisApp.model.selectedBilling = checkTaskRes.taskResult;
                        }
                    }

                });
            }

            if(response.hasOwnProperty('cartTaskId') && response.cartTaskId)
            {
                console.log('***CARTTASKID:',response.cartTaskId);
                let cartCalcReq = new CheckTask(response.cartTaskId);
                cartCalcReq.send().then(checkTaskRes => {

                    console.log('***CARTTASK_RESULT:',checkTaskRes);
                    if(checkTaskRes.success)
                    {
                        if(checkTaskRes.taskResult && Object.keys(checkTaskRes.taskResult).length > 0)
                        {
                            if(checkTaskRes.taskResult.cart) {
                                thisApp.vueApp.cart = thisApp.model.cart = checkTaskRes.taskResult.cart;
                            }
                        }
                    }

                });
            }

            //thisApp.render();

        });
    }


    runMiddleware(){
        let thisApp = this;


    }

    compileSubVues() {
        let thisApp = this;

        mptapi.buyVues.locationSelectorVue = new MPTLocationSelector(thisApp.model, null);
        /*mptapi.buyVues.paymentSelectorVue = new MPTPaymentSelector(thisApp.model, null);
        mptapi.buyVues.cartReviewVue = new MPTPaymentSelector(thisApp.model, null);
        mptapi.buyVues.addonVue = new MPTAddonSelector(thisApp.model, null);
        mptapi.buyVues.accountSettingsVue = new MPTAccountSettings(thisApp.model, null);
        mptapi.buyVues.optInsVue = new MPTOptIns(thisApp.model, null);
        mptapi.buyVues.completeOrderVue = new MPTCompleteOrder(thisApp.model, null);*/

    }
}


class MPTLocationSelector extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTLocationSelector', model, reqOptions);

        this.model = model;

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                loadLocations(){
                    let thisVue = this;

                    //On shop title day change controls
                    let locationReq = new V3GetLocations();
                    locationReq.send().then(() => {
                        if(locationReq.response && locationReq.response.deliveryLocations.length > 0) {
                            /*thisVue.deliveryLocations = locationReq.response.deliveryLocations.map(d => {
                                d.clicked = false;
                                d.profileId = null;
                                return d;
                            });*/

                            let firstLocationType = locationReq.response.deliveryLocations[0].type;

                            thisVue.deliveryLocations = [];

                            let pickupLocations = {
                                type: 'pickup',
                                isFirst: firstLocationType === 'pickup',
                                locations: locationReq.response.deliveryLocations.filter(dl => dl.type === 'pickup').map(d => {
                                    d.clicked = false;
                                    d.profileId = null;
                                    return d;
                                })
                            };
                            thisVue.deliveryLocations.push(pickupLocations);


                            let homeDeliveryLocations = {
                                type: 'home-delivery',
                                isFirst: firstLocationType === 'home-delivery',
                                locations: locationReq.response.deliveryLocations.filter(dl => dl.type === 'home-delivery').map(d => {
                                    d.clicked = false;
                                    d.profileId = null;
                                    return d;
                                })
                            };
                            thisVue.deliveryLocations.push(homeDeliveryLocations);

                            thisVue.deliveryLocations.sort((a, b) => { if(a.isFirst) return -1; else return 1; });


                            thisVue.shippingProfiles = locationReq.response.shippingProfiles;
                            jMPT('.mpt-location-selector-container').slideDown();
                        }

                    });


                },
                clickLocation(locationId, profileId){
                    let thisVue = this;

                    thisVue.deliveryLocations = thisVue.deliveryLocations.map(locationGroup => {
                            locationGroup.locations = locationGroup.locations.map(location => {
                                location.clicked = location.id === locationId && location.profileId === profileId;
                                return location;
                            });
                            return locationGroup;
                        });
                },
                saveLocation(location){
                    let thisVue = this;

                    if(!location.profileId)

                    if(location && location.attributes) {
                        let formData = {
                            locationId: location.id,
                            profileId: location.profileId || null,
                            address: location.attributes.address,
                            address2: location.attributes.address2,
                            city: location.attributes.city,
                            region: location.attributes.region,
                            postal: location.attributes.postal,
                            instructions: thisVue.selectedShipping.instructions,
                            phone: thisVue.selectedShipping.phone,
                            firstName: thisVue.selectedShipping.firstName,
                            lastName: thisVue.selectedShipping.lastName,
                        };

                        let updateLocationReq = new V3SaveLocation(formData);
                        updateLocationReq.send().then(response => {
                            console.log('SAVE LOCATION RESPONSE');
                            console.log(response);

                            if(response.defaultShipping) {
                                let newShipping = response.defaultShipping;
                                try {
                                    newShipping.firstName = newShipping.firstName || thisVue.cart.deliveries[0].shippingFirstName;
                                    newShipping.lastName = newShipping.lastName || thisVue.cart.deliveries[0].shippingLastName;
                                }catch(err){ console.warn(err);}
                                thisVue.selectedShipping = newShipping;
                            }


                            if(response.hasOwnProperty('cartTaskId') && response.cartTaskId)
                            {
                                console.log('***CARTTASKID:',response.cartTaskId);
                                let cartCalcReq = new CheckTask(response.cartTaskId);
                                cartCalcReq.send().then(checkTaskRes => {

                                    console.log('***CARTTASK_RESULT:',checkTaskRes);
                                    if(checkTaskRes.success)
                                    {
                                        if(checkTaskRes.taskResult && Object.keys(checkTaskRes.taskResult).length > 0)
                                        {
                                            if(checkTaskRes.taskResult.cart) {

                                                thisVue.cart = checkTaskRes.taskResult.cart;
                                            }
                                        }
                                    }

                                });
                            }

                        });
                    }
                }
            }
        });

        if (!thisApp.model.onCheckout) {
            setTimeout(function(){
                thisApp.bindExternalUI();
            }, 250);
        }

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;
        /*
                jMPT(containerSelector + ' .add-single-delivery').click(function (e) {
                    e.stopPropagation();
                    let thisBtn = jMPT(this);
                    thisBtn.attr("disabled", true);


                    let dayId = thisBtn.data("id");
                    jMPT('#DeliveryAddStatus' + dayId).remove();
                    thisBtn.parent().append(jMPT('<i>', {class: "fa fa-spinner fa-spin", id: "DeliveryAddStatus" + dayId}));

                    //<-----------YOU ARE HERE
                    let req = new ChangeDeliveryDate(null, null, null, null, containerSelector);
                    req.send().then(x => {
                        let delId = mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;
                        if(delId) {
                            if(mptapi.cartDropdown && mptapi.cartDropdown.visible)
                                mptapi.cartDropdown.toggle();

                            mptapi.router.updateRoute();
                            Custombox.modal.closeAll();

                            if (mptapi.companyInfo && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
                                mptapi.router.redirect("/store");
                            }
                            else {
                                if (mptapi.router.page !== mptapi.options.slugs.shop) {
                                    if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                                        mptapi.router.redirect(mptapi.options.slugs.shop, "#subscription", {deliveryId: delId});
                                    } else {
                                        mptapi.router.redirect(mptapi.options.slugs.shop, "#products", {deliveryId: delId});
                                    }
                                } else {
                                    if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                                        mptapi.router.changeHash("#subscription", {deliveryId: delId}, true);
                                    } else {
                                        mptapi.router.changeHash("#products", {deliveryId: delId}, true);
                                    }
                                }
                            }
                        }
                    });
                });


                jMPT(containerSelector + ' .timeslot-selector').change(function(){
                    let selectedDay = jMPT('#deliveryDayDropdown option:selected');
                    let selectedTimeSlot = jMPT('.' + selectedDay.val() + 'timeslots[data-date="' + selectedDay.data('date') + '"] option:selected');

                    jMPT('#SelectedDate').text(selectedDay.data("dayOfWeek") + ", " + selectedDay.data("date")).parent().show();
                    if(selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== "0"){
                        jMPT('.mobile-delivery-wrapper .add-single-delivery').attr("disabled", false);
                        let timeSlotDescription = selectedTimeSlot.data('description') || null;
                        if(timeSlotDescription) {
                            jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function(){
                                jMPT(this).text(timeSlotDescription);
                            });
                        }
                    }else{
                        jMPT('.mobile-delivery-wrapper .add-single-delivery').attr("disabled", true);
                    }

                });

                jMPT('.desktop-timeslot-selector').change(function(){
                    let selectedDay = jMPT('.deliveryDay[data-active="true"]');
                    let deliveryDayId = selectedDay.data('deliverydayid');
                    let selectedTimeSlot = jMPT('.desktop-timeslot-selector[data-date="' + selectedDay.data('date') + '"] option:selected');

                    if(selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== "0"){
                        let timeSlotDescription = selectedTimeSlot.data('description') || null;
                        if(timeSlotDescription) {
                            jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function(){
                                jMPT(this).text(timeSlotDescription);
                            });
                        }
                    }
                });

                jMPT('#deliveryDayDropdown').change(function(){
                    let selectedDay = jMPT(this).find('option:selected');
                    let selectedVal = selectedDay.val();
                    let selectedDate = selectedDay.data('date');

                    jMPT('.timeslot-selector').not('.' + selectedVal + 'timeslots[data-date="' + selectedDate + '"]').hide();
                    jMPT('.' + selectedVal + 'timeslots[data-date="' + selectedDate +'"]').show().change();
                    jMPT('#timeSlotTitle').show();
                });*/

    }

    compileSubVues(){
        let thisApp = this;

    }
}

class MPTAddressEditor extends MPTVueComponent {
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'MPTAddressEditor';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);

        if(this.model && this.model.uniqueId)
            this.sendRequest(); // this is a saved address
        else { //this is a new address
            let addressModel = {
                uniqueId: guid(),
                firstName: null,
                lastName: null,
                address: null,
                address2: null,
                city: null,
                region: null,
                regionLabel: 'State',
                country: 'US',
                postal: null,
                phone: null,
                deliveryInstructions: null,
                isBillingAddress: false,
                paymentInfo: {
                    uniqueId: null,
                    ccToken: null,
                    ccExp: null,
                    ccCvv: null
                }
            };

            this.model = Object.assign(addressModel, this.model || {});
            this.uniqueId = this.model.paymentInfo.uniqueId = this.model.uniqueId;
            this.render();
        }
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                parseAndApplyComponents(addressComponents)
                {
                    let thisVue = this;

                    let addressBuilder = '';

                    for(let i = 0; i < addressComponents.length; i++){
                        const addressComponent = addressComponents[i];
                        if(addressComponent.types.filter(t => t === 'street_number').length > 0){
                            addressBuilder = addressComponent.long_name + ' ' + addressBuilder;
                        }
                        else if(addressComponent.types.filter(t => t === 'route').length > 0){
                            addressBuilder += addressComponent.long_name;
                        }
                        else if(addressComponent.types.filter(t => t === 'locality').length > 0){
                            thisVue.city = addressComponent.long_name;
                        }
                        else if(addressComponent.types.filter(t => t === 'administrative_area_level_1').length > 0){
                            thisVue.region = addressComponent.short_name;
                        }
                        else if(addressComponent.types.filter(t => t === 'postal_code').length > 0){
                            thisVue.postal = addressComponent.long_name;
                        }
                    }

                    thisVue.address = addressBuilder;

                    console.log(thisVue.address);
                    console.log(thisVue.address2);
                    console.log(thisVue.city);
                    console.log(thisVue.region);
                    console.log(thisVue.postal);
                },
                showDeliveryInstructions() {
                    jMPT('#' + thisApp.uniqueId + 'deliveryInstructionsControl').slideUp();
                    jMPT('#' + thisApp.uniqueId + 'deliveryInstructions').slideDown();
                }
            }
        });


        this.doneLoad();

        this.compileSubVues();

        this.bindExternalUI();
    }


    bindExternalUI(){
        let thisApp = this;

        if (typeof window.crs !== "undefined") {
            window.crs.init();

            setTimeout(function () {
                jMPT('#' + thisApp.uniqueId).find('.crs-country').val(thisApp.vueApp.country).change();
                jMPT('#' + thisApp.uniqueId).find('[data-value-selection]').each(function () {
                    let $this = jMPT(this);
                    $this.val($this.data("valueSelection"));
                });
                setTimeout(function(){
                    thisApp.initGooglePlaces();
                }, 250);
            }, 150);
        }
        else thisApp.initGooglePlaces();
    }

    initGooglePlaces()
    {
        let thisApp = this;
        if(typeof(google) === 'object') {
            let input = document.getElementById(thisApp.uniqueId + "address");

            let options = {
                //componentRestrictions: {country: ["us", "ca"]},
                componentRestrictions: {country: [ thisApp.model.country.toLowerCase() ]},
                fields: ["address_components", "name"],
                strictBounds: false,
            };

            if(thisApp.autocomplete)
                try{ google.maps.event.clearInstanceListeners(thisApp.autocomplete); }
                catch{ }

            thisApp.autocomplete = new google.maps.places.Autocomplete(input, options);
            thisApp.autocomplete.addListener("place_changed", () => {
                const place = thisApp.autocomplete.getPlace();
                thisApp.vueApp.parseAndApplyComponents(place.address_components);

                console.log(place.address_components);
            });
        }
    }


    sendRequest(){
        let thisApp = this;
        if(this.model.isBillingAddress)
        {
            //TODO: GET BILLING PROFILE
        }
        else{
            //TODO: GET SHIPPING PROFILE
        }
    }


    runMiddleware(){
        let thisApp = this;


    }

    compileSubVues() {
        let thisApp = this;

        if(thisApp.model.isBillingAddress)
        {
            mptapi.buyVues.addPaymentVue = new MPTPaymentInfo(thisApp.model.paymentInfo, thisApp.reqOptions);
        }
        //TODO: IF THIS IS A BILLING PROFILE, COMPILE SUB VUES
    }
}


class MPTPaymentInfo extends MPTVueComponent {

    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions) {
        if ((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'MPTPaymentInfo';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);


        let paymentInfoModel = {
            uniqueId: null,
            padKey: null,
            ccToken: null,
            ccExp: null,
            ccCvv: null
        };

        this.model = Object.assign(paymentInfoModel, this.model || {});
        this.uniqueId = this.model.uniqueId;

        this.sendRequest();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                encryptCC() {
                    let thisVue = this;
                    let ccInput = jMPT('#' + thisApp.uniqueId + 'ccnInput');
                    if (ccInput.hasClass('identified')) {
                        thisVue.ccToken = encryptText(ccInput.val(), thisVue.padKey);
                    }
                },
            }
        });


        this.doneLoad();

        this.compileSubVues();

        this.bindExternalUI();
    }


    bindExternalUI(){
        let thisApp = this;

        if(typeof(jQuery.payment) !== 'undefined') {
            jQuery('#' + thisApp.uniqueId + 'ccnInput').payment('formatCardNumber');
            jQuery('#' + thisApp.uniqueId + 'ccExp').payment('formatCardExpiry').on('change keyup', function () {
                let expElem = jQuery(this);
                try {
                    let exprArr = expElem.val().split(/[\s\/]+/);
                    if (!jQuery.payment.validateCardExpiry(exprArr[0], exprArr[exprArr.length - 1]))
                        throw 'invalid expiry';
                    else expElem.removeClass('unknown');
                } catch (err) {
                    expElem.addClass('unknown');
                }
            });

            jQuery('#' + thisApp.uniqueId + 'ccCvv').payment('formatCardCVC').on('change keyup', function () {
                let cvvElem = jQuery(this);
                try {
                    let cardType = jQuery.payment.cardType(jQuery('#' + thisApp.uniqueId + 'ccnInput').val());
                    if (cardType) {
                        if (jQuery.payment.validateCardCVC(cvvElem.val(), cardType))
                            cvvElem.removeClass('unknown');
                        else cvvElem.addClass('unknown');
                    }
                    else throw 'cannot detect card type';
                } catch (err) {
                    if (jQuery.payment.validateCardCVC(cvvElem.val()))
                        cvvElem.removeClass('unknown');
                    else cvvElem.addClass('unknown');
                }
            });
        }
    }

    sendRequest(){
        //TODO: getPadKey
        let thisApp = this;

        let padKeyRequest = new GeneratePadKey();
        padKeyRequest.send().then(function(response){
            if(response.success && response.hasOwnProperty('padKey')) {
                thisApp.model.padKey = response.padKey;
            }

            thisApp.render();
        });
    }

    runMiddleware(){}

    compileSubVues() {}
}

class MPTTopNav extends MPTVueComponent
{
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'MPTTopNav';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);

        if(!this.model)
            this.model = {
                isLoggedIn: mptapi.authToken !== null,
                cart: mptapi.cart,
                user: mptapi.user,
                cartIsOpen: false,
                accountIsOpen: false,
                menuIsOpen: false,
                cartCount: 0
            };

        this.render();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                accountClick() {
                    let thisVue = this;
                    thisVue.closeCart();
                    thisVue.closeMenu();

                    if(thisVue.accountIsOpen)
                    {
                        thisVue.closeAccount()
                    }
                    else {
                        thisVue.accountIsOpen = true;
                        window.location.href="/user/";
                    }
                },
                cartClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeMenu();

                    if(thisVue.cartIsOpen)
                    {
                        thisVue.closeCart()
                    }
                    else {
                        thisVue.cartIsOpen = true;
                        jMPT('.mpt-cart-icon').click();
                    }

                },
                siteMenuClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeCart();

                    if(thisVue.menuIsOpen)
                    {
                        thisVue.closeMenu()
                    }
                    else {
                        thisVue.menuIsOpen = true;
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if(siteMenuVue)
                            siteMenuVue.showNav();
                    }
                },
                closeAccount() {
                    let thisVue = this;

                    /*if(thisVue.accountIsOpen)
                    TODO: CLOSE ACCOUNT SUB MENU
                        */

                    thisVue.accountIsOpen = false;
                },
                closeCart() {
                    let thisVue = this;

                    if(thisVue.cartIsOpen)
                        jMPT('.mpt-cart-icon').click();

                    thisVue.cartIsOpen = false;
                },
                closeMenu() {
                    let thisVue = this;

                    if(thisVue.menuIsOpen) {
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if (siteMenuVue)
                            siteMenuVue.hideNav();
                    }

                    thisVue.menuIsOpen = false;
                }
            }
        });




        this.doneLoad();

        this.compileSubVues();

        this.bindExternalUI();
    }

    bindExternalUI(){
        let thisApp = this;

    }


    sendRequest(){
        let thisApp = this;

    }


    runMiddleware(){
        let thisApp = this;


    }

    compileSubVues() {
        let thisApp = this;

    }
}



class MPTBottomNav extends MPTVueComponent
{
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'MPTBottomNav';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);

        if(!this.model)
            this.model = {
                isLoggedIn: mptapi.authToken !== null,
                cart: mptapi.cart,
                user: mptapi.user,
                cartIsOpen: false,
                menuIsOpen: false,
                accountIsOpen: false
            };

        this.render();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                accountClick() {
                    let thisVue = this;
                    thisVue.closeCart();
                    thisVue.closeMenu();

                    if(thisVue.accountIsOpen)
                    {
                        thisVue.closeAccount()
                    }
                    else {
                        thisVue.accountIsOpen = true;
                        window.location.href="/user/";
                    }
                },
                cartClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeMenu();

                    if(thisVue.cartIsOpen)
                    {
                        thisVue.closeCart()
                    }
                    else {
                        thisVue.cartIsOpen = true;
                        jMPT('.mpt-cart-icon').click();
                    }

                },
                siteMenuClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeCart();

                    if(thisVue.menuIsOpen)
                    {
                        thisVue.closeMenu()
                    }
                    else {
                        thisVue.menuIsOpen = true;
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if(siteMenuVue)
                            siteMenuVue.showNav();
                    }
                },
                closeAccount() {
                    let thisVue = this;

                    /*if(thisVue.accountIsOpen)
                    TODO: CLOSE ACCOUNT SUB MENU
                        */

                    thisVue.accountIsOpen = false;
                },
                closeCart() {
                    let thisVue = this;

                    if(thisVue.cartIsOpen)
                        jMPT('.mpt-cart-icon').click();

                    thisVue.cartIsOpen = false;
                },
                closeMenu() {
                    let thisVue = this;

                    if(thisVue.menuIsOpen) {
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if (siteMenuVue)
                            siteMenuVue.hideNav();
                    }

                    thisVue.menuIsOpen = false;
                }
            }
        });




        this.doneLoad();

        this.compileSubVues();

        this.bindExternalUI();
    }

    bindExternalUI(){
        let thisApp = this;

    }


    sendRequest(){
        let thisApp = this;

    }


    runMiddleware(){
        let thisApp = this;


    }

    compileSubVues() {
        let thisApp = this;

    }
}


class MPTOrder extends MPTVueComponent
{
    constructor(model, reqOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let groupByCategory = templateOptions && templateOptions.groupAndSortProductsByCategory;

        groupByCategory = true;//TODO: REMOVE THIS AFTER TESTING

        let compName = 'MPTOrder';
        super(compName, model, reqOptions, null, null, groupByCategory ? 'GPC' : null);

        if(groupByCategory) {
            this.model = this.model || {};
            Object.assign(this.model, {templateSuffix: 'GPC'});
        }

        this.routerDeliveryId = (this.model && this.model.deliveryId) ? this.model.deliveryId : getSafeAPIValue('cart.deliveries[0].id');
        this.routerPackageId = (this.model && this.model.packageId) ? this.model.packageId : null;

        if(this.model && this.model.products && this.model.products.length > 0)
            this.render();
        else this.sendRequest();
    }

    render(){
        this.runMiddleware();



        this.doneLoad();

        this.compileSubVues();
    }




    initAndSend(deliveryId, packageId){
        let thisApp = this;

        thisApp.init(deliveryId, packageId);

        let productRequest = new GetDeliveryShopAndTasks(deliveryId, packageId, thisApp.reqOptions);
        productRequest.send().then(shopResponse => {
            try { mptapi.track('page-view', null); } catch(errMessage){ console.error(errMessage); }
            _testResponse = shopResponse;
            thisApp.runMiddleware(shopResponse);

            jMPT('MPTOrder').removeClass('d-none');

            if (shopResponse.hasOwnProperty('productSummary'))
                mptapi.router.data.productCount = shopResponse.productSummary.productCount || context.products.length;

            let filterTasks = shopResponse.filters;
            if(filterTasks) {
                if(filterTasks.recurrenceTask)
                {
                    let recurrenceReq = new CheckTask(filterTasks.recurrenceTask);
                    recurrenceReq.send().then(checkTaskRes => {
                        mptapi.orderVues.mptFilterSidebar.vueApp.loadRecurrenceFilter(checkTaskRes);
                    });
                }

                if(filterTasks.categoriesTask)
                {
                    let categoryReq = new CheckTask(filterTasks.categoriesTask);
                    categoryReq.send().then(checkTaskRes => {

                        /*Cat format: {id: '', name: '', icons: [], images: []}*/
                        mptapi.orderVues.mptCategoryFilter.vueApp.load(checkTaskRes);

                    });
                }

                if(filterTasks.tagsTask)
                {
                    let tagsReq = new CheckTask(filterTasks.tagsTask);
                    tagsReq.send().then(checkTaskRes => {
                        console.warn('tags task checked...');
                        console.warn(checkTaskRes);
                        mptapi.orderVues.mptFilterSidebar.vueApp.loadTagFilter(checkTaskRes);
                    });
                }


                if(filterTasks.groupsTask)
                {
                    let groupsReq = new CheckTask(filterTasks.groupsTask);
                    groupsReq.send().then(checkTaskRes => {
                        mptapi.orderVues.mptFilterSidebar.vueApp.loadGroupFilters(checkTaskRes);
                    });
                }

                //TODO: let datesReq = ...
            }
        });
    }

    autoPickDate(){
        let thisApp = this;

        //TODO: if delivery id blank then add next one to cart but flag it as temp
        let autoPickDeliveryReq = new AddNextAvailableDelivery();
        autoPickDeliveryReq.send().then(() => {
            console.warn(autoPickDeliveryReq.response);
            thisApp.routerDeliveryId = thisApp.model.deliveryId = autoPickDeliveryReq.response.deliveryIds[0];
            thisApp.model.autoPickedDeliveryDate = true;
            thisApp.initAndSend(thisApp.routerDeliveryId, thisApp.routerPackageId);
        });
    }

    sendRequest(){
        let thisApp = this;

        if (thisApp.routerDeliveryId) { //make sure the deliveryid in router memory hasn't been removed.
            try {
                if (!getSafeAPIValue('cart.deliveries').filter(d => d.id === thisApp.routerDeliveryId).length > 0)
                    thisApp.routerDeliveryId = false;
            } catch (err) {
                console.warn(err);
                thisApp.routerDeliveryId = false;
            }
        }

        if(!thisApp.routerDeliveryId)
            thisApp.autoPickDate();
        else {
            thisApp.model.autoPickedDeliveryDate = false;
            thisApp.initAndSend(thisApp.routerDeliveryId, thisApp.routerPackageId);
        }

    }

    getDeliveryAndTasks(callback) {
        let thisApp = this;

        return new Promise(function (resolve, reject) {

            if (thisApp.routerDeliveryId) { //make sure the deliveryid in router memory hasn't been removed.
                try {
                    if (!getSafeAPIValue('cart.deliveries').filter(d => d.id === thisApp.routerDeliveryId).length > 0)
                        thisApp.routerDeliveryId = false;
                } catch (err) {
                    console.warn(err);
                    thisApp.routerDeliveryId = false;
                }
            }

            if (!thisApp.routerDeliveryId) {
                let autoPickDeliveryReq = new AddNextAvailableDelivery();
                autoPickDeliveryReq.send().then(resValue => {
                    thisApp.routerDeliveryId = thisApp.model.deliveryId = autoPickDeliveryReq.response.deliveryIds[0];
                    thisApp.model.autoPickedDeliveryDate = true;
                    return resolve(thisApp.routerDeliveryId);
                });
            }
            else {


                let data = Object.assign(MPTRequest.tokensObject(), {
                    deliveryId: thisApp.routerDeliveryId,
                    packageId: thisApp.routerPackageId,
                    ip: mptapi.ip
                });

                if (data.authToken && data.authToken.token) {
                    data.authToken.ip = mptapi.ip;
                }

                let requestData = JSON.stringify(data);

                let options = {
                    method: 'PUT',
                    url: activeURL() + "products/shoptasks",
                    data: requestData,
                    headers: {
                        "Authorization": "Basic " + getSafeAPIValue('mptapi.options.client_api_key'),
                        "Content-Type": "application/json",
                        "X-Forwarded-For": mptapi.ip
                    },
                    success: function (data) {
                        if (data.hasOwnProperty("error")) {
                            let autoPickDeliveryReq = new AddNextAvailableDelivery();
                            autoPickDeliveryReq.send().then(resValue => {
                                thisApp.routerDeliveryId = thisApp.model.deliveryId = autoPickDeliveryReq.response.deliveryIds[0];
                                thisApp.model.autoPickedDeliveryDate = true;

                                thisApp.getDeliveryAndTasks().then(resValue2 => {
                                    return resolve(resValue2);
                                }, rejValue2 => {
                                    return reject(rejValue2)
                                });
                            }, rejValue => {
                                return reject(rejValue)
                            });
                        }
                        else {
                            thisApp.model.autoPickedDeliveryDate = false;
                            if (callback && typeof callback === "function") {
                                data = callback(data);
                            }
                            return resolve(thisApp.routerDeliveryId);
                        }
                    },
                    error: function (xhr) {
                        console.error("[MPT Request] Oops! There was an error processing your request.");
                        return reject(xhr);
                    }
                };
                if (options.data === "null") {
                    delete options.data;
                }

                jQuery.ajax(options);
            }
        });
    }


    init(deliveryId, packageId){ //initializes vues before model is loaded since they all need to be rendered together
        let thisApp = this;

        if(thisApp.model === null)
            thisApp.model = {};

        let mobileView = false;
        if(jMPT(document).width() < 600)
            mobileView = true;

        thisApp.model = Object.assign({
            summary: { productCount: 0 },
            products: [ ],
            selectedProduct: {},
            selectedVariations:[],
            shownVariations: [],
            filterTasks: [],
            filters: {
                recurrence:[],
                tags:[],
                tagLabel: 'Filter by Tag',
                deliveryFilterLabel: 'Pre-Order Date:'
            },
            serverSideShopPage: false,
            moreOptionsText: 'View More',
            storeScrollTop: 0,
            scrollSelectedCategory: null,
            additionalCheckoutButton: false,
            compressNutritionalLabels: true,
            selectedCategory: { id: null, name: 'All'},
            selectedRecurrence: { id: null, name: 'One-time Products', icons: [], productIds: [] },
            delivery: {},
            deliveryId: deliveryId,
            deliveryIsSelected: false,
            packageId: packageId,
            fullProductPages: false,
            showDatesInShopFilters: true,
            showLocationsInShopFilters: false,
            defaultRecurrenceOptions: ['null', 'weekly', 'biweekly', 'monthly'],
            productsByCategory: {},
            deliveryOptions: [],
            firstLoad: !(thisApp.reqOptions && thisApp.reqOptions.viewProduct),
            autoPickedDeliveryDate: false,
            previewMode: (thisApp.reqOptions && thisApp.reqOptions.previewMode) || false,
            mobileView: mobileView,
            isLoaded: false,
            searchText: null,
            filterIds: [],
            searchIds: []
        }, thisApp.model);

        if(deliveryId && mptapi.cart)
        {
            try{
                thisApp.model.delivery = mptapi.cart.deliveries.filter(d => d.id === deliveryId)[0];
            }catch(err)
            {
                console.warn('no matching delivery')
            }
        }

        thisApp.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                load(productList) {
                    let thisVue = this;
                    if (productList) {
                        thisVue.products = productList;

                        if(thisApp.reqOptions && thisApp.reqOptions.viewProduct)
                        {
                            setTimeout(function(){
                                let directNavProd = thisVue.products.filter(p => p.id === thisApp.reqOptions.viewProduct);
                                if(directNavProd.length > 0)
                                {
                                    thisVue.handleProductClick(directNavProd[0]);
                                    console.warn('auto nav to: ' + directNavProd[0].id);
                                }
                            }, 250);
                        }
                    }
                },
                scrollToCategory(catId) {
                    if (catId) {

                        let catTop = jMPT('.mpt-shop-category-header[data-categoryid="' + catId + '"]').closest('.mpt-shop-category-header-container').closest('.product-container').offset().top;
                        let headerMain = jMPT('.header-main').height();
                        let sliderHeight = jMPT('.mpt-category-slider-section') ? jMPT('.mpt-category-slider-section').height() : 0;
                        let dateHeight = jMPT('.mpt-current-date-container') ? jMPT('.mpt-current-date-container').height() : 0;

                        jQuery([document.documentElement, document.body]).animate({
                            scrollTop: catTop - headerMain - sliderHeight - dateHeight - 130
                        }, 900);

                        thisApp.model.storeScrollTop = catTop;
                    }
                },
                handleProductClick(product) {
                    console.warn('product clicked:\n', product);

                    //TODO: freeze scrolling on order page


                    mptapi.orderVues.mptProductPage.vueApp.loadProduct(product);


                    //thisApp.model.storeScrollTop = jMPT(document).scrollTop();

                    //jMPT('#orderBody').fadeOut(250);


                    jMPT('html').css('overflow-y', 'hidden');
                    jMPT('body').addClass('mpt-no-scroll');


                    //top: jMPT('.header-main').outerHeight() + jMPT('.mpt-current-date-container').outerHeight() + 150,
                    //jMPT('MPTProductDetail').css('left', 0);
                    /*jMPT('MPTProductDetail').css({
                        position: "absolute",
                        top: jMPT(document).scrollTop(),
                        width: "100vw",
                        overflowY: scroll
                    });*/

                    jMPT('MPTProductDetail .mpt-back-to-store-container').css({
                        opacity: 0,
                        position: 'fixed'
                    });

                    jMPT('MPTProductDetail').css({
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        overflowY: 'scroll',
                        zIndex:9999
                    });

                    setTimeout(function() {
                            jMPT('MPTProductDetail .mpt-back-to-store-container').animate({opacity: 1}, 300);
                    }, 300);


                    //setTimeout(() => {jMPT(document).scrollTop(jMPT('mptproductpage .mpt-btn-link').offset().top);}, 300);
                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {viewProduct: product.id});
                    thisApp.updateUrl(1);
                    jMPT(window).on('popstate', function () {

                        jMPT('MPTProductDetail').css({'left': '-150vw', 'top': '0'}).removeClass("visible");
                        jMPT('html').css('overflow-y', 'auto');
                        jMPT('body').removeClass('mpt-no-scroll');
                        jMPT('MPTProductDetail .mpt-back-to-store-container').css({
                            opacity: 0,
                            position: 'relative'
                        });


                        //jMPT('MPTProductDetail').fadeOut(250);
                        //jMPT('#orderBody').fadeIn(300);
                        //setTimeout(() => { jMPT(document).scrollTop(model.storeScrollTop); }, 300);
                        jMPT(window).off('popstate');
                        thisApp.model.reqOptions.viewProduct = null;
                    });
                },
                changeDate(enforced = false) {
                    let thisVue = this;

                    mptapi.orderVues.mptPreOrderDays.vueApp.loadDays();
                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {previewMode: false});
                    thisVue.previewMode = false;
                    thisApp.updateUrl(1);
                    MPTUI.generateModal("#mpt-change-day-modal");
                },
                closeModals() {
                    let thisVue = this;

                    Custombox.modal.closeAll();
                    thisVue.previewModel = false;
                    thisVue.firstLoad = false;
                },
                initPreviewMode() {
                    let thisVue = this;

                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {previewMode: true});
                    thisVue.previewMode = true;
                    thisVue.firstLoad = false;
                    thisApp.updateUrl(1);
                    thisVue.closeModals();
                }

            }
        });

        //'Filter by Category';
        //'#header' let appendOpt = { 'appendSearchOptions': {      'id': '3rkSearchBar',      'class': 'mpt-full-search-control'    }};
        mptapi.orderVues.mptCategoryFilter = new MPTCategorySlider(thisApp.model, thisApp.reqOptions, null, null, null);
        mptapi.orderVues.mptProductPage = new MPTProductDetail(thisApp.model, thisApp.reqOptions);
        mptapi.orderVues.mptFilterSidebar = new MPTFilterSidebar(thisApp.model, thisApp.reqOptions);
        mptapi.orderVues.mptPreOrderDays = new MPTPreOrderDays(thisApp.model, thisApp.reqOptions);


        //set initial position of product detail
        jMPT('MPTProductDetail').css({'left': '-150vw', 'top': '0', 'position': 'fixed'}).removeClass("visible");
        jMPT('html').css('overflow-y', 'auto');
        jMPT('body').removeClass('mpt-no-scroll');
        jMPT('MPTProductDetail .mpt-back-to-store-container').css({
            opacity: 0,
            position: 'relative'
        });

    }

    runMiddleware(context){
        let thisApp = this;

        if(!thisApp.model)
            thisApp.model = {};

        let mobileView = false;
        if(jMPT(document).width() < 600)
            mobileView = true;

        Object.assign(thisApp.model, {
            summary: Object.assign((context.summary || {}), {productCount: context.products.length}),
            products: context.products,
            serverSideShopPage: context.companyInfo.uiSettings.serverSideShopPage,
            additionalCheckoutButton: context.companyInfo.uiSettings.showAdditionalCheckoutButton,
            compressNutritionalLabels: context.companyInfo.uiSettings.compressNutritionalLabels || false,
            delivery: mptapi.cart.deliveries.find(x => x.id === (mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId)),
            fullProductPages: (context.companyInfo.uiSettings && context.companyInfo.uiSettings.fullProductPages),
            showDatesInShopFilters: (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showDatesInShopFilters),
            showLocationsInShopFilters: (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showLocationsInShopFilters),
            defaultRecurrenceOptions: ['null', 'weekly', 'biweekly', 'monthly'],
            mobileView: mobileView,
            productsByCategory: (thisApp.model && thisApp.model.templateSuffix === 'GPC') ? { 'uncategorized': [] } : {},
            deliveryOptions: [],
            filterIds: [],
            searchText: null,
            searchIds: []
        });

        let mdCompiler = null;

        if(window.markdownit) {
            mdCompiler = window.markdownit();
            mdCompiler.disable(["code"]);
        }

        thisApp.model.products = thisApp.model.products.map(x => {
            let prod = x;

            /*if (x.variations != null) {
                x.quickAdd = x.variations.length === 0;
            }
            else x.quickAdd = true;
            TODO: include quickadd in product click considerations
            */
            x.quickAdd = false;
            x.searchFriendlyName = x.name.toLowerCase().replace(/[^A-Z0-9]/ig, '');

            if(x.description) {
                if (mdCompiler)
                    x.compiledDescription = mdCompiler.render(x.description);
                else x.compiledDescription = x.description;

                x.descriptionSnapshot = jMPT(x.compiledDescription).text();
                x.descriptionSnapshot = x.descriptionSnapshot.substr(0, Math.min(50, x.descriptionSnapshot.length));
                x.descriptionSnapshot += x.descriptionSnapshot.length > 50 ? '...' : '';
            } else {
                x.compiledDescription = null;
                x.descriptionSnapshot = null;
            }

            x.inCart = typeof mptapi.cart.deliveries.find(d => (d.products.find(p => p.productId === x.id))) !== "undefined";

            // Default Image if none sent
            if (x.images.length === 0) {
                x.images.push([{
                    id: "placeholder",
                    url: "https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg"
                }]);
                x.defaultImage = "placeholder";
            }

            const productImages = sortProductImage(x.images);

            if(mobileView && productImages.length > 0 && productImages[0].length > 2)
                x.activeImageUrl = productImages[0][2].url;
            else{
                try {
                    x.activeImageUrl = productImages[0][1].url;
                }catch{
                    x.activeImageUrl = 'https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg';
                }
            }

            x.selections = {};
            for(let i = 0; i < thisApp.model.defaultRecurrenceOptions.length; i++){
                let key = thisApp.model.defaultRecurrenceOptions[i];
                let product = prod;
                if(thisApp.model.delivery) {
                    x.selections[key] = {
                        recordId: thisApp.model.delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.id).firstOrDefault(),
                        qty: thisApp.model.delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.qty).firstOrDefault(0)
                    };
                } else x.selections[key] = {
                    recordId: null,
                    qty: 0
                }
            }

            try {
                if (thisApp.model.compressNutritionalLabels && x.attributes.length > 0) {
                    x.attributes = x.attributes.map(a => {
                        if (a.type === 'nutritionLabel' && a.data && a.data.nutritionLabel && a.data.nutritionLabel.data) {
                            a.data.nutritionLabel.data = a.data.nutritionLabel.data.filter(nlrow => {
                                return nlrow.filter(rCell => {
                                    return rCell.value;
                                }).length >= 2;
                            });
                            if (a.data.nutritionLabel.data.length > 0)
                                return a;
                            else return false;
                        }
                        else return a;
                    }).filter(a => a);
                }
            } catch(err){ console.error(err);}


            let formatted = parseFloat(x.price);
            if(thisApp.model.selectedRecurrence) {
                switch (thisApp.model.selectedRecurrence.name) {
                    case "weekly":
                        formatted = parseFloat(x.weeklyPrice);
                        break;
                    case "null":
                        formatted = parseFloat(x.price);
                        break;
                    default:
                        formatted = parseFloat(x.price);
                }
            }
            x.activePrice = formatted.toFixed(2);

            if(thisApp.model.templateSuffix === 'GPC') {
                if (prod.categories && prod.categories.length > 0) {
                    for(let j = 0; j < prod.categories.length; j++) {
                        let thisCatKey = prod.categories[j].id;
                        let thisCatName = prod.categories[j].name;
                        if(thisApp.model.productsByCategory[thisCatKey])
                            thisApp.model.productsByCategory[thisCatKey].products.push(x);
                        else thisApp.model.productsByCategory[thisCatKey] = {name: thisCatName, products: [x]};
                    }
                }
                else {
                    thisApp.model.productsByCategory['uncategorized'].push(x);
                }
            }

            return x;
        });

        if(context.hasOwnProperty("packages")){
            if(context.packages.length === 1){
                thisApp.model.package = context.packages[0];
            }
        }

        if(thisApp.reqOptions && thisApp.reqOptions.viewProduct)
        {
            setTimeout(function(){
                let directNavProd = thisApp.model.products.filter(p => p.id === thisApp.reqOptions.viewProduct);
                if(directNavProd.length > 0)
                {
                    thisApp.vueApp.handleProductClick(directNavProd[0]);
                    console.warn('auto nav to: ' + directNavProd[0].id);
                }
            }, 250);
        }
    }

    compileSubVues() {

        mptapi.orderVues.categoryFilterVue.init();
        mptapi.orderVues.mptProductPage = new MPTProductDetail(this.model, this.reqOptions, 'orderVues');
    }
}

class MPTCategorySlider extends MPTVueComponent
{
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'MPTCategorySlider';
        let groupByCategory = templateOptions && templateOptions.groupAndSortProductsByCategory;

        super(compName, model, reqOptions, appendToSelector, appendOptions, groupByCategory ? 'GPC' : null);

        if(!this.model)
            this.model = {};

        this.model.groupByCategory = groupByCategory;

        if(this.model.productsByCategory)
        {
            this.render();
        }
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                load(taskResponse){
                    let thisVue = this;
                    if(!(thisVue.categories && thisVue.categories.length > 0))
                        thisVue.categories = [];

                    jMPT('.mpt-category-carousel').removeClass('d-none').fadeIn();
                    if(taskResponse && taskResponse.success && taskResponse.taskResult) {
                        thisVue.categories = taskResponse.taskResult;
                        thisVue.categories.sort((a, b) => a.itemOrder - b.itemOrder);

                        if(thisVue.categories.length > 2)
                        {
                            setTimeout(function() {
                                thisVue.slickify();
                            }, 200);
                        }
                        else thisApp.bindExternalUI();
                    }
                },
                scrollToCategoryEvent(event) {
                    thisApp.vueApp.scrollToCategory(event.target.value);
                },
                scrollToCategory(catId) {
                    if (catId) {

                        let catTop = jMPT('.mpt-shop-category-header[data-categoryid="' + catId + '"]').closest('.mpt-shop-category-header-container').closest('.product-container').offset().top;
                        let headerMain = jMPT('.header-main').height();
                        let sliderHeight = jMPT('.mpt-category-slider-section') ? jMPT('.mpt-category-slider-section').height() : 0;
                        let dateHeight = jMPT('.mpt-current-date-container') ? jMPT('.mpt-current-date-container').height() : 0;

                        jQuery([document.documentElement, document.body]).animate({
                            scrollTop: catTop - headerMain - sliderHeight - dateHeight - 50
                        }, 900, function() {
                            thisApp.getCurrentVisibleCategory();
                        });

                        thisApp.model.storeScrollTop = catTop;
                        thisApp.model.scrollSelectedCategory = catId;
                    }
                },
                slickify()
                {
                    let thisVue = this;

                    /*let full = Math.min(thisVue.categories.length, 5);
                    let large = Math.min(thisVue.categories.length, 3);
                    let medium = Math.min(thisVue.categories.length, 3);
                    let small = Math.min(thisVue.categories.length, 1);*/

                    try {
                        jQuery('.mpt-category-carousel').slick('unslick');
                    } catch{}

                    let screenwidth = jQuery(window).width();
                    let slidesToShow = 1;

                    if(screenwidth <= 960)
                        slidesToShow = 1;
                    else if(screenwidth <= 1080)
                        slidesToShow = Math.min((2 * Math.round(thisVue.categories.length / 2) - 1), 3);
                    else slidesToShow = Math.min((2 * Math.round(thisVue.categories.length / 2) - 1), 5);


                    jQuery('.mpt-category-carousel').slick({
                        centerMode: true,
                        centerPadding: '60px',
                        infinite: true,
                        focusOnSelect: true,
                        slidesToShow: slidesToShow,
                        slidesToScroll: 1,
                        autoplay: false,
                        arrows: true
                    });



                    setTimeout(function(){
                        jQuery('.mpt-category-carousel').animate({opacity: 1}, 700);
                        jQuery('.mpt-category-carousel').slick('refresh');

                        thisApp.bindSlickBeforeChange();

                        thisApp.bindExternalUI();

                        if (thisApp.reqOptions?.viewCategory) {
                            thisApp.vueApp.scrollToCategory(thisApp.reqOptions.viewCategory);
                        }
                    }, 150);
                }
            }
        });


        this.doneLoad();

        this.compileSubVues();
    }

    bindExternalUI(){
        let thisApp = this;
        let renderTop = jMPT('.mpt-category-slider-section').offset().top;

        function checkAndSet() {
            let docWidth = jMPT(window).width();
            let sliderSection = jMPT('.mpt-category-slider-section');
            let dateSection = jMPT('.mpt-current-date-container');

            sliderSection.css({'max-width': docWidth, 'min-width': docWidth});


            //CUSTOM FOR FOODIE

            let newPos = jMPT('.header-main').outerHeight() || 0;
            dateSection.css({'position': 'fixed', 'top': newPos});
            sliderSection.css({'position': 'fixed', 'top': (newPos + dateSection.outerHeight() - 5)});

            // if(renderTop < jMPT(document).scrollTop())
            // {
            //     let newPos = jMPT('.header-main').outerHeight();
            //     sliderSection.css({'position': 'fixed', 'top': newPos});
            //     dateSection.css({'position': 'fixed', 'top': (newPos + sliderSection.outerHeight())});
            // }
            // else{
            //     sliderSection.css({'position': 'relative', 'top': '0'});
            //     dateSection.css({'position': 'relative', 'top': '0'});
            // }
        }


        jMPT(document).on('scroll resize', checkAndSet);
        checkAndSet();
        jMPT(document).on('scroll', thisApp.getCurrentVisibleCategory);
    }

    unbindScrollCheck(){
        let thisApp = this;
        jMPT(document).off('scroll', thisApp.getCurrentVisibleCategory);
    }


    bindScrollCatCheck(){
        let thisApp = this;
        jMPT(document).on('scroll', thisApp.getCurrentVisibleCategory);
    }

    unbindSlickBeforeChange(){
        jQuery('.mpt-category-carousel').off('beforeChange');
    }

    bindSlickBeforeChange(){
        let thisApp = this;
        mptapi.orderVues.mptCategoryFilter.unbindSlickBeforeChange();
        jQuery('.mpt-category-carousel').off('beforeChange');
        jQuery('.mpt-category-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            let catId = jQuery('.mpt-category-carousel-slide[data-slick-index="' + nextSlide + '"]').data('categoryid');
            mptapi.orderVues.mptCategoryFilter.unbindScrollCheck();
            mptapi.orderVues.mptOrder.vueApp.scrollToCategory(catId);
            setTimeout(function() { mptapi.orderVues.mptCategoryFilter.bindScrollCatCheck(); }, 1200);
        });
    }


    getCurrentVisibleCategory() {
        try {
            let categoryHeaders = jMPT('.mpt-shop-category-header').toArray().map((x) => {
                let $this = jMPT(x);
                return {
                    id: $this.data('categoryid'),
                    name: $this.data('categoryname'),
                    top: $this.offset().top - 300
                }
            }).filter(x => x.top < jMPT(document).scrollTop() && x.id !== 'uncategorized');

            if (categoryHeaders.length > 0) {
                let thisCat = categoryHeaders.filter(ch => ch.top === Math.max(...categoryHeaders.map(x => x.top)));
                if (thisCat.length > 0) {
                    let foundCategoryLi = jQuery('.mpt-category-li[data-category-id="'+ thisCat[0].id+'"]');

                    if(jQuery('.slick-center[data-categoryid="'+ thisCat[0].id+'"]').length === 0) {
                        let slickIndexList = jQuery('.mpt-category-carousel-slide[data-categoryid="' + thisCat[0].id + '"]').toArray().map(el => jQuery(el).data('slick-index')).filter(ind => ind > 0);
                        if (slickIndexList.length > 0) {
                            let slickIndex = slickIndexList[0];
                            //console.warn('index found: ', slickIndex);
                            mptapi.orderVues.mptCategoryFilter.unbindScrollCheck();
                            mptapi.orderVues.mptCategoryFilter.unbindSlickBeforeChange();
                            jQuery('.mpt-category-carousel').slick('slickGoTo', slickIndex);
                            setTimeout(function() { mptapi.orderVues.mptCategoryFilter.bindSlickBeforeChange(); }, 1200);
                            setTimeout(function() { mptapi.orderVues.mptCategoryFilter.bindScrollCatCheck(); }, 1200);
                        }
                    }

                    if (foundCategoryLi.length > 0) {
                        setTimeout(function() {
                            jQuery('.mpt-category-li').removeClass('vc_active');
                            jQuery(foundCategoryLi).addClass('vc_active');
                            jQuery('#scrollSelectedCategory').val(thisCat[0].id);
                        }, 20);
                    }
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    sendRequest(){
        let thisApp = this;

    }

    init(){ //initializes vues before model is loaded since they all need to be rendered together
        let thisApp = this;

        if(thisApp.model === null)
            thisApp.model = {};

        let mobileView = false;
        if(jMPT(document).width() < 600)
            mobileView = true;

        thisApp.model = Object.assign({
            categories: [],
            filtersApplied: [],
            categoryFilterText: 'Filter By Category:',
            mobileView: mobileView
        }, thisApp.model);
    }


    runMiddleware(){
        let thisApp = this;

        if(!thisApp.model || !thisApp.model.categories || thisApp.model.categories.length === 0)
        {
            thisApp.init();
        }
    }

    compileSubVues() {
        let thisApp = this;

    }
}


class MPTFilterSidebar extends MPTVueComponent
{
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'MPTFilterSidebar';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);

        if(!this.model)
            this.model = {};

        this.render();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                loadRecurrenceFilter(taskResponse) {
                    let thisVue = this;
                    if (!(thisVue.filters.recurrence && thisVue.filters.recurrence.length > 0))
                        thisVue.filters.recurrence = [];

                    if (taskResponse && taskResponse.success && taskResponse.taskResult) {
                        thisVue.filters.recurrence = taskResponse.taskResult;
                    }
                },
                loadTagFilter(taskResponse) {
                    console.warn('tag filter:', taskResponse);

                    let thisVue = this;
                    if (!(thisVue.filters.tags && thisVue.filters.tags.length > 0))
                        thisVue.filters.tags = [];

                    if (taskResponse && taskResponse.success && taskResponse.taskResult) {
                        //Custom Foodie Tag Sort
                        const filterOrder = ['Gift Cards', 'Keto Friendly', 'Gluten Free', 'Add-Ons', 'Low Carb (Red)', 'Active (Green)', 'Breakfast (Yellow)', 'New'];
                        const resultTags = [...taskResponse.taskResult];
                        resultTags.sort((aTag, bTag) => {
                            const aTagOrder = filterOrder.indexOf(aTag.name);
                            const bTagOrder = filterOrder.indexOf(bTag.name);

                            return bTagOrder - aTagOrder;
                        });
                        thisVue.filters.tags = resultTags;
                    }
                },
                loadGroupFilters(taskResponse) {
                    let thisVue = this;
                    if (!(thisVue.filters.groups && thisVue.filters.groups.length > 0))
                        thisVue.filters.groups = [];

                    if (taskResponse && taskResponse.success && taskResponse.taskResult) {
                        thisVue.filters.groups = taskResponse.taskResult;
                    }

                },
                loadDateFilter(taskResponse) {
                    console.warn('date filter:', taskResponse);
                },
                updateFilters() {
                    let thisVue = this;

                    if (thisVue.searchText) {
                        let searchVal = thisVue.searchText.toLowerCase().replace(/[^A-Z0-9]/ig, '');
                        thisVue.searchIds = thisVue.products.filter(x => x.searchFriendlyName.includes(searchVal)).map(x => x.id);
                    } else {
                        thisVue.searchIds = [];
                    }

                    let selectedTags = jMPT('.tag-filter:checked');
                    if (selectedTags.length > 0) {
                        thisVue.filterIds = selectedTags.toArray().map($tagFilter => {
                            let ids = jMPT($tagFilter).data('ids').split(',');
                            return ids;
                        }).reduce((current, agg) => {
                            return agg.concat(current)
                        }, []);
                    } else {
                        thisVue.filterIds = [];
                    }

                    if (thisVue.searchIds && thisVue.searchIds.length > 0) {
                        if (thisVue.filterIds.length > 0)
                            thisVue.filterIds = thisVue.filterIds.filter(value => thisVue.searchIds.includes(value));
                        else thisVue.filterIds = thisVue.searchIds.map(x => x);
                    }

                    if (thisVue.filterIds.length > 0) {
                        setTimeout(function () {
                            if (jMPT('.mpt-filter-include').inViewPort().length === 0) {
                                let firstUnfiltered = jMPT('.mpt-filter-include').firstBelowViewPort();
                                if (firstUnfiltered.length > 0) {
                                    jQuery([document.documentElement, document.body]).animate({
                                        scrollTop: firstUnfiltered.offset().top - trueViewPortOffset()
                                    }, 700);
                                }
                                else {
                                    let previousUnfiltered = jMPT('.mpt-filter-include').firstAboveViewPort();
                                    if (previousUnfiltered.length > 0) {
                                        jQuery([document.documentElement, document.body]).animate({
                                            scrollTop: previousUnfiltered.offset().top - trueViewPortOffset()
                                        }, 700);
                                    }
                                }

                            }

                        }, 750);


                    }
                    else {
                        thisVue.filterIds = [];
                    }
                }
            }
        });


        this.doneLoad();

        this.compileSubVues();

        this.bindExternalUI();
    }

    bindExternalUI(){
        let thisApp = this;

        function showFilterSideBar() {
            let mobileSlideOut = jMPT(window).width() < 500;
            if(mobileSlideOut)
            {
                jMPT('html').css('overflow-y', 'hidden');
                jMPT('body').addClass('mpt-no-scroll');
            }

            jMPT('.mpt-filter-sidebar').css('left', 0);

            if(mobileSlideOut){
                jMPT('.mpt-filter-sidebar').css({
                    position: "fixed",
                    top: 0,
                    width: "100vw",
                    height: "100vh",
                }).addClass("mobile");
            }
            else{
                jMPT('.mpt-filter-sidebar').css({
                    position: "fixed",
                    top: 0,
                    width: "375px",
                    height: "100vh",
                }).removeClass("mobile");
            }
        };

        function hideFilterSideBar() {
            jMPT('.mpt-filter-sidebar').css('left', '-150vw').removeClass("visible");
            jMPT('html').css('overflow-y', 'auto');
            jMPT('body').removeClass('mpt-no-scroll');
        };


        jMPT('.mpt-filter-sidebar-expand').click(showFilterSideBar);
        jMPT('.mpt-filter-sidebar-close').click(hideFilterSideBar);


        jMPT('MPTFilterSidebar').show();


    }


    sendRequest(){
        let thisApp = this;

    }


    runMiddleware(){
        let thisApp = this;


    }

    compileSubVues() {
        let thisApp = this;

    }
}


class MPTPreOrderDays extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTPreOrderDays', model, reqOptions);

        this.model = model;

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                loadDays(){
                    let thisVue = this;
                    let explicitSubEdit = false;

                    if (enforceSubEdits())
                        if (mptapi.router.data.editingSubscription) {
                            explicitSubEdit = true;
                            subscriptionEditMode(mptapi.user.displayName, 'explicit-deliveries');
                        }

                    let packageId = mptapi.router.data.packageId || null;

                    //On shop title day change controls
                    let dayReq = new GetDeliveryOptions(packageId, explicitSubEdit);
                    dayReq.send().then(() => {
                        thisVue.deliveryOptions = dayReq.response.deliveryOptions.map(d => {
                            try{
                                let dateSplit = d.date.split('/');
                                d.dateShort = dateSplit[0] + "/" + dateSplit[1];
                            }
                            catch{ d.dateShort = d.date; }

                            d.timeSlots.sort((ts1, ts2)=>{
                                let time1 = new Date(ts1.dateTime);
                                let time2 = new Date(ts2.dateTime);
                                if(time2 < time1)
                                    return 1;
                                if(time2 > time1)
                                    return -1;
                                return 0;
                            });

                            return d;
                        });
                    });
                },
                clickDay(deliveryOptionId, dateValue){
                    let thisVue = this;

                    thisVue.deliveryOptions = thisVue.deliveryOptions.map(dopt => {
                       dopt.clicked = dopt.id === deliveryOptionId && dopt.date == dateValue;

                       if(dopt.clicked)
                           jMPT('.delivery-day-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(dopt.description);


                       return dopt;
                    });

                    thisVue.clickTimeSlot(deliveryOptionId, dateValue);
                },
                clickTimeSlot(deliveryOptionId, dateValue){
                    let thisVue = this;
                    let clickedTimeSlot = jMPT('#timeSlots' + deliveryOptionId).val();


                        thisVue.deliveryOptions = thisVue.deliveryOptions.map(dopt => {
                            dopt.clicked = dopt.id === deliveryOptionId && dopt.date == dateValue;

                            if(dopt.clicked) {
                                if (dopt.timeSlots.length > 1) {
                                    dopt.timeSlots = dopt.timeSlots.map(ts => {
                                        ts.selected = ts.id === clickedTimeSlot;

                                        if (ts.selected)
                                            jMPT('.delivery-timeslot-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(ts.description);

                                        return ts;
                                    });
                                } else {
                                    jMPT('.delivery-timeslot-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(dopt.timeSlots[0].description);
                                }
                            }

                            return dopt;
                        });


                },
                changeDay(){
                    //deliveryId, dayId, timeSlotId, dateTime, containerSelector

                    let thisVue = this;

                    let selectedDay = thisVue.deliveryOptions.filter(dopt => dopt.clicked === true);
                    if(selectedDay.length > 0) {
                        selectedDay  = selectedDay[0];
                        let selectedTimeslot = [...selectedDay.timeSlots]
                        selectedTimeslot.sort((a, b) => {
                            if(a.selected) return -1;
                            else if(b.selected) return 1;
                            else return 0;
                        } );

                        if(selectedTimeslot.length > 0) {
                            selectedTimeslot = selectedTimeslot[0];
                            let req = new ChangeDeliveryDate(thisVue.deliveryId, selectedDay.id, selectedTimeslot.id, selectedTimeslot.dateTime, null);
                            req.send().then(() => {
                                window.location.reload();
                            });
                        }
                    }
                },
                addDay(){

                },
                customDeliveryDisplay(timeSlotStr) {
                    let deliveries = getSafeAPIValue('mptapi.cart.deliveries');
                    if (deliveries && deliveries.length && deliveries[0].shippingLocationType === 'pickup') {
                        return timeSlotStr.replace('04:00 PM - 09:00 PM', '03:30 PM - 08:00PM');
                    }

                    return timeSlotStr;
                }
            }
        });

        setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;
/*
        jMPT(containerSelector + ' .add-single-delivery').click(function (e) {
            e.stopPropagation();
            let thisBtn = jMPT(this);
            thisBtn.attr("disabled", true);


            let dayId = thisBtn.data("id");
            jMPT('#DeliveryAddStatus' + dayId).remove();
            thisBtn.parent().append(jMPT('<i>', {class: "fa fa-spinner fa-spin", id: "DeliveryAddStatus" + dayId}));

            //<-----------YOU ARE HERE
            let req = new ChangeDeliveryDate(null, null, null, null, containerSelector);
            req.send().then(x => {
                let delId = mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;
                if(delId) {
                    if(mptapi.cartDropdown && mptapi.cartDropdown.visible)
                        mptapi.cartDropdown.toggle();

                    mptapi.router.updateRoute();
                    Custombox.modal.closeAll();

                    if (mptapi.companyInfo && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
                        mptapi.router.redirect("/store");
                    }
                    else {
                        if (mptapi.router.page !== mptapi.options.slugs.shop) {
                            if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                                mptapi.router.redirect(mptapi.options.slugs.shop, "#subscription", {deliveryId: delId});
                            } else {
                                mptapi.router.redirect(mptapi.options.slugs.shop, "#products", {deliveryId: delId});
                            }
                        } else {
                            if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                                mptapi.router.changeHash("#subscription", {deliveryId: delId}, true);
                            } else {
                                mptapi.router.changeHash("#products", {deliveryId: delId}, true);
                            }
                        }
                    }
                }
            });
        });


        jMPT(containerSelector + ' .timeslot-selector').change(function(){
            let selectedDay = jMPT('#deliveryDayDropdown option:selected');
            let selectedTimeSlot = jMPT('.' + selectedDay.val() + 'timeslots[data-date="' + selectedDay.data('date') + '"] option:selected');

            jMPT('#SelectedDate').text(selectedDay.data("dayOfWeek") + ", " + selectedDay.data("date")).parent().show();
            if(selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== "0"){
                jMPT('.mobile-delivery-wrapper .add-single-delivery').attr("disabled", false);
                let timeSlotDescription = selectedTimeSlot.data('description') || null;
                if(timeSlotDescription) {
                    jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function(){
                        jMPT(this).text(timeSlotDescription);
                    });
                }
            }else{
                jMPT('.mobile-delivery-wrapper .add-single-delivery').attr("disabled", true);
            }

        });

        jMPT('.desktop-timeslot-selector').change(function(){
            let selectedDay = jMPT('.deliveryDay[data-active="true"]');
            let deliveryDayId = selectedDay.data('deliverydayid');
            let selectedTimeSlot = jMPT('.desktop-timeslot-selector[data-date="' + selectedDay.data('date') + '"] option:selected');

            if(selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== "0"){
                let timeSlotDescription = selectedTimeSlot.data('description') || null;
                if(timeSlotDescription) {
                    jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function(){
                        jMPT(this).text(timeSlotDescription);
                    });
                }
            }
        });

        jMPT('#deliveryDayDropdown').change(function(){
            let selectedDay = jMPT(this).find('option:selected');
            let selectedVal = selectedDay.val();
            let selectedDate = selectedDay.data('date');

            jMPT('.timeslot-selector').not('.' + selectedVal + 'timeslots[data-date="' + selectedDate + '"]').hide();
            jMPT('.' + selectedVal + 'timeslots[data-date="' + selectedDate +'"]').show().change();
            jMPT('#timeSlotTitle').show();
        });*/

    }

    compileSubVues(){
        let thisApp = this;

    }
}

class MPTCheckoutPreOrderDays extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTCheckoutPreOrderDays', model, reqOptions);

        if(model)
            this.model = model;
        else this.model = {
            deliveryOptions: []
        };

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                loadDays(deliveryId){
                    let thisVue = this;
                    thisVue.deliveryId = deliveryId;
                    let explicitSubEdit = false;

                    if (enforceSubEdits())
                        if (mptapi.router.data.editingSubscription) {
                            explicitSubEdit = true;
                            subscriptionEditMode(mptapi.user.displayName, 'explicit-deliveries');
                        }

                    let packageId = mptapi.router.data.packageId || null;

                    //On shop title day change controls
                    let dayReq = new GetDeliveryOptions(packageId, explicitSubEdit);
                    dayReq.send().then(() => {
                        thisVue.deliveryOptions = dayReq.response.deliveryOptions.map(d => {
                            try{
                                let dateSplit = d.date.split('/');
                                d.dateShort = dateSplit[0] + "/" + dateSplit[1];
                            }
                            catch{ d.dateShort = d.date; }

                            d.timeSlots.sort((ts1, ts2)=>{
                                let time1 = new Date(ts1.dateTime);
                                let time2 = new Date(ts2.dateTime);
                                if(time2 < time1)
                                    return 1;
                                if(time2 > time1)
                                    return -1;
                                return 0;
                            });

                            return d;
                        });
                    });
                },
                clickDay(deliveryOptionId, dateValue){
                    let thisVue = this;

                    thisVue.deliveryOptions = thisVue.deliveryOptions.map(dopt => {
                        dopt.clicked = dopt.id === deliveryOptionId && dopt.date == dateValue;

                        if(dopt.clicked)
                            jMPT('.delivery-day-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(dopt.description);


                        return dopt;
                    });

                    thisVue.clickTimeSlot(deliveryOptionId, dateValue);
                },
                clickTimeSlot(deliveryOptionId, dateValue){
                    let thisVue = this;
                    let clickedTimeSlot = jMPT('#timeSlots' + deliveryOptionId).val();


                    thisVue.deliveryOptions = thisVue.deliveryOptions.map(dopt => {
                        dopt.clicked = dopt.id === deliveryOptionId && dopt.date == dateValue;

                        if(dopt.clicked) {
                            if (dopt.timeSlots.length > 1) {
                                dopt.timeSlots = dopt.timeSlots.map(ts => {
                                    ts.selected = ts.id === clickedTimeSlot;

                                    if (ts.selected)
                                        jMPT('.delivery-timeslot-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(ts.description);

                                    return ts;
                                });
                            } else {
                                jMPT('.delivery-timeslot-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(dopt.timeSlots[0].description);
                            }
                        }

                        return dopt;
                    });


                },
                changeDay(){
                    //deliveryId, dayId, timeSlotId, dateTime, containerSelector

                    let thisVue = this;

                    let selectedDay = thisVue.deliveryOptions.filter(dopt => dopt.clicked === true);
                    if(selectedDay.length > 0) {
                        selectedDay  = selectedDay[0];
                        let selectedTimeslot = [...selectedDay.timeSlots]
                        selectedTimeslot.sort((a, b) => {
                            if(a.selected) return -1;
                            else if(b.selected) return 1;
                            else return 0;
                        } );

                        if(selectedTimeslot.length > 0) {
                            selectedTimeslot = selectedTimeslot[0];
                            let req = new ChangeDeliveryDate(thisVue.deliveryId, selectedDay.id, selectedTimeslot.id, selectedTimeslot.dateTime, null);
                            req.send().then(() => {
                                window.location.reload();
                            });
                        }
                    }
                },
                addDay(){

                },
                customDeliveryDisplay(timeSlotStr) {
                    let deliveries = getSafeAPIValue('mptapi.cart.deliveries');
                    if (deliveries && deliveries.length && deliveries[0].shippingLocationType === 'pickup') {
                        return timeSlotStr.replace('04:00 PM - 09:00 PM', '03:30 PM - 08:00PM');
                    }

                    return timeSlotStr;
                },
                closeModals() {
                    let thisVue = this;

                    Custombox.modal.closeAll();
                }
            }
        });

        setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;
    }

    compileSubVues(){
        let thisApp = this;
    }
}

class MPTCartPreOrderDays extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTCartPreOrderDays', model, reqOptions);

        if(model)
            this.model = model;
        else this.model = {
            deliveryOptions: []
        };

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                loadDays(){
                    let thisVue = this;
                    let explicitSubEdit = false;

                    if (enforceSubEdits())
                        if (mptapi.router.data.editingSubscription) {
                            explicitSubEdit = true;
                            subscriptionEditMode(mptapi.user.displayName, 'explicit-deliveries');
                        }

                    let packageId = mptapi.router.data.packageId || null;
                    let existingDates = [];

                    if(mptapi.cart && mptapi.cart.deliveries.length > 0) {
                        try {
                            existingDates = mptapi.cart.deliveries.map(d => {
                                return {
                                    timeSlotId: d.timeSlotId,
                                    dateTime: new Date(d.nextDeliveryFrom).getTime()
                                };
                            });
                        }catch{}
                    }

                    //On shop title day change controls
                    let dayReq = new GetDeliveryOptions(packageId, explicitSubEdit);
                    dayReq.send().then(() => {
                        thisVue.deliveryOptions = dayReq.response.deliveryOptions.map(d => {
                            try{
                                let dateSplit = d.date.split('/');
                                d.dateShort = dateSplit[0] + "/" + dateSplit[1];
                            }
                            catch{ d.dateShort = d.date; }

                            try {
                                if(existingDates.length > 0)
                                {
                                    d.timeSlots = d.timeSlots.filter((ts) => {
                                        return existingDates.filter(ed => ed.dateTime === new Date(ts.dateTime).getTime() && ts.id === ed.timeSlotId).length === 0;
                                    });
                                }
                            }
                            catch(err){
                                console.error(err);
                                d.timeSlots = d.timeSlots;
                            }

                            d.timeSlots.sort((ts1, ts2)=>{
                                let time1 = new Date(ts1.dateTime);
                                let time2 = new Date(ts2.dateTime);
                                if(time2 < time1)
                                    return 1;
                                if(time2 > time1)
                                    return -1;
                                return 0;
                            });

                            return d;
                        }).filter(d => d.timeSlots.length > 0);
                    });
                },
                clickDay(deliveryOptionId, dateValue){
                    let thisVue = this;

                    thisVue.deliveryOptions = thisVue.deliveryOptions.map(dopt => {
                        dopt.clicked = dopt.id === deliveryOptionId && dopt.date == dateValue;

                        if(dopt.clicked)
                            jMPT('MPTCartPreOrderDays .delivery-day-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(dopt.description);

                        return dopt;
                    });

                    thisVue.clickTimeSlot(deliveryOptionId, dateValue);
                },
                clickTimeSlot(deliveryOptionId, dateValue){
                    let thisVue = this;
                    let clickedTimeSlot = jMPT('#timeSlots' + deliveryOptionId).val();


                        thisVue.deliveryOptions = thisVue.deliveryOptions.map(dopt => {
                            dopt.clicked = dopt.id === deliveryOptionId && dopt.date == dateValue;

                            if(dopt.clicked) {
                                if (dopt.timeSlots.length > 1) {
                                    dopt.timeSlots = dopt.timeSlots.map(ts => {
                                        ts.selected = ts.id === clickedTimeSlot;

                                        if (ts.selected)
                                            jMPT('.delivery-timeslot-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(ts.description);

                                        return ts;
                                    });
                                } else {
                                    jMPT('.delivery-timeslot-description[data-delivery-day-id="' + deliveryOptionId + '"][data-date="' + dateValue + '"]').text(dopt.timeSlots[0].description);
                                }
                            }

                            return dopt;
                        });



                },
                addDay(){
                    //deliveryId, dayId, timeSlotId, dateTime, containerSelector

                    let thisVue = this;

                    let selectedDay = thisVue.deliveryOptions.filter(dopt => dopt.clicked === true);
                    if(selectedDay.length > 0) {
                        selectedDay  = selectedDay[0];
                        let selectedTimeslot = [...selectedDay.timeSlots]
                        selectedTimeslot.sort((a, b) => {
                            if(a.selected) return -1;
                            else if(b.selected) return 1;
                            else return 0;
                        } );

                        if(selectedTimeslot.length > 0) {
                            selectedTimeslot = selectedTimeslot[0];

                            let newDayReq = new AddDelivery(selectedDay.id, selectedTimeslot.id, selectedTimeslot.dateTime);
                            newDayReq.send().then((newDayRes) => {
                                mptapi.router.redirect("order", '', {deliveryId: newDayRes.newDeliveryIds[0]});
                            });
                        }
                    }
                },
                initAddPreOrderDay() {
                    let thisVue = this;
                    thisVue.loadDays();
                    setTimeout(function () {
                        MPTUI.generateModal("#mpt-add-day-modal");
                    }, 250);
                },
                closeModals() {
                    let thisVue = this;

                    Custombox.modal.closeAll();
                },
                customDeliveryDisplay(timeSlotStr) {
                    let deliveries = getSafeAPIValue('mptapi.cart.deliveries');
                    if (deliveries && deliveries.length && deliveries[0].shippingLocationType === 'pickup') {
                        return timeSlotStr.replace('04:00 PM - 09:00 PM', '03:30 PM - 08:00PM');
                    }

                    return timeSlotStr;
                }
            }
        });

        setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;
        /*
                jMPT(containerSelector + ' .add-single-delivery').click(function (e) {
                    e.stopPropagation();
                    let thisBtn = jMPT(this);
                    thisBtn.attr("disabled", true);


                    let dayId = thisBtn.data("id");
                    jMPT('#DeliveryAddStatus' + dayId).remove();
                    thisBtn.parent().append(jMPT('<i>', {class: "fa fa-spinner fa-spin", id: "DeliveryAddStatus" + dayId}));

                    //<-----------YOU ARE HERE
                    let req = new ChangeDeliveryDate(null, null, null, null, containerSelector);
                    req.send().then(x => {
                        let delId = mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;
                        if(delId) {
                            if(mptapi.cartDropdown && mptapi.cartDropdown.visible)
                                mptapi.cartDropdown.toggle();

                            mptapi.router.updateRoute();
                            Custombox.modal.closeAll();

                            if (mptapi.companyInfo && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
                                mptapi.router.redirect("/store");
                            }
                            else {
                                if (mptapi.router.page !== mptapi.options.slugs.shop) {
                                    if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                                        mptapi.router.redirect(mptapi.options.slugs.shop, "#subscription", {deliveryId: delId});
                                    } else {
                                        mptapi.router.redirect(mptapi.options.slugs.shop, "#products", {deliveryId: delId});
                                    }
                                } else {
                                    if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                                        mptapi.router.changeHash("#subscription", {deliveryId: delId}, true);
                                    } else {
                                        mptapi.router.changeHash("#products", {deliveryId: delId}, true);
                                    }
                                }
                            }
                        }
                    });
                });


                jMPT(containerSelector + ' .timeslot-selector').change(function(){
                    let selectedDay = jMPT('#deliveryDayDropdown option:selected');
                    let selectedTimeSlot = jMPT('.' + selectedDay.val() + 'timeslots[data-date="' + selectedDay.data('date') + '"] option:selected');

                    jMPT('#SelectedDate').text(selectedDay.data("dayOfWeek") + ", " + selectedDay.data("date")).parent().show();
                    if(selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== "0"){
                        jMPT('.mobile-delivery-wrapper .add-single-delivery').attr("disabled", false);
                        let timeSlotDescription = selectedTimeSlot.data('description') || null;
                        if(timeSlotDescription) {
                            jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function(){
                                jMPT(this).text(timeSlotDescription);
                            });
                        }
                    }else{
                        jMPT('.mobile-delivery-wrapper .add-single-delivery').attr("disabled", true);
                    }

                });

                jMPT('.desktop-timeslot-selector').change(function(){
                    let selectedDay = jMPT('.deliveryDay[data-active="true"]');
                    let deliveryDayId = selectedDay.data('deliverydayid');
                    let selectedTimeSlot = jMPT('.desktop-timeslot-selector[data-date="' + selectedDay.data('date') + '"] option:selected');

                    if(selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== "0"){
                        let timeSlotDescription = selectedTimeSlot.data('description') || null;
                        if(timeSlotDescription) {
                            jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function(){
                                jMPT(this).text(timeSlotDescription);
                            });
                        }
                    }
                });

                jMPT('#deliveryDayDropdown').change(function(){
                    let selectedDay = jMPT(this).find('option:selected');
                    let selectedVal = selectedDay.val();
                    let selectedDate = selectedDay.data('date');

                    jMPT('.timeslot-selector').not('.' + selectedVal + 'timeslots[data-date="' + selectedDate + '"]').hide();
                    jMPT('.' + selectedVal + 'timeslots[data-date="' + selectedDate +'"]').show().change();
                    jMPT('#timeSlotTitle').show();
                });*/

    }

    compileSubVues(){
        let thisApp = this;

    }
}


class MPTProductDetail extends MPTVueComponent
{
    constructor(model, reqOptions, parentOverride){
        super('MPTProductDetail', model, reqOptions);

        this.parentOverride = parentOverride;
        this.model = model;



        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                loadProduct(prod, selectedQty, selectedRecurrence, selectedPackageId, selectedVariations){
                    let thisVue = this;
                    console.warn('Loading product:', prod);
                    thisVue.selectedProduct.id = prod.id;
                    thisVue.selectedProduct.name = prod.name;
                    thisVue.selectedProduct.images = prod.images;
                    thisVue.selectedProduct.description = prod.description;
                    thisVue.selectedProduct.activePrice = prod.activePrice;
                    thisVue.selectedProduct.price = prod.price;
                    thisVue.selectedProduct.variations = prod.variations;
                    thisVue.selectedProduct.descriptionSummary = prod.descriptionSummary;
                    thisVue.selectedProduct.compiledDescription = prod.compiledDescription;

                    console.warn('compiled description:', thisVue.selectedProduct.compiledDescription);

                    thisVue.selectedRecordId = null;
                    thisVue.selectedQty = selectedQty || 1;
                    thisVue.selectedRecurrence = selectedRecurrence || null;
                    thisVue.selectedPackageId = selectedPackageId|| null;// TODO: current packageId
                    thisVue.selectedVariations = selectedVariations || [];
                    thisVue.shownVariations = thisVue.selectedProduct.variations.map((v) => {
                        v.level = 0;
                        v.selectedOptions = v.options.filter(o => o.default).map(o => o.id);
                        if(v.selectedOptions.length === 0 && v.type === 'drop-down')
                                v.selectedOptions = v.options.slice(0,1).map(o => o.id);
                        return v;
                    });
                    thisVue.updateInDelivery = [];

                    setTimeout(function(){
                        jMPT('MPTProductDetail input[type="checkbox"]:checked').each(function(){
                            jMPT(this).removeAttr('checked');
                        });
                        thisVue.shownVariations.filter(sv => sv.type === 'drop-down').map(sv => thisVue.selectVariationOption(sv));
                        thisVue.slickify();

                    }, 200);
                },
                slickify() {
                    let thisVue = this;
                    try {
                        jQuery('MPTProductDetail .slick-initialized').slick('unslick');
                    } catch {}

                    jMPT('.mpt-fp-product-thumbnail-image').off();

                    let screenwidth = jQuery(window).width();
                    /*let slidesToShow = 1;

                    if(screenwidth <= 960)
                        slidesToShow = 1;
                    else if(screenwidth <= 1080)
                        slidesToShow = Math.min((2 * Math.round(thisVue.categories.length / 2) - 1), 3);
                    else slidesToShow = Math.min((2 * Math.round(thisVue.categories.length / 2) - 1), 5);*/

                    if (thisVue.selectedProduct.images && thisVue.selectedProduct.images.length > 0) {
                        let slidesToShow = thisVue.selectedProduct.images.length;

                        setTimeout(function () {
                            jQuery('MPTProductDetail .slider-for').slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                fade: true,
                                asNavFor: 'MPTProductDetail .slider-nav'
                            });

                            jQuery('MPTProductDetail .slider-nav').slick({
                                slidesToShow: slidesToShow,
                                slidesToScroll: 1,
                                asNavFor: 'MPTProductDetail .slider-for',
                                dots: false,
                                centerMode: true,
                                focusOnSelect: true
                            });

                            setTimeout(function() {
                                jMPT('.mpt-fp-product-thumbnail-image').on('mouseover', function() {
                                    jMPT(this).click();
                                });

                            }, 200);
                        }, 150);
                    }
                },
                backToStore(){
                    let thisVue = this;

                    jMPT('MPTProductDetail').css({'left': '-150vw', 'top': '0'}).removeClass("visible");
                    jMPT('MPTProductDetail .mpt-back-to-store-container').css({
                        opacity: 0,
                        position: 'relative'
                    });
                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');

                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions  || {}, {viewProduct: null});
                    thisApp.updateUrl(1);
                },
                addProductToDelivery(){
                    let addRequest = new AddProductToDelivery(thisApp.model.updateProductId, thisApp.model.updateQty || 1, thisApp.model.updateSelectedVariations, thisApp.model.updateProductName, 0, thisApp.model.updateRecurrence, thisApp.model.updatePackageId); //TODO: packageId
                    addRequest.send().then(addResponse => {
                        mptapi.cartDropdown.getCart(false, addResponse);
                        jMPT('.mpt-cart-icon').addTimedClass("shake");

                        //TODO: update current page -> tag products on store page and add to product pages

                        jMPT.createNotification("Success!", "Product added!");
                    });

                    console.warn(addRequest);
                },
                selectVariationOption(variation){
                    let thisVue = this;


                    if(variation) {
                        if(variation.type==='multiselect' || variation.multiselect)
                        {
                            variation.selectedOptions = jMPT('input[type="checkbox"][data-variationid="' + variation.id + '"]:checked').toArray().map(el => {
                                let $this = jMPT(el);
                                return $this.val();
                            });
                        }

                        thisVue.shownVariations = thisVue.shownVariations.filter(sv => sv.parentVariation !== variation.id)

                        let subVariations = variation.options.filter(o => variation.selectedOptions.includes(o.id)).map(full_opt => full_opt.variations || []).reduce((a, b) => a.concat(b));
                        if (subVariations.length > 0)
                        {
                            let varIndex = thisVue.shownVariations.indexOf(variation);


                            let mappedSubvars =  subVariations.map(sv => {
                                sv.level = variation.level + 1;
                                sv.selectedOptions = sv.options.filter(o => o.default).map(o => o.id);
                                if(sv.selectedOptions.length === 0 && sv.type === 'drop-down')
                                    sv.selectedOptions = sv.options.slice(0,1).map(o => o.id);
                                return sv;
                            });

                            let modifiedShownVariations = thisVue.shownVariations;

                            Array.prototype.splice.apply(modifiedShownVariations, [varIndex + 1, 0].concat(mappedSubvars));

                            thisVue.shownVariations = modifiedShownVariations;

                        }
                    }
                },
                addToCart(){
                    let thisVue = this;

                    if(thisVue.previewMode)
                    {
                        mptapi.orderVues.mptOrder.vueApp.changeDate();
                    }else {
                        let productId = thisVue.selectedProduct.id;
                        let recurrence = thisVue.selectedRecurrence;
                        let variations = thisVue.shownVariations.map(v => {
                            return {
                                id: v.id,
                                options: v.selectedOptions
                            }
                        });
                        let packageId = thisVue.selectedPackageId;
                        let qty = thisVue.selectedQty;
                        let addRequest = new AddProductToDelivery(productId, qty, variations, null, null, recurrence, packageId);

                        mptapi.navVue.cartCount += qty;
                        mptapi.ffBottomNavVue.cartCount += qty;

                        addRequest.send().then(addResponse => {
                            mptapi.cartDropdown.getCart(false, addResponse);


                            //TODO: update current page -> tag products on store page and add to product pages

                            jMPT.createNotification("Success!", "Product added!");
                        });
                    }
                }
            }
        });

        setTimeout(function(){
          thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;
        console.warn('INIT NEW MODEL');

        thisApp.model.selectedProduct = {
            id: '0',
            images: [
                [{
                    url: 'https://www.mealpreptech.com/images/logo2.png',
                    size: 'full'
                },
                    {
                        url: 'https://www.mealpreptech.com/images/logo2.png',
                        size: 'large'
                    }]
            ],
            name: '',
            description: '',
            activePrice: 0,
            price: 0,
            weeklyPrice: 0,
            variations: [{
                id: "blank",
                multiselect: false,
                name: "Size",
                options: [{
                    id: 'blank',
                    text: 'blank',
                    value: 0,
                    sku: 'SKU',
                    category: 'blank',
                    description: 'blank',
                    price: 0,
                    default: false,
                    variations: null,
                    associations: []
                }],
                sku: 'SKU',
                type: 'drop-down',
                variations: null
            }]
        };

        thisApp.model.selectedRecordId = null;
        thisApp.model.selectedQty = 1;
        thisApp.model.selectedRecurrence = null;
        thisApp.model.selectedPackageId = null;// TODO: current packageId
        thisApp.model.selectedVariations = [];
        thisApp.model.shownVariations = [];
        thisApp.model.updateInDelivery = [];

    }

    bindExternalUI(){
        let tl,
            downloading = false,
            points = [],
            btn = document.querySelector('.mpt-atc-innerbtn'),
            btnback = document.querySelector('.mpt-atc-background'),
            dot = document.querySelector('.mpt-atc-dot'),
            atcText = document.querySelector('.mpt-atc-text'),
            mainCirc = document.querySelector('.mpt-atc-maincircle'),
            subCirc = document.querySelector('.mpt-atc-subcircle'),
            mainCircFill = document.querySelector('.mainCircleFill'),
            arrow = document.querySelector('.mpt-atc-arrow'),
            rect = document.querySelector('.rect');

        TweenLite.set(rect, {
            transformOrigin: '50% 50%',
            rotation: 45
        });


        setTimeout(function(){
            jQuery('.slick-initialized').slick('resize');
            setTimeout(() => { jMPT(document).scrollTop(jMPT('.mpt-fp-product-image-container').offset().top - 150); }, 300);
        }, 250);

        btn.addEventListener('click', handler);

        function handler() {
            mptapi.orderVues.mptProductPage.vueApp.addToCart();

            if (downloading) return;
            downloading = !downloading;
            let downloadTime = .02;
            tl = new TimelineLite({
                onComplete: restart
            });
            tl.restart().play().to(arrow, .35, {
                y: 2.5,
                ease: CustomEase.create('custom', 'M0,0,C0.042,0.14,0.374,1,0.5,1,0.64,1,0.964,0.11,1,0')
            }, 'click').to(atcText, .2, {
                svgOrigin: '55% 35%',
                scale: .77,
                ease: CustomEase.create('custom', 'M0,0,C0.042,0.14,0.374,1,0.5,1,0.64,1,0.964,0.11,1,0')
            }, 'click+=.05').set(subCirc, {
                fillOpacity: 1,
                strokeOpacity: 1
            }, 'squeeze-=.3').to(subCirc, .15, {
                fillOpacity: 0,
                ease: Power1.easeInOut
            }, 'squeeze-=.3').to(subCirc, .25, {
                attr: {
                    r: 13
                },
                strokeOpacity: 0,
                ease: Power0.easeNone
            }, 'squeeze-=.3').to([btn, btnback], .3, {
                attr: {
                    d: 'M50,25 h0 a10,10 0 0,1 10,10 a10,10 0 0,1 -10,10 s0,0 0,0  a10,10 0 0,1 -10,-10 a10,10 0 0,1 10,-10 h0'
                },
                ease: Sine.easeOut
            }, 'squeeze').to([mainCirc, mainCircFill, rect, arrow], .4, {
                x: 30,
                ease: Sine.easeOut
            }, 'squeeze').to(rect, .3, {
                fill: '#fff',
                rotation: 270,
                ease: Sine.easeOut
            }, 'squeeze').to(atcText, .3, {
                autoAlpha: 0,
                y: 7,
                onComplete: changeText
            }, 'squeeze').to(arrow, .3, {
                attr: {
                    d: 'M20,39 l3.5,-3.5 l-3.5,-3.5 M20,39 l-3.5,-3.5 l3.5,-3.5 M20,39 l0,0'
                },
                transformOrigin: '50% 50%',
                rotation: 225,
                ease: Sine.easeOut
            }, 'squeeze').to(dot, .3, {
                attr: {
                    r: 1.5
                },
                ease: Back.easeOut.config(7)
            }).set(subCirc, {
                drawSVG: 0,
                strokeOpacity: 1,
                transformOrigin: '50% 50%',
                x: 30,
                rotation: -90,
                attr: {
                    r: 9.07
                }
            }).to(subCirc, downloadTime, {
                drawSVG: '102%',
                ease: Power2.easeIn
            }, 'fill+=.02').to(dot, downloadTime, {
                motionPath: {
                    path: points,
                    curviness: 2
                },
                attr: {
                    r: 2.7
                },
                ease: Power2.easeIn
            }, 'fill').to('.gradient', downloadTime, {
                attr: {
                    offset: '0%'
                },
                ease: Power2.easeIn
            }, 'fill').to(dot, .44, {
                fill: 'rgba(2, 252, 134, 1)',
                y: -22,
                ease: Power1.easeOut
            }, 'stretch-=.01').to(dot, .27, {
                transformOrigin: '50% 50%',
                scaleX: .5,
                ease: "slow(0.1, 2)"
            }, 'stretch+=.04').to(dot, .3, {
                scaleY: .6,
                ease: "slow(0.1, 2)"
            }, 'stretch+=.31').to(dot, .35, {
                scaleX: .4,
                y: 22,
                ease: Power2.easeIn
            }, 'stretch+=.45').to([mainCirc, subCirc, arrow, rect, mainCircFill], .3, {
                opacity: 0,
                ease: Power2.easeOut
            }, 'stretch+=.2').to([btn, btnback], .3, {
                attr: {
                    d: 'M50,25 h20 a10,10 0 0,1 10,10 a10,10 0 0,1 -10,10 s-20,0 -40,0 a10,10 0 0,1 -10,-10 a10,10 0 0,1 10,-10 h20'
                },
                ease: Power1.easeOut
            }, 'stretch+=.2').set(dot, {
                opacity: 1
            }, 'fill').to(btnback, .4, {
                fill: 'rgba(2, 252, 134, 0.8)',
                ease: Power2.easeOut
            }, 'stretch+=.875').set(dot, {
                opacity: 0
            }, 'stretch+=.875').to([btn, btnback], .01, {
                stroke: '#02fc86',
                ease: Power2.easeIn
            }, 'stretch+=.87').to([btn, btnback], .25, {
                attr: {
                    d: 'M50,25 h20 a10,10 0 0,1 10,10 a12,12 0 0,1 -10,10.5 s-20,6 -40,0 a12,12 0 0,1 -10,-10.5 a10,10 0 0,1 10,-10 h20'
                },
                ease: CustomEase.create('custom', 'M0,0 C0.046,0.062 0.018,1 0.286,1 0.532,1 0.489,-0.206 0.734,-0.206 0.784,-0.206 0.832,-0.174 1,0')
            }, 'stretch+=.869').to(atcText, .45, {
                autoAlpha: 1,
                y: 0,
                ease: Back.easeOut.config(2.5)
            }, 'stretch+=.855');
        };

        function restart() {
            setTimeout(() => {
                tl.seek(0).pause();
                atcText.textContent = 'Add to cart';
                TweenLite.set(atcText, {
                    x: 0
                });
                downloading = false;
            }, 1000);
        };

        function changeText() {
            atcText.textContent = 'Added!';
            TweenLite.set(atcText, {
                x: -5
            });
        }

        (function () {
            let data = Snap.path.toCubic('M0,0 a9,9 0 0,1 0,18 a9,9 0 0,1 0,-18'),
                dataLen = data.length;

            for (let i = 0; i < dataLen; i++) {
                let seg = data[i];

                if (seg[0] === 'M') {
                    let point = {};
                    point.x = seg[1];
                    point.y = seg[2];
                    points.push(point);
                } else {
                    for (let i = 1; i < 6; i += 2) {
                        let point = {};
                        point.x = seg[i];
                        point.y = seg[i + 1];
                        points.push(point);
                    }
                }
            }
        })();
    }

    compileSubVues(){
        let thisApp = this;

        let parentName = thisApp.parentOverride || 'orderVues';

        //TODO: variations
        //mptapi[parentName].mptProductVariations = [];
        //mptapi[parentName].mptProductVariations.push(new MPTProductVariations(thisApp.model, thisApp.reqOptions, thisApp.model.updateVariations, null));
    }
}


class MPTStore extends MPTVueComponent
{
    constructor(model, reqOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        super('MPTStore', model, reqOptions);

        if(this.model !== null)
            this.render();
        else this.sendRequest(this.reqOptions);
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;
        //TODO: check for deliveryId
        let summaryRequest = new GetStore(null, this.reqOptions);
        summaryRequest.send().then(function(response){
            thisApp.model = Object.assign((thisApp.model || {}), response);
            thisApp.render();
        });
    }

    runMiddleware(){
        this.model.delivery = { recurrence: null }; //TODO: tie to selected delivery from cart if provided
        this.model.isMobile = jMPT(document).width() < 600;
        this.model.reqOptions = this.reqOptions;
        this.model.selectedCategory = { id: null, name: 'All'};
        this.model.selectedRecurrence = { id: null, name: 'One-time Products', icons: [], productIds: [] };
        this.model.products = this.model.products || [];
        this.model.storeScrollTop = 0;
        this.model.openMobileFilterName = null;
        this.model.filtersApplied = [];
        this.model.loadingMore = false;

        if(this.reqOptions != null)
            this.model.page = this.reqOptions.page || 1;
        else this.model.page = 1;

        MPTMobileStoreFilters.init(this.model);
        MPTProductPage.init(this.model, null);
    }

    compileSubVues() {

        if (this.model.summary.subscription) mptapi.storeVues.mptSubscriptionBar = new MPTSubscriptionBar(this.model, null);

        if (this.model.isMobile) {
            mptapi.storeVues.mptMobileStoreFilters = new MPTMobileStoreFilters(this.model, this.reqOptions);
            mptapi.storeVues.mptDesktopStoreFilters = null;
        }
        else {
            mptapi.storeVues.mptMobileStoreFilters = null;
            mptapi.storeVues.mptDesktopStoreFilters = new MPTDesktopStoreFilters(this.model, this.reqOptions);
        }

        mptapi.storeVues.mptStoreProducts = new MPTStoreProducts(this.model, this.reqOptions);
        mptapi.storeVues.mptProductPage = new MPTProductPage(this.model, this.reqOptions);
    }
}

class MPTSubscriptionBar extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTSubscriptionBar', model, reqOptions);

        this.model = model;
        this.render();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {

            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        this.model.subscriptionLabelText = getTextOverride('subscriptionLabelText') || "Subscription";
        this.model.subscriptionBarText = 'Editing ' + this.model.subscriptionLabelText + ': ' + this.model.delivery.deliveryDayName; //text override field
    }
}

class MPTDesktopStoreFilters extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTDesktopStoreFilters', model, reqOptions);

        this.model = model;
        if(this.model.hasOwnProperty('filters'))
            this.render();
        else this.sendRequest(this.reqOptions);
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                selectedRecurrenceText() {
                    if (thisApp.model.selectedRecurrence.id === null)
                        return 'Great! Now, any products you add will automatically reorder ' + this.selectedRecurrence.name + '!';
                    else if (this.isBinaryRecurrence()) {
                        return 'Subscribe to a ' + this.filters.recurrence[1].name + ' meal plan!'
                    } else return 'Subscribe to a meal plan!'
                },
                isBinaryRecurrence(){
                    return thisApp.model.filters.recurrence.length === 2;
                },
                hideRecurrenceFilter(){
                    return thisApp.model.filters.recurrence && (thisApp.model.filters.recurrence.length === 1 || (thisApp.model.companyInfo.uiSettings.hasOwnProperty('hideRecurrenceFilter') && thisApp.model.companyInfo.uiSettings.hideRecurrenceFilter));
                },
                hideCategoriesFilter(){
                    return !(thisApp.model.filters.categories && !thisApp.model.companyInfo.uiSettings.serverSideShopPage);
                },
                hideTagsFilter(){
                    return !(thisApp.model.filters.tags && thisApp.model.filters.tags.length > 1 && !thisApp.model.companyInfo.uiSettings.hideTagFilter);
                },
                hideGroupFilters(){
                    return !(thisApp.model.filters.groups && Object.keys(thisApp.model.filters.groups).length > 0 && !thisApp.model.companyInfo.uiSettings.hideGroupFilters);
                }
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;

        let tasks = thisApp.model.tasks || {};
        tasks = Object.values(tasks);

        let filterRequest = new GetStoreFilters(tasks, thisApp.reqOptions);
        filterRequest.send().then(function(response){
            if(response.success && response.hasOwnProperty('filters'))
                thisApp.model.filters = response.filters;
            thisApp.render();
        });
    }

    runMiddleware() {
        try {
            if (this.model.filters.recurrence) {
                for (let i = 0; i < this.model.filters.recurrence.length; i++) {
                    if (this.model.filters.recurrence[i].name === "null" || this.model.filters.recurrence[i].name === null) {
                        this.model.filters.recurrence[i].name = "One-time Products";
                        this.model.filters.recurrence[i].id = null;
                    }
                    else
                    {
                        this.model.filters.recurrence[i].id = this.model.filters.recurrence[i].name;
                    }
                    //TODO: recurrenceLabelText
                }

                this.model.selectedRecurrence = this.model.filters.recurrence[0];

            }
        }catch(err){
            console.error(err);
        }

        if (this.model.reqOptions && this.model.reqOptions.cat && this.model.filters && this.model.filters.categories) {
            let sCat = this.model.filters.categories.filter(c => c.id === this.model.reqOptions.cat);
            if (sCat) this.model.selectedCategory = sCat[0];
        } else this.model.selectedCategory = {id: null, name: 'All'};
    }

    compileSubVues(){
        if(this.model.companyInfo.uiSettings.serverSideShopPage)
            mptapi.storeVues.mptServerSideSearchBar = new MPTServerSideSearchBar(this.model, this.reqOptions);

        mptapi.storeVues.mptGroupFilters = new MPTGroupFilters(this.model, this.reqOptions);
    }
}


class MPTMobileStoreFilters extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTMobileStoreFilters', model, reqOptions);
        this.model = model;
        if(this.model.hasOwnProperty('filters'))
            this.render();
        else this.sendRequest(this.reqOptions);
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                selectedRecurrenceText() {
                    if (thisApp.model.selectedRecurrence.id === null)
                        return 'Great! Now, any products you add will automatically reorder ' + this.selectedRecurrence.name + '!';
                    else if (this.isBinaryRecurrence()) {
                        return 'Subscribe to a ' + this.filters.recurrence[1].name + ' meal plan!'
                    } else return 'Subscribe to a meal plan!'
                },
                isBinaryRecurrence(){
                    return thisApp.model.filters.recurrence.length === 2;
                },
                hideRecurrenceFilter(){
                    return thisApp.model.filters.recurrence && (thisApp.model.filters.recurrence.length === 1 || (thisApp.model.companyInfo.uiSettings.hasOwnProperty('hideRecurrenceFilter') && thisApp.model.companyInfo.uiSettings.hideRecurrenceFilter));
                },
                hideCategoriesFilter(){
                    return !(thisApp.model.filters.categories && !thisApp.model.companyInfo.uiSettings.serverSideShopPage);
                },
                hideTagsFilter(){
                    return !(thisApp.model.filters.tags && thisApp.model.filters.tags.length > 1 && !thisApp.model.companyInfo.uiSettings.hideTagFilter);
                },
                hideGroupFilters(){
                    return !(thisApp.model.filters.groups && Object.keys(thisApp.model.filters.groups).length > 0 && !thisApp.model.companyInfo.uiSettings.hideGroupFilters);
                },
                toggleGroup(filterTitle, prodIds, filterSelection) {
                    if(thisApp.model.reqOptions === null) thisApp.model.reqOptions = {};

                    this.filtersApplied = [];
                    if(prodIds)
                        prodIds = [...new Set(prodIds)];
                    else prodIds = [];

                    this.filtersApplied.push({filterTitle, filterSelection});

                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {productIds: prodIds || []});
                    mptapi.storeVues.mptStoreProducts.vueApp.refresh();

                    this.toggleMobileFilter(filterTitle);
                },
                refreshFilterAttributes()
                {
                    let thisVue = this;
                    let keys = ['recurrence', 'tags', 'categories'];

                    if(this.filters.groups)
                        keys = Object.keys(thisVue.filters.groups).concat(keys);

                    this.filterAttributes = {};

                    for(let i = 0; i < keys.length; i++) {
                        let key = keys[i];
                        this.filterAttributes[key] = {
                            filterTitle: {
                                class: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'class', 'mpt-filter-title'),
                                style: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'style', 'mpt-filter-title')
                            },
                            filterTitleText: {
                                class: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'class', 'mpt-filter-title-text'),
                                style: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'style', 'mpt-filter-title-text')
                            },
                            filterArrow: {
                                class: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'class', 'mpt-filter-arrow'),
                                style: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'style', 'mpt-filter-arrow')
                            },
                            filterContent: {
                                class: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'class', 'mpt-filter-content'),
                                style: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'style', 'mpt-filter-content')
                            },
                            filterContentBody: {
                                class: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'class', 'mpt-filter-content-body'),
                                style: MPTMobileStoreFilters.initMobileFilterAttribute(thisApp.model, key, 'style', 'mpt-filter-content-body')
                            }
                        };
                    }
                },
                hasFiltersApplied(filterTitle) {
                    this.filtersApplied = this.filtersApplied || [];
                    return this.filtersApplied.length > 0 && this.filtersApplied.map(x => x.filterTitle).includes(filterTitle);
                },
                toggleMobileFilter(filterTitle) {
                    let openAction = !(this.openMobileFilterName === filterTitle);
                    this.openMobileFilterName = (!openAction) ? null : filterTitle;
                    this.refreshFilterAttributes();

                    if(openAction) {
                        let lastFilter = jMPT('.list-group-item[data-filtertype="' + filterTitle + '"]').filter(':last')[0];
                        let filterRect = lastFilter.getBoundingClientRect();
                        let contentRect = jMPT('.mpt-filter-content[data-filtertype="' + filterTitle + '"]')[0].getBoundingClientRect();
                        let newBottom = filterRect.top + filterRect.height + 15;
                        let newHeight = newBottom - contentRect.top;
                        jMPT('.mpt-filter-content[data-filtertype=' + filterTitle + ']').css('height', newHeight);
                        jMPT('.mpt-filter-content-body[data-filtertype=' + filterTitle + ']').css('height', newHeight);
                    }
                    else
                    {
                        jMPT('.mpt-filter-content[data-filtertype=' + filterTitle + ']').css('height', 26);
                        jMPT('.mpt-filter-content-body[data-filtertype=' + filterTitle + ']').css('height', 26);
                    }
                }
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;

        let tasks = thisApp.model.tasks || {};
        tasks = Object.values(tasks);

        let filterRequest = new GetStoreFilters(tasks, thisApp.reqOptions);
        filterRequest.send().then(function(response){
            if(response.success && response.hasOwnProperty('filters'))
                thisApp.model.filters = response.filters;

            thisApp.render();
        });
    }

    runMiddleware() {
        try {
            if (this.model.filters.recurrence) {
                for (let i = 0; i < this.model.filters.recurrence.length; i++) {
                    if (this.model.filters.recurrence[i].name === "null" || this.model.filters.recurrence[i].name === null) {
                        this.model.filters.recurrence[i].name = "One-time Products";
                        this.model.filters.recurrence[i].id = null;
                    }
                    else
                    {
                        this.model.filters.recurrence[i].id = this.model.filters.recurrence[i].name;
                    }
                    //TODO: recurrenceLabelText
                }

                this.model.selectedRecurrence = this.model.filters.recurrence[0];
            }
        }catch(err){
            console.error(err);
        }

        if (this.model.reqOptions && this.model.reqOptions.cat && this.model.filters && this.model.filters.categories) {
            let sCat = this.model.filters.categories.filter(c => c.id == this.model.reqOptions.cat);
            if (sCat) this.model.selectedCategory = sCat[0];
        } else this.model.selectedCategory = {id: null, name: 'All'};

        MPTMobileStoreFilters.init(this.model);
    }

    compileSubVues(){
        if(this.model.companyInfo.uiSettings.serverSideShopPage)
            mptapi.storeVues.mptServerSideSearchBar = new MPTServerSideSearchBar(this.model, this.reqOptions);

        mptapi.storeVues.mptGroupFilters = new MPTGroupFilters(this.model, this.reqOptions);
    }


    static init(model)
    {
        let keys = ['recurrence', 'tags', 'categories'];

        if(model.filters && model.filters.groups)
            keys = Object.keys(model.filters.groups).concat(keys);

        if(!model.filterAttributes)
            model.filterAttributes = {};

        for(let i = 0; i < keys.length; i++) {
            let key = keys[i];
            model.filterAttributes[key] = {
                filterTitle: {
                    class: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'class', 'mpt-filter-title'),
                    style: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'style', 'mpt-filter-title')
                },
                filterTitleText: {
                    class: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'class', 'mpt-filter-title-text'),
                    style: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'style', 'mpt-filter-title-text')
                },
                filterArrow: {
                    class: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'class', 'mpt-filter-arrow'),
                    style: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'style', 'mpt-filter-arrow')
                },
                filterContent: {
                    class: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'class', 'mpt-filter-content'),
                    style: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'style', 'mpt-filter-content')
                },
                filterContentBody: {
                    class: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'class', 'mpt-filter-content-body'),
                    style: MPTMobileStoreFilters.initMobileFilterAttribute(model, key, 'style', 'mpt-filter-content-body')
                }
            };
        }
    }

    static initMobileFilterAttribute(model, filterName, attr, elemType)
    {
        let hasFiltersApplied = (model && model.filtersApplied && model.filtersApplied.map(x => x.filterTitle).includes(filterName));
        let thisFilterActive = (model && model.openMobileFilterName && model.openMobileFilterName === filterName);

        if(thisFilterActive)
        {
            switch(elemType)
            {
                case 'mpt-filter-title':
                    if(attr === 'class')
                        return 'mpt-filter-title mpt-row' + (hasFiltersApplied ? ' mpt-filters-applied' : '');
                    else if(attr === 'style')
                        return '';
                    break;
                case 'mpt-filter-title-text':
                    if(attr === 'class')
                        return 'mpt-filter-title-text mpt-col-11 mpt-filter-title-text-open';
                    else if(attr === 'style')
                        return '';
                    break;
                case 'mpt-filter-arrow':
                    if(attr === 'class')
                        return 'fa fa-angle-down mpt-filter-arrow fa-rotate-180';
                    else if(attr === 'style')
                        return '';
                    break;
                case 'mpt-filter-content':
                    if(attr === 'class')
                        return 'mpt-filter-content mpt-filter-content-open';
                    else if(attr === 'style')
                        return '';
                    break;
                case 'mpt-filter-content-body':
                    if(attr === 'class')
                        return 'mpt-filter-content-body mpt-filter-content-body-open';
                    else if(attr === 'style')
                        return '';
                    break;
                default:
                    return '';
            }
        }
        else
        {
            switch(elemType)
            {
                case 'mpt-filter-title':
                    if(attr === 'class')
                        return 'mpt-filter-title mpt-row' + (hasFiltersApplied ? ' mpt-filters-applied' : '');
                    else if(attr === 'style')
                        return '';
                    break;
                case 'mpt-filter-title-text':
                    if(attr === 'class')
                        return 'mpt-filter-title-text mpt-col-11';
                    else if(attr === 'style')
                        return '';
                    break;
                case 'mpt-filter-arrow':
                    if(attr === 'class')
                        return 'fa fa-angle-down mpt-filter-arrow';
                    else if(attr === 'style')
                        return '';
                    break;
                case 'mpt-filter-content':
                    if(attr === 'class')
                        return 'mpt-filter-content';
                    else if(attr === 'style')
                        return 'height: 26px;';
                    break;
                case 'mpt-filter-content-body':
                    if(attr === 'class')
                        return 'mpt-filter-content-body';
                    else if(attr === 'style')
                        return 'height:26px';
                    break;
                default:
                    return '';
            }
        }
    }

}


class MPTServerSideSearchBar extends MPTVueComponent
{
    constructor(model, reqOptions){
        let appendToSelector = (model.companyInfo.uiSettings.hasOwnProperty('appendSearchTo') && model.companyInfo.uiSettings.appendSearchTo) ? model.companyInfo.uiSettings.appendSearchTo : null;
        let appendToOptions = (model.companyInfo.uiSettings.hasOwnProperty('appendSearchOptions') && model.companyInfo.uiSettings.appendSearchOptions) ? model.companyInfo.uiSettings.appendSearchOptions : null;
        super('MPTServerSideSearchBar', model, reqOptions, appendToSelector, appendToOptions);

        this.model = model;
        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                changeCategory(category) {
                    console.log('Category Changed to: ');
                    console.log(category);

                    category = category || {id: null, name: 'All'};

                    if(thisApp.model.reqOptions === null) thisApp.model.reqOptions = {};
                    this.selectedCategory = category;
                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {cat: category.id});
                    thisApp.updateUrl(0);
                },
                searchKeyup(event) {
                    //TODO: autocomplete product names
                    /*let autocomp = [];

                    try {
                        autocomp = thisApp.model.summary.productNames.filter(pn => pn.toLowerCase().includes(event.target.value));
                        console.log(autocomp);
                    }catch (e) { console.error(e); }*/

                    if(event.keyCode === 13)
                    {
                        let newReqs = {
                            qry: event.target.value,
                            productIds: null, //reset these since the search qry has changed
                            rec: null,
                            pn: null,
                        };

                        thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, newReqs);
                        thisApp.updateUrl(2);
                    }
                }
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
    }

    compileSubVues(){
    }

    /*anchorTop(afterElemSelector){

        let elem = jMPT(afterElemSelector);
        let $this = jMPT(componentName);
        if(elem.length > 0)
        {

        }
    }*/
}

class MPTGroupFilters extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTGroupFilters', model, reqOptions);
        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                toggleGroup() {
                    if(thisApp.model.reqOptions === null) thisApp.model.reqOptions = {};

                    let prodIds = [];
                    jMPT('.mpt-group-checkbox:checked').each(function(){
                        let idString = jMPT(this).data('ids');

                        if(idString){
                            prodIds = [...new Set(prodIds.concat(idString.split(',')))];
                        }
                    });

                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {productIds: prodIds || []});
                    mptapi.storeVues.mptStoreProducts.vueApp.refresh();
                }
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
    }

    compileSubVues(){
    }
}

class MPTStoreProducts extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTStoreProducts', model, reqOptions);

        this.model = model;
        /*if(this.model.hasOwnProperty('products') && reqOptions === model.reqOptions)
            this.render(); else*/
        this.sendRequest(this.reqOptions);
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            name: thisApp.componentName,
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                goToProduct(prod) {
                    thisApp.model.storeScrollTop = jMPT(document).scrollTop();
                    MPTProductPage.init(thisApp.model, prod);
                    jMPT('#shopBody').fadeOut(250);
                    jMPT('MPTProductPage').fadeIn(300);
                    setTimeout(() => {jMPT(document).scrollTop(jMPT('mptproductpage .mpt-btn-link').offset().top);}, 300);
                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {viewProduct: prod.id});
                    thisApp.updateUrl(1);
                    jMPT(window).on('popstate', function(){
                        jMPT('MPTProductPage').fadeOut(250);
                        jMPT('#shopBody').fadeIn(300);
                        setTimeout(() => { jMPT(document).scrollTop(model.storeScrollTop); }, 300);
                        jMPT(window).off('popstate');
                        thisApp.model.reqOptions.viewProduct = null;
                    });
                },
                refresh(){
                    let thisVue = this;
                    let productRequest = new GetStoreProducts(null, thisApp.model.reqOptions);

                    productRequest.send().then(function(response){
                        if(response.success && response.hasOwnProperty('products')) {
                            let prodWrap = jMPT('#products-wrapper');
                            let originalHeight = null;
                            if(prodWrap.length > 0)
                                originalHeight = prodWrap[0].getBoundingClientRect().height;
                            thisVue.products = response.products;
                            thisApp.normalizeImages();
                            if(originalHeight != null)
                                jMPT('#products-wrapper').css('height', originalHeight);

                            mptapi.storeVues.mptStore.vueApp.summary.productCount = response.products.length;

                            setTimeout(function(){ thisApp.normalizeImages(); }, 750); //catch any slow loading images
                        }
                    });
                },
                loadMore()
                {
                    let thisVue = this;
                    thisApp.model.loadingMore = thisVue.loadingMore = true;
                    thisApp.model.reqOptions = thisApp.model.reqOptions || {};
                    thisApp.model.reqOptions.page = thisApp.model.page = ++this.page;

                    let productRequest = new GetStoreProducts(null, thisApp.model.reqOptions);

                    productRequest.send().then(function(response){
                        if(response.success && response.hasOwnProperty('products')) {
                            thisVue.products = thisVue.products.concat(response.products);
                            thisApp.normalizeImages();

                            setTimeout(function(){ thisApp.normalizeImages(); }, 750); //catch any slow loading images

                            thisApp.model.loadingMore = thisVue.loadingMore = false;
                        }
                    });

                }
            }
        });
        this.normalizeImages();
        this.doneLoad();
        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;

        let tasks = thisApp.model.tasks || {};
        tasks = Object.values(tasks);
        let filterRequest = new GetStoreProducts(tasks);
        filterRequest.send().then(function(response){

            if(response.success && response.hasOwnProperty('products'))
                thisApp.model.products = response.products;
            thisApp.render();
        });
    }

    normalizeImages(){
        let minHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).height(); }).get())]);
        let minWidth = Math.max.apply(null, [145, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).width(); }).get())]);
        let rightminHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).height(); }).get())]);
        let rightminWidth = Math.max.apply(null, [109, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).width(); }).get())]);

        jMPT('.card').css({ 'display': 'block', 'max-height': minHeight + 'px', 'max-width': minWidth + 'px', 'width': 'auto', 'height': 'auto' });
        jMPT('.card-img-top').css({ 'display': 'block', 'max-height': minHeight + 'px', 'max-width': minWidth + 'px', 'width': 'auto', 'height': 'auto', 'margin': 'auto' });
        jMPT('.card-img-right').css({ 'display': 'block', 'max-height': rightminHeight + 'px', 'max-width': rightminWidth + 'px', 'width': 'auto', 'height': 'auto', 'margin': 'auto' });
    }

    runMiddleware(){
        console.log('CURRENT TEST filter model:');
        console.log(this.model);

        let selectedRecurrence = this.model.selectedRecurrence;
        let formatted = 0;

        this.model.products = this.model.products.map(function(p){

            switch (selectedRecurrence.name) {
                case "weekly":
                    formatted = parseFloat(p.weeklyPrice);
                    break;
                case "null":
                    formatted = parseFloat(p.price);
                    break;
                default:
                    formatted = parseFloat(p.price);
            }

            p.activePrice = formatted.toFixed(2);
            return p;
        });
    }

    compileSubVues(){
    }
}


class MPTFeaturedProducts extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTFeaturedProducts', model, reqOptions);

        this.model = model || {};
        this.sendRequest();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            name: thisApp.componentName,
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                handleProductClick(prod) {
                    if(hasCustomFeaturedProductRoute())
                    {
                        _mptCustomFeaturedProductScript();
                    }
                    else {
                        window.location.href='/order/?viewProduct=' + prod.id;
                    }
                }
            }
        });
        //this.normalizeImages();
        this.doneLoad();
        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;

        let featuredProdReq = new GetFeaturedProducts();
        featuredProdReq.send().then(() => {
            let response = featuredProdReq.response;
            if(response.success && response.hasOwnProperty('products'))
                thisApp.model.products = response.products;
            thisApp.render();
        });
    }

    normalizeImages(){
        let minHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).height(); }).get())]);
        let minWidth = Math.max.apply(null, [145, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).width(); }).get())]);
        let rightminHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).height(); }).get())]);
        let rightminWidth = Math.max.apply(null, [109, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).width(); }).get())]);

        jMPT('.card').css({ 'display': 'block', 'max-height': minHeight + 'px', 'max-width': minWidth + 'px', 'width': 'auto', 'height': 'auto' });
        jMPT('.card-img-top').css({ 'display': 'block', 'max-height': minHeight + 'px', 'max-width': minWidth + 'px', 'width': 'auto', 'height': 'auto', 'margin': 'auto' });
        jMPT('.card-img-right').css({ 'display': 'block', 'max-height': rightminHeight + 'px', 'max-width': rightminWidth + 'px', 'width': 'auto', 'height': 'auto', 'margin': 'auto' });
    }

    runMiddleware(){
        let thisApp = this;

        this.model.isMobile = jMPT(document).width() < 600;

        this.model.products = this.model.products.map(function(p){
            p.activePrice = parseFloat(p.price || p.weeklyPrice || "0");

            if(thisApp.isMobile && p.images.length > 0 && p.images[0].length > 2)
                p.activeImageUrl = p.images[0][2].url;
            else{
                try {
                    p.activeImageUrl = p.images[0][1].url;
                }catch{
                    p.activeImageUrl = 'https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg';
                }
            }

            return p;
        });


        this.model.moreOptionsText = "Get Started";
    }

    compileSubVues(){
    }
}

class MPTProductPage extends MPTVueComponent
{
    constructor(model, reqOptions, parentOverride){
        super('MPTProductPage', model, reqOptions);

        this.parentOverride = parentOverride;
        this.model = model;
        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                backToStore(){
                    jMPT('MPTProductPage').fadeOut(250);
                    jMPT('#shopBody').fadeIn(300);
                    setTimeout(() => { jMPT(document).scrollTop(thisApp.model.storeScrollTop); }, 300);
                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions  || {}, {viewProduct: null});
                    thisApp.updateUrl(1);
                },
                addProductToDelivery(){
                    let addRequest = new AddProductToDelivery(thisApp.model.updateProductId, thisApp.model.updateQty || 1, thisApp.model.updateSelectedVariations, thisApp.model.updateProductName, 0, thisApp.model.updateRecurrence, thisApp.model.updatePackageId); //TODO: packageId
                    addRequest.send().then(addResponse => {
                        mptapi.cartDropdown.getCart(false, addResponse);
                        jMPT('.mpt-cart-icon').addTimedClass("shake");

                        //TODO: update current page -> tag products on store page and add to product pages

                        jMPT.createNotification("Success!", "Product added!");
                    });

                    console.warn(addRequest);
                }
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let firstProduct = null;

        if(this.model.products && this.model.length > 0)
        {
            firstProduct = this.model.products[0];
        }

        MPTProductPage.init(this.model, firstProduct);
    }

    compileSubVues(){
        let thisApp = this;

        let parentName = thisApp.parentOverride || 'storeVues';

        mptapi[parentName].mptProductVariations = [];
        mptapi[parentName].mptProductVariations.push(new MPTProductVariations(thisApp.model, thisApp.reqOptions, thisApp.model.updateVariations, null));
    }

    static init(model, prod)
    {
        prod = prod || null;

        if(prod !== null) {
            model.updateProductId = prod.id;
            model.updateName = prod.name;
            model.updateDescription = prod.description;
            model.updateImages = prod.images;
            model.updateRecordId = null;
            model.updateQty = 1;
            model.updateRecurrence = 'weekly';//TODO: current recurrence
            model.updatePackageId = null;// TODO: current packageId
            model.updateVariations = prod.variations;
            model.updateVariations = MPTProductVariations.traverseVariations(model.updateVariations, false, model.updateProductId);
            model.updateSelectedVariations = [];
            model.updateInDelivery = [];

        }
        else
        {
            model.updateProductId = null;
            model.updateName = null;
            model.updateDescription = null;
            model.updateImages = [
                [{
                url: 'https://www.mealpreptech.com/images/logo2.png',
                size: 'full'
                }]
            ];
            model.updateRecordId = null;
            model.updateQty = 1;
            model.updateRecurrence = null;
            model.updatePackageId = null;
            model.updateVariations = [{
                id: "blank",
                multiselect: false,
                name: "Size",
                options: [{
                    id: 'blank',
                    text: 'blank',
                    value: 0,
                    sku: 'SKU',
                    category: 'blank',
                    description: 'blank',
                    price: 0,
                    default: false,
                    variations: null,
                    associations: []
                }],
                sku: 'SKU',
                type: 'drop-down',
                variations: null
            }];
            model.updateSelectedVariations = [];
            model.updateInDelivery = [];
        }
    }
}

class MPTProductVariations extends MPTVueComponent
{
    constructor(model, reqOptions, variationList, parentId){ //parentId indicates if this is the base variation layer or a nested variation
        parentId = parentId || null;
        variationList = variationList || null;
        if(parentId == null) { //base layer
            super('MPTProductVariations', model, reqOptions);
            this.model = model;
            this.model.updateVariations = variationList = MPTProductVariations.traverseVariations(variationList, false, this.model.updateProductId);
        }
        else //nested layer
        {
            super('MPTSubVariations', model, reqOptions);
            this.model = model;
        }

        this.parentId = parentId;
        this.variations = variationList;

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        if(this.parentId == null) { //base layer
            this.vueApp = new Vue({
                el: thisApp.componentName,
                data: thisApp.model,
                methods: {
                    changeVariationSelections(){
                        let thisVue = this;
                        thisVue.updateSelectedVariations = [];
                        jMPT('.variation-selection').each(function() {
                            let thisVariation = jMPT(this);
                            let selectedVar = {
                                id: thisVariation.data('variation-id'),
                                options: [ thisVariation.val() ]
                            };
                            thisVue.updateSelectedVariations.push(selectedVar);
                        });
                        //TODO: multiselect
                    }
                }
            });

            this.doneLoad();
            console.warn('COMPILING BASE SUBS')
            console.warn(thisApp.model.updateVariations);

            let subVariation = null;
            for(let i = 0; i < thisApp.model.updateVariations.length; i++) {
                subVariation = thisApp.model.updateVariations[i];
                this.compileSubvariationVue(subVariation);
            }
        }
        else//nested layer
        {
            let elementSelector = thisApp.componentName + (thisApp.parentId !== null ? "[data-parentid='" + thisApp.parentId + "']" : "");

            let subVariation = MPTProductVariations.findVariation(thisApp.parentId, thisApp.model);

            this.vueApp = new Vue({
                el: elementSelector,
                data: subVariation.variations,
                methods: {}
            });

            console.warn('COMPILING SUBS')
            console.warn(subVariation);

            this.compileSubvariationVue(subVariation);
        }
    }


    runMiddleware(){
    }

    compileSubVues(){
    }

    compileSubvariationVue(subVariation)
    {
        if (subVariation.hasOwnProperty('variations') && subVariation.variations !== null && subVariation.variations.length > 0) {
            console.warn('Has subs: ');
            console.warn(subVariation);
            mptapi.storeVues.mptProductVariations.push(new MPTProductVariations(thisApp.model, thisApp.reqOptions, subVariation.variations, subVariation.id));
        }

        if (subVariation.hasOwnProperty('options') && subVariation.options !== null && subVariation.options.length > 0) {
            subVariation.options.map(function (o) {
                if (o.hasOwnProperty('variations') && o.variations !== null && o.variations.length > 0) {
                    console.warn('Has subs: ');
                    console.warn(subVariation);
                    mptapi.storeVues.mptProductVariations.push(new MPTProductVariations(thisApp.model, thisApp.reqOptions, o.variations, o.id));
                }
            });
        }
    }

    static traverseVariations(variations, isNested, productId){
        let result = variations.map(function(v) {
            v.isNested = isNested;
            v.productId = productId;

            if (v.hasOwnProperty('variations') && v.variations !== null && v.variations.length > 0)
                v.variations = MPTProductVariations.traverseVariations(v.variations, true, productId);

            if (v.hasOwnProperty('options') && v.options !== null && v.options.length > 0) {
                v.options.map(function(o){
                    if (o.hasOwnProperty('variations') && o.variations !== null && o.variations.length > 0)
                        o.variations = MPTProductVariations.traverseVariations(o.variations, true, productId);
                });
            }

            return v;
        });

        return result;
    }

    static findVariation(variationId, variationList) {
        let filtered = variationList.filter(v => v.id === variationId);
        if (filtered.length > 0)
            return filtered[0];
        else {
            let nextList = [];
            variationList.map(function (v) { //get next level
                if (v.hasOwnProperty('variations') && v.variations !== null && v.variations.length > 0) {
                    for (var i = 0; i < v.variations.length; i++) {
                        let child = v.variations[i];
                        nextList.push(child);
                    }
                }
                if (v.hasOwnProperty('options') && v.options !== null && v.options.length > 0) {
                    v.options.map(function (o) {
                        if (o.hasOwnProperty('variations') && o.variations !== null && o.variations.length > 0) {
                            for (var i = 0; i < o.variations.length; i++) {
                                let child = o.variations[i];
                                nextList.push(child);
                            }
                        }
                    });
                }
            });

            if (nextList.length > 0)
                return MPTProductVariations.findVariation(variationId, nextList);
            else return null;
        }
    }
}


class MPTBottomCheckoutBar extends MPTVueComponent
{
    constructor(model, reqOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        super('MPTBottomCheckoutBar', model, reqOptions);

        this.render();

    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                updateCart(cartModel)
                {
                    let thisVue = this;
                    let keys = Object.keys(thisVue.$data);

                    //clone model sent in case it is the reference to the master cart
                    let clonedCart = new MPTCartModel(cartModel);

                    for(let i = 0; i < keys.length; i++)
                    {
                        thisApp.model[keys[i]] = clonedCart[keys[i]];
                        thisVue[keys[i]] = clonedCart[keys[i]];
                    }

                    let productCount = 0;

                    productCount = (clonedCart) ? (clonedCart.deliveries ? clonedCart.deliveries.sum(d => d.products ? d.products.sum(p => p.qty) : 0) : 0) : 0;

                    thisApp.model.productCount = productCount;
                    thisVue.productCount = productCount;
                }
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    sendRequest(){
    }

    runMiddleware(){
        let thisApp = this;
        thisApp.model.productCount = (thisApp.model) ? ((thisApp.model.deliveries) ? thisApp.model.deliveries.sum(d => d.products.sum(p => p.qty)) : 0) : 0;
    }

    compileSubVues() {
    }
}



function getTextOverride(label) {
    if (mptapi.companyInfo.hasOwnProperty("uiSettings") && mptapi.companyInfo.uiSettings.textOverrides != null) {
        if (mptapi.companyInfo.uiSettings.textOverrides[label]) {
            return mptapi.companyInfo.uiSettings.textOverrides[label];
        } else {
            return null;
        }
    } else {
        return null;
    }
}


class MPTCartModel {
    constructor(sourceCart)
    {
        if(typeof sourceCart === "object")
        {
            let keys = Object.keys(sourceCart );

            for(let i = 0; i < keys.length; i++) {
                let keyType = typeof sourceCart[keys[i]];
                if (keys[i] === "deliveries")
                    if(sourceCart.deliveries.length > 0)
                        this.deliveries = sourceCart.deliveries.map(d => {
                            return new MPTDeliveryModel(d)
                        });
                    else this.deliveries = [];
                else if(keyType === "string" || keyType === "number" || keyType === "boolean")
                    this[keys[i]] = sourceCart[keys[i]];
                else{
                    //TODO: copy other types
                }
            }
        }else {
            //TODO: default cart model
        }
    }
}

class MPTDeliveryModel
{
    constructor(sourceDel)
    {
        if(typeof sourceDel === "object")
        {
            let keys = Object.keys(sourceDel);

            for(let i = 0; i < keys.length; i++) {
                let keyType = typeof sourceDel[keys[i]];
                if (keys[i] === "products")
                    if (sourceDel.products.length > 0)
                        this.products = sourceDel.products.map(dp => {
                            return new MPTDeliveryProductModel(dp)
                        });
                    else this.products = [];
                else if (keyType === "string" || keyType === "number" || keyType === "boolean")
                    this[keys[i]] = sourceDel[keys[i]];
                else {
                    //TODO: copy other types
                }
            }
        }
        else
        {
            //TODO: default delivery model
        }
    }
}

class MPTDeliveryProductModel
{
    constructor(sourceDP) {
        if(typeof sourceDP === "object") {
            let keys = Object.keys(sourceDP);

            for (let i = 0; i < keys.length; i++) {
                let keyType = typeof sourceDP[keys[i]];
                if (keyType === "string" || keyType === "number" || keyType === "boolean")
                    this[keys[i]] = sourceDP[keys[i]];
                else {
                    //TODO: copy other types
                }
            }
        }
        else
        {
            //TODO: default product model
        }

    }
}


class MPTStepperProduct extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('MPTStepperProduct', model, reqOptions);

        if(this.model !== null)
            this.render();
        else this.sendRequest(this.reqOptions);
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                clickMainOption(optionId, optionType) {
                    let thisVue = this;
                    let list = null;

                    if(optionType) optionType = optionType.toLowerCase(); else optionType = 'protein';

                    switch(optionType)
                    {
                        case 'veg':
                            list = thisVue.vegOptions;
                            break;
                        case 'carb':
                            list = thisVue.carbOptions;
                            break;
                        default: //protein
                            optionType = 'protein';
                            list = thisVue.proteinOptions;
                            break;
                    }

                    for (let i = 0; i < list.length; i++) {
                        let thisOpt = list[i];
                        thisOpt.selected = thisOpt.id === optionId;
                        let indicatorElem = jMPT('.' + optionType + '-option[data-optionid="' + thisOpt.id + '"] i');
                        if (thisOpt.selected)
                            indicatorElem.slideDown();
                        else indicatorElem.hide();
                    }
                },
                tryLoadMeal() {
                    let thisVue = this;

                    if(1 <= thisVue.mealNumber && thisVue.mealNumber <= thisVue.selections.length)
                    {
                        let currentMeal = null;

                        try{
                            currentMeal = thisVue.selections[thisVue.mealNumber - 1];
                            for (let i = 0; i < currentMeal.variations.length; i++) {
                                let thisVar = currentMeal.variations[i];
                                if (thisVar.id === thisVue.proteinVariationId)
                                    thisVue.clickMainOption(thisVar.options[0].id, 'protein');
                                else if (thisVar.id === thisVue.carbVariationId)
                                    thisVue.clickMainOption(thisVar.options[0].id, 'carb');
                                else if (thisVar.id === thisVue.vegVariationId)
                                    thisVue.clickMainOption(thisVar.options[0].id, 'veg');
                            }
                        }
                        catch{ currentMeal = null; }
                    }
                },
                nextMeal() {
                    let thisVue = this;
                    thisVue.isValid = true;
                    jMPT('.option-group-container').removeClass('option-group-error').resetError();
                    let proteinOpt = thisVue.proteinOptions.filter(o => o.selected);//validate protein options
                    if (proteinOpt.length !== 1) {
                        jMPT('.option-group-1-container').addClass('option-group-error').generateError('Please select 1 protein.', false);
                        thisVue.isValid = false;
                    }

                    let carbOpt = thisVue.carbOptions.filter(o => o.selected);//validate protein options
                    if (carbOpt.length !== 1) {
                        jMPT('.option-group-2-container').addClass('option-group-error').generateError('Please select 1 carb.', false);
                        thisVue.isValid = false;
                    }

                    let vegOpt = thisVue.vegOptions.filter(o => o.selected);//validate protein options
                    if (vegOpt.length !== 1) {
                        jMPT('.option-group-3-container').addClass('option-group-error').generateError('Please select 1 veggie.', false);
                        thisVue.isValid = false;
                    }

                    if (thisVue.isValid) {
                        let selectedVariations = [
                            {id: thisVue.proteinVariationId, options: proteinOpt},
                            {id: thisVue.carbVariationId, options: carbOpt},
                            {id: thisVue.vegVariationId, options: vegOpt}
                        ];

                        let meal = {
                            productId: thisVue.reqOptions.productId,
                            qty: 1,
                            variations: selectedVariations,
                            recurrence: thisVue.reqOptions.recurrence || null,
                            packageId: thisVue.reqOptions.packageId || null,
                        };
                        if (thisVue.mealNumber > thisVue.selections.length)
                            thisVue.selections.push(meal);
                        else thisVue.selections[thisVue.mealNumber - 1] = meal;

                        if (thisVue.mealNumber < thisVue.totalMeals) {
                            thisVue.mealNumber++;

                            jMPT('.mpt-custom-meal-container').animate({opacity: 0}, 500);
                            thisVue.resetMeal();

                            setTimeout(function () {
                                thisVue.tryLoadMeal();
                                jMPT('.mpt-custom-meal-container').animate({opacity: 1}, 500);
                            }, 475);
                        }
                    }
                },
                prevMeal() {
                    let thisVue = this;
                    if (thisVue.mealNumber > 1) {
                        thisVue.mealNumber--;
                        let currentMeal = null;

                        try{ currentMeal = thisVue.selections[thisVue.mealNumber - 1];}
                        catch{ currentMeal = null; }

                        jMPT('.mpt-custom-meal-container').animate({opacity: 0}, 500);
                        thisVue.resetMeal();

                        setTimeout(function () {
                            thisVue.tryLoadMeal();
                            jMPT('.mpt-custom-meal-container').animate({opacity: 1}, 500);
                        }, 475);
                    }
                },
                resetMeal() {
                    let thisVue = this;

                    jMPT('.protein-option i').hide();
                    jMPT('.carb-option i').hide();
                    jMPT('.veg-option i').hide();

                    jMPT('.option-group-container').removeClass('option-group-error').resetError();

                    for (let i = 0; i < thisVue.proteinOptions.length; i++)
                        thisVue.proteinOptions[i].selected = false;

                    for (let i = 0; i < thisVue.carbOptions.length; i++)
                        thisVue.carbOptions[i].selected = false;

                    for (let i = 0; i < thisVue.vegOptions.length; i++)
                        thisVue.vegOptions[i].selected = false;

                    if(thisVue.mealNumber <= 1)
                        jMPT('.prev-meal-button').attr('disabled', true).hide();
                    else jMPT('.prev-meal-button').removeAttr('disabled').show();

                    if(thisVue.mealNumber >= thisVue.totalMeals) {
                        jMPT('.next-meal-button').attr('disabled', true).hide();
                        jMPT('.add-all-custom-meals-btn').attr('disabled', false).show();
                    }
                    else{
                        jMPT('.next-meal-button').removeAttr('disabled').show();
                        jMPT('.add-all-custom-meals-btn').attr('disabled', true).hide();
                    }
                },
                addToCart() {
                    let thisVue = this;
                    thisVue.nextMeal(); //validates selections and saves last meal choice
                    if(thisVue.isValid) {
                        thisApp.completeAddRequestCount = 0;

                        let recurrence = thisApp.reqOptions.recurrence || null;

                        if (recurrence === 'null')
                            recurrence = null;

                        for (let i = 0; i < thisVue.selections.length; i++) {
                            let productId = thisVue.selections[i].productId;
                            let variations = thisVue.selections[i].variations.map(v => {
                                return {
                                    id: v.id,
                                    options: v.options.map(o => o.id)
                                }
                            });
                            let packageId = thisVue.selections[i].packageId;

                            let req = new AddProductToDelivery(productId, 1, variations, null, null, recurrence, packageId);
                            req.send().then(res => {
                                thisApp.completeAddRequestCount++;
                                thisVue.ifDone(res);
                            });
                        }
                    }
                },
                ifDone(res)
                {
                    let thisVue = this;
                    console.log(thisApp.completeAddRequestCount + ' REQS COMPLETE');
                    if(thisApp.completeAddRequestCount === thisVue.selections.length)
                    {
                        console.log('ALL REQUESTS RETURNED, REFRESHING CART...');
                        mptapi.cartDropdown.getCart(false, res);
                        jMPT('.mpt-cart-icon').addTimedClass("shake");
                    }
                }
            }
        });

        this.doneLoad();

        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;

        let productRequest = new GetProduct(this.reqOptions.productId);
        productRequest.send().then(function(response){
            thisApp.model = Object.assign((thisApp.model || {}), response);
            thisApp.render();
        });
    }

    runMiddleware(){
        let proteinVariationName = 'Protein';
        let carbVariationName = 'Carb';
        let vegVariationName = 'Veg';

        this.model.isMobile = jMPT(document).width() < 600;
        this.model.reqOptions = this.reqOptions;
        this.model.mealNumber = 1;

        try { this.model.totalMeals = parseInt(this.reqOptions.totalMeals.toString()); }
        catch { this.model.totalMeals = 6; }

        /*if(!(this.model.totalMeals === 6 || this.model.totalMeals === 8 || this.model.totalMeals === 10))
        {
            this.model.totalMeals = 6;
        }*/

        if (this.model.products && this.model.products.length > 0 && this.model.products[0].variations && this.model.products[0].variations.length > 0)
        {
            this.model.productName = this.model.products[0].name;

            let productVariations = this.model.products[0].variations;
            let protOpt = productVariations.filter(v => v.name === proteinVariationName);
            if(protOpt.length > 0) {
                this.model.proteinOptions = protOpt[0].options;
                this.model.proteinVariationId = protOpt[0].id;
            } else {
                this.model.proteinOptions = [];
                this.model.proteinVariationId = null;
            }

            let carbOpt = productVariations.filter(v => v.name === carbVariationName);
            if(carbOpt.length > 0) {
                this.model.carbOptions = carbOpt[0].options;
                this.model.carbVariationId = carbOpt[0].id;
            } else {
                this.model.carbOptions = [];
                this.model.carbVariationId = null;
            }

            let vegOpt = productVariations.filter(v => v.name === vegVariationName);
            if(vegOpt.length > 0){
                this.model.vegOptions = vegOpt[0].options;
                this.model.vegVariationId = vegOpt[0].id;
            } else {
                this.model.vegOptions = [];
                this.model.vegVariationId = null;
            }

            this.model.otherVariations = productVariations.filter(v => !(v.name === proteinVariationName || v.name === carbVariationName || v.name === vegVariationName));
        } else {
            this.model.proteinOptions = [];
            this.model.carbOptions = [];
            this.model.vegOptions = [];
            this.model.otherVariations = [];
        }

        this.model.selections = [];
        this.model.isValid = true;
    }

    compileSubVues() {

    }
}

/* //MOVE TO SITE SPECIFIC CUSTOM PRODUCT CLASS
class MPTCustomProduct extends MPTVueComponent
{
    constructor(model, reqOptions){

        reqOptions = reqOptions || locationParamsToJSON(window.location) || {};

        //reqOptions.packageId = reqOptions.packageId || mptapi.router.data.packageId || null;
        reqOptions.packageId = null; //remember the custom products themselves are packageless, it's just the prerouter that is in the package
        reqOptions.recurrence = reqOptions.recurrence || null;

        super('MPTCustomProduct', model, reqOptions);

        this.completeAddRequestCount = 0;

        if(this.model !== null)
            this.render();
        else this.sendRequest(this.reqOptions);
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                clickMainOption(optionId, optionType) {
                    let thisVue = this;
                    let list = null;

                    if(optionType) optionType = optionType.toLowerCase(); else optionType = 'protein';

                    switch(optionType)
                    {
                        case 'veg':
                            list = thisVue.vegOptions;
                            break;
                        case 'carb':
                            list = thisVue.carbOptions;
                            break;
                        default: //protein
                            optionType = 'protein';
                            list = thisVue.proteinOptions;
                            break;
                    }

                    for (let i = 0; i < list.length; i++) {
                        let thisOpt = list[i];
                        thisOpt.selected = thisOpt.id === optionId;
                        let indicatorElem = jMPT('.' + optionType + '-option[data-optionid="' + thisOpt.id + '"] i');
                        if (thisOpt.selected) {
                            indicatorElem.slideDown();
                            let subVariation = thisVue.otherVariations.filter(x => x.parentOption === thisOpt.id);
                            if(subVariation.length > 0) {
                                thisVue[optionType + 'SubVariation'] = subVariation[0];
                            }
                        }
                        else indicatorElem.hide();
                    }
                },
                tryLoadMeal() {
                    let thisVue = this;

                    if(1 <= thisVue.mealNumber && thisVue.mealNumber <= thisVue.selections.length)
                    {
                        let currentMeal = null;

                        try{
                            currentMeal = thisVue.selections[thisVue.mealNumber - 1];
                            for (let i = 0; i < currentMeal.variations.length; i++) {
                                let thisVar = currentMeal.variations[i];
                                if (thisVar.id === thisVue.proteinVariationId)
                                    thisVue.clickMainOption(thisVar.options[0].id, 'protein');
                                else if (thisVar.id === thisVue.carbVariationId)
                                    thisVue.clickMainOption(thisVar.options[0].id, 'carb');
                                else if (thisVar.id === thisVue.vegVariationId)
                                    thisVue.clickMainOption(thisVar.options[0].id, 'veg');
                            }

                            for (let i = 0; i < currentMeal.variations.length; i++) {
                                let thisVar = currentMeal.variations[i];
                                if (thisVue.proteinSubVariation && thisVar.id === thisVue.proteinSubVariation.id) {
                                    console.warn('PROTEIN SUB FOUND');
                                    jMPT('.protein-subvariation .mpt-variation-switch').click();
                                }
                                else if (thisVue.carbSubVariation && thisVar.id === thisVue.carbSubVariation.id) {
                                    console.warn('CARB SUB FOUND');
                                    jMPT('.carb-subvariation .mpt-variation-switch').click();
                                }
                                else if (thisVue.vegSubVariation && thisVar.id === thisVue.vegSubVariation.id) {
                                    console.warn('VEG SUB FOUND');
                                    jMPT('.veg-subvariation .mpt-variation-switch').click();
                                }
                            }
                            //main options set, iterate sub options
                        }
                        catch{ currentMeal = null; }
                    }
                },
                nextMeal() {
                    let thisVue = this;
                    thisVue.isValid = true;
                    jMPT('.option-group-container').removeClass('option-group-error').resetError();
                    let proteinOpt = thisVue.proteinOptions.filter(o => o.selected);//validate protein options
                    if (proteinOpt.length !== 1) {
                        jMPT('.option-group-1-container').addClass('option-group-error').generateError('Please select 1 protein.', false);
                        thisVue.isValid = false;
                    }

                    let carbOpt = thisVue.carbOptions.filter(o => o.selected);//validate protein options
                    if (carbOpt.length !== 1) {
                        jMPT('.option-group-2-container').addClass('option-group-error').generateError('Please select 1 carb.', false);
                        thisVue.isValid = false;
                    }

                    let vegOpt = thisVue.vegOptions.filter(o => o.selected);//validate protein options
                    if (vegOpt.length !== 1) {
                        jMPT('.option-group-3-container').addClass('option-group-error').generateError('Please select 1 veggie.', false);
                        thisVue.isValid = false;
                    }

                    if (thisVue.isValid) {
                        let selectedVariations = [
                            {id: thisVue.proteinVariationId, options: proteinOpt},
                            {id: thisVue.carbVariationId, options: carbOpt},
                            {id: thisVue.vegVariationId, options: vegOpt}
                        ];


                        let proteinSubVar = jMPT('.protein-subvariation .mpt-variation-switch input');
                        if(proteinSubVar.is(':checked'))
                        {
                            let pSVarId = proteinSubVar.attr('data-variationid');//NOTICE: DO NOT USE .data()
                            let pSOptId = proteinSubVar.val();
                            if(pSVarId  && pSOptId)
                                selectedVariations.push({ id: pSVarId, options: [ {id: pSOptId }]});
                        }

                        let carbSubVar = jMPT('.carb-subvariation .mpt-variation-switch input');
                        if(carbSubVar.is(':checked'))
                        {
                            let cSVarId = carbSubVar.attr('data-variationid');//NOTICE: DO NOT USE .data()
                            let cSOptId = carbSubVar.val();
                            if(cSVarId && cSOptId)
                                selectedVariations.push({ id: cSVarId, options: [ {id: cSOptId }]});
                        }

                        let vegSubVar = jMPT('.veg-subvariation .mpt-variation-switch input');
                        if(vegSubVar.is(':checked'))
                        {
                            let vSVarId = vegSubVar.attr('data-variationid');//NOTICE: DO NOT USE .data()
                            let vSOptId = vegSubVar.val();
                            if(vSVarId && vSOptId)
                                selectedVariations.push({ id: vSVarId, options: [ {id: vSOptId }]});
                        }

                        let meal = {
                            productId: thisVue.reqOptions.productId,
                            qty: 1,
                            variations: selectedVariations,
                            recurrence: thisVue.reqOptions.recurrence || null,
                            packageId: thisVue.reqOptions.packageId || null,
                        };
                        if (thisVue.mealNumber > thisVue.selections.length)
                            thisVue.selections.push(meal);
                        else thisVue.selections[thisVue.mealNumber - 1] = meal;

                        if (thisVue.mealNumber < thisVue.totalMeals) {
                            thisVue.mealNumber++;

                            jMPT('.mpt-custom-meal-container').animate({opacity: 0}, 500);
                            thisVue.resetMeal();

                            setTimeout(function () {
                                thisVue.tryLoadMeal();
                                jMPT('.mpt-custom-meal-container').animate({opacity: 1}, 500);
                            }, 475);
                        }
                    }
                },
                prevMeal() {
                    let thisVue = this;
                    if (thisVue.mealNumber > 1) {
                        thisVue.mealNumber--;
                        let currentMeal = null;

                        try{ currentMeal = thisVue.selections[thisVue.mealNumber - 1];}
                        catch{ currentMeal = null; }

                        jMPT('.mpt-custom-meal-container').animate({opacity: 0}, 500);
                        thisVue.resetMeal();

                        setTimeout(function () {
                            thisVue.tryLoadMeal();
                            jMPT('.mpt-custom-meal-container').animate({opacity: 1}, 500);
                        }, 475);
                    }
                },
                resetMeal() {
                    let thisVue = this;

                    jMPT('.protein-option i').hide();
                    jMPT('.carb-option i').hide();
                    jMPT('.veg-option i').hide();

                    jMPT('.mpt-variation-switch :checked').click();
                    thisVue.proteinSubVariation = null;
                    thisVue.carbSubVariation = null;
                    thisVue.vegSubVariation = null;

                    jMPT('.option-group-container').removeClass('option-group-error').resetError();

                    for (let i = 0; i < thisVue.proteinOptions.length; i++)
                        thisVue.proteinOptions[i].selected = false;

                    for (let i = 0; i < thisVue.carbOptions.length; i++)
                        thisVue.carbOptions[i].selected = false;

                    for (let i = 0; i < thisVue.vegOptions.length; i++)
                        thisVue.vegOptions[i].selected = false;

                    if(thisVue.mealNumber <= 1)
                        jMPT('.prev-meal-button').attr('disabled', true).hide();
                    else jMPT('.prev-meal-button').removeAttr('disabled').show();

                    if(thisVue.mealNumber >= thisVue.totalMeals) {
                        jMPT('.next-meal-button').attr('disabled', true).hide();
                        jMPT('.add-all-custom-meals-btn').attr('disabled', false).show();
                    }
                    else{
                        jMPT('.next-meal-button').removeAttr('disabled').show();
                        jMPT('.add-all-custom-meals-btn').attr('disabled', true).hide();
                    }
                },
                addToCart() {
                    let thisVue = this;
                    thisVue.nextMeal(); //validates selections and saves last meal choice
                    if(thisVue.isValid) {
                        MPTUI.generateModal('#addProgressContainer', {content: {width: "30%"}}, {content: {width: "100%"}});

                        thisApp.completeAddRequestCount = 0;

                        let recurrence = thisApp.reqOptions.recurrence || null;

                        if (recurrence === 'null')
                            recurrence = null;

                        for (let i = 0; i < thisVue.selections.length; i++) {
                            let productId = thisVue.selections[i].productId;
                            let variations = thisVue.selections[i].variations.map(v => {
                                return {
                                    id: v.id,
                                    options: v.options.map(o => o.id)
                                }
                            });
                            let packageId = thisVue.selections[i].packageId;

                            let req = new AddProductToDelivery(productId, 1, variations, null, null, recurrence, packageId);
                            req.send().then(res => {
                                thisApp.completeAddRequestCount++;
                                thisVue.ifDone(res);
                            });
                        }
                    }
                },
                ifDone(res)
                {
                    let thisVue = this;

                    if(thisVue.selections.length > 1 && thisApp.completeAddRequestCount ===  thisVue.selections.length - 1)
                    {
                        jMPT('#addProgressContainer .fal').removeClass('fa-spin').removeClass('fa-spinner').addClass('fa-check-circle').removeClass('text-info').addClass('text-success');
                        jMPT('#addProgressContainer h1').show();
                        jMPT('#addProgressContainer').fadeOut(1200);
                    }

                    if(thisApp.completeAddRequestCount === thisVue.selections.length)
                    {
                        jMPT('#addProgressContainer .fal').removeClass('fa-spin').removeClass('fa-spinner').addClass('fa-check-circle').removeClass('text-info').addClass('text-success');
                        jMPT('#addProgressContainer h1').show();
                        jMPT('.mpt-cart-icon').addTimedClass("shake");
                        setTimeout(function () {
                            jMPT('#addProgressContainer').fadeOut(750, function () {
                                Custombox.modal.closeAll();
                            });
                        }, 500);
                        setTimeout(function () {
                            mptapi.router.redirect('checkout');
                        }, 750);
                    }
                }
            }
        });

        this.vueApp.resetMeal();

        this.doneLoad();

        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;

        let productRequest = new GetProduct(this.reqOptions.productId);
        productRequest.send().then(function(response){
            thisApp.model = Object.assign((thisApp.model || {}), response);
            thisApp.render();
        });
    }

    runMiddleware(){
        let proteinVariationName = 'Protein';
        let carbVariationName = 'Carb';
        let vegVariationName = 'Veg';

        this.model.isMobile = jMPT(document).width() < 600;
        this.model.reqOptions = this.reqOptions;
        this.model.mealNumber = 1;
        this.model.proteinSubVariation = null;
        this.model.carbSubVariation = null;
        this.model.vegSubVariation = null;

        try { this.model.totalMeals = parseInt(this.reqOptions.totalMeals.toString()); }
        catch { this.model.totalMeals = 6; }


        if (this.model.products && this.model.products.length > 0 && this.model.products[0].variations && this.model.products[0].variations.length > 0)
        {
            this.model.productName = this.model.products[0].name;

            let productVariations = this.model.products[0].variations;
            let protOpt = productVariations.filter(v => v.name === proteinVariationName);
            if(protOpt.length > 0) {
                this.model.proteinOptions = protOpt[0].options;
                this.model.proteinVariationId = protOpt[0].id;
            } else {
                this.model.proteinOptions = [];
                this.model.proteinVariationId = null;
            }

            let carbOpt = productVariations.filter(v => v.name === carbVariationName);
            if(carbOpt.length > 0) {
                this.model.carbOptions = carbOpt[0].options;
                this.model.carbVariationId = carbOpt[0].id;
            } else {
                this.model.carbOptions = [];
                this.model.carbVariationId = null;
            }

            let vegOpt = productVariations.filter(v => v.name === vegVariationName);
            if(vegOpt.length > 0){
                this.model.vegOptions = vegOpt[0].options;
                this.model.vegVariationId = vegOpt[0].id;
            } else {
                this.model.vegOptions = [];
                this.model.vegVariationId = null;
            }

            this.model.otherVariations = productVariations.filter(v => !(v.name === proteinVariationName || v.name === carbVariationName || v.name === vegVariationName));
        } else {
            this.model.proteinOptions = [];
            this.model.carbOptions = [];
            this.model.vegOptions = [];
            this.model.otherVariations = [];
        }

        this.model.selections = [];
        this.model.isValid = true;
    }

    compileSubVues() {

    }
}
*/


//TODO: middleware notes:
/*
need to capitalize recurrence options
*/

//TODO: modifications:
/*
changed id="activeFilters" to class="mpt-active-filters"
*/

let _v = function(){
    return mptapi.storeVues;
};

let _debugProducts = function (){
    let vueKeys = Object.keys(mptapi.storeVues);

    for(var i = 0; i < vueKeys.length; i++)
    {
        let vk = vueKeys[i];
        let vueObj = mptapi.storeVues[vk];

        console.log('Vue: ' + vk);
        try {
            if (typeof vueObj !== 'undefined') {
                console.log(vueObj.model.products);
                console.log(vueObj.vueApp.products);
            } else {
                console.warn(vueObj);
            }
        }catch(e) { console.error(e); }
    }
};

let _debugVues = function (){
    let vueKeys = Object.keys(mptapi.storeVues);

    for(var i = 0; i < vueKeys.length; i++)
    {
        let vk = vueKeys[i];
        let vueObj = mptapi.storeVues[vk];

        console.log('Vue: ' + vk);
        try {
            if (typeof vueObj !== 'undefined') {
                console.log(vueObj.vueApp);
            } else {
                console.warn(vueObj);
            }
        }catch(e) { console.error(e); }
    }
};





/*THIS COULD BE USEFUL IN CUSTOM SCRIPTS
            let parentElem = document.querySelector(appendToSelector);
            let inheritStyle = window.getComputedStyle(elem); //TODO: FIRST, CHECK IF PARENT HAS A CHILD TO INHERIT STYLE FROM, IF NOT THEN GET PARENT STYLE
            let newComponent = document.querySelector(this.componentName); //TODO: ASSIGN A CUSTOM ID TO THE ELEMENT WHEN IT'S APPENDED AND USE THAT INSTEAD
            newComponent.style.backgroundColor = inheritStyle.backgroundColor;
            */

//-------------------------------------------------------------
class FFCustomCart extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('FFCustomCart', model, reqOptions);

        if(model)
            this.model = model;
        else if(mptapi && mptapi.cart)
            this.model = {cart: mptapi.cart, currentSubtotal: FFCustomCart.getRelevantSubtotal()};
        else this.model = { cart: {}, currentSubtotal: 0 };

        this.model.isSubscription = Page.isPage("order", "#subscription");
        this.model.companyInfo = getSafeAPIValue('mptapi.companyInfo');
        this.model.cartSubscriptionStatus = null;
        this.render();
    }

    static getRelevantSubtotal(context) {
        if (context && context.totals && context.totals.length > 0) {
            let filteredTotals = context.totals.filter(lineItem => { return lineItem.name.toLowerCase().includes("subtotal") && lineItem.amount > 0}).sort((a, b) => { return a.amount - b.amount });

            if (filteredTotals.length > 0) {
                return filteredTotals[0].amount;
            }
        }

        return 0;
    }

    render() {
        let thisApp = this;
        //this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            mounted(){
                let thisVue = this;
                if (!thisVue.cart) {
                    jMPT('.ff-cart-container').hide();
                } else {
                    jMPT('.ff-cart-container').show();
                    jMPT('.ff-cart-container').css({
                        position: "fixed",
                        top: 0,
                        right: "-150vw",
                        width: (jMPT(window).width() < 500 ? '100vw' : '450px'),
                        height: "100vh",
                    });
                }

                thisVue.setCartSubscriptionStatus();
            },
            methods: {
                setCartSubscriptionStatus(){
                    let thisVue = this;
                    let deliveries = getSafeAPIValue('mptapi.cart.deliveries');
                    if(typeof(deliveries) !== 'undefined' && deliveries.length > 0 && deliveries.map(d => {return d.products;}).reduce((agg, thisProdList) => agg.concat(thisProdList)).length > 0) {
                        thisVue.cartSubscriptionStatus = deliveries.map(d => d.products).reduce((a, b) => a.concat(b)).every(p => p.recurrence !== null) ? 'weekly' : 'single-order';
                    } else {
                        thisVue.cartSubscriptionStatus = 'empty';
                    }
                    thisVue.companyInfo = getSafeAPIValue('mptapi.companyInfo');
                },
                setSubscribeAll() {
                    let thisVue = this;
                    let req = new CartSubscribeAll();
                    req.send().then((ct) => {
                        mptapi.cartDropdown.getCart(false, ct);
                        thisVue.setCartSubscriptionStatus();
                    });
                },
                updateCart(newCart){
                    if(newCart) {
                        let thisVue = this;
                        thisVue.cart = newCart;
                        thisVue.currentSubtotal = FFCustomCart.getRelevantSubtotal(newCart);
                        thisVue.setCartSubscriptionStatus();
                    }
                },
                showCart(){
                    let thisVue = this;

                    thisVue.setCartSubscriptionStatus();
                    let mobileSlideOut = jMPT(window).width() < 500;
                    if(mobileSlideOut)
                    {
                        jMPT('html').css('overflow-y', 'hidden');
                        jMPT('body').addClass('mpt-no-scroll');
                    }

                    jMPT('.ff-cart-container').css('right', 0);

                    if(mobileSlideOut){
                        jMPT('.ff-cart-container').css({
                            position: "fixed",
                            top: 0,
                            width: "100vw",
                            height: "100vh",
                            paddingTop: "30px",
                        }).addClass("mobile");
                    }
                    else{
                        jMPT('.ff-cart-container').css({
                            position: "fixed",
                            top: 0,
                            width: "450px",
                            height: "100vh",
                            paddingTop: "50px"
                        }).removeClass("mobile");
                    }

                    jMPT('.mpt-cart-icon').click();
                },
                hideCart(){
                    jMPT('.ff-cart-container').css('right', '-150vw');//.removeClass("visible");
                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');
                },
                removeAllFromDelivery(recordId){
                    let req = new RemoveProductFromDelivery(recordId);
                    let effectiveDate = new Date();
                    req.send().then(response => {
                        if(response && response.success){
                            console.log('Remove Response: ', response);
                            MPTMiddleware.cartMiddleware(response, effectiveDate);
                        }
                        else{

                        }
                    });
                },
                removeDeliveryFromCart(deliveryId){
                    let thisVue = this;
                    if(deliveryId && thisVue.cart && thisVue.cart.deliveries){
                        if(thisVue.cart.deliveries.filter(delivery => delivery.id === deliveryId).length > 0)
                        {

                            let removeRequest = new RemoveDelivery(deliveryId);
                            FFCustomCart.setDeliveryDisableAll(deliveryId);

                            removeRequest.send().then(removeResponse => {
                                console.log('RemoveResponse:', removeResponse);
                                if(removeResponse && removeResponse.success)
                                {
                                    window.location.reload();
                                }
                                else {
                                    FFCustomCart.setDeliveryDisableAll(deliveryId, true);
                                }
                            }).catch((err) => {
                                console.error(err);
                                FFCustomCart.setDeliveryDisableAll(deliveryId, true); });
                        }
                    }
                },
                cartQtyUp(product){
                    try {
                        mptapi.track('add-to-cart', {productId: product.productId, productName: product.name});

                        if (pixelActive()) {
                            fbq('track', 'AddToCart', {
                                value: product.price,
                                currency: "USD",
                                "content_ids": [product.productId],
                                "content_type": "product",
                                "content_name": product.name,
                            });
                        }
                    } catch(errMessage){
                        console.error(errMessage);
                    }

                    let effectiveDate = new Date();
                    let recordId = product.id;
                    let newQty = product.qty + 1;
                    let addRequest  = new UpdateProductInDelivery(recordId, {qty: newQty});
                    addRequest.send().then(addResponse => {
                        MPTMiddleware.cartMiddleware(addResponse, effectiveDate);
                    });
                },
                cartQtyDown(product){
                    try { mptapi.track('remove-from-cart', {productId: product.productId, productName: product.name}); } catch(errMessage){ console.error(errMessage); }

                    let effectiveDate = new Date();
                    let recordId = product.id;
                    let newQty = product.qty - 1;
                    let removeRequest  = new UpdateProductInDelivery(recordId, {qty: newQty});
                    removeRequest.send().then(addResponse => {
                        MPTMiddleware.cartMiddleware(addResponse, effectiveDate);
                    });
                },
                backToShopping(navigateToOrderPage){
                    let nav = getSafeAPIValue('mptapi.ffBottomNavVue.vueApp');
                    let topNav = getSafeAPIValue('mptapi.ffTopNavVue.vueApp');

                    if(nav) {
                        nav.closeCart();
                    }
                    if(topNav) {
                        topNav.closeCart();
                    }
                    if(!nav && !topNav) {
                        let thisVue = this;
                        thisVue.hideCart();
                    }
                    if(navigateToOrderPage && !window.location.href.includes('/order'))
                    {
                        window.location.href='/order';
                    }
                },
                checkoutNav(){
                    this.backToShopping(); //this will hide the cart so it does not cover the modal in the event registration is required

                    if(MPTSession.signedIn())
                    {
                        window.location.href = '/checkout/';
                    }
                    else{
                        let register = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp');
                        if(register)
                        {
                            register.setRedirect('checkout');
                            register.showRegisterModal();
                        }
                        else window.location.href = '/checkout/'
                    }
                },
                saveSubscription(){
                    let req = new SubscriptionCommit(mptapi.router.data.subId);
                    req.send().then(() => {
                        window.removeEventListener('beforeunload', handleExitSubEditor);
                        mptapi.router.redirect("user", "#subscriptions", false);
                    });
                },
                customDeliveryDisplay(delivery) {
                    if (delivery.shippingLocationType === 'pickup' && delivery.windowShort) {
                        return `${delivery.windowShort.replace('4PM - 9PM', '3:30PM - 8PM')}`;
                    } else {
                        return `${delivery.windowShort}`;
                    }
                }
            }
        });

        /*setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();*/
    }

    static setDeliveryDisableAll(deliveryId, reenable = false){
        let toggleFunction = null;

        if(deliveryId) {
            let $thisDeliveryContainer = jMPT(`.ff-delivery-container[data-deliveryid="${deliveryId}"`);

            if($thisDeliveryContainer.length > 0) {
                if (!reenable) {
                    $thisDeliveryContainer.find('.ff-remove-delivery-icon').removeClass('fa-times-circle').addClass('fa-spinner fa-spin');
                    toggleFunction = function (thisElem) {
                        let $thisElem = jMPT(thisElem);
                        $thisElem .addClass('ff-disable').find('*').addClass('ff-disable');
                        $thisElem .find('button').attr('disabled', true);
                    };
                    setTimeout(() => {
                        try{ $thisDeliveryContainer.slideUp(); } catch{}
                    }, 400);
                }
                else {
                    $thisDeliveryContainer.find('.ff-remove-delivery-icon').addClass('fa-times-circle').removeClass('fa-spinner fa-spin');
                    toggleFunction = function (thisElem) {
                        let $thisElem = jMPT(thisElem);
                        $thisElem .removeClass('ff-disable').find('*').removeClass('ff-disable');
                        $thisElem .find('button').removeAttr('disabled');
                        $thisDeliveryContainer.slideDown();
                    };
                }

                $thisDeliveryContainer.each((i, e) => toggleFunction(e));
            }
        }
    }

    static resetAllDisabledDeliveries(){
        jMPT('.ff-remove-delivery-icon').addClass('fa-times-circle').removeClass('fa-spinner fa-spin');
        let resetFunction = function (thisElem) {
            let $thisElem = jMPT(thisElem);
            $thisElem .removeClass('ff-disable').find('*').removeClass('ff-disable');
            $thisElem .find('button').removeAttr('disabled');
        };

        jMPT('.ff-delivery-container').show().each((i, e) => resetFunction(e));
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;

    }

    compileSubVues(){
        let thisApp = this;

    }
}

class FFCustomOrder extends MPTVueComponent
{
    constructor(model, reqOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let groupByCategory = templateOptions && templateOptions.groupAndSortProductsByCategory;

        groupByCategory = true;

        let compName = 'FFCustomOrder';
        super(compName, model, reqOptions, null, null, groupByCategory ? 'GPC' : null);

        if(groupByCategory) {
            this.model = this.model || {};
            Object.assign(this.model, {templateSuffix: 'GPC'});
        }

        this.routerDeliveryId = (this.model && this.model.deliveryId) ? this.model.deliveryId : getSafeAPIValue('cart.deliveries[0].id');
        this.routerPackageId = (this.model && this.model.packageId) ? this.model.packageId : null;

        if(this.model && this.model.products && this.model.products.length > 0) {
            this.render();
        } else {
            this.sendRequest();
        }
    }


    render(){
        this.runMiddleware();

        this.doneLoad();

        this.compileSubVues();
    }



    initAndSend(deliveryId, packageId){
        let thisApp = this;

        thisApp.init(deliveryId, packageId);

        let productRequest = new GetDeliveryShopAndTasks(deliveryId, packageId, thisApp.reqOptions);
        productRequest.send().then(shopResponse => {
            try { mptapi.track('page-view', null); } catch(errMessage){ console.error(errMessage); }
            _testResponse = shopResponse;
            thisApp.runMiddleware(shopResponse);

            jMPT('FFCustomOrder').removeClass('d-none');

            if (shopResponse.hasOwnProperty('productSummary'))
                mptapi.router.data.productCount = shopResponse.productSummary.productCount || context.products.length;

            let filterTasks = shopResponse.filters;
            if(filterTasks) {
                if(filterTasks.recurrenceTask)
                {
                    let recurrenceReq = new CheckTask(filterTasks.recurrenceTask);
                    recurrenceReq.send().then(checkTaskRes => {
                        mptapi.orderVues.mptFilterSidebar.vueApp.loadRecurrenceFilter(checkTaskRes);
                    });
                }

                if(filterTasks.categoriesTask)
                {
                    let categoryReq = new CheckTask(filterTasks.categoriesTask);
                    categoryReq.send().then(checkTaskRes => {

                        /*Cat format: {id: '', name: '', icons: [], images: []}*/
                        mptapi.orderVues.mptCategoryFilter.vueApp.load(checkTaskRes);

                    });
                }

                if(filterTasks.tagsTask)
                {
                    let tagsReq = new CheckTask(filterTasks.tagsTask);
                    tagsReq.send().then(checkTaskRes => {
                        console.warn('tags task checked...');
                        console.warn(checkTaskRes);
                        mptapi.orderVues.mptFilterSidebar.vueApp.loadTagFilter(checkTaskRes);
                    });
                }


                if(filterTasks.groupsTask)
                {
                    let groupsReq = new CheckTask(filterTasks.groupsTask);
                    groupsReq.send().then(checkTaskRes => {
                        mptapi.orderVues.mptFilterSidebar.vueApp.loadGroupFilters(checkTaskRes);
                    });
                }

                //TODO: let datesReq = ...
            }

            thisApp.vueApp.recurrenceChanged().then(() => {
                if (localStorage.getItem('showDateOption')) {
                    localStorage.removeItem('showDateOption');
                    thisApp.vueApp.changeDate();
                }
                thisApp.vueApp.updateQtys();
                thisApp.normalizeProductNameHeights();
            });
        }, rejValue => {
            let shouldReloadOrder = false;

            if (rejValue?.error && rejValue.error.length) {
                rejValue.error.forEach(error => {
                    if (error.adminMessage === 'clientCartId or authToken is required') {
                        shouldReloadOrder = true;
                    }
                });
            }

            if (shouldReloadOrder || rejValue?.responseJSON?.StackTrace.includes('V2CartResponse.savePreselectedFilters')) {
                this.autoPickDate().then(() => {
                    if (window.location.pathname.includes('/order')) {
                        location.reload();
                    } else {
                        window.location = '/order';
                    }
                });
            }
        });
    }

    autoPickDate(){
        let thisApp = this;

        //TODO: if delivery id blank then add next one to cart but flag it as temp
        let autoPickDeliveryReq = new AddNextAvailableDelivery();
        return autoPickDeliveryReq.send().then(() => {
            console.warn(autoPickDeliveryReq.response);
            thisApp.routerDeliveryId = thisApp.model.deliveryId = autoPickDeliveryReq.response.deliveryIds[0];
            thisApp.model.autoPickedDeliveryDate = true;
            thisApp.initAndSend(thisApp.routerDeliveryId, thisApp.routerPackageId);
        });
    }

    sendRequest(){
        let thisApp = this;

        if (thisApp.routerDeliveryId) { //make sure the deliveryid in router memory hasn't been removed.
            try {
                if (!getSafeAPIValue('cart.deliveries').filter(d => d.id === thisApp.routerDeliveryId).length > 0)
                    thisApp.routerDeliveryId = false;
            } catch (err) {
                console.warn(err);
                thisApp.routerDeliveryId = false;
            }
        }

        if(!thisApp.routerDeliveryId)
            thisApp.autoPickDate();
        else {
            thisApp.model.autoPickedDeliveryDate = false;
            thisApp.initAndSend(thisApp.routerDeliveryId, thisApp.routerPackageId);
        }

    }

    getDeliveryAndTasks(callback) {
        let thisApp = this;

        return new Promise(function (resolve, reject) {

            if (thisApp.routerDeliveryId) { //make sure the deliveryid in router memory hasn't been removed.
                try {
                    if (!getSafeAPIValue('cart.deliveries').filter(d => d.id === thisApp.routerDeliveryId).length > 0)
                        thisApp.routerDeliveryId = false;
                } catch (err) {
                    console.warn(err);
                    thisApp.routerDeliveryId = false;
                }
            }

            if (!thisApp.routerDeliveryId) {
                let autoPickDeliveryReq = new AddNextAvailableDelivery();
                autoPickDeliveryReq.send().then(resValue => {
                    thisApp.routerDeliveryId = thisApp.model.deliveryId = autoPickDeliveryReq.response.deliveryIds[0];
                    thisApp.model.autoPickedDeliveryDate = true;
                    return resolve(thisApp.routerDeliveryId);
                });
            }
            else {


                let data = Object.assign(MPTRequest.tokensObject(), {
                    deliveryId: thisApp.routerDeliveryId,
                    packageId: thisApp.routerPackageId,
                    ip: mptapi.ip
                });

                if (data.authToken && data.authToken.token) {
                    data.authToken.ip = mptapi.ip;
                }

                let requestData = JSON.stringify(data);

                let options = {
                    method: 'PUT',
                    url: activeURL() + "products/shoptasks",
                    data: requestData,
                    headers: {
                        "Authorization": "Basic " + getSafeAPIValue('mptapi.options.client_api_key'),
                        "Content-Type": "application/json",
                        "X-Forwarded-For": mptapi.ip
                    },
                    success: function (data) {
                        if (data.hasOwnProperty("error")) {
                            let autoPickDeliveryReq = new AddNextAvailableDelivery();
                            autoPickDeliveryReq.send().then(resValue => {
                                thisApp.routerDeliveryId = thisApp.model.deliveryId = autoPickDeliveryReq.response.deliveryIds[0];
                                thisApp.model.autoPickedDeliveryDate = true;

                                thisApp.getDeliveryAndTasks().then(resValue2 => {
                                    return resolve(resValue2);
                                }, rejValue2 => {
                                    return reject(rejValue2)
                                });
                            }, rejValue => {
                                return reject(rejValue)
                            });
                        }
                        else {
                            thisApp.model.autoPickedDeliveryDate = false;
                            if (callback && typeof callback === "function") {
                                data = callback(data);
                            }
                            return resolve(thisApp.routerDeliveryId);
                        }
                    },
                    error: function (xhr) {
                        console.error("[MPT Request] Oops! There was an error processing your request.");
                        return reject(xhr);
                    }
                };
                if (options.data === "null") {
                    delete options.data;
                }

                jQuery.ajax(options);
            }
        });
    }


    normalizeProductNameHeights(){
        let productNames = document.querySelectorAll('.product-wrapper .card-title');
        let maxHeight = Math.max.apply(Math, Array.from(productNames).map((e) =>{ return e.offsetHeight; }));
        let pNameText;
        let namePadding;

        for(let i = 0; i < productNames.length; i++)
        {
            productNames[i].style.height = `${maxHeight}px`;
            pNameText = productNames[i].querySelector('.productName');
            namePadding = (maxHeight - pNameText.offsetHeight) / 2;
            productNames[i].style.paddingTop = `${namePadding}px`;
            productNames[i].style.paddingBottom = `${namePadding}px`;
        }


    }

    init(deliveryId, packageId){ //initializes vues before model is loaded since they all need to be rendered together
        let thisApp = this;

        if(thisApp.model === null)
            thisApp.model = {};

        let mobileView = false;
        if(jMPT(document).width() < 600)
            mobileView = true;


        let subscriptionStatus = FFCustomGetStarted.cartSubscriptionStatus();

        if(subscriptionStatus === 'weekly' || (subscriptionStatus === 'empty' && getSafeAPIValue('mptapi.getStartedSelections.recurrence') === 'weekly'))
            thisApp.model.selectedRecurrence = { id: 'weekly', name: 'Weekly', icons: [], productIds: [] };

        thisApp.model = Object.assign({
            summary: { productCount: 0 },
            products: [ ],
            selectedProduct: {},
            selectedVariations:[],
            shownVariations: [],
            filterTasks: [],
            filters: {
                recurrence:[],
                tags:[],
                tagLabel: 'Filter by Tag',
                deliveryFilterLabel: 'Pre-Order Date:'
            },
            serverSideShopPage: false,
            moreOptionsText: 'View More',
            storeScrollTop: 0,
            additionalCheckoutButton: false,
            compressNutritionalLabels: true,
            selectedCategory: { id: null, name: 'All'},
            selectedRecurrence: { id: null, name: 'One-time Products', icons: [], productIds: [] },
            delivery: {},
            deliveryId: deliveryId,
            deliveryIsSelected: false,
            packageId: packageId,
            fullProductPages: false,
            showDatesInShopFilters: true,
            showLocationsInShopFilters: false,
            defaultRecurrenceOptions: ['null', 'weekly', 'biweekly', 'monthly'],
            productsByCategory: {},
            firstLoad: !(thisApp.reqOptions && thisApp.reqOptions.viewProduct),
            autoPickedDeliveryDate: false,
            previewMode: (thisApp.reqOptions && thisApp.reqOptions.previewMode) || false,
            mobileView: mobileView,
            isLoaded: false,
            searchText: null,
            filterIds: [],
            searchIds: [],
            getStartedModal: {state: 'closed', modal: null},
            getStartedLoading: false,
            getStartedDateSelectActive: false,
            getStartedTimeSelectActive: false,
            pickupLocationSelectActive: false,
            getStartedRecurrenceSelectActive: false,
            getStartedLocationTypeSelectActive: false,
            getStartedDayName: null,
            getStartedTSName: null,
            getStartedDayId: null,
            getStartedTSId: null,
            getStartedTSDateTime: null,
            selectedShippingLocationTypeName: 'Delivery',
            selectedShippingLocationName: null,
            selectedShippingLocationType: null,
            selectedShippingLocationId: null,
            getStartedEmail: null,
            getStartedRecurrenceName: 'Single Order',
            getStartedRecurrence: 'single-order',
            pickupLocationOptions: [],
            shippingLocationOptions: [],
            deliveryOptions: [{
                customDateText: null,
                date: null,
                dateShort: null,
                description: null,
                id: null,
                name: null,
                selected: false,
                set: 0,
                textOverride: null,
                timeSlots: [{
                    customTSText: null,
                    dateTime: null,
                    description: null,
                    end: null,
                    id: null,
                    selected: false,
                    start: null,
                    textOverride: null
                }]
            }],
            getStartedTimeSlotOptions: [],
            user: {
                firstName: null,
                lastName: null,
                email: null,
                hasSubscriptions: null
            },
            onGetStarted: false

        }, thisApp.model);

        if(deliveryId && mptapi.cart)
        {
            try{
                thisApp.model.delivery = mptapi.cart.deliveries.filter(d => d.id === deliveryId)[0];
            }catch(err)
            {
                console.warn('no matching delivery')
            }
        }

        thisApp.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                load(productList) {
                    let thisVue = this;
                    if (productList) {
                        thisVue.products = productList;

                        if(thisApp.reqOptions && thisApp.reqOptions.viewProduct)
                        {
                            setTimeout(function(){
                                let directNavProd = thisVue.products.filter(p => p.id === thisApp.reqOptions.viewProduct);
                                if(directNavProd.length > 0)
                                {
                                    thisVue.handleProductClick(directNavProd[0]);
                                    console.warn('auto nav to: ' + directNavProd[0].id);
                                }
                            }, 250);
                        }



                        setTimeout(function(){
                            thisVue.recurrenceChanged().then(() => {
                                thisVue.updateQtys();
                            });
                            thisApp.normalizeProductNameHeights();

                        }, 250);
                    }
                },
                recurrenceChanged(requestedRecurrence){
                    let thisVue = this;

                    if(requestedRecurrence){
                        if(requestedRecurrence === 'weekly')
                            thisVue.selectedRecurrence = { id: 'weekly', name: 'Weekly Subscription', icons: [], productIds: [] };
                        else thisVue.selectedRecurrence = { id: null, name: 'One-time Products', icons: [], productIds: [] };
                        console.warn('TOGGLE RECURRENCE TO:f ' + requestedRecurrence);
                    }

                    thisVue.delivery = mptapi.cart.deliveries.filter(d => d.id === deliveryId)[0];

                    return new Promise(function (resolve, reject) {

                        try {
                            let priceKey = thisVue.selectedRecurrence.id === 'weekly' ? 'weeklyPrice' : 'price';

                            for (const catKey in thisVue.productsByCategory) {
                                thisVue.productsByCategory[catKey].products = thisVue.productsByCategory[catKey].products.map(p => {
                                    p.recurrenceHide = p[priceKey] === null || p[priceKey] === 'undefined' ? true : false;
                                    if(!p.recurrenceHide)
                                        p.activePrice = p[priceKey].toFixed(2);
                                    return p;
                                });
                            }
                        } catch (e) {
                            return reject(e);
                        }
                        return resolve({success: true});
                    });

                },
                scrollToCategory(catId) {
                    if (catId) {

                        let catTop = jMPT('.mpt-shop-category-header[data-categoryid="' + catId + '"]').closest('.mpt-shop-category-header-container').closest('.product-container').offset().top;

                        jQuery([document.documentElement, document.body]).animate({
                            scrollTop: catTop
                        }, 900);

                        thisApp.model.storeScrollTop = catTop;
                    }
                },
                gotoFaq() {
                    jMPT("html, body").animate({ scrollTop: jMPT('#mpt-faq-row').offset().top - 180 }, 400);
                },
                handleProductClick(product, $event) {
                    let productCatString = null;
                    if(product.categories && product.categories.length > 0)
                    {
                        productCatString = JSON.stringify(product.categories);
                    } else {
                        productCatString = JSON.stringify([]);
                    }
                    try {
                        mptapi.track('product-view', {
                            productId: product.id,
                            productName: product.name,
                            price: product.activePrice.toString(),
                            categories: productCatString,
                            imageURL: product.activeImageUrl,
                            productURL: `${window.location.origin}/order/?viewProduct=${product.id}`,
                        });
                    } catch (errMessage) {
                        console.error(errMessage);
                    }

                    let quickAdd = $event && $event.target && ($event.target.classList.contains('quantityUp') || $event.target.classList.contains('quantityDown') || $event.target.classList.contains('ff-order-cart-qty'));

                    if(!quickAdd) {
                        try {
                            mptapi.track('product-view', {
                                productId: product.id,
                                productName: product.name,
                                price: product.activePrice.toString(),
                                categories: productCatString,
                                imageURL: product.activeImageUrl,
                                productURL: `${window.location.origin}/order/?viewProduct=${product.id}`,
                            }); }
                        catch(errMessage){ console.error(errMessage); }

                        //try { mptapi.track('page-view', {productId: product.id}); } catch(errMessage){ console.error(errMessage); }

                        mptapi.orderVues.mptProductPage.vueApp.loadProduct(product);

                        jMPT('html').css('overflow-y', 'hidden');
                        jMPT('body').addClass('mpt-no-scroll');


                        jMPT('FFCustomProductDetail .mpt-back-to-store-container').css({
                            opacity: 0,
                            position: 'fixed'
                        });

                        jMPT('FFCustomProductDetail').css({
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            overflowY: 'scroll',
                            zIndex: 9999
                        });

                        setTimeout(function () {
                            jMPT('FFCustomProductDetail .mpt-back-to-store-container').animate({opacity: 1}, 300);
                        }, 300);

                        //setTimeout(() => {jMPT(document).scrollTop(jMPT('mptproductpage .mpt-btn-link').offset().top);}, 300);

                        thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {viewProduct: product.id});
                        thisApp.updateUrl(1);
                        jMPT(window).on('popstate', function () {

                            jMPT('FFCustomProductDetail').css({'left': '-150vw', 'top': '0'}).removeClass("visible");
                            jMPT('html').css('overflow-y', 'auto');
                            jMPT('body').removeClass('mpt-no-scroll');
                            jMPT('FFCustomProductDetail .mpt-back-to-store-container').css({
                                opacity: 0,
                                position: 'relative'
                            });


                            jMPT(window).off('popstate');
                            thisApp.model.reqOptions.viewProduct = null;

                        });
                    }
                },
                changeDate(enforced = false) {
                    let thisVue = this;

                    mptapi.orderVues.mptPreOrderDays.vueApp.loadDays();
                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {previewMode: false});
                    thisVue.previewMode = false;
                    thisApp.updateUrl(1);
                    MPTUI.generateModal("#mpt-change-day-modal");
                },
                updateQtys(cartProducts){
                    console.warn('CART PRODUCTS:', cartProducts);
                    let thisVue = this;

                    jMPT('FFCustomOrder .ff-order-cart-qty').val('0');

                    if(!cartProducts || cartProducts.length === 0)
                    {
                        let thisCart = getSafeAPIValue('mptapi.cart');
                        if(thisCart) {
                            let thisDelivery = thisCart.deliveries.filter(d => d.id === thisVue.deliveryId);
                            if(thisDelivery.length > 0) {
                                cartProducts = thisDelivery[0].products;
                            }
                        }
                    }

                    if(cartProducts && cartProducts.length > 0) {
                        for (let i = 0; i < cartProducts.length; i++) {
                            let p = cartProducts[i];
                            let qaIdentifier = p.productId;
                            if(p.selectedVariations && p.selectedVariations.length === 1 && p.selectedVariations[0].options.length === 1)
                            {
                                qaIdentifier = p.productId + p.selectedVariations[0].id + p.selectedVariations[0].options[0].id;
                            }

                            console.log('SELECTOR: ' + `FFCustomOrder .ff-order-cart-qty.${qaIdentifier}`);
                            jMPT(`FFCustomOrder .ff-order-cart-qty.${qaIdentifier}`).val(p.qty);
                        }
                    }
                },
                resetAllQuickAddOptions(){
                    /*CURRENTLY DEPRECATED*/
                    let thisVue = this;
                    let result = [];

                    for(const catKey in thisVue.productsByCategory)
                    {
                        result = result.concat(
                            thisVue.productsByCategory[catKey].products.map(p => {
                                if(p.quickAdd) {
                                    return [{catId: catKey, productId: p.id, qaIdentifier: p.id, qa: p.quickAdd}];
                                }
                                else if(p.quickAdd1Option) {
                                    return [{catId: catKey, productId: p.id, qaIdentifier: p.id + p.quickAdd1Option.option1.variationId + p.quickAdd1Option.option1.opt.id, qa: p.quickAdd1Option.option1}];
                                }
                                else if(p.quickAdd2Options) {
                                    return [{
                                        catId: catKey,
                                        productId: p.id,
                                        qaIdentifier: p.id + p.quickAdd2Options.option1.variationId + p.quickAdd2Options.option1.opt.id,
                                        qa: p.quickAdd2Options.option1,
                                    },
                                    {
                                        catId: catKey,
                                        productId: p.id,
                                        qaIdentifier: p.id + p.quickAdd2Options.option2.variationId + p.quickAdd2Options.option2.opt.id,
                                        qa: p.quickAdd2Options.option2,
                                    }];
                                }
                                else return false;
                            }).filter(p => p).reduce((a, b) => { return a.concat(b);}, []));
                    }

                    return result;
                },
                quickAddUp(product, quickAddOptions)
                {
                    let thisVue = this;
                    let selectedVariations = null;
                    let deliveryId = this.overrideDeliveryId || mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;

                    if(thisVue.firstLoad && thisVue.autoPickedDeliveryDate && !thisVue.previewMode){
                        thisVue.changeDate();
                    }

                    if (quickAddOptions && quickAddOptions.variationId && quickAddOptions.opt)
                        selectedVariations = [{id: quickAddOptions.variationId, options: [quickAddOptions.opt.id]}];

                    let effectiveDate = new Date();
                    let addRequest = new AddProductToDelivery(product.id, 1, selectedVariations, product.name, product.price, thisVue.selectedRecurrence.id, null);
                    addRequest.send().then(addResponse => {
                        if (addResponse.cart) {
                            let cartTotal = 0;
                            try {
                                cartTotal = Math.max.apply(null, addResponse.cart.totals.filter(cli => cli.name.toLowerCase().includes('total')).map(cli => {
                                    return cli.amount
                                }));
                            } catch (errMessage) {
                                console.error(errMessage);
                                cartTotal = 0;
                            }

                            try {
                                mptapi.track('add-to-cart', {
                                    productId: product.id,
                                    productName: product.name,
                                    qty: 1,
                                    cartObj: JSON.stringify(addResponse.cart),
                                    price: product.activePrice.toString(),
                                    cartTotal: cartTotal
                                });

                                mptapi.trackGTag('add_to_cart_2');
                            } catch (errMessage) {
                                console.error(errMessage);
                            }
                        }

                        MPTMiddleware.cartMiddleware(addResponse, effectiveDate);
                    });

                },
                quickAddDown(product, quickAddOptions)
                {
                    try { mptapi.track('remove-from-cart', {productId: product.id, productName: product.name}); } catch(errMessage){ console.error(errMessage); }

                    let thisVue = this;

                    if(thisVue.firstLoad && thisVue.autoPickedDeliveryDate && !thisVue.previewMode){
                        thisVue.changeDate();
                    }

                    if(quickAddOptions) {
                        let qaIdentifier = quickAddOptions.qaIdentifier;
                        let cartProduct = thisVue.searchCart(thisVue.deliveryId, qaIdentifier);

                        if(cartProduct) {
                            let effectiveDate = new Date();

                            let req = new UpdateProductInDelivery(cartProduct.id, {qty: (cartProduct.qty - 1)});
                            req.send().then(response => {
                                if (response && response.success) {

                                    MPTMiddleware.cartMiddleware(response, effectiveDate);
                                }

                                //mptapi.cartDropdown.getCart(false, x);
                            });
                        }
                    }
                },
                searchCart(deliveryId, qaIdentifier) {
                    let thisCart = getSafeAPIValue('mptapi.cart');
                    let cartProducts = [];

                    if (thisCart) {
                        let thisDelivery = thisCart.deliveries.filter(d => d.id === deliveryId);
                        if (thisDelivery.length > 0) {
                            cartProducts = thisDelivery[0].products;
                            if (cartProducts && cartProducts.length > 0) {
                                for (let i = 0; i < cartProducts.length; i++) {
                                    let p = cartProducts[i];
                                    let cartQAIdentifier = p.productId;
                                    if (p.selectedVariations && p.selectedVariations.length === 1 && p.selectedVariations[0].options.length === 1) {
                                        cartQAIdentifier = p.productId + p.selectedVariations[0].id + p.selectedVariations[0].options[0].id;
                                    }

                                    if(qaIdentifier === cartQAIdentifier)
                                    {
                                        return p;
                                    }
                                }
                            }
                        }
                    }
                },
                showGetStarted() {
                    Custombox.modal.closeAll();

                    let thisVue = this;

                    //ffSetCustomModalState('registerModal', 'closed', null);
                    //ffSetCustomModalState('userAccountModal', 'closed', null);

                    /*try {
                        let registerModal = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp.registerModal');
                        if(registerModal) registerModal._close();
                    } catch { }

                    try {
                        let userAccountModal = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp.userAccountModal');
                        if(userAccountModal) userAccountModal._close();
                    } catch { }*/


                    thisVue.initModalComponent().then(() =>{
                        thisVue.startGetStartedLoading();

                        mptapi.orderVues.ffCustomGetStarted.vueApp.loadData().then(() => {
                            let getStartedForm = jMPT('.ff-start-container');
                            if (jMPT(document).width() <= 1200) {
                                setTimeout(() => {
                                    getStartedForm.css('flex-basis', '100%').css('max-height', '100%');
                                    jMPT('.custombox-overlay:visible').css('background-color', 'rgb(230, 230, 230)');
                                    jMPT('.custombox-content:visible').css('background-color', 'rgb(230, 230, 230)');
                                    thisVue.stopGetStartedLoading();
                                }, 250);
                            } else {
                                setTimeout(() => {
                                    getStartedForm.css('flex-basis', '75%');
                                    thisVue.stopGetStartedLoading();
                                }, 250);
                            }


                            jMPT(window).on('popstate', function () {
                                Custombox.modal.closeAll();
                                //ffSetCustomModalState('getStartedModal', 'closed', null);
                                /*try {
                                    let getStartedModal = getSafeAPIValue('mptapi.orderVues.ffCustomGetStarted.vueApp.getStartedModal');
                                    if(getStartedModal) getStartedModal._close();
                                } catch { }*/

                                jMPT('html').css('overflow-y', 'auto');
                                jMPT('body').removeClass('mpt-no-scroll');
                                jMPT(window).off('popstate');
                            });
                        });
                    });
                },
                initModalComponent(){
                    let thisVue = this;

                    //ffSetCustomModalState('registerModal', 'closed', null);
                    //ffSetCustomModalState('userAccountModal', 'closed', null);

                    /*try {
                        let registerModal = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp.registerModal');
                        if(registerModal) registerModal._close();
                    } catch { }

                    try {
                        let userAccountModal = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp');
                        if(userAccountModal) userAccountModal._close();
                    } catch { }*/

                    return new Promise((resolve, reject) => {
                        thisVue.getStarted = true;
                        thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {getStarted: true});
                        thisApp.updateUrl(1);

                        let getStartedForm = jMPT('.ff-start-container');
                        getStartedForm.attr('data-mobilesettings', '{"content": {"fullscreen": true, "width": "100%", "effect": "push", "animateFrom": "left", "animateTo": "left"}}').css('display:none;');

                        MPTUI.generateModal(".ff-start-container");
                        //ffSetCustomModalState('getStartedModal', 'open', MPTUI.generateModal(".ff-start-container"));
                        //thisVue.getStartedModal = MPTUI.generateModal(".ff-start-container");

                        jMPT('html').css('overflow-y', 'hidden');
                        jMPT('body').addClass('mpt-no-scroll');

                        setTimeout(() => { return resolve({success: true})}, 250);
                    });
                },
                closeModals() {
                    let thisVue = this;

                    //ffSetCustomModalState('getStartedModal', 'closed', null);
                    Custombox.modal.closeAll();
                    //try{ thisVue.getStartedModal._close() } catch{}

                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {previewMode: false});
                    thisVue.previewMode = false;
                    thisVue.firstLoad = false;
                },
                initPreviewMode() {
                    let thisVue = this;

                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions || {}, {previewMode: true});
                    thisVue.previewMode = true;
                    thisVue.firstLoad = false;
                    thisApp.updateUrl(1);
                    thisVue.closeModals();
                },
                startGetStartedLoading() {
                    jMPT('.ff-start-form').css('pointer-events', 'none');
                    jMPT('.ff-start-form').css('opacity', '.2');
                    jMPT('#ff-start-modal').append('<i class="start-modal-load fa fa-spin fa-spinner fa-2x mpt-page-loader" style="position: fixed; top: 45%; left: 50%">');
                },
                stopGetStartedLoading() {
                    jMPT('.ff-start-form').css('pointer-events', 'all');
                    jMPT('.ff-start-form').css('opacity', '1');
                    jMPT('.start-modal-load').remove();
                },
                customDeliveryDisplay() {
                    let thisVue = this;

                    if (thisVue.delivery.shippingLocationType === 'pickup') {
                        return `${thisVue.delivery.deliveryDayName.replace('04:00 PM', '03:30 PM')}`;
                    } else {
                        return `${thisVue.delivery.deliveryDayName}`;
                    }
                }
            }
        });

        //'Filter by Category';
        //'#header' let appendOpt = { 'appendSearchOptions': {      'id': '3rkSearchBar',      'class': 'mpt-full-search-control'    }};
        mptapi.orderVues.mptCategoryFilter = new MPTCategorySlider(thisApp.model, thisApp.reqOptions, null, null, null);
        mptapi.orderVues.mptProductPage = new FFCustomProductDetail(thisApp.model, thisApp.reqOptions);
        mptapi.orderVues.mptFilterSidebar = new MPTFilterSidebar(thisApp.model, thisApp.reqOptions);
        mptapi.orderVues.mptPreOrderDays = new MPTPreOrderDays(thisApp.model, thisApp.reqOptions);
        mptapi.orderVues.ffCustomGetStarted = new FFCustomGetStarted(thisApp.model, thisApp.reqOptions);


        //set initial position of product detail
        jMPT('FFCustomProductDetail').css({'left': '-150vw', 'top': '0', 'position': 'fixed'}).removeClass("visible");
        jMPT('html').css('overflow-y', 'auto');
        jMPT('body').removeClass('mpt-no-scroll');
        jMPT('FFCustomProductDetail .mpt-back-to-store-container').css({
            opacity: 0,
            position: 'relative'
        });

    }

    runMiddleware(context){
        let thisApp = this;

        if(!thisApp.model)
            thisApp.model = {};

        let mobileView = false;
        if(jMPT(document).width() < 600)
            mobileView = true;

        const deliveryId = mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || getSafeAPIValue('cart.deliveries[0].id');

        Object.assign(thisApp.model, {
            summary: Object.assign((context.summary || {}), {productCount: context.products.length}),
            products: context.products,
            serverSideShopPage: context.companyInfo.uiSettings.serverSideShopPage,
            additionalCheckoutButton: context.companyInfo.uiSettings.showAdditionalCheckoutButton,
            compressNutritionalLabels: context.companyInfo.uiSettings.compressNutritionalLabels || false,
            delivery: mptapi.cart.deliveries.find(x => x.id === (deliveryId)),
            fullProductPages: (context.companyInfo.uiSettings && context.companyInfo.uiSettings.fullProductPages),
            showDatesInShopFilters: (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showDatesInShopFilters),
            showLocationsInShopFilters: (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showLocationsInShopFilters),
            defaultRecurrenceOptions: ['null', 'weekly', 'biweekly', 'monthly'],
            mobileView: mobileView,
            productsByCategory: (thisApp.model && thisApp.model.templateSuffix === 'GPC') ? { 'uncategorized': {id: 'uncategorized', products: [] } } : {},
            filterIds: [],
            searchText: null,
            searchIds: []
        });

        let mdCompiler = null;

        if(window.markdownit) {
            mdCompiler = window.markdownit();
            mdCompiler.disable(["code"]);
        }

        let customCategoryDesc = getSafeAPIValue('mptapi.companyInfo.uiSettings.customCategoryDesc');

        thisApp.model.products = thisApp.model.products.map(x => {
            let prod = x;

            /* Customization for a quickadd feature for products that have no variations OR that have exactly 1 variation with 2 options */
            if(x.variations.length === 0) {
                x.quickAdd = {
                    qaIdentifier: x.id,
                    cartQty: 0,
                    recordId: '',
                    variationId: null,
                    opt: null,
                };
                x.quickAdd1Option = false;
                x.quickAdd2Options = false;
            } else if(x.variations.length === 1 && x.variations[0].options.length === 1) {
                let thisVar = x.variations[0];
                x.quickAdd = false;
                x.quickAdd1Option = {
                    option1: {
                        qaIdentifier: x.id + thisVar.id + thisVar.options[0].id,
                        cartQty: 0,
                        recordId: '',
                        variationId: thisVar.id,
                        opt: thisVar.options[0],
                        title: thisVar.options[0].text,
                        calculatedBasePrice: x.price + thisVar.options[0].price,
                        calculatedWeeklyPrice: x.weeklyPrice + thisVar.options[0].price
                    }
                };
                x.quickAdd2Options = false;
            } else if(x.variations.length === 1 && x.variations[0].options.length === 2) {
                let thisVar = x.variations[0];
                x.quickAdd = false;
                x.quickAdd1Option = false;
                    x.quickAdd2Options = {
                    option1: {
                        qaIdentifier: x.id + thisVar.id + thisVar.options[0].id,
                        cartQty: 0,
                        recordId: '',
                        variationId: thisVar.id,
                        opt: thisVar.options[0],
                        title: thisVar.options[0].text,
                        calculatedBasePrice: x.price + thisVar.options[0].price,
                        calculatedWeeklyPrice: x.weeklyPrice + thisVar.options[0].price
                    },
                    option2: {
                        qaIdentifier: x.id + thisVar.id + thisVar.options[1].id,
                        cartQty: 0,
                        recordId: '',
                        variationId: thisVar.id,
                        opt: thisVar.options[1],
                        title: thisVar.options[1].text,
                        calculatedBasePrice: x.price + thisVar.options[1].price,
                        calculatedWeeklyPrice: x.weeklyPrice + thisVar.options[1].price
                    }
                };
            }

            if(x.tags.length > 0) {
                x.greenLabel = x.tags.filter(t => t.name.toLowerCase().includes('active')).length > 0;
                x.redLabel = x.tags.filter(t => t.name.toLowerCase().includes('low carb')).length > 0;
                x.yellowLabel = x.tags.filter(t => t.name.toLowerCase().includes('breakfast')).length > 0;
                x.purpleLabel = x.tags.filter(t => t.name.toLowerCase().includes('(purple)')).length > 0;
                x.blueLabel = x.tags.filter(t => t.name.toLowerCase().includes('snack')).length > 0;
                x.altTagLabel = x.tags.filter(t => t.name.toLowerCase().includes('new')).length > 0;
            } else {
                x.redLabel = false;
                x.greenLabel = false;
                x.yellowLabel = false;
                x.purpleLabel = false;
                x.blueLabel = false;
                x.altTagLabel = false;
            }

            x.searchFriendlyName = x.name.toLowerCase().replace(/[^A-Z0-9]/ig, '');

            if(x.description) {
                if (mdCompiler)
                    x.compiledDescription = mdCompiler.render(x.description);
                else x.compiledDescription = x.description;

                x.descriptionSnapshot = jMPT(x.compiledDescription).text();
                x.descriptionSnapshot = x.descriptionSnapshot.substr(0, Math.min(50, x.descriptionSnapshot.length));
                x.descriptionSnapshot += x.descriptionSnapshot.length > 50 ? '...' : '';
            } else {
                x.compiledDescription = null;
                x.descriptionSnapshot = null;
            }

            if(x.specifications) {
                if (mdCompiler) {
                    x.compiledSpecifications = mdCompiler.render(x.specifications);
                } else {
                    x.compiledSpecifications = x.specifications;
                }
            } else {
                x.specifications = null;
            }

            x.inCart = typeof mptapi.cart.deliveries.find(d => (d.products.find(p => p.productId === x.id))) !== "undefined";

            // Default Image if none sent
            if (x.images.length === 0) {
                x.images.push([{
                    id: "placeholder",
                    url: "https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg"
                }]);
                x.defaultImage = "placeholder";
            }

            const productImages = sortProductImage(x.images);

            if(mobileView && productImages.length > 0 && productImages[0].length > 2)
                x.activeImageUrl = productImages[0][2].url;
            else{
                try {
                    x.activeImageUrl = productImages[0][1].url;
                }catch{
                    x.activeImageUrl = 'https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg';
                }
            }

            x.selections = {};
            for(let i = 0; i < thisApp.model.defaultRecurrenceOptions.length; i++){
                let key = thisApp.model.defaultRecurrenceOptions[i];
                let product = prod;
                if(thisApp.model.delivery) {
                    x.selections[key] = {
                        recordId: thisApp.model.delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.id).firstOrDefault(),
                        qty: thisApp.model.delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.qty).firstOrDefault(0)
                    };
                } else x.selections[key] = {
                    recordId: null,
                    qty: 0
                }
            }

            try {
                if (thisApp.model.compressNutritionalLabels && x.attributes.length > 0) {
                    x.addtlInfo = x.attributes.map(a => {
                        if (a.type === 'nutritionLabel' && a.data && a.data.nutritionLabel && a.data.nutritionLabel.data) {
                            a.data.nutritionLabel.data = a.data.nutritionLabel.data.filter(nlrow => {
                                return nlrow.filter(rCell => {
                                    return rCell.value;
                                }).length >= 2;
                            });
                            if (a.data.nutritionLabel.data.length > 0)
                                return a;
                            else return false;
                        }
                        else return a;
                    }).filter(a => a);
                }
            } catch(err){ console.error(err);}



            x.recurrenceHide = false;
            let formatted = parseFloat(x.price);
            if(thisApp.model.selectedRecurrence) {
                switch (thisApp.model.selectedRecurrence.id) {
                    case "weekly":
                        x.recurrenceHide = x.weeklyPrice ? false : true;
                        formatted = parseFloat(x.weeklyPrice);
                        break;
                    case "null":
                        x.recurrenceHide = x.price ? false : true;
                        formatted = parseFloat(x.price);
                        break;
                    default:
                        x.recurrenceHide = x.price ? false : true;
                        formatted = parseFloat(x.price);
                }
            }
            x.activePrice = formatted.toFixed(2);


            if(thisApp.model.templateSuffix === 'GPC') {
                if (prod.categories && prod.categories.length > 0) {
                    for(let j = 0; j < prod.categories.length; j++) {
                        let thisCatKey = prod.categories[j].id;
                        let thisCatName = prod.categories[j].name;
                        if(thisApp.model.productsByCategory[thisCatKey]) {
                            thisApp.model.productsByCategory[thisCatKey].products.push(x);
                        } else {
                            thisApp.model.productsByCategory[thisCatKey] = {name: thisCatName, products: [x]};

                            if (customCategoryDesc) {
                                const foundCatDesc = customCategoryDesc.find(desc => {
                                    return desc.id === thisCatKey;
                                });

                                if (foundCatDesc) {
                                    thisApp.model.productsByCategory[thisCatKey].description = foundCatDesc.text;
                                }
                            }
                        }
                    }
                }
                else {
                    thisApp.model.productsByCategory['uncategorized'].products.push(x);
                }
            }

            return x;
        });

        if(context.hasOwnProperty("packages")){
            if(context.packages.length === 1){
                thisApp.model.package = context.packages[0];
            }
        }

        if(thisApp.reqOptions && thisApp.reqOptions.viewProduct)
        {
            setTimeout(function(){
                let directNavProd = thisApp.model.products.filter(p => p.id === thisApp.reqOptions.viewProduct);
                if(directNavProd.length > 0)
                {
                    thisApp.vueApp.handleProductClick(directNavProd[0]);
                    console.warn('auto nav to: ' + directNavProd[0].id);
                }
            }, 250);
        }

    }

    compileSubVues() {

        mptapi.orderVues.categoryFilterVue.init();
        mptapi.orderVues.mptProductPage = new FFCustomProductDetail(this.model, this.reqOptions, 'orderVues');
    }
}

class FFCustomGetStarted extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('FFCustomGetStarted', model, reqOptions);

        let defaultModel = {
            getStartedModal: null,
            getStartedDateSelectActive: false,
            getStartedTimeSelectActive: false,
            pickupLocationSelectActive: false,
            getStartedRecurrenceSelectActive: false,
            getStartedLocationTypeSelectActive: false,

            getStartedDayName: 'Wed Mar 2 2022',
            getStartedTSName: '4PM-9PM',
            getStartedDayId: 'd960521a-8112-4e4f-8711-125fabbb4e5e',
            getStartedTSId: 'bfee1983-95b2-4f17-9070-8d169a6dac56',
            getStartedTSDateTime: '',

            selectedShippingLocationTypeName: 'Delivery',
            selectedShippingLocationName: 'Home Delivery',
            selectedShippingLocationType: 'home-delivery',
            selectedShippingLocationId: 'fe91b45f-6b1a-474c-96cc-4f345b1abb62',

            getStartedEmail: null,
            getStartedRecurrence: 'single-order',
            getStartedRecurrenceName: 'Single Order',
            pickupLocationOptions: [],
            shippingLocationOptions: [], //TODO: (Later) implement multiple types of home delivery
            deliveryOptions: [
                {
                    customDateText: "Wed Mar 2 2022",
                    date: "3/2/2022",
                    dateShort: "3/2",
                    description: null,
                    id: "d960521a-8112-4e4f-8711-125fabbb4e5e",
                    name: "Wednesday",
                    selected: false,
                    set: 0,
                    textOverride: null,
                    timeSlots: [{
                        customTSText: "4PM-9PM",
                        dateTime: "3/2/2022 4:00:00 PM",
                        description: null,
                        end: "09:00 PM",
                        id: "bfee1983-95b2-4f17-9070-8d169a6dac56",
                        selected: false,
                        start: "04:00 PM",
                        textOverride: null
                    }]
                }
            ],
            getStartedTimeSlotOptions: []
        };



        this.model = model || defaultModel;
        this.model.getStartedLoading = false;

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            mounted(){
                let thisVue = this;

                // let hasValidGetStarted = MPTSession.checkGetStarted();
                //
                // if((thisApp.reqOptions && thisApp.reqOptions.getStarted) || !MPTSession.checkGetStarted())
                // {
                //     if(!thisApp.reqOptions || (!thisApp.reqOptions.previewMode && !thisApp.reqOptions.viewProduct)) {
                //         setTimeout(function () {
                //             if (typeof(mptapi.orderVues.mptOrder.vueApp.showGetStarted) === 'function') {
                //                 mptapi.orderVues.mptOrder.vueApp.showGetStarted();
                //             }
                //
                //         }, 250);
                //     }
                // }
            },
            methods: {
                changeRecurrence(recurrenceValue){
                    let thisVue = this;
                    thisVue.getStartedRecurrence = (recurrenceValue === 'weekly') ? 'weekly' : 'single-order';
                    thisVue.getStartedRecurrenceName = (recurrenceValue === 'weekly') ? 'Subscribe' : 'Single Order';
                    console.log('GET STARTED RECURRENCE:');
                    console.log(thisVue.getStartedRecurrence);
                    console.log(thisVue.getStartedRecurrenceName);

                    thisVue.hideOptions();

                    let orderVue = getSafeAPIValue('mptapi.orderVues.mptOrder.vueApp');
                    if(orderVue)
                    {
                        orderVue.recurrenceChanged(thisVue.getStartedRecurrence);
                    }
                },
                changeLocationType(selectedType, preselectedLocationId){
                    let thisVue = this;

                    if(selectedType === 'pickup') {
                        thisVue.selectedShippingLocationType = 'pickup';
                        thisVue.selectedShippingLocationTypeName = 'Pickup';

                        if(thisVue.pickupLocationOptions && thisVue.pickupLocationOptions.length > 0) {
                            let filteredPULocations = [];
                            if(preselectedLocationId)
                                filteredPULocations = thisVue.pickupLocationOptions.filter(loc => loc.id === preselectedLocationId);

                            if(filteredPULocations.length === 0)
                                filteredPULocations = thisVue.pickupLocationOptions;

                            thisVue.clickPickupLocation(filteredPULocations[0]);
                        }
                        else
                        {
                            thisVue.selectedShippingLocationName = 'Select location...';
                            thisVue.selectedShippingLocationId = null;
                        }
                    }
                    else {
                        thisVue.selectedShippingLocationType = 'home-delivery';
                        thisVue.selectedShippingLocationTypeName = 'Delivery';

                        const foundDeliveryOption = thisVue.deliveryOptions.find(deliveryOption => {
                           return deliveryOption.id === thisVue.getStartedDayId;
                        });

                        if (foundDeliveryOption) {
                            thisVue.getStartedTimeSlotOptions = foundDeliveryOption.timeSlots;
                        }

                        if(thisVue.shippingLocationOptions && thisVue.shippingLocationOptions.length > 0) {
                            thisVue.selectedShippingLocationName = thisVue.shippingLocationOptions[0].name;
                            thisVue.selectedShippingLocationId = thisVue.shippingLocationOptions[0].id;
                        }
                        else{
                            thisVue.selectedShippingLocationName = null;
                            thisVue.selectedShippingLocationId = null;
                        }
                    }

                    thisVue.getStartedTimeSlotOptions = FFCustomGetStarted.timeSlotMiddleware(thisVue.getStartedTimeSlotOptions, thisVue.selectedShippingLocationType);
                    let selectedTS = thisVue.getStartedTimeSlotOptions.filter(ts => ts.id === thisVue.getStartedTSId);
                    if(selectedTS.length === 0)
                        selectedTS = thisVue.getStartedTimeSlotOptions.filter((ts, i) => i === 0);
                    if(selectedTS.length > 0) {
                        setTimeout(() => {
                            thisVue.clickTimeSlot(selectedTS[0]);
                        }, 300);
                    }

                    thisVue.hideOptions();
                },
                loadData(){
                    console.warn('LOAD DATA CALLED');
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        thisVue.loadUser();
                        thisVue.loadFromLocalStorage().then(() => {
                            thisVue.loadLocations().then(() => {
                                thisVue.loadDays().then(() => {
                                    return resolve({success: true, notRequired: false});
                                });
                            });
                        });
                    });
                },
                loadFromLocalStorage(){
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        let getStartedData = MPTSession.checkGetStarted();

                        if (getStartedData) {
                            if (getStartedData.recurrence === 'weekly') {
                                thisVue.selectedRecurrence = {
                                    id: 'weekly',
                                    name: 'Weekly Subscription',
                                    icons: [],
                                    productIds: []
                                };
                                thisVue.getStartedRecurrence = 'weekly';
                                thisVue.getStartedRecurrenceName = 'Subscribe';
                            }
                            else {
                                thisVue.selectedRecurrence = {
                                    id: null,
                                    name: 'Single Order',
                                    icons: [],
                                    productIds: []
                                };
                                thisVue.getStartedRecurrence = 'single-order';
                                thisVue.getStartedRecurrenceName = 'Single Order';
                            }


                            thisVue.selectedShippingLocationType = getStartedData.shippingLocationType || 'home-delivery';
                            thisVue.selectedShippingLocationId = getStartedData.shippingLocationId || null;
                            thisVue.selectedShippingLocationName = getStartedData.shippingLocationName || 'Home Delivery';
                            thisVue.getStartedEmail = getStartedData.getStartedEmail || null;
                            thisVue.getStartedDayId = getStartedData.getStartedDayId || null;
                            thisVue.getStartedTSName = getStartedData.getStartedTSName || null;
                            thisVue.getStartedTSId = getStartedData.getStartedTSId || null;
                            thisVue.updateLocationTypeName();

                            return resolve({success: true, notRequired: false});
                        } else return resolve({success: true, notRequired: true});
                    });
                },
                updateLocationTypeName(){
                  let thisVue = this;

                  if(thisVue.selectedShippingLocationType)
                  {
                      let arr = thisVue.selectedShippingLocationType.split('-');
                      if(arr.length > 0) {
                          let name = arr[arr.length - 1];
                          name = name.charAt(0).toUpperCase() + name.substr(1);
                      }
                      else thisVue.selectedShippingLocationTypeName = 'Delivery';
                  }
                  else thisVue.selectedShippingLocationTypeName = 'Delivery';

                },
                loadUser(){
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        if(MPTSession.signedIn()){
                            let req = new GetAccountInfo();
                            req.send().then((res) => {
                                if(res.success)
                                {
                                    thisVue.user = res.user;
                                    thisVue.getStartedEmail = res.user.email;
                                    return resolve(res);
                                }
                                else{
                                    return reject(res);
                                }
                            }).catch((err) => { return reject(err); });
                        }
                        else return resolve({success: true, notRequired: true});
                    });
                },
                loadLocations(){
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        let locReq = new GetLocations();
                        locReq.send().then((res) => {
                            if (res.success && res.deliveryLocations && res.deliveryLocations.length > 0) {
                                thisVue.shippingLocationOptions = res.deliveryLocations.filter(dl => dl.type === 'home-delivery');
                                thisVue.pickupLocationOptions = res.deliveryLocations.filter(dl => dl.type === 'pickup');

                                if(!thisVue.selectedShippingLocationType || thisVue.selectedShippingLocationType === 'home-delivery')
                                {
                                    thisVue.changeLocationType(thisVue.selectedShippingLocationType || 'home-delivery');
                                }
                                else {
                                    let savedLocationId = (thisVue.selectedShippingLocationId ? thisVue.selectedShippingLocationId.toString() : null);
                                    console.log('SAVED PL1: ', savedLocationId);
                                    thisVue.changeLocationType('pickup', savedLocationId);
                                }
                            }
                            else {
                                thisVue.shippingLocationOptions = [];
                                thisVue.pickupLocationOptions = [];
                            }
                            return resolve(res);
                        }).catch((err) => { return reject(err); });
                    });
                },
                loadDays(){
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        let packageId = mptapi.router.data.packageId || null;

                        let dayReq = new GetDeliveryOptions(packageId, false);
                        dayReq.send().then((res) => {
                            if (res.success) {
                                thisVue.deliveryOptions = dayReq.response.deliveryOptions.map(d => {
                                    try {
                                        let dateSplit = d.date.split('/');
                                        d.dateShort = dateSplit[0] + "/" + dateSplit[1];
                                    }
                                    catch {
                                        d.dateShort = d.date;
                                    }

                                    try {
                                        let dateObj = new Date(d.date);
                                        d.customDateText = `${dateObj.toLocaleDateString('en-US', {weekday: 'short'})} ${dateObj.toLocaleDateString('en-US', {month: 'short'})} ${dateObj.getDate()} ${dateObj.getFullYear()}`;
                                    }
                                    catch {
                                        d.customDateText = d.date;
                                    }

                                    d.timeSlots.map((ts) => {
                                        try {

                                            let time1 = new Date(ts.dateTime);
                                            let time2 = new Date(ts.dateTime.split(' ')[0] + ' ' + ts.end);
                                            ts.customTSText = shortWindowStringFromDates(time1, time2, '-');

                                        } catch {
                                            ts.customTSText = ts.start + '-' + ts.end;
                                        }
                                        return ts;
                                    });

                                    return d;
                                });

                                if (thisVue.deliveryOptions && thisVue.deliveryOptions.length > 0) {
                                    let selectedOpt = [];
                                    let selectedTS = [];

                                    if (thisVue.delivery && thisVue.delivery.deliveryDayId) {
                                        selectedOpt = thisVue.deliveryOptions.filter(dopt => dopt.id === thisVue.delivery.deliveryDayId)
                                    }

                                    if (selectedOpt.length === 0)
                                        selectedOpt = thisVue.deliveryOptions.filter((dopt, i) => i === 0);

                                    thisVue.clickDay(selectedOpt[0]);

                                    if (thisVue.getStartedTimeSlotOptions && thisVue.getStartedTimeSlotOptions.length > 0) {
                                        if (thisVue.delivery && thisVue.delivery.timeSlotId) {
                                            selectedTS = thisVue.getStartedTimeSlotOptions.filter(dopt => dopt.id === thisVue.delivery.timeSlotId)
                                        }

                                        if (selectedTS.length === 0)
                                            selectedTS = thisVue.getStartedTimeSlotOptions.filter((ts, i) => i === 0);
                                            setTimeout(() => {
                                                thisVue.clickTimeSlot(selectedTS[0]);
                                            }, 300);
                                    }
                                }

                                return resolve(res);

                            }
                            else return reject(res);
                        }).catch((err) => { return reject(err); });
                    });
                },
                showOptions(type){
                    let thisVue = this;

                    console.warn('showOptions: ' + type);
                    switch(type){
                        case 'pickup':
                            thisVue.pickupLocationSelectActive = true;
                            jMPT('.pl-list-options').show();
                            jMPT('.ts-list-options').hide();
                            jMPT('.date-list-options').hide();
                            jMPT('.lt-list-options').hide();
                            jMPT('.rec-list-options').hide();
                            break;
                        case 'time':
                            thisVue.getStartedTimeSelectActive = true;
                            jMPT('.pl-list-options').hide();
                            jMPT('.ts-list-options').show();
                            jMPT('.date-list-options').hide();
                            jMPT('.lt-list-options').hide();
                            jMPT('.rec-list-options').hide();
                            break;
                        case 'recurrence':
                            thisVue.getStartedRecurrenceSelectActive = true;
                            jMPT('.pl-list-options').hide();
                            jMPT('.ts-list-options').hide();
                            jMPT('.date-list-options').hide();
                            jMPT('.lt-list-options').hide();
                            jMPT('.rec-list-options').show();
                            break;
                        case 'locationType':
                            thisVue.getStartedLocationTypeSelectActive = true;
                            jMPT('.pl-list-options').hide();
                            jMPT('.ts-list-options').hide();
                            jMPT('.date-list-options').hide();
                            jMPT('.lt-list-options').show();
                            jMPT('.rec-list-options').hide();
                            break;
                        default: //case 'date'
                            thisVue.getStartedDateSelectActive = true;
                            jMPT('.pl-list-options').hide();
                            jMPT('.ts-list-options').hide();
                            jMPT('.date-list-options').show();
                            jMPT('.lt-list-options').hide();
                            jMPT('.rec-list-options').hide();
                            break;
                    }
                },
                hideOptions(){
                    let thisVue = this;

                    thisVue.getStartedDateSelectActive = false;
                    thisVue.getStartedTimeSelectActive = false;
                    thisVue.pickupLocationSelectActive = false;

                    thisVue.getStartedLocationTypeSelectActive = false;
                    thisVue.getStartedRecurrenceSelectActive = false;

                    jMPT('.select-options').hide();

                },
                clickPickupLocation(location){
                    let thisVue = this;

                    thisVue.selectedShippingLocationName = location.name;
                    thisVue.selectedShippingLocationId = location.id;

                    thisVue.hideOptions();
                },
                clickDay(deliveryOption){
                    let thisVue = this;

                    thisVue.getStartedDateSelectActive = false;
                    thisVue.getStartedDayName = deliveryOption.customDateText;
                    thisVue.getStartedDayId = deliveryOption.id;
                    thisVue.getStartedTimeSlotOptions = deliveryOption.timeSlots;

                    if(thisVue.getStartedTimeSlotOptions.length > 0) {
                        thisVue.getStartedTimeSlotOptions = FFCustomGetStarted.timeSlotMiddleware(thisVue.getStartedTimeSlotOptions, thisVue.selectedShippingLocationType);
                        setTimeout(() => {
                            thisVue.clickTimeSlot(thisVue.getStartedTimeSlotOptions[0]);
                        }, 300);
                    }
                    else thisVue.hideOptions();

                },
                clickTimeSlot(timeSlot){
                    let thisVue = this;

                    thisVue.getStartedTimeSelectActive = false;
                    thisVue.getStartedTSName = timeSlot.customTSText;
                    thisVue.getStartedTSId = timeSlot.id;
                    thisVue.getStartedTSDateTime = timeSlot.dateTime;

                    thisVue.hideOptions();
                },
                loginClick(){
                    let thisVue = this;

                    if(mptapi.ffBottomNavVue && mptapi.ffBottomNavVue.vueApp) {
                        thisVue.onGetStarted = true;
                        mptapi.ffBottomNavVue.vueApp.accountClick();
                    }
                },
                validateGetStarted(){
                    let isValid = true;

                    isValid = jMPT('.ff-start-email:visible').ffCustomValidate({required: true, isEmail: true}).isValid && isValid;

                    return isValid;
                },
                getStartedContinue(){
                    let thisVue = this;

                    if(thisVue.validateGetStarted()) {
                        let effectiveDate = new Date();
                        let localStorageData = {
                            recurrence: thisVue.getStartedRecurrence,
                            shippingLocationId: thisVue.selectedShippingLocationId,
                            shippingLocationType: thisVue.selectedShippingLocationType,
                            shippingLocationName: thisVue.selectedShippingLocationName,
                            getStartedEmail: thisVue.getStartedEmail,
                            getStartedDayName: thisVue.getStartedDayName,
                            getStartedDayId: thisVue.getStartedDayId,
                            getStartedTSName: thisVue.getStartedTSName,
                            getStartedTSId: thisVue.getStartedTSId,
                            effectiveDate: effectiveDate.toString()
                        };

                        mptapi.getStartedSelections = localStorageData;

                        let reqCount = 0;
                        thisVue.getStartedLoading = true;
                        thisVue.startGetStartedLoading();


                        thisVue.submitCartRecurrence().then((result) => {
                            if (result && result.success && !result.notRequired) {

                            }
                            console.warn('recurrence result', result);
                            reqCount++;
                            thisVue.submitDone(reqCount, result);
                        });

                        thisVue.submitChangeDay().then((result) => {
                            console.warn('day result', result);
                            reqCount++;
                            thisVue.submitDone(reqCount, result);
                        });

                        thisVue.submitLocation().then((result) => {
                            console.warn('location result', result);
                            reqCount++;
                            thisVue.submitDone(reqCount, result);
                        });
                    }
                },
                submitDone(reqCount, result){
                    let thisVue = this;

                    console.warn('thisReqCount: ' + reqCount);
                    let effectiveDate = new Date();

                    if(result && result.success && !result.notRequired && result.cart)
                        MPTMiddleware.cartMiddleware(result, effectiveDate);

                    if(reqCount >= 3)
                    {
                        mptapi.track('get-started-submit', {
                            email: thisVue.getStartedEmail,
                        });

                        thisVue.getStartedLoading = false;
                        thisVue.stopGetStartedLoading();
                        thisVue.closeGetStarted(!mptapi.cart?.deliveries.length || !mptapi.router.data.deliveryId || !(thisVue.getStartedDayId === thisVue.delivery.deliveryDayId && thisVue.getStartedTSId === thisVue.delivery.timeSlotId))
                        console.warn('all changes done');
                    }
                },
                submitChangeDay(){
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        if(!(thisVue.getStartedDayId === thisVue.delivery.deliveryDayId && thisVue.getStartedTSId === thisVue.delivery.timeSlotId)){
                            let req = new ChangeDeliveryDate(thisVue.delivery.deliveryId, thisVue.getStartedDayId, thisVue.getStartedTSId, thisVue.getStartedTSDateTime, null);
                            req.send().then((res) => {
                                if(res.success)
                                {
                                    return resolve(res);
                                }
                                else{
                                    return reject(res);
                                }
                            }).catch((err) => {
                                return reject(err);
                            });
                        }
                        else return resolve({success: true, notRequired: true});
                    });
                },
                submitCartRecurrence(){
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        let subscriptionStatus = FFCustomGetStarted.cartSubscriptionStatus();

                        if(subscriptionStatus !== thisVue.getStartedRecurrence){
                            /*if(subscriptionStatus === 'empty')
                            {
                                //TODO: may require reload
                            }
                            else {*/
                                let req = new CartSubscribeAll(thisVue.getStartedRecurrence);
                                req.send().then((res) => {
                                    if (res.success) {
                                        return resolve(res);
                                    }
                                    else {
                                        return reject(res);
                                    }
                                }).catch((err) => {
                                    return reject(err);
                                });
                            //}
                        }
                        else return resolve({success: true, notRequired: true});
                    });

                },
                submitLocation(){
                    let thisVue = this;
                    return new Promise(function (resolve, reject) {
                        if(thisVue.selectedShippingLocationId !== thisVue.delivery.shippingLocationId){

                            let payload = {
                                shippingLocationId: thisVue.selectedShippingLocationId,
                                updateEmail: thisVue.getStartedEmail,
                                updatePresets: true
                            };

                            if(thisVue.selectedShippingLocationType === "home-delivery")
                            {
                                payload.shippingPostal = null;
                                payload.shippingAddress = null;
                                payload.shippingAddress2 = null;
                                payload.shippingCity = null;
                                payload.shippingRegion = null;
                            }

                            console.warn('UPDATE LOCATION PAYLOAD:', payload);
                            let req = new UpdateDelivery(payload);
                            req.send().then((res) => {
                                console.warn('UPDATE LOCATION RESPONSE:', res);
                                if(res.success)
                                {
                                    return resolve(res);
                                }
                                else{
                                    return reject(res);
                                }
                            }).catch((err) => { return reject(err); });
                        }
                        else return resolve({success: true, notRequired: true});
                    });

                },
                closeGetStarted(reload){
                    let thisVue = this;

                    if(thisApp.model.reqOptions && thisApp.model.reqOptions.hasOwnProperty('getStarted'))
                    {
                        delete thisApp.model.reqOptions.getStarted;
                    }

                    thisApp.updateUrl(1);

                    //ffSetCustomModalState('getStartedModal', 'closed', null);
                    /*try {
                        let getStartedModal = getSafeAPIValue('mptapi.orderVues.ffCustomGetStarted.vueApp.getStartedModal');
                        if(getStartedModal) getStartedModal._close();
                    } catch { }*/

                    Custombox.modal.closeAll();

                    let getStartedSummary = jMPT('.mpt-current-date-container');
                    getStartedSummary.addClass('ff-get-started-closed');

                    setTimeout(() => {
                        jMPT("#ff-start-modal").css({'position': '', 'top' : ''});
                        jMPT('.mpt-current-date-container').removeClass('ff-get-started-closed');
                    }, 1000);

                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');
                    jMPT(window).off('popstate');

                    if(reload)
                        window.location.reload();
                    else {
                        let orderVue = getSafeAPIValue('mptapi.orderVues.mptOrder.vueApp');
                        if(orderVue)
                        {
                            orderVue.recurrenceChanged(thisVue.getStartedRecurrence);
                        }
                    }
                },
                startGetStartedLoading() {
                    jMPT('.ff-start-form').css('pointer-events', 'none');
                    jMPT('.ff-start-form').css('opacity', '.2');
                    jMPT('#ff-start-modal').append('<i class="start-modal-load fa fa-spin fa-spinner fa-2x mpt-page-loader" style="position: fixed; top: 45%; left: 50%">');
                },
                stopGetStartedLoading() {
                    jMPT('.ff-start-form').css('pointer-events', 'all');
                    jMPT('.ff-start-form').css('opacity', '1');
                    jMPT('.start-modal-load').remove();
                }
            }
        });

        setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;

    }


    static cartSubscriptionStatus(){
        let deliveries = getSafeAPIValue('mptapi.cart.deliveries');
        if(typeof(deliveries) !== 'undefined' && deliveries.length > 0 && deliveries.map(d => {return d.products;}).reduce((agg, thisProdList) => agg.concat(thisProdList)).length > 0) {
            return deliveries.map(d => d.products).reduce((a, b) => a.concat(b)).every(p => p.recurrence !== null) ? 'weekly' : 'single-order';
        }
        else return 'empty';
    }

    static timeSlotMiddleware(timeSlots, locationType){

        let result = [];

        if(!(timeSlots && timeSlots.length > 0))
            return timeSlots;

        result = timeSlots.sort((ts1, ts2)=>{
            let time1 = new Date(ts1.dateTime);
            let time2 = new Date(ts2.dateTime);
            if(time2 < time1)
                return 1;
            if(time2 > time1)
                return -1;
            return 0;
        });

        // if(locationType === 'pickup') {
        //     result = result.filter((ts, i) => i === 0);
        // }

        result = result.map((ts) => {
            try {
                let time1 = new Date(ts.dateTime);
                let time2 = new Date(ts.dateTime.split(' ')[0] + ' ' + ts.end);
                ts.customTSText = shortWindowStringFromDates(time1, time2, '-');

                //TODO: handle override for pickup location time text display HERE
            } catch {
                ts.customTSText = ts.start + '-' + ts.end;
            }

            if(locationType === 'pickup') {
                ts.customTSText = ts.customTSText.replace('4PM-9PM', '3:30PM-8PM');
            }

            return ts;
        });

        return result;
    }

    bindExternalUI(){
        let thisApp = this;

        //jMPT(document).on('click', thisApp.vueApp.hideOptions);

        /*
        jMPT('#ff-start-modal #time').each(function () {

            let $this = jMPT(this), numberOfOptions = jMPT(this).children('option').length;

            $this.addClass('select-hidden');
            $this.wrap('<h3 class="select"></h3>');
            $this.after('<div class="select-styled"></div>');

            var $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.children('option').eq(0).text());

            var $list = jMPT('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            for (var i = 0; i < numberOfOptions; i++) {
                jMPT('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

            var $listItems = $list.children('li');

            $styledSelect.click(function (e) {
                e.stopPropagation();
                jMPT('div.select-styled.active').not(this).each(function () {
                    jMPT(this).removeClass('active').next('ul.select-options').hide();
                });
                jMPT(this).toggleClass('active').next('ul.select-options').toggle();
            });

            $listItems.click(function (e) {
                e.stopPropagation();
                $styledSelect.text(jMPT(this).text()).removeClass('active');
                $this.val(jMPT(this).attr('rel'));
                $list.hide();
                //console.log($this.val());
            });

            jMPT(document).click(function () {
                $styledSelect.removeClass('active');
                $list.hide();
            });

        });*/

    }

    compileSubVues(){
        let thisApp = this;

    }
}


class FFCustomRegister extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('FFCustomRegister', model, reqOptions);

        this.model = model || {
            registerEmail: null,
            registerFirst: null,
            registerLast: null,
            registerPhone: null,
            password: null,
            confirmPassword: null,
            loginPassword: null,
            loginEmail: null,
            loginFailed: null,
            checkEmailValidation: null,
            registerFailed: null,
            validLength: false,
            validNumeric: false,
            validUpper: false,
            validLower: false,
            validForm: false,
            redirectUrl: null,
            validPassword: false,
            validConfirmPassword: false,
            registerModal: {state: 'closed', modal: null},
            turnstileToken: null,
            registerDisabled: true,
            createAccountBtnText: 'Create Account',
            turnstileFailed: null
        };

        this.reqOptions = reqOptions || {};

        if(this.reqOptions.redirectUrl)
            this.model.redirectUrl = this.reqOptions.redirectUrl;

        this.model.reqOptions = this.reqOptions;

        console.warn('S1:', this.model.reqOptions);

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            mounted(){

                let locationParams = locationParamsToJSON(window.location);
                let thisVue = this;

                if(!MPTSession.signedIn())
                {
                    if (locationParams && locationParams.login && (locationParams.login === true || locationParams.login === 'true')) {
                        thisVue.switchToLogin();
                        thisVue.showRegisterModal();
                    }
                    else if (locationParams && locationParams.register && (locationParams.register === true || locationParams.register === 'true')) {
                        thisVue.switchToRegister();
                        thisVue.showRegisterModal();
                    }
                    else jMPT('.ff-login-form').show(); //jMPT('.ff-register-form').show();
                }
            },
            methods: {
                showRegisterModal() {
                    Custombox.modal.closeAll();

                    let thisVue = this;

                    //Removed GetStarted
                    // let getStartedData = MPTSession.checkGetStarted();
                    // if(!thisVue.registerEmail && getStartedData && getStartedData.getStartedEmail)
                    //     thisVue.registerEmail = getStartedData.getStartedEmail;
                    //ffSetCustomModalState('getStartedModal', 'closed', null);
                    //ffSetCustomModalState('userAccountModal', 'closed', null);

                    /*try {
                        let getStartedModal = getSafeAPIValue('mptapi.orderVues.ffCustomGetStarted.vueApp.getStartedModal');
                        if(getStartedModal) getStartedModal._close();
                    } catch { }

                    try {
                        let userAccountModal = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp.userAccountModal');
                        if(userAccountModal) userAccountModal._close();
                    } catch { }*/


                    let locationParams = locationParamsToJSON(window.location);
                    //check if account button was pressed
                    /*if (!locationParams || (!(locationParams.login && (locationParams.login === true || locationParams.login === 'true')) && !(locationParams && locationParams.register && (locationParams.register === true || locationParams.register === 'true')))) {
                        thisVue.switchToRegister();
                    }*/

                    if (!locationParams || (!(locationParams.register && (locationParams.register === true || locationParams.register === 'true')) && !(locationParams && locationParams.login && (locationParams.login === true || locationParams.login === 'true')))) {
                        thisVue.switchToLogin();
                    }

                    let registerForm = jMPT('.ff-register-container');
                    registerForm.attr('data-mobilesettings', '{"content": {"fullscreen": true, "width": "100%", "effect": "push", "animateFrom": "left", "animateTo": "left"}}').css('display:none;');
                    jMPT('html').css('overflow-y', 'hidden');
                    jMPT('body').addClass('mpt-no-scroll');

                    MPTUI.generateModal(".ff-register-container");
                    //ffSetCustomModalState('registerModal', 'open', MPTUI.generateModal(".ff-register-container"));
                    //thisVue.registerModal = MPTUI.generateModal(".ff-register-container");

                    if (jMPT(document).width() <= 1200) {
                        setTimeout(() => {
                            registerForm.css('flex-basis', '100%').css('max-height', '100%');
                            jMPT('.custombox-overlay:visible').css('background-color', 'rgb(230, 230, 230)');
                            jMPT('.custombox-content:visible').css('background-color', 'rgb(230, 230, 230)');
                        }, 250);
                    }



                    jMPT(window).on('popstate', function () {
                        Custombox.modal.closeAll();
                        //ffSetCustomModalState('registerModal', 'closed', null);
                        /*try {
                            let registerModal = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp.registerModal');
                            if(registerModal) registerModal._close();
                        } catch { }*/

                        jMPT('html').css('overflow-y', 'auto');
                        jMPT('body').removeClass('mpt-no-scroll');
                        jMPT(window).off('popstate');
                    });


                },
                switchToLogin(){
                    let thisVue = this;
                    if(thisApp.model.reqOptions.hasOwnProperty('register'))
                    {
                        delete thisApp.model.reqOptions.register;
                    }
                    thisApp.model.reqOptions.login = true;

                    //Removed GetStarted
                    // let getStartedData = MPTSession.checkGetStarted();
                    // if(!thisVue.loginEmail && getStartedData && getStartedData.getStartedEmail)
                    //     thisVue.loginEmail = getStartedData.getStartedEmail;

                    jMPT('.ff-register-form').fadeOut(275);
                    setTimeout(() => { jMPT('.ff-login-form').fadeIn(275); }, 275);
                    thisApp.updateUrl(1);
                },
                resetTurnStile() {
                    let thisVue = this;

                    const widgetContainer = document.getElementById('turnstile-widget');
                    if (widgetContainer && window.turnstile) {
                        window.turnstile.remove(widgetContainer);
                    }
                    thisVue.turnstileToken = null;
                    thisVue.turnstileFailed = null;
                    widgetContainer.innerHTML = '';
                },
                renderTurnStile() {
                    let thisVue = this;
                    thisVue.registerDisabled = true;

                    const widgetContainer = document.getElementById('turnstile-widget');
                    if (!widgetContainer) {
                        console.error('Turnstile widget container not found.');
                        return;
                    }

                    if (window.turnstile) {
                        window.turnstile.remove(widgetContainer);
                    }

                    widgetContainer.innerHTML = '';
                    thisVue.turnstileFailed = null;

                    window.turnstile.render(widgetContainer, {
                        sitekey: '0x4AAAAAAASjNsUtOgBHYFNt',
                        callback: (token) => {
                            thisVue.turnstileToken = token;
                            thisVue.registerDisabled = false;
                            thisVue.turnstileFailed = null;
                        },
                        'error-callback': () => {
                            console.error('Turnstile verification failed.');
                            thisVue.turnstileToken = null;
                            thisVue.registerDisabled = true;
                            thisVue.turnstileFailed = 'Error with human verification, please refresh page and try again.';
                        },
                        'expired-callback': () => {
                            console.warn('Turnstile token expired. Re-rendering Turnstile widget.');
                            thisVue.turnstileToken = null;
                            thisVue.renderTurnStile();
                        },
                    });
                },
                switchToRegister(){
                    let thisVue = this;
                    if(thisApp.model.reqOptions.hasOwnProperty('login'))
                    {
                        delete thisApp.model.reqOptions.login;
                    }
                    thisApp.model.reqOptions.register = true;

                    jMPT('.ff-login-form').fadeOut(275);
                    thisVue.renderTurnStile();
                    setTimeout(() => {
                        jMPT('.ff-register-form').fadeIn(275);
                    }, 275);
                    thisApp.updateUrl(1);
                },
                closeModal(){
                    let thisVue = this;
                    thisVue.resetTurnStile();

                    if(thisApp.model.reqOptions && thisApp.model.reqOptions.hasOwnProperty('register'))
                    {
                        delete thisApp.model.reqOptions.register;
                    }

                    if(thisApp.model.reqOptions && thisApp.model.reqOptions.hasOwnProperty('login'))
                    {
                        delete thisApp.model.reqOptions.login;
                    }

                    thisApp.updateUrl(1);
                    thisApp.model.checkEmailValidation = '';

                    //ffSetCustomModalState('registerModal', 'closed', null);
                    /*try {
                        let registerModal = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp.registerModal');
                        if(registerModal) registerModal._close();
                    } catch { }*/

                    Custombox.modal.closeAll();
                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');
                    jMPT(window).off('popstate');
                },
                backBtnHandler(){
                    let thisVue = this;
                    thisVue.closeModal();

                    let topNav = getSafeAPIValue('mptapi.ffTopNavVue.vueApp');
                    if(topNav)
                        topNav.accountIsOpen = false;

                    let bottomNav = getSafeAPIValue('mptapi.ffBottomNavVue.vueApp');
                    if(bottomNav)
                        bottomNav.accountIsOpen = false;
                },
                validatePassword(){
                    let thisVue = this;
                    let numeric = new RegExp(/^(?=.*\d).+$/);
                    let lower = new RegExp(/^(?=.*[a-z]).+$/);
                    let upper = new RegExp(/^(?=.*[A-Z]).+$/);
                    let length = new RegExp(/^.{6,}$/);

                    thisVue.validNumeric = numeric.test(thisVue.password);
                    thisVue.validLower = lower.test(thisVue.password);
                    thisVue.validUpper = upper.test(thisVue.password);
                    thisVue.validLength = length.test(thisVue.password);


                    thisVue.validPassword = thisVue.validNumeric && thisVue.validLower && thisVue.validUpper && thisVue.validLength;

                    return thisVue.validPassword;
                },
                validateRegisterForm(){
                    let thisVue = this;

                    let isValid = true;
                    isValid = jMPT('.ff-register-container .ff-register-email:visible').ffCustomValidate({required: true, isEmail: true}).isValid && isValid;
                    isValid = jMPT('.ff-register-container .ff-register-first:visible').ffCustomValidate({required: true, maxLength: 200}).isValid && isValid;
                    isValid = jMPT('.ff-register-container .ff-register-last:visible').ffCustomValidate({required: true, maxLength: 200}).isValid && isValid;
                    isValid = jMPT('.ff-register-container .ff-register-phone:visible').ffCustomValidate({required: true, isPhone: true}).isValid && isValid;

                    isValid = isValid && thisVue.validatePassword() && thisVue.matchPasswords();

                    return isValid;
                },
                validateLoginForm(){
                    let thisVue = this;

                    let isValid = true;
                    isValid = jMPT('.ff-register-container .ff-login-email:visible').ffCustomValidate({required: true, isEmail: true}).isValid && isValid;
                    isValid = jMPT('.ff-register-container .ff-login-password:visible').ffCustomValidate({required: true}).isValid && isValid;

                    return isValid;
                },
                matchPasswords(){
                    let thisVue = this;
                    thisVue.validConfirmPassword = thisVue.password === thisVue.confirmPassword;

                    return thisVue.validConfirmPassword;
                },
                submitRegister(){
                    let thisVue = this;

                    thisVue.registerFailed = null;

                    if (!thisVue.turnstileToken) {
                        thisVue.registerFailed = "Please verify you are human.";
                        return;
                    }

                    if(thisVue.validateRegisterForm()) {
                        let registerReq = new Register(thisVue.registerEmail, thisVue.password, thisVue.turnstileToken, {
                            firstName: thisVue.registerFirst,
                            lastName: thisVue.registerLast,
                            phoneNumber: thisVue.registerPhone
                        });

                        thisVue.registerDisabled = true;
                        thisVue.createAccountBtnText = 'Please wait...';

                        registerReq.send().then((x) => {
                            thisVue.registerDisabled = false;
                            thisVue.createAccountBtnText = 'Create Account';

                            if (x.hasOwnProperty("authToken")) {
                                mptapi.savedLocation = false;
                                mptapi.trackGTag('register_form');

                                thisVue.closeModal();
                                thisVue.resetTurnStile();

                                if (!getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')) {
                                    thisVue.checkEmailValidation = 'Please check your email for a link to activate your account. (Check spam/junk folder if you don\'t see the email)'
                                }

                                setTimeout(() => {
                                    let accountVue = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp');
                                    if (accountVue)
                                        accountVue.showModal();
                                }, 600);
                            }
                        }).catch(err => {
                            thisVue.registerDisabled = false;
                            thisVue.createAccountBtnText = 'Create Account';
                            thisVue.registerFailed = 'Hmm, something went wrong.';

                            if (err?.error && err.error.length > 0 && err.error[0]?.errorMessage) {
                                thisVue.registerFailed = err.error[0].errorMessage;
                            }
                            thisVue.renderTurnStile();
                        });
                    }
                },
                setRedirect(url){
                    let thisVue = this;

                    if(url && typeof url === 'string')
                    {
                        thisVue.redirectUrl = url;
                    } else thisVue.redirectUrl = null;
                },
                submitLogin(){
                    let thisVue = this;
                    thisVue.failedLogin = null;
                    if(thisVue.validateLoginForm())
                    {
                        let req = new Login(thisVue.loginEmail, thisVue.loginPassword);
                        req.send().then((x) => {
                            if (x.hasOwnProperty("authToken")) {
                                mptapi.savedLocation = false;
                                mptapi.trackGTag('login_form');
                                if (!thisVue.redirectUrl) {
                                    /*jMPT('.loginLink').hide();
                                    jMPT('.logoutLink').show();*/
                                    thisVue.closeModal();
                                    setTimeout(() => {
                                        let accountVue = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp');
                                        //Remove GetStarted
                                        // if (mptapi.orderVues.mptOrder.vueApp.onGetStarted) {
                                        //     mptapi.orderVues.mptOrder.vueApp.onGetStarted = false;
                                        //     mptapi.orderVues.mptOrder.vueApp.showGetStarted();
                                        // } else
                                        if(accountVue)
                                            accountVue.showModal();
                                    }, 200);
                                } else {
                                    window.location.href = thisVue.redirectUrl;
                                }
                            }
                        }).catch(err => {
                            if(err.error && err.error.length > 0 && err.error[0].errorCode === 2){
                                thisVue.loginFailed = err.error[0].errorMessage ? err.error[0].errorMessage : 'Hmm, looks like that info is incorrect. Try logging in again.';
                            }
                            else thisVue.loginFailed = 'Hmm, something went wrong. Try logging in again.';
                            console.warn(err);
                        });
                    }
                }
            }
        });

        setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;

    }

    compileSubVues(){
        let thisApp = this;

    }
}

class FFCustomUserMenu extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('FFCustomUserMenu', model, reqOptions);

        this.model = model || {
            user: mptapi.user || {},
            userAccountModal: {state: 'closed', modal: null}
        };


        this.reqOptions = reqOptions || {};
        this.model.reqOptions = this.reqOptions;

        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            mounted(){
                let thisVue = this;

                let locationParams = locationParamsToJSON(window.location);
                if (locationParams && locationParams.useraccount && (locationParams.useraccount === true || locationParams.useraccount === 'true')) {
                    thisVue.showModal();
                }
            },
            methods: {
                showModal(){
                    Custombox.modal.closeAll();

                    let thisVue = this;
                    //ffSetCustomModalState('getStartedModal', 'closed', null);


                    if(MPTSession.signedIn()) {
                        //ffSetCustomModalState('registerModal', 'closed', null);
                        /*try {
                            let registerModal = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp.registerModal');
                            if(registerModal) registerModal._close();
                        } catch { }*/

                        if (thisApp.model.reqOptions && (!thisApp.model.reqOptions.hasOwnProperty('useraccount') || !thisApp.model.reqOptions.useraccount || thisApp.model.reqOptions.useraccount !== 'false')) {
                            thisApp.model.reqOptions.useraccount = true;
                            thisApp.updateUrl(1);
                        }

                        let userModal = jMPT('.ff-user-container');
                        userModal.attr('data-mobilesettings', '{"content": {"fullscreen": true, "width": "100%", "effect": "push", "animateFrom": "left", "animateTo": "left"}}').css('display:none;');
                        jMPT('html').css('overflow-y', 'hidden');
                        jMPT('body').addClass('mpt-no-scroll');
                        MPTUI.generateModal(".ff-user-container");

                        //ffSetCustomModalState('userAccountModal', 'open', MPTUI.generateModal(".ff-user-container"));
                        //thisVue.userAccountModal = MPTUI.generateModal(".ff-user-container");

                        if(jMPT(document).width() <= 1200) {
                            setTimeout(() => {
                                userModal.css('flex-basis', '100%').css('max-height', '100%');
                                jMPT('.custombox-overlay:visible').css('background-color', 'rgb(230, 230, 230)');
                                jMPT('.custombox-content:visible').css('background-color', 'rgb(230, 230, 230)');
                            }, 250);
                        }

                        jMPT(window).on('popstate', function () {
                            Custombox.modal.closeAll();
                            //ffSetCustomModalState('userAccountModal', 'closed', null);
                            /*try {
                                let userAccountModal = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp.userAccountModal');
                                if(userAccountModal) userAccountModal._close();
                            } catch { }*/

                            jMPT('html').css('overflow-y', 'auto');
                            jMPT('body').removeClass('mpt-no-scroll');
                            jMPT(window).off('popstate');
                        });
                    }
                    else {
                        let registerModal = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp');
                        if(registerModal)
                        {
                            registerModal.showRegisterModal();
                        }
                    }
                },
                closeModal(){
                    if(thisApp.model.reqOptions && thisApp.model.reqOptions.hasOwnProperty('useraccount'))
                        delete thisApp.model.reqOptions.useraccount;

                    thisApp.updateUrl(1);
                    //ffSetCustomModalState('userAccountModal', 'closed', null);
                    Custombox.modal.closeAll();
                    /*try {
                        let userAccountModal = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp.userAccountModal');
                        if(userAccountModal) userAccountModal._close();
                    } catch { }*/


                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');
                    jMPT(window).off('popstate');
                },
                backBtnHandler(){
                    let thisVue = this;
                    thisVue.closeModal();

                    let topNav = getSafeAPIValue('mptapi.ffTopNavVue.vueApp');
                    if(topNav)
                        topNav.accountIsOpen = false;

                    let bottomNav = getSafeAPIValue('mptapi.ffBottomNavVue.vueApp');
                    if(bottomNav)
                        bottomNav.accountIsOpen = false;
                },
                routeHandler(route){
                    if(route) {
                        switch (route)
                        {
                            case 'account':
                                window.location.href = '/user/#accountinfo';
                                break;
                            case 'orders':
                                window.location.href = '/user/#orders';
                                break;
                            case 'subscriptions':
                                window.location.href = '/user/#subscriptions';
                                break;
                            case 'shipping':
                                window.location.href = '/user/#addresses';
                                break;
                            case 'payment':
                                window.location.href = '/user/#payments';
                                break;
                            case 'referral-code':
                                window.location.href = '/user/#referral-code';
                                break;
                            default:
                                window.location.href = '/user/#accountinfo';
                                break;
                        }
                    }
                },
                logout(){
                    mptapi.logout(true);
                }
            }
        });

        setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;
    }

    compileSubVues(){
        let thisApp = this;

    }
}



class FFCustomNavMenu extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('FFCustomNavMenu', model, reqOptions);

        if(model && model.menuItems && model.menuItems.length > 0) {
            this.model = model;
            this.render();
        } else this.loadNavLinks();
    }

    loadNavLinks(){
        let thisApp = this;
        let wpMenuItems = document.querySelectorAll('.mobile-nav-wrap .menu-item a');
        let menuItems = [];

        if( wpMenuItems.length > 0) {
            for (let i = 0; i < wpMenuItems.length; i++) {
                let navElem = wpMenuItems[i];
                let navText = navElem.text;
                let navHref = navElem.attributes.href.value;

                if (navHref && navText && !['logout', 'login', 'account'].includes(navText.toLowerCase())) {
                    menuItems.push({text: navText, href: navHref, faIcon: false});
                }
            }
        } else{
            this.model = {
                menuItems: [{text: 'Home', href: '/'}]
            };
        }


        thisApp.model = {menuItems: menuItems};
        thisApp.render();
    }

    render() {
        let thisApp = this;
        //this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                showNav(){
                    jMPT('#nav-panel').css('display', 'block');
                    jMPT('#nav-panel').appendTo('.ff-menu-inner');
                    let mobileSlideOut = jMPT(window).width() < 500;
                    if(mobileSlideOut)
                    {
                        jMPT('html').css('overflow-y', 'hidden');
                        jMPT('body').addClass('mpt-no-scroll');
                    }

                    jMPT('.ff-custom-nav-menu').css('left', 0);
                    jMPT('#nav-panel').css('left', 0);

                    //
                    if(mobileSlideOut){
                        jMPT('.ff-custom-nav-menu').css({
                            position: "fixed",
                            top: 0,
                            width: "100vw",
                            height: "100vh",
                        }).addClass("mobile");
                    }
                    else{
                        jMPT('.ff-custom-nav-menu').css({
                            position: "fixed",
                            top: 0,
                            width: "375px",
                            height: "100vh",
                        }).removeClass("mobile");
                    }
                },
                hideNav(){
                    jMPT('.ff-custom-nav-menu').css('left', '-150vw').removeClass("visible");
                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');
                }
            }
        });

        /*setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();*/
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;

    }

    compileSubVues(){
        let thisApp = this;

    }
}




class FFCustomAlertContainer extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('FFCustomAlertContainer', model, reqOptions);

        this.model = model || { alerts: [{
                alertType: 'danger',
                alertIcon: 'fa-exclamation-triangle',
                alertTitle: '',
                alertMessage: '',
                route: '',
                routeMessage: ''
            }] };


        this.render();
    }


    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            mounted(){
                this.refreshAlerts();
            },
            methods: {
                refreshAlerts(newAlerts){
                    let thisVue = this;

                    setAlertTop();

                    thisVue.alerts = newAlerts || [];
                },
                concatAlerts(addedAlerts){
                    let thisVue = this;

                    setAlertTop();

                    if(addedAlerts)
                        thisVue.alerts = [...new Set(thisVue.alerts.concat(addedAlerts))];
                }
            }
        });

        /*setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();*/
    }

    runMiddleware(){
        let thisApp = this;

    }

    bindExternalUI(){
        let thisApp = this;

    }

    compileSubVues(){
        let thisApp = this;

    }
}



class FFBottomNav extends MPTVueComponent
{
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'FFBottomNav';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);

        if(!this.model)
            this.model = {
                isLoggedIn: mptapi.authToken !== null,
                cart: mptapi.cart,
                user: mptapi.user,
                cartIsOpen: false,
                menuIsOpen: false,
                accountIsOpen: false,
                cartCount: 0
            };

        this.render();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                updateCart(newCart){
                    if(newCart) {
                        let thisVue = this;
                        thisVue.cart = newCart;
                    }
                },
                updateUser(){

                },
                accountClick() {
                    let thisVue = this;
                    thisVue.closeCart();
                    thisVue.closeMenu();

                    if(thisVue.accountIsOpen)
                    {
                        thisVue.closeAccount();
                    }
                    else {
                        thisVue.accountIsOpen = true;

                        if(MPTSession.signedIn())
                        {
                            let accountVue = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp');
                            if (accountVue)
                                accountVue.showModal();
                            else
                                window.location.href = '/user';
                        }
                        else {
                            let registerVue = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp');
                            if (registerVue)
                                registerVue.showRegisterModal();
                            else
                                window.location.href = '/user';
                        }
                    }
                },
                cartClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeMenu();

                    if(thisVue.cartIsOpen)
                    {
                        thisVue.closeCart()
                    }
                    else {
                        thisVue.cartIsOpen = true;
                        let cartVue = getSafeAPIValue('mptapi.ffCustomCartVue.vueApp');
                        if(cartVue)
                            cartVue.showCart();
                        else
                            jMPT('.mpt-cart-icon').click();
                    }

                },
                siteMenuClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeCart();

                    if(thisVue.menuIsOpen)
                    {
                        thisVue.closeMenu()
                    }
                    else {
                        thisVue.menuIsOpen = true;
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if(siteMenuVue)
                            siteMenuVue.showNav();
                    }
                },
                closeAccount() {
                    let thisVue = this;

                    if(thisVue.accountIsOpen)
                    {
                        let registerVue = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp');
                        if (registerVue)
                            registerVue.closeModal();

                        let accountVue = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp');
                        if(accountVue)
                            accountVue.closeModal();
                    }

                    thisVue.accountIsOpen = false;
                },
                closeCart() {
                    let thisVue = this;

                    if(thisVue.cartIsOpen)
                    {
                        let cartVue = getSafeAPIValue('mptapi.ffCustomCartVue.vueApp');
                        if(cartVue)
                            cartVue.hideCart();

                        if(jMPT('.mpt-cart-icon').hasClass('visible'))
                            jMPT('.mpt-cart-icon').click();
                    }

                    thisVue.cartIsOpen = false;
                },
                closeMenu() {
                    let thisVue = this;

                    if(thisVue.menuIsOpen) {
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if (siteMenuVue)
                            siteMenuVue.hideNav();
                    }

                    thisVue.menuIsOpen = false;
                }
            }
        });




        this.doneLoad();

        this.compileSubVues();

        this.bindExternalUI();
    }

    bindExternalUI(){
        let thisApp = this;

    }


    sendRequest(){
        let thisApp = this;

    }


    runMiddleware(){
        let thisApp = this;


    }

    compileSubVues() {
        let thisApp = this;

    }
}

class FFTopNav extends MPTVueComponent
{
    constructor(model, reqOptions, appendToSelector, appendOptions, templateOptions){
        if((reqOptions || null) === null)
            reqOptions = locationParamsToJSON(window.location);

        let compName = 'FFTopNav';

        super(compName, model, reqOptions, appendToSelector, appendOptions, null);

        if(!this.model)
            this.model = {
                isLoggedIn: mptapi.authToken !== null,
                cart: mptapi.cart,
                user: mptapi.user,
                cartIsOpen: false,
                menuIsOpen: false,
                accountIsOpen: false,
                cartCount: 0
            };

        this.render();
    }

    render(){
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                updateCart(newCart){
                    if(newCart) {
                        let thisVue = this;
                        thisVue.cart = newCart;
                    }
                },
                updateUser(){

                },
                accountClick() {
                    let thisVue = this;
                    thisVue.closeCart();
                    thisVue.closeMenu();

                    if(thisVue.accountIsOpen)
                    {
                        thisVue.closeAccount()
                    }
                    else {
                        thisVue.accountIsOpen = true;

                        if(MPTSession.signedIn())
                        {
                            let accountVue = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp');
                            if (accountVue)
                                accountVue.showModal();
                            else
                                window.location.href = '/user';
                        }
                        else {
                            let registerVue = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp');
                            if (registerVue)
                                registerVue.showRegisterModal();
                            else
                                window.location.href = '/user';
                        }
                    }
                },
                cartClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeMenu();

                    if(thisVue.cartIsOpen)
                    {
                        thisVue.closeCart()
                    }
                    else {
                        thisVue.cartIsOpen = true;
                        let cartVue = getSafeAPIValue('mptapi.ffCustomCartVue.vueApp');
                        if(cartVue)
                            cartVue.showCart();
                        else
                            jMPT('.mpt-cart-icon').click();
                    }

                },
                siteMenuClick() {
                    let thisVue = this;
                    thisVue.closeAccount();
                    thisVue.closeCart();

                    if(thisVue.menuIsOpen)
                    {
                        thisVue.closeMenu()
                    }
                    else {
                        thisVue.menuIsOpen = true;
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if(siteMenuVue)
                            siteMenuVue.showNav();
                    }
                },
                closeAccount() {
                    let thisVue = this;

                    if(thisVue.accountIsOpen)
                    {
                        let registerVue = getSafeAPIValue('mptapi.ffCustomRegisterVue.vueApp');
                        if (registerVue)
                            registerVue.closeModal();

                        let accountVue = getSafeAPIValue('mptapi.ffCustomUserMenuVue.vueApp');
                        if(accountVue)
                            accountVue.closeModal();
                    }

                    thisVue.accountIsOpen = false;
                },
                closeCart() {
                    let thisVue = this;

                    if(thisVue.cartIsOpen)
                    {
                        let cartVue = getSafeAPIValue('mptapi.ffCustomCartVue.vueApp');
                        if(cartVue)
                            cartVue.hideCart();

                        if(jMPT('.mpt-cart-icon').hasClass('visible'))
                            jMPT('.mpt-cart-icon').click();
                    }

                    thisVue.cartIsOpen = false;
                },
                closeMenu() {
                    let thisVue = this;

                    if(thisVue.menuIsOpen) {
                        let siteMenuVue = getSafeAPIValue('mptapi.siteMenuVue.vueApp');
                        if (siteMenuVue)
                            siteMenuVue.hideNav();
                    }

                    thisVue.menuIsOpen = false;
                }
            }
        });




        this.doneLoad();

        this.compileSubVues();

        this.bindExternalUI();
    }

    bindExternalUI(){
        let thisApp = this;

    }


    sendRequest(){
        let thisApp = this;

    }


    runMiddleware(){
        let thisApp = this;


    }

    compileSubVues() {
        let thisApp = this;

    }
}


class FFCustomProductDetail extends MPTVueComponent
{
    constructor(model, reqOptions, parentOverride){
        super('FFCustomProductDetail', model, reqOptions);

        this.parentOverride = parentOverride;
        this.model = model;



        this.render();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                loadProduct(prod, selectedQty, selectedRecurrence, selectedPackageId, selectedVariations){
                    let thisVue = this;
                    console.warn('Loading product:', prod);
                    thisVue.selectedProduct.id = prod.id;
                    thisVue.selectedProduct.name = prod.name;
                    thisVue.selectedProduct.images = prod.images;
                    thisVue.selectedProduct.description = prod.description;
                    thisVue.selectedProduct.activePrice = prod.activePrice;
                    thisVue.selectedProduct.price = prod.price;
                    thisVue.selectedProduct.orgPrice = prod.activePrice;
                    thisVue.selectedProduct.variations = prod.variations;
                    thisVue.selectedProduct.descriptionSummary = prod.descriptionSummary;
                    thisVue.selectedProduct.compiledDescription = prod.compiledDescription;
                    thisVue.selectedProduct.tags = prod.tags;
                    thisVue.selectedProduct.greenLabel = prod.greenLabel;
                    thisVue.selectedProduct.yellowLabel = prod.yellowLabel;
                    thisVue.selectedProduct.redLabel = prod.redLabel;
                    thisVue.selectedProduct.blueLabel = prod.blueLabel;
                    thisVue.selectedProduct.purpleLabel = prod.purpleLabel;
                    thisVue.selectedProduct.altTagLabel = prod.altTagLabel;
                    thisVue.selectedProduct.addtlInfo = prod.addtlInfo;

                    console.warn('compiled description:', thisVue.selectedProduct.compiledDescription);

                    thisVue.selectedRecordId = null;
                    thisVue.selectedQty = selectedQty || 1;
                    thisVue.selectedRecurrence = selectedRecurrence || { id: null, name: 'Single Order', icons: [], productIds: [] };
                    thisVue.selectedPackageId = selectedPackageId|| null;// TODO: current packageId
                    thisVue.selectedVariations = selectedVariations || [];
                    thisVue.shownVariations = thisVue.selectedProduct.variations.map((v) => {
                        v.level = 0;
                        v.selectedOptions = v.options.filter(o => o.default).map(o => o.id);
                        if(v.selectedOptions.length === 0 && v.type === 'drop-down')
                            v.selectedOptions = v.options.slice(0,1).map(o => o.id);
                        return v;
                    });
                    thisVue.updateInDelivery = [];

                    setTimeout(function(){
                        jMPT('FFCustomProductDetail input[type="checkbox"]:checked').each(function(){
                            jMPT(this).removeAttr('checked');
                        });
                        thisVue.shownVariations.filter(sv => sv.type === 'drop-down').map(sv => thisVue.selectVariationOption(sv));
                        thisVue.slickify();

                    }, 200);
                },
                slickify() {
                    let thisVue = this;
                    try {
                        const sliderNav = jQuery('FFCustomProductDetail .slider-nav');
                        const slickInitialized = jQuery('FFCustomProductDetail .slick-initialized');

                        if (sliderNav.length === 0) {
                            slickInitialized.slick('reinit');
                        } else {
                            slickInitialized.slick('unslick');
                        }
                    } catch {}

                    jMPT('.mpt-fp-product-thumbnail-image').off();

                    let screenwidth = jQuery(window).width();
                    /*let slidesToShow = 1;

                    if(screenwidth <= 960)
                        slidesToShow = 1;
                    else if(screenwidth <= 1080)
                        slidesToShow = Math.min((2 * Math.round(thisVue.categories.length / 2) - 1), 3);
                    else slidesToShow = Math.min((2 * Math.round(thisVue.categories.length / 2) - 1), 5);*/

                    if (thisVue.selectedProduct.images && thisVue.selectedProduct.images.length > 0) {
                        let slidesToShow = thisVue.selectedProduct.images.length;

                        setTimeout(function () {
                            jQuery('FFCustomProductDetail .slider-for').slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                fade: true,
                                asNavFor: 'FFCustomProductDetail .slider-nav'
                            });

                            jQuery('FFCustomProductDetail .slider-nav').slick({
                                slidesToShow: slidesToShow,
                                slidesToScroll: 1,
                                asNavFor: 'FFCustomProductDetail .slider-for',
                                dots: false,
                                centerMode: true,
                                focusOnSelect: true
                            });

                            setTimeout(function() {
                                jMPT('.mpt-fp-product-thumbnail-image').on('mouseover', function() {
                                    jMPT(this).click();
                                });

                            }, 200);
                        }, 150);
                    }
                },
                backToStore(){
                    let thisVue = this;

                    jMPT('FFCustomProductDetail').css({'left': '-150vw', 'top': '0'}).removeClass("visible");
                    jMPT('FFCustomProductDetail .mpt-back-to-store-container').css({
                        opacity: 0,
                        position: 'relative'
                    });
                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');

                    thisApp.model.reqOptions = Object.assign(thisApp.model.reqOptions  || {}, {viewProduct: null});
                    thisApp.updateUrl(1);
                },
                addProductToDelivery(){
                    let addRequest = new AddProductToDelivery(thisApp.model.updateProductId, thisApp.model.updateQty || 1, thisApp.model.updateSelectedVariations, thisApp.model.updateProductName, 0, thisApp.model.updateRecurrence, thisApp.model.updatePackageId); //TODO: packageId
                    addRequest.send().then(addResponse => {
                        mptapi.cartDropdown.getCart(false, addResponse);
                        jMPT('.mpt-cart-icon').addTimedClass("shake");

                        jMPT.createNotification("Success!", "Product added!");
                    });
                },
                recalculatePrice() {
                    let thisVue = this;
                    let calPrice = parseFloat(thisVue.selectedProduct.orgPrice);

                    thisVue.shownVariations.forEach(variation => {
                        if (variation.selectedOptions) {
                            variation.selectedOptions.forEach(selectedOption => {
                                const foundOption = variation.options.find(option => option.id === selectedOption);
                                if (foundOption) {
                                    calPrice += foundOption.price;
                                }
                            })
                        }
                    });

                    if (this.selectedQty) {
                        this.selectedProduct.activePrice = (calPrice * parseInt(this.selectedQty)).toFixed(2);
                    }
                },
                selectVariationOption(variation){
                    let thisVue = this;


                    if(variation) {
                        if(variation.type==='multiselect' || variation.multiselect)
                        {
                            variation.selectedOptions = jMPT('input[type="checkbox"][data-variationid="' + variation.id + '"]:checked').toArray().map(el => {
                                let $this = jMPT(el);
                                return $this.val();
                            });
                        }

                        thisVue.shownVariations = thisVue.shownVariations.filter(sv => sv.parentVariation !== variation.id);

                        let subVariations = variation.options.filter(o => variation.selectedOptions.includes(o.id)).map(full_opt => full_opt.variations || []).reduce((a, b) => a.concat(b));
                        if (subVariations.length > 0)
                        {
                            let varIndex = thisVue.shownVariations.indexOf(variation);


                            let mappedSubvars =  subVariations.map(sv => {
                                sv.level = variation.level + 1;
                                sv.selectedOptions = sv.options.filter(o => o.default).map(o => o.id);
                                if(sv.selectedOptions.length === 0 && sv.type === 'drop-down')
                                    sv.selectedOptions = sv.options.slice(0,1).map(o => o.id);
                                return sv;
                            });

                            let modifiedShownVariations = thisVue.shownVariations;

                            Array.prototype.splice.apply(modifiedShownVariations, [varIndex + 1, 0].concat(mappedSubvars));

                            thisVue.shownVariations = modifiedShownVariations;

                        }

                        this.recalculatePrice();
                    }
                },
                addToCart(onCheckout){
                    let thisVue = this;
                    let deliveryId = this.overrideDeliveryId || mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;

                    //Remove GetStarted
                    // if(!mptapi.cart?.deliveries.length || !deliveryId || !MPTSession.checkGetStarted())
                    // {
                    //     mptapi.orderVues.mptOrder.vueApp.showGetStarted();
                    // }else {

                        jMPT('.ff-add-to-cart').animate({color: '#f04c3c'}, 300);
                        setTimeout(() => {
                            jMPT('.ff-add-to-cart').text("Added!");
                            jMPT('.ff-add-to-cart').animate({color: '#ffffff'}, 300);
                        }, 300);

                        let productId = thisVue.selectedProduct.id;
                        let title = thisVue.selectedProduct.name;
                        let activePrice = thisVue.selectedProduct.activePrice;
                        let price = thisVue.selectedProduct.price;
                        let recurrence = thisVue.selectedRecurrence.id;
                        let variations = thisVue.shownVariations.map(v => {
                            return {
                                id: v.id,
                                options: v.selectedOptions
                            }
                        });
                        let packageId = thisVue.selectedPackageId;
                        let qty = thisVue.selectedQty;

                        if (activePrice) {
                            try {
                                price = parseFloat(activePrice);
                            } catch {}
                        }

                        let addRequest = new AddProductToDelivery(productId, qty, variations, title, price, recurrence, packageId);

                        mptapi.navVue.cartCount += qty;
                        mptapi.ffBottomNavVue.cartCount += qty;

                        let effectiveDate = new Date();
                        addRequest.send().then(response => {
                            if(response && response.success){
                                if(response.cart) {
                                    let cartTotal = 0;
                                    try{
                                        cartTotal = Math.max.apply(null, response.cart.totals.filter(cli => cli.name.toLowerCase().includes('total')).map(cli => { return cli.amount }));
                                    }  catch (errMessage) {
                                        console.error(errMessage);
                                        cartTotal = 0;
                                    }

                                    setTimeout(function(){
                                        const featureContainer = jQuery('#featured-product-container');

                                        if (featureContainer && featureContainer.length) {
                                            featureContainer.slick({
                                                dots: true
                                            });
                                        }
                                    }, 200);

                                    if (onCheckout) {
                                        mptapi.router.data.checkout.cart = {...response.cart, rewards: mptapi.router.data.checkout.cart.rewards};
                                        mptapi.orderVues.mptProductPage.vueApp.renderTemplate('reviewContainer', mptapi.router.data.checkout, null).then(() => {
                                            MPTUI.initCheckout(true);
                                        });
                                    }
                                    try {
                                        mptapi.track('add-to-cart', {
                                            productId: thisVue.selectedProduct.id,
                                            productName: thisVue.selectedProduct.name,
                                            qty: thisVue.selectedQty.toString(),
                                            cartObj: JSON.stringify(response.cart),
                                            price: thisVue.selectedProduct.activePrice.toString(),
                                            cartTotal: cartTotal
                                        });

                                        mptapi.trackGTag('add_to_cart_1');
                                    } catch (errMessage) {
                                        console.error(errMessage);
                                    }
                                }

                                MPTMiddleware.cartMiddleware(response, effectiveDate);


                            }
                        });

                    // }
                },
                addToCartProduct(onCheckout) {
                    let btn = jMPT('.ff-add-to-cart');
                    mptapi.orderVues.mptProductPage.vueApp.addToCart(onCheckout);
                    setTimeout(() => {
                        btn.text("Add to Cart");
                    }, 1000);
                },
                renderTemplate(elementId, setContext, replaceElement) {

                    return new Promise(function (resolve, reject) {
                        let html = '';
                        let t = Handlebars.compile(document.getElementById("checkoutTemplate").innerHTML.decHTML());
                        let context = setContext;

                        //Default Middleware
                        context = MPTMiddleware.flashHandler(context);
                        html += t(context);

                        if (html != null && html !== '') {
                            let element = jMPT('#' + elementId);
                            if (element.length !== 0) {
                                if (replaceElement) {
                                    element.replaceWith(html);
                                } else {
                                    element.html(html);
                                }

                                let event = new CustomEvent("renderedTemplate", {
                                    detail: {
                                        id: elementId
                                    }
                                });
                                if (element.hasOwnProperty("dispatchEvent")) {
                                    element.dispatchEvent(event);
                                } else {
                                    element[0].dispatchEvent(event);
                                }
                            }
                            return resolve(html);
                        }
                        reject(null);
                    });
                }
            }
        });

        setTimeout(function(){
            thisApp.bindExternalUI();
        }, 250);

        this.doneLoad();

        this.compileSubVues();
    }

    runMiddleware(){
        let thisApp = this;
        console.warn('INIT NEW MODEL');

        thisApp.model.selectedProduct = {
            id: '0',
            images: [
                [{
                    url: 'https://www.mealpreptech.com/images/logo2.png',
                    size: 'full'
                },
                    {
                        url: 'https://www.mealpreptech.com/images/logo2.png',
                        size: 'large'
                    }]
            ],
            name: '',
            description: '',
            activePrice: 0,
            price: 0,
            weeklyPrice: 0,
            variations: [{
                id: "blank",
                multiselect: false,
                name: "Size",
                options: [{
                    id: 'blank',
                    text: 'blank',
                    value: 0,
                    sku: 'SKU',
                    category: 'blank',
                    description: 'blank',
                    price: 0,
                    default: false,
                    variations: null,
                    associations: []
                }],
                sku: 'SKU',
                type: 'drop-down',
                variations: null
            }]
        };

        thisApp.model.selectedRecordId = null;
        thisApp.model.selectedQty = 1;
        if (thisApp.model.selectedRecurrence) {
            thisApp.model.selectedRecurrence.icons = [];
            thisApp.model.selectedRecurrence.productIds = [];
        }
        thisApp.model.selectedPackageId = null;// TODO: current packageId
        thisApp.model.selectedVariations = [];
        thisApp.model.shownVariations = [];
        thisApp.model.updateInDelivery = [];

    }

    bindExternalUI(){
        let btn = jMPT('.ff-add-to-cart');

        setTimeout(function(){
            jQuery('.slick-initialized').slick('resize');
            setTimeout(() => { jMPT(document).scrollTop(jMPT('.mpt-fp-product-image-container').offset().top - 150); }, 300);
        }, 250);

        btn.click(handler);

        function handler() {
            mptapi.orderVues.mptProductPage.vueApp.addToCart();
            setTimeout(() => {
                btn.text("Add to Cart");
            }, 1000);
        };
    }

    compileSubVues(){
        let thisApp = this;

        let parentName = thisApp.parentOverride || 'orderVues';

        //TODO: variations
        //mptapi[parentName].mptProductVariations = [];
        //mptapi[parentName].mptProductVariations.push(new MPTProductVariations(thisApp.model, thisApp.reqOptions, thisApp.model.updateVariations, null));
    }
}


class FFCustomFeaturedProducts extends MPTVueComponent
{
    constructor(model, reqOptions){
        super('FFCustomFeaturedProducts', model, reqOptions);

        this.model = model || {};
        this.sendRequest();
    }

    render() {
        let thisApp = this;
        this.runMiddleware();

        this.vueApp = new Vue({ //initialize vue component
            name: thisApp.componentName,
            el: thisApp.componentName,
            data: thisApp.model,
            methods: {
                handleProductClick(prod) {
                    if(hasCustomFeaturedProductRoute())
                    {
                        _mptCustomFeaturedProductScript();
                    }
                    else {
                        window.location.href='/order/?viewProduct=' + prod.id;
                    }
                }
            }
        });
        this.doneLoad();
        this.compileSubVues();
    }

    sendRequest(){
        let thisApp = this;

        let featuredProdReq = new GetFeaturedProducts();
        featuredProdReq.send().then(() => {
            let response = featuredProdReq.response;
            if(response.success && response.hasOwnProperty('products'))
                thisApp.model.products = response.products;
            thisApp.render();
        });
    }


    runMiddleware(){
        let thisApp = this;

        this.model.isMobile = jMPT(document).width() < 600;

        let mdCompiler = null;

        if(window.markdownit) {
            mdCompiler = window.markdownit();
            mdCompiler.disable(["code"]);
        }

        this.model.products = this.model.products.map(function(p){
            p.activePrice = parseFloat(p.price || p.weeklyPrice || "0");


            if(p.variations && p.variations.length === 1 && p.variations[0].options.length === 2) {
                let thisVar = p.variations[0];
                p.quickAdd = false;
                p.quickAdd1Option = false;
                p.quickAdd2Options = {
                    option1: {
                        calculatedBasePrice: p.price + thisVar.options[0].price,
                        calculatedWeeklyPrice: p.weeklyPrice + thisVar.options[0].price
                    },
                    option2: {
                        calculatedBasePrice: p.price + thisVar.options[1].price,
                        calculatedWeeklyPrice: p.weeklyPrice + thisVar.options[1].price
                    }
                };
            }

            if(p.tags.length > 0) {
                p.greenLabel = p.tags.filter(t => t.name.toLowerCase().includes('active')).length > 0;
                p.redLabel = p.tags.filter(t => t.name.toLowerCase().includes('low carb')).length > 0;
                p.yellowLabel = p.tags.filter(t => t.name.toLowerCase().includes('breakfast')).length > 0;
                p.purpleLabel = p.tags.filter(t => t.name.toLowerCase().includes('(purple)')).length > 0;
                p.blueLabel = p.tags.filter(t => t.name.toLowerCase().includes('snack')).length > 0;
                p.altTagLabel = p.tags.filter(t => t.name.toLowerCase().includes('new')).length > 0;
            } else {
                p.redLabel = false;
                p.greenLabel = false;
                p.yellowLabel = false;
                p.purpleLabel = false;
                p.blueLabel = false;
                p.altTagLabel = false;
            }

            if(p.description) {
                if (mdCompiler)
                    p.compiledDescription = mdCompiler.render(p.description);
                else p.compiledDescription = p.description;

                p.descriptionSnapshot = jMPT(p.compiledDescription).text();
                p.descriptionSnapshot = p.descriptionSnapshot.substr(0, Math.min(50, p.descriptionSnapshot.length));
                p.descriptionSnapshot += p.descriptionSnapshot.length > 50 ? '...' : '';
            } else {
                p.compiledDescription = null;
                p.descriptionSnapshot = null;
            }

            const productImages = sortProductImage(p.images);

            if(thisApp.isMobile && productImages.length > 0 && productImages[0].length > 2)
                p.activeImageUrl = productImages[0][2].url;
            else{
                try {
                    p.activeImageUrl = productImages[0][1].url;
                }catch{
                    p.activeImageUrl = '/wp-content/uploads/2021/03/FoodieFit_Logo_Color.png';
                }
            }

            return p;
        });


        this.model.moreOptionsText = "Get Started";
    }

    compileSubVues(){
    }
}

//-------------------------------------------------------------
class MPTMiddleware {

    /**
     * Filteres the shop page and adds in fields
     * @param context
     * @returns {mptdata + {products: *, recurrenceOptions: Array}}
     */
    static shopModelMiddleware(context) {
        let products = context.products;
        let serverSideShopPage = context.companyInfo.uiSettings.serverSideShopPage;
        let additionalCheckoutButton = context.companyInfo.uiSettings.showAdditionalCheckoutButton;
        let compressNutritionalLabels = context.companyInfo.uiSettings.compressNutritionalLabels || false;

		let filters = context.filters;
		if(context.filters.recurrence) {
			let onetime = filters.recurrence.find(x => x.name === null);
			if(onetime){
				onetime.name = "null";
			}
		}

		if (context.filters.groups && context.filters.groups != null && Object.keys(context.filters.groups).length === 0) context.filters.groups = null;

		if(context.filters.groups != null)
        {
            Object.keys(context.filters.groups).forEach(function (key) {
                context.filters.groups[key] = context.filters.groups[key].map(x => {
                    let m = {id: newGuid(), name: x.name, productIds: x.productIds};
                    return m;
                });
            });
        }

        if(context.filters.tags != null)
        {
            context.filters.tags = context.filters.tags.map(x => {
                let m = {id: newGuid(), name: x.name, productIds: x.productIds};
                return m;
            });
        }

        function newGuid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }

		let recurrenceOptions = context.filters.recurrence ? context.filters.recurrence.map(x => x.name) : [];

		let recurrenceSettings = null;
		if(recurrenceOptions != null)
        {
            if(recurrenceOptions.length === 1) //only one option, hide filters
            {
                recurrenceSettings = {
                    hideRecurrenceFilter: true
                };
            }
            else if(recurrenceOptions.length === 2 && recurrenceOptions.filter(x => x === 'null').length === 1) {
                recurrenceSettings = {
                    isBinary: true
                };
            }
        }

		let delivery = mptapi.cart.deliveries.find(x => x.id === (mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId));

        let editableDayOnShop = false;
        if(delivery)
        {
            editableDayOnShop = (context.companyInfo.uiSettings.autoAddDelivery || context.companyInfo.uiSettings.editableDayOnShop);
        }
        else editableDayOnShop = false;

        let alwaysUseMobileFilters = context.companyInfo && context.companyInfo.uiSettings && context.companyInfo.uiSettings.alwaysUseMobileFilters;
        let filterTemplate = (context.companyInfo && context.companyInfo.uiSettings && context.companyInfo.uiSettings.filterTemplate) || 0;
        let fullProductPages = (context.companyInfo.uiSettings && context.companyInfo.uiSettings.fullProductPages);
        let showDatesInShopFilters = (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showDatesInShopFilters);
        let showLocationsInShopFilters = (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showLocationsInShopFilters);
        let categoryFilterRenderType =  (context.companyInfo.uiSettings && context.companyInfo.uiSettings.categoryFilterRenderType) || 'drop-down';

        products = products.map(x => {
			let prod = x;
            // Quickadd flag
            if (x.variations != null) {
                x.quickAdd = x.variations.length === 0;
            }

            x.inCart = typeof mptapi.cart.deliveries.find(d => (d.products.find(p => p.productId === x.id))) !== "undefined";

            // Default Image if none sent
            if (x.images.length === 0) {
                x.images.push({
                    id: "placeholder",
                    url: "https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg"
                });
                x.defaultImage = "placeholder";
            } else {
                x.images = sortProductImage(x.images);
            }

            // Prices for different variations
            /*x.price = (x.price || -1).toFixed(2);
            x.weeklyPrice = (x.weeklyPrice || -1).toFixed(2);
            x.biweeklyPrice = (x.biweeklyPrice || -1).toFixed(2);
            x.monthlyPrice = (x.monthlyPrice || -1).toFixed(2);*/

            // Get Selections

			x.selections = {};
			for(let i = 0; i < recurrenceOptions.length; i++){
				let key = recurrenceOptions[i];
				let product = prod;
                if(delivery) {
                    x.selections[key] = {
                        recordId: delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.id).firstOrDefault(),
                        qty: delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.qty).firstOrDefault(0)
                    };
                } else x.selections[key] = {
                    recordId: null,
                    qty: 0
                }
			}
            /*x.selections = delivery.products.filter(y => y.productId === x.id);
            if (x.selections.length === 1) {
                x.qty = x.selections[0].qty;
            }*/

            try {
                if (compressNutritionalLabels && x.attributes.length > 0) {
                    x.attributes = x.attributes.map(a => {
                        if (a.type === 'nutritionLabel' && a.data && a.data.nutritionLabel && a.data.nutritionLabel.data) {
                            a.data.nutritionLabel.data = a.data.nutritionLabel.data.filter(nlrow => {
                                return nlrow.filter(rCell => {
                                    return rCell.value;
                                }).length >= 2;
                            });
                            if (a.data.nutritionLabel.data.length > 0)
                                return a;
                            else return false;
                        }
                        else return a;
                    }).filter(a => a);
                }
            } catch(err){ console.error(err);}

            return x;
        });



        //set selected recurrence
        /*let selectedRecurrence = recurrenceOptions.find(x => x.value === delivery.recurrence);
        if(selectedRecurrence != null){
            selectedRecurrence.selected = true;
        }else{
            recurrenceOptions[0].selected = true;
        }*/

        let filteredResponse = Object.assign(mptapi.router.data, {shopPage: null}, {
            delivery,
            products,
            filters,
            recurrenceOptions,
            recurrenceSettings,
            serverSideShopPage,
            additionalCheckoutButton,
            compressNutritionalLabels,
            editableDayOnShop,
            fullProductPages,
            alwaysUseMobileFilters,
            filterTemplate,
            showDatesInShopFilters,
            showLocationsInShopFilters,
            categoryFilterRenderType,
            activeSubscriptions: mptapi.activeSubscriptions,
            subscription: Page.isPage("order", "#subscription")
        });

        filteredResponse.shopPage = null;

        if(context.hasOwnProperty("packages")){
        	if(context.packages.length === 1){
        		filteredResponse.package = context.packages[0];
			}
		}
        if(context.products.length > 0 && context.products[0].hasOwnProperty("userChoice") &&  !context.products[0].userChoice){
        	filteredResponse.recurrenceOptions = context.filters.recurrence.map(x => {
        		if(x.name === "null"){
        			x.display = "One Time";
				}else{
        			x.display = x.name.capitalize();
				}
        		return x;
			});
		}
        mptapi.router.data.shopPage = null;
        console.log("[MPT Middleware] Shop Middleware Response", filteredResponse);
        return filteredResponse;
    }

    static productsByCategoryMiddleware(context, currentViewportWidth) {
        let products = context.products;
        let serverSideShopPage = context.companyInfo.uiSettings.serverSideShopPage;
        let additionalCheckoutButton = context.companyInfo.uiSettings.showAdditionalCheckoutButton;
        let compressNutritionalLabels = context.companyInfo.uiSettings.compressNutritionalLabels || false;
        let delivery = mptapi.cart.deliveries.find(x => x.id === (mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId));
        let fullProductPages = (context.companyInfo.uiSettings && context.companyInfo.uiSettings.fullProductPages);
        let showDatesInShopFilters = (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showDatesInShopFilters);
        let showLocationsInShopFilters = (context.companyInfo.uiSettings && context.companyInfo.uiSettings.showLocationsInShopFilters);
        let defaultRecurrenceOptions = ['null', 'weekly','biweekly','monthly'];

        products = products.map(x => {
            let prod = x;

            if (x.variations != null) {
                x.quickAdd = x.variations.length === 0;
            }

            x.inCart = typeof mptapi.cart.deliveries.find(d => (d.products.find(p => p.productId === x.id))) !== "undefined";

            // Default Image if none sent
            if (x.images.length === 0) {
                x.images.push({
                    id: "placeholder",
                    url: "https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg"
                });
                x.defaultImage = "placeholder";
            }

            x.selections = {};
            for(let i = 0; i < defaultRecurrenceOptions.length; i++){
                let key = defaultRecurrenceOptions[i];
                let product = prod;
                if(delivery) {
                    x.selections[key] = {
                        recordId: delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.id).firstOrDefault(),
                        qty: delivery.products.filter(delProduct => delProduct.recurrence === (key === "null" ? null : key) && delProduct.productId === product.id).map(delProduct => delProduct.qty).firstOrDefault(0)
                    };
                } else x.selections[key] = {
                    recordId: null,
                    qty: 0
                }
            }

            try {
                if (compressNutritionalLabels && x.attributes.length > 0) {
                    x.addtlInfo = x.attributes.map(a => {
                        if (a.type === 'nutritionLabel' && a.data && a.data.nutritionLabel && a.data.nutritionLabel.data) {
                            a.data.nutritionLabel.data = a.data.nutritionLabel.data.filter(nlrow => {
                                return nlrow.filter(rCell => {
                                    return rCell.value;
                                }).length >= 2;
                            });
                            if (a.data.nutritionLabel.data.length > 0)
                                return a;
                            else return false;
                        }
                        else return a;
                    }).filter(a => a);
                }
            } catch(err){ console.error(err);}

            return x;
        });

        let filteredResponse = mptapi.router.data = Object.assign(mptapi.router.data, {shopPage:  {
            delivery,
            products,
            filters,
            serverSideShopPage,
            additionalCheckoutButton,
            compressNutritionalLabels,
            fullProductPages,
            showDatesInShopFilters,
            showLocationsInShopFilters,
            activeSubscriptions: mptapi.activeSubscriptions,
            subscription: Page.isPage("order", "#subscription")
        }});

        if(context.hasOwnProperty("packages")){
            if(context.packages.length === 1){
                filteredResponse.package = context.packages[0];
            }
        }

        return filteredResponse;
    }

    static packageMiddleware(context){
        context.activeSubscriptions = mptapi.activeSubscriptions;
        context.hasSubscriptions = mptapi.activeSubscriptions && mptapi.activeSubscriptions.length > 0;
        context.packageContinueOrReset = mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.resetCartOnNewPackageSelection && mptapi.cart && mptapi.cart.deliveries && mptapi.cart.deliveries.filter(d => d.packageid !== null).length > 0;
        context.titleOnlyPackages = mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.titleOnlyPackages;

        if(context.packageContinueOrReset)
        {
            try {
                let existSel = mptapi.cart.deliveries.filter(d => d.packageid !== null).map(d => {
                    return {id: d.id, packageid: d.packageid, deliveryDayName: d.deliveryDayName};
                });

                context.existingSelections = existSel.map(es => {
                    let pkgMatch = context.packages.filter(pkg => pkg.id === es.packageid);
                    if(pkgMatch.length > 0)
                    {
                        es.packageName = pkgMatch[0].name;
                        return es;
                    }
                    else return null;
                }).filter(es => es !== null);

                if(context.existingSelections.length === 0)
                {
                    context.packageContinueOrReset = false;
                }
            }
            catch(err)
            {
                console.error(err);
                context.packageContinueOrReset = false;
            }
        }

        console.warn('package context:', context);
        return context;
    }

    /**
     * Filteres the shop page and adds in fields
     * @param context
     * @returns {mptdata + {products: *, recurrenceOptions: Array}}
     */
    static menuMiddleware(context) {
        let products = context.products;
        let recurrenceOptions = [];
        let categories = [];

        products = products.map(x => {
            // Quickadd flag
            if (x.variations != null) {
                x.quickAdd = x.variations.length === 0;
            }

            // Default Image if none sent
            if (x.images.length === 0) {
                x.images.push({
                    id: "placeholder",
                    url: "https://www.careergirldaily.com/wp-content/uploads/2017/05/Roasted-Salmon-with-Broccolini-and-Sweet-Potato-Meal-Prep-9-200x200.jpg"
                });
                x.defaultImage = "placeholder";
            }

            // Prices for different variations
            x.price = (x.price || -1).toFixed(2);
            x.weeklyPrice = (x.weeklyPrice || -1).toFixed(2);
            x.biweeklyPrice = (x.biweeklyPrice || -1).toFixed(2);
            x.monthlyPrice = (x.monthlyPrice || -1).toFixed(2);
            for(let i = 0, length = x.categories.length; i < length; i++){
                let cat = x.categories[i];
                if(categories.indexOf(cat) < 0){
                    categories.push(cat);
                }
            }

            return x;
        });

        let filteredResponse = Object.assign({}, mptapi.router.data, {shopPage: null}, {
            products,
            recurrenceOptions,
            categories
        });
        console.log("[MPT Middleware] Shop Middleware Response", filteredResponse);
        return filteredResponse;
    }

    static deliveriesMiddleware(context){
    	let packageId = mptapi.router.data.packageId;
    	let newContext = Object.assign({}, context);
    	if(typeof packageId !== "undefined" && packageId !== ""){
    		newContext.deliveries = context.deliveries.filter(x => x.packageid === packageId && x.products.length > 0);
		}
    	newContext.activeSubscriptions = mptapi.activeSubscriptions;
    	newContext.hasSubscriptions = mptapi.activeSubscriptions && mptapi.activeSubscriptions.length > 0;
    	console.log("[MPT Middleware] Deliveries Middleware Response", newContext);
    	return newContext;
	}

    static POSMiddleware(context){
        let products = context.products;
        let filters = context.filters;
        let companyInfo = context.companyInfo;
        products = products.map(x => {
            if (x.variations != null) {
                x.quickAdd = x.variations.length === 0;
            }
        });
        let response = Object.assign({}, mptapi.router.data, {shopPage: null}, {
            products,
            filters,
            companyInfo
        });
        console.log("POS Middleware Response", response);
        return response;
    }

    static filterByEmailModifierRule(context) {
        return context.deliveryLocations.filter(deliveryLocation => {
            if (deliveryLocation.attributes && deliveryLocation.attributes.prohibitedRules) {
                const foundEmailRule = deliveryLocation.attributes.prohibitedRules.find(prohibitedRule => prohibitedRule.variable === 'userEmail');
                if (foundEmailRule) {
                    const emailList = JSON.parse(foundEmailRule.value);
                    const index = emailList.findIndex(email => {
                        return email.toLowerCase() === context.user.email.toLowerCase();
                    });
                    if (index === -1) {
                        return false;
                    }
                }
            }

            return true;
        });
    }

    static checkoutPage(context) {
        context.deliveryLocations = MPTMiddleware.filterByEmailModifierRule(context);
        context.selectedShipping = context.cart.deliveries.filter(x => x.shippingLocationId != null).map(x => {
            return {
                deliveryId: x.id,
                locationId: x.shippingLocationId,
                location: context.deliveryLocations.find(y => y.id === x.shippingLocationId),
                address: {
                    firstName: context.cart.deliveries[0].shippingFirstName,
                    lastName: context.cart.deliveries[0].shippingLastName,
                    address: context.cart.deliveries[0].shippingAddress,
                    address2: context.cart.deliveries[0].shippingAddress2,
                    city: context.cart.deliveries[0].shippingCity,
                    region: context.cart.deliveries[0].shippingRegion,
                    postal: context.cart.deliveries[0].shippingPostal,
                    phone: context.cart.deliveries[0].shippingPhone,
                    instructions: context.cart.deliveries[0].shippingInstructions
                }
            };
        });

        context.deliveryLocations.forEach(deliveryLocation => {
            if (deliveryLocation.type === 'pickup') {
                deliveryLocation.description = `Order will be ready by ${context.cart.deliveries[0].deliveryDayName.replace('04:00 PM', '03:30 PM - 08:00 PM').replace('08:00 AM', '08:00 AM - 12:00 PM')}`;
            }
        });

        context.savedLocation = mptapi.savedLocation;

        context.activeSubscriptions = mptapi.activeSubscriptions;
        context.hasSubscriptions = mptapi.activeSubscriptions && mptapi.activeSubscriptions.length > 0;
        context.enforcedSubOverwriteMode = enforceSubEdits() && context.hasSubscriptions;

        context.selectedBilling = (context.cart.billingProfileId != null) ? context.billingProfiles.find(x => x.id === context.cart.billingProfileId) : null;

        if (context.featuredProducts) {
            let mdCompiler = null;

            if(window.markdownit) {
                mdCompiler = window.markdownit();
                mdCompiler.disable(["code"]);
            }

            context.featuredProducts.forEach(featureProduct => {
                if (featureProduct.images && featureProduct.images.length) {
                    featureProduct.activeImageUrl = featureProduct.images[0][2].url;
                }

                featureProduct.altTagLabel = featureProduct.tags.filter(t => t.name.toLowerCase().includes('new')).length > 0 ? 'New' : '';
                featureProduct.activePrice = featureProduct.price;

                if (mdCompiler) {
                    featureProduct.compiledDescription = mdCompiler.render(featureProduct.description);
                } else {
                    x.compiledDescription = x.description;
                }
            })
        }

        //console.log("[MPT Middleware] Checkout Middleware Response", context);
        return context;
    }

    static cartMiddleware(context, onUpdate){
    	context.cart.deliveries.forEach(delivery => {
          if(delivery.hasOwnProperty('nextDeliveryFrom') && delivery.nextDeliveryFrom)
          {
              try {
                  let ndf = new Date(delivery.nextDeliveryFrom);
                  let ndt = new Date(delivery.nextDeliveryTo);
                  delivery.dayShort = ndf.toShortDateString();
                  delivery.windowShort = shortWindowStringFromDates(ndf, ndt, ' - ')
              } catch {
                  delivery.dayShort = null;
                  delivery.windowShort = null;
              }
          } else {
              delivery.dayShort = null;
              delivery.windowShort = null;
          }

    	    if(typeof delivery.products !== 'undefined') {
                delivery.products.forEach(product => {
                    product.recurrenceOptions.map(x => {
                        x.recurrenceDisplay = x.recurrence == null ? "One-time" : x.recurrence.capitalize();
                        if (x.recurrence === null) x.recurrence = "null";
                        return x;
                    });
                    /**
                     * Set the type of recurrence selector
                     * If 1 option, show none
                     * If 2 options, show a toggle
                     * if > 2 options, show dropdown
                     */
                    product.recurrenceSelector = product.recurrenceOptions.length === 1 ? "none" : product.recurrenceOptions.length === 2 ? "toggle" : "dropdown";
                    product.selectedRecurrence = product.recurrenceOptions.find(x => x.selected);
                });
            }
		});


        context.addMoreText = "Add Delivery";
        let addMoreTextOverwritten = false;
        let isEmpty = true;
        try {
            isEmpty = context.cart.deliveries.length === 0;
        }catch(err){ isEmpty = true; }

        if(context.companyInfo) {
            if (context.companyInfo.uiSettings) {
                if (context.companyInfo.uiSettings.textOverrides) {
                    if (isEmpty && context.companyInfo.uiSettings.textOverrides.emptyAddDeliveryText) {
                        context.addMoreText = context.companyInfo.uiSettings.textOverrides.emptyAddDeliveryText;
                        addMoreTextOverwritten = true;
                    }
                    else if (context.companyInfo.uiSettings.textOverrides.addDeliveryText) {
                        context.addMoreText = context.companyInfo.uiSettings.textOverrides.addDeliveryText;
                        addMoreTextOverwritten = true;
                    }
                }

                if (!addMoreTextOverwritten && context.companyInfo.uiSettings.autoAddDelivery) {
                    context.addMoreText = "Shop";
                    addMoreTextOverwritten = true;
                }
            }

            if (!addMoreTextOverwritten && context.companyInfo.hasPackages) {
                context.addMoreText = "Add Package";
            }
        }

        if(mptapi.storeVues && context.cart) { //go through all store vues that have cart data in their models
            if (mptapi.storeVues.mptBottomCheckoutBar && mptapi.storeVues.mptBottomCheckoutBar.vueApp) {
                let cartModel = new MPTCartModel(context.cart);
                mptapi.storeVues.mptBottomCheckoutBar.vueApp.updateCart(cartModel);
            }
        } else updateGlobalCartObjects(context.cart);

        if (mptapi.router.page === 'checkout' && onUpdate) {
            mptapi.router.data.checkout.cart = {...context.cart, rewards: mptapi.router.data.checkout.cart.rewards};
            mptapi.orderVues.mptProductPage.vueApp.renderTemplate('reviewContainer', mptapi.router.data.checkout, null).then(() => {
                MPTUI.initCheckout(true);
            });
        }
		return context;
	}

    static loginRedirect(context) {
        let redirectUrl = "/account";
        if (context.hasOwnProperty("success")) {
            if (context.success) {
                window.location = redirectUrl;
            } else {

            }
        }
    }

    static productMiddleware(context){
        context.deliveryId = mptapi.router.data.deliveryId;
        return context;
    }

    static requireAuthentication(currentPage, redirect) {
        return function () {
            if (mptapi.authToken == null) {
                mptapi.router.redirect(redirect);
                return false;
            } else {
                return true;
            }
        };
    }

    static flashHandler(context) {
        if (mptapi.router.flashData.length > 0) {
            context.flash = mptapi.router.flashData;
        }
        return context;
    }

    static agreementsMiddleware(context){
        context.agreements = context.agreements.filter(x => x.dateSigned != null && x.url != null);
        return context;
    }
}

//-------------------------------------------------------------
const PUT = "PUT";
const DELETE = "DELETE";
const GET = "GET";
const POST = "POST";
/**
 * Error Codes Enum
 * @typedef {Object} ErrorCodes
 * @property {Number} UnauthorizedAPI failure in the Authorization header
 * @property {Number} InvalidLogin failed attempt to login or register
 * @property {Number} UnauthorizedUser authtoken did not validate (may have expired)
 * @property {Number} InvalidFormat missing necessary fields in the request
 * @property {Number} OperationFailed an error occurred in saving the data to the db
 * @property {Number} BadRequest request format wasn't recognized at all
 * @property {Number} UncaughtException 500 error was uncaught
 * @property {Number} NoBilling
 * @property {Number} InvalidCartNoLocation
 * @property {Number} InvalidCartBadHomeAddress
 * @property {Number} InvalidCartViolatedDeliveryRule
 * @property {Number} InvalidCartEmpty
 * @property {Number} InvalidCartModified
 * @property {Number} InvalidAddress
 * @property {Number} InvalidAddress2
 * @property {Number} InvalidCity
 * @property {Number} InvalidRegion
 * @property {Number} InvalidPostal
 */
/**
 * ErrorCodes
 * @type {ErrorCodes}
 */
const ErrorCodes = {
    'UnauthorizedAPI': 0,
    'InvalidLogin': 1,
    'UnauthorizedUser': 2,
    'InvalidFormat': 3,
    'OperationFailed': 4,
    'BadRequest': 5,
    'UncaughtException': 6,
    'NoBilling': 7, //billingProfileId is blank and no new billing was sent with checkout
    'InvalidCartNoLocation': 8, //shipping applied to cart is invalid
    'InvalidCartBadHomeAddress': 9, //home location is missing information or has bad data
    'InvalidCartViolatedDeliveryRule': 10, //prohibited rule violated
    'InvalidCartEmpty': 11, //cart is empty
    'InvalidCartModified': 12, //cart was modified on this request (happens when checkout/validation request caught outdated items/deliveries and automatically modified)
    'InvalidAddress': 13,
    'InvalidAddress2': 14,
    'InvalidCity': 15,
    'InvalidRegion': 16,
    'InvalidPostal': 17
};

const urls = {
    production: 'https://mptapi20170804072902.azurewebsites.net/',
    staging: "https://mptapiv2staging.azurewebsites.net/",
    dev: "https://mptapiv2dev.azurewebsites.net/",
    local: "http://localhost:52313/"
};

const ErrorMap = {
    101: '#monthlyIncome',
    102: '#employer',
    103: '#birthdate',
    104: '#ssn',
    105: '#billingfirstName',
    106: '#billinglastName',
    107: '#cc-cvv',
    108: '#cc-expiration-month'
};

let overrideURL = (localStorage && localStorage.overrideURL) ? localStorage.overrideURL : null;

let activeURL = () => (mptsettings.options.api_environment && mptsettings.options.api_environment !== "" && overrideURL == null) ? urls[mptsettings.options.api_environment] : (overrideURL == null) ? urls.staging : overrideURL;

let _btmNavCount = 3;

let numRequest = 0;

//This class is meant to establish a session with all of a user's persisting properties.
class MPTSession {
    constructor(options, fromSession) {
        let session = this;
        const defaults = {
            url: (mptsettings.options.api_environment && mptsettings.options.api_environment !== "" && overrideURL == null) ? urls[mptsettings.options.api_environment] : (overrideURL == null) ? urls.staging : overrideURL,
            authToken: null,
            clientCartId: null,
            ip: null,
            requestHistory: [],
            router: null,
            debug: true,
            locked: false
        };

        Object.assign(this, defaults, options); // Merge options and presets into self

        MPTSession.configurePace(this);
        MPTSession.initSlaask(this);
        MPTSession.initGAnalytics(this);
        MPTSession.initAPIs(this);
        MPTSession.initGlobalScripts(this);
    }

    static signedIn() {
        if (mptapi.authToken != null) {
            return new Date() <= new Date(mptapi.authToken.expirationUTC);
        }
        return false;
    }


    static fromJSON(serializedJson, newOptions = {}, routerOptions = {}) {
        let sessionObj = Object.assign(new MPTSession({}, true), JSON.parse(serializedJson), newOptions);
        MPTSession.configurePace(this);
        MPTSession.initSlaask(sessionObj);
        MPTSession.initGAnalytics(sessionObj);
        MPTSession.initGlobalScripts(sessionObj);
        return sessionObj;
    }

    logout(allSessions) {
        if(getSafeAPIValue('user.isGuestAcct')) {
            let guestLogoutDialog = confirm("Are you sure? This is a guest account, so you won't be able to review order after you logout!");
            if(guestLogoutDialog === true) {
                let logoutReq = new Logout(allSessions);
                logoutReq.sendAndClear();
            }
        }
        else {
            let logoutReq = new Logout(allSessions);
            logoutReq.sendAndClear();
        }
    }

    trackGTag(eventType) {
        if(gaActive()) {
            gtag('event', eventType);
        }
    }

    track(eventType, data) {
        console.warn('trackevent:', eventType);
        try {
            let trackingReq = new TrackEvent(eventType, data);
            trackingReq.send();

            if(!gaActive() && typeof dataLayer === 'object') //If google analytics isn't directly configured and the google data layer is present, then report event to dataLayer for tag manager integration
                if(eventType && eventType !== 'page-view')
                {
                    if(eventType === 'conversion' && data && data.conversionAmount)
                    {
                        try{ dataLayer.push({'event': eventType,'conversionValue': data.conversionAmount}); } catch{}
                    }
                    else try{ dataLayer.push({'event': eventType }); } catch{}

                }

        }catch(err)
        {
            console.warn("Unable to Track Events: " + err);
        }
    }

    log(message) {

    }

    warn(message) {

    }

    error(message) {

    }

    save() {
        console.log('Saving mpt session...');
        try {
            if (this)
                if (this.router.clearData) {
                    this.router.data = {};
                    this.router.modals = [];
                    //this.router.redirectUrl = "";
                }
            if (this.router.clearProps.length > 0) {
                this.router.clearProps.forEach(x => {
                    delete this.router.data[x];
                });
                this.router.clearProps.splice(0, this.router.clearProps.length);
            }

            if (this.router.data && this.router.data.shopPage)
                delete this.router.data.shopPage;

            this.router.clearData = true;

            if (this.storeVues)
                delete this.storeVues;

            if (this.orderVues)
                delete this.orderVues;

            if (this.siteMenuVue)
                delete this.siteMenuVue;

            if (this.ffBottomNavVue)
                delete this.ffBottomNavVue;

            if (this.ffCustomCartVue)
                delete this.ffCustomCartVue;

            if (this.ffCustomAlertVue)
                delete this.ffCustomAlertVue;

            if (this.ffCustomRegisterVue)
                delete this.ffCustomRegisterVue;

            if (this.ffCustomUserMenuVue)
                delete this.ffCustomUserMenuVue;

            if (this.navVue)
                delete this.navVue;

            if(this.ffTopNavVue)
                delete this.ffTopNavVue;

            if(this.topNavVue)
                delete this.topNavVue;

            if (this.addNewDayVue)
                delete this.addNewDayVue;

            if (this.updateCheckoutDayVue)
                delete this.updateCheckoutDayVue;

            if (this.buyVues)
                delete this.buyVues;

            if (this.customProductVues)
                delete this.customProductVues;

            localStorage.setItem("MPTSession", JSON.stringify(this));
            console.log('Session saved.');
        } catch (err) {
            console.error("Could not save MPTSession. " + err);
        }
    }

    static configurePace(session)
    {
        Pace.options.ajax = false;
    }

    static initSlaask(session) {
        Pace.ignore(function(){
            if (session.hasOwnProperty('companyInfo') && session.companyInfo.hasOwnProperty('uiSettings') && session.companyInfo.uiSettings.slaaskKey) {
                !function () {
                    let sElem = document.createElement("script");
                    sElem.src = "https://cdn.slaask.com/chat.js", sElem.type = "text/javascript", sElem.async = "true", sElem.onload = sElem.onreadystatechange = function () {
                        let state = this.readyState;
                        if (!state || "complete" == state || "loaded" == state) try {
                            _slaask.init(session.companyInfo.uiSettings.slaaskKey);
                            /*setTimeout(function(){
                                Pace.stop();
                            }, 1500);*/
                        } catch (state) {
                        }
                    };
                    let t = document.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(sElem, t)
                }();
            }
        });
    }

    static initGAnalytics(session) {
        /*Pace.ignore(function() {
            if (session.hasOwnProperty('companyInfo') && session.companyInfo.hasOwnProperty('uiSettings') && session.companyInfo.uiSettings.googleAnalyticsTID && gaActive() {
                ga('require', 'ecommerce');
            }
        });*/


        /*Pace.ignore(function() {
            if (session.hasOwnProperty('companyInfo') && session.companyInfo.hasOwnProperty('uiSettings') && session.companyInfo.uiSettings.googleAnalyticsTID) {
                !function () {
                    let gElem = document.createElement("script");
                    gElem.src = "https://www.googletagmanager.com/gtag/js?id=" + session.companyInfo.uiSettings.googleAnalyticsTID, gElem.type = "text/javascript", gElem.async = "true", gElem.onload = gElem.onreadystatechange = function () {
                        let state = this.readyState;
                        if (!state || "complete" == state || "loaded" == state) try {
                            window.dataLayer = window.dataLayer || [];
                            gtag('js', new Date());
                            gtag('config', session.companyInfo.uiSettings.googleAnalyticsTID);
                        } catch (state) {
                        }
                    };
                    let t = document.getElementsByTagName("head")[0];
                    t.appendChild(gElem);
                }();
            }

            function gtag() {
                dataLayer.push(arguments);
            }
        });*/
    }

    static initAPIs(session) {
        const placesKey = getSafeValue(session, 'companyInfo.googleapis.places') || 'AIzaSyBgA2CcTH4WYegclv-a2tvXZ04D2PZjWB8';

        if(placesKey)
        {
            jMPT('head').append('<script async src="https://maps.googleapis.com/maps/api/js?key=' + placesKey + '&libraries=places"></script>');
        }
    }

    /*Any search forms in the theme should be redirected to the shop*/
    static initGlobalScripts(session) {
        document.addEventListener('click', function(evt) {
            try{
                /*CUSTOM FOR FOODIE*/
                if(Array.from(evt.target.classList).includes('custombox-close'))
                {
                    console.warn('evt:', evt);
                    jMPT('html').css('overflow-y', 'auto');
                    jMPT('body').removeClass('mpt-no-scroll');
                    let topNav = getSafeAPIValue('mptapi.ffTopNavVue.vueApp');
                    if(topNav && topNav.accountIsOpen) {
                        topNav.closeAccount();
                    }

                    let bottomNav = getSafeAPIValue('mptapi.ffBottomNavVue.vueApp');
                    if(bottomNav && bottomNav.accountIsOpen) {
                        bottomNav.closeAccount();
                    }

                    if(evt.target.id === 'custombox-.ff-start-container')
                    {
                        let getStartedSummary = jMPT('.mpt-current-date-container');
                        //let minimizeTarget = -(jMPT("#ff-start-modal").height() / 2) + getStartedSummary.position().top;
                        let minimizeTarget = -420;
                        jMPT("#ff-start-modal").css('position', 'absolute').animate({ 'top': minimizeTarget }, 200);
                        getStartedSummary.addClass('ff-get-started-closed');

                        setTimeout(() => {
                            jMPT("#ff-start-modal").css({'position': '', 'top' : ''});
                            jMPT('.mpt-current-date-container').removeClass('ff-get-started-closed');
                        }, 1000);

                    }

                }
            } catch{}

        });

        /*
        document.addEventListener('custombox:overlay:close', function() {


            setTimeout(() => {

                let topNav = getSafeAPIValue('mptapi.ffTopNavVue.vueApp');
                if(topNav && top.accountIsOpen) {
                    topNav.closeAccount();
                }

                let bottomNav = getSafeAPIValue('mptapi.ffBottomNavVue.vueApp');
                if(bottomNav && bottomNav.accountIsOpen) {
                    bottomNav.closeAccount();
                }

            }, 200);

        });*/

        /* TODO: CUSTOM POPUP NOTIFICATIONS
        if (session.companyInfo && session.companyInfo.popups && session.companyInfo.popups.constructor === Array) {
            let popups = session.companyInfo.popups;
            for(let i = 0; i < popups.length; i++)
            {
                if(popups[i].showOnLoad)
                {
                    MPTUI.generateModal('#customPopup', {content: {width: "80%"}}, {content: {width: "100%"}});
                }
            }
        }*/

        updateCopyright();

        let existingDropShadow = jMPT('#mpt-drop-shadow');
        if(existingDropShadow.length === 0)
            jMPT('body').append(' <svg height="0" xmlns="http://www.w3.org/2000/svg">        <filter id="mpt-drop-shadow">            <feGaussianBlur in="SourceAlpha" stdDeviation="4"/>            <feOffset dx="10" dy="10" result="offsetblur"/>            <feFlood flood-color="rgba(0,0,0,0.2)"/>            <feComposite in2="offsetblur" operator="in"/>            <feMerge>                <feMergeNode/>                <feMergeNode in="SourceGraphic"/>            </feMerge>        </filter>    </svg>');

        if(jMPT('MPTBottomNav').length === 0) {
            jMPT('body').append(jMPT('<MPTBottomNav>', {css: 'display:none;'}));
        }

        if(jMPT('FFCustomAlertContainer').length === 0) {
            jMPT('body').append(jMPT('<FFCustomAlertContainer>', {css: 'display:none;'}));
        }

        if(jMPT('MPTTopNav').length === 0) {
            jMPT('.header-main').prepend(jMPT('<MPTTopNav>', {css: 'display:none;'}));
        }

        if(jMPT('FFTopNav').length === 0) {
            jMPT('body').prepend(jMPT('<FFTopNav>', {css: 'display:none;'}));
        }

        if(jMPT('MPTCartPreOrderDays').length === 0) {
            jMPT('body').append(jMPT('<MPTCartPreOrderDays>', {css: 'display:none;'}));
        }

        if(jMPT('MPTCheckoutPreOrderDays').length === 0) {
            jMPT('body').append(jMPT('<MPTCheckoutPreOrderDays>', {css: 'display:none;'}));
        }

        if(jMPT('FFCustomNavMenu').length === 0) {
            jMPT('body').append(jMPT('<FFCustomNavMenu>', {css: 'display:none;'}));
        }

        if(jMPT('FFBottomNav').length === 0) {
            jMPT('body').append(jMPT('<FFBottomNav>', {css: 'display:none;'}));
        }

        if(jMPT('FFCustomAlertContainer').length === 0) {
            jMPT('body').append(jMPT('<FFCustomAlertContainer>', {css: 'display:none;'}));
        }

        if(jMPT('FFCustomCart').length === 0) {
            jMPT('body').append(jMPT('<FFCustomCart>', {css: 'display:none;'}));
        }

        if(jMPT('FFCustomRegister').length === 0) {
            jMPT('body').append(jMPT('<FFCustomRegister>', {css: 'display:none;'}));
        }

        if(jMPT('FFCustomUserMenu').length === 0) {
            jMPT('body').append(jMPT('<FFCustomUserMenu>', {css: 'display:none;'}));
        }

        if(!mptapi.navVue || !mptapi.navVue.vueApp || !mptapi.navVue.vueApp._isVue || mptapi.navVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.navVue = new MPTBottomNav(null, null);
            }, 200);
        }

        if(!mptapi.topNavVue || !mptapi.topNavVue.vueApp || !mptapi.topNavVue.vueApp._isVue || mptapi.topNavVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.topNavVue = new MPTTopNav(null, null);
            }, 200);
        }

        if(!mptapi.addNewDayVue || !mptapi.addNewDayVue.vueApp || !mptapi.addNewDayVue.vueApp._isVue || mptapi.addNewDayVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.addNewDayVue = new MPTCartPreOrderDays(null, null);
            }, 200);
        }

        if(!mptapi.updateCheckoutDayVue || !mptapi.updateCheckoutDayVue.vueApp || !mptapi.updateCheckoutDayVue.vueApp._isVue || mptapi.updateCheckoutDayVue.vueApp._isDestroyed) {
            setTimeout(function () {
                mptapi.updateCheckoutDayVue = new MPTCheckoutPreOrderDays(null, null);
            }, 200);
        }

        if(!mptapi.siteMenuVue || !mptapi.siteMenuVue.vueApp || !mptapi.siteMenuVue.vueApp._isVue || mptapi.siteMenuVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.siteMenuVue = new FFCustomNavMenu(null, null);
            }, 200);
        }

        if(!mptapi.ffBottomNavVue || !mptapi.ffBottomNavVue.vueApp || !mptapi.ffBottomNavVue.vueApp._isVue || mptapi.ffBottomNavVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.ffBottomNavVue = new FFBottomNav(null, null);
            }, 200);
        }

        if(!mptapi.ffTopNavVue || !mptapi.ffTopNavVue.vueApp || !mptapi.ffTopNavVue.vueApp._isVue || mptapi.ffTopNavVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.ffTopNavVue = new FFTopNav(null, null);
            }, 200);
        }

        if(!mptapi.ffCustomAlertVue || !mptapi.ffCustomAlertVue.vueApp || !mptapi.ffCustomAlertVue.vueApp._isVue || mptapi.ffCustomAlertVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.ffCustomAlertVue = new FFCustomAlertContainer(null, null);
            }, 200);
        }

        if(!mptapi.ffCustomCartVue || !mptapi.ffCustomCartVue.vueApp || !mptapi.ffCustomCartVue.vueApp._isVue || mptapi.ffCustomCartVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.ffCustomCartVue = new FFCustomCart({cart: mptapi.cart, currentSubtotal: FFCustomCart.getRelevantSubtotal(mptapi.cart)}, null);
            }, 200);
        }

        if(!mptapi.ffCustomRegisterVue || !mptapi.ffCustomRegisterVue.vueApp || !mptapi.ffCustomRegisterVue.vueApp._isVue || mptapi.ffCustomRegisterVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.ffCustomRegisterVue = new FFCustomRegister(null, null);
            }, 200);
        }

        if(!mptapi.ffCustomUserMenuVue || !mptapi.ffCustomUserMenuVue.vueApp || !mptapi.ffCustomUserMenuVue.vueApp._isVue || mptapi.ffCustomUserMenuVue.vueApp._isDestroyed)
        {
            setTimeout( function() {
                mptapi.ffCustomUserMenuVue = new FFCustomUserMenu(null, null);
            }, 200);
        }

        jMPT( ".form-search" ).submit(function(e) {
            e.preventDefault();
            let searchVal = jMPT('.search-query').val();
            if(mptapi.companyInfo && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage)
            {
                mptapi.router.redirect('store', '?qry=' + searchVal);
            }else
                mptapi.router.redirect("shop", "#products", { qry: searchVal, cat: null, catName: null, pn: null });
        });

        //override contact forms to utilize crm if set up
        if (session.hasOwnProperty('companyInfo') && session.companyInfo.hasOwnProperty('overrideContactForms') && session.companyInfo.overrideContactForms === true) {
            if(jMPT('.wpcf7-submit').closest('form').length > 0) {
                jMPT('.wpcf7-submit').closest('form').submit(function(e){
                    e.preventDefault();

                    if(jMPT('.wpcf7-form-control[aria-invalid="true"]').length === 0)//validate
                    {
                        let customFields = {};
                        jMPT('.contact-other').each(function() {
                            let elem = jMPT(this);
                            if(elem.is('input, select, textarea')) {
                                try{ customFields[elem.attr('name') || elem.attr('id')] = elem.val();}
                                catch (err) { console.error('could not serialize input: ' + elem.attr('id') || elem.attr('name') + '\n' + err); }
                            }
                            else if(elem.attr('type') === "checkbox") {
                                let value = elem.parent.find('input:checked').toArray().map(x => jMPT(x).val()).join(', ');
                                try{ customFields[elem.attr('name') || elem.attr('id')] = value;}
                                catch (err) { console.error('could not serialize input: ' + elem.attr('id') || elem.attr('name') + '\n' + err); }
                            }
                            else {
                                let subElem = elem.find('input, select, textarea');
                                if (subElem.length > 0) {
                                    if (subElem.attr('type') === "checkbox") {
                                        let value = elem.find('input:checked').toArray().map(x => jMPT(x).val()).join(', ');
                                        try {
                                            customFields[elem.attr('name') || elem.attr('id')] = value;
                                        }
                                        catch (err) {
                                            console.error('could not serialize input: ' + elem.attr('id') || elem.attr('name') + '\n' + err);
                                        }
                                    } else {
                                        try {
                                            customFields[subElem.attr('name') || subElem.attr('id')] = subElem.val();
                                        }
                                        catch (err) {
                                            console.error('could not serialize input: ' + elem.attr('id') || elem.attr('name') + '\n' + err);
                                        }
                                    }
                                }

                                else { console.error('could not serialize input: ' + elem.attr('id') || elem.attr('name') + '\n' + err); }
                            }
                        });

                        let payload = {
                            content: (jMPT('#contact-message').val() || "").trim() || null,
                            subject: (jMPT('#contact-subject').val() || "Contact Form Submission").trim(),
                            firstName: (jMPT('#contact-name').val() || "").trim() || null,
                            lastName: (jMPT('#contact-last').val() || "").trim() || null,
                            email: jMPT('#contact-email').val().trim(),
                            phone: (jMPT('#contact-phone').val() || "").trim() || null,
                            ip: mptapi.ip,
                            customFields
                        };

                        let req = new ContactForm(payload);
                        jMPT('.wpcf7-response-output').text('Sending...').show().removeClass('wpcf7-display-none');
                        req.send().then(x => {
                            jMPT('.wpcf7-response-output').text('Sent! Thank you for your message.').show().removeClass('wpcf7-display-none');
                        });
                    }
                });
            }

            if(jMPT('#elementor-contact-submit').closest('form').length > 0) {
                jMPT('#elementor-contact-submit').closest('form').submit(function(e){
                    e.preventDefault();
                    let payload = {
                        content: jMPT('#form-field-elementor-contact-message').val().trim(),
                        subject: (jMPT('#form-field-elementor-contact-subject').val() || "Contact Form Submission").trim(),
                        firstName: (jMPT('#form-field-elementor-contact-name').val() || "").trim() || null,
                        lastName: (jMPT('#form-field-elementor-contact-last').val() || "").trim() || null,
                        email: jMPT('#form-field-elementor-contact-email').val().trim(),
                        phone: (jMPT('#form-field-elementor-contact-phone').val() || "").trim() || null,
                        ip: mptapi.ip
                    };

                    jMPT('.elementor-message').remove();
                    jMPT('#elementor-contact-submit').closest('form').append(jMPT('<div class="elementor-message elementor-message-success" role="alert">Sending...</div>'));

                    let req = new ContactForm(payload);
                    req.send().then(x => {
                        jMPT('.elementor-message').remove();
                        jMPT('#elementor-contact-submit').closest('form').append(jMPT('<div class="elementor-message elementor-message-success" role="alert">Sent! Thank you for your message.</div>'));
                    });
                });
            }

        }
    }
}

class MPTRequest {
    constructor(epoint, mthd, authenticated) {
        this.url = (mptsettings.options.api_environment && mptsettings.options.api_environment !== "" && overrideURL == null) ? urls[mptsettings.options.api_environment] : (overrideURL == null) ? urls.staging : overrideURL;
        this.endpoint = epoint;
        this.method = mthd;
        this.response = null;
        this.payload = null;
        this.template = null;
        this.invalid = null;
        this.doNotRender = false;
        this.authenticated = authenticated || false;

        if (authenticated) {
            if (mptapi.authToken == null) {
                this.invalid = "Not authenticated.";
            }
        }

        // Handle Auth Token Expiry
        if (mptapi.hasOwnProperty("authToken") && mptapi.authToken != null) {
            if (new Date() > new Date(mptapi.authToken.expirationUTC)) {
                if (this.authenticated) {
                    this.invalid = "Please sign back in.";
                    mptapi.router.setRedirect(this.page, this.hash);
                    mptapi.router.redirect("user", "#login");
                }
                mptapi.authToken = null;
                mptapi.clientCartId = null;
                jMPT('.logoutLink').hide().removeClass("active");
                jMPT('.loginLink').show().addClass("active");
            }
        }

        if (mptapi.router.data.hasOwnProperty("newDeliveryIds")) {
            delete mptapi.router.data.newDeliveryIds;
        }
    }

    static overrideURL(active_url = urls.local, save_to_storage = false) {
        if (save_to_storage) {
            localStorage.overrideURL = active_url;
            overrideURL = active_url;
        } else {
            overrideURL = active_url;
        }
        console.warn(((save_to_storage) ? "[LocalStorage] " : "") + "Set API url to ", active_url);
    }

    static resetAPIURL() {
        delete localStorage.overrideURL;
        overrideURL = null;
        console.warn("Reset URL to ", (mptsettings.options.api_environment && mptsettings.options.api_environment !== "" && overrideURL == null) ? urls[mptsettings.options.api_environment] : (overrideURL == null) ? urls.staging : overrideURL);
    }

    static encryptText(text, key) {
        return new Promise(function (resolve, reject) {
            console.log(text, key);
            jMPT.ajax({
                url: mptapi.ajaxurl,
                method: "POST",
                data: {
                    action: "encrypttext",
                    text: text,
                    padKey: key
                },
                success: function (data) {
                    if (data)
                        resolve(data);
                    else
                        reject(data);
                },
                error: function (xhr) {
                    reject(xhr);
                }
            });
        });
    }

    static addTokens(obj) {
        if (mptapi != null) {
            let aToken = mptapi.authToken;
            let clientCartId = mptapi.clientCartId;
            obj.authToken = aToken;
            obj.clientCartId = clientCartId;
        }
        return obj;
    }

    static tokensObject() {
        let obj = {};
        let overwriteMode = false;

        try {
            if (mptapi.router && mptapi.router.data && mptapi.router.data.editingSubscription) {
                overwriteMode = mptapi.router.data.editingSubscription;
            }
        } catch(err){ console.error(err); }


        if (mptapi.authToken != null) {
            obj.authToken = {
                token: mptapi.authToken.token,
                overwriteMode,
                ip: mptapi.ip
            };
        } else if (mptapi.clientCartId != null) {
            obj.clientCartId = mptapi.clientCartId;
        }
        return obj;
    }

    sendAndRender(elementId, middleware, replaceElement) {
        let request = this;
        if (!this.invalid) {

            return this.send().then(x => {

                if (middleware) {
                    if (typeof middleware === "function") {
                        x = middleware(x);
                    } else if (middleware.constructor === Array) {
                        for (let i = 0; i < middleware.length; i++) {
                            x = middleware[i](x);
                        }
                    }
                }

                request.response = x;

                this.renderTemplate(elementId, x, replaceElement);


            }).catch((err) => {
                console.error(elementId, err);
            });
        }

    }

    renderTemplate(elementId, setContext, replaceElement) {
        let request = this;

        return new Promise(function (resolve, reject) {
            let html = '';
            let t = Handlebars.compile(request.template);
            let context = request.response;
            if (setContext) {
                context = setContext;
            }

            //Default Middleware
            context = MPTMiddleware.flashHandler(context);

            if (request.doNotRender) {
                return resolve(context);
            }
            html += t(context);


            if (html != null && html !== '') {
                let element = jMPT('#' + elementId);
                if (element.length !== 0) {
                    if (replaceElement) {
                        element.replaceWith(html);
                    } else {
                        element.html(html);
                    }

                    let event = new CustomEvent("renderedTemplate", {
                        detail: {
                            id: elementId
                        }
                    });
                    if (element.hasOwnProperty("dispatchEvent")) {
                        element.dispatchEvent(event);
                    } else {
                        element[0].dispatchEvent(event);
                    }
                }
                return resolve(html);
            }
            reject(null);
        });
    }

    generatePayload(arg) {
        let request = this;
        let payload = request.payloadFunc(arg);
        request.payload = payload;
        console.log("[MPT Request] Generating Payload for " + this.endpoint + " " + this.method, this.payload);
        return payload;
    }

    send(callback) {
        let request = this;
        if (this.payload == null) {
            this.payload = this.generatePayload();
        }

        if (!this.invalid) {
            numRequest++;
            if (!jMPT('.mpt-page-loader').length) {
                jMPT('.mpt-content').append('<i style="position: fixed; top: 45%; left: 50%; font-size: 70px; opacity: .5" class="fa fa-spin fa-spinner fa-2x mpt-page-loader">');
            }
            return new Promise(function (resolve, reject) {
                let requestData = JSON.stringify(request.payload);
                console.log("[MPT Request] Sending Request: " + [request.endpoint, request.method].join(" "), request.payload);
                Pace.restart();
                let options = {
                    method: request.method,
                    url: request.url + request.endpoint,
                    data: requestData,
                    headers: {
                        "Authorization": "Basic " + mptapi.options.client_api_key,
                        "Content-Type": "application/json",
                        "X-Forwarded-For": mptapi.ip
                    },
                    success: function (data) {
                        console.timeEnd("Total Request Time");
                        //console.log(data);

                        if (data.hasOwnProperty("error")) {
                            jMPT('.mpt-error').remove();

                            for(let i = 0; i < data.error.length; i++)
                            {
                                let err = data.error[i];
                                let message = data.error[i].errorMessage;

                                if(err.hasOwnProperty('route') && err.route != null)
                                {
                                    message += '  <a href="' + err.route + '">' + err.routeMessage + '</a>';
                                }

                                let errorInput = ErrorMap[err.errorCode];
                                let title = 'Error!';
                                if(errorInput) title = '';

                                let orderLinkOnError = getSafeAPIValue('mptapi.companyInfo.uiSettings.orderLinkOnError');
                                if (orderLinkOnError && orderLinkOnError.length && orderLinkOnError.includes(message)) {
                                    localStorage.setItem('showDateOption', true);
                                    message = `${message} <a href="/order">Select another option here</a>`
                                }
                                jMPT.createAlert({
                                    title: title,
                                    message: message,
                                    //element: ".mpt-content",
                                    element: errorInput || ".mpt-content",
                                    type: "danger mpt-error",
                                    icon: "fa fa-exclamation-triangle"
                                });

                            }

                            /*if(data.error.filter(x => x.errorCode === ErrorCodes.UnauthorizedUser)){
                                                            mptapi.router.redirect("user", "#login");
                                                            return;
                                                        }*/
                            /*jMPT.createAlert({
                                title: "Error!",
                                message: data.error.map(x => x.errorMessage).join("<br>"),
                                element: ".mpt-content",
                                type: "danger mpt-error",
                                icon: "fa fa-exclamation-triangle"
                            });*/

                            jMPT('html, body').animate({scrollTop: 0}, 800);

                            numRequest--;
                            jMPT('.mpt-page-loader').remove();
                            return reject(data);
                        }
                        if (callback && typeof callback === "function") {
                            data = callback(data);
                        }

                        if (typeof request.after === "function") {
                            request.after(data);
                        }

                        request.updateSession(data);

                        jMPT('.mpt-wait-button').doneButton();

                        numRequest--;
                        if (numRequest === 0) {
                            jMPT('.mpt-page-loader').remove();
                        }
                        return resolve(request.response = data);
                    },
                    error: function (xhr) {
                        console.error("[MPT Request] Oops! There was an error processing your request.");
                        jMPT.createNotification("Error!", JSON.stringify(xhr), "danger", "fa fa-exclamation-triangle", 3500);
                        numRequest--;
                        jMPT('.mpt-page-loader').remove();

                        return reject(xhr);
                    }
                };
                if (options.data === "null") {
                    delete options.data;
                }

                jQuery.ajax(options);
            });
        } else {
            return new Promise(function (resolve, reject) {
                console.warn("Not a valid response: ");
                return reject();
            });
        }
    }

    updateSession(res) {
        let request = this;
        if (res != null) {
            //TODO: remove sensitive data from the stored req res

            if (res.hasOwnProperty('authToken')) {
                mptapi.authToken = res.authToken;
                mptapi.clientCartId = null;
            } else if (res.hasOwnProperty('clientCartId')) {
                mptapi.clientCartId = res.clientCartId;
            }

            if (res.hasOwnProperty('cart')) {
                mptapi.cart = res.cart;

                if((Page.isPage('store') || Page.isPage('shop')) && mptapi.companyInfo && mptapi.companyInfo.uiSettings.showAdditionalCheckoutButton)
                if(mptapi.storeVues && res.cart != null) { //go through all store vues that have cart data in their models
                    if (mptapi.storeVues.mptBottomCheckoutBar && mptapi.storeVues.mptBottomCheckoutBar.vueApp) {
                        console.warn('UPDATING CART UPDATE SESSION');
                        let cartModel = new MPTCartModel(mptapi.cart);
                        mptapi.storeVues.mptBottomCheckoutBar.vueApp.updateCart(cartModel);
                    }
                }
            }

            if (res.hasOwnProperty('messages')) {
                jMPT.clearAlerts();
                mptapi.messages = res.messages.filter(x => x.message != null);
                if (mptapi.messages.length > 0) {
                    for (let i = 0; i < mptapi.messages.length; i++) {
                        let alert = mptapi.messages[i];
                        let message = alert.message;

                        if(alert.hasOwnProperty('route') && alert.route != null)
                        {
                            message += '  <a href="' + alert.route + '">' + alert.routeMessage + '</a>';
                        }

                        jMPT.createAlert({
                            message: message,
                            element: ".mpt-content",
                            type: alert.type + " mpt-" + alert.type,
                            icon: "fa fa-exclamation-triangle"
                        });
                    }
                }
            }

            if (res.hasOwnProperty('companyInfo')) {
                mptapi.companyInfo = res.companyInfo;
            }

            if (res.hasOwnProperty("displayName")) {
                mptapi.displayName = res.displayName;
            }

            if(res.hasOwnProperty("user")) {
                mptapi.user = res.user;
            }

            if (mptapi.requestHistory.length > 3) {
                mptapi.requestHistory.shift();
            }

            if(res.hasOwnProperty("activeSubscriptions")){
                //mptapi.activeSubscriptions = res.activeSubscriptions.map(x => x.id);
                mptapi.activeSubscriptions = res.activeSubscriptions.map(function(x) { return { id: x.id, subscriptionName: x.subscriptionName, cartMatch: x.cartMatch || false }; }).sort(function(a, b){ //sort desc by highest matching cart total
                    let bfloat = 0;
                    let afloat = 0;
                    try { bfloat = parseFloat(b.cartMatch.matchingTotal.replace('$', '')); } catch(e) {}
                    try { afloat = parseFloat(a.cartMatch.matchingTotal.replace('$', '')); } catch(e) {}
                    return bfloat-afloat;
                });
            }
            /*mptapi.requestHistory.push({ //store the sanitized request and response
                payload: request.payload,
                response: res,
                timestamp: new Date().toISOString()
            });*/
        }
    }




    removeBlankKeys(obj) {
        let newObj = {};

        Object.keys(obj).forEach((prop) => {
            if (obj[prop] !== "" && obj[prop] != null && obj[prop] !== "null") {
                newObj[prop] = obj[prop];
            }
        });

        return newObj;
    }
}

//All of these classes that extend MPTRequest


class ApproveSignature extends MPTRequest {
    constructor(agreementId, sigImage, sigType, typedName, signerId) {
        super("user/agreements/" + agreementId + "/signatures", "POST");
        this.template = "";
        this.signatureImage = sigImage;
        this.signatureType = sigType;
        this.typedName = typedName;
        this.signerId = signerId;
    }

    payloadFunc() {
        return Object.assign({
            signatureImage: this.signatureImage,
            signatureType: this.signatureType,
            typedName: this.typedName,
            signerId: this.signerId,
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}

class ResetSignature extends MPTRequest {
    constructor(agreementId, sigType, signerId) {
        super("user/agreements/" + agreementId + "/signatures", "DELETE");
        this.template = "";
        this.signatureType = sigType;
        this.signerId = signerId;
    }

    payloadFunc() {
        return Object.assign({
            signatureType: this.signatureType,
            signerId: this.signerId,
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}

class SignRequest extends MPTRequest {
    constructor(agreementId, sigType, signerId, index) {
        super("user/agreements/" + agreementId + "/sign", "POST");
        this.template = "";
        this.signatureType = sigType;
        this.signerId = signerId;
        this.index = index;
    }

    payloadFunc() {
        return Object.assign({
            signatureType: this.signatureType,
            signerId: this.signerId,
            index: this.index,
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}

class UnsignRequest extends MPTRequest {
    constructor(agreementId, signerId, index) {
        super("user/agreements/" + agreementId + "/sign", "DELETE");
        this.template = "";
        this.signerId = signerId;
        this.index = index;
    }

    payloadFunc() {
        return Object.assign({
            signerId: this.signerId,
            index: this.index,
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}

class SubmitAgreementRequest extends MPTRequest {
    constructor(agreementId) {
        super("user/agreements/" + agreementId, "POST");
        this.template = "";
    }

    payloadFunc() {
        return Object.assign({
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}


/**
 * Shop Operations
 */
class GetStore extends MPTRequest {
    constructor(deliveryId, parameters) {
        super("store/summary", "PUT");
        this.parameters = parameters || {};
        this.deliveryId = deliveryId || null;
    }

    payloadFunc() {
        return Object.assign(this.parameters, {deliveryId: this.deliveryId}, MPTRequest.tokensObject());
    }
}

class GetStoreFilters extends MPTRequest {
    constructor(tasks, parameters) {
        super("store/filters", "PUT");
        this.tasks = tasks || null;

        if(tasks === null)
            this.parameters = parameters || {};
        else this.parameters = {};

    }

    payloadFunc() {
        return Object.assign({tasks: this.tasks}, this.parameters, MPTRequest.tokensObject());
    }
}

class GetStoreProducts extends MPTRequest {
    constructor(tasks, parameters) {
        super("store/products", "PUT");
        this.tasks = tasks || null;

        if(tasks === null)
            this.parameters = parameters || {};
        else this.parameters = {};

    }

    payloadFunc() {
        return Object.assign({tasks: this.tasks}, this.parameters, MPTRequest.tokensObject());
    }
}

class GetFeaturedProducts extends MPTRequest {
    constructor(parameters) {
        super("products/featured", "GET");
        this.parameters = parameters || {};
    }

    payloadFunc() {
        return {};
        //return Object.assign(this.parameters, MPTRequest.tokensObject());
    }
}


class GetDeliveryOptions extends MPTRequest {
    constructor(/*string*/ packageId, /*boolean*/editingSubscription) {
        packageId = packageId || null;
        let url = 'delivery/dates';
        let urlParams = null;
        let payloadFuncOverride = null;

        if(packageId !== null)
             urlParams += 'packageId=' + packageId;

        if(editingSubscription)
        {
            if(mptapi.authToken && mptapi.authToken.token) //auth sub edit
            {
                url = 'delivery/subdates';
                payloadFuncOverride = function(){
                    return MPTRequest.tokensObject();
                }
            }
            else //unauth sub edit
                urlParams += (urlParams ? '&subedit=true' : 'subedit=true');
        }

        if(urlParams)
            url += '?' + urlParams;

        if(typeof payloadFuncOverride === 'function') {
            super(url, 'PUT');
            this.payloadFunc = payloadFuncOverride;
        } else
            super(url, 'GET');

        if (!!!mptapi.companyInfo.multiSelectDeliveryDates) {
            this.template = document.getElementById("getDeliveriesTemplate").innerHTML;
        } else {
            this.template = document.getElementById("getDeliveriesMultipleTemplate").innerHTML;
        }
    }

    payloadFunc() {
        return null;
    }
}

class CheckDeliveryOption extends MPTRequest {
    constructor(deliveryId, timeSlotId, dateTime) {
        super('delivery/datecheck', 'POST');
        this.deliveryId = deliveryId;
        this.dateTime = dateTime;
        this.timeSlotId = timeSlotId;
    }

    payloadFunc() {

        let payload = {
            deliveryDayId: this.deliveryId,
            timeSlotId: this.timeSlotId,
            dateTime: this.dateTime,
        };

        if (mptapi.router.data.hasOwnProperty("packageId")) {
            payload.packageId = mptapi.router.data.packageId;
        }

        return this.removeBlankKeys(Object.assign(payload, MPTRequest.tokensObject()));
    }
}

class GetPackages extends MPTRequest {
    constructor() {
        super("products/packages", "GET");
        this.template = jMPT('#packagesTemplate').html().decHTML();
    }

    payloadFunc() {
        return {};
    }
}

class GetCategories extends MPTRequest {
    constructor() {
        super("products/categories", "GET");
        this.template = jMPT('#categoriesTemplate').html().decHTML();
    }

    payloadFunc() {
        return {};
    }
}

class GeneratePadKey extends MPTRequest {
    constructor() {
        super("checkout/padkey", "POST");
    }

    payloadFunc() {
        return Object.assign(MPTRequest.tokensObject(), {});
    }
}

class V3InitCheckout extends MPTRequest {
    constructor(parameters) {
        super("checkout/init", "POST");
        this.parameters = parameters || {};
    }

    payloadFunc() {
        return Object.assign(this.parameters, MPTRequest.tokensObject());
    }
}

class V3GetLocations extends MPTRequest {
    constructor(parameters) {
        super("checkout/locations", "PUT");
        this.parameters = parameters || {};
    }

    payloadFunc() {
        return Object.assign(this.parameters, MPTRequest.tokensObject());
    }
}

class V3SaveLocation extends MPTRequest {
    constructor(shippingInfo) {
        super("checkout/locations", "POST");
        this.template = "";
        this.shippingInfo = shippingInfo;
    }

    payloadFunc() {
        return Object.assign(this.shippingInfo, MPTRequest.tokensObject());
    }
}


class GetLocations extends MPTRequest {
    constructor() {
        super("delivery/locations", "GET");
        this.template = "";
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}



class GetDeliveryShopAndTasks extends MPTRequest {
    constructor(deliveryId, packageId, reqOptions) {

        let apiUrl = "products/shoptasks";
        let parameters = '';

        if(reqOptions?.activateToken)
            parameters += '&activateToken=' + reqOptions.activateToken;
        if(mptapi.router.data.qry)
            parameters += '&qry=' + mptapi.router.data.qry;
        if(mptapi.router.data.cat)
            parameters += '&cat=' + mptapi.router.data.cat;
        if(mptapi.router.data.pageNum)
            parameters += '&pn=' + mptapi.router.data.pageNum;
        if(mptapi.router.data.tags && mptapi.router.data.tags.length > 0)
            parameters += '&tag=' + mptapi.router.data.tags.join('|');

        if(parameters.includes('&')) parameters = '?' + parameters.substr(1);

        apiUrl += parameters;
        super(apiUrl, "PUT");



        try{
            this.filters = locationParamsToKVArray();
        }catch(err){
            console.error(err);
            this.filters = [];
        }

        if(mptapi.router.data.grp && mptapi.router.data.grp.length > 0)
            this.productIds = mptapi.router.data.grp;
        else this.productIds = null;

        this.deliveryId = deliveryId || mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;
        if (packageId)
            this.packageId = packageId;
        else {
            let delivery = mptapi.cart.deliveries.find(x => x.id === this.deliveryId);
            if (delivery != null && delivery.hasOwnProperty("packageId")) {
                this.packageId = delivery.packageId;
            } else if (mptapi.router.data.hasOwnProperty("packageId")) {
                this.packageId = mptapi.router.data.packageId;
            } else {
                this.packageId = null;
            }
        }


    }

    payloadFunc() {
        return Object.assign(MPTRequest.tokensObject(), {
            deliveryId: this.deliveryId,
            packageId: this.packageId,
            productIds: this.productIds,
            filters: this.filters
        });
    }
}

class CheckTask extends MPTRequest {
    constructor(taskId) {
        super("tasks/check/" + taskId, "PUT");
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class GetDeliveryShop extends MPTRequest {
    constructor(deliveryId, packageId) {

        let apiUrl = "products/shop";
        let parameters = '';

        if(mptapi.router.data.qry)
            parameters += '&qry=' + mptapi.router.data.qry;
        if(mptapi.router.data.cat)
            parameters += '&cat=' + mptapi.router.data.cat;
        if(mptapi.router.data.pageNum)
            parameters += '&pn=' + mptapi.router.data.pageNum;
        if(mptapi.router.data.tags && mptapi.router.data.tags.length > 0)
            parameters += '&tag=' + mptapi.router.data.tags.join('|');

        if(parameters.includes('&')) parameters = '?' + parameters.substr(1);

        apiUrl += parameters;
        super(apiUrl, "PUT");

        this.template = document.getElementById("getShopTemplate").innerHTML.decHTML();

        try{
            this.filters = locationParamsToKVArray();
        }catch(err){
            console.error(err);
            this.filters = [];
        }

        if(mptapi.router.data.grp && mptapi.router.data.grp.length > 0)
            this.productIds = mptapi.router.data.grp;
        else this.productIds = null;

        this.deliveryId = deliveryId || mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;
        if (packageId)
            this.packageId = packageId;
        else {
            let delivery = mptapi.cart.deliveries.find(x => x.id === this.deliveryId);
            if (delivery != null && delivery.hasOwnProperty("packageId")) {
                this.packageId = delivery.packageId;
            } else if (mptapi.router.data.hasOwnProperty("packageId")) {
                this.packageId = mptapi.router.data.packageId;
            } else {
                this.packageId = null;
            }
        }


    }

    payloadFunc() {
        return Object.assign(MPTRequest.tokensObject(), {
            deliveryId: this.deliveryId,
            packageId: this.packageId,
            productIds: this.productIds,
            filters: this.filters
        });
    }
}

class GetStorePage extends MPTRequest { //returns 1 page of products only
    constructor(deliveryId, packageId, qry, cat, pageNum, tags, grp) {

        let apiUrl = "products/store";
        super(apiUrl, "PUT");

        this.template = document.getElementById("getShopTemplate").innerHTML.decHTML();

        if(grp && grp.length > 0)
            this.productIds = grp;
        else this.productIds = null;

        this.qry = qry;
        this.cat = cat;
        this.pn = pageNum;
        this.tags = tags;

        this.deliveryId = deliveryId || mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;
        if (packageId)
            this.packageId = packageId;
        else {
            let delivery = mptapi.cart.deliveries.find(x => x.id === this.deliveryId);
            if (delivery != null && delivery.hasOwnProperty("packageId")) {
                this.packageId = delivery.packageId;
            } else if (mptapi.router.data.hasOwnProperty("packageId")) {
                this.packageId = mptapi.router.data.packageId;
            } else {
                this.packageId = null;
            }
        }
    }

    payloadFunc() {
        return Object.assign(MPTRequest.tokensObject(), {
            deliveryId: this.deliveryId,
            packageId: this.packageId,
            productIds: this.productIds,
            qry: this.qry,
            cat: this.cat,
            pn: this.pn,
            tags: this.tags
        });
    }
}

class GetShop extends MPTRequest {
    constructor() {
        super("products/shop", 'GET');
        this.template = document.getElementById("getShopTemplate").innerHTML;
    }

    payloadFunc() {
        return null;
    }
}

class GetProduct extends MPTRequest {
    constructor(productId) {
        if(!productId)
            productId = mptapi.router.data.productId;

        super("products/shop?ids=" + JSON.stringify([productId]), "GET");

        this.template = jMPT('#fullProductPage').html().decHTML();
    }

    payloadFunc() {
        return null;
    }
}

class GetFOH extends MPTRequest {
    constructor() {
        super("products/foh", "PUT");
        this.template = document.getElementById("posTemplate").innerHTML;
    }

    payloadFunc() {
        return {};
    }
}

class AddDelivery extends MPTRequest {
    constructor(deliveryId, timeSlotId, dateTime) {
        super('delivery/dates', 'POST');
        this.template = document.getElementById("addDeliveryConfirmationTemplate").innerHTML;
        this.deliveryId = deliveryId;
        this.dateTime = dateTime;
        this.timeSlotId = timeSlotId;
    }

    payloadFunc() {

        let selectedDeliveryDay = jMPT('#deliveryOptions a[data-active="true"]');
        let timeSlot = selectedDeliveryDay.find("select");
        let timeSlotId = timeSlot.val();
        let dateTime = timeSlot.children(":selected").data("datetime");

        let payload = {
            deliveryDayId: typeof this.deliveryId !== 'undefined' ? this.deliveryId : selectedDeliveryDay.data("deliverydayid"),
            timeSlotId: typeof this.timeSlotId !== 'undefined' ? this.timeSlotId : timeSlotId,
            dateTime: typeof this.timeSlotId !== 'undefined' ? this.dateTime : dateTime,
            comments: null
        };

        if (mptapi.router.data.hasOwnProperty("packageId")) {
            payload.packageId = mptapi.router.data.packageId;
        }

        return this.removeBlankKeys(Object.assign(payload, MPTRequest.tokensObject()));
    }
}


class TrackEvent extends MPTRequest {
    constructor(eventType, data) {
        super('events/track', 'POST');
        this.template = null;
        this.eventType = eventType;
        this.data = data || {};

        this.data.productId = this.data.productId || getSafeAPIValue('router.data.productId') ||  null;
        this.data['page_path'] = this.data['page_path'] || window.location.pathname + window.location.hash;
    }

    payloadFunc() {
        let payload = {
            eventType: this.eventType,
            data: this.data
        };

        try{
            payload.params = locationParamsToJSON(window.location);
            if(!payload.data.productId && payload.params && payload.params.viewProduct)
            {
                payload.data.productId = payload.params.viewProduct;
            }
        }
        catch{
            payload.params = null;
        }

        try {
            payload.href = window.location.href;
        }catch {
            payload.href = null;
        }

        try {
            payload.cookies = getAllCookies();
        }catch {
            payload.cookies = null;
        }

        return this.removeBlankKeys(Object.assign(payload, MPTRequest.tokensObject()));
    }
}

class ChangeDeliveryDate extends MPTRequest {
    constructor(deliveryId, dayId, timeSlotId, dateTime, containerSelector) {
        super("delivery/dates/change", "PUT");
        this.id = deliveryId;
        this.deliveryDayId = dayId;
        this.dateTime = dateTime;
        this.timeSlotId = timeSlotId;
        this.containerSelector = containerSelector || '#deliveryOptions';
    }

    payloadFunc() {

        let selectedDeliveryDay = jMPT(this.containerSelector + ' a[data-active="true"]');
        let timeSlot = selectedDeliveryDay.find("select");
        let timeSlotId = timeSlot.val();
        let dateTime = timeSlot.children(":selected").data("datetime");

        let payload = {
            id: this.id || mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null,
            deliveryDayId: this.deliveryDayId || selectedDeliveryDay.data("deliverydayid"),
            timeSlotId: this.timeSlotId || timeSlotId,
            dateTime: this.dateTime || dateTime,
        };

        if (mptapi.router.data.hasOwnProperty("packageId")) {
            payload.packageId = mptapi.router.data.packageId;
        }

        return this.removeBlankKeys(Object.assign(payload, MPTRequest.tokensObject()));
    }
}

class AddNextAvailableDelivery extends MPTRequest {
    constructor(packageId, editingSubscription) {

        let url = 'delivery/dates/autoadd';
        let urlParams = '';

        if(packageId)
            urlParams += 'packageId=' + packageId;
        else if(mptapi.router.data.hasOwnProperty("packageId") && mptapi.router.data.packageId)
            urlParams += 'packageId=' + packageId;
        else urlParams += 'packageId=';

        if(editingSubscription)
        {
            if(!(mptapi.authToken && mptapi.authToken.token)) //unauth sub edit
                urlParams += (urlParams ? '&subedit=true' : 'subedit=true');
        }

        if(urlParams)
            url += '?' + urlParams;

        super(url, 'POST');

    }

    payloadFunc() {
        let payload = {};

        return this.removeBlankKeys(Object.assign(payload, MPTRequest.tokensObject()));
    }
}

class AddEmptyDelivery extends MPTRequest {
    constructor() {
        super('delivery/dates', 'POST');
        this.template = document.getElementById("addDeliveryConfirmationTemplate").innerHTML;
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class RemoveDelivery extends MPTRequest {
    constructor(deliveryId) {
        super("delivery/dates", "DELETE");
        this.template = "Delivery removed!";
        this.deliveryId = deliveryId;
    }

    payloadFunc() {
        return Object.assign({deliveryId: this.deliveryId}, MPTRequest.tokensObject());
    }
}

/*class EmptyCart extends MPTRequest {
    constructor() {
        super("delivery/empty", "DELETE");
        this.template = "";
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}*/

class ChangeDeliveryRecurrence extends MPTRequest {
    constructor(deliveryId, recurrence) {
        super("delivery/recurrence", PUT);
        this.deliveryId = deliveryId;
        this.recurrence = recurrence;
        this.template = "";
    }

    payloadFunc() {
        return Object.assign({
            deliveryId: this.deliveryId,
            recurrence: this.recurrence
        }, MPTRequest.tokensObject());
    }
}

class AddProductToDelivery extends MPTRequest {
    constructor(productId, qty, variations, title, price, recurrence, packageId, overrideDeliveryId) {
        super('delivery/products', 'POST');

        this.template = document.getElementById('addProductConfirmationTemplate').innerHTML;
        this.productId = productId;
        this.qty = qty;
        this.variations = variations;
        this.title = title || "Product";
        this.price = price || 0;
        this.recurrence = recurrence;
        this.packageId = packageId;
        this.overrideDeliveryId = overrideDeliveryId || null;
    }

    after() {
        if (pixelActive()) {
            try {
                fbq('track', 'AddToCart', {
                    value: this.price,
                    currency: "USD",
                    "content_ids": [this.productId],
                    "content_type": "product",
                    "content_name": this.title,
                });
            } catch{}
        }

        /*if(gaActive()) {
            ga('ecommerce:addItem', {
                'id': mptapi.cart.id,
                'name': this.title,    // Product name. Required.
                'sku': this.productId,                 // SKU/code.
                'price': this.price,                 // Unit price.
                'quantity': this.qty                   // Quantity.
            });
        }*/

    }

    payloadFunc() {
        let deliveryId = this.overrideDeliveryId || mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;

        //if (!deliveryId) return console.error("[MPT Error] Could not find deliveryId");

        let qty = this.qty;

        let recurrence = this.recurrence || jMPT('#recurrenceOptions').val();

        if (recurrence === "null")
            recurrence = null;

        let payload = {
            deliveryId,
            packageId: this.packageId,
            productId: this.productId,
            qty,
            recurrence,
            variations: this.variations || [],
            addons: [],
            preferences: []
        };

        console.log(payload);

        payload = MPTRequest.addTokens(payload);
        payload = this.removeBlankKeys(payload);

        return payload;
    }
}

class RemoveProductFromDelivery extends MPTRequest {
    constructor(recordId) {
        super("delivery/products", "DELETE");
        this.template = ""; // document.getElementById("deleteProductConfirmationTemplate").innerHTML;
        this.recordId = recordId;
        this.qty = 0;
    }

    payloadFunc() {
        let payload = {};
        payload.recordId = this.recordId;
        payload.qty = this.qty;

        payload = MPTRequest.addTokens(payload);
        payload = this.removeBlankKeys(payload);

        return payload;
    }
}

class UpdateProductInDelivery extends MPTRequest {
    constructor(recordId, data) {
        super("delivery/products", "PUT");
        this.template = document.getElementById("updateProductConfirmationTemplate").innerHTML;
        this.recordId = recordId;
        this.data = data;
    }

    payloadFunc() {
        return Object.assign({
            recordId: this.recordId,
        }, this.data, MPTRequest.tokensObject());

    }
}

/**
 * Subscription Operations
 **/
class StopEnforcedSubEdit extends MPTRequest {
    constructor() {
        super("user/subscriptions/enfstop", 'POST');
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class SubscriptionEdit extends MPTRequest {
    constructor(subid, action) {
        super("user/subscriptions/" + subid, 'PUT');
        this.action = action;
        this.template = jMPT('#SubscriptionCartTemplate').html().decHTML();
    }

    payloadFunc() {
        return Object.assign({
            action: this.action,
        }, MPTRequest.tokensObject());
    }
}

class SubscriptionCommit extends MPTRequest {
    constructor(subid) {
        super("user/subscriptions/" + subid, 'POST');
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class GetFreezeOptions extends MPTRequest {
    constructor(subscriptionId) {
        super("user/subscriptions/" + subscriptionId + "/freeze", "PUT");
        this.template = jMPT('#freezeSubscriptionTemplate').html().decHTML();
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class FreezeSubscription extends MPTRequest {
    constructor(subscriptionId, fromDate, toDate) {
        super("user/subscriptions/" + subscriptionId + "/freeze", "POST");
        this.fromDate = fromDate;
        this.toDate = toDate;
    }

    payloadFunc() {
        return Object.assign({
            fromDate: this.fromDate,
            toDate: this.toDate
        }, MPTRequest.tokensObject());
    }
}

class UnfreezeSubscription extends MPTRequest {
    constructor(subscriptionId, fromDate, toDate) {
        super("user/subscriptions/" + subscriptionId + "/unfreeze", "POST");
        this.fromDate = fromDate;
        this.toDate = toDate;
    }

    payloadFunc() {
        return Object.assign({
            fromDate: this.fromDate,
            toDate: this.toDate
        }, MPTRequest.tokensObject());
    }
}

class GetCancelOptions extends MPTRequest {
    constructor(subscriptionId) {
        super("user/subscriptions/" + subscriptionId + "/cancel", "PUT");
        this.template = jMPT('#cancelSubscriptionTemplate').html().decHTML();
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class CancelSubscription extends MPTRequest {
    constructor(subscriptionId, fromDate, cancelReason, cancelText) {
        super("user/subscriptions/" + subscriptionId + "/cancel", "POST");
        this.fromDate = fromDate;
        this.cancelReason = cancelReason;
        this.cancelText = cancelText;
    }

    payloadFunc() {
        return Object.assign({
            cancelDate: this.fromDate,
            cancelReason: this.cancelReason,
            cancelText: this.cancelText
        }, MPTRequest.tokensObject());
    }
}

/**
 * Cart Operations
 */
class GetCart extends MPTRequest {
    constructor() {
        super("cart", "PUT");
        this.template = document.getElementById("CartTemplate").innerHTML;
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class EmptyCart extends MPTRequest {
    constructor() {
        super("cart", "DELETE");
        this.template = "";
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class AddOfferCode extends MPTRequest {
    constructor(code) {
        super('cart/offer', 'PUT');
        this.template = "";
        this.renderable = true;
        this.code = code;
    }

    payloadFunc() {
        return Object.assign({

            code: this.code
        }, MPTRequest.tokensObject());
    }
}

class CartSubscribeAll extends MPTRequest {
    constructor() {
        super("cart/subscribeall", "POST");
        this.template = document.getElementById("CartTemplate").innerHTML;
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class RemoveOfferCode extends MPTRequest {
    constructor(code) {
        super('cart/offer', 'DELETE');
        this.template = "";
        this.renderable = true;
        this.code = code;
    }

    payloadFunc() {
        return Object.assign({

            code: this.code
        }, MPTRequest.tokensObject());
    }
}

class UpdateTip extends MPTRequest {
    constructor(tip) {
        super("delivery/tip", "PUT");
        this.tip = tip;
    }

    payloadFunc() {
        return Object.assign({
            tip: this.tip,
        }, MPTRequest.tokensObject());
    }
}

/**
 * User Operations
 */

class Login extends MPTRequest {
    constructor(username, password) {
        super("user/login", "POST");
        //this.preTemplate = document.getElementById("PreLoginTemplate").innerHTML;
        //this.template = document.getElementById("LoginTemplate").innerHTML;
        this.template = "";
        this.username = username;
        this.password = password;
    }

    payloadFunc() {
        return Object.assign({
            ip: mptapi.ip,
            username: this.username,
            password: this.password
        }, MPTRequest.tokensObject());
    }
}

class Logout extends MPTRequest {
    constructor(allSessions) {
        super("user/logout", "POST");
        this.allSessions = allSessions;
    }

    payloadFunc() {
        return Object.assign({
            allSessions: this.allSessions || false,
        }, MPTRequest.tokensObject());
    }

    sendAndClear() {
        let request = this;
        if (this.payload == null) {
            this.payload = this.generatePayload();
        }

        if (!this.invalid) {
            let requestData = JSON.stringify(request.payload);
            Pace.restart();
            let options = {
                method: request.method,
                url: request.url + request.endpoint,
                data: requestData,
                headers: {
                    "Authorization": "Basic " + mptapi.options.client_api_key,
                    "Content-Type": "application/json",
                    "X-Forwarded-For": mptapi.ip
                },
                success: function (data) {
                    jMPT('.mpt-error').remove();

                    if (typeof request.after === "function") {
                        request.after(data);
                    }

                    jMPT('.mpt-wait-button').doneButton();
                    request.response = data;
                },
                error: function (xhr) {
                    console.error("[MPT Request] Oops! There was an error processing your request.");
                    return reject(xhr);
                }
            };
            if (options.data === "null") {
                delete options.data;
            }

            jQuery.ajax(options);

            setTimeout(function() {
                mptapi.authToken = null;
                mptapi.user = null;
                mptapi.clientCartId = null;
                window.location.replace('/order');
            }, 250)
        }
    }
}

class Register extends MPTRequest {
    constructor(username, password, turnstileToken, extraFields) {
        super("user/register", "POST");
        //this.preTemplate = document.getElementById("PreLoginTemplate").innerHTML;
        //this.template = document.getElementById("LoginTemplate").innerHTML;
        this.template = "";
        this.username = username;
        this.password = password;
        this.turnstileToken = turnstileToken;
        this.extraFields = extraFields;
    }

    after() {
        if (pixelActive()) {
            let total = 0;
            try{
                total = Math.max(mptapi.cart.totals.filter(x => x.name.includes("Total")).map(x => x.amount));
            }catch{ total = 0; }

            fbq('track', 'CompleteRegistration', {status: 'registered', value: total, currency: "USD"});
        }
    }

    payloadFunc() {
        return Object.assign({
            username: this.username,
            password: this.password,
            turnstileToken: this.turnstileToken,
            ip: mptapi.ip
        }, this.extraFields, MPTRequest.tokensObject());
    }
}

class RegisterGuest extends MPTRequest {
    constructor(extraFields) {
        super("user/registerguest", "POST");
        this.template = "";
        this.extraFields = extraFields;
    }

    after() {
        if (pixelActive()) {
            let total = 0;
            try{
                total = Math.max(mptapi.cart.totals.filter(x => x.name.includes("Total")).map(x => x.amount));
            }catch{ total = 0; }

            fbq('track', 'CompleteRegistration', {status: 'registered', value: total, currency: "USD"});
        }
    }

    payloadFunc() {
        return Object.assign({
            ip: mptapi.ip
        }, this.extraFields, MPTRequest.tokensObject());
    }
}

class ForgotPassword extends MPTRequest {
    constructor(username) {
        super("user/password", "PUT");
        this.template = "";
        this.username = username;
    }

    payloadFunc() {
        return {
            username: this.username,
            ip: mptapi.ip
        };
    }
}

class ResetPassword extends MPTRequest {
    constructor(username, password, token) {
        super("user/password", "POST");
        this.template = "";
        this.username = username;
        this.password = password;
        this.token = token;
    }

    payloadFunc() {
        return {
            username: this.username,
            password: this.password,
            token: this.token,
            ip: mptapi.ip
        };
    }
}

class GetShippingProfiles extends MPTRequest {
    constructor() {
        super("user/shipping", "PUT");
        this.template = document.getElementById("addressesTemplate").innerHTML.decHTML();
        Handlebars.registerPartial("newAddress", jMPT('#newAddressTemplate').html().decHTML());
        Handlebars.registerPartial("existingAddress", jMPT('#existingAddressTemplate').html().decHTML());
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class AddShippingProfile extends MPTRequest {
    constructor(profileData) {
        super("user/shipping", "POST");
        this.profileData = profileData;
    }

    payloadFunc() {
        return Object.assign(this.profileData, MPTRequest.tokensObject());
    }
}

class SetShippingProfile extends MPTRequest {
    constructor(shippingInfo) {
        super("delivery/locations", "PUT");
        this.template = "";
        this.shippingInfo = shippingInfo;
    }

    payloadFunc() {
        return Object.assign(this.shippingInfo, MPTRequest.tokensObject());
    }
}

class UpdateShippingProfile extends MPTRequest {
    constructor(shippingProfileId, shippingInfo) {
        super("user/shipping/" + shippingProfileId, "POST");
        this.shippingInfo = shippingInfo;
    }

    payloadFunc() {
        return Object.assign(this.shippingInfo, MPTRequest.tokensObject());
    }
}

class UpdateDelivery extends MPTRequest {
    constructor(fields) {
        super("delivery/locations", "PUT");
        this.updateFields = fields;
    }

    payloadFunc() {
        return Object.assign(this.updateFields, MPTRequest.tokensObject());
    }
}

class SetDefaultShippingProfile extends MPTRequest {
    constructor(shippingProfileId, shippingInfo) {
        super("user/shipping/" + shippingProfileId, "POST");
        this.shippingInfo = shippingInfo;
    }

    payloadFunc() {
        return Object.assign(this.shippingInfo, MPTRequest.tokensObject());
    }
}

class DeleteShippingProfile extends MPTRequest {
    constructor(shippingProfileId) {
        super("user/shipping/" + shippingProfileId, "DELETE");
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class GetBillingProfiles extends MPTRequest {
    constructor() {
        super("user/billing", "PUT");
        this.template = document.getElementById("paymentsTemplate").innerHTML.decHTML();
        Handlebars.registerPartial("newAddress", jMPT('#newAddressTemplate').html().decHTML());
        Handlebars.registerPartial("existingAddress", jMPT('#existingAddressTemplate').html().decHTML());
        Handlebars.registerPartial("newPaymentInfo", jMPT('#newPaymentInfoTemplate').html().decHTML());
        Handlebars.registerPartial("existingPaymentInfo", jMPT('#existingPaymentInfoTemplate').html().decHTML());
        Handlebars.registerPartial("newACHInfo", jMPT('#newACHInfoTemplate').html().decHTML());
        Handlebars.registerPartial("existingACHInfo", jMPT('#existingACHInfoTemplate').html().decHTML());
    }

    payloadFunc() {
        return MPTRequest.tokensObject(); // Has authToken (if logged in) or clientCartId
    }
}

class AddBillingProfile extends MPTRequest {
    constructor(profileData) {
        super("user/billing", "POST");
        this.profileData = profileData;
    }

    payloadFunc() {
        return Object.assign(this.profileData, MPTRequest.tokensObject());
    }
}

class SetBillingProfile extends MPTRequest {
    constructor(billingProfileId) {
        super("cart/billing", "PUT");
        this.template = "";
        this.billingProfileId = billingProfileId;
    }

    payloadFunc() {
        return Object.assign({
            billingProfileId: this.billingProfileId
        }, MPTRequest.tokensObject());
    }
}

class UpdateBillingProfile extends MPTRequest {
    constructor(billingProfileId, billingInfo) {
        super("user/billing/" + billingProfileId, "POST");
        this.billingInfo = billingInfo;
    }

    payloadFunc() {
        return Object.assign(this.billingInfo, MPTRequest.tokensObject());
    }
}

class UpdateSubscriptionBilling extends MPTRequest {
    constructor(subid, billingProfileId) {
        super("user/subscriptions/" + subid + "/billing", "POST");
        this.billingProfileId = billingProfileId;
    }

    payloadFunc() {
        return Object.assign({ billingProfileId: this.billingProfileId}, MPTRequest.tokensObject());
    }
}

class SetDefaultBillingProfile extends MPTRequest {
    constructor(billingProfileId, billingProfileInfo) {
        super("user/billing/" + billingProfileId, "POST");
        this.billingProfileInfo = billingProfileInfo;
    }

    payloadFunc() {
        return Object.assign(this.billingProfileInfo, MPTRequest.tokensObject());
    }
}

class DeleteBillingProfile extends MPTRequest {
    constructor(billingProfileId) {
        super("user/billing/" + billingProfileId, "DELETE");
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class GetAccountInfo extends MPTRequest {
    constructor() {
        super("user/account", "PUT");
        this.template = document.getElementById("accountinfoTemplate").innerHTML.decHTML();
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }

}

class UpdateAccountInfo extends MPTRequest {
    constructor(accountinfoData) {
        super("user/account", "POST");
        this.accountinfoData = accountinfoData;
    }

    payloadFunc() {
        return Object.assign(this.accountinfoData, MPTRequest.tokensObject());
    }

}

class GetOrders extends MPTRequest {
    constructor() {
        super("user/orders", "PUT");
        this.template = document.getElementById("ordersTemplate").innerHTML.decHTML();
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }

}

class GetReferralCode extends MPTRequest {
    constructor() {
        super("user/referral-code", "PUT");
        this.template = document.getElementById("referralCodeTemplate").innerHTML.decHTML();
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }

}

class AddUpdateAccountSetting extends MPTRequest {
    constructor(id, options) {
        super("user/settings", POST);
        this.id = id;
        this.options = options || [];
    }

    payloadFunc() {
        return Object.assign({
            settingId: this.id,
            settingValues: this.options
        }, MPTRequest.tokensObject());
    }
}

class UpdateAllAccountSettings extends MPTRequest {
    constructor(newSettings, shippingProfileId) {
        super("user/settings/all", POST);
        this.settings = newSettings;
        this.shippingProfileId = shippingProfileId || null;
    }

    payloadFunc() {
        return Object.assign({
            settings: this.settings,
            shippingProfileId: this.shippingProfileId
        }, MPTRequest.tokensObject());
    }
}

class GetSubscriptions extends MPTRequest {
    constructor() {
        super("user/subscriptions", "PUT");
        this.template = document.getElementById("subscriptionsTemplate").innerHTML.decHTML();
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }

}

class GetUserList extends MPTRequest {
    constructor(token) {
        super("owner/users/active/list", "PUT");
        this.ownerToken = token;
    }

    payloadFunc() {
        return {
            authToken: {
                token: this.ownerToken,
                ip: mptapi.ip
            }
        };
    }
}

class GetUserBillingProfiles extends MPTRequest {
    constructor(token, userId) {
        super("owner/users/" + userId + "/billing", "PUT");
        this.ownerToken = token;
    }

    payloadFunc() {
        return {
            authToken: {
                token: this.ownerToken,
                ip: mptapi.ip
            }
        };
    }
}

class GetUserShippingProfiles extends MPTRequest {
    constructor(token, userId) {
        super("owner/users/" + userId + "/shipping", "PUT");
        this.ownerToken = token;
    }

    payloadFunc() {
        return {
            authToken: {
                token: this.ownerToken,
                ip: mptapi.ip
            }
        };
    }
}

class ContactForm extends MPTRequest {
    constructor(payload){
        super("user/contact", "POST");
        this.template = null;
        this.payload = payload;
    }

    payloadFunc(){
        return Object.assign(MPTRequest.tokensObject(), this.payload, {ip: mptapi.ip});
    }
}

/**
 * Finance Operations
 *
 */

class GetFinanceApplications extends MPTRequest {
    constructor() {
        super("user/applications", "PUT");
        //this.template = jMPT('#userApplicationsTemplate').html().decHTML();
    }

    payloadFunc() {
        return MPTRequest.tokensObject(); // Has authToken (if logged in) or clientCartId
    }
}

class GetAgreements extends MPTRequest {
    constructor(){
        super("user/agreements", "PUT");
        //this.template = jMPT('#userAgreementsTemplate').html().decHTML();
    }

    payloadFunc(){
        return MPTRequest.tokensObject();
    }
}

class GetUserAgreement extends MPTRequest {
    constructor(id){
        super("user/agreements/" + id, "PUT");
    }

    payloadFunc(){
        return MPTRequest.tokensObject();
    }
}

class UpdateFinanceApp extends MPTRequest {
    constructor(id, firstName, lastName, monthlyIncome, employer, birthdate, ssn) {
        super("user/applications/" + id, "PUT");
        this.template = "";
        this.firstName = firstName;
        this.lastName = lastName;
        this.monthlyIncome = monthlyIncome;
        this.employer = employer;
        this.birthdate = birthdate;
        this.ssn = ssn;
    }

    payloadFunc() {
        return Object.assign({
            firstName: this.firstName,
            lastName: this.lastName,
            monthlyIncome: this.monthlyIncome,
            employer: this.employer,
            birthdate: this.birthdate,
            ssn: this.ssn,
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}

class CompleteFinanceApp extends MPTRequest {
    constructor(id) {
        super("user/applications/" + id, "POST");
        this.template = "";
    }

    payloadFunc() {
        return Object.assign({
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}

class RegisterAndApply extends MPTRequest {
    constructor(username, password, firstName, lastName, monthlyIncome, employer, birthdate, ssn) {
        super("user/applications" , "POST");
        this.template = "";
        this.username = username;
        this.password = password;
        this.firstName = firstName;
        this.lastName = lastName;
        this.monthlyIncome = monthlyIncome;
        this.employer = employer;
        this.birthdate = birthdate;
        this.ssn = ssn;
    }

    after() {
        if (pixelActive()) {
            let total = 0;
            try{
                total = Math.max(mptapi.cart.totals.filter(x => x.name.includes("Total")).map(x => x.amount));
            }catch{ total = 0; }

            fbq('track', 'CompleteRegistration', {status: 'registered', value: total, currency: "USD"});
        }
    }

    payloadFunc() {
        return Object.assign({
            username: this.username,
            password: this.password,
            firstName: this.firstName,
            lastName: this.lastName,
            monthlyIncome: this.monthlyIncome,
            employer: this.employer,
            birthdate: this.birthdate,
            ssn: this.ssn,
            ip: mptapi.ip
        }, MPTRequest.tokensObject());
    }
}

/**
 * Checkout Operations
 */

class InitCheckout extends MPTRequest {
    constructor(context, total) {
        super("cart/checkout", "PUT");
        this.template = document.getElementById("checkoutTemplate").innerHTML.decHTML();
        this.total = total;
        Handlebars.registerPartial("billingProfiles", jMPT('#billingProfilesTemplate').html().decHTML());
        Handlebars.registerPartial("shippingProfiles", jMPT("#shippingProfilesTemplate").html().decHTML());
        Handlebars.registerPartial("newBillingProfile", jMPT("#newBillingProfileTemplate").html().decHTML());
        Handlebars.registerPartial("newACHInfo", jMPT('#newACHInfoTemplate').html().decHTML());
        Handlebars.registerPartial("newShippingProfile", jMPT("#newShippingProfileTemplate").html().decHTML());
        Handlebars.registerPartial("newAddress", jMPT('#newAddressTemplate').html().decHTML());
        Handlebars.registerPartial("completeCheckoutCard", jMPT('#completeCheckoutCardTemplate').html().decHTML());

    }

    after() {
        if (pixelActive()) {
            fbq("track", "InitiateCheckout", {
                value: this.total,
                currency: "USD",
                "content_name": mptapi.displayName || "Authenticated User",
                //"content_ids": checkout.cart.purchasedItems.map(x => x.id).concat(checkout.cart.purchasedMembershipSets.map(x => x.id)),
                "content_type": 'product'
            });
        }

        setTimeout(function(){
            const featureContainer = jQuery('#featured-product-container');

            if (featureContainer && featureContainer.length) {
                featureContainer.slick({
                    dots: true
                });
            }
        }, 200);
    }

    payloadFunc() {
        return MPTRequest.tokensObject();
    }
}

class Checkout extends MPTRequest {
    constructor(total, subId, sessionKey) {
        super("cart/checkout", "POST");
        this.template = document.getElementById("orderConfirmation").innerHTML;
        this.activeSubscriptionId = subId;
        this.sessionId = sessionKey;
        this.total = total || 0;
    }

    after() {
        if (pixelActive()) {
            fbq('track', 'Purchase', {
                value: this.total,
                currency: "USD",
                "content_name": mptapi.displayName,
                "content_ids": jMPT('.product').toArray().map(x => x.id),
                "content_type": 'product'
            });
        }
    }

    payloadFunc() {
        let payload = {};

        if(this.activeSubscriptionId){
            payload.activeSubscriptionId = this.activeSubscriptionId;
        }

        if (this.sessionId) {
            payload.sessionId = this.sessionId;
        }

        return Object.assign(payload, MPTRequest.tokensObject());
    }
}

class UpdateLeadSource extends MPTRequest {
    constructor(orderId, leadSource, leadDetail) {
        super("cart/lead", "PUT");
        this.template = "";
        this.orderId = orderId;
        this.leadSource = leadSource;
        this.leadDetail = leadDetail;
    }

    payloadFunc() {
        return Object.assign({
            orderId: this.orderId,
            leadSource: this.leadSource,
            leadDetail: this.leadDetail
        }, MPTRequest.tokensObject());
    }
}

/**
 * MPTRouter
 * Instantiated on page load to
 */
class MPTRouter {
    constructor(routes = {}) {
        let router = this;
        this.updateRoute();

        this.data = {};
        this.modal = null;
        this.history = [];
        this.skipChange = false;

        Object.defineProperty(this, "flashCache", {
            value: [],
            writable: true,
            enumerable: false,
        });

        this.flashData = [];
        this.redirectUrl = "";

        this.routeOverride = routes;
        this.routes = {};
        this.clearData = true;
        this.clearProps = [];
        this.historySize = 5;


        this.setRoutes(routes);
    }

    static fromJSON(serializedJSON, routerOptions) {
        return Object.assign(new MPTRouter(), serializedJSON, routerOptions);
    }

    static checkAuth() {
        if (mptapi.authToken != null) {
            if (mptapi.authToken.hasOwnProperty("expirationUTC")) {
                return new Date() < new Date(mptapi.authToken.expirationUTC);
            }
        }
        return false;
    }

    static renderError() {
        window.location.pathname = "404";
    }

    static currentHash() {
        return window.location.hash;
    }

    setRoutes(override) {
        this.routes = this.getRoutes(override);
        return this;
    }

    setRedirect(page, hash = "") {
        this.redirectUrl = page + hash;
        return this;
    }

    getRouteVariables()
    {
        var hashData = {};
        window.location.hash.split('|').map(function(kv) {
            try{
                var key = kv.split(':')[0];
                var value = kv.split(':')[1];
                if(typeof value !== 'undefined')
                    hashData[key] = value;
                else return null;
            } catch{ return null; }
        });
        return hashData;
    }

    getRoutes(override = {}) {
        let router = this;
        let defaults = {
            "shop": {
                options: {
                    default() {
                        new AwaitProperty('companyInfo', mptapi, function () {
                            if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')){
                                router.redirect('/order');
                            }
                        });
                    }
                },
                '#deliveries': {
                    options: {
                        clearData: false
                    },
                    fn() {
                        new AwaitProperty('companyInfo', mptapi, function () {
                            if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')){
                                router.redirect('/order');
                            }
                        });
                    }
                },
                '#menu': {
                    options: {
                        clearData: false
                    },
                    fn() {
                        new AwaitProperty('companyInfo', mptapi, function () {
                            if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')){
                                router.redirect('/order/?previewMode=true');
                            }
                        });
                    }
                }
            },
            "shop-old": {
                options: {
                    default() {
                        new AwaitProperty('companyInfo', mptapi, function () {

                            if (mptapi.companyInfo.uiSettings) { //custom settings present
                                if(mptapi.companyInfo.uiSettings.serverSideShopPage)
                                {
                                    mptapi.router.redirect('/store');
                                }
                                else if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3'))
                                {
                                    mptapi.router.redirect('/order')
                                }
                                else if (mptapi.companyInfo.hasPackages) { //package must be selected first
                                    mptapi.router.changeHash('#packages');
                                }
                                else if (mptapi.companyInfo.autoAddDelivery) { //automatically add first available delivery date
                                    let req = new AddNextAvailableDelivery();
                                    req.send().then(() => {
                                        mptapi.router.changeHash("#products", { newDeliveryIds: req.response.deliveryIds });
                                    });
                                }
                                else { //no packages to select
                                    if (mptapi.companyInfo.uiSettings.autoAddDelivery) { //skip delivery page
                                        if (mptapi.cart.deliveries.length === 0) { //no deliveries found, auto add
                                            let req = new AddEmptyDelivery();
                                            req.send().then(() => {
                                                let deliveryId = req.response.newDeliveryIds.firstOrDefault();
                                                mptapi.cartDropdown.getCart();
                                                if (mptapi.companyInfo.uiSettings.preselectCategories) //category must be selected to pre-filter products
                                                {
                                                    mptapi.router.changeHash("#products", { //TODO FIX THIS
                                                        deliveryId,
                                                        newDeliveryIds: req.response.newDeliveryIds
                                                    });
                                                }
                                                else { //no more auto functions, go to products
                                                    mptapi.router.changeHash("#products", {
                                                        deliveryId,
                                                        newDeliveryIds: req.response.newDeliveryIds
                                                    });
                                                }
                                            });
                                        } else { //delivery already auto added, skip to next route
                                            if (mptapi.companyInfo.uiSettings.preselectCategories) //category must be selected to pre-filter products
                                            {
                                                //commit url data to router data
                                                mptapi.router.data.cat = (mptapi.router.params) ? (mptapi.router.params.cat || mptapi.router.data.cat || null) : (mptapi.router.data.cat || null);
                                                mptapi.router.data.catName = (mptapi.router.params) ? (mptapi.router.params.catName || mptapi.router.data.catName || null) : (mptapi.router.data.catName || null);
                                                mptapi.router.data.pageNum = (mptapi.router.params) ? (mptapi.router.params.pn || mptapi.router.data.pageNum || null) : (mptapi.router.data.pageNum || null);
                                                mptapi.router.data.grp = (mptapi.router.params) ? (mptapi.router.params.grp || mptapi.router.data.grp || null) : (mptapi.router.data.grp || null);

                                                mptapi.router.changeHash("#products", {deliveryId: mptapi.cart.deliveries[0].id})

                                                /*if(mptapi.router.params) {

                                                    if (mptapi.router.params && mptapi.router.params.cat) { //categories in location params
                                                        console.log('CURRENT: TEST: categories in location params');
                                                        mptapi.router.data.cat = mptapi.router.params.cat; //commit url data to router data
                                                    }
                                                    if (mptapi.router.params.p) { //categories in location params
                                                        console.log('CURRENT: TEST: page number in location params');

                                                    }
                                                }*/

                                                /*if(mptapi.router.data.cat)//check route data for existing cat selection
                                                {
                                                    console.log('cat already select, go to products');
                                                    console.log(mptapi.router.data.cat);
                                                    mptapi.router.changeHash("#products", {deliveryId: mptapi.cart.deliveries[0].id});//cat already select, go to products
                                                }else mptapi.router.redirect("/categories"); //mptapi.router.redirect("/categories"); //look for a categories page*/
                                            }
                                            else mptapi.router.changeHash("#products", {deliveryId: mptapi.cart.deliveries[0].id});
                                        }
                                    }
                                    else { // no custom settings that affect shop routing
                                        router.changeHash('#deliveries');
                                    }
                                }
                            } else router.changeHash('#deliveries'); //no custom settings, standard routing
                        }, 10);
                    }
                },
                '#deliveries': {
                    options: {
                        clearData: false
                    },
                    fn() {
                        new AwaitProperty('companyInfo', mptapi, function () {

                            if(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage)
                            {
                                router.redirect('/store');
                            }
                            else if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')){
                                router.redirect('/order');
                            }
                            else {
                                let explicitSubEdit = false;

                                if(enforceSubEdits())
                                    if(mptapi.router.data.editingSubscription) {
                                        explicitSubEdit = true;
                                        subscriptionEditMode(mptapi.user.displayName, 'explicit-deliveries');
                                    }

                                if (gaActive() && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.googleAnalyticsTID) {
                                    gtag('config', mptapi.companyInfo.uiSettings.googleAnalyticsTID, {'page_path': '/shop/#deliveries'});
                                }

                                if(pinActive())
                                {
                                    pintrk('track', 'checkout', {
                                        value: 116,
                                        order_quantity: 2,
                                        currency: 'USD',
                                        line_items: [
                                            {
                                                product_name: 'Pillows (Set of 2)',
                                                product_id: '11',
                                                product_price: 48.00,
                                                product_quantity: 1
                                            },
                                            {
                                                product_name: 'Pillows, Large (Set of 2)',
                                                product_id: '15',
                                                product_price: 68.00,
                                                product_quantity: 1
                                            },
                                        ]
                                    });
                                }

                                let req = null;
                                if (mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.autoAddDelivery) {
                                    if(!(mptapi.router.data.additionalDelivery && mptapi.cart.deliveries.length > 0)) {

                                        if(mptapi.router.data.editingSubscription) {

                                        }
                                        else{
                                            let autoAddReq = new AddNextAvailableDelivery();
                                            autoAddReq.send().then(() => {
                                                mptapi.router.changeHash("#products", {newDeliveryIds: autoAddReq.response.deliveryIds});
                                            });
                                        }
                                        return;
                                    }
                                }
                                // Show Deliveries
                                var packageId = mptapi.router.data.packageId || null;

                                let evaluateSingleTimeslotDays = function(){
                                    let timeSlotEvaluationResults = [];
                                    let timeSlots = jMPT('.timeslot-selector');
                                    for(let i = 0; i < timeSlots.length; i++)
                                    {
                                        let selector = jMPT(timeSlots[i]);
                                        let validOpts = selector.find('option:enabled').length;
                                        let newVal = selector.find('option:enabled').val();
                                        if(validOpts === 1 && newVal)
                                        {
                                            timeSlotEvaluationResults.push(newVal);
                                            selector.val(newVal).change();
                                            selector.addClass('d-none');
                                        }
                                        else timeSlotEvaluationResults.push(false);
                                    }

                                    if (timeSlotEvaluationResults.length > 0 && timeSlotEvaluationResults.every(r => r))
                                    {
                                        jMPT('#timeSlotTitle').addClass('d-none');
                                        jMPT('#SelectedDate').closest('small').addClass('d-none');
                                        for(let i = 0; i < timeSlotEvaluationResults.length; i++)
                                        {
                                            jMPT('.desktop-timeslot-selector option[value="' + timeSlotEvaluationResults[i] + '"]').closest('.desktop-timeslot-selector').addClass('d-none').closest('.mpt-col-md-6').addClass('d-none');
                                        }
                                    }
                                };

                                req = new GetDeliveryOptions(packageId, explicitSubEdit);
                                req.sendAndRender("deliveryContainer").then(() => {
                                    if (mptapi.cart.deliveries.length !== 0) {
                                        let t = Handlebars.compile(jMPT('#existingDeliverySectionTemplate').html());
                                        jMPT('#existingDeliveriesSection').html(t(MPTMiddleware.deliveriesMiddleware(mptapi.cart))).show();
                                    } else {
                                        jMPT('.order-1').removeClass("mpt-col-md-8");
                                    }

                                    MPTUI.deliveryUI();
                                    jMPT('#deliveryContainer').showPage();
                                    if (req.response.companyInfo.checkRulesOnShop && req.response.companyInfo.prohibitedRules.filter(x => x.variable === "shippingPostal") && !mptapi.authToken) {
                                        MPTUI.generateModal('#checkZipModal', {content: {width: "30%"}}, {content: {width: "100%"}});
                                    }

                                    if (hasCustomShopDeliveryScripts()) {
                                        _mptShopDeliveryCustomScript();
                                    }

                                    if(req.response.deliveryOptions.length > 0 && req.response.hasDelSelectionCountLimits)
                                    {
                                        let delOptions = req.response.deliveryOptions;

                                        let requestCount = delOptions.reduce((agg, dOpt) => agg + dOpt.timeSlots.length, 0);
                                        let completedRequests = 0;
                                        for(let i = 0; i < delOptions.length; i++)
                                        {
                                            let currentDelOpt = delOptions[i];

                                            for(let j = 0; j < currentDelOpt.timeSlots.length; j++)
                                            {
                                                let currentTimeSlot = currentDelOpt.timeSlots[j];

                                                let checkReq = new CheckDeliveryOption(currentDelOpt.id, currentTimeSlot.id, currentTimeSlot.dateTime);
                                                checkReq.send().then(checkRes => {
                                                    completedRequests++;
                                                    if(checkRes.valid)
                                                    {
                                                        if(checkRes.spotsRemaining !== null) // there are a limited number of spots left for this selection
                                                        {
                                                            let thisTSElems = jMPT('option[data-datetime="' + checkRes.dateTime + '"]');
                                                            let spotsRemainingLabel = '';
                                                            if(req.response.companyInfo.uiSettings && req.response.companyInfo.uiSettings.showRemainingDeliverySpots)
                                                            {
                                                                spotsRemainingLabel = ' (' + checkRes.spotsRemaining + ' spot' + (checkRes.spotsRemaining === 1 ? '' : 's') + ' left.)';

                                                                thisTSElems.each(function () {
                                                                    let limitWarning = checkRes.spotsRemaining < 5;
                                                                    let $this = jMPT(this);
                                                                    let parent = $this.parent();
                                                                    if (parent.find('option').length === 1) //this is the only ts option, modify the day selector as well
                                                                    {
                                                                        try {
                                                                            let dayATag = parent.closest('a');
                                                                            if (dayATag.length > 0) {
                                                                                if (limitWarning) dayATag.removeClass('border-primary').addClass('border-warning');
                                                                                let dayLabel = dayATag.find('label');
                                                                                if (dayLabel.length > 0) dayLabel.text(dayLabel.text() + ' (' + checkRes.spotsRemaining + ' spots left.)')
                                                                            }

                                                                            let mobileDay = jMPT('option[data-date="' + checkRes.dateTime.split(' ')[0] + '"]');
                                                                            if (mobileDay.length > 0) {
                                                                                if (limitWarning) mobileDay.addClass('text-warning');
                                                                                mobileDay.text(mobileDay.text() + spotsRemainingLabel);
                                                                            }
                                                                        } catch (err) {
                                                                            console.error(err);
                                                                        }
                                                                    }
                                                                    else { //multiple options for this delday
                                                                        $this.text($this.text() + spotsRemainingLabel);
                                                                        if (limitWarning) $this.addClass('text-warning');
                                                                    }
                                                                });
                                                            }
                                                        }
                                                    }
                                                    else { //day has passed order limits and is no longer valid
                                                        let thisTSElems = jMPT('option[data-datetime="' + checkRes.dateTime + '"]');
                                                        thisTSElems.each(function(){
                                                            let $this = jMPT(this);
                                                            let parent = $this.parent();
                                                            jMPT(this).remove();
                                                            if(parent.find('option').length === 0)
                                                            {
                                                                try {
                                                                    let dayATag = parent.closest('a');
                                                                    if(dayATag.length > 0)
                                                                        dayATag.remove();

                                                                    let mobileDay = jMPT('option[data-date="' + checkRes.dateTime.split(' ')[0] + '"]');
                                                                    if(mobileDay.length > 0)
                                                                        mobileDay.remove();
                                                                }catch(err){ console.error(err); }
                                                            }
                                                        });
                                                    }

                                                    if(completedRequests === requestCount)
                                                    {
                                                        if(req.response.companyInfo.uiSettings && req.response.companyInfo.uiSettings.skipSingleTimeSlotSelection)
                                                            evaluateSingleTimeslotDays();
                                                    }
                                                });
                                            }

                                        }
                                    }
                                    else if(req.response.companyInfo.uiSettings && req.response.companyInfo.uiSettings.skipSingleTimeSlotSelection)
                                        evaluateSingleTimeslotDays();

                                });
                            }
                        });
                    }
                },
                '#packages': {
                    options: {
                        removeData: ['shopPage'],
                        clearData: false,
                        pageTitle: "Packages"
                    },
                    fn() {
                        if (!mptapi.companyInfo.hasPackages) {
                            router.changeHash("#deliveries");
                            return;
                        }
                        let packageReq = new GetPackages();

                        packageReq.sendAndRender('packagesContainer', MPTMiddleware.packageMiddleware).then(() => {
                            MPTUI.packages();

                            if(gaActive() && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.googleAnalyticsTID)
                            {
                                gtag('config', mptapi.companyInfo.uiSettings.googleAnalyticsTID, {'page_path': '/shop/#packages'});
                            }

                            if(pinActive()) {
                                pintrk('track', 'pagevisit', {
                                    'page_path': '/shop/#packages'
                                });
                            }

                            try {
                                if (hasCustomPackageScripts()) {
                                    _mptShopPackageCustomScript();
                                }
                            }
                            catch(err) {
                                console.error(err);
                            }

                            jMPT('#packagesContainer').showPage();
                        });
                    }
                },
                '#menu': {
                    fn() {
                        if(gaActive() && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.googleAnalyticsTID)
                        {
                            gtag('config', mptapi.companyInfo.uiSettings.googleAnalyticsTID, {'page_path': '/shop/#menu'});
                        }

                        if(pinActive()) {
                            pintrk('track', 'pagevisit', {
                                'page_path': '/shop/#menu'
                            });
                        }

                        if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')) {
                            router.redirect('/order/?previewMode=true');
                        } else {
                            let req = new GetShop();
                            req.send().then(x => {
                                console.log("Menu", x);
                                let t = Handlebars.compile(jMPT('#menuTemplate').html().decHTML());

                                let context = MPTMiddleware.shopModelMiddleware(x);
                                context.isMobile = _isMobile || jMPT(document).width() < 600;
                                context.fullWidthFilters = jMPT(document).width() < 980;
                                mptapi.router.data.shopPage = context;

                                jMPT('#shopContainer').html(t(context)).show();
                                MPTUI.menuPage();

                                if(hasCustomMenuScripts()){
                                    _mptShopMenuCustomScript();
                                }
                            });
                        }
                    }
                },
                '#products': {
                    options: {
                        requireData: [['deliveryId', 'newDeliveryIds']],
                        removeData: ['shopPage'],
                        requireCart: true,
                        invalidRedirect: {
                            action: "#deliveries"
                        },
                        clearData: false,
                        pageTitle: "Shop",
                        routeData: true
                    },
                    fn() {
                        if (mptapi.router.data.hasOwnProperty("newDeliveryIds") && mptapi.router.data.newDeliveryIds && mptapi.router.data.newDeliveryIds.length > 0) {
                            mptapi.router.data.deliveryId = mptapi.router.data.newDeliveryIds[0];
                        }

                        if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')){
                            router.redirect('/order');
                        }

                        MPTUI.shopPagePartials();

                        if(getSafeAPIValue('companyInfo.uiSettings.categoryTemplate') === 'minimalistByCategoryFilterTemplate')
                        {
                            let productRequest = new GetDeliveryShopAndTasks();
                            productRequest.send().then(shopResponse => {

                                if (gaActive() && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.googleAnalyticsTID) {
                                    gtag('config', mptapi.companyInfo.uiSettings.googleAnalyticsTID, {'page_path': '/shop/#products'});
                                }

                                if (pinActive()) {
                                    pintrk('track', 'pagevisit', {
                                        'page_path': '/shop/#products'
                                    });
                                }

                                let context = MPTMiddleware.productsByCategoryMiddleware(shopResponse, jMPT(document).width());

                                if (context.products.length === 1) {
                                    if (!context.products[0].userChoice) { // Chef's choice
                                        let template = Handlebars.compile(jMPT('#weChooseProductPage').html().decHTML());
                                        jMPT('#weChooseContainer').html(template(context)).showPage();
                                        MPTUI.chefsChoice(context);
                                        if (hasCustomChefsChoiceProductScripts()) {
                                            _mptChefsChoiceProductCustomScript(context);
                                        }
                                        return;
                                    }
                                }

                                if (shopResponse.hasOwnProperty('productSummary'))
                                    mptapi.router.data.productCount = shopResponse.productSummary.productCount || context.products.length;

                                let shopTemplate = Handlebars.compile(jMPT('#minimalistByCategoryShopTemplate').html().decHTML());

                                jMPT('#shopContainer').html(shopTemplate(context)).showPage();
                                MPTUI.shopPage(req.response, mptapi.router.data.routeData); //TODO: UI changes here

                                let filterTasks = shopResponse.filters;
                                if(filterTasks) {
                                    if(filterTasks.recurrenceTask)
                                    {
                                        let recurrenceReq = new CheckTask(filterTasks.recurrenceTask);
                                        recurrenceReq.send(checkTaskRes => {
                                            let taskTemplate = Handlebars.compile(jMPT('#minimalistRecurrenceFilterTemplate').html().decHTML());
                                            let taskComponent = jMPT('#categoryComponent');
                                            taskComponent.html(taskTemplate(checkTaskRes));
                                            taskComponent.fadeIn({ complete: function () { taskComponent .addClass("visible"); } });

                                            //TODO:  newUI(); componentUI: bind category filter controls
                                        });
                                    }

                                    if(filterTasks.categoriesTask)
                                    {
                                        let categoryReq = new CheckTask(filterTasks.categoriesTask);
                                        categoryReq.send(checkTaskRes => {
                                            let taskTemplate = Handlebars.compile(jMPT('#minimalistByCategoryFilterTemplate').html().decHTML());
                                            let taskComponent = jMPT('#categoryComponent');
                                            taskComponent.html(taskTemplate(checkTaskRes));
                                            taskComponent.fadeIn({ complete: function () { taskComponent .addClass("visible"); } });

                                            //TODO:  newUI(); componentUI: bind category filter controls

                                        });
                                    }

                                    if(filterTasks.tagsTask)
                                    {
                                        let tagsReq = new CheckTask(filterTasks.tagsTask);
                                        tagsReq.send(checkTaskRes => {
                                            let taskTemplate = Handlebars.compile(jMPT('#minimalistTagsFilterTemplate').html().decHTML());
                                            let taskComponent = jMPT('#tagsComponent');
                                            taskComponent.html(taskTemplate(checkTaskRes));
                                            taskComponent.fadeIn({ complete: function () { taskComponent .addClass("visible"); } });

                                            //TODO:  newUI(); componentUI: bind category filter controls
                                        });
                                    }

                                    if(filterTasks.groupsTask)
                                    {
                                        let groupsReq = new CheckTask(filterTasks.groupsTask);
                                        groupsReq.send(checkTaskRes => {
                                            let taskTemplate = Handlebars.compile(jMPT('#minimalistGroupsFilterTemplate').html().decHTML());
                                            let taskComponent = jMPT('#groupsComponent');

                                        });
                                    }

                                    //TODO: let datesReq = ...
                                }
                            });
                        }
                        else {

                            let req = new GetDeliveryShop();
                            req.send().then(shopResponse => {

                                if (gaActive() && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.googleAnalyticsTID) {
                                    gtag('config', mptapi.companyInfo.uiSettings.googleAnalyticsTID, {'page_path': '/shop/#products'});
                                }

                                if (pinActive()) {
                                    pintrk('track', 'pagevisit', {
                                        'page_path': '/shop/#products'
                                    });
                                }

                                let context = MPTMiddleware.shopModelMiddleware(shopResponse);
                                context.isMobile = _isMobile || jMPT(document).width() < 980;
                                //context.fullWidthFilters = jMPT(document).width() < 980;


                                if (context.products.length === 1) {
                                    if (!context.products[0].userChoice) { // Chef's choice
                                        let template = Handlebars.compile(jMPT('#weChooseProductPage').html().decHTML());
                                        jMPT('#weChooseContainer').html(template(context)).showPage();
                                        MPTUI.chefsChoice(context);
                                        if (hasCustomChefsChoiceProductScripts()) {
                                            _mptChefsChoiceProductCustomScript(context);
                                        }

                                        return;
                                    }
                                }

                                if (shopResponse.hasOwnProperty('productSummary'))
                                    mptapi.router.data.productCount = shopResponse.productSummary.productCount || context.products.length;

                                let template = Handlebars.compile(jMPT('#getShopTemplate').html().decHTML());
                                jMPT('#shopContainer').html(template(context)).showPage();

                                if (mptapi.router.data.catName || mptapi.router.data.qry) {
                                    let queries = {};
                                    if (mptapi.router.data.catName) queries.category = mptapi.router.data.catName.toLowerCase();
                                    if (mptapi.router.data.qry) queries.search = mptapi.router.data.qry.toLowerCase();
                                    if (mptapi.router.data.routeData) Object.assign(mptapi.router.data.routeData, queries)
                                    else mptapi.router.data.routeData = queries;
                                }

                                MPTUI.shopPage(req.response, mptapi.router.data.routeData);
                                // Stop opening by default
                                /*if (!mptapi.cartDropdown.mobileMode) {
                                    mptapi.cartDropdown.show();
                                    mptapi.cartDropdown.position();
                                }*/

                                if (mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
                                    if (mptapi.router.data.qry || mptapi.router.data.catName || mptapi.router.data.grpNames) {
                                        let filterEl = 'Results ';
                                        let removeFiltersEl = '';

                                        if (mptapi.router.data.catName) {
                                            filterEl += 'in ' + mptapi.router.data.catName + ' ';
                                        }
                                        if (mptapi.router.data.qry) {
                                            filterEl += 'for "' + mptapi.router.data.qry + '"';
                                            removeFiltersEl = '<span class="remove-all-filters text-danger" style="cursor:pointer;">  x</span>';
                                        }
                                        if (mptapi.router.data.grpNames) {
                                            let groups = mptapi.router.data.grpNames;
                                            for (let i = 0; i < groups.length; i++) {
                                                jMPT('.group-section input[data-group-label="' + groups[i] + '"]').prop('checked', true);
                                            }
                                        }

                                        filterEl += removeFiltersEl;

                                        jMPT('.mpt-result-title').html(filterEl);
                                    }
                                }

                                jMPT('.remove-all-filters').click(function () {
                                    mptapi.router.data.qry = null;
                                    mptapi.router.data.routeData.search = null;
                                    mptapi.router.data.grp = null;
                                    mptapi.router.data.grpNames = null;
                                    mptapi.router.data.pageNum = null;
                                    jMPT('#searchbox').val(null);
                                    mptapi.router.changeHash('');
                                });

                                //init mobile controls
                                jMPT('.mpt-filter-title').on('click', function () {
                                    let accordion = jMPT(this);
                                    let filterType = accordion.data('filtertype');
                                    let content = jMPT('.mpt-filter-content[data-filtertype=' + filterType + ']');
                                    let isOpen = content.hasClass('mpt-filter-content-open');

                                    if (isOpen) {
                                        jMPT('.mpt-filter-content-open[data-filtertype=' + filterType + ']').css('height', 26);
                                        jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']').css('height', 26);

                                        content.removeClass('mpt-filter-content-open');
                                        jMPT('.mpt-filter-arrow[data-filtertype=' + filterType + ']').removeClass('fa-rotate-180');
                                        let contentBody = jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']');
                                        contentBody.removeClass('mpt-filter-content-body-open');
                                    }
                                    else {
                                        content.addClass('mpt-filter-content-open');
                                        jMPT('.mpt-filter-arrow[data-filtertype=' + filterType + ']').addClass('fa-rotate-180');
                                        let contentBody = jMPT('.mpt-filter-content-body[data-filtertype=' + filterType + ']');

                                        console.log('contentBody');
                                        console.log(contentBody);

                                        contentBody.addClass('mpt-filter-content-body-open');

                                        let lastFilter = jMPT('.list-group-item[data-filtertype="' + filterType + '"]').filter(':last')[0];
                                        let filterRect = lastFilter.getBoundingClientRect();
                                        let contentRect = jMPT('.mpt-filter-content-open[data-filtertype="' + filterType + '"]')[0].getBoundingClientRect();
                                        let newBottom = filterRect.top + filterRect.height + 15;
                                        let newHeight = newBottom - contentRect.top;
                                        jMPT('.mpt-filter-content-open[data-filtertype=' + filterType + ']').css('height', newHeight);
                                        jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']').css('height', newHeight);
                                    }
                                });

                                jMPT('.mobile-filter-option').on('click', function () {
                                    let selectedOption = jMPT(this);
                                    let ftype = selectedOption.data('filtertype');
                                    let filterTitle = jMPT('.mpt-filter-title[data-filtertype="' + ftype + '"]');

                                    let gid = jMPT(this).data('group-id');
                                    if (typeof gid !== 'undefined' && gid != null) {
                                        jMPT('input.filter-item[data-group-id="' + gid + '"]').click();
                                    }

                                    filterTitle.click();

                                    jMPT('#' + selectedOption.data('filter')).val(selectedOption.data('option')).change();
                                });

                                jMPT('.switch.recurrence-switch input').each(function (i, e) {
                                    e.onchange = function () {
                                        let newVal = !e.checked ? jMPT(e).data('disabledValue') : e.value;
                                        let filterLabel = jMPT('.mpt-recurrence-filter-label');
                                        let filterLabelText = null;
                                        let overrideVal = null;
                                        if (e.checked) {
                                            if (typeof(_localOverrides) !== 'undefined')
                                                overrideVal = _localOverrides[(newVal || 'no') + 'RecurrenceLabels'];

                                            filterLabelText = overrideVal || 'Great! Now, any products you add will automatically reorder ' + newVal + '!';
                                            filterLabel.text(filterLabelText);
                                            filterLabel.addClass('subscribed-filter');
                                            jMPT('#recurrenceOptions').val(newVal).change();
                                        }
                                        else {
                                            if (typeof(_localOverrides) !== 'undefined')
                                                overrideVal = _localOverrides[(newVal || 'no') + 'RecurrenceLabels'];

                                            filterLabelText = overrideVal || 'Subscribe to a ' + e.value + ' meal plan!';
                                            filterLabel.text(filterLabelText);
                                            filterLabel.removeClass('subscribed-filter');
                                            jMPT('#recurrenceOptions').val("null").change();
                                        }
                                    };
                                });

                                jMPT('.group-section input:checked').each(function () {
                                    let gid = jMPT(this).data('group-id');
                                    jMPT('button.mobile-filter-option[data-group-id="' + gid + '"]').css('background-color', 'rgba(0,0,0,.3)');
                                });

                                if (getSafeAPIValue('companyInfo.uiSettings.autofitImages')) {
                                    let minHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-top').map(function () {
                                        return jMPT(this).height();
                                    }).get())]);
                                    let minWidth = Math.max.apply(null, [145, Math.min.apply(null, jMPT('.card-img-top').map(function () {
                                        return jMPT(this).width();
                                    }).get())]);
                                    let rightminHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-right').map(function () {
                                        return jMPT(this).height();
                                    }).get())]);
                                    let rightminWidth = Math.max.apply(null, [109, Math.min.apply(null, jMPT('.card-img-right').map(function () {
                                        return jMPT(this).width();
                                    }).get())]);

                                    jMPT('.card').css({
                                        'display': 'block',
                                        'max-height': minHeight + 'px',
                                        'max-width': minWidth + 'px',
                                        'width': 'auto',
                                        'height': 'auto'
                                    });

                                    jMPT('.card-img-top').css({
                                        'display': 'block',
                                        'max-height': minHeight + 'px',
                                        'max-width': minWidth + 'px',
                                        'width': 'auto',
                                        'height': 'auto',
                                        'margin': 'auto'
                                    });


                                    jMPT('.card-img-right').css({
                                        'display': 'block',
                                        'max-height': rightminHeight + 'px',
                                        'max-width': rightminWidth + 'px',
                                        'width': 'auto',
                                        'height': 'auto',
                                        'margin': 'auto'
                                    });
                                }


                                try {
                                    if (!context.isMobile) {
                                        let productRows = jMPT('.card-title')
                                            .map(function () {
                                                return {
                                                    el: jMPT(this),
                                                    positionY: jMPT(this).offset().top,
                                                    height: jMPT(this).height()
                                                };
                                            })
                                            .toArray()
                                            .reduce(function (agg, thisElem) {
                                                (agg[thisElem.positionY] = agg[thisElem.positionY] || []).push(thisElem);
                                                return agg;
                                            }, {});

                                        if (productRows) {
                                            let rowPositions = Object.keys(productRows);
                                            for (let i = 0; i < rowPositions.length; i++) {
                                                console.log(productRows[rowPositions[i]].map(r => r.height));
                                                let rowHeight = Math.max.apply(null, [20, Math.max.apply(null, productRows[rowPositions[i]].map(r => r.height))]);
                                                console.log(rowHeight);
                                                let elements = productRows[rowPositions[i]].map(r => r.el);
                                                for (let j = 0; j < elements.length; j++) {
                                                    elements[j].css({'min-height': rowHeight + 'px'});
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    console.error(err);
                                }


                                if (context.additionalCheckoutButton) {
                                    let cartModel = new MPTCartModel(mptapi.cart);
                                    if (mptapi.storeVues) {
                                        if (mptapi.storeVues.mptBottomCheckoutBar) {
                                            if (mptapi.storeVues.mptBottomCheckoutBar.vueApp instanceof Vue)
                                                mptapi.storeVues.mptBottomCheckoutBar.vueApp.$destroy();
                                            mptapi.storeVues.mptBottomCheckoutBar = null;
                                        }
                                    }
                                    else mptapi.storeVues = {};

                                    mptapi.storeVues.mptBottomCheckoutBar = new MPTBottomCheckoutBar(cartModel, null);
                                }

                                if (enforceSubEdits()) {
                                    if (mptapi.router.data.editingSubscription)
                                        subscriptionEditMode(mptapi.user.displayName, 'explicit-shop');
                                    else if (mptapi.router.data && mptapi.router.data.delivery && mptapi.router.data.delivery.products) {
                                        let recurringProducts = mptapi.router.data.delivery.products.filter(p => p.recurrence !== null);
                                        if (recurringProducts.length > 0) {
                                            let recVal = recurringProducts[0].recurrence;
                                            jMPT('#recurrenceOptions').val(recVal).change();
                                        }
                                    }
                                }

                                if (getSafeAPIValue('companyInfo.uiSettings.alwaysSortProductsByCategory')) {
                                    jMPT('#categorySelector option').each(function () {
                                        let cat = jMPT(this).text().toLowerCase();
                                        if (cat && cat !== 'all')
                                            jMPT('<div class="mpt-col-12 mpt-shop-category-header-container"><h2 class="text-center mpt-shop-category-header"><span>' + cat.toUpperCase() + '</span></h2></div>').insertBefore(jMPT('article.' + cat.replace(/ /g, '-')).first());
                                    });
                                }

                                if (hasCustomShopProductScripts()) {
                                    _mptShopProductCustomScript(context);
                                }

                            }).catch(err => {
                                console.error(err);
                                router.flash({
                                    message: err,
                                    type: "notification",
                                    title: "Error",
                                    notificationType: "danger"
                                }).changeHash("#deliveries");
                            });
                        }
                    }
                },
                '#subscription': {
                    options: {
                        clearData: false,
                        requireData: ['deliveryId'],
                        removeData: ['shopPage'],
                        requireCart: true,
                        invalidRedirect: {
                            action: '#deliveries'
                        },
                        requireAuth: true,
                        loginRedirect: {
                            page: "user",
                            action: "#subscriptions"
                        },
                        pageTitle: "Pick Your Meals - Subscription"
                    },
                    fn() {
                        MPTUI.shopPagePartials();
                        let req = new GetDeliveryShop();
                        req.sendAndRender('shopContainer', MPTMiddleware.shopModelMiddleware).then(() => {

                            if(gaActive() && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.googleAnalyticsTID)
                            {
                                gtag('config', mptapi.companyInfo.uiSettings.googleAnalyticsTID, {'page_path': '/shop/#subscription'});
                            }

                            if(pinActive()) {
                                pintrk('track', 'pagevisit', {
                                    'page_path': '/shop/#subscription'
                                });
                            }

                            let context = req.response;
                            context.isMobile = _isMobile || jMPT(document).width() < 600;
                            context.fullWidthFilters = jMPT(document).width() < 980;
                            mptapi.router.data.shopPage = context;

                            //router.data.shopPage = req.response;
                            //MPTUI.shopPage(req.response);

                            MPTUI.shopPage(context, mptapi.router.data.routeData);
                            jMPT('#shopContainer').showPage();

                            if (!mptapi.cartDropdown.mobileMode) {
                                mptapi.cartDropdown.show();
                                mptapi.cartDropdown.position();
                            }
                            else{
                                mptapi.cartDropdown.show();//force cart to render on page
                                mptapi.cartDropdown.hide();//hide cart immediately after rendering
                                mptapi.cartDropdown.position();
                            }

                            jMPT('.mpt-filter-title').on('click', function() {
                                let accordion = jMPT(this);
                                let filterType = accordion.data('filtertype');
                                let content = jMPT('.mpt-filter-content[data-filtertype=' + filterType + ']');
                                let isOpen = content.hasClass('mpt-filter-content-open');

                                if(isOpen)
                                {
                                    jMPT('.mpt-filter-content-open[data-filtertype=' + filterType + ']').css('height', 26);
                                    jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']').css('height', 26);

                                    content.removeClass('mpt-filter-content-open');
                                    jMPT('.mpt-filter-arrow[data-filtertype=' + filterType + ']').removeClass('fa-rotate-180');
                                    let contentBody = jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']');
                                    contentBody.removeClass('mpt-filter-content-body-open');
                                }
                                else
                                {
                                    content.addClass('mpt-filter-content-open');
                                    jMPT('.mpt-filter-arrow[data-filtertype=' + filterType + ']').addClass('fa-rotate-180');
                                    let contentBody = jMPT('.mpt-filter-content-body[data-filtertype=' + filterType + ']');

                                    console.log('contentBody');
                                    console.log(contentBody);

                                    contentBody.addClass('mpt-filter-content-body-open');

                                    let lastFilter = jMPT('.list-group-item[data-filtertype="' + filterType + '"]').filter(':last')[0];
                                    let filterRect = lastFilter.getBoundingClientRect();
                                    let contentRect = jMPT('.mpt-filter-content-open[data-filtertype="' + filterType + '"]')[0].getBoundingClientRect();
                                    let newBottom = filterRect.top + filterRect.height + 15;
                                    let newHeight = newBottom - contentRect.top;
                                    jMPT('.mpt-filter-content-open[data-filtertype=' + filterType + ']').css('height', newHeight);
                                    jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']').css('height', newHeight);
                                }
                            });

                            jMPT('.mobile-filter-option').on('click', function() {
                                let selectedOption = jMPT(this);
                                let ftype = selectedOption.data('filtertype');
                                let filterTitle = jMPT('.mpt-filter-title[data-filtertype="' + ftype + '"]');

                                let gid = jMPT(this).data('group-id');
                                if (typeof gid !== 'undefined' && gid != null) {
                                    jMPT('input.filter-item[data-group-id="' + gid + '"]').click();
                                }

                                filterTitle.click();

                                jMPT('#' + selectedOption.data('filter')).val(selectedOption.data('option')).change();
                            });

                            jMPT('.group-section input:checked').each(function () {
                                let gid = jMPT(this).data('group-id');
                                jMPT('button.mobile-filter-option[data-group-id="' + gid + '"]').css('background-color', 'rgba(0,0,0,.3)');
                            });

                            if (mptapi.hasOwnProperty('companyInfo') && mptapi.companyInfo.hasOwnProperty('uiSettings') && mptapi.companyInfo.uiSettings.autofitImages)
                            {
                                let minHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).height(); }).get())]);
                                let minWidth = Math.max.apply(null, [145, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).width(); }).get())]);
                                let rightminHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).height(); }).get())]);
                                let rightminWidth = Math.max.apply(null, [109, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).width(); }).get())]);

                                jMPT('.card').css({
                                    'display': 'block',
                                    'max-height': minHeight + 'px',
                                    'max-width': minWidth + 'px',
                                    'width': 'auto',
                                    'height': 'auto'
                                });

                                jMPT('.card-img-top').css({
                                    'display': 'block',
                                    'max-height': minHeight + 'px',
                                    'max-width': minWidth + 'px',
                                    'width': 'auto',
                                    'height': 'auto',
                                    'margin': 'auto'
                                });


                                jMPT('.card-img-right').css({
                                    'display': 'block',
                                    'max-height': rightminHeight + 'px',
                                    'max-width': rightminWidth + 'px',
                                    'width': 'auto',
                                    'height': 'auto',
                                    'margin': 'auto'
                                });
                            }

                            jMPT('.page-title').text("Edit Subscription");
                            jMPT('.breadcrumbs-wrap').hide();


                            if(hasCustomSubscriptionEditScripts())
                            {
                                _mptSubscriptionEditCustomScript();
                            }


                        }).catch(err => {
                            console.error(err);
                            router.flash({
                                message: err,
                                type: "notification",
                                title: "Error",
                                notificationType: "danger"
                            }).changeHash("#deliveries");
                        });
                    }
                },
                '#product': {
                    options: {
                        requireData: ['productId'],
                        requireCart: true,
                        invalidRedirect: {
                            action: "#products"
                        },
                        routeData: true,
                        clearData: false
                    },
                    fn() {
                        mptapi.router.data.scrollTop = jMPT(document).scrollTop();
                        Handlebars.registerPartial("productSelections", jMPT('#productSelectionsTemplate').html());

                        let urlProductId = getSafeAPIValue('router.data.routeData.productId');
                        let req = new GetProduct(urlProductId || router.data.productId);
                        req.sendAndRender("productContainer", MPTMiddleware.productMiddleware).then(() => {
                            MPTUI.shopPage();
                            jMPT('#productContainer').showPage();
                            setTimeout(function(){
                                jQuery('.slick-initialized').slick('resize');
                                setTimeout(() => { jMPT(document).scrollTop(jMPT('.mpt-fp-product-image-container').offset().top - 150); }, 300);
                            }, 250);
                        });


                        /*req.send().then(res => {
                            let context = MPTMiddleware.productMiddleware(res);
                            context.isMobile = _isMobile || jMPT(document).width() < 980;

                            if(!mptapi.router.data.shopPage)
                            {
                                console.warn('yup', res);
                                mptapi.router.data.shopPage = MPTMiddleware.shopModelMiddleware(context);
                            }

                            MPTUI.shopPage();
                            let template = Handlebars.compile(jMPT('#fullProductPage').html().decHTML());
                            jMPT('#productContainer').html(template(context)).showPage();
                        });*/
                    }
                },
                '#pos': {
                    options: {
                        clearData: true,
                        fullscreen: true,
                        routeData: true
                    },
                    fn() {
                        if (mptapi.router.data.routeData) {
                            let adminToken = mptapi.router.data.routeData;
                            if (adminToken.length < 1) {
                                console.error("No admin token found. Redirecting to menu.");
                                mptapi.router.changeHash("#menu");
                                return;
                            }
                            mptapi.router.data.adminToken = adminToken[0];
                            jMPT('.mpt-content .page').hide();
                            let req = new GetFOH();
                            req.sendAndRender('posContainer', MPTMiddleware.POSMiddleware).then(() => {
                                mptapi.router.data.shopPage = req.response;
                                MPTUI.pos();
                                jMPT('#posContainer').show();
                            }).catch(x => {
                                mptapi.router.redirect("shop", "#menu");
                            });
                        } else {
                            mptapi.router.redirect("shop", "#menu");
                        }

                    }
                }
            },
            "store": {
                options: {
                    default() {
                        mptapi.storeVues = {};
                        mptapi.storeVues.mptStore = new MPTStore(null, null);

                        if(hasCustomStoreProductsScripts())
                        {
                            _mptStoreProductsCustomScript();
                        }

                    }
                }
            },
            "order": {
                options: {
                    default() {
                        if (mptapi.router?.params?.activateToken) {

                        }

                        if (mptapi.router.data.hasOwnProperty("newDeliveryIds") && mptapi.router.data.newDeliveryIds && mptapi.router.data.newDeliveryIds.length > 0) {
                            mptapi.router.data.deliveryId = mptapi.router.data.newDeliveryIds[0];
                        }
                        else {
                            let delId = getSafeAPIValue('router.data.deliveryId') || getSafeAPIValue('cart.deliveries[0].id');
                            if(delId)
                                mptapi.router.data.deliveryId = delId;
                        }

                        mptapi.orderVues = {};
                        // mptapi.orderVues.mptOrder = new MPTOrder(null, null);
                        mptapi.orderVues.mptOrder = new FFCustomOrder(null, null);

                        if(hasCustomOrderProductsScripts())
                        {
                            _mptOrderProductsCustomScript();
                        }
                    }
                },
                '#subscription': {
                    options: {
                        clearData: false,
                        requireData: ['deliveryId'],
                        removeData: ['shopPage'],
                        requireCart: true,
                        invalidRedirect: {
                            action: '#deliveries'
                        },
                        requireAuth: true,
                        loginRedirect: {
                            page: "user",
                            action: "#subscriptions"
                        },
                        pageTitle: "Pick Your Meals - Subscription"
                    },
                    fn() {
                        MPTUI.shopPagePartials();
                        let req = new GetDeliveryShop();
                        req.sendAndRender('shopContainer', MPTMiddleware.shopModelMiddleware).then(() => {

                            if(gaActive() && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.googleAnalyticsTID)
                            {
                                gtag('config', mptapi.companyInfo.uiSettings.googleAnalyticsTID, {'page_path': '/shop/#subscription'});
                            }

                            if(pinActive()) {
                                pintrk('track', 'pagevisit', {
                                    'page_path': '/shop/#subscription'
                                });
                            }

                            let context = req.response;
                            context.isMobile = _isMobile || jMPT(document).width() < 600;
                            context.fullWidthFilters = jMPT(document).width() < 980;
                            mptapi.router.data.shopPage = context;

                            //router.data.shopPage = req.response;
                            //MPTUI.shopPage(req.response);

                            MPTUI.shopPage(context, mptapi.router.data.routeData);
                            jMPT('#shopContainer').showPage();

                            if (!mptapi.cartDropdown.mobileMode) {
                                mptapi.cartDropdown.show();
                                mptapi.cartDropdown.position();
                            }
                            else{
                                mptapi.cartDropdown.show();//force cart to render on page
                                mptapi.cartDropdown.hide();//hide cart immediately after rendering
                                mptapi.cartDropdown.position();
                            }

                            jMPT('.mpt-filter-title').on('click', function() {
                                let accordion = jMPT(this);
                                let filterType = accordion.data('filtertype');
                                let content = jMPT('.mpt-filter-content[data-filtertype=' + filterType + ']');
                                let isOpen = content.hasClass('mpt-filter-content-open');

                                if(isOpen)
                                {
                                    jMPT('.mpt-filter-content-open[data-filtertype=' + filterType + ']').css('height', 26);
                                    jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']').css('height', 26);

                                    content.removeClass('mpt-filter-content-open');
                                    jMPT('.mpt-filter-arrow[data-filtertype=' + filterType + ']').removeClass('fa-rotate-180');
                                    let contentBody = jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']');
                                    contentBody.removeClass('mpt-filter-content-body-open');
                                }
                                else
                                {
                                    content.addClass('mpt-filter-content-open');
                                    jMPT('.mpt-filter-arrow[data-filtertype=' + filterType + ']').addClass('fa-rotate-180');
                                    let contentBody = jMPT('.mpt-filter-content-body[data-filtertype=' + filterType + ']');

                                    console.log('contentBody');
                                    console.log(contentBody);

                                    contentBody.addClass('mpt-filter-content-body-open');

                                    let lastFilter = jMPT('.list-group-item[data-filtertype="' + filterType + '"]').filter(':last')[0];
                                    let filterRect = lastFilter.getBoundingClientRect();
                                    let contentRect = jMPT('.mpt-filter-content-open[data-filtertype="' + filterType + '"]')[0].getBoundingClientRect();
                                    let newBottom = filterRect.top + filterRect.height + 15;
                                    let newHeight = newBottom - contentRect.top;
                                    jMPT('.mpt-filter-content-open[data-filtertype=' + filterType + ']').css('height', newHeight);
                                    jMPT('.mpt-filter-content-body-open[data-filtertype=' + filterType + ']').css('height', newHeight);
                                }
                            });

                            jMPT('.mobile-filter-option').on('click', function() {
                                let selectedOption = jMPT(this);
                                let ftype = selectedOption.data('filtertype');
                                let filterTitle = jMPT('.mpt-filter-title[data-filtertype="' + ftype + '"]');

                                let gid = jMPT(this).data('group-id');
                                if (typeof gid !== 'undefined' && gid != null) {
                                    jMPT('input.filter-item[data-group-id="' + gid + '"]').click();
                                }

                                filterTitle.click();

                                jMPT('#' + selectedOption.data('filter')).val(selectedOption.data('option')).change();
                            });

                            jMPT('.group-section input:checked').each(function () {
                                let gid = jMPT(this).data('group-id');
                                jMPT('button.mobile-filter-option[data-group-id="' + gid + '"]').css('background-color', 'rgba(0,0,0,.3)');
                            });

                            if (mptapi.hasOwnProperty('companyInfo') && mptapi.companyInfo.hasOwnProperty('uiSettings') && mptapi.companyInfo.uiSettings.autofitImages)
                            {
                                let minHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).height(); }).get())]);
                                let minWidth = Math.max.apply(null, [145, Math.min.apply(null, jMPT('.card-img-top').map(function (){ return jMPT(this).width(); }).get())]);
                                let rightminHeight = Math.max.apply(null, [170, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).height(); }).get())]);
                                let rightminWidth = Math.max.apply(null, [109, Math.min.apply(null, jMPT('.card-img-right').map(function (){ return jMPT(this).width(); }).get())]);

                                jMPT('.card').css({
                                    'display': 'block',
                                    'max-height': minHeight + 'px',
                                    'max-width': minWidth + 'px',
                                    'width': 'auto',
                                    'height': 'auto'
                                });

                                jMPT('.card-img-top').css({
                                    'display': 'block',
                                    'max-height': minHeight + 'px',
                                    'max-width': minWidth + 'px',
                                    'width': 'auto',
                                    'height': 'auto',
                                    'margin': 'auto'
                                });


                                jMPT('.card-img-right').css({
                                    'display': 'block',
                                    'max-height': rightminHeight + 'px',
                                    'max-width': rightminWidth + 'px',
                                    'width': 'auto',
                                    'height': 'auto',
                                    'margin': 'auto'
                                });
                            }

                            jMPT('.page-title').text("Edit Subscription");
                            jMPT('.breadcrumbs-wrap').hide();


                            if(hasCustomSubscriptionEditScripts())
                            {
                                _mptSubscriptionEditCustomScript();
                            }


                        }).catch(err => {
                            console.error(err);
                            router.flash({
                                message: err,
                                type: "notification",
                                title: "Error",
                                notificationType: "danger"
                            }).changeHash("#deliveries");
                        });
                    }
                }
            },
            "buy": {
                options: {
                    default() {
                        if(!mptapi.buyVues);
                            mptapi.buyVues = {};
                        mptapi.buyVues.mptCheckout = new MPTCheckout(null, null);

                        if(hasCustomInitBuyScripts())
                        {
                            _mptCustomInitBuyScript();
                        }
                    }
                }
            },
            "custom-product": {
                options: {
                    default() {

                        mptapi.customProductVues = {};
                        if(typeof MPTCustomProduct === 'function')
                            mptapi.customProductVues.customProduct = new MPTCustomProduct(null, null);

                        if(hasCustomProductScripts())
                        {
                            _mptCustomProductCustomScript();
                        }
                    }
                }
            },
            /**
             * User Auth and Account pages
             */
            "user": {
                options: {
                    default: {
                        action: "#account",
                    },
                },
                "#login": {
                    options: {
                        clearData: false
                    },
                    fn() {
                        if (mptapi.authToken == null) {
                            let signInTemplate = jMPT('#loginTemplate').html();

                            try {
                                if (jMPT('#mptCustomLoginTemplate').length > 0 && jMPT('#mptCustomLoginTemplate').html().length > 0) {
                                    signInTemplate = jMPT('#mptCustomLoginTemplate').html();
                                }
                            }catch(err){console.error('Error loading custom login template:', err);}

                            let compiledTemplate = Handlebars.compile(signInTemplate);

                            jMPT('#loginContainer').html(compiledTemplate(mptapi.companyInfo));
                            MPTUI.login();
                            jMPT('#loginContainer').showPage();

                            if(hasCustomLoginScripts())
                            {
                                _mptUserLoginCustomScript();
                            }

                        } else {
                            router.changeHash("#account");
                        }
                    }
                },
                "#register": {
                    options: {
                        clearData: false,
                    },
                    fn() {
                        if (mptapi.authToken == null) {
                            let registerTemplate = jMPT('#registerTemplate').html();

                            try {
                                if (jMPT('#mptCustomRegistrationTemplate').length > 0 && jMPT('#mptCustomRegistrationTemplate').html().length > 0) {
                                    registerTemplate = jMPT('#mptCustomRegistrationTemplate').html();
                                }
                            }catch(err){console.error('Error loading custom template:', err);}

                            let compiledTemplate = Handlebars.compile(registerTemplate);

                            jMPT('#registerContainer').html(compiledTemplate);
                            MPTUI.register();
                            jMPT('#registerContainer').showPage();

                            if(hasCustomLoginScripts())
                            {
                                _mptUserLoginCustomScript();
                            }
                        } else {
                            router.changeHash("#account");
                        }
                    }
                },
                '#forgotpassword': {
                    fn() {
                        let forgotPassTemplate = jMPT('#forgotPasswordTemplate').html();
                        jMPT('#forgotPasswordContainer').html(forgotPassTemplate);
                        MPTUI.forgotPass();
                        jMPT('#forgotPasswordContainer').showPage();
                    }
                },
                '#resetpassword': {
                    options: {
                        routeData: true,
                    },
                    fn() {

                        if (mptapi.router.data.routeData) {
                            if(!!mptapi.router.data.routeData.token && !!mptapi.router.data.routeData.username){
                                let token = mptapi.router.data.routeData.token,
                                    username = mptapi.router.data.routeData.username;
                                let t = Handlebars.compile(jMPT('#resetPasswordTemplate').html());
                                jMPT('#resetPasswordContainer').html(t({token, username})).showPage();
                                MPTUI.resetPass();
                            } else {
                                router.changeHash("#login");
                            }
                        } else {
                            router.changeHash("#login");
                        }
                    }
                },
                "#account": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#account"
                        }
                    },
                    fn() {
                        let req = new GetAccountInfo();
                        req.send().then((context) => {
                            let accountTemplate = Handlebars.compile(jMPT('#accountTemplate').html());
                            jMPT('#accountContainer').html(accountTemplate(context));
                            MPTUI.account();
                            jMPT('#accountContainer').showPage();

                            /*if(isGhosting) //TODO: add to all showPage functions
                            {
                                var ghostingBanner = jMPT('<div class="ghosting-banner" style="background-color:#1976d2;color:#fff;font-weight:900">GHOSTING AS JOHN DOE</div>');
                                ghostingBanner.appendTo('.header-main');
                            }*/
                        });


                    }
                },
                "#orders": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#orders"
                        }
                    },
                    fn() {
                        let req = new GetOrders();
                        req.sendAndRender("ordersContainer", MPTMiddleware.orderHistoryMiddleware).then(x => {
                            MPTUI.orders();
                            jMPT('#ordersContainer').showPage();
                        });
                    }
                },
                "#referral-code": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#referral-code"
                        }
                    },
                    fn() {
                        let req = new GetReferralCode();
                        req.send().then(context => {
                            let referralCodeTemplate = Handlebars.compile(jMPT('#referralCodeTemplate').html());
                            jMPT('#referralCodeContainer').html(referralCodeTemplate(context));
                            MPTUI.referralCode();
                            jMPT('#referralCodeContainer').showPage();
                        });
                    }
                },
                "#addresses": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#addresses"
                        }
                    },
                    fn() {
                        let req = new GetShippingProfiles();
                        req.sendAndRender("addressesContainer").then(x => {
                            MPTUI.addresses();
                            jMPT('#addressesContainer').showPage();
                        });
                    }
                },
                "#subscriptions": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#subscriptions"
                        },
                    },
                    fn() {
                        let req = new GetSubscriptions();
                        req.sendAndRender('subscriptionsContainer').then(() => {

                            MPTUI.subscriptions();
                            jMPT('#subscriptionsContainer').showPage();

                            var hashData = mptapi.router.getRouteVariables();

                            if(hashData.hasOwnProperty('subid') && typeof(hashData.subid) !== 'undefined')
                            {
                                var buttonElem = jMPT('.edit-subpayment-btn[data-id="' + hashData.subid + '"]'); //edit card button
                                var subDiv = buttonElem.closest('.card');

                                buttonElem.prepend(jMPT('<i class="fa fa-arrow-right mr-2"></i>'));
                                buttonElem.removeClass('mpt-btn-primary').addClass('mpt-btn-success');
                                subDiv.css('border', '3px solid #28a745');

                                if(!subDiv.is(':visible')) { //on a non-active page
                                    jMPT('.paginate').each(function () {
                                        jMPT(this).removeClass('active');
                                    });
                                    subDiv.closest('.paginate').addClass('active');

                                    jMPT('.page-item').each(function(){ jMPT(this).removeClass('active'); });
                                }
                                jMPT([document.documentElement, document.body]).animate({
                                    scrollTop: buttonElem.offset().top
                                }, 1000); //scroll to button
                            }

                        });
                    }
                },
                "#agreements": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#agreements"
                        },
                        target: "agreementsContainer"
                    },
                    fn(){
                        let req = new GetAgreements();
                        req.send().then((res) => {

                            if(res.hasOwnProperty('agreements') && res.agreements.length > 0) res.agreements = res.agreements.filter(a => a.dateSigned !== null);

                            let agTemplate = Handlebars.compile(jMPT('#userAgreementsTemplate').html());
                            jMPT('#agreementsContainer').html(agTemplate(res));
                            MPTUI.agreements();
                            jMPT('#agreementsContainer').showPage();
                        });

                        /*let _t = this;
                        let req = new GetAgreements();
                        req.sendAndRender(this.options.target, MPTMiddleware.agreementsMiddleware).then(() => {
                            MPTUI.agreements();
                            jMPT('#' + _t.options.target).showPage();
                        })*/
                    }
                },
                "#freeze": {
                    options: {
                        requireAuth: true,
                        requireData: ['subscriptionId'],
                        clearData: false,
                        loginRedirect: {
                            page: "user",
                            action: "#subscriptions"
                        }
                    },
                    fn() {
                        let req = new GetFreezeOptions(router.data.subscriptionId);
                        req.sendAndRender('freezeSubscriptionContainer').then(() => {
                            MPTUI.freezeSubscription();
                            jMPT('#freezeSubscriptionContainer').showPage();
                        });
                    }
                },
                "#cancel": {
                    options: {
                        requireAuth: true,
                        requireData: ['subscriptionId'],
                        clearData: false,
                        loginRedirect: {
                            page: "user",
                            action: "#subscriptions"
                        }
                    },
                    fn() {
                        let req = new GetCancelOptions(router.data.subscriptionId);
                        req.sendAndRender('cancelSubscriptionContainer').then(() => {
                            MPTUI.cancelSubscription();
                            jMPT('#cancelSubscriptionContainer').showPage();
                        });
                    }
                },
                "#accountinfo": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#accountinfo"
                        },
                        hideCart: true
                    },
                    fn() {
                        let req = new GetAccountInfo();
                        req.sendAndRender("accountinfoContainer").then(x => {
                            MPTUI.accountinfo();
                            jMPT('#accountinfoContainer').showPage();
                        });
                    }
                },
                "#payments": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            action: "#payments"
                        }
                    },
                    fn() {
                        let req = new GetBillingProfiles();
                        req.sendAndRender("paymentsContainer").then(x => {
                            if (req.response.hasOwnProperty("padKey")) {
                                router.data.padKey = req.response.padKey;
                            }
                            MPTUI.payments();
                            jMPT('#paymentsContainer').showPage();
                        });
                    }
                },
                "#ghost": {
                    options: {
                        requireAuth: false,
                        routeData: true
                    },
                    fn() {

                        if (!router.data.routeData.token) {
                            console.error("GhostId not found");
                            router.changeHash("#login");
                            return;
                        }

                        mptapi.authToken = {
                            token: router.data.routeData.token,
                            expirationUTC: new Date().addHours(4)
                        };
                        console.log("Ghosting as user. ", mptapi.authToken);
                        jMPT('.loginLink').hide();
                        jMPT('.logoutLink').show();
                        //router.changeHash("#account");

                        if(router.data.routeData.route)
                        {
                            if(router.data.routeData.subId)
                                router.data.subId = router.data.routeData.subId;

                            let reRouteHash = router.data.routeData.hash || null;
                            router.redirect(router.data.routeData.route, '#' + reRouteHash);
                        }else
                            router.redirect('user', '#account');
                    }
                }
            },
            "apply": {
                options: {
                    requireAuth: false,
                    hideCart: false,
                    default: {
                        action: "#new",
                    }
                },
                "#new": {
                    options: {
                        clearData: false,
                    },
                    fn() {
                        MPTUI.apply();
                        jMPT('#applicationContainer').showPage();
                    }
                },
                "#update": {
                    options: {
                        clearData: false,
                        requireAuth: true,
                    },
                    fn() {
                        MPTUI.updateApplication();
                        jMPT('#applicationContainer').showPage();
                    }
                },
                "#approval": {
                    options: {
                        requireAuth: false, //TODO: change to true when done editing
                        clearData: false,
                    },
                    fn() {
                        let approvalTemplate = jMPT('#approvalTemplate').html();
                        jMPT('#applicationContainer').html(approvalTemplate);

                        if (router.data.hasOwnProperty("financeApp")) {
                            MPTUI.approved();
                            jMPT('#applicationContainer').showPage();
                        }
                        else{
                            router.changeHash("#review"); //TODO: reroute to approval history page
                        }
                    }
                },
                "#review": {
                    options: {
                        clearData: false,
                        routeData: true
                    },
                    fn() {
                        if (router.data.routeData) {
                            new GetApprovals().send().then(x => {
                                if (x.hasOwnProperty("approvalHistory")) {
                                    let id = router.data.routeData[0];
                                    let order = x.approvalHistory.filter(x => x.id === id);
                                    let t = Handlebars.compile(jMPT('#approvalTemplate').html());
                                    jMPT('#applicationContainer').html(t({cart: order[0]}));
                                    MPTUI.approved();
                                    jMPT('#applicationContainer').showPage();
                                } else {
                                    throw new Error("Cannot find approval.");
                                }
                            });
                        }
                    }
                }
            },
            "agreement": {
                options: {
                    requireAuth: true,
                    default: {
                        action: "#sign",
                    },
                    hideCart: true
                },
                "#sign": {
                    options: {
                        clearData: false,
                        requireAuth: true,
                        hideCart: true
                    },
                    fn() {
                        new AwaitProperty('cart', mptapi, function () {
                            let agrId = mptapi.cart.agreements[0].id;
                            let agrReq = new GetUserAgreement(agrId);
                            agrReq.send().then((agrRes) => {
                                MPTUI.completeAgreement(agrRes.agreements[0]);
                            });
                        }, 10);

                        jMPT('#agreementContainer').showPage();

                        let limit = jMPT('#agreementContainer').offset().top;
                        jMPT(document).on("scroll", function(e) {
                            if (jMPT(this).scrollTop() > limit) { //scrolled past the top of the agreement
                                jMPT('.mpt-agreement-toolbar').addClass('mpt-floating-toolbar').removeClass('mpt-top-toolbar');
                                if(jMPT('#header').offset().top + jMPT('#header').height() <= jMPT(this).scrollTop())//header is not visible
                                {
                                    jMPT('.mpt-agreement-toolbar').css('top', 0);//place toolbar at top
                                }
                                else{//header is visible
                                    jMPT('.mpt-agreement-toolbar').css('top', jMPT('#header').height() + (jMPT('#header').offset().top - jMPT(window).scrollTop() + 1));//place toolbar below header
                                }

                            } else { //above the top of the agreement
                                jMPT('.mpt-agreement-toolbar').removeClass('mpt-floating-toolbar').addClass('mpt-top-toolbar');
                            }
                        });
                    }
                },
                "#view": {
                    options: {
                        clearData: false,
                        requireAuth: true,
                        hideCart: true
                    },
                    fn() {
                        //MPTUI.reviewAgreement();
                        jMPT('#agreementContainer').showPage();
                    }
                }
            },
            "checkout": {
                options: {
                    middleware: [
                        //MPTMiddleware.requireAuthentication(this.page"/user")
                    ],
                    default: {
                        action: "#review"
                    }
                },
                "#review": {
                    options: {
                        requireAuth: true,
                        loginRedirect: {
                            page: "checkout",
                            action: "#review"
                        }
                    },
                    fn() {
                        if (mptapi.cart.deliveries.length === 0 || mptapi.cart.deliveries.map(x => x.products.length).sum() === 0) {
                            jMPT.createNotification("Oops!", "Please add something to your cart first.", "warning", "fa fa-excl");
                            router.redirect("/shop");
                            return;
                        }

                        let total = 0;

                        try{
                            total = Math.max(mptapi.cart.totals.filter(x => x.name.includes("Total")).map(x => x.amount));
                        }catch{ total = 0; }

                        let req = new InitCheckout(MPTRequest.tokensObject, total);
                        req.sendAndRender("reviewContainer", MPTMiddleware.checkoutPage).then(x => {

                            if(req.response.cart) {
                                let cartTotal = 0;
                                try{
                                    cartTotal = Math.max.apply(null, req.response.cart.totals.filter(cli => cli.name.toLowerCase().includes('total')).map(cli => { return cli.amount }));
                                }  catch (errMessage) {
                                    console.error(errMessage);
                                    cartTotal = 0;
                                }

                                try {
                                    mptapi.track('init-checkout', {
                                        cartTotal: cartTotal,
                                        cartObj: JSON.stringify(req.response.cart),
                                    });
                                } catch (errMessage) {
                                    console.error(errMessage);
                                }
                            }

                            if (req.response.hasOwnProperty("padKey")) {
                                    router.data.padKey = req.response.padKey;
                            }
                            router.data.checkout = req.response;
                            MPTUI.initCheckout();
                            //Showing Page
                            jMPT('#reviewContainer').showPage();

                            if(req.response.enforcedSubOverwriteMode)
                                subscriptionEditMode(mptapi.user.displayName, 'checkout');

                            if(hasCustomReviewCheckoutScripts())
                            {
                                _mptReviewCheckoutCustomScript();
                            }
                        });
                    }
                },
                "#confirmation": {
                    options: {
                        clearData: false,
                        routeData: true
                    },
                    fn() {
                        if (!!router.data.routeData && !!router.data.routeData.orderid) { // Past order
                            new GetOrders().send().then(x => {
                                if (x.hasOwnProperty("orderHistory")) {
                                    let id = router.data.routeData.orderid;
                                    let order = x.orderHistory.filter(x => x.id === id);
                                    let t = Handlebars.compile(jMPT('#orderConfirmation').html());
                                    jMPT('#confirmationContainer').html(t({cart: order[0]}));

                                    MPTUI.confirmation();
                                    jMPT('#confirmationContainer').showPage();
                                    if(hasCustomConfirmationScripts())
                                    {
                                        _mptConfirmationCustomScript();
                                    }
                                } else {
                                    throw new Error("Cannot find order.");
                                }
                            });
                        } else if (router.data.hasOwnProperty("prevOrder")) { // Order confirmation page
                            let prevOrder = router.data.prevOrder;
                            if(prevOrder.cart) {//report purchase
                                try {
                                    let subtotal = prevOrder.cart.totals.filter(x => x.name === "Subtotal").sum(t => t.amount) || 0;
                                    let weeklySubtotal = prevOrder.cart.totals.filter(x => x.name === "Weekly Subtotal").sum(t => t.amount) || 0;

                                    if(subtotal || weeklySubtotal) {
                                        let total = 0;
                                        let tax = 0;
                                        let shipping = 0;

                                        if (subtotal > weeklySubtotal) {
                                            total = prevOrder.cart.totals.filter(x => x.name === "Total").sum(t => t.amount) || 0;
                                            tax = prevOrder.cart.totals.filter(x => x.name === "Tax").sum(t => t.amount) || 0;
                                            shipping = prevOrder.cart.totals.filter(x => x.name === "Shipping").sum(t => t.amount) || 0;
                                        } else {
                                            total = prevOrder.cart.totals.filter(x => x.name === "Weekly Total").sum(t => t.amount) || 0;
                                            tax = prevOrder.cart.totals.filter(x => x.name === "Weekly Tax").sum(t => t.amount) || 0;
                                            shipping = prevOrder.cart.totals.filter(x => x.name === "Weekly Shipping").sum(t => t.amount) || 0;
                                        }

                                        if(gaActive()) {
                                            gtag('event', 'purchase', {
                                                "transaction_id": prevOrder.cart.id,
                                                "value": total,
                                                "currency": "USD",
                                                "tax": tax,
                                                "shipping": shipping
                                            });
                                        }

                                        if(pinActive()) {
                                            pintrk('track', 'checkout', {
                                                value: total,
                                                currency: 'USD',
                                            });
                                        }

                                        if (mptsettings.options.hasOwnProperty("adword") && mptsettings.options.adword.hasOwnProperty("checkout") && mptsettings.options.adword.checkout !== "") {
                                            gtag('event', 'conversion', {
                                                'send_to': mptsettings.options.adword.checkout,
                                                'value': total,
                                                'currency': 'USD',
                                                'transaction_id': prevOrder.cart.id
                                            });
                                        } else {
                                            gtag('event', 'conversion', {
                                                'value': total,
                                                'currency': 'USD'
                                            });
                                        }
                                    }
                                    else{
                                        gtag('event', 'conversion');
                                    }
                                }catch(err){
                                    console.error(err);
                                }
                            }
                            if (prevOrder) {
                                let t = Handlebars.compile(jMPT('#orderConfirmation').html());
                                jMPT('#confirmationContainer').html(t(prevOrder));
                                MPTUI.confirmation();
                                jMPT('#confirmationContainer').showPage();
                                if(hasCustomConfirmationScripts())
                                {
                                    _mptConfirmationCustomScript();
                                }
                            } else {

                                throw new Error("Cannot find order.");
                            }
                        }
                    }
                }
            },
            "404": function () {
                MPTRouter.renderError();
            },
            "$": {
                '#redirect': function () {
                    /*
                        Redirect Ex.
                        <page>#redirect;page|#action;data1:val1|data2:val2
                        would redirect to /page#action with the data:
                        {
                            data1: val1,
                            data2: val2
                        }

                     */
                    let hash = window.location.hash.substr(1).split(";");
                    let redirectTo = hash[1].split("|");
                    let redirectPage = redirectTo[0];
                    let redirectHash = (redirectTo.length > 1) ? redirectTo[1] : "";

                    let hashData = Object.assign(...hash[2].split("|").map(x => {
                        let obj = {};
                        let split = x.split(":");
                        obj[split[0]] = split[1];
                        return obj;
                    }));
                    router.redirect(redirectPage, redirectHash, hashData);
                }
            }
        };
        return jMPT.extend(true, defaults, override);
    }

    flash(data) {
        this.flashCache.push(data);
        return this;
    }

    flashIt() {
        this.flashData = this.flashCache;
        this.flashCache = [];
    }

    updateRoute() {
        this.path = decodeURI(window.location.pathname).split("/").filter(x => x !== ""); // Array of all path pieces in the url separated by a slash.
        this.page = this.path[this.path.length - 1]; // Name of the page
        this.action = window.location.hash.length > 0 ? decodeURIComponent(decodeURIComponent(window.location.hash)).match(/^#([\w-]+)/g)[0] : null; // The current action to show on the page.
        this.params = locationParamsToJSON(window.location);
        this.modal = decodeURIComponent(decodeURIComponent(window.location.hash)).match(/\/([\w-]+)/g); // Opened Modals (NOT IN USE)
        this.clearData = true; // Flag used for redirecting with data. true clears data on unload.
        this.setRoutes(); // Regenerate Routes
    }

    updateHistory(options) {
        let sliceIndex = this.history.length - this.historySize;
        if (sliceIndex < 0) {
            sliceIndex = 0;
        }
        //this.history = this.history.slice(sliceIndex);
        //this.history.push(options);
    }

    render(callback) {
        jMPT('.mpt-error').remove();
        this.updateHistory({
            page: this.page,
            action: this.action,
            params: this.params,
            data: this.data,
            time: new Date().toISOString()
        });


        //Setup options
        let pageDefaults = {
            requireData: []
        };
        let actionDefaults = {
            requireAuth: false,
            requireCart: false,
            requiredFields: false,
            clearData: true,
            hideCart: false
        };
        this.updateRoute();
        let hasAction = this.action != null;
        this.routes = this.getRoutes(this.routeOverride);
        let page = this.routes[this.page];

        if (this.routes.$[this.action] != null) {
            this.routes.$[this.action]();
            return;
        }
        //console.log("[MPT Router] Updated Route: ", this);
        //Only run router for pages in the wp slug options
        if (Object.values(mptsettings.options.slugs).indexOf(this.page) !== -1 && this.routes.hasOwnProperty(this.page)) {
            jMPT('.mpt-content .page').hidePage();
            let pageOptions = Object.assign(pageDefaults, page.options || {});

            if (this.routes[this.page]) { // Check if page is in routes

                if (typeof this.routes[this.page] === "function") { // if key is function (ie. 404)
                    this.flashIt();
                    page(); // run function
                } else if (hasAction) {
                    let action = page[this.action];
                    if (action) { // Action exists on current page
                        let actionOptions = Object.assign(actionDefaults, action.options || {});

                        //region Action Options
                        /**
                         * Extract Extra data in the route
                         * Ex #<action>|<key>:<val>|...
                         */
                        if (actionOptions.routeData) {
                            let data = decodeURIComponent(decodeURIComponent(window.location.hash)).split("|");
                            if (data.length > 1) {
                                data = data.slice(1); // Remove action

                                // Convert array to Key/Val pairs object
                                this.data.routeData = data.reduce((agg,val) => {
                                    agg[val.split(":")[0]] = val.split(":")[1];
                                    return agg;
                                }, {});
                            }
                            else{  //Old version of route data for ghosting and forgot password only//TODO: remove this once all plugin versions are synced
                                let data = decodeURIComponent(decodeURIComponent(window.location.hash)).split(":");
                                if (data.length > 1) {
                                    this.data.routeData = {};
                                    if(this.action === '#ghost') {
                                        this.data.routeData.token = data[1];
                                    }else if(this.action === "#resetpassword")
                                    {
                                        if (data.length > 2) {
                                            this.data.routeData = {};
                                            this.data.routeData.token = data[1];
                                            this.data.routeData.token = data[2];
                                        }
                                    }
                                }else this.data.routeData = {}; //NOTE: <-- need to keep this after old decode method has been removed
                            }


                        }

                        /**
                         * options.requireAuth
                         * @type boolean
                         *
                         * options.loginRedirect
                         * @type Object
                         * @keys ['page', 'action']
                         */
                        if (actionOptions.requireAuth) { //Auth Required for action
                            if (!MPTRouter.checkAuth()) { // Check the auth for validity
                                //If invalid, set redirect after login or register
                                mptapi.authToken = null;
                                let redirectPage = this.page;
                                let redirectAction = this.action;

                                if (!!actionOptions.loginRedirect) {
                                    redirectPage = actionOptions.loginRedirect.page || this.page;
                                    redirectAction = actionOptions.loginRedirect.action || this.action;
                                }

                                console.warn("[MPT Router] Authentication required. Please log in. Redirecting...");
                                this.setRedirect(redirectPage, redirectAction);

                                if (Page.isPage("user")) {
                                    this.changeHash("#login");
                                } else {
                                    this.redirect("user", "#login");
                                }
                                return; // Do not move forward.
                            }
                        }

                        if (actionOptions.removeData) {
                            this.clearProps.push.apply(this.clearProps, actionOptions.removeData);
                        }

                        if (actionOptions.requireCart) {
                            if (!(mptapi.clientCartId || mptapi.authToken)) { // Check the auth for validity
                                console.warn("[MPT Router] This action requires a cart. Redirecting...");
                                //Redirect to get missing fields
                                if (!!actionOptions.invalidRedirect) {
                                    let redirect = {
                                        page: actionOptions.invalidRedirect.page || this.page,
                                        action: actionOptions.invalidRedirect.action || this.action
                                    };
                                    if (Page.isPage(redirect.page)) {
                                        this.changeHash(redirect.action);
                                    } else {
                                        this.redirect(redirect.page, redirect.action);
                                    }
                                } else {
                                    if (typeof pageOptions.default === "function") {
                                        pageOptions.default();
                                    } else {
                                        this.changeHash(pageOptions.default.action);
                                    }

                                }
                                return; // Do not move forward.
                            }
                        }

                        let cart = jMPT('.mpt-cart-icon');
                        if (actionOptions.hideCart) {
                            if (cart.length > 0) {
                                cart.hide();
                                mptapi.cartDropdown.hidden = true;
                            } else {
                                new Await(".mpt-cart-icon", function (c) {
                                    jMPT('.mpt-cart-icon').hide();
                                    c.hide();
                                }, 300, cart);
                            }
                        } else {
                            cart.show();
                        }

                        this.clearData = actionOptions.clearData; //Clear data on reload

                        /**
                         * options.requireData
                         * @type Array
                         *
                         */
                        if (!!actionOptions.requireData) {
                            console.log("Has requireData field", actionOptions.requireData);
                            let missingFields = [];
                            for (let i = 0; i < actionOptions.requireData.length; i++) {
                                if (actionOptions.requireData[i].constructor === String) {
                                    if (!this.data.hasOwnProperty(actionOptions.requireData[i])) {
                                        if(this.data.routeData && this.data.routeData.hasOwnProperty(actionOptions.requireData[i]))
                                        {
                                            this.data[actionOptions.requireData[i]] = this.data.routeData[actionOptions.requireData[i]];
                                        }else missingFields.push(actionOptions.requireData[i]);
                                    }
                                } else if (actionOptions.requireData[i].constructor === Array) {
                                    let subMissingFields = [];
                                    for (let j = 0; j < actionOptions.requireData[i].length; j++) {
                                        if (!this.data.hasOwnProperty(actionOptions.requireData[i][j])) {
                                            if(this.data.routeData && this.data.routeData.hasOwnProperty(actionOptions.requireData[i][j]))
                                            {
                                                this.data[actionOptions.requireData[i][j]] = this.data.routeData[actionOptions.requireData[i][j]];
                                            }else subMissingFields.push(actionOptions.requireData[i][j]);
                                        }
                                    }
                                    if (subMissingFields.length === actionOptions.requireData[i].length)
                                        missingFields.push(subMissingFields);
                                }
                            }
                            if (missingFields.length > 0) { // Missing Required Fields
                                console.warn("[MPT Router] Action is missing fields: {0}".format(missingFields.map(x => {
                                    if (x.constructor === Array) {
                                        return x.join(" or ");
                                    }
                                    return x;
                                }).join(", and ")));

                                //Redirect to get missing fields
                                if (!!actionOptions.invalidRedirect) {
                                    let redirect = {
                                        page: actionOptions.invalidRedirect.page || this.page,
                                        action: actionOptions.invalidRedirect.action || this.action
                                    };
                                    if (Page.isPage(redirect.page)) {
                                        this.changeHash(redirect.action);
                                    } else {
                                        this.redirect(redirect.page, redirect.action);
                                    }
                                } else {
                                    if (typeof pageOptions.default === "function") {
                                        pageOptions.default();
                                    } else {
                                        this.changeHash(pageOptions.default.action);
                                    }
                                }
                                return;
                            }
                        }
                        //endregion

                        //region Flash Data
                        this.flashIt();
                        if (this.flashData.length > 0) {
                            for (let i = 0; i < this.flashData.length; i++) {
                                let flashObj = this.flashData[i];
                                if (flashObj.hasOwnProperty("type")) {
                                    switch (flashObj.type) {
                                        default:
                                        case "notification":
                                            let title = flashObj.title;
                                            jMPT.createNotification(title, flashObj.message, flashObj.notificationType);
                                            break;
                                    }
                                }
                            }
                        }
                        //endregion

                        if (actionOptions.fullscreen) {

                            jMPT('body').html(jMPT('.mpt-content')).show();
                        }

                        new AwaitProperty('companyInfo', mptapi, function () {
                            action.fn();
                        }, 10);
                    } else if (pageOptions.default) { // Action does not exist, route to default
                        console.log("[MPT Router] Action does not exist (" + this.action + "). Routing to default action " + pageOptions.default.action);
                        if (typeof pageOptions.default === "function") {
                            pageOptions.default();
                        } else {
                            this.changeHash(pageOptions.default.action); // Route to default action if action does not exist
                        }
                    } else { // No default, show 404
                        MPTRouter.renderError(); // 404
                    }
                } else {
                    console.log("[MPT Router] No action specified. Routing to default action " + pageOptions.default.action + " for " + this.page);
                    if (typeof pageOptions.default === 'function') {
                        pageOptions.default();
                    } else {
                        this.changeHash(pageOptions.default.action); // Route to default action if no action specified
                    }
                }

            }
            /*else{
                MPTRouter.renderError();
            }*/
        }

        if (typeof callback === "function") {
            callback();
        }
    }

    changeHash(hash, data = {}, forceRender = false, flashData = false) {
        console.log("[MPT Router] Changing Hash: ", hash);

        if (!flashData) {
            this.data = Object.assign(this.data, data);
        } else {
            this.flashCache.push(data);
        }

        if (data !== {} && !!data) {
            this.clearData = false;
        }
        window.location.hash = hash;
        this.params = locationParamsToJSON(window.location);
        if (forceRender) {
            this.render();
        }
    }

    /**
     * Provides various routing functionality with a redirect.
     * @param page Page to redirect to
     * @param hash Action to redirect to including the "#"
     * @param data Any extra data to pass to the redirected page
     */
    redirect(page, hash = "", data = {}) {

        if(mptapi) //REMOVE BECAUSE THIS IS CONTAINED IN THE UNLOAD FUNC.
            mptapi.save();

        if (typeof page === "undefined") {
            if (this.redirectUrl != null) {
                page = this.redirectUrl;
            } else {
                console.error("Redirect FAIL");
                return;
            }
        }
        let fullUri = "";
        if (typeof page === "string") {
            if (page.substr(0, 1) !== "/") { // Prepend forward slash
                page = "/" + page;
            }
            fullUri = page + hash;

            this.data = Object.assign(this.data, data);
            console.log("[MPT Router] Redirecting to: " + fullUri, data);

            this.clearData = false;
            if (data === false) {
                this.clearData = true;
            }

            if (Page.isPage(page) && !!hash) {
                this.changeHash(hash);
            } else {
                window.location = fullUri;
            }
        } else {
            console.error("No page to redirect to. ");
        }

    }


}

class Page {
    constructor(options) {
        this.fullUrl = window.location.href;
        this.path = decodeURI(window.location.pathname).split("/").filter(x => x !== ""); // Array of all path pieces in the url separated by a slash.
        this.pageName = this.path[this.path.length - 1]; // Name of the page
        this.action = window.location.hash.length > 0 ? window.location.hash.match(/^#([\w-]+)/g)[0] : null; // The current action to show on the page.
        this.params = locationParamsToJSON(window.location);
        this.clearData = true; // Flag used for redirecting with data. true clears data on unload.
    }

    isPage(page, action) {
        let curPage = this.pageName;
        let curAction = this.action;
        if (!page) {
            return false;
        }
        if (!action) {
            action = curAction;
        }
        return curPage === page && curAction === action;
    }

    static isPage(page, action) {
        let curPage = mptapi.router.page;
        let curAction = mptapi.router.action;
        if (!page) {
            return true;
        }
        if (!action) {
            action = curAction;
        }
        return curPage === page && curAction === action;
    }
}

/**
 * MPTCart
 */
class MPTCart {
    constructor() {
        let cart = this;
        this.dropdown = '.shopping-cart-wrapper';
        let dropdownHTML = jMPT('<div>', {class: this.dropdown.substr(1)});
        this.parentElement = "body";
        jMPT(this.parentElement).append(dropdownHTML);

        if (!Page.isPage('order', '#subscription')) {
            this.getCart(true);
        }

        this.mobileMode = false;
        this.qtyuptimeout = null;
        this.qtydowntimeout = null;
        this.visible = false;
        this.mobileBreakpoint = 500;
        this.scrollPosition = 0;
        this.buttonDelay = 500;


        jMPT('.mpt-cart-icon').click(this.toggle);

        if (is_safari) {
            console.log("Safari detected. Disabling scroll positioning.");
        }

        this.position();

        jMPT(window).on({
            scroll: () => cart.position(),
            resize: () => cart.position()
        });


        jMPT('#nav-panel').on("slideToggle", function () {
            let time = 1000;
            let interval = setInterval(function () {
                cart.position();
                if (time === 0) {
                    clear();
                }
                time -= 10;
            }, 10);

            function clear() {
                clearInterval(interval);
                console.log("CLEAR INTERVAL");
            }

        });
    }

    static getScrollBarWidth() {
        let inner = document.createElement('p');
        inner.style.width = "100%";
        inner.style.height = "200px";

        let outer = document.createElement('div');
        outer.style.position = "absolute";
        outer.style.top = "0px";
        outer.style.left = "0px";
        outer.style.visibility = "hidden";
        outer.style.width = "200px";
        outer.style.height = "150px";
        outer.style.overflow = "hidden";
        outer.appendChild(inner);

        document.body.appendChild(outer);
        let w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        let w2 = inner.offsetWidth;
        if (w1 === w2) w2 = outer.clientWidth;

        document.body.removeChild(outer);

        return (w1 - w2);
    }

    getCartCount(type) {
        if (mptapi.cart && mptapi.cart.deliveries) {
            if (type === "menuItems") {
                return mptapi.cart.deliveries.map(x => {
                    if(x.products)
                        return x.products.map(y => y.qty).sum();
                    else return 0;
                }).sum();
            } else if (type === "deliveries")
                return mptapi.cart.deliveries.sum();
        }
        else return 0;
    }

    getCart(toggle, prevResponse) {
        let cart = this;
        let req = null;
        if (Page.isPage("order", "#subscription")) {
            req = new SubscriptionEdit(mptapi.router.data.subId);
        } else {
            req = new GetCart();
        }

        if (prevResponse && prevResponse.hasOwnProperty('cart')) {
            initCart(prevResponse);
        }
        else {
            req.send().then(x => {
                initCart(x);
            });
        }

        function initCart(x)
        {
            cart = mptapi.cartDropdown;
            x = MPTMiddleware.cartMiddleware(x);
            let t = Handlebars.compile(req.template);
            let carts = jMPT(cart.dropdown);

            jMPT(cart.dropdown).html(t(x));

            jMPT('.shopping-cart-body').on('scroll', function () {
                cart.scrollPosition = jMPT(this).scrollTop();
            });

            if (cart.visible) {
                jMPT('.shopping-cart').css('right', 0).addClass('visible');
                jMPT('.mpt-cart-icon').css('right', (cart.mobileMode) ? "87vw" : "333px").addClass('visible');
            } else {
                jMPT('.mpt-cart-icon').css('right', '10px').removeClass('visible');
            }

            cart.position();
            jMPT('.cart-save-subscription-changes').click(function () {
                let req = new SubscriptionCommit(mptapi.router.data.subId);
                req.send().then(() => {
                    window.removeEventListener('beforeunload', handleExitSubEditor);
                    mptapi.router.redirect("user", "#subscriptions", false);
                });
            });

            jMPT('.mpt-cart-icon').click(cart.toggle);
            jMPT('.edit-cart-delivery').click(function () {
                let deliveryId = jMPT(this).data("deliveryid");
                mptapi.router.updateRoute();
                Custombox.modal.closeAll();

                if(mptapi.companyInfo && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
                    mptapi.router.redirect("/store");
                }
                else if(getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')) {
                    mptapi.router.redirect("/order", '', {deliveryId: deliveryId});
                }
                else {
                    if (mptapi.router.page !== mptapi.options.slugs.order) {
                        if (Page.isPage('order', '#subscription') && mptapi.router.data.subId) {
                            mptapi.router.redirect(mptapi.options.slugs.order, "#subscription", {deliveryId: deliveryId});
                        } else {
                            mptapi.router.redirect(mptapi.options.slugs.shop, "#products", {deliveryId: deliveryId});
                        }
                    } else {
                        if (cart.mobileMode) {
                            cart.toggle();
                        }

                        if (Page.isPage('order', '#subscription') && mptapi.router.data.subId) {
                            mptapi.router.changeHash("#subscription", {deliveryId}, true);
                        } else {
                            mptapi.router.changeHash("#products", {deliveryId}, true);
                        }
                    }
                }
            });

            jMPT('.removeFromCart').on({
                click() {
                    let recordid = jMPT(this).attr("data-recordid");
                    jMPT('.quantity').toArray().map(x => ({
                        productId: jMPT(x).data("productid"),
                        records: jMPT(x).data('records')
                    })).filter(x => x.records != null && x.records != "");
                    let req = new RemoveProductFromDelivery(recordid);
                    req.send().then(x => {
                        jMPT('.mpt-cart-icon').addTimedClass("shake");
                        cart.getCart(false, x);
                        Custombox.modal.closeAll();
                        if (Page.isPage('shop', '#products') || Page.isPage('shop', '#product') || Page.isPage('shop', '#subscription')) {
                            let currentRecurrence = jMPT('#recurrenceOptions').val();
                            jMPT('.quantity[data-records*=' + recordid + ']').each(function (i, e) {
                                let records = IsJsonString(jMPT(this).data('records')) ? JSON.parse(jMPT(this).data('records')) : jMPT(this).data('records');
                                records[currentRecurrence].recordId = null;
                                records[currentRecurrence].qty = 0;
                                jMPT(this).data('records', JSON.stringify(records));
                                jMPT(this).find('select').val(0);
                            });
                            if(!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
                                mptapi.router.render();
                            }
                        }
                        if (Page.isPage('checkout', "#review")) {
                            let checkoutProduct = jMPT('#' + recordid);
                            if (checkoutProduct.siblings().length === 0) {
                                checkoutProduct.closest(".card").slideUp();
                            } else {
                                checkoutProduct.slideUp();
                            }
                            mptapi.router.render();
                        }
                    });
                }
            });

            jMPT('.remove-cart-delivery').on({
                click() {
                    let $this = jMPT(this);
                    let deliveryId = $this.attr("data-deliveryid");
                    let req = new RemoveDelivery(deliveryId);
                    let deliveryContainer = $this.closest('.cart-delivery-container')
                    deliveryContainer.setDisableAll(true);
                    $this.find('i').removeClass('fa-times-circle text-danger').addClass('fa-spinner fa-spin text-info');
                    req.send().then(x => {
                        deliveryContainer.slideUp();
                        setTimeout(function(){
                            deliveryContainer.setDisableAll(false);
                            try{ $this.find('i').addClass('fa-times-circle text-danger').removeClass('fa-spinner fa-spin text-info'); }catch{};
                        }, 350);
                        if (mptapi.router.page === "shop") {
                            if (Page.isPage('shop', '#products') || Page.isPage('shop', '#packages') || Page.isPage('shop', '#subscription') || Page.isPage('shop', '#product')) {
                                if ((mptapi.router.data.deliveryId || "") === deliveryId) {
                                    if(mptapi.companyInfo.uiSettings.serverSideShopPage)
                                    {
                                        router.redirect('/store');
                                    }
                                    else if (mptapi.companyInfo.hasPackages) { //package must be selected first
                                        router.changeHash('#packages');
                                    }
                                    else if (getSafeAPIValue('companyInfo.uiSettings.autoAddDelivery')) { //automatically add first available delivery date
                                        let req = new AddNextAvailableDelivery();
                                        req.send().then(() => {
                                            console.warn('auto add result:');
                                            console.warn(req.response);
                                            mptapi.router.changeHash("#products", { newDeliveryIds: req.response.deliveryIds });
                                        });
                                    }else {
                                        mptapi.router.changeHash("#deliveries");
                                    }
                                    cart.getCart(false, null);
                                }
                                else cart.getCart(false, x);
                            }
                            if (mptapi.router.action === "#deliveries") {
                                cart.getCart(false, null);
                                mptapi.router.render();
                            }
                        } else if (mptapi.router.page === "order") {
                            window.location.reload();
                        } else if (Page.isPage('checkout', "#review")) {
                            cart.getCart(false, null);
                            jMPT('[data-delivery-id=' + deliveryId + ']').slideUp();
                            mptapi.router.render();
                        }
                    });
                },
                mouseenter() {
                    jMPT(this).find("i").switchToggleClass("fal", "fas");
                },
                mouseleave() {
                    jMPT(this).find("i").switchToggleClass("fal", "fas");
                }
            });
            jMPT('.cart-qty-up').on({
                click() {
                    let recordId = jMPT(this).attr("data-recordid");
                    let target = jMPT('#cartQty' + recordId);
                    jMPT('.cart-qty-down').attr("disabled", true);

                    if (target.length > 0) {
                        target.text(parseInt(target.text().trim()) + 1);
                        clearTimeout(cart.qtyuptimeout);
                        cart.qtyuptimeout = setTimeout(function () {
                            jMPT('.cart-qty-down').attr("disabled", false);
                            let req = new UpdateProductInDelivery(recordId, {qty: target.text()});
                            req.send().then((res) => {
                                jMPT('.mpt-cart-icon').addTimedClass("shake");
                                jMPT.createNotification("Success!", req.template, "info");
                                cart.getCart(false, res);
                                Custombox.modal.closeAll();

                                if (Page.isPage('shop', '#products') || Page.isPage('shop', '#product')  || Page.isPage('shop', '#subscription')) {
                                    let currentRecurrence = jMPT('#recurrenceOptions').val();
                                    jMPT('.quantity[data-records*=' + recordId + ']').each(function (i, e) {
                                        let records = IsJsonString(jMPT(this).data('records')) ? JSON.parse(jMPT(this).data('records')) : jMPT(this).data('records');
                                        records[currentRecurrence].qty = parseInt(target.text().trim());
                                        jMPT(this).data('records', JSON.stringify(records));
                                        jMPT(this).find('select').val(parseInt(target.text().trim()));
                                    });
                                    jMPT('.quantity[data-recordid=' + recordId + ']').each(function (i, e) {
                                        jMPT(this).find('select').val(parseInt(target.text().trim()));
                                    });
                                    if(!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
                                        mptapi.router.render();
                                    }
                                }
                                if (Page.isPage("checkout", "#review")) {
                                    mptapi.router.render();
                                }
                            });
                        }, cart.buttonDelay);
                    }

                },
                mouseenter() {
                    jMPT(this).find("i").switchToggleClass("far", "fas");
                },
                mouseleave() {
                    jMPT(this).find("i").switchToggleClass("far", "fas");
                }
            });

            jMPT('.cart-qty-down').on({
                click() {
                    let recordId = jMPT(this).attr("data-recordid");
                    let target = jMPT('#cartQty' + recordId);

                    jMPT('.cart-qty-up').attr("disabled", true);
                    if (target.length > 0 && parseInt(target.text().trim()) > 0) {
                        target.text(parseInt(target.text().trim()) - 1);

                        clearTimeout(cart.qtydowntimeout);
                        cart.qtydowntimeout = setTimeout(function () {
                            jMPT('.cart-qty-up').attr("disabled", false);
                            let req = new UpdateProductInDelivery(recordId, {qty: target.text()});
                            req.send().then((res) => {
                                jMPT('.mpt-cart-icon').addTimedClass("shake");
                                jMPT.createNotification("Success!", req.template, "info");
                                mptapi.cartDropdown.getCart(false, res);
                                Custombox.modal.closeAll();

                                if (Page.isPage('shop', '#products') || Page.isPage('shop', '#product')  || Page.isPage('shop', '#subscription')) {
                                    let currentRecurrence = jMPT('#recurrenceOptions').val();
                                    jMPT('.quantity[data-records*=' + recordId + ']').each(function (i, e) {
                                        let records = IsJsonString(jMPT(this).data('records')) ? JSON.parse(jMPT(this).data('records')) : jMPT(this).data('records');
                                        records[currentRecurrence].qty = parseInt(target.text().trim());
                                        if (req.response.hasOwnProperty("removedRecordIds")) {
                                            records[currentRecurrence].recordId = null;
                                        }
                                        jMPT(this).data('records', JSON.stringify(records));
                                        jMPT(this).find('select').val(parseInt(target.text().trim()));
                                    });
                                    jMPT('.quantity[data-recordid=' + recordId + ']').each(function (i, e) {
                                        jMPT(this).find('select').val(parseInt(target.text().trim()));
                                    });
                                    if(!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
                                        mptapi.router.render();
                                    }

                                }
                                if (Page.isPage("checkout", "#review")) {
                                    mptapi.router.render();
                                }
                            });
                        }, cart.buttonDelay);
                    }
                },
                mouseenter() {
                    jMPT(this).find("i").switchToggleClass("far", "fas");
                },
                mouseleave() {
                    jMPT(this).find("i").switchToggleClass("far", "fas");
                }
            });

            jMPT('#saveSubscription').click(function () {
                let req = new SubscriptionCommit(mptapi.router.data.subId);
                req.send().then(() => {
                    mptapi.router.redirect("user", "#subscriptions", false);
                });
            });

            jMPT('.mpt-subscribe-all').click(function() {
                let req = new CartSubscribeAll();
                req.send().then((ct) => {
                    mptapi.cartDropdown.getCart(false, ct);
                });
            });

            // jMPT('.')

            /*jMPT('.edit-delivery-container').on({
                mouseenter() {
                    jMPT(this).css({
                        width: 110
                    })
                }
            })*/
            jMPT('.cart-qty').text(cart.getCartCount("menuItems"));

            jMPT('.switch.product-switch input').each(function (i, e) {
                e.onchange = function () {
                    let req = new UpdateProductInDelivery(jMPT(e).data('recordId'), {
                        recurrence: !e.checked ? jMPT(e).data('disabledValue') : e.value
                    });
                    req.send().then((res) => {
                        cart.getCart(false, res);
                        if (Page.isPage("checkout", "#review")) {
                            Custombox.modal.closeAll();
                            mptapi.router.render();
                        }
                        else if(Page.isPage("shop", "#products") || Page.isPage('shop', '#product'))
                        {
                            Custombox.modal.closeAll();
                            if(!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
                                mptapi.router.render();
                            }
                        }
                    });
                };
            });
            jMPT('.recurrenceDropdown').each(function (i, e) {
                e.onchange = function () {
                    let value = jMPT(e).val();
                    let req = new UpdateProductInDelivery(jMPT(e).data("recordId"), {
                        recurrence: value
                    });
                    req.send().then((res) => {
                        cart.getCart(false, res);
                        if (Page.isPage("checkout", "#review")) {
                            mptapi.router.render();
                        }
                        else if(Page.isPage("shop", "#products") || Page.isPage('shop', '#product'))
                        {
                            if(!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
                                mptapi.router.render();
                            }
                        }
                    });
                };
            });

            jMPT('.mpt-cart-close').off();
            jMPT('.mpt-cart-close').on('click', function() {
                jMPT('.mpt-cart-icon').click();
            });

            jMPT('.mpt-menu-cart').off();
            jMPT('.mpt-menu-cart').on('click', function() {
                jMPT('.mpt-cart-icon').click();
            });

            Pace.stop();
        }
    }

    position() {
        let cart = this;
        if (this.constructor !== MPTCart) {
            cart = mptapi.cartDropdown;
        }

        if (!is_safari) {
            jMPT('.shopping-cart-body').scrollTop(cart.scrollPosition);
        }

        let browserWidth = jMPT(window).width();
        cart.mobileMode = browserWidth <= cart.mobileBreakpoint;

        let topPosition = 0;

        if (cart.mobileMode) {
            jMPT('.shopping-cart').css({
                position: "fixed",
                top: topPosition,
                width: "100vw",
                height: "100vh"
            }).addClass("mobile");
        } else {
            jMPT('.shopping-cart').css({
                position: "fixed",
                top: topPosition,
                width: "420px",
                height: "100vh",
            }).removeClass("mobile");
        }

        new Await('.shopping-cart-header', function () {
            let height =  Math.floor((jMPT(window).height() - (jMPT('.shopping-cart-header')[0].getBoundingClientRect().height + jMPT('.shopping-cart-footer')[0].getBoundingClientRect().height)) * 0.9) - 70;
            if (cart.mobileMode) {
                height -= (10 / document.documentElement.clientWidth);
            }
            let scrollbarWidth = MPTCart.getScrollBarWidth();
            if (scrollbarWidth !== 0) {
                scrollbarWidth = "-" + scrollbarWidth + "px";
            }

            jMPT(cart.dropdown).find('.shopping-cart-body').css({
                height: height,
                //"margin-right": scrollbarWidth
            });
        }, 50);
    }

    toggle() {
        let cart = mptapi.cartDropdown;

        this.IconPosition = {
            mobile: {
                opened: {top: '45vh', right: () => jMPT('')},
                closed: {top: '45vh', right: ''}
            },
            desktop: {}
        };
        if (cart.visible) {
            cart.visible = false;
            jMPT('.shopping-cart').css('right', '-150vw');
            jMPT('.mpt-cart-icon').css('right', '10px').removeClass("visible");
            jMPT('html').css('overflow-y', 'auto');
            jMPT('body').removeClass('mpt-no-scroll');
        } else {
            cart.visible = true;

            jMPT('.shopping-cart').css('right', 0);
            jMPT('.mpt-cart-icon').css("right", (cart.mobileMode) ? "87vw" : "333px").addClass("visible");

            if(cart.mobileMode) {
                jMPT('html').css('overflow-y', 'hidden');
                jMPT('body').addClass('mpt-no-scroll');
            }

            setTimeout(() => {
                cart.getCart();
            }, 1000);

        }
        cart.position();
    }

    show() {
        if (!this.visible) {
            this.visible = true;
            this.getCart();

            if(this.mobileMode)
            {
                jMPT('html').css('overflow-y', 'hidden');
                jMPT('body').addClass('mpt-no-scroll');
            }

            jMPT('.shopping-cart').css('right', 0);
            jMPT('.mpt-cart-icon').css("right", (this.mobileMode) ? "87vw" : "333px").addClass("visible");
            this.position();
        }
    }

    hide() {
        if (this.visible) {
            this.visible = false;
            jMPT('.shopping-cart').css('right', '-150vw');
            jMPT('.mpt-cart-icon').css('right', '10px').removeClass("visible");
            jMPT('html').css('overflow-y', 'auto');
            jMPT('body').removeClass('mpt-no-scroll');
            this.position();
        }
    }
}

/**
 * Await Class
 * Used to wait on an element on the page to arrive then runs the callback
 */
class Await {
    constructor() {
        let element = null;
        let callback = null;
        let time = 300;

        if(arguments.length > 0) {
            element = arguments[0] || null;
            callback = arguments[1] || null;
            time = arguments[2] || 300;

            this.element = element;
            this.callback = callback;
            this.time = time;
            this.complete = false;
            this.callbackParams = Array.from(arguments).filter((a, index) => index > 2);
            let valid = true;

            //let callbackParams =  Array.from(arguments).filter((a, index) => index > 2);

            if (typeof this.callback !== "function") {
                console.error("[Await] Please provide a callback function.");
                valid = false;
            }

            if (valid) {
                this.loop = setTimeout(this.timeoutfunction(element, callback, this), time);
                //callback.apply(null, this.callbackParams)
            }
        }
    }

    restart() {
        this.loop = setTimeout(this.timeoutfunction(this.element, this.callback, this), this.time);
    }

    timeoutfunction(element, callback, self) {
        return function () {
            if (jMPT(element).length > 0) {
                self.complete = true;
                callback.apply(null, self.callbackParams);
            } else {
                self.loop = setTimeout(self.timeoutfunction(element, callback, self), self.time);
            }
        };
    }

    valueOf() {
        return this.complete;
    }

    toString() {
        if (this.complete) {
            return jMPT(this.element).html();
        } else {
            console.warn("[Await] Tried to get value of element before it has arrived.");
            return null;
        }
    }
}

class AwaitVariable extends Await {
    constructor(element, callback, time = 300) {
        super(element, callback, time);
    }

    timeoutfunction(element, callback, self) {
        return function () {
            if (element != null) {
                self.complete = true;
                callback();
            } else {
                self.loop = setTimeout(self.timeoutfunction(element, callback, self), self.time);
            }
        };
    }
}

class AwaitProperty extends Await {
    constructor(property, parent, callback, time = 100) {
        super(property, callback, time);
        this.parentObj = parent;
    }

    timeoutfunction(element, callback, self) {
        return function () {
            if (self.parentObj.hasOwnProperty(element)) {
                self.complete = true;
                callback();
            } else {
                self.loop = setTimeout(self.timeoutfunction(element, callback, self), self.time);
            }
        };
    }
}


function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

//Load the variable into Session
let additionalOptions = mptsettings || {};
let mptapi = {};


/**
 * Initialize API
 */
(function () {
    let navigationEventHandler = function () {
        try {
            if (mptapi) {
                if (mptapi.router) {
                    if (mptapi.router.clearData) {
                        mptapi.router.data = {};
                        mptapi.router.modals = [];
                        mptapi.router.redirectUrl = "";
                    }
                    if (mptapi.router.clearProps.length > 0) {
                        mptapi.router.clearProps.forEach(x => {
                            delete mptapi.router.data[x];
                        });
                        mptapi.router.clearProps.splice(0, mptapi.router.clearProps.length);
                    }

                    if (mptapi.router.data && mptapi.router.data.shopPage)
                        delete mptapi.router.data.shopPage;

                    mptapi.router.clearData = true;
                }

                if (mptapi.storeVues)
                    delete mptapi.storeVues;

                if (mptapi.orderVues)
                    delete mptapi.orderVues;

                if (mptapi.buyVues)
                    delete mptapi.buyVues;

                if(mptapi.siteMenuVue)
                    delete mptapi.siteMenuVue;

                if(mptapi.ffBottomNavVue)
                    delete mptapi.ffBottomNavVue;

                if(mptapi.ffCustomCartVue)
                    delete mptapi.ffCustomCartVue;

                if(mptapi.ffCustomAlertVue)
                    delete mptapi.ffCustomAlertVue;

                if (mptapi.navVue)
                    delete mptapi.navVue;

                if (mptapi.ffTopNavVue)
                    delete mptapi.ffTopNavVue;

                if (mptapi.topNavVue)
                    delete mptapi.topNavVue;

                if (mptapi.addNewDayVue)
                    delete mptapi.addNewDayVue;

                if (mptapi.updateCheckoutDayVue)
                    delete mptapi.updateCheckoutDayVue;

                if (mptapi.customProductVues)
                    delete mptapi.customProductVues;

                if (mptapi.ffCustomRegisterVue)
                    delete mptapi.ffCustomRegisterVue;

                if (mptapi.ffCustomUserMenuVue)
                    delete mptapi.ffCustomUserMenuVue;

                console.log("[MPT API] UNLOADING");
                localStorage.setItem("MPTSession", JSON.stringify(mptapi));
            }
        } catch (err) {
            console.error('Could not unload: ' + err);
        }
    };

    if (is_safari) {
        window.onpagehide = navigationEventHandler;
    }
    else{
        window.addEventListener("beforeunload", navigationEventHandler);
    }


    jMPT(window).on({hashchange: function () {
            if (!mptapi.router.skipChange) {
                if (mptapi.router.clearData) {
                    mptapi.router.data = {};
                    mptapi.router.modals = [];
                    mptapi.router.redirectUrl = "";
                }
                mptapi.router.render();
            }
        }
    });

    jMPT(document).ready(function () {
        try{
            _isMobile == _isMobile || jMPT(document).width() <= 600;
        }catch(err){}

        if (localStorage.hasOwnProperty("MPTSession")) {
            mptapi = MPTSession.fromJSON(localStorage.MPTSession, additionalOptions);
            mptapi.router = MPTRouter.fromJSON(mptapi.router);
            mptapi.router.render();
        } else {
            mptapi = new MPTSession(additionalOptions, false);
            mptapi.router = new MPTRouter();
            mptapi.router.render();
        }

        localStorage.MPTSession = JSON.stringify(Object.assign({}, mptapi, {orderVues: null, storeVues: null, buyVues: null, siteMenuVue: null, navVue: null, topNavVue: null, ffBottomNavVue: null, ffTopNavVue: null, customProductVues: null, ffCustomCartVue: null, ffCustomRegisterVue: null, ffCustomUserMenuVue: null})); // Save in storage
        mptapi.cartDropdown = new MPTCart();

        if (MPTSession.signedIn()) {
            jMPT('.logoutLink').show().addClass("active");
        } else {
            jMPT('.loginLink').show().addClass("active");
        }

    });

})();

//-------------------------------------------------------------
const MPTUI = {
   //#region Shop Pages
   deliveryUI() {
      this.data = {};
      jMPT('#deliveryOptions a').click(function () {
         let delOptionElem = jMPT(this);
         let curVal = delOptionElem.attr('data-active');
         if (curVal === 'true') {
            delOptionElem.removeClass('border-right-selected').attr('data-active', false);
            delOptionElem.find('.desktop-datetime-container').slideUp();
         } else {
            jMPT('#deliveryOptions a')
               .not(this)
               .removeClass('border-right-selected')
               .attr('data-active', false)
               .each(function () {
                  jMPT(this).find('.desktop-datetime-container').slideUp();
               });
            delOptionElem.addClass('border-right-selected').attr('data-active', true);
            delOptionElem.find('.desktop-datetime-container').slideDown();
            delOptionElem.find('select').change();
         }
         if (jMPT('#deliveryOptions a[data-active="true"]').length === 0) {
            jMPT('#addDeliveryOptionControl').addClass('disabled');
         } else {
            jMPT('#addDeliveryOptionControl').removeClass('disabled').resetError();
         }
      });
      jMPT('select').click(function (e) {
         e.stopPropagation();
      });

      jMPT('.editDeliveryItem').click(function () {
         let id = jMPT(this).data('deliveryid');
         delete mptapi.router.data.newDeliveryId;
         mptapi.router.changeHash('#products', { deliveryId: id });
      });
      jMPT('.removeDeliveryItem').click(function (e) {
         e.stopPropagation();
         let deliveryId = jMPT(this).attr('data-deliveryid');
         let req = new RemoveDelivery(deliveryId);
         req.send().then((x) => {
            mptapi.cartDropdown.getCart(false, x);
            mptapi.router.render();
         });
      });

      jMPT('.check-zip-code').click(function () {
         let prohibitedRules = mptapi.companyInfo.prohibitedRules.filter((x) => x.variable === 'shippingPostal');
         let input = jMPT('#zipCheck').val();

         let valid = true;
         if (input) {
            input = input.trim().replace(/[^\d]/g, '');
            jMPT('#zipCheck').val(input);
            for (let i = 0; i < prohibitedRules.length; i++) {
               let rule = prohibitedRules[i];
               if (rule.variable !== 'shippingPostal') continue;

               switch (rule.comparer) {
                  case 'not-in-list':
                     if (rule.value.substringIndexOf(input) === -1) {
                        valid = false;
                     }
                     break;
                  case 'in-list':
                     if (rule.value.substringIndexOf(input) >= 0) {
                        valid = false;
                     }
                     break;
               }
            }
         } else valid = false;

         if (!valid) {
            jMPT('#zipText').hide();
            jMPT('#invalidZipText').show();
            jMPT(this).next().show().addClass('warning').text('Continue Anyway');
            jMPT(this).hide();
         } else {
            jMPT('#checkZipModal')
               .empty()
               .removeClass('mpt-modal')
               .addClass('text-center')
               .append(
                  jMPT('<i>', {
                     class: 'fal fa-check-circle fa-4x text-success',
                     id: 'successZipCheck',
                  }),
               );
            setTimeout(function () {
               jMPT('#successZipCheck').fadeOut(1250, function () {
                  Custombox.modal.closeAll();
               });
            }, 1250);
         }
      });

      jMPT('.add-single-delivery').click(function (e) {
         e.stopPropagation();
         jMPT(this).attr('disabled', true);
         let useMobile = false;

         let id = jMPT(this).data('id');
         let mobileDate = null;
         if (id == null) {
            //Use Mobile
            useMobile = true;
            let mobileSelection = jMPT('#deliveryDayDropdown option:selected');
            id = mobileSelection.val();
            mobileDate = mobileSelection.data('date');
         }
         jMPT('#DeliveryAddStatus' + id).remove();
         jMPT(this)
            .parent()
            .append(jMPT('<i>', { class: 'fa fa-spinner fa-spin', id: 'DeliveryAddStatus' + id }));

         let req = null;
         if (useMobile) {
            let timeSlot = jMPT('.' + id + 'timeslots[data-date="' + mobileDate + '"] option:selected');
            let timeSlotId = timeSlot.val();
            let dateTime = timeSlot.data('datetime');
            req = new AddDelivery(id, timeSlotId, dateTime);
         } else {
            req = new AddDelivery(id);
         }

         req.send().then((x) => {
            /*
				IF PACKAGES SECOND
				if(!!mptapi.companyInfo.hasPackages){
					let deliveryId = x.newDeliveryIds[0];
					delete mptapi.router.data.newDeliveryIds;
					mptapi.router.changeHash("#packages", {deliveryId});
					return;
				}*/
            mptapi.router.changeHash('#products', { deliveryId: x.newDeliveryIds[0] }); //Go Directly to shop page.
            /*
				jMPT(this).attr("disabled", false);
				mptapi.cartDropdown.getCart();
				jMPT('#DeliveryAddStatus' + id).removeClass("fa-spin fa-spinner").addClass("fa-check text-success");

				if(mptapi.cart.deliveries.length !== 0){
					let t = Handlebars.compile(jMPT('#existingDeliverySectionTemplate').html());
					jMPT('#existingDeliveriesSection').html(t(MPTMiddleware.deliveriesMiddleware(mptapi.cart))).show();
					jMPT('.order-1').addClass("mpt-col-md-8");
				}else{
					jMPT('.order-1').removeClass("mpt-col-md-8");
				}

				jMPT('.editDeliveryItem').click(function () {
					let id = jMPT(this).data("deliveryid");
					delete mptapi.router.data.newDeliveryId;

					mptapi.router.changeHash("#products", {deliveryId: id});
				});
				jMPT('.mpt-cart-icon').addTimedClass("shake");
				jMPT('.removeDeliveryItem').click(function (e) {
					e.stopPropagation();
					let deliveryId = jMPT(this).attr("data-deliveryid");
					let req = new RemoveDelivery(deliveryId);
					req.send().then(x => {
						mptapi.cartDropdown.getCart();
						mptapi.router.render();
					});
				});*/
         });
      });

      jMPT('#addDeliveryOptionControl').click(MPTUI.addDelivery);
      /*if (mptapi.options.customScripts.hasOwnProperty("deliveryPageScripts")) {
			let temp = jMPT('<textarea>').html(mptapi.options.customScripts.deliveryPageScripts.stripSlashes());
			eval(temp.html().decHTML());
		}*/

      jMPT('.timeslot-selector').change(function () {
         let selectedDay = jMPT('#deliveryDayDropdown option:selected');
         let selectedTimeSlot = jMPT(
            '.' + selectedDay.val() + 'timeslots[data-date="' + selectedDay.data('date') + '"] option:selected',
         );
         jMPT('.delivery-timeslot-description').hide();

         jMPT('#SelectedDate')
            .text(selectedDay.data('dayOfWeek') + ', ' + selectedDay.data('date'))
            .parent()
            .show();
         if (selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== '0') {
            jMPT('.mobile-delivery-wrapper .add-single-delivery').attr('disabled', false);
            let timeSlotDescription = selectedTimeSlot.data('description') || null;
            if (timeSlotDescription) {
               jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function () {
                  jMPT(this).text(timeSlotDescription).show();
               });
            }
         } else {
            jMPT('.mobile-delivery-wrapper .add-single-delivery').attr('disabled', true);
         }
      });

      jMPT('.desktop-timeslot-selector').change(function () {
         let selectedDay = jMPT('.deliveryDay[data-active="true"]');
         let deliveryDayId = selectedDay.data('deliverydayid');
         let selectedTimeSlot = jMPT(
            '.desktop-timeslot-selector[data-date="' + selectedDay.data('date') + '"] option:selected',
         );

         if (selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== '0') {
            let timeSlotDescription = selectedTimeSlot.data('description') || null;
            if (timeSlotDescription) {
               jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function () {
                  jMPT(this).text(timeSlotDescription);
               });
            }
         }
      });

      jMPT('#deliveryDayDropdown').change(function () {
         let selectedDay = jMPT(this).find('option:selected');
         let selectedVal = selectedDay.val();
         let selectedDate = selectedDay.data('date');

         jMPT('.timeslot-selector')
            .not('.' + selectedVal + 'timeslots[data-date="' + selectedDate + '"]')
            .hide();
         jMPT('.' + selectedVal + 'timeslots[data-date="' + selectedDate + '"]')
            .show()
            .change();
         jMPT('#timeSlotTitle').show();
      });
   },
   changeDayUI(containerSelector) {
      this.data = {};
      jMPT(containerSelector + ' a').off();

      jMPT(containerSelector + ' a').click(function () {
         let delOptionElem = jMPT(this);
         let curVal = delOptionElem.attr('data-active');
         if (curVal === 'true') {
            delOptionElem.removeClass('border-right-selected').attr('data-active', false);
            delOptionElem.children().eq(1).slideUp();
         } else {
            jMPT(containerSelector + ' a')
               .not(this)
               .removeClass('border-right-selected')
               .attr('data-active', false)
               .each(function () {
                  jMPT(this).children().eq(1).slideUp();
               });
            delOptionElem.addClass('border-right-selected').attr('data-active', true);
            delOptionElem.children().eq(1).slideDown();
            delOptionElem.find('select').change();
         }
         if (jMPT(containerSelector + ' a[data-active="true"]').length === 0) {
            jMPT('#addDeliveryOptionControl').addClass('disabled');
         } else {
            jMPT('#addDeliveryOptionControl').removeClass('disabled').resetError();
         }
      });

      jMPT(containerSelector + ' select').click(function (e) {
         e.stopPropagation();
      });

      jMPT('.editDeliveryItem').click(function () {
         let id = jMPT(this).data('deliveryid');
         delete mptapi.router.data.newDeliveryId;
         mptapi.router.changeHash('#products', { deliveryId: id });
      });
      jMPT('.removeDeliveryItem').click(function (e) {
         e.stopPropagation();
         let deliveryId = jMPT(this).attr('data-deliveryid');
         let req = new RemoveDelivery(deliveryId);
         req.send().then((x) => {
            mptapi.cartDropdown.getCart(false, x);
            mptapi.router.render();
         });
      });

      /*
        CHECK IF NEEDED
        jMPT('.check-zip-code').click(function () {
            let prohibitedRules = mptapi.companyInfo.prohibitedRules.filter(x => x.variable === "shippingPostal");
            let input = jMPT('#zipCheck').val();

            let valid = true;
            if(input) {
                input = input.trim().replace(/[^\d]/g, "");
                jMPT('#zipCheck').val(input);
                for (let i = 0; i < prohibitedRules.length; i++) {
                    let rule = prohibitedRules[i];
                    if (rule.variable !== "shippingPostal") continue;

                    switch (rule.comparer) {
                        case "not-in-list":
                            if (rule.value.substringIndexOf(input) === -1) {
                                valid = false;
                            }
                            break;
                        case "in-list":
                            if (rule.value.substringIndexOf(input) >= 0) {
                                valid = false;
                            }
                            break;
                    }
                }
            }
            else valid = false;

            if (!valid) {
                jMPT('#zipText').hide();
                jMPT('#invalidZipText').show();
                jMPT(this).next().show().addClass("warning").text("Continue Anyway");
                jMPT(this).hide();
            } else {
                jMPT('#checkZipModal').empty().removeClass("mpt-modal").addClass("text-center").append(jMPT("<i>", {
                    class: "fal fa-check-circle fa-4x text-success",
                    id: "successZipCheck"
                }));
                setTimeout(function () {
                    jMPT('#successZipCheck').fadeOut(1250, function () {
                        Custombox.modal.closeAll();
                    });
                }, 1250);
            }
        });*/

      jMPT(containerSelector + ' .add-single-delivery').click(function (e) {
         e.stopPropagation();
         let thisBtn = jMPT(this);
         thisBtn.attr('disabled', true);

         let dayId = thisBtn.data('id');
         jMPT('#DeliveryAddStatus' + dayId).remove();
         thisBtn.parent().append(jMPT('<i>', { class: 'fa fa-spinner fa-spin', id: 'DeliveryAddStatus' + dayId }));

         //<-----------YOU ARE HERE
         let req = new ChangeDeliveryDate(null, null, null, null, containerSelector);
         req.send().then((x) => {
            let delId = mptapi.router.data.deliveryId || mptapi.router.data.newDeliveryId || null;
            if (delId) {
               if (mptapi.cartDropdown && mptapi.cartDropdown.visible) mptapi.cartDropdown.toggle();

               mptapi.router.updateRoute();
               Custombox.modal.closeAll();

               if (
                  mptapi.companyInfo &&
                  mptapi.companyInfo.uiSettings &&
                  mptapi.companyInfo.uiSettings.serverSideShopPage
               ) {
                  mptapi.router.redirect('/store');
               } else {
                  if (mptapi.router.page !== mptapi.options.slugs.shop) {
                     if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                        mptapi.router.redirect(mptapi.options.slugs.shop, '#subscription', { deliveryId: delId });
                     } else {
                        mptapi.router.redirect(mptapi.options.slugs.shop, '#products', { deliveryId: delId });
                     }
                  } else {
                     if (Page.isPage('shop', '#subscription') && mptapi.router.data.subId) {
                        mptapi.router.changeHash('#subscription', { deliveryId: delId }, true);
                     } else {
                        mptapi.router.changeHash('#products', { deliveryId: delId }, true);
                     }
                  }
               }
            }
         });
      });

      jMPT(containerSelector + ' .timeslot-selector').change(function () {
         let selectedDay = jMPT('#deliveryDayDropdown option:selected');
         let selectedTimeSlot = jMPT(
            '.' + selectedDay.val() + 'timeslots[data-date="' + selectedDay.data('date') + '"] option:selected',
         );

         jMPT('#SelectedDate')
            .text(selectedDay.data('dayOfWeek') + ', ' + selectedDay.data('date'))
            .parent()
            .show();
         if (selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== '0') {
            jMPT('.mobile-delivery-wrapper .add-single-delivery').attr('disabled', false);
            let timeSlotDescription = selectedTimeSlot.data('description') || null;
            if (timeSlotDescription) {
               jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function () {
                  jMPT(this).text(timeSlotDescription);
               });
            }
         } else {
            jMPT('.mobile-delivery-wrapper .add-single-delivery').attr('disabled', true);
         }
      });

      jMPT('.desktop-timeslot-selector').change(function () {
         let selectedDay = jMPT('.deliveryDay[data-active="true"]');
         let deliveryDayId = selectedDay.data('deliverydayid');
         let selectedTimeSlot = jMPT(
            '.desktop-timeslot-selector[data-date="' + selectedDay.data('date') + '"] option:selected',
         );

         if (selectedTimeSlot.length > 0 && selectedTimeSlot.val() !== '0') {
            let timeSlotDescription = selectedTimeSlot.data('description') || null;
            if (timeSlotDescription) {
               jMPT('.delivery-timeslot-description[data-date="' + selectedDay.data('date') + '"]').each(function () {
                  jMPT(this).text(timeSlotDescription);
               });
            }
         }
      });

      jMPT('#deliveryDayDropdown').change(function () {
         let selectedDay = jMPT(this).find('option:selected');
         let selectedVal = selectedDay.val();
         let selectedDate = selectedDay.data('date');

         jMPT('.timeslot-selector')
            .not('.' + selectedVal + 'timeslots[data-date="' + selectedDate + '"]')
            .hide();
         jMPT('.' + selectedVal + 'timeslots[data-date="' + selectedDate + '"]')
            .show()
            .change();
         jMPT('#timeSlotTitle').show();
      });
   },

   addDelivery() {
      if (!jMPT(this).hasClass('disabled')) {
         let req = new AddDelivery();
         req.send().then((x) => {
            jMPT.createNotification('Success!', req.template);
            if (!!x.companyInfo.hasPackages) {
               mptapi.router.changeHash('#packages', Object.assign(req.payload, req.response));
            } else {
               mptapi.router.changeHash('#products', Object.assign(req.payload, req.response));
            }
            mptapi.cartDropdown.getCart(false, x);
         });
      } else {
         jMPT(this).generateError('selectError', true);
      }
   },

   shopPagePartials() {
      Handlebars.registerPartial('productSelections', jMPT('#productSelectionsTemplate').html());
      Handlebars.registerPartial('mobileFilters', jMPT('#mobileShopFiltersTemplate').html());
      Handlebars.registerHelper('mobileFilterContext', function (context) {
         if (typeof context !== 'undefined' && context && Object.keys(context).length > 0) {
            context.nestedFilters = false;

            for (let filter in context) {
               //get all filter groups
               if (context.hasOwnProperty(filter)) {
                  // make sure property isn't inherited
                  if (context[filter] != null) {
                     if (Array.isArray(context[filter])) {
                     } else {
                     }
                  }
               }
            }
         } else return false;
      });
   },

   reinitShopModals(x) {
      jMPT('.recurrenceOption').off('click');
      jMPT('.addMenuItemVariations').off('click');
      jMPT('.add-product-no-vars').off('click');
      jMPT('[class$=quantity]').off('change');
      jMPT('[id$=modalQuantity]').off('change');
      jMPT('.quantityDown').off('click');
      jMPT('.quantityUp').off('click');
      jMPT('.quantityUpModal').off('click');
      jMPT('.quantityDownModal').off('click');
      jMPT('#recurrenceOptions').off('change');
      jMPT('.mpt-modal .quantity-section').empty();
      MPTUI.shopPage();
   },

   packages() {
      jMPT('.choose-package').click(function () {
         let packageId = jMPT(this).data('packageId');

         if (
            mptapi.companyInfo &&
            mptapi.companyInfo.uiSettings &&
            mptapi.companyInfo.uiSettings.resetCartOnNewPackageSelection
         ) {
            if (mptapi.cart && mptapi.cart.deliveries && mptapi.cart.deliveries.length > 0) {
               let emptyCartReq = new EmptyCart();
               emptyCartReq.send().then(() => {
                  mptapi.router.changeHash('#deliveries', { packageId });
               });
            } else mptapi.router.changeHash('#deliveries', { packageId });
         } else mptapi.router.changeHash('#deliveries', { packageId });
      });

      jMPT('.mpt-continue-package').click(function () {
         let deliveryId = jMPT(this).data('deliveryid');

         if (mptapi.companyInfo && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
            mptapi.router.redirect('/store');
         } else {
            mptapi.router.changeHash('#products', { deliveryId }, true);
         }
      });
   },

   shopPage(response, queries) {
      if (window.markdownit) {
         let mdconverter = window.markdownit();
         mdconverter.disable(['code']);
         jMPT('.product-description').each(function () {
            let productId = jMPT(this).data('productid');
            let text = jMPT('.product-description-source[data-productid="' + productId + '"]').text();

            jMPT(this).html(mdconverter.render(text));
         });

         jMPT('.full-page-product-description').each(function () {
            let productId = jMPT(this).data('productid');
            let text = jMPT('.full-page-product-description-source[data-productid="' + productId + '"]').text();

            jMPT(this).html(mdconverter.render(text));
         });
      }

      try {
         jMPT('.mpt-product-image-container:not(.slick-initialized)').each(function () {
            let $this = jMPT(this);
            if ($this.find('.mpt-product-image').length > 1) {
               let productId = $this.data('productid');
               jQuery('.mpt-product-image-container[data-productid="' + productId + '"]').slick({
                  centerMode: true,
                  centerPadding: '-3px',
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: false,
                  arrows: true,
                  responsive: [
                     {
                        breakpoint: 375,
                        settings: {
                           arrows: true,
                           centerMode: true,
                           centerPadding: '-3px',
                           slidesToShow: 1,
                        },
                     },
                     {
                        breakpoint: 300,
                        settings: {
                           arrows: true,
                           centerMode: true,
                           centerPadding: '-3px',
                           slidesToShow: 1,
                        },
                     },
                  ],
               });
            }
         });

         jMPT('.mpt-fp-product-image-container:not(.slick-initialized)').each(function () {
            let $this = jMPT(this);
            if ($this.find('.mpt-fp-product-image').length > 1) {
               let productId = $this.data('productid');
               jQuery('.mpt-fp-product-image-container[data-productid="' + productId + '"]').slick({
                  centerMode: true,
                  centerPadding: '-3px',
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: false,
                  arrows: true,
                  responsive: [
                     {
                        breakpoint: 375,
                        settings: {
                           arrows: true,
                           centerMode: true,
                           centerPadding: '-3px',
                           slidesToShow: 1,
                        },
                     },
                     {
                        breakpoint: 300,
                        settings: {
                           arrows: true,
                           centerMode: true,
                           centerPadding: '-3px',
                           slidesToShow: 1,
                        },
                     },
                  ],
               });
            }
         });
      } catch (err) {
         console.error(err);
      }

      let context = response;

      let buttonDelay = 500;

      jMPT('.mpt-expand-group').click(function () {
         let elem = jMPT(this);
         expandGroups(elem);
      });

      function expandGroups(elem) {
         let moreButton = elem;
         let type = moreButton.data('type');

         jMPT('.mpt-filter-label[data-type="' + type + '"].d-none').each(function () {
            jMPT(this).removeClass('d-none').addClass('d-block');
         });

         moreButton.text('Less ^');
         moreButton.off();
         moreButton.click(function () {
            let type = jMPT(this).data('type');
            jMPT('.mpt-filter-label[data-type="' + type + '"].d-block.mpt-expandable').each(function () {
               jMPT(this).removeClass('d-block').addClass('d-none');
            });
            jMPT(this).text('More...');
            jMPT(this).off();
            jMPT(this).click(function () {
               let elem = jMPT(this);
               expandGroups(elem);
            });
         });
      }

      if (typeof context !== 'undefined' && context !== null && context.subscription) {
         jMPT('#recurrenceOptions').val(context.delivery.recurrence);
         window.addEventListener('beforeunload', handleExitSubEditor);
      }

      //let recurrenceValue = mptapi.router.data.shopPage.recurrenceOptions.find(x => x.selected).value;

      //jMPT('#recurrenceOptions').val(recurrenceValue);
      /*jMPT('.mpt-content .itemPrice').each(function () {
			if (recurrenceValue === "null") recurrenceValue = "onetime";
			let price = jMPT(this).data(recurrenceValue);
			if (parseInt(price) === -1 || Object.values(jMPT(this).data()).filter(x => parseInt(x) !== -1).length === 0) {
				jMPT(this).closest(".product").hide();
				let product = productList.find(x => x.product.id === jMPT(this).closest('.product').attr("id"));
				if(product){
					product.ignore = true;
				}
			} else {
				jMPT(this).closest(".product").show();
			}
			jMPT(this).text(price);
		});*/

      jMPT('.mpt-change-date-btn').click(function () {
         MPTUI.generateModal('#mpt-change-day-modal');

         let evaluateSingleTimeslotDays = function () {
            let timeSlotEvaluationResults = [];
            let timeSlots = jMPT('.desktop-timeslot-selector');
            for (let i = 0; i < timeSlots.length; i++) {
               let selector = jMPT(timeSlots[i]);
               let validOpts = selector.find('option:enabled').length;
               let newVal = selector.find('option:enabled').val();
               if (validOpts === 1 && newVal) {
                  timeSlotEvaluationResults.push(newVal);
                  selector.val(newVal).change();
                  selector.addClass('d-none');
                  selector.closest('.mpt-col-md-6').addClass('d-none');
               } else timeSlotEvaluationResults.push(false);
            }
         };

         let explicitSubEdit = false;

         if (enforceSubEdits())
            if (mptapi.router.data.editingSubscription) {
               explicitSubEdit = true;
               subscriptionEditMode(mptapi.user.displayName, 'explicit-deliveries');
            }

         let packageId = mptapi.router.data.packageId || null;

         //On shop title day change controls
         let dayReq = new GetDeliveryOptions(packageId, explicitSubEdit);
         dayReq.send().then(() => {
            let t = Handlebars.compile(jMPT('#dayChangeTemplate').html());
            let dayContainer = jMPT('.mpt-delivery-day-change-options');
            dayContainer.html(t(dayReq.response));
            if (
               dayReq.response.companyInfo.uiSettings &&
               dayReq.response.companyInfo.uiSettings.skipSingleTimeSlotSelection
            )
               evaluateSingleTimeslotDays();

            MPTUI.changeDayUI('.mpt-delivery-day-change-options');
            dayContainer.show();
            jMPT('.mpt-delivery-day-change-loader').hide();
         });
      });

      jMPT('.OrderNowButton').click(function () {
         Custombox.modal.closeAll();
         mptapi.router.changeHash('#deliveries');
      });

      //TODO Logic for switching to single page
      if (mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.fullProductPages) {
         jMPT('.more-options').on('click', function (e) {
            try {
               if (
                  !(
                     jMPT(e.target).parents('.quantityDown').length > 0 ||
                     jMPT(e.target).parents('.quantityUp').length > 0
                  )
               ) {
                  e.stopPropagation();
                  let id = jMPT(this).data('productid');
                  mptapi.router.changeHash('#product', { productId: id });
               }
            } catch {}
         });
      }

      //Load in quantity

      jMPT('.back-to-shopping').click(function () {
         mptapi.router.changeHash('#deliveries');
      });
      jMPT('.back-to-subscriptions').click(function () {
         mptapi.router.redirect('user', '#subscriptions');
      });

      jMPT('.save-subscription-changes').click(function () {
         let req = new SubscriptionCommit(mptapi.router.data.subId);
         req.send().then(() => {
            window.removeEventListener('beforeunload', handleExitSubEditor);
            mptapi.router.redirect('user', '#subscriptions', false);
         });
      });

      if (mptapi.router.data.hasOwnProperty('category')) {
         jMPT('#categorySelector').val(mptapi.router.data.category).change();
         delete mptapi.router.data.category;
      }

      jMPT('.addMenuItemVariations').click(function () {
         Custombox.modal.closeAll();
         let productId = jMPT(this).attr('data-productid');
         let title = jMPT(this).attr('data-name');
         let variations = jMPT('select[data-productid=' + productId + ']:not([id$=modalQuantity]):visible')
            .toArray()
            .filter((x) => {
               return jMPT(x).val() !== '-1' && jMPT(x).val() != null && jMPT(x).val() !== ['-1'];
            })
            .map((x) => {
               return {
                  id: jMPT(x).attr('id').replace('variation-', ''),
                  options: jMPT(x)
                     .children(':selected')
                     .toArray()
                     .map((y) => {
                        return jMPT(y).val();
                     }),
               };
            });
         let multiselectVariations = jMPT('.variation-multiselect[data-productid=' + productId + ']:visible')
            .toArray()
            .filter((x) => jMPT(x).find('input:checked').length > 0)
            .map((x) => ({
               id: jMPT(x).data('variationId'),
               options: jMPT(x)
                  .find('input:checked')
                  .toArray()
                  .map((y) => jMPT(y).val()),
            }));
         if (multiselectVariations.length > 0) {
            variations = variations.concat(multiselectVariations);
         }

         let qty = 1;
         let qtyInput = jMPT('.add-to-cart-qty[data-productid="' + productId + '"]:visible');
         if (qtyInput.length > 0) {
            try {
               let parsedQ = parseInt(qtyInput.val());
               if (!isNaN(parsedQ) && parsedQ > 0 && parsedQ <= 99) qty = parsedQ;
            } catch {
               qty = 1;
            }
         }

         let req = new AddProductToDelivery(productId, qty, variations, title, 1);
         req.send().then((x) => {
            jMPT('.mpt-cart-icon').addTimedClass('shake');
            mptapi.cartDropdown.getCart(false, x);
            if (!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
               let products = regenerateSelectionModal(x, productId, [
                  MPTUI.reinitShopModals,
                  mptapi.cartDropdown.getCart,
               ]);
            }

            MPTUI.reinitShopModals();
            jMPT.createAlert(
               'Success!',
               'Product added!',
               '#Modal' + productId + ' .mpt-modal-header',
               'success',
               'fa fa-plus',
               2500,
            );
            //Custombox.modal.closeAll();
         });
      });

      jMPT('.add-product-no-vars').click(function () {
         Custombox.modal.closeAll();
         let productId = jMPT(this).attr('data-productid');
         let title = jMPT(this).attr('data-name');

         let qty = 1;
         let qtyInput = jMPT('.add-to-cart-qty[data-productid="' + productId + '"]:visible');
         if (qtyInput.length > 0) {
            try {
               let parsedQ = parseInt(qtyInput.val());
               if (!isNaN(parsedQ) && parsedQ > 0 && parsedQ <= 99) qty = parsedQ;
            } catch {
               qty = 1;
            }
         }

         let req = new AddProductToDelivery(productId, qty, null, title, 1);
         req.send().then((x) => {
            mptapi.cartDropdown.getCart(false, x);
            jMPT('.mpt-cart-icon').addTimedClass('shake');
            if (!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
               let products = regenerateSelectionModal(x, productId, [
                  MPTUI.reinitShopModals,
                  mptapi.cartDropdown.getCart,
               ]);
            }

            MPTUI.reinitShopModals();
            jMPT.createAlert(
               'Success!',
               'Product added!',
               '#Modal' + productId + ' .mpt-modal-header',
               'success',
               'fa fa-plus',
               2500,
            );
            //Custombox.modal.closeAll();
         });
      });

      jMPT('.mpt-fp-product-qty-ctl.qty-up').off();
      jMPT('.mpt-fp-product-qty-ctl.qty-up').click(function () {
         let $this = jMPT(this);
         let productId = $this.data('productid');
         let quantityInput = jMPT('.mpt-fp-product-qty-input[data-productid="' + productId + '"]:visible');
         if (quantityInput.length > 0) {
            try {
               let newVal = (parseInt(quantityInput.val()) || 1) + 1;
               if (newVal > 99) newVal = 99;
               quantityInput.val(newVal).change();
            } catch {}
         }
      });

      jMPT('.mpt-fp-product-qty-ctl.qty-down').off();
      jMPT('.mpt-fp-product-qty-ctl.qty-down').click(function () {
         let $this = jMPT(this);
         let productId = $this.data('productid');
         let quantityInput = jMPT('.mpt-fp-product-qty-input[data-productid="' + productId + '"]:visible');
         if (quantityInput.length > 0) {
            try {
               let newVal = (parseInt(quantityInput.val()) || 1) - 1;
               if (newVal < 1) newVal = 1;
               quantityInput.val(newVal).change();
            } catch {}
         }
      });

      jMPT('.add-to-cart-qty').change(function () {
         let $this = jMPT(this);
         try {
            let currentVal = parseInt($this.val());
            if (currentVal > 99) $this.val(99);
            else if (currentVal < 1) $this.val(1);
         } catch {
            $this.val(1);
         }
      });

      jMPT('.quantityUpModal').click(function () {
         let target = jMPT(this).closest('.quantity-container');
         let productId = target.data('productid');
         let recordId = target.data('recordid');
         let select = target.find('select');

         jMPT('.quantityDownModal').attr('disabled', true);
         select.val(parseInt(select.val()) + 1);

         clearTimeout(addToCartModalTimeout);
         addToCartModalTimeout = setTimeout(function () {
            jMPT('.quantityUpModal').attr('disabled', true);
            let qty = select.val();
            let req = new UpdateProductInDelivery(recordId, { qty });
            req.send().then((x) => {
               jMPT('.mpt-cart-icon').addTimedClass('shake');
               jMPT('.quantityDownModal, .quantityUpModal').attr('disabled', false);
               if (!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
                  regenerateSelectionModal(x, productId);
               }
               MPTUI.reinitShopModals();
               mptapi.cartDropdown.getCart(false, x);
               jMPT.createAlert(
                  'Success!',
                  'Product Updated!',
                  '#Modal' + productId + ' .mpt-modal-header',
                  'success',
                  'fa fa-check',
                  2500,
               );
            });
         }, buttonDelay);
      });

      jMPT('.quantityDownModal').click(function () {
         let target = jMPT(this).closest('.quantity-container');
         let productId = target.data('productid');
         let recordId = target.data('recordid');
         let select = target.find('select');

         jMPT('.quantityUpModal').attr('disabled', true);
         select.val(parseInt(select.val()) - 1);

         clearTimeout(removeFromCartModalTimeout);
         removeFromCartModalTimeout = setTimeout(function () {
            jMPT('.quantityDownModal').attr('disabled', true);
            let qty = select.val();
            let req = new UpdateProductInDelivery(recordId, { qty });
            req.send().then((x) => {
               jMPT('.mpt-cart-icon').addTimedClass('shake');
               jMPT('.quantityUpModal, .quantityDownModal').attr('disabled', false);

               if (!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.preventModalRegeneration)) {
                  regenerateSelectionModal(x, productId);
               }

               MPTUI.reinitShopModals();
               if (x.hasOwnProperty('removedRecordIds')) {
                  jMPT.createAlert(
                     'Success!',
                     'Product Removed from Cart!',
                     '#Modal' + productId + ' .mpt-modal-header',
                     'danger',
                     'fa fa-times',
                     2500,
                  );
               } else {
                  jMPT.createAlert(
                     'Success!',
                     'Product Updated!',
                     '#Modal' + productId + ' .mpt-modal-header',
                     'success',
                     'fa fa-check',
                     2500,
                  );
               }
               mptapi.cartDropdown.getCart(false, x);
            });
         }, buttonDelay);
      });

      jMPT('[data-modal-type=product-modal][data-quickadd=true]').each(function () {
         let productId = jMPT(this).data('productid');
         let productItemClone = jMPT('.quantity-container[data-productid=' + (productId || 'null') + ']').clone();
         let section = jMPT(this).find('.quantity-section');

         section.append(productItemClone);
      });

      jMPT('[id$=modalQuantity]')
         .filter('select')
         .change(function () {
            let target = jMPT(this).closest('.quantity-container');
            let productid = target.data('productid');
            let recordId = target.data('recordid');

            let qty = jMPT(this).val();
            jMPT('.quantityUpModal, .quantityDownModal').attr('disabled', true);
            jMPT('[class$=quantity][data-productid=' + productid + ']')
               .not(this)
               .val(qty);
            let price = ~~jMPT('#' + productid + ' .itemPrice').data(
               jMPT('#recurrenceOptions')
                  .val()
                  .eval(function (x) {
                     return x === 'null' ? 'onetime' : x;
                  }),
            );
            let title = jMPT('#' + productid + ' .productName').text();

            let req = new UpdateProductInDelivery(recordId, { qty });
            req.send().then((x) => {
               jMPT('.quantityUpModal, .quantityDownModal').attr('disabled', false);
               jMPT.createNotification('Success!', req.template);
               regenerateSelectionModal(x, productid);
               MPTUI.reinitShopModals();
               mptapi.cartDropdown.getCart(false, x);
               if (x.hasOwnProperty('removedRecordIds')) {
                  jMPT.createAlert(
                     'Success!',
                     'Product Removed from Cart!',
                     '#Modal' + productid + ' .mpt-modal-header',
                     'danger',
                     'fa fa-times',
                     2500,
                  );
               } else {
                  jMPT.createAlert(
                     'Success!',
                     'Product Updated!',
                     '#Modal' + productid + ' .mpt-modal-header',
                     'success',
                     'fa fa-check',
                     2500,
                  );
               }
               if (Page.isPage('shop', '#product')) {
                  mptapi.router.render();
               }
            });
         });

      jMPT('[class$=quantity]')
         .filter('select')
         .change(function () {
            let productid = jMPT(this).attr('data-productid');
            let target = jMPT('.quantity-container[data-productid=' + productid + ']');
            let containers = jMPT('.quantity-container[data-productid=' + productid + ']');
            let curRecurrence = jMPT('#recurrenceOptions').val();
            let records = IsJsonString(containers.first().data('records'))
               ? JSON.parse(containers.first().data('records'))
               : containers.first().data('records'); // Get selection records for available recurrence options
            let recordId = records[curRecurrence].recordId; // Get record id if there is one.
            let price = ~~jMPT('#' + productid + ' .itemPrice').data(
               jMPT('#recurrenceOptions')
                  .val()
                  .eval(function (x) {
                     return x === 'null' ? 'onetime' : x;
                  }),
            );
            let title = jMPT('#' + productid + ' .productName').text();

            let qty = jMPT(this).val();
            records[curRecurrence].qty = qty;
            jMPT('.quantityUp, .quantityDown').attr('disabled', true);
            jMPT('[class$=quantity][data-productid=' + productid + ']')
               .not(this)
               .val(qty);

            if (recordId === null) {
               let req = new AddProductToDelivery(productid, qty, null, title, price * ~~qty);
               req.send()
                  .then((x) => {
                     jMPT('.mpt-cart-icon').addTimedClass('shake');
                     jMPT('.quantityUp, .quantityDown').attr('disabled', false);
                     jMPT.createNotification('Success!', req.template);
                     if (req.response.hasOwnProperty('newRecordIds')) {
                        records[curRecurrence].recordId = req.response.newRecordIds[0];
                        containers.first().attr('data-records', JSON.stringify(records));
                     }
                     mptapi.cartDropdown.getCart(false, x);
                  })
                  .catch((err) => {
                     console.error(err);
                     alert(err);
                  });
            } else {
               let req = new UpdateProductInDelivery(recordId, { qty });
               req.send().then((x) => {
                  jMPT('.mpt-cart-icon').addTimedClass('shake');
                  jMPT('.quantityUp, .quantityDown').attr('disabled', false);
                  if (req.response.hasOwnProperty('removedRecordIds')) {
                     records[curRecurrence].recordId = null;
                     containers.first().attr('data-records', JSON.stringify(records));
                  }
                  jMPT.createNotification('Success!', req.template);
                  mptapi.cartDropdown.getCart(false, x);
               });
            }
         })
         .each(function (i, e) {
            let currentRecurrence = jMPT('#recurrenceOptions').val();
            let container = jMPT(this).closest('.quantity-container');
            let records = IsJsonString(jMPT(container).data('records'))
               ? JSON.parse(jMPT(container).data('records'))
               : jMPT(container).data('records');

            if (records[currentRecurrence]) {
               jMPT(this).val(records[currentRecurrence].qty);
            }
         });

      jMPT('.quantityUp').click(function () {
         let target = jMPT('.' + jMPT(this).data('target')), // Select element
            productId = jMPT(this).attr('data-productid'),
            max = parseInt(jMPT(target.first().children().last()).text()),
            containers = jMPT('.quantity-container[data-productid=' + productId + ']'),
            curRecurrence = jMPT('#recurrenceOptions').val(), // Current Recurrence selected
            records = IsJsonString(containers.first().data('records'))
               ? JSON.parse(containers.first().data('records'))
               : containers.first().data('records'), // Get selection records for available recurrence options
            recordId = records[curRecurrence].recordId, // Get record id if there is one.
            price = ~~jMPT('#' + productId + ' .itemPrice').data(
               jMPT('#recurrenceOptions')
                  .val()
                  .eval(function (x) {
                     return x === 'null' ? 'onetime' : x;
                  }),
            ),
            title = jMPT('#' + productId + ' .productName').text();

         if (target.length > 0 && target.val() <= max - 1) {
            jMPT('.quantityDown, .quantityUp:not([data-productid=' + productId + '])').attr('disabled', true);
            target.val(parseInt(target.val()) + 1);
            records[curRecurrence].qty += 1;

            clearTimeout(addToCartTimeout);
            addToCartTimeout = setTimeout(function () {
               jMPT('.quantityDown, .quantityUp').attr('disabled', true);
               if (recordId === null) {
                  // No previous selections, add new
                  let req = new AddProductToDelivery(
                     productId,
                     target.first().val(),
                     null,
                     title,
                     price * ~~target.first().val(),
                  );
                  req.send()
                     .then((x) => {
                        jMPT('.mpt-cart-icon').addTimedClass('shake');
                        jMPT('.quantityDown, .quantityUp').attr('disabled', false);
                        jMPT.createNotification('Success!', req.template);
                        if (req.response.hasOwnProperty('newRecordIds')) {
                           records[curRecurrence].recordId = req.response.newRecordIds[0];
                           containers.first().attr('data-records', JSON.stringify(records));
                        }
                        mptapi.cartDropdown.getCart(false, x);
                     })
                     .catch((err) => {
                        console.error(err);
                        alert(err);
                     });
               } else {
                  // Has selections, update existing
                  let req = new UpdateProductInDelivery(recordId, { qty: target.val() });
                  req.send().then((x) => {
                     jMPT('.mpt-cart-icon').addTimedClass('shake');
                     jMPT('.quantityDown, .quantityUp').attr('disabled', false);
                     jMPT.createNotification('Success!', req.template);
                     if (req.response.hasOwnProperty('newRecordIds')) {
                        records[curRecurrence].recordId = req.response.newRecordIds[0];
                        containers.first().attr('data-records', records);
                     }
                     mptapi.cartDropdown.getCart(false, x);
                  });
               }
            }, buttonDelay);
         }
      });

      jMPT('.quantityDown').click(function () {
         let target = jMPT('.' + jMPT(this).data('target'));
         let productId = jMPT(this).attr('data-productid');
         let containers = jMPT('.quantity-container[data-productid=' + productId + ']');
         let curRecurrence = jMPT('#recurrenceOptions').val(); // Current Recurrence selected
         let records = IsJsonString(containers.first().data('records'))
            ? JSON.parse(containers.first().data('records'))
            : containers.first().data('records'); // Get selection records for available recurrence options
         let recordId = records[curRecurrence].recordId; // Get record id if there is one.

         if (target.length > 0 && target.val() > 0) {
            jMPT('.quantityUp').attr('disabled', true);
            target.val(parseInt(target.val()) - 1);
            records[curRecurrence].qty -= 1;

            clearTimeout(removeFromCartTimeout);
            removeFromCartTimeout = setTimeout(function () {
               let req = new UpdateProductInDelivery(recordId, { qty: target.val() });
               req.send().then((x) => {
                  jMPT('.mpt-cart-icon').addTimedClass('shake');
                  jMPT('.quantityUp').attr('disabled', false);

                  if (req.response.hasOwnProperty('removedRecordIds')) {
                     records[curRecurrence].recordId = null;
                     containers.first().attr('data-records', JSON.stringify(records));
                  }
                  jMPT.createNotification('Success!', req.template, 'info');
                  mptapi.cartDropdown.getCart(false, x);
               });
            }, buttonDelay);
         }
      });

      jMPT('.variation-selection')
         .change(function (e) {
            let select = jMPT(this);
            let value = select.val();
            let productId = select.data('productid');
            let variationId = null;

            let firstSubVariation = jMPT(
               '[data-parent-option=' + value + '][data-productid=' + productId + ']',
            ).first();
            if (firstSubVariation.length > 0) {
               variationId = firstSubVariation.data('parent-variation');
               if (variationId) {
                  let allSubVariations = jMPT(
                     '[data-parent-variation=' + variationId + '][data-productid=' + productId + ']',
                  );
                  allSubVariations.each(function () {
                     let thisVar = jMPT(this);
                     if (thisVar.data('parent-option') === value) thisVar.parent().parent().slideDown();
                     else thisVar.parent().parent().slideUp();
                  });
               }
            } else {
               variationId = select.data('variation-id');
               jMPT('[data-parent-variation=' + variationId + '][data-productid=' + productId + ']').each(function () {
                  jMPT(this).parent().parent().slideUp();
               });
            }
         })
         .change();

      let addToCartTimeout = null;
      let removeFromCartTimeout = null;
      let addToCartModalTimeout = null;
      let removeFromCartModalTimeout = null;

      MPTUI.globals();
      MPTUI.filters();

      if (queries != null) {
         for (let key in queries) {
            let query = queries[key];
            switch (key) {
               case 'search':
                  jMPT('#searchbox').val(query).change();
                  break;
               case 'category':
                  jMPT('#categorySelector').val(query).change();
                  break;
            }
         }
      }

      jMPT('input[name="mpt-category-radio-option"]').change(function () {
         let radioCatValue = jMPT('input[name="mpt-category-radio-option"]:checked').val() || 'all';
         jMPT('#categorySelector').val(radioCatValue).change();
      });

      function showFilterSideBar() {
         let mobileSlideOut = jMPT(window).width() < 500;
         if (mobileSlideOut) {
            jMPT('html').css('overflow-y', 'hidden');
            jMPT('body').addClass('mpt-no-scroll');
         }

         jMPT('.mpt-filter-sidebar').css('left', 0);

         if (mobileSlideOut) {
            jMPT('.mpt-filter-sidebar')
               .css({
                  position: 'fixed',
                  top: 0,
                  width: '100vw',
                  height: '100vh',
               })
               .addClass('mobile');
         } else {
            jMPT('.mpt-filter-sidebar')
               .css({
                  position: 'fixed',
                  top: 0,
                  width: '375px',
                  height: '100vh',
               })
               .removeClass('mobile');
         }
      }

      function hideFilterSideBar() {
         jMPT('.mpt-filter-sidebar').css('left', '-150vw').removeClass('visible');
         jMPT('html').css('overflow-y', 'auto');
         jMPT('body').removeClass('mpt-no-scroll');
      }

      jMPT('.mpt-filter-sidebar-expand').click(showFilterSideBar);
      jMPT('.mpt-filter-sidebar-close').click(hideFilterSideBar);

      if (mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.showDatesInShopFilters) {
         let evaluateFilterSingleTimeslotDays = function () {
            let timeSlotEvaluationResults = [];
            let timeSlots = jMPT('.desktop-timeslot-selector');
            for (let i = 0; i < timeSlots.length; i++) {
               let selector = jMPT(timeSlots[i]);
               let validOpts = selector.find('option:enabled').length;
               let newVal = selector.find('option:enabled').val();
               if (validOpts === 1 && newVal) {
                  timeSlotEvaluationResults.push(newVal);
                  selector.val(newVal).change();
                  selector.addClass('d-none');
                  selector.closest('.mpt-col-md-6').addClass('d-none');
               } else timeSlotEvaluationResults.push(false);
            }
         };

         let explicitSubEdit = false;

         if (enforceSubEdits())
            if (mptapi.router.data.editingSubscription) {
               explicitSubEdit = true;
               subscriptionEditMode(mptapi.user.displayName, 'explicit-deliveries');
            }

         let packageId = mptapi.router.data.packageId || null;

         let dayReq = new GetDeliveryOptions(packageId, explicitSubEdit);
         dayReq.send().then(() => {
            let t = Handlebars.compile(jMPT('#dayChangeTemplate').html());
            let dayContainer = jMPT('.mpt-filter-day-change-options');
            dayContainer.html(t(dayReq.response));
            if (
               dayReq.response.companyInfo.uiSettings &&
               dayReq.response.companyInfo.uiSettings.skipSingleTimeSlotSelection
            )
               evaluateFilterSingleTimeslotDays();

            MPTUI.changeDayUI('.mpt-filter-day-change-options');
            dayContainer.show();
            jMPT('.mpt-delivery-day-change-loader').hide();
         });
      }
   },
   chefsChoice(context) {
      let product = context.products[0];
      let packageId = context.packageId;
      let state = {
         variations: product.variations,
         totalSteps: product.variations.length + (context.recurrenceOptions.length > 1 ? 1 : 0) + 1,
         progress: {
            step: 1,
         },
         labelPosition() {
            let barWidth = jMPT('.progress-bar.active')
               .toArray()
               .sum((x) => jMPT(x).width());
            jMPT('.progress-label').css({
               left: barWidth - Math.floor(jMPT('.progress-label').width()) / 2,
            });
         },
         update(e) {
            if (e) {
               this.progress.step = e.to + 1;
               if (this.progress.step === this.totalSteps) {
                  jMPT('.progress-label').html("<i class='far fa-shopping-cart'></i>");
               } else {
                  jMPT('.progress-label').text('Step ' + this.progress.step);
               }
               //Add active progress bar
               jMPT('.progress-bar').removeClass('active');
               jMPT('.progress-bar')
                  .slice(0, this.progress.step)
                  .each(function (i, e) {
                     jMPT(e).addClass('active');
                  });
            }
            this.labelPosition();
         },
      };

      let label = jMPT('.progress-label');
      label.css({
         left: state.labelPosition(),
      });

      jMPT('#weChooseQtyDown').click(function () {
         let qtyEl = jMPT('#weChooseQty');
         qtyEl.val(qtyEl.val() + 1);
      });

      jMPT('#weChooseQtyDown').click(function () {
         let qtyEl = jMPT('#weChooseQty');
         qtyEl.val(qtyEl.val() - 1);
      });

      jMPT('.proceedToCheckout').click(function () {
         mptapi.router.redirect('/checkout');
      });
      jMPT('.backToShopping').click(function () {
         if (mptapi.companyInfo && mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage)
            mptapi.router.redirect('/store');
         else mptapi.router.redirect('/shop');
      });
      jMPT('.next').click(function () {
         let activeSlide = jMPT('.carousel-item.active').data('variationId');
         try {
            jQuery('#variationCarousel').popover('dispose');
         } catch (err) {
            console.error(err);
         }
         if (state.progress.step === state.totalSteps) {
            let variations = [];
            let recurrence = jMPT('.recurrence-option:checked').data('recurrence');
            let qty = jMPT('#weChooseQty').val();

            product.variations.forEach(function (e, i) {
               let variationId = e.id;
               let selectedOptions = jMPT(
                  'input[data-variation-id=' +
                     e.id +
                     ']:checked, input[data-variation-id=' +
                     e.id +
                     ']:selected, select[data-variation-id=' +
                     e.id +
                     '] option:selected',
               )
                  .toArray()
                  .map((x) => x.value);
               variations.push({
                  id: variationId,
                  options: selectedOptions,
               });
            });

            let req = new AddProductToDelivery(
               product.id,
               qty,
               variations,
               product.name,
               product.price,
               recurrence,
               packageId,
            );
            req.send().then((x) => {
               MPTUI.generateModal('#redirectModal');
               //mptapi.router.changeHash("#deliveries")
            });
            return;
         } else if (state.progress.step === state.totalSteps - 1) {
            jMPT('.next').text('Add to Cart');
            jQuery('.carousel').carousel('next');
         } else if (
            jMPT(
               'input[data-variation-id=' +
                  activeSlide +
                  ']:checked, input[data-variation-id=' +
                  activeSlide +
                  ']:selected, select[data-variation-id=' +
                  activeSlide +
                  '] option:selected',
            ).length === 0
         ) {
            try {
               jQuery('#variationCarousel')
                  .popover({
                     placement: 'bottom',
                     container: 'body',
                     content: 'Please select an option!',
                  })
                  .popover('show');
            } catch (err) {
               console.error(err);
            }
            return;
         } else {
            jQuery('.carousel').carousel('next');
         }
      });
      jMPT('.back').click(function () {
         if (state.progress.step === state.totalSteps) {
            jMPT('.next').text('Next');
         }
         jQuery('.carousel').carousel('prev');
      });
      jQuery('.carousel')
         .carousel({
            interval: false,
            wrap: false,
         })
         .on({
            'slide.bs.carousel': function (e) {
               jMPT('.next, .back').attr('disabled', true);
               state.update(e);
            },
            'slid.bs.carousel': function (e) {
               jMPT('.next, .back').attr('disabled', false);
            },
         });

      jMPT(window).resize(function () {
         if (typeof state === 'undefined') {
            jMPT(window).off('resize');
            return;
         } else {
            state.update();
         }
      });
   },

   menuPage() {
      if (window.markdownit) {
         let mdconverter = window.markdownit();
         mdconverter.disable(['code']);
         jMPT('.product-description').each(function () {
            let productId = jMPT(this).data('productid');
            let text = jMPT('.product-description-source[data-productid="' + productId + '"]').text();

            jMPT(this).html(mdconverter.render(text));
         });

         jMPT('.full-page-product-description').each(function () {
            let productId = jMPT(this).data('productid');
            let text = jMPT('.full-page-product-description-source[data-productid="' + productId + '"]').text();

            jMPT(this).html(mdconverter.render(text));
         });
      }

      /*let recurrenceValue = mptapi.router.data.shopPage.recurrenceOptions[0].value;
		jMPT('.mpt-content .itemPrice').each(function () {
			let price = jMPT(this).data(recurrenceValue);
			if (parseInt(price) === -1) {
				jMPT(this).closest(".product").hide();
			} else if (Object.values(jMPT(this).data()).filter(x => parseInt(x) !== -1).length === 0) {
				jMPT(this).closest(".product").hide();
			} else {
				jMPT(this).closest(".product").show();
			}
			jMPT(this).text(price);
		});*/

      jMPT('.OrderNowButton').click(function () {
         mptapi.router.changeHash('#deliveries');
         Custombox.modal.closeAll();
      });

      jMPT('#categorySelector').change(function () {
         let selected = jMPT(this).val();
         if (selected === 'all') {
            jMPT('.product').show();
            return;
         }
         jMPT('.product.' + selected).show();
         jMPT('.product')
            .not('.' + selected)
            .hide();
      });

      if (mptapi.router.data.hasOwnProperty('category')) {
         jMPT('#categorySelector').val(mptapi.router.data.category).change();
         delete mptapi.router.data.category;
      }

      jMPT('#recurrenceOptions').change(function () {
         let val = jMPT(this).val();
         if (val === 'null') {
            val = 'onetime';
         }

         jMPT('.mpt-content .itemPrice').each(function () {
            let price = jMPT(this).data(val);
            let newPrice = parseFloat(price);
            if (isNaN(newPrice)) {
               jMPT(this).closest('.product').hide();
            } else {
               jMPT(this).closest('.product').show();
               jMPT(this).text(newPrice.toFixed(2));
            }
         });
         console.log('Updated Pricing');
         let req = new ChangeDeliveryRecurrence(mptapi.router.data.deliveryId, val);
         req.send().then((res) => {
            mptapi.router.render();
            mptapi.cartDropdown.getCart(false, res);
         });
      });

      MPTUI.globals();
   },

   filters() {
      if (!mptapi.router.data.selectedFilters) {
         mptapi.router.data.selectedFilters = {};
      }
      let filters = mptapi.router.data.selectedFilters;

      /*if(!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage))
		{

        }*/
      if (Object.keys(filters).length > 0) {
         filterChange();
         //Load values into filters

         for (let key in filters) {
            if (filters.hasOwnProperty(key)) {
               let filter = filters[key];
               if (filter.multiple) {
                  for (let i = 0; i < filter.val.length; i++) {
                     let subFilter = filter.val[i];
                     if (subFilter.hasOwnProperty('setField')) subFilter.setField();
                  }
               } else {
                  if (filter.hasOwnProperty('setField')) filter.setField();
               }
            }
         }
      }
      try {
         window.productList = mptapi.router.data.shopPage.products.map((x) => ({
            product: x,
            visible: jMPT(x).is(':visible'),
         }));
         window.filterIds = [];
      } catch (err) {
         //direct route to product page
         try {
            window.productList = mptapi.router.data.products.map((x) => ({
               product: x,
               visible: jMPT(x).is(':visible'),
            }));
            window.filterIds = [];
         } catch (err2) {
            console.error(err2);
         }
      }
      /**
       * Category Filter
       */
      jMPT('#categorySelector').change(function () {
         let key = 'category';
         let selected = jMPT(this).val();

         if (mptapi.companyInfo.uiSettings.serverSideShopPage) {
            let filterText = jMPT('.mpt-filter-title-text[data-filtertype="' + key + '"]');
            if (filterText) {
               filterText.text('Search in ' + selected);
               let filterTitle = jMPT('.mpt-filter-title[data-filtertype="' + key + '"]');
               if (filterTitle) {
                  filterTitle.addClass('mpt-filters-applied');
               }
            }
         } else {
            let text = jMPT('#categorySelector option:selected').text();
            let ids = jMPT(this).find('option:selected').data('ids');

            if (selected === 'all') {
               delete filters.category;
               jMPT('#category-filter').remove();
            } else {
               filters.category = {
                  title: 'Category',
                  setField: () => jMPT('#categorySelector').val(selected),
                  reset: () => jMPT('#categorySelector').val('all'),
                  val: text,
                  ids: ids.split(','),
                  filter: (x) => !jMPT('#' + x.product.id).hasClass(selected),
               };
            }
            filterChange();
         }
      });

      /**
       * Group Filter
       */

      jMPT('.group').on('change', function () {
         let groups = {};

         if (mptapi.companyInfo.uiSettings.serverSideShopPage) {
            let selectedGroups = [];
            let selectedNames = [];
            jMPT('.group-section input:checked').each(function () {
               selectedGroups = selectedGroups.concat(jMPT(this).data('ids').split(','));
               selectedNames.push(jMPT(this).data('group-label'));
            }); //Get all checked group filters

            console.log(selectedGroups);
            console.log(selectedNames);

            mptapi.router.changeHash('#products', { grp: selectedGroups, grpNames: selectedNames }, true);
         } else {
            //Get all checked group filters
            jMPT('.group-section input:checked')
               .toArray()
               .forEach((x) => {
                  let ids = jMPT(x).data('ids').split(',');
                  let type = jMPT(x).data('type');
                  if (!groups.hasOwnProperty(type)) groups[type] = [];
                  //Join the list of ids from two checkboxes
                  groups[type] = groups[type].union(ids);
               });

            if (Object.values(groups).length > 0) {
               //Intersect the lists of all group types to get final list of filtered ids (AND)
               let ids = Object.values(groups).reduce((acc, val) => acc.intersect(val));
               filters.groups = {
                  multiple: true,
                  val: jMPT('.group:checked')
                     .toArray()
                     .map((x) => {
                        return (label = {
                           id: jMPT(x).data('uniqueId'),
                           setField: (x) => jMPT(x).prop('checked', true),
                           title: jMPT(x).data('type').capitalize(),
                           val: jMPT(x).closest('label').text().trim(),
                           field: jMPT(x),
                           reset: () => jMPT(x).attr('checked', false),
                        });
                     }),
                  ids,
                  filter: (x) => !ids.includes(x.product.id),
               };
            } else {
               delete filters.groups;
               jMPT('#groups-filter').remove();
            }
            jMPT('.group').each(function (i, e) {
               if (!jMPT(this).is(':checked')) {
                  jMPT('#groups-' + jMPT(this).data('unique-id') + '-filter').remove();
               }
            });
            filterChange();
         }
      });

      /**
       * Search Filter
       */
      if (mptapi.companyInfo.uiSettings.serverSideShopPage) {
         jMPT('#searchbox').on('keypress', function (e) {
            if (e.keyCode === 13) {
               //enter key pressed
               e.preventDefault();
               mptapi.router.data.pageNum = null;
               let searchVal = jMPT(this).val();
               let categoryName = jMPT('#categorySelector').val();
               let catId = null;
               console.log('category name:' + categoryName);
               if (categoryName && categoryName !== 'all') {
                  catId = jMPT('#categorySelector option:selected').data('categoryid');
                  console.log('category id:' + catId);
               } else categoryName = null;

               if (mptapi.router.data.routeData) mptapi.router.data.routeData.search = searchVal;

               if (mptapi.router.data.cat !== catId) {
                  let newUrl = window.location.search;
                  newUrl = newUrl
                     .replace(mptapi.router.data.cat, catId)
                     .replace(mptapi.router.data.catName, categoryName);
                  mptapi.router.data.qry = searchVal;
                  mptapi.router.data.catName = categoryName;
                  mptapi.router.data.cat = catId;
                  window.location.search = newUrl;
               } else {
                  mptapi.router.changeHash(
                     '#products',
                     {
                        qry: searchVal,
                        catName: categoryName,
                        cat: catId,
                     },
                     true,
                  );
               }
            }
         });
      } else {
         jMPT('#searchbox').on('keyup change', function (e) {
            let val = jMPT(this).val();
            if (jMPT(this).blank()) {
               delete filters.searchbox;
               jMPT('#searchbox-filter').remove();
            } else {
               let ids = productList
                  .filter((x) => x.product.name.toLowerCase().includes(val.toLowerCase()))
                  .map((x) => x.product.id);
               filters.searchbox = {
                  title: 'Search: ',
                  setField: () => jMPT('#searchbox').val(val),
                  reset: () => jMPT('#searchbox').val(''),
                  val: val,
                  ids,
                  filter: (x) => !x.product.name.toLowerCase().includes(val.toLowerCase()),
               };
            }
            filterChange();
         });
      }

      /**
       * Recurrence Filter
       */
      jMPT('#recurrenceOptions')
         .change(function () {
            if (jMPT(this).children().length > 0) {
               let currentRecurrence = jMPT('#recurrenceOptions').val();
               let recurrenceValue = currentRecurrence === 'null' ? 'onetime' : currentRecurrence;

               if (recurrenceValue !== 'onetime' && enforceSubEdits() && !mptapi.router.data.editingSubscription)
                  subscriptionEditMode(mptapi.user.displayName, 'inferred-shop');

               jMPT('article.product').each(function (i, e) {
                  let productId = jMPT(this).attr('id');
                  let itemPrice = jMPT('#' + productId + ' .itemPrice');
                  let newPrice = parseFloat(itemPrice.data(recurrenceValue));

                  if (!isNaN(newPrice)) itemPrice.text(newPrice.toFixed(2));
               });

               jMPT('[class$=quantity]')
                  .filter('select')
                  .each(function (i, e) {
                     let container = jMPT(this).closest('.quantity-container');
                     let productId = jMPT(this).data('productid');
                     if (container.data('records')[currentRecurrence]) {
                        jMPT(this).val(container.data('records')[currentRecurrence].qty);
                     }
                  });

               let selected = jMPT(this).val();
               let ids = jMPT(this).find('option:selected').data('ids').split(',');
               filters.recurrence = {
                  noTag: true,
                  val: selected,
                  setField: () => jMPT('#recurrenceOptions').val(selected),
                  ids,
                  filter: (x) => {
                     if (selected === '') {
                        return x.product.price == null;
                     } else if (selected === 'weekly') {
                        return x.product.weeklyPrice == null;
                     }
                  },
               };
               filterChange();
            }
         })
         .change();

      /**
       * Function to reload filters
       */
      function filterChange() {
         if (Object.keys(filters).length > 0) {
            let filterOptions = getSafeAPIValue('mptapi.router.data.filters');
            for (let key in filters) {
               let filter = filters[key];
               let clearThisFilter = false;

               if (filterOptions) {
                  if (filterOptions.length === 0) clearThisFilter = true;
                  else {
                     if (filter.title === 'Category') {
                        try {
                           clearThisFilter =
                              filterOptions.categories.filter((cat) => cat.name === filter.val).length === 0;
                        } catch {
                           clearThisFilter = true;
                        }
                     }
                  }

                  if (clearThisFilter) {
                     if (filters[key].hasOwnProperty('reset')) {
                        filters[key].reset();
                     }
                     delete filters[key];
                     let filterTitle = jMPT('.mpt-filter-title[data-filtertype="' + key + '"]');
                     if (filterTitle) filterTitle.removeClass('mpt-filters-applied');
                     let filterText = jMPT('.mpt-filter-title-text[data-filtertype="' + key + '"]');
                     if (filterText) filterText.text('Categories');
                     try {
                        jMPT('#' + key + '-filter').remove();
                     } catch {}
                     filterChange();
                  }
               }

               if (!clearThisFilter) {
                  if (!filter.noTag) {
                     // If filter has noTag key, do not create a tag
                     if (filter.multiple) {
                        // Run loop for multiple tags (ie groups)
                        for (let i = 0; i < filter.val.length; i++) {
                           let val = filter.val[i];
                           let badge = jMPT('<span>', {
                              class: 'badge badge-primary cursor-pointer ' + val.id,
                              id: key + '-' + val.id + '-filter',
                              html: val.title + ': "' + val.val + '"<span class="text-danger ml-1">x</span>',
                           }).on(
                              'click',
                              (function (val, key, filters) {
                                 return function () {
                                    if (jMPT('.group:checked').length === 0) {
                                       delete filters[key];
                                    }
                                    val.reset();
                                    jMPT(this).remove();
                                    val.field.change();
                                    filterChange();
                                 };
                              })(val, key, filters),
                           );

                           if (jMPT('#' + key + '-' + val.id + '-filter').length === 0) {
                              jMPT('#activeFilters').append(badge);
                           } else {
                              jMPT('#' + key + '-' + val.id + '-filter').replaceWith(badge);
                           }
                        }
                     } else {
                        let filterText = jMPT('.mpt-filter-title-text[data-filtertype="' + key + '"]');
                        if (filterText) {
                           filterText.text(filter.val);
                           let filterTitle = jMPT('.mpt-filter-title[data-filtertype="' + key + '"]');
                           if (filterTitle) {
                              filterTitle.addClass('mpt-filters-applied');
                           }
                        }

                        let badge = jMPT('<span>', {
                           class: 'badge badge-primary cursor-pointer',
                           id: key + '-filter',
                           html: filter.title + ': "' + filter.val + '"<span class="text-danger ml-1">x</span>',
                        }).on('click', function () {
                           if (filters[key].hasOwnProperty('reset')) {
                              filters[key].reset();
                           }
                           delete filters[key];
                           let filterTitle = jMPT('.mpt-filter-title[data-filtertype="' + key + '"]');
                           if (filterTitle) filterTitle.removeClass('mpt-filters-applied');
                           let filterText = jMPT('.mpt-filter-title-text[data-filtertype="' + key + '"]');
                           if (filterText) filterText.text('Categories');
                           jMPT(this).remove();
                           filterChange();
                        });

                        if (jMPT('#' + key + '-filter').length === 0) {
                           jMPT('#activeFilters').append(badge);
                        } else {
                           jMPT('#' + key + '-filter').replaceWith(badge);
                        }
                     }
                  }
               }
            }

            let filterItems = jMPT('.filter-item').toArray().sort();
            let filteredIds = intersectAll(Object.values(filters).map((x) => x.ids));

            if (!mptapi.companyInfo.uiSettings.serverSideShopPage) {
               for (let i = 0; i < filterItems.length; i++) {
                  let item = jMPT(filterItems[i]);
                  //Check if the filter item should be disabled
                  if (
                     item
                        .data('ids')
                        .split(',')
                        .some((x) => filteredIds.indexOf(x) >= 0) ||
                     item.data('type') === 'recurrenceOption' ||
                     item.data('type') === 'category'
                  ) {
                     item.attr('disabled', false);
                     item.css('opacity', 1);
                  } else {
                     //Skip disabling group filter if filter in same group is checked
                     if (item.hasClass('group')) {
                        let type = item.data('type');
                        if (jMPT('.group[data-type=' + type + ']:checked').length > 0) {
                           continue;
                        }
                     }
                     item.css('opacity', 0.5).attr('disabled', true); //Disable filters without selections
                  }
               }
            }

            jMPT('.product').hide();
            jMPT('#' + filteredIds.join(', #')).css('display', 'flex'); // Show only the ones that are filtered
            jMPT('#product-count').text(filteredIds.length);
            paginateProducts(filteredIds);
         } else {
            resetPagination();
            jMPT('.product').show(); // Show all products
         }
      }

      function resetPagination() {
         jMPT('.product').appendTo('#products-wrapper');
         jMPT('#product-pages').empty();
         jMPT('#pagination-selector').empty();
      }

      function paginateProducts(productIds) {
         let $sel = jMPT('#paginate-selector');
         let pageSize = 50;

         if (!(mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.alwaysShowAllProducts)) {
            pageSize = productIds.length;
            jMPT('.paginate-selector-container').hide();
         } else {
            pageSize = parseInt($sel.val());
         }

         if (mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
            //1. get length from summary
            let count = 0;
            pageSize = 50;

            if (mptapi.router.data.productCount) count = mptapi.router.data.productCount;
            else count = productIds.length;

            //2. calculate number of pages
            let pageCount = Math.ceil(count / pageSize);

            $sel.hide(); //TODO: resolve page size selection for server side shop pages
            let filterString = 'Showing page ' + ((mptapi.router.data.pageNum || 0) + 1) + ' of ' + pageCount;
            $sel.closest('label').text(filterString);

            /*create partitioned array for product pages*/
            let array = [];
            array.push(productIds);
            for (let i = 0; i < pageCount - 1; i++) array.push(['']);

            /*generate page controls*/
            jMPT('#page-controls').html(MPTUI.regeneratePageControls(array, 'product-page'));
            MPTUI.paginate();
         } else {
            //client-side pagination

            let count = productIds.length;

            // Reset pagination
            resetPagination();

            let array = paginateArray(productIds, pageSize);
            for (let i = 0; i < array.length; i++) {
               let page = array[i];
               let pageClass = i == 0 ? 'paginate mpt-row mpt-col-12 active' : 'paginate mpt-col-12 mpt-row';
               jMPT('#product-pages').append(jMPT('<div>', { id: 'product-page-' + i, class: pageClass }));
               let pageDiv = jMPT('#product-page-' + i);
               for (let p = 0; p < page.length; p++) {
                  let productId = page[p];
                  let prod = jMPT('#' + productId);
                  prod.appendTo(pageDiv);
               }
            }

            jMPT('#page-controls').html(MPTUI.regeneratePageControls(array, 'product-page'));
            MPTUI.paginate();
         }
      }

      jMPT('#paginate-selector').change(function () {
         filterChange();
         /*let $this = $(this);
			let count = parseInt($this.data("count"));
			let pageSize = parseInt($this.val());
			if(mptapi.router.data.shopPage == null){
				return;
			}
			if(count > pageSize){
				let paginatedArray = paginateArray(mptapi.router.data.shopPage.products, pageSize);
				$('#product-wrapper');

				for(let i = 0; i < paginatedArray.length; i++){
					let page = paginatedArray[i];
					for(let p = 0; p < page.length; p++){
						let product = page[p];

					}
				}
				regeneratePageControls(pageSize);
			}else{

			}*/
      });
   },
   pos() {
      jMPT('#categorySelector').change(function () {
         let selected = jMPT(this).val();
         let text = jMPT('#categorySelector option:selected').text();

         if (selected === 'all') {
            delete filters.category;
            jMPT('#category-filter').remove();
         } else {
            filters.category = {
               title: 'Category: ',
               reset: () => jMPT('#categorySelector').val('all'),
               val: text,
               filter: (x) => !jMPT('#' + x.product.id).hasClass(selected),
            };
         }
         filterChange();
      });

      if (mptapi.router.data.hasOwnProperty('category')) {
         jMPT('#categorySelector').val(mptapi.router.data.category).change();
         delete mptapi.router.data.category;
      }

      let adminToken = mptapi.router.data.adminToken;
      //Load Users

      let userReq = new GetUserList(adminToken);
      userReq.send().then((x) => {
         let res = userReq.response;
         for (let i = 0; i < res.activeUsers.length; i++) {
            let user = res.activeUsers[i];
            jMPT('#pos-users').append(
               jMPT('<option>', {
                  value: user.Id,
                  text: user.Name,
               }),
            );
         }
         jMPT('#pos-users')
            .change(function () {
               let selection = jMPT('#pos-users option:selected');
               getUserProfiles(adminToken, selection.val());
            })
            .change();
      });

      function getUserProfiles(adminToken, userId) {
         let getShipping = new GetUserShippingProfiles(adminToken, userId).send();
         let getBilling = new GetUserBillingProfiles(adminToken, userId).send();
         getShipping.then((x) => {
            let template = Handlebars.compile(jMPT('#POSShippingProfileListTemplate').html().decHTML());
            jMPT('#shippingProfileSection').empty().html(template(x));
            try {
               jQuery('[data-toggle="popover"]').popover();
            } catch (err) {
               console.error(err);
            }
            jMPT('.popover').remove();
         });
         getBilling.then((x) => {
            let template = Handlebars.compile(jMPT('#POSBillingProfileListTemplate').html().decHTML());
            console.log('Billing Profiles', x);
            jMPT('#billingProfileSection').empty().html(template(x));
            try {
               jQuery('[data-toggle="popover"]').popover();
            } catch (err) {
               console.error(err);
            }
            jMPT('.popover').remove();
         });
      }

      MPTUI.filters();
      MPTUI.globals();
   },
   changeDateInCheckout(elem) {
      const deliveryId = jMPT(elem).data('checkoutDeliveryId');
      mptapi.orderVues.mptCheckoutPreOrderDays.vueApp.loadDays(deliveryId);
      setTimeout(function () {
         MPTUI.generateModal("#mpt-checkout-change-day-modal");
      }, 250);
   },
   addNewShop(additionalDelivery) {
      Custombox.modal.closeAll();
      mptapi.cartDropdown.hide();
      mptapi.router.data.additionalDelivery = additionalDelivery;
      if (getSafeAPIValue('mptapi.companyInfo.uiSettings.v3')) {
         //TODO: add package integration
         if (getSafeAPIValue('mptapi.cart.deliveries.length')) {
            if (mptapi.addNewDayVue) {
               mptapi.addNewDayVue.vueApp.initAddPreOrderDay();
            } else mptapi.router.redirect('order');
         } else mptapi.router.redirect('order');
      } else {
         if (mptapi.companyInfo.hasPackages) {
            mptapi.router.redirect('shop', '#packages');
         } else {
            mptapi.router.redirect('shop', '#deliveries');
         }
      }
   },
   //#endregion

   //#region User Pages
   /* 2a. Login Page */
   login() {
      jMPT('#Password, #Email').on('keyup', function (e) {
         if (e.which === 13 || e.key === 'Enter') {
            e.preventDefault();
            jMPT('#loginButton').click();
            return false;
         }
      });
      jMPT('#loginButton').click(function () {
         let userName = jMPT('#Email').val();
         let pass = jMPT('#Password').val();
         let req = new Login(userName, pass);
         req.send()
            .then((x) => {
               if (x.hasOwnProperty('authToken')) {
                  mptapi.savedLocation = false;
                  if (!mptapi.router.redirectUrl) {
                     jMPT('.loginLink').hide();
                     jMPT('.logoutLink').show();
                     mptapi.router.changeHash('#account');
                  } else {
                     mptapi.router.redirect();
                  }
               }
               console.log(x);
            })
            .catch((err) => {
               console.warn(err);
            });
      });
      jMPT('#switchToRegister').click(function () {
         let email = jMPT('#Email').val();
         let pass = jMPT('#Password').val();

         jMPT('#switchToRegister').off('click');
         jMPT('#loginButton').off('click');

         mptapi.router.changeHash(
            '#register',
            {
               '#RegisterEmail': email,
               '#RegisterPassword': pass,
            },
            false,
            true,
         );
      });

      jMPT('#continueAsGuest').click(function () {
         let req = new RegisterGuest({});
         req.send()
            .then((x) => {
               if (x.hasOwnProperty('authToken')) {
                  mptapi.router.redirect('/checkout');
               }
               console.log(x);
            })
            .catch((err) => {
               console.error(err);
            });
      });
   },

   /* 2b. Register Page */
   register() {
      jMPT('#registerButton').click(function () {
         let $e = this;
         jMPT($e).prop('disabled', true);
         let userName = jMPT('#RegisterEmail').val();
         let pass = jMPT('#RegisterPassword').val();
         jMPT
            .validateFields({
               '#FirstName': {
                  blank: {
                     required: false,
                     message: 'Please enter a first name.',
                  },
               },
               '#LastName': {
                  blank: {
                     required: false,
                     message: 'Please enter a last name.',
                  },
               },
            })
            .then(() => {
               if (confirmPassword()) {
                  let req = new Register(userName, pass, {
                     firstName: jMPT('#FirstName').val(),
                     lastName: jMPT('#LastName').val(),
                  });

                  req.send()
                     .then((x) => {
                        console.log('Registering ', x);
                        jMPT('#activation-alert').show();
                     })
                     .catch(() => {
                        jMPT($e).prop('disabled', false);
                        //jMPT($e).prop("disabled", true);
                     });
               } else jMPT($e).prop('disabled', false);
            })
            .catch(() => {
               jMPT($e).prop('disabled', false);
               //jMPT($e).prop("disabled", true);
            });
      });

      var passwordReqs = jMPT('.password-reqs');

      jMPT('#RegisterPassword').on({
         focus: function () {
            validatePassword();

            if (!(isMobile() || typeof jQuery('#RegisterPassword').popover !== 'function')) {
               passwordReqs.css('display', 'none');
            } else {
               try {
                  jQuery(this).popover('destroy');
               } catch (err) {
                  console.error(err);
               }
               passwordReqs.css('display', 'block');
            }
         },
         keyup: validatePassword,
      });
      try {
         jQuery('#RegisterPassword').popover({
            html: true,
            trigger: 'focus',
            placement: 'right',
            title: 'Password Requirements',
            container: 'body',
            content: function () {
               return passwordReqs.html();
            },
         });
      } catch (err) {
         console.error(err);
      }

      jMPT('#Password_confirm').keydown(function (e) {
         if (e.which === 13 || e.key === 'Enter') {
            e.preventDefault();
            jMPT('#registerButton').click();
            return false;
         }
      });

      jMPT('#Password_confirm').change(confirmPassword);

      let numeric = new RegExp(/^(?=.*\d).+$/);
      let lower = new RegExp(/^(?=.*[a-z]).+$/);
      let upper = new RegExp(/^(?=.*[A-Z]).+$/);
      let length = new RegExp(/^.{6,}$/);

      function validatePassword() {
         let valid = true;
         let field = jMPT('#RegisterPassword').val();
         if (!lower.test(field)) {
            jMPT('.lower-req').removeClass('text-success').addClass('text-danger');
            jMPT('.lower-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.lower-req').removeClass('text-danger').addClass('text-success');
            jMPT('.lower-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Uppercase
         if (!upper.test(field)) {
            jMPT('.upper-req').removeClass('text-success').addClass('text-danger');
            jMPT('.upper-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.upper-req').removeClass('text-danger').addClass('text-success');
            jMPT('.upper-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Numeric
         if (!numeric.test(field)) {
            jMPT('.num-req').removeClass('text-success').addClass('text-danger');
            jMPT('.num-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.num-req').removeClass('text-danger').addClass('text-success');
            jMPT('.num-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Length
         if (!length.test(field)) {
            jMPT('.length-req').removeClass('text-success').addClass('text-danger');
            jMPT('.length-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.length-req').removeClass('text-danger').addClass('text-success');
            jMPT('.length-req i').removeClass('fa-times').addClass('fa-check');
         }
         if (!isMobile()) {
            try {
               jQuery('#RegisterPassword').popover({
                  html: true,
                  trigger: 'focus',
                  placement: 'right',
                  title: 'Password Requirements',
                  container: 'body',
                  content: function () {
                     return passwordReqs.html();
                  },
               });
            } catch (err) {
               console.error(err);
            }
            jQuery('.popover').addClass('show bs-popover-right');
         }

         if (isMobile() || typeof jQuery('#RegisterPassword').popover !== 'function') {
            if (valid) jMPT('.password-reqs').slideUp();
            else jMPT('.password-reqs').slideDown();
         }

         return valid;
      }

      function confirmPassword() {
         let password = jMPT('#RegisterPassword').val();
         let passconfirm = jMPT('#Password_confirm').val();
         let confirmed = password == passconfirm;
         if (!confirmed) jMPT('.confirm-message').slideDown();
         else jMPT('.confirm-message').slideUp();
         return confirmed;
      }

      function isMobile() {
         let isMobile = false;
         if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
               navigator.userAgent,
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([-\s_agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([\s-\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([\s\/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([-\sov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([\-\s])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
               navigator.userAgent.substr(0, 4),
            ) ||
            jMPT(window).width() <= 600
         ) {
            isMobile = true;
         }
         return isMobile;
      }

      jMPT('#continueAsGuest').click(function () {
         let req = new RegisterGuest({});
         req.send()
            .then((x) => {
               if (x.hasOwnProperty('authToken')) {
                  mptapi.router.redirect('/checkout');
               }
               console.log(x);
            })
            .catch((err) => {
               console.error(err);
            });
      });
   },
   apply() {
      let finApp = {
         applicantFirst: null,
         applicantLast: null,
      };

      if (mptapi.authToken != null) {
         //if the user is logged in, get available information to pre-populate form
         let req = new GetFinanceApplications();
         req.send().then((res) => {
            if (!res.hasOwnProperty('error')) {
               let utcNow = Date.now();
               let existingApproval = res.financeApps.filter(
                  (x) => x.status === 'approved' && x.expirationDate !== null && Date.parse(x.expirationDate) > utcNow,
               )[0];

               if (typeof existingApproval === 'undefined' || existingApproval === null) {
                  // no approval found, route to update
                  finApp = res.financeApps.filter((x) => x.status === 'init' || x.status === 'not-submitted')[0]; //check for init finance apps
                  mptapi.router.changeHash('#update', { financeApp: finApp });
               } else {
                  //approval found, route to approval
                  mptapi.router.changeHash('#approval', { financeApp: existingApproval });
               }
            }
         });
      } else {
         let applicationTemplate = jMPT('#applicationTemplate').html();
         let t = Handlebars.compile(applicationTemplate);
         jMPT('#applicationContainer').html(t(finApp));
      }

      jMPT('#applyButton').click(function () {
         jMPT('#applyButton').attr('disabled', true);
         let userName = jMPT('#RegisterEmail').val();
         let pass = jMPT('#RegisterPassword').val();
         let firstName = jMPT('#FirstName').val();
         let lastName = jMPT('#LastName').val();
         let monthlyIncome = jMPT('#monthlyIncome')
            .val()
            .replace(/[^0-9.]/g, '');
         let employer = jMPT('#employer').val();
         let birthdate = jMPT('#birthdate').val();
         let ssn = jMPT('#ssn')
            .val()
            .replace(/[^0-9]/g, '');

         let req = new RegisterAndApply(userName, pass, firstName, lastName, monthlyIncome, employer, birthdate, ssn);

         req.send()
            .then((res) => {
               if (!res.hasOwnProperty('error')) {
                  if (res.hasOwnProperty('user') && res.user.hasOwnProperty('financeApps')) {
                     mptapi.router.changeHash('#approval', { financeApp: res.user.financeApps[0] });
                  }
               } else {
                  jMPT('#applyButton').attr('disabled', false);
               }
            })
            .catch((x) => {
               jMPT('#applyButton').attr('disabled', false);
            });
      });

      var passwordReqs = jMPT('.password-reqs');

      jMPT('#RegisterPassword').on({
         focus: function () {
            validatePassword();

            if (!isMobile()) {
               passwordReqs.css('display', 'none');
            } else {
               try {
                  jQuery(this).popover('destroy');
               } catch (err) {
                  console.error(err);
               }
               passwordReqs.css('display', 'block');
            }
         },
         keyup: validatePassword,
      });
      try {
         jQuery('#RegisterPassword').popover({
            html: true,
            trigger: 'focus',
            placement: 'right',
            title: 'Password Requirements',
            container: 'body',
            content: function () {
               return passwordReqs.html();
            },
         });
      } catch (err) {
         console.error(err);
      }

      jMPT('#Password_confirm').keydown(function (e) {
         if (e.which === 13 || e.key === 'Enter') {
            e.preventDefault();
            jMPT('#registerButton').click();
            return false;
         }
      });

      let numeric = new RegExp(/^(?=.*\d).+$/);
      let lower = new RegExp(/^(?=.*[a-z]).+$/);
      let upper = new RegExp(/^(?=.*[A-Z]).+$/);
      let length = new RegExp(/^.{6,}$/);

      function validatePassword() {
         let valid = true;
         let field = jMPT('#RegisterPassword').val();
         if (!lower.test(field)) {
            jMPT('.lower-req').removeClass('text-success').addClass('text-danger');
            jMPT('.lower-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.lower-req').removeClass('text-danger').addClass('text-success');
            jMPT('.lower-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Uppercase
         if (!upper.test(field)) {
            jMPT('.upper-req').removeClass('text-success').addClass('text-danger');
            jMPT('.upper-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.upper-req').removeClass('text-danger').addClass('text-success');
            jMPT('.upper-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Numeric
         if (!numeric.test(field)) {
            jMPT('.num-req').removeClass('text-success').addClass('text-danger');
            jMPT('.num-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.num-req').removeClass('text-danger').addClass('text-success');
            jMPT('.num-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Length
         if (!length.test(field)) {
            jMPT('.length-req').removeClass('text-success').addClass('text-danger');
            jMPT('.length-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.length-req').removeClass('text-danger').addClass('text-success');
            jMPT('.length-req i').removeClass('fa-times').addClass('fa-check');
         }
         if (!isMobile()) {
            try {
               jQuery('#RegisterPassword').popover({
                  html: true,
                  trigger: 'focus',
                  placement: 'right',
                  title: 'Password Requirements',
                  container: 'body',
                  content: function () {
                     return passwordReqs.html();
                  },
               });
            } catch (err) {
               console.log(err);
            }
            jQuery('.popover').addClass('show bs-popover-right');
         }

         if (isMobile() || typeof jQuery('#RegisterPassword').popover !== 'function') {
            if (valid) jMPT('.password-reqs').slideUp();
            else jMPT('.password-reqs').slideDown();
         }

         return valid;
      }

      function confirmPassword() {
         let password = jMPT('#RegisterPassword').val();
         let passconfirm = jMPT('#Password_confirm').val();
         let confirmed = password == passconfirm;
         if (!confirmed) jMPT('.confirm-message').slideDown();
         else jMPT('.confirm-message').slideUp();
         return confirmed;
      }

      function isMobile() {
         let isMobile = false;
         if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
               navigator.userAgent,
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([-\s_agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([\s-\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([\s\/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([-\sov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([\-\s])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
               navigator.userAgent.substr(0, 4),
            ) ||
            jMPT(window).width() <= 600
         ) {
            isMobile = true;
         }
         return isMobile;
      }
   },
   updateApplication() {
      let finApp = {};

      if (mptapi.router.data.hasOwnProperty('financeApp')) {
         finApp = mptapi.router.data.financeApp;
      }

      if (typeof finApp !== 'undefined' && finApp !== null && finApp.hasOwnProperty('id') && finApp.id !== null) {
         //if valid application was sent
         renderAndBind(finApp);
      } else {
         let req = new GetFinanceApplications();
         req.send().then((res) => {
            if (!res.hasOwnProperty('error')) {
               if (typeof id === 'undefined' || id === null) {
                  finApp = res.financeApps.filter((x) => x.status === 'init' || x.status === 'not-submitted')[0];
               } else {
                  finApp = res.financeApps.filter((x) => x.id === id)[0];
               }
            }
            renderAndBind(finApp);
         });
      }

      function renderAndBind(appData) {
         let applicationTemplate = jMPT('#existingAppTemplate').html();
         let t = Handlebars.compile(applicationTemplate);
         jMPT('#applicationContainer').html(t(appData));

         jMPT('#applyButton').click(function () {
            jMPT('#applyButton').attr('disabled', true);

            let firstName = jMPT('#FirstName').val();
            let lastName = jMPT('#LastName').val();
            let monthlyIncome = jMPT('#monthlyIncome').val();
            let employer = jMPT('#employer').val();
            let birthdate = jMPT('#birthdate').val();
            let ssn = jMPT('#ssn').val();

            let appReq = new UpdateFinanceApp(appData.id, firstName, lastName, monthlyIncome, employer, birthdate, ssn);
            appReq.send().then((appRes) => {
               if (!appRes.hasOwnProperty('error')) {
                  mptapi.router.changeHash('#approval', {
                     financeApp: appRes.financeApps.filter((x) => x.id === appData.id)[0],
                  });
                  /*let completionReq = new CompleteFinanceApp(appData.id);
                        completionReq.send().then((compRes) => {
                            console.warn(JSON.stringify(compRes));

                            if(!appRes.hasOwnProperty('error')) {
                                mptapi.router.changeHash('#approval', { financeApp: compRes.financeApps.filter(x => x.id == appData.id)[0]});
                            }
                        });*/
               }
            });
         });
      }
   },
   approved() {
      jMPT('.hero-title-3rk-subpages').text('APPROVED');
      jMPT('.section-title-3rk').text("Congratulations! You're Approved");
      jMPT('.subtitle-italic-3rk > span').text("You're one step closer to starting your next adventure!");

      if (mptapi.router.data.hasOwnProperty('financeApp')) {
         let approvalTemplate = jMPT('#approvalTemplate').html();
         let t = Handlebars.compile(approvalTemplate);
         let model = mptapi.router.data.financeApp;
         model.cartIsEmpty = mptapi.cart.isEmpty;
         jMPT('#applicationContainer').html(t(model));
      } else {
         mptapi.router.changeHash('#review');
      }
   },
   completeAgreement(agr) {
      window.scrollTo(0, 0);
      let agreementTemplate = jMPT('#agreementTemplate').html();
      let t = Handlebars.compile(agreementTemplate);
      let container = jMPT('#agreementContainer');
      container.html(t(agr.html));

      let agreementElem = document.getElementsByClassName('mpt-agreement')[0];
      let shadowRoot = agreementElem.attachShadow({ mode: 'open' });
      shadowRoot.innerHTML = agr.html;

      let submitButton = document.getElementById('mpt-complete-agreement');

      jMPT('.mpt-final-agree').click(function () {
         Custombox.modal.closeAll();
         submitAgreement();
      });

      if (agr.status === 'signed') {
         MPTUI.generateModal('#finalAgreementModal', { content: { width: '85%' } }, { content: { width: '100%' } });
         jMPT('.print-complete-step').hide();
         jMPT('.complete-session-step').show();
         jMPT('.mpt-signing-session-back').click(function () {
            Custombox.modal.closeAll();
         });

         jMPT('.mpt-complete-signing-session').click(function () {
            jMPT('.complete-session-step').slideUp();
            jMPT('.print-complete-step').slideDown();
         });

         submitButton.removeAttribute('disabled');
         submitButton.onclick = function () {
            MPTUI.generateModal('#finalAgreementModal', { content: { width: '85%' } }, { content: { width: '100%' } });
            jMPT('.print-complete-step').show();
            jMPT('.complete-session-step').hide();
         };

         jMPT('#mpt-agreement-pdf').attr('src', agr.url);
         jMPT('#mpt-agreement-download').attr('href', agr.url);

         jMPT('#mpt-signature-accept')
            .html('<i class="text-success fas fa-2x fa-check"></i><span> Saved.</span>')
            .removeClass('mpt-btn-success')
            .removeClass('mpt-btn-secondary')
            .attr('disabled', true);

         jMPT('#signature-fg').hide();
      }

      let maxSigWidth = 240;
      let fixedSigHeight = 45;
      let minFontSize = 11;
      let currentSigWidth = 0;
      let billingName = '';
      let printedName = '';
      let sigType = '';
      let valid = false;
      let sigRepImg = '';
      let signer = { name: 'John Doe' };

      if (agr.hasOwnProperty('signers') && agr.signers.length > 0) {
         signer = agr.signers[0]; //TODO: for now this supports a single signer per document, in the future this will support multiple signers
      }

      billingName = signer.name;

      jMPT('#mpt-signature-accept').on('click', acceptSignature);

      bindSigButtons();

      function bindSigButtons() {
         let signatureButtons = shadowRoot.querySelectorAll('.sign-button');
         for (var i = 0; i < signatureButtons.length; i++) {
            let signatureIndex = signatureButtons[i].getAttribute('data-sig-index') || 0;
            let signerId = signatureButtons[i].getAttribute('data-signer-id') || null;
            let signatureType = signatureButtons[i].getAttribute('data-signer-type') || 'full';
            signatureButtons[i].onclick = (function () {
               let index = signatureIndex;
               let sid = signerId;
               let stype = signatureType;
               return function () {
                  let signer = agr.signers.filter((x) => x.id === sid);

                  if (signer.length > 0) {
                     signer = signer[0];
                     if (
                        (stype === 'full' && signer.fullSignature) ||
                        (stype === 'initial' && signer.initialSignature)
                     ) {
                        //if there is an approved signature of this type
                        jMPT('#mpt-signature-accept').on('click', acceptSignature);
                        sign(signerId, stype, index);
                     } //no matching approved signature
                     else {
                        jMPT('#mpt-signature-accept').off();
                        jMPT('#mpt-signature-accept').click(
                           { signFirst: true, signerId, stype, index },
                           acceptSignature,
                        );
                        MPTUI.generateModal('#editSignatureModal');
                     }
                  } else {
                     jMPT('#mpt-signature-accept').off();
                     jMPT('#mpt-signature-accept').click({ signFirst: true, signerId, stype, index }, acceptSignature);
                     MPTUI.generateModal('#editSignatureModal');
                  }
               };
            })();
         }
      }

      function calculatePages() {
         let agreementText = shadowRoot.querySelector('.agreement-text');

         if (agreementText.children.length > 25) {
            //get all child elements
            let elementList = agreementText.children;

            let pageNum = 1;
            let currentPage = null;
            let currentText = null;
            let child = null;

            for (i = 25; i < elementList.length; i++) {
               child = elementList[i];
               let calcPgNum = Math.floor(i / 25) + 1;

               if (calcPgNum != pageNum) {
                  pageNum = calcPgNum;
                  if (currentPage != null && currentText != null) {
                     currentPage.appendChild(currentText);
                     shadowRoot.insertBefore(currentPage, null);
                  }

                  let newPage = document.createElement('div');
                  newPage.classList.add('web-api-agreement-page');

                  let newText = document.createElement('div');
                  newText.classList.add('agreement-text');

                  currentPage = newPage;
                  currentText = newText;
               }

               agreementText.removeChild(child);
               currentText.appendChild(child);
            }

            if (currentPage != null && currentText != null) {
               currentPage.appendChild(currentText);
               shadowRoot.insertBefore(currentPage, null);
            }
         }
      }

      function initSigApp(username, type) {
         currentSigWidth = maxSigWidth;
         sigType = type;

         if (typeof username != 'undefined' && username != null && username != '') {
            billingName = username;
            jMPT('#signatureInput').attr('placeholder', 'Type ' + username + ' here.');
         }

         jMPT('#signatureInput').on('change keyup', function () {
            printedName = jMPT(this).val();

            if (printedName.length > 0) {
               jMPT('#mpt-signature-accept').attr('disabled', false);
            } else {
               jMPT('#mpt-signature-accept').attr('disabled', true);
            }

            jMPT('#signatureText').text(printedName);
            var currentWidth = jMPT('#signatureText')[0].getBoundingClientRect().width;
            var currentFontSize = parseFloat(jMPT('#signatureText').css('font-size'));
            if (currentWidth > currentSigWidth) {
               if (currentFontSize > minFontSize) {
                  while (currentWidth > currentSigWidth) {
                     currentFontSize -= 1;
                     jMPT('#signatureText').css('font-size', currentFontSize);
                     currentWidth = jMPT('#signatureText')[0].getBoundingClientRect().width;
                  }
               } else {
                  currentSigWidth = currentWidth;
                  jMPT('#signatureSVG').width(currentSigWidth + 10);
               }
            }
         });
      }

      function acceptSignature() {
         try {
            validateSignature();
            valid = true;
         } catch (err) {
            jMPT('#signatureInput').addClass('invalid-signature');
            jMPT('#signatureError').text(err);
            valid = false;
         }

         let signFirst = false;
         let signerId = null;
         let sType = null;
         let index = 0;
         if (arguments.length > 0 && typeof arguments[0].data == 'object') {
            signFirst = arguments[0].data.signFirst;
            signerId = arguments[0].data.signerId;
            sType = arguments[0].data.stype;
            index = arguments[0].data.index;
         }

         if (valid) {
            let accButton = jMPT('#mpt-signature-accept');

            accButton
               .html('<i class="fas fa-2x fa-spinner fa-pulse"></i><span> Uploading image...</span>')
               .removeClass('mpt-btn-success')
               .addClass('mpt-btn-secondary')
               .attr('disabled', true);

            jMPT('#signatureInput').removeClass('invalid-signature');
            jMPT('#signatureError').text('');
            jMPT('#signature-fg').slideUp();
            jMPT('#mpt-signature-approved').slideDown();

            //force svg refresh
            let svg = document.body.querySelector('#signatureSVG').innerHTML;
            document.body.querySelector('#signatureSVG').innerHTML = '';
            document.body.querySelector('#signatureSVG').innerHTML = svg;

            //serialize and store as base64 to ensure rendering never changes
            //encodeImage('https://fonts.gstatic.com/s/satisfy/v9/rP2Hp2yn6lkG50LoCZOIHQ.woff2', 'Satisfy');
            let text = jMPT('#signatureInput').val();
            let width = parseInt(jMPT('#signatureSVG').css('width').replace(/\D/g, ''));
            let height = parseInt(jMPT('#signatureSVG').css('height').replace(/\D/g, ''));
            let fontSize = parseInt(jMPT('#signatureText').css('fontSize').replace(/\D/g, ''));

            jMPT.post(
               mptsettings.ajaxurl,
               { action: 'save_signature', text, fontSize, width, height },
               function (response) {
                  //if(response == null) return;
                  response = JSON.parse(response);
                  if (response.hasOwnProperty('imageString')) {
                     jMPT('<canvas/>', {
                        id: 'savedSignature',
                     }).appendTo('#sig-representation');

                     let canvas = document.body.querySelector('#savedSignature');
                     canvas.width = currentSigWidth + 10;
                     canvas.height = fixedSigHeight;
                     let context = canvas.getContext('2d');

                     /*let img = document.createElement('img');
						img.setAttribute('src', 'data:image/png;base64,' + response.imageString);*/
                     let img = new Image(currentSigWidth + 10, fixedSigHeight);
                     img.src = 'data:image/png;base64,' + response.imageString;

                     img.onload = function () {
                        context.drawImage(
                           img,
                           0,
                           0,
                           currentSigWidth + 10,
                           fixedSigHeight,
                           0,
                           0,
                           canvas.width,
                           canvas.height,
                        );

                        submitSignature(response.imageString, signFirst, signerId, sType, index);
                     };
                  }
               },
            );
         }
      }

      function encodeImage(fontSrc, fontFamily) {
         var xhr = new XMLHttpRequest();
         xhr.open('GET', fontSrc);
         xhr.overrideMimeType('text/plain; charset=x-user-defined');
         xhr.send();

         xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
               let base64EncodedFont = base64EncodeFont(xhr.responseText);
               let sigContainer = document.getElementById('sig-representation');
               let sigSVG = document.getElementById('signatureSVG');

               sigSVG.width = currentSigWidth + 10;
               sigSVG.height = fixedSigHeight;
               let svgDefs = sigSVG.querySelector('defs');
               if (svgDefs !== null) {
                  if (svgDefs.querySelector('style') === null) {
                     let sigTxt = document.getElementById('signatureText');
                     let fontCode =
                        "@font-family: '" +
                        fontFamily +
                        "'; font-style: normal; font-weight: 400; src: local('" +
                        fontFamily +
                        " Regular'), local('" +
                        fontFamily +
                        "-Regular'), url('data:application/font-woff;base64," +
                        base64EncodedFont +
                        "') format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;";
                     let styleElement = document.createElement('style');
                     styleElement.type = 'text/css';
                     styleElement.innerHTML = fontCode;

                     svgDefs.append(styleElement);
                     //sigSVG.insertBefore(styleElement, sigSVG.firstChild);
                     sigTxt.style.fontFamily = "'" + fontFamily + "', sans-serif";
                  }
               }

               let s = new XMLSerializer().serializeToString(sigSVG);

               if (jMPT('#savedSignature').length) {
                  jMPT('#savedSignature').remove();
               }

               jMPT('<canvas/>', {
                  id: 'savedSignature',
               }).appendTo('#sig-representation');

               let canvas = document.body.querySelector('#savedSignature');
               canvas.width = currentSigWidth + 10;
               canvas.height = fixedSigHeight;
               let context = canvas.getContext('2d');

               let img = document.createElement('img');
               img.setAttribute('src', 'data:image/svg+xml;base64,' + btoa(s));
               img.onload = function () {
                  context.drawImage(img, 0, 0, currentSigWidth + 10, fixedSigHeight, 0, 0, canvas.width, canvas.height);
                  sigRepImg = canvas.toDataURL('image/png');
                  //submitSignature(sigRepImg);
               };
            }
         };
      }

      function base64EncodeFont(str) {
         var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
         var out = '',
            i = 0,
            len = str.length,
            c1,
            c2,
            c3;
         while (i < len) {
            c1 = str.charCodeAt(i++) & 0xff;
            if (i == len) {
               out += CHARS.charAt(c1 >> 2);
               out += CHARS.charAt((c1 & 0x3) << 4);
               out += '==';
               break;
            }
            c2 = str.charCodeAt(i++);
            if (i == len) {
               out += CHARS.charAt(c1 >> 2);
               out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
               out += CHARS.charAt((c2 & 0xf) << 2);
               out += '=';
               break;
            }
            c3 = str.charCodeAt(i++);
            out += CHARS.charAt(c1 >> 2);
            out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
            out += CHARS.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
            out += CHARS.charAt(c3 & 0x3f);
         }
         return out;
      }

      function resetSignature() {
         currentSigWidth = maxSigWidth;

         jMPT('#signatureInput').removeClass('invalid-signature');
         jMPT('#signatureError').text('');
         valid = true;

         if (jMPT('#savedSignature').length) {
            jMPT('#savedSignature').slideUp();
            jMPT('#savedSignature').remove();
         }

         jMPT('#mpt-signature-next').slideUp();
         jMPT('#signature-fg').slideDown();
         jMPT('#signatureInput').val(null).keyup();
         jMPT('#signatureSVG').slideDown();
         jMPT('#mpt-signature-accept').slideDown();
         jMPT('#mpt-signature-status').html('');

         try {
            let resetReq = new ResetSignature(agr.id, sigType, printedName, null); //TODO: leaving signerId blank defaults to first signer, will need to support mulitiple signers in the future

            resetReq.send().then((res) => {
               console.log(res);
               if (res.hasOwnProperty('success') && res.success == true) {
                  mptapi.cart.agreements = res.agreements;
                  agr = mptapi.cart.agreements[0];
                  shadowRoot.innerHTML = agr.html;
                  jMPT('#mpt-signature-accept')
                     .html('I accept this signature.')
                     .addClass('mpt-btn-success')
                     .removeClass('mpt-btn-secondary')
                     .attr('disabled', false);
                  bindSigButtons();

                  jMPT('#mpt-signature-reset').slideUp();
               }
            });
         } catch (err) {
            console.error(err);
         }
      }

      function submitSignature(sigRepImg, signFirst, signerId, sType, index) {
         try {
            let acceptButton = jMPT('#mpt-signature-accept');

            jMPT('#signatureSVG').slideUp();
            jMPT('#mpt-signature-reset').slideDown();

            let sigReq = new ApproveSignature(agr.id, sigRepImg, sigType, printedName, null); //TODO: leaving signerId blank defaults to first signer, will need to support mulitiple signers in the future
            mptapi.signSession = { currentSignature: sigRepImg, openSignRequest: false };

            sigReq.send().then((res) => {
               if (res.hasOwnProperty('success') && res.success == true) {
                  acceptButton
                     .html('<i class="text-success fas fa-2x fa-check"></i><span> Saved.</span>')
                     .removeClass('mpt-btn-success')
                     .removeClass('mpt-btn-secondary')
                     .attr('disabled', true);
                  mptapi.cart.agreements = res.agreements;
                  agr = mptapi.cart.agreements[0];
                  Custombox.modal.close();

                  if (signFirst) {
                     sign(signerId, sType, index);
                  }
               } else {
                  //upload failed
                  acceptButton
                     .html('<i class="text-danger fas fa-2x fa-times"></i><span> Failed. Retry</span>')
                     .addClass('mpt-btn-success')
                     .removeClass('mpt-btn-secondary')
                     .attr('disabled', false);
               }
            });
         } catch (err) {
            console.error(err);
         }
      }

      function sign(signerId, sType, index) {
         try {
            let signReq = new SignRequest(agr.id, sType, signerId, index);
            let sigButton = shadowRoot.querySelector('.sign-button[data-sig-index="' + index + '"]');
            sigButton.style.display = 'none';
            sigButton.setAttribute('data-signed', 'true');

            mptapi.signSession.openSignRequest = true;
            if (mptapi.signSession.currentSignature) {
               shadowRoot.querySelector('td[data-sig-index="' + index + '"]').innerHTML =
                  '<img class="signature-image" src="data:image/png;base64,' +
                  mptapi.signSession.currentSignature +
                  '" data-sig-index="' +
                  index +
                  '" data-signer-id="' +
                  signerId +
                  '">';
               Pace.restart();
            } else {
               shadowRoot.querySelector('.sign-loader[data-sig-index="' + index + '"]').style.display = 'block';
            }

            //TODO: check if any signature buttons remain. if not then show: MPTUI.generateModal('#pleaseWaitSignatureModal', {content: {width: "85%"}}, {content: {width: "100%"}});
            let sigCount = shadowRoot.querySelectorAll('.sign-button').length;
            let completeCount = shadowRoot.querySelectorAll('.sign-button[data-signed="true"]').length;
            if (sigCount === completeCount) {
               MPTUI.generateModal(
                  '#pleaseWaitSignatureModal',
                  { content: { width: '85%' } },
                  { content: { width: '100%' } },
               );
            }

            signReq.send().then((res) => {
               if (res.hasOwnProperty('success') && res.success == true) {
                  shadowRoot.querySelector('td[data-sig-index="' + index + '"]').innerHTML =
                     '<img class="signature-image" src="' +
                     res.signature.signature +
                     '" data-sig-index="' +
                     index +
                     '" data-signer-id="' +
                     signerId +
                     '">';
                  Custombox.modal.closeAll();
                  mptapi.signSession.openSignRequest = false;
                  if (res.signature.agreementStatus === 'signed') {
                     submitButton.removeAttribute('disabled');

                     if (res.signature.hasOwnProperty('url') && res.signature.url !== null) {
                        jMPT('#mpt-agreement-pdf').attr('src', res.signature.url);
                        jMPT('#mpt-agreement-download').attr('href', res.signature.url);
                        submitButton.onclick = function () {
                           jMPT('.mpt-final-agree').click(function () {
                              Custombox.modal.closeAll();
                              submitAgreement();
                              MPTUI.generateModal(
                                 '#pleaseWaitAgreementModal',
                                 { content: { width: '85%' } },
                                 { content: { width: '100%' } },
                              );
                           });
                           MPTUI.generateModal(
                              '#finalAgreementModal',
                              { content: { width: '85%' } },
                              { content: { width: '100%' } },
                           );
                        };
                     } else {
                        submitButton.onclick = function () {
                           submitAgreement();
                        };
                     }

                     jMPT('.print-complete-step').hide();
                     jMPT('.complete-session-step').show();
                     jMPT('.mpt-signing-session-back').click(function () {
                        Custombox.modal.closeAll();
                     });

                     jMPT('.mpt-complete-signing-session').click(function () {
                        jMPT('.complete-session-step').slideUp();
                        jMPT('.print-complete-step').slideDown();
                     });
                     MPTUI.generateModal(
                        '#finalAgreementModal',
                        { content: { width: '85%' } },
                        { content: { width: '100%' } },
                     );
                  } else {
                     submitButton.setAttribute('disabled', 'disabled');
                     submitButton.onclick = function () {
                        return false;
                     };
                  }
               }
            });
         } catch (err) {
            console.error(err);
            alert(err);
         }
      }

      function submitAgreement() {
         console.log('complete agreement...');
         let submitReq = new SubmitAgreementRequest(agr.id);
         let subscriptionTotal = mptapi.cart.totals.filter((x) => x.name === 'Weekly Total');

         if (subscriptionTotal.length > 0) subscriptionTotal = subscriptionTotal[0];
         else subscriptionTotal = 0;

         submitReq.send().then((res) => {
            if (res.hasOwnProperty('success') && res.success == true) {
               let checkoutReq = new Checkout(subscriptionTotal);
               checkoutReq.send().then((x) => {
                  mptapi.router.redirect('/checkout', '#confirmation', { prevOrder: x });
               });
            }
         });
      }

      function validateSignature() {
         if (sigType === 'full') {
            let requiredNames = billingName.toLowerCase().split(' ');
            let providedNames = printedName.toLowerCase().split(' ');

            if (requiredNames.length) {
               for (i = 0; i < requiredNames.length; i++) {
                  let req = requiredNames[i];
                  if (!providedNames.includes(req)) {
                     throw 'Oops! The signer for this document must match the name for the billing information.';
                  }
               }
            } else throw 'billing name required';
         }
      }

      initSigApp(billingName, 'full');

      jMPT('#mpt-sigtool').on('click', function () {
         MPTUI.generateModal('#editSignatureModal');
         jMPT('#mpt-signature-accept').off();
         jMPT('#mpt-signature-accept').on('click', acceptSignature);
      });

      jMPT('#mpt-signature-reset').on('click', resetSignature);
   },
   /* 2c. Account Page */
   account() {
      jMPT('#yourOrders').click(function () {
         mptapi.router.changeHash('#orders');
      });

      jMPT('#yourAddresses').click(function () {
         mptapi.router.changeHash('#addresses');
      });

      jMPT('#yourSubscriptions').click(function () {
         mptapi.router.changeHash('#subscriptions');
      });

      jMPT('#accountInfo').click(function () {
         mptapi.router.changeHash('#accountinfo');
      });

      jMPT('#paymentOptions').click(function () {
         mptapi.router.changeHash('#payments');
      });

      jMPT('#referralCodeOptions').click(function () {
         mptapi.router.changeHash('#referral-code');
      });

      jMPT('#contactUs').click(function () {
         mptapi.router.redirect('/contact');
      });
      jMPT('#yourAgreements').click(function () {
         mptapi.router.changeHash('#agreements');
      });
   },

   /* 2d. Order History Page */
   orders() {
      jMPT('.backToAccountButton').click(function () {
         mptapi.router.changeHash('#account');
      });
      MPTUI.paginate();
   },

   referralCode() {
      jMPT('.backToAccountButton').click(function () {
         mptapi.router.changeHash('#account');
      });
   },

   /* 2e. Shipping Profiles Page */
   addresses() {
      if (mptapi.router.data.hasOwnProperty('back-button')) {
         let back = mptapi.router.data['back-button'];
         jMPT('.backToAccountButton')
            .click(function () {
               mptapi.router.redirect('/' + back.page + back.action);
            })
            .text(back.title);
      } else {
         jMPT('.backToAccountButton').click(function () {
            mptapi.router.changeHash('#account');
         });
      }

      jMPT('#saveNewAddress').click(function (e) {
         console.log('validating');

         let firstName = jMPT('#shippingAddfirstName').val();
         let lastName = jMPT('#shippingAddlastName').val();
         let address = jMPT('#shippingAddaddress').val();
         let address2 = jMPT('#shippingAddaddress2').val();
         let city = jMPT('#shippingAddcity').val();
         let region = jMPT('#shippingAddregion').val();
         let postal = jMPT('#shippingAddzip').val();
         let country = jMPT('#shippingAddcountry').val();
         let phone = jMPT('#shippingAddPhone').val();
         let instructions = jMPT('#shippingAddInstructions').val();

         jMPT
            .validateFields(
               {
                  '#shippingAddfirstName': {
                     blank: {
                        required: false,
                        message: 'Please enter a first name.',
                     },
                  },
                  '#shippingAddlastName': {
                     blank: {
                        required: false,
                        message: 'Please enter a last name.',
                     },
                  },
                  '#shippingAddaddress': {
                     blank: {
                        required: false,
                        message: 'Please enter a valid street address.',
                     },
                  },
                  '#shippingAddcity': {
                     blank: {
                        required: false,
                        message: 'Please enter a valid city.',
                     },
                  },
                  '#shippingAddregion': {
                     hasSelections: {
                        required: true,
                        message: 'Please select a region.',
                     },
                  },
                  '#shippingAddzip': {
                     isZipcode: {
                        required: true,
                        message: 'Please enter a valid postal/zip code.',
                     },
                  },
                  '#shippingAddPhone': {
                     blank: {
                        required: false,
                        message: 'Please enter a valid phone.',
                     },
                  },
               },
               '#addAddressModal',
            )
            .then(() => {
               let req = new AddShippingProfile({
                  firstName: firstName,
                  lastName: lastName,
                  address: address,
                  address2: address2,
                  city: city,
                  region: region,
                  postal: postal,
                  country: country,
                  phone: phone,
                  instructions: instructions,
               });
               req.send().then(() => {
                  mptapi.router.render();
               });
            });
      });

      jMPT('.saveAddressEdits').on('click', function () {
         let shippingProfileId = jMPT(this).data('shippingProfileId');
         let firstName = jMPT('#' + shippingProfileId + 'firstName').val();
         let lastName = jMPT('#' + shippingProfileId + 'lastName').val();
         let address = jMPT('#' + shippingProfileId + 'address').val();
         let address2 = jMPT('#' + shippingProfileId + 'address2').val();
         let city = jMPT('#' + shippingProfileId + 'city').val();
         let region = jMPT('#' + shippingProfileId + 'region').val();
         let postal = jMPT('#' + shippingProfileId + 'zip').val();
         let country = jMPT('#' + shippingProfileId + 'country').val();
         let phone = jMPT('#' + shippingProfileId + 'Phone').val();
         let instructions = jMPT('#' + shippingProfileId + 'deliveryInstructions').val();
         let req = new UpdateShippingProfile(shippingProfileId, {
            firstName: firstName,
            lastName: lastName,
            address: address,
            address2: address2,
            city: city,
            region: region,
            postal: postal,
            country: country,
            phone: phone,
            instructions: instructions,
         });

         req.send().then(() => {
            mptapi.router.render();
         });
      });

      jMPT('.defaultAddress').on('click', function () {
         let shippingProfileId = jMPT(this).data('shippingProfileId');
         let req = new SetDefaultShippingProfile(shippingProfileId, { setAsDefault: true });

         req.send().then(() => {
            mptapi.router.render();
         });
      });

      jMPT('.deleteAddress').on('click', function () {
         let shippingProfileId = jMPT(this).data('shippingProfileId');
         let req = new DeleteShippingProfile(shippingProfileId);

         req.send().then(() => {
            mptapi.router.render();
         });
      });

      if (typeof window.crs !== 'undefined') {
         window.crs.init();
      }

      jMPT('.crs-country').val(jMPT('#companyCountry').val()).change();
      jMPT('[data-value-selection]').each(function () {
         jMPT(this).val(jMPT(this).data('valueSelection'));
      });
      MPTUI.globals();
   },

   /* 2f. Active Subscription Page */
   subscriptions() {
      jMPT('.backToAccountButton').click(function () {
         mptapi.router.changeHash('#account');
      });

      jMPT('.edit-subscription-btn').click(function () {
         if (
            mptapi.companyInfo &&
            mptapi.user &&
            mptapi.user.hasActiveSubscriptions &&
            mptapi.companyInfo.enforceSubscriptionOverwrite
         ) {
            mptapi.router.redirect('shop', '#deliveries', { editingSubscription: true });
         } else {
            let id = jMPT(this).data('id');
            let req = new SubscriptionEdit(id, 'init');
            req.send().then((x) => {
               if (
                  x.companyInfo &&
                  x.user &&
                  x.user.hasActiveSubscriptions &&
                  x.companyInfo.enforceSubscriptionOverwrite
               ) {
                  mptapi.router.redirect('shop', '#deliveries', { editingSubscription: true });
               } else if (x.hasOwnProperty('cart')) {
                  if (x.cart.hasOwnProperty('deliveries')) {
                     if (x.cart.deliveries.length >= 0) {
                        let deliveryId = x.cart.deliveries[0].id;
                        mptapi.router.redirect('order', '#subscription', { deliveryId, subId: id });
                        return;
                     }
                  }
               }
               throw new Error('Data error. Missing Cart');
            });
         }
      });

      jMPT('.freeze-subscription').click(function () {
         let id = jMPT(this).data('subscriptionId');
         mptapi.router.changeHash('#freeze', { subscriptionId: id });
      });

      jMPT('.unfreeze-subscription').click(function () {
         let subid = jMPT(this).data('subscriptionId');
         let fromDate = jMPT(this).data('fromDate');
         let toDate = jMPT(this).data('toDate');
         let req = new UnfreezeSubscription(subid, fromDate, toDate);
         req.send().then((x) => {
            jMPT.createNotification('Success!', x.hasOwnProperty('result') ? x.result : 'Subscription unfrozen.');
            mptapi.router.redirect('user', '#subscriptions');
         });
      });

      jMPT('.cancel-subscription').click(function () {
         let id = jMPT(this).data('subscriptionId');
         mptapi.router.changeHash('#cancel', { subscriptionId: id });
      });

      jMPT('.edit-subpayment-btn').click(function () {
         let subid = jMPT(this).data('id');
         MPTUI.generateModal(
            '.selectPaymentModal[data-subid="' + subid + '"]',
            { content: { width: '85%' } },
            { content: { width: '100%' } },
         );
      });

      jMPT('#billingProfileSection .billingProfile').click(function () {
         jMPT('#billingProfileSection .billingProfile.active').removeClass('active');
         jMPT(this).addClass('active');
      });

      jMPT('.update-sub-billing').click(function () {
         let subid = jMPT(this).data('subid');
         let profId = jMPT('#billingProfileSection[data-subid=' + subid + '] .billingProfile.active').data(
            'billingprofile',
         );

         var profReq = new UpdateSubscriptionBilling(subid, profId);
         profReq.send().then(function (profRes) {
            console.log(profRes);
            mptapi.router.changeHash('#subscriptions');
         });
      });

      MPTUI.globals();
      MPTUI.contactForm();
      MPTUI.paginate();
   },

   freezeSubscription() {
      jMPT('.back-to-subscriptions').click(function () {
         mptapi.router.changeHash('#subscriptions');
      });
      jMPT('#freezeOptions a').click(function () {
         let curVal = jMPT(this).attr('data-active');
         if (curVal === 'true') {
            jMPT(this).removeClass('border-right-selected').attr('data-active', false);
            jMPT(this).children().eq(1).slideUp();
         } else {
            jMPT('#freezeOptions a')
               .not(this)
               .removeClass('border-right-selected')
               .attr('data-active', false)
               .each(function () {
                  jMPT(this).children().eq(1).slideUp();
               });
            jMPT(this).addClass('border-right-selected').attr('data-active', true);
            jMPT(this).children().eq(1).slideDown();
         }
         if (jMPT('#freezeOptions a[data-active="true"]').length === 0) {
            jMPT('#addDeliveryOptionControl').addClass('disabled');
         } else {
            jMPT('#addDeliveryOptionControl').removeClass('disabled').resetError();
         }
      });
      jMPT('select').click(function (e) {
         e.stopPropagation();
      });
      jMPT('.freeze-subscription').click(function () {
         let active = jMPT('#freezeOptions a[data-active=true]');
         let fromDate = active.data('fromDate');
         let endDate = active.find('select').val();
         let req = new FreezeSubscription(mptapi.router.data.subscriptionId, fromDate, endDate);
         req.send().then((x) => {
            jMPT.createNotification(
               'Success!',
               x.hasOwnProperty('result') ? x.result : 'Subscription frozen until <b>' + endDate + '</b>.',
            );
            mptapi.router.changeHash('#subscriptions');
         });
      });
   },

   cancelSubscription() {
      jMPT('.back-to-subscriptions').click(function () {
         mptapi.router.changeHash('#subscriptions');
      });
      jMPT('#cancelOptions a').click(function () {
         let curVal = jMPT(this).attr('data-active');
         if (curVal === 'true') {
            jMPT(this).removeClass('border-right-selected').attr('data-active', false);
            jMPT(this).children().eq(1).slideUp();
         } else {
            jMPT('#cancelOptions a')
               .not(this)
               .removeClass('border-right-selected')
               .attr('data-active', false)
               .each(function () {
                  jMPT(this).children().eq(1).slideUp();
               });
            jMPT(this).addClass('border-right-selected').attr('data-active', true);
            jMPT(this).children().eq(1).slideDown();
         }
         if (jMPT('#cancelOptions a[data-active="true"]').length === 0) {
            jMPT('#addDeliveryOptionControl').addClass('disabled');
         } else {
            jMPT('#addDeliveryOptionControl').removeClass('disabled').resetError();
         }
      });
      jMPT('select').click(function (e) {
         e.stopPropagation();
      });
      jMPT('.cancel-subscription').click(function () {
         let active = jMPT('#cancelOptions a[data-active=true]');
         let fromDate = active.data('fromDate');
         let cancelReason = jMPT('.cancel-reason').val();
         let cancelText = null;
         if (cancelReason && cancelReason.toLowerCase() === 'other') cancelText = jMPT('.cancel-reason-text').val();
         let req = new CancelSubscription(mptapi.router.data.subscriptionId, fromDate, cancelReason, cancelText);
         req.send().then((x) => {
            jMPT.createNotification(
               'Success!',
               x.hasOwnProperty('result') ? x.result : 'Subscription cancelled starting on <b>' + fromDate + '</b>.',
            );
            mptapi.router.changeHash('#subscriptions');
         });
      });

      jMPT('.cancel-reason').change(function () {
         if (jMPT(this).val().toLowerCase() === 'other') jMPT('.cancel-reason-text').slideDown();
         else jMPT('.cancel-reason-text').slideUp();
      });

      jMPT('.request-cancel-subscription').click(function () {
         jMPT('.request-cancel-subscription').slideUp();
         jMPT('#cancelOptions').slideUp();
         jMPT('.cancel-reason').slideDown();
         jMPT('.cancel-subscription').slideDown();
      });
   },

   /* 2g. Account Info Page */
   accountinfo() {
      jMPT('.backToAccountButton').click(function () {
         mptapi.router.changeHash('#account');
      });

      jMPT('#editName').click(function () {
         jMPT('.fullName').hide();
         jMPT('#fullNameInputs').show();
         jMPT('#editName').hide();
         jMPT('#editNameButtons').show();
      });

      jMPT('#cancelNameChange').click(function () {
         let first = jMPT('#firstNameInput');
         let last = jMPT('#lastNameInput');
         jMPT('.fullName').show();
         jMPT('#fullNameInputs').hide();
         jMPT('#editName').show();
         jMPT('#editNameButtons').hide();
         first.val(first.data('defaultValue'));
         last.val(last.data('defaultValue'));
      });

      jMPT('#saveName').click(function () {
         let first = jMPT('#firstNameInput');
         let last = jMPT('#lastNameInput');
         jMPT
            .validateFields({
               '#firstNameInput': {
                  blank: {
                     required: false,
                     message: 'First name is required',
                  },
               },
               '#lastNameInput': {
                  blank: {
                     required: false,
                     message: 'Last name is required',
                  },
               },
            })
            .then(() => {
               let payload = {
                  firstName: first.val(),
                  lastName: last.val(),
               };
               let req = new UpdateAccountInfo(payload);
               req.send().then(() => {
                  jMPT('.fullName')
                     .text(payload.firstName + ' ' + payload.lastName)
                     .show();
                  //Set default again to allow for reverting changes
                  first.data('defaultValue', payload.firstName);
                  last.data('defaultValue', payload.lastName);
                  jMPT('#fullNameInputs').hide();
                  jMPT('#editName').show();
                  jMPT('#editNameButtons').hide();
               });
            });
      });

      jMPT('#editEmail').click(function () {
         jMPT('.userEmail').hide();
         jMPT('#emailInputs').show();
         jMPT('#editEmail').hide();
         jMPT('#editEmailButtons').show();
      });

      jMPT('#cancelEmail').click(function () {
         let email = jMPT('#emailInput');
         email.val(email.data('defaultValue'));
         jMPT('.userEmail').show();
         jMPT('#emailInputs').hide();
         jMPT('#editEmail').show();
         jMPT('#editEmailButtons').hide();
      });

      jMPT('#saveEmail').click(function () {
         let email = jMPT('#emailInput');
         jMPT
            .validateFields({
               '#emailInput': {
                  isEmail: {
                     required: true,
                     message: 'Please enter a valid email.',
                  },
               },
            })
            .then(() => {
               let payload = {
                  email: email.val(),
               };
               let req = new UpdateAccountInfo(payload);
               req.send().then(() => {
                  // Set new default to allow for reverting changes
                  email.data('defaultValue', payload.email);
                  jMPT('.userEmail').text(payload.email).show();
                  jMPT('#emailInputs').hide();
                  jMPT('#editEmail').show();
                  jMPT('#editEmailButtons').hide();
               });
            });
      });

      jMPT('#editPhone').click(function () {
         jMPT('.userPhone').hide();
         jMPT('#phoneInputs').show();
         jMPT('#editPhone').hide();
         jMPT('#editPhoneButtons').show();
      });

      jMPT('#cancelPhoneChange').click(function () {
         let phone = jMPT('#phoneInput');
         phone.val(phone.data('defaultValue'));
         jMPT('.userPhone').show();
         jMPT('#phoneInputs').hide();
         jMPT('#editPhone').show();
         jMPT('#editPhoneButtons').hide();
      });

      jMPT('#savePhone').click(function () {
         let phone = jMPT('#phoneInput');
         jMPT
            .validateFields({
               '#phoneInput': {
                  blank: {
                     required: false,
                     message: 'Please enter a phone number.',
                  },
               },
            })
            .then(() => {
               let payload = {
                  phone: phone.val(),
               };
               let req = new UpdateAccountInfo(payload);
               req.send().then(() => {
                  phone.data('defaultValue', payload.phone);
                  jMPT('.userPhone').text(payload.phone).show();
                  jMPT('#phoneInputs').hide();
                  jMPT('#editPhone').show();
                  jMPT('#editPhoneButtons').hide();
               });
            });
      });

      jMPT('#resetPasswordSend').click(function () {
         let email = jMPT(this).data('user');
         let req = new ForgotPassword(email);
         req.send().then((x) => {
            jMPT('#resetPasswordModalDiv').html(
               "<i class='fa fa-check text-success mr-2'></i>Password Reset Sent Successfully.",
            );
            jMPT('#resetPasswordSend').hide();
         });
      });
      MPTUI.globals();
   },

   /* 2h. Billing Info Page */
   payments() {
      MPTUI.globals();

      let profileType = 'credit';

      jMPT('.backToAccountButton').click(function () {
         mptapi.router.changeHash('#account');
      });

      /*jMPT('#achTypeSelector').click(function() {
			let target = jMPT(this).data("target");
			jMPT('#achTypeSelector').addClass('active-mpt-payment-type').removeClass('mpt-payment-type');
			jMPT('#creditTypeSelector').addClass('mpt-payment-type').removeClass('active-mpt-payment-type');
			jMPT('#achInfoDiv').slideDown();
			jMPT('#creditInfoDiv').slideUp();
		});*/

      jMPT('.mpt-payment-type, .active-mpt-payment-type').click(function () {
         let target = jMPT(this).data('target');
         profileType = jMPT(this).data('type');
         let parent = jMPT(this).closest('.mpt-modal');

         let otherPaymentTypes = parent.find('.payment-type-div:not(.' + profileType + ')');
         let otherPaymentSelectors = parent.find('.mpt-payment-type:not([data-type=' + profileType + '])');

         //Change button classes
         otherPaymentSelectors.removeClass('active-mpt-payment-type');
         jMPT(this).addClass('active-mpt-payment-type');

         //Show target div and hide others
         otherPaymentTypes.slideUp();
         jMPT(target).slideDown();
      });

      jMPT('#saveNewBillingProfile').click(function () {
         if (profileType.toLowerCase() === 'ach') {
            MPTRequest.encryptText(jMPT('#add-account-number').val(), mptapi.router.data.padKey)
               .then((acctToken) => {
                  let routing = jMPT('#add-routing-number').val();
                  let firstName = jMPT('#paymentAddfirstName').val();
                  let lastName = jMPT('#paymentAddlastName').val();
                  let address = jMPT('#paymentAddaddress').val();
                  let address2 = jMPT('#paymentAddaddress2').val();
                  let city = jMPT('#paymentAddcity').val();
                  let region = jMPT('#paymentAddregion').val();
                  let postal = jMPT('#paymentAddzip').val();
                  let country = jMPT('#paymentAddcountry').val();

                  let request = {
                     acctType: profileType,
                     address,
                     address2,
                     city,
                     region,
                     postal,
                     country,
                     acctToken,
                     routing,
                     firstName,
                     lastName,
                  };

                  let req = new AddBillingProfile(request);
                  req.send().then(() => {
                     mptapi.router.render();
                  });
               })
               .catch((err) => {
                  jMPT.createNotification('Error!', err);
               });
         } else {
            MPTRequest.encryptText(jMPT('#add-cc-number').val(), mptapi.router.data.padKey)
               .then((ccToken) => {
                  let cardholderFirst = jMPT('#paymentAddfirstName').val();
                  let cardholderLast = jMPT('#paymentAddlastName').val();
                  let address = jMPT('#paymentAddaddress').val();
                  let address2 = jMPT('#paymentAddaddress2').val();
                  let city = jMPT('#paymentAddcity').val();
                  let region = jMPT('#paymentAddregion').val();
                  let postal = jMPT('#paymentAddzip').val();
                  let country = jMPT('#paymentAddcountry').val();
                  let ccExp = jMPT('#add-cc-expiration-month').val() + jMPT('#add-cc-expiration-year').val();
                  let ccCvv = jMPT('#add-cc-cvv').val();
                  let request = {
                     acctType: profileType,
                     address,
                     address2,
                     city,
                     region,
                     postal,
                     country,
                     ccToken,
                     ccExp,
                     ccCvv,
                     cardholderFirst,
                     cardholderLast,
                  };
                  let req = new AddBillingProfile(request);
                  req.send().then(() => {
                     mptapi.router.render();
                  });
               })
               .catch((err) => {
                  jMPT.createNotification('Error!', err);
               });
         }
      });

      jMPT('.savePaymentsEdits').on('click', function () {
         let billingProfileId = jMPT(this).data('billingProfileId');
         MPTRequest.encryptText(jMPT('#' + billingProfileId + 'cc-number').val(), mptapi.router.data.padKey)
            .then((ccToken) => {
               let cardholderFirst = jMPT('#' + billingProfileId + 'firstName').val();
               let cardholderLast = jMPT('#' + billingProfileId + 'lastName').val();
               let address = jMPT('#' + billingProfileId + 'address').val();
               let address2 = jMPT('#' + billingProfileId + 'address2').val();
               let city = jMPT('#' + billingProfileId + 'city').val();
               let region = jMPT('#' + billingProfileId + 'region').val();
               let postal = jMPT('#' + billingProfileId + 'zip').val();
               let country = jMPT('#' + billingProfileId + 'country').val();
               let ccExp =
                  jMPT('#' + billingProfileId + 'cc-expiration-month').val() +
                  jMPT('#' + billingProfileId + 'cc-expiration-year').val();
               let ccCvv = jMPT('#' + billingProfileId + 'cc-cvv').val();

               let payload = {
                  address,
                  address2,
                  city,
                  region,
                  postal,
                  country,
                  ccToken,
                  ccExp,
                  ccCvv,
                  cardholderFirst,
                  cardholderLast,
               };

               if (jMPT('#' + billingProfileId + 'updatePaymentToggle').not(':visible')) {
                  payload.ccCvv = null;
                  payload.ccExp = null;
                  payload.ccToken = null;
               }

               let request = new UpdateBillingProfile(billingProfileId, payload);

               request.send().then(() => {
                  mptapi.router.render();
               });
            })
            .catch((err) => {
               jMPT.createNotification('Error!', err);
            });
      });

      jMPT('.defaultPayment').on('click', function () {
         let billingProfileId = jMPT(this).data('billingProfileId');
         let req = new SetDefaultBillingProfile(billingProfileId, {
            setAsDefault: true,
         });

         req.send().then(() => {
            mptapi.router.render();
         });
      });

      jMPT('.deletePayment').on('click', function () {
         let billingProfileId = jMPT(this).data('billingProfileId');
         let req = new DeleteBillingProfile(billingProfileId);

         req.send().then(() => {
            mptapi.router.render();
         });
      });

      if (typeof window.crs !== 'undefined') {
         window.crs.init();
      }

      jMPT('.crs-country').val(jMPT('#companyCountry').val()).change();
      jMPT('[data-value-selection]').each(function () {
         jMPT(this).val(jMPT(this).data('valueSelection'));
      });

      let currentYear = parseInt(new Date().getFullYear().toString().substr(2));
      let expirationYearElements = [];
      for (let i = 0; i < currentYear + 30; i++) {
         expirationYearElements.push(jMPT('<option>', { value: currentYear + i, text: currentYear + i }));
      }
      jMPT('.cc-expiration-year').append(expirationYearElements);
   },

   forgotPass() {
      var emailex = new RegExp(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,7})$/);

      jMPT('#forgotPassSubmit').click(function () {
         let email = jMPT('#email').resetError().val();
         if (email.length !== 0 && emailex.test(email)) {
            let req = new ForgotPassword(email);
            req.send().then((x) => {
               if (x.success) {
                  jMPT('#forgot-container').fadeOut(400, function () {
                     jMPT('#forgot-confirmation').fadeIn();
                  });
               }
            });
         } else {
            jMPT('#email').generateError('Please enter an email address.');
         }
      });
   },

   resetPass() {
      jMPT('#resetPassSubmit').click(function () {
         let email = jMPT('#Email').val();
         let token = jMPT('#Token').val();
         let password = jMPT('#newPassword').val();

         if (validatePassword()) {
            let req = new ResetPassword(email, password, token);
            req.send().then((res) => {
               if (res.success) {
                  jMPT.createAlert(
                     'Success!',
                     'Password Reset. <a href="/user/#login">Please log in.</a>',
                     null,
                     'success',
                     'fa fa-check',
                  );
                  mptapi.router.changeHash('#login');
               }
            });
         }
      });

      function validatePass(options) {
         let defaults = {
            passwordField: '#Password',
            confirmField: '#confirmPassword',
         };
      }

      let passwordReqs = jMPT('.password-reqs');
      try {
         if (isMobile() || typeof jQuery('#newPassword').popover !== 'function') passwordReqs.css('display', 'block');
         else passwordReqs.css('display', 'none');

         jQuery('#newPassword')
            .popover({
               html: true,
               trigger: 'focus',
               placement: 'right',
               title: 'Password Requirements',
               container: 'body',
               content: function () {
                  return passwordReqs.html();
               },
            })
            .on({
               focus: function () {
                  validatePassword();

                  if (!isMobile()) {
                     passwordReqs.css('display', 'none');
                  } else {
                     jQuery(this).popover('dispose');
                     passwordReqs.css('display', 'block');
                  }
               },
               keyup: validatePassword,
            });
      } catch (err) {
         console.error(err);
      }

      jMPT('#confirmNewPassword').keydown(function (e) {
         if (e.which === 13 || e.key === 'Enter') {
            e.preventDefault();
            jMPT('#resetPassSubmit').click();
            return false;
         }
      });

      let numeric = new RegExp(/^(?=.*\d).+$/);
      let lower = new RegExp(/^(?=.*[a-z]).+$/);
      let upper = new RegExp(/^(?=.*[A-Z]).+$/);
      let length = new RegExp(/^.{6,}$/);

      function validatePassword() {
         let valid = true;
         let field = jMPT('#newPassword').val();
         if (!lower.test(field)) {
            jMPT('.lower-req').removeClass('text-success').addClass('text-danger');
            jMPT('.lower-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.lower-req').removeClass('text-danger').addClass('text-success');
            jMPT('.lower-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Uppercase
         if (!upper.test(field)) {
            jMPT('.upper-req').removeClass('text-success').addClass('text-danger');
            jMPT('.upper-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.upper-req').removeClass('text-danger').addClass('text-success');
            jMPT('.upper-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Numeric
         if (!numeric.test(field)) {
            jMPT('.num-req').removeClass('text-success').addClass('text-danger');
            jMPT('.num-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.num-req').removeClass('text-danger').addClass('text-success');
            jMPT('.num-req i').removeClass('fa-times').addClass('fa-check');
         }
         //Length
         if (!length.test(field)) {
            jMPT('.length-req').removeClass('text-success').addClass('text-danger');
            jMPT('.length-req i').removeClass('fa-check').addClass('fa-times');
            valid = false;
         } else {
            jMPT('.length-req').removeClass('text-danger').addClass('text-success');
            jMPT('.length-req i').removeClass('fa-times').addClass('fa-check');
         }
         if (!isMobile()) {
            try {
               jQuery('#newPassword').popover({
                  html: true,
                  trigger: 'focus',
                  placement: 'right',
                  title: 'Password Requirements',
                  container: 'body',
                  content: function () {
                     return passwordReqs.html();
                  },
               });
            } catch (err) {
               console.error(err);
            }
            jQuery('.popover').addClass('show bs-popover-right');
         }

         if (isMobile() || typeof jQuery('#newPassword').popover !== 'function') {
            if (valid) jMPT('.password-reqs').slideUp();
            else jMPT('.password-reqs').slideDown();
         }

         return valid;
      }

      function confirmPassword() {
         let password = jMPT('#newPassword').val();
         let passconfirm = jMPT('#confirmNewPassword').val();
         let confirmed = password === passconfirm;
         if (!confirmed) jMPT('.confirm-message').slideDown();
         else jMPT('.confirm-message').slideUp();
         return confirmed;
      }

      function isMobile() {
         let isMobile = false;
         if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
               navigator.userAgent,
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
               navigator.userAgent.substr(0, 4),
            )
         ) {
            isMobile = true;
         }
         return isMobile;
      }
   },

   agreements() {
      jMPT('#backToAccount').click(function () {
         mptapi.router.changeHash('#account');
      });
   },
   //#endregion

   //#region Checkout Pages
   initCheckout(reload) {
      if (!reload) {
         mptapi.orderVues = {};
         mptapi.orderVues.mptProductPage = new FFCustomProductDetail({ selectedProduct: null, onCheckout: true });
         mptapi.orderVues.mptCheckoutPreOrderDays = new MPTCheckoutPreOrderDays(null, null);
         jMPT('FFCustomProductDetail').css({ left: '-150vw', top: '0', position: 'fixed' }).removeClass('visible');
         jMPT('FFCustomProductDetail .mpt-back-to-store-container').css({
            opacity: 0,
            position: 'relative',
         });
      } else {
         const featureContainer = jQuery('#featured-product-container');

         if (featureContainer && featureContainer.length) {
            featureContainer.slick({
               dots: true
            });
         }
      }

      FINIX_API.options.submitLabel = FINIX_STATES.billing;
      let customScriptCallback = null;

      if (window.markdownit) {
         let mdconverter = window.markdownit();
         mdconverter.disable(['code']);
         jMPT('.mpt-company-terms').each(function () {
            let text = jMPT('.mpt-company-terms-source').text();
            jMPT(this).html(mdconverter.render(text));
         });
      }

      if (hasCustomReviewCheckoutScripts()) customScriptCallback = _mptReviewCheckoutCustomScript;

      /*let cartHasSubscriptionItems = mptapi.cart.deliveries.map(x => x.products.filter(p => p.recurrence != null).length).sum() > 0;
		if((mptapi.activeSubscriptions && mptapi.activeSubscriptions.length > 0) && cartHasSubscriptionItems){
			if(getCookie("acknowledged_active_subscription") !== "true"){
				MPTUI.generateModal('#activeSubscriptionModal');
				MPTUI.enableModalClose();
			}
		}
		window.setActiveSubAck = function(){
			document.cookie = "acknowledged_active_subscription=true; expires=" + new Date().addHours(1).toUTCString() + ";";
		};*/

      mptapi.router.data.checkout.preferenceStates = {
         shippingStateInternal:
            !mptapi.router.data.checkout.selectedShipping || mptapi.router.data.checkout.selectedShipping.length === 0
               ? 'editing'
               : 'saved',
         set shippingState(val) {
            this.shippingStateInternal = val;
            this.changed();
         },
         get shippingState() {
            return this.shippingStateInternal;
         },
         billingStateInternal:
            !mptapi.router.data.checkout.selectedBilling || mptapi.router.data.checkout.selectedBilling.length === 0
               ? 'editing'
               : 'saved',
         set billingState(val) {
            this.billingStateInternal = val;
            this.changed();
         },
         get billingState() {
            return this.billingStateInternal;
         },
         changed: function () {
            if (
               this.shippingStateInternal === 'editing' ||
               this.shippingStateInternal === 'selected' ||
               this.billingStateInternal == 'editing' ||
               this.billingStateInternal == 'selected'
            ) {
               jMPT('#completeCheckoutGroup').fadeOut();
               jMPT('#saveProfilesGroup').fadeIn();
            } else {
               jMPT('#completeCheckoutGroup').fadeIn();
               jMPT('#saveProfilesGroup').fadeOut();
            }
            console.log('shipping state: ' + this.shippingStateInternal);
            console.log('billing state: ' + this.billingStateInternal);
         },
         updateStates() {
            let savedShipping = jMPT('#selectedShipping').is(':visible');
            let chooseLocation = jMPT('#setShipping').is(':visible');
            //let chooseExistingShippingProfile = jMPT('#shippingProfileSection').is(':visible');
            let addNewShippingProfile = jMPT('#newShippingProfile').is(':visible');
            let deliveryLocation = jMPT('#deliveryLocation option:selected');
            let locationType = deliveryLocation.first().attr('data-type');

            if (savedShipping) this.shippingStateInternal = 'saved';
            else {
               //shipping has open changes
               if (!locationType) {
                  jMPT('#deliveryLocation').generateError(
                     'Please select a location',
                     true,
                     '#deliveryLocation',
                     false,
                     true,
                  );
               } else {
                  jMPT('#deliveryLocation').resetError();
               }

               if (chooseLocation) {
                  //picking delivery location
                  let pickedLocation = jMPT('#deliveryLocation').val(); //get the selected location
                  if (pickedLocation) {
                     if (jMPT('#' + pickedLocation).data('type') === 'pickup') {
                        this.shippingStateInternal = 'selected';
                        jMPT('#settings').hide(); //custom for foodie
                     } else {
                        jMPT('#settings').hide(); //custom for foodie
                        if (jMPT('.shippingProfile.active').length > 0) {
                           this.shippingStateInternal = 'selected';
                        } else {
                           this.shippingStateInternal = 'editing';
                        }
                     }
                  } else this.shippingStateInternal = 'editing';
               } else if (addNewShippingProfile)
                  //adding a new home delivery address
                  this.shippingStateInternal = 'selected';
            }

            let savedBilling = jMPT('#selectedBilling').is(':visible');
            let chooseExistingBillingProfile = jMPT('#billingProfileSection').is(':visible');
            let addNewBillingProfile = jMPT('#newBillingProfile').is(':visible');

            if (savedBilling) this.billingStateInternal = 'saved';
            else {
               //billing has open changes
               if (chooseExistingBillingProfile) {
                  if (jMPT('.billingProfile.active').length > 0) {
                     this.billingStateInternal = 'selected';
                  } else {
                     let billingProfiles = getSafeAPIValue('mptapi.router.data.checkout.billingProfiles');
                     if (billingProfiles && billingProfiles.length) {
                        let billingBtn = jMPT('[data-billingprofile=' + billingProfiles[0].id + ']');
                        if (billingBtn) {
                           jMPT(billingBtn).addClass('active');
                        }
                     }
                     this.billingStateInternal = 'editing';
                  }
               } else if (addNewBillingProfile) {
                  this.billingStateInternal = 'selected';
               }
            }

            if (
               this.shippingStateInternal === 'editing' ||
               this.shippingStateInternal === 'selected' ||
               this.billingStateInternal == 'editing' ||
               this.billingStateInternal == 'selected'
            ) {
               jMPT('#completeCheckoutGroup').fadeOut();
               jMPT('#saveProfilesGroup').fadeIn();
            } else {
               jMPT('#completeCheckoutGroup').fadeIn();
               jMPT('#saveProfilesGroup').fadeOut();
            }
            console.log('shipping state: ' + this.shippingStateInternal);
            console.log('billing state: ' + this.billingStateInternal);
         },
      };

      let currentYear = parseInt(new Date().getFullYear().toString().substr(2));
      let expirationYearElements = [];
      for (let i = 0; i < currentYear + 30; i++) {
         expirationYearElements.push(jMPT('<option>', { value: currentYear + i, text: currentYear + i }));
      }
      jMPT('#cc-expiration-year').append(expirationYearElements);
      jMPT('#toggleOfferCode').click(function () {
         jMPT('#offerCode div').toggle();
         jMPT(this).children('i').switchToggleClass('fa-chevron-down', 'fa-chevron-up');
      });

      if (jMPT('#deliveryLocation').children().length === 1) {
         jMPT('#deliveryLocation').hide();
      }

      jMPT('#changeBilling').click(function () {
         jMPT('#billingProfileSection').toggle(250);
         jMPT('#selectedBilling').toggle(250);

         if (jMPT('button.billingProfile.active').length == 0 && jMPT('button.billingProfile').length > 0) {
            let defaultProfile = null;
            if (mptapi.router.data.checkout.selectedBilling && mptapi.router.data.checkout.selectedBilling.id)
               defaultProfile = jMPT(
                  'button.billingProfile[data-billingprofile="' + mptapi.router.data.checkout.selectedBilling.id + '"]',
               );

            if (!(defaultProfile && defaultProfile.length > 0)) defaultProfile = jMPT('button.billingProfile:first');

            defaultProfile.click();
         }

         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#cancelChangeBilling').click(function () {
         jMPT('#billingProfileSection').toggle(250);
         jMPT('#selectedBilling').toggle(250);
         //mptapi.router.data.checkout.preferenceStates.billingState = (typeof mptapi.router.data.checkout.selectedShipping === "undefined" || mptapi.router.data.checkout.selectedShipping.length === 0) ? "editing" : "saved";
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#cancelAddBilling').click(function () {
         jMPT('.billingSection').hide();
         jMPT('#selectedBilling').show();
         //mptapi.router.data.checkout.preferenceStates.billingState = (typeof mptapi.router.data.checkout.selectedBilling === "undefined" || mptapi.router.data.checkout.selectedBilling.length === 0) ? "editing" : "saved";
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#cancelAddShipping').click(function () {
         jMPT('.shippingSection').hide();
         jMPT('#setShipping').toggle();
         //mptapi.router.data.checkout.preferenceStates.shippingState = (typeof mptapi.router.data.checkout.selectedShipping === "undefined" || mptapi.router.data.checkout.selectedShipping.length === 0) ? "editing" : "saved";
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#billingProfileSection .billingProfile').click(function () {
         jMPT('#billingProfileSection .billingProfile.active').removeClass('active');
         jMPT(this).addClass('active');
         //profileStateChange();
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('.mpt-subscribe-all').click(function () {
         let req = new CartSubscribeAll();
         req.send().then((ct) => {
            mptapi.cartDropdown.getCart(false, ct);
            mptapi.router.render(customScriptCallback);
         });
      });

      jMPT('#changeShipping').click(function () {
         jMPT('#setShipping').toggle(250);
         jMPT('#selectedShipping').toggle(250);
         /*mptapi.router.data.checkout.preferenceStates.shippingState = "editing";

            let pickedLocation = jMPT('#deliveryLocation').val();
            if(pickedLocation)
			{
				if(jMPT('#' + pickedLocation).data('type') === 'pickup') {
                    mptapi.router.data.checkout.preferenceStates.shippingState = "selected";
                }
			}*/

         if (mptapi.router.data.checkout.selectedShipping && mptapi.router.data.checkout.selectedShipping.length > 0) {
            jMPT('#deliveryLocation').val(mptapi.router.data.checkout.selectedShipping[0].locationId);
            jMPT('#deliveryLocation').change();
         }
         if (
            jMPT('#shippingProfileSection').find('button.shippingProfile.active').length == 0 &&
            jMPT('#shippingProfileSection').find('button.shippingProfile').length > 0
         )
            jMPT('#shippingProfileSection').find('button.shippingProfile')[0].click();
         //profileStateChange();
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#cancelChangeShipping').click(function () {
         jMPT('#setShipping').toggle(250);
         jMPT('#selectedShipping').toggle(250);
         //mptapi.router.data.checkout.preferenceStates.shippingState = (typeof mptapi.router.data.checkout.selectedShipping === "undefined" || mptapi.router.data.checkout.selectedShipping.length === 0) ? "editing" : "saved";
         //profileStateChange();
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#shippingProfileSection .shippingProfile').click(function () {
         jMPT('#shippingProfileSection .shippingProfile.active').removeClass('active');
         jMPT(this).addClass('active');
         //mptapi.router.data.checkout.preferenceStates.shippingState = "selected";
         //profileStateChange();
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#newShippingProfileButton').click(function () {
         jMPT('.shippingSection').hide();
         jMPT('#newShippingProfile').fadeIn();
         //mptapi.router.data.checkout.preferenceStates.shippingState = "selected";
         //profileStateChange();
         setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
      });

      jMPT('#deliveryLocation')
         .change(function () {
            let selected = jMPT(this).children('option:selected');
            let visibleAddress = jMPT('[id$=Address]:not(.billingProfileSection):visible');
            let selectedAddress = jMPT('#' + selected.attr('value') + 'Address');
            visibleAddress.slideUp();
            selectedAddress.slideDown();

            if (selected.attr('data-type') !== 'home-delivery') {
               jMPT('#saveDeliveryLocation').slideDown();
               jMPT('#shippingProfileSection').slideUp();
               jMPT('#sameAddressContainer').attr('checked', false).change().hide();
            } else {
               //this is a home/local delivery
               jMPT('#saveDeliveryLocation').slideUp();
               jMPT('#sameAddressContainer').show();
               jMPT('#shippingProfileSection').slideDown();

               if (
                  jMPT('#shippingProfileSection').find('button.shippingProfile.active').length == 0 &&
                  jMPT('#shippingProfileSection').find('button.shippingProfile').length > 0
               )
                  jMPT('#shippingProfileSection').find('button.shippingProfile')[0].click();
            }

            setTimeout(mptapi.router.data.checkout.preferenceStates.updateStates, 550);
         })
         .change();

      jMPT('#addNewShipping').click(function () {
         let valObj = {
            '#shippingfirstName': {
               blank: {
                  required: false,
                  message: 'Please enter your First Name.',
               },
            },
            '#shippinglastName': {
               blank: {
                  required: false,
                  message: 'Please enter your Last Name.',
               },
            },
            '#shippingaddress': {
               blank: {
                  required: false,
                  message: 'Please enter an Address.',
               },
            },
            '#shippingcity': {
               blank: {
                  required: false,
                  message: 'Please enter a City.',
               },
            },
            '#shippingregion': {
               blank: {
                  required: false,
                  message: 'Please pick a Region.',
               },
            },
            '#shippingzip': {
               blank: {
                  required: false,
                  message: 'Please enter a postal code.',
               },
            },
            '#shippingPhone': {
               blank: {
                  required: false,
                  message: 'Please enter a phone number.',
               },
            },
         };

         let isGuestAcct = getSafeAPIValue('user.isGuestAcct');
         if (isGuestAcct) {
            valObj['#profileAccountEmail'] = {
               blank: {
                  required: false,
                  message: 'Please enter an email address.',
               },
            };
         }

         jMPT.validateFields(valObj).then(() => {
            let firstName = jMPT('#shippingfirstName').val();
            let lastName = jMPT('#shippinglastName').val();
            let address = jMPT('#shippingaddress').val();
            let address2 = jMPT('#shippingaddress2').val();
            let city = jMPT('#shippingcity').val();
            let region = jMPT('#shippingregion').val();
            let postal = jMPT('#shippingzip').val();
            let country = jMPT('#shippingcountry').val();
            let phone = jMPT('#shippingPhone').val();
            let instructions = jMPT('#deliveryInstructions').val();
            let guestEmail = jMPT('#profileAccountEmail').val();

            let req = new AddShippingProfile({
               firstName: firstName,
               lastName: lastName,
               address: address,
               address2: address2,
               city: city,
               region: region,
               postal: postal,
               country: country,
               phone: phone,
               instructions: instructions,
               updateEmail: guestEmail,
               setAsDefault: true,
            });
            req.send().then(() => {
               mptapi.router.render(customScriptCallback);
            });
         });
      });

      jMPT('#saveDeliveryLocation, #saveShipping').click(function () {
         let deliveryLocation = jMPT('#deliveryLocation option:selected');
         let newLocationId = deliveryLocation.first().attr('id');
         let locationType = deliveryLocation.first().attr('data-type');
         let currentLocationId = null;
         let currentLocation = getSafeAPIValue('router.data.checkout.selectedShipping');
         if (currentLocation && currentLocation.length > 0) {
            currentLocation = currentLocation[0];
            currentLocationId = currentLocation.locationId;
         }

         let validationOptions = {};

         if (!locationType) {
            jMPT('#deliveryLocation').generateError('Please select a location', true, '#deliveryLocation', false, true);
         } else if (locationType === 'pickup') {
            let deliveryLocationId = deliveryLocation.val();

            let payload = {
               shippingLocationId: deliveryLocationId,
               shippingFirstName: jMPT('#' + deliveryLocationId + 'firstName').val(),
               shippingLastName: jMPT('#' + deliveryLocationId + 'lastName').val(),
               shippingPhone: jMPT('#' + deliveryLocationId + 'phone').val(),
               updatePresets: true,
            };
            try {
               let acctEmail = jMPT('#pickupAccountEmail').val();
               if (acctEmail) payload.updateEmail = acctEmail;
            } catch (err) {
               console.error(err);
            }

            let req = new UpdateDelivery(payload);

            validationOptions['#' + deliveryLocationId + 'firstName'] = {
               blank: {
                  required: false,
                  message: 'Please enter a first name.',
               },
            };
            validationOptions['#' + deliveryLocationId + 'lastName'] = {
               blank: {
                  required: false,
                  message: 'Please enter a last name.',
               },
            };
            validationOptions['#' + deliveryLocationId + 'phone'] = {
               blank: {
                  required: false,
                  message: 'Please enter a phone number in case we need to contact you.',
               },
            };
            validationOptions['#mpt-disclaimer-checkbox'] = {
               checked: {
                  required: true,
                  errorElem: '.mpt-home-deliver-disclaimer',
                  message: 'Please check the box to acknowledge.',
               },
            };
            jMPT.validateFields(validationOptions).then(() => {
               req.send().then(() => {
                  mptapi.savedLocation = true;
                  mptapi.router.render(customScriptCallback);
               });
            });
         } else {
            let selectedProfile = jMPT('.shippingProfile.active');
            let profileId = selectedProfile.attr('data-shippingprofileid');
            let req = new SetShippingProfile({
               shippingProfileId: profileId,
               shippingLocationId: newLocationId,
               updatePresets: true,
            });

            validationOptions['#mpt-disclaimer-checkbox'] = {
               checked: {
                  required: true,
                  errorElem: '.mpt-home-deliver-disclaimer',
                  message: 'Please check the box to acknowledge.',
               },
            };
            jMPT.validateFields(validationOptions).then(() => {
               req.send().then(() => {
                  mptapi.savedLocation = true;
                  mptapi.router.render(customScriptCallback);
               });
            });
         }
      });

      jMPT('.mpt-phone-number').on('change', function () {
         let $thisVal = jMPT(this).val();
         if ($thisVal) {
            $thisVal = $thisVal.replace(/\D/g, '');
            jMPT(this).val($thisVal);
            if ($thisVal.length < 10 || $thisVal.length > 11) {
               jMPT(this).css('border-color', 'red');
            } else jMPT(this).css('border-color', '');
         }
      });

      jMPT('#saveBilling').click(function () {
         let billingProfile = jMPT('.billingProfile.active');
         if (billingProfile.length > 0) {
            let profileId = billingProfile.data('billingprofile');
            let req = new SetBillingProfile(profileId);
            req.send().then(() => {
               mptapi.router.render(customScriptCallback);
            });
         } else {
            mptapi.router.data.checkout.billingState = 'selected';
         }
      });

      jMPT('#addNewBilling').click(function () {
         saveNewBillingProfile();
      });
      /*let profileType = jMPT('#newProfileType').data('newprofiletype');

            if (profileType === 'ach') {
                let payload = {};
                MPTRequest.encryptText(jMPT('#add-account-number').val(), mptapi.router.data.padKey).then((acctToken) => {
                    jMPT('#newBillingAddress input:not([type=hidden]), #newBillingAddress select').each(function (i, e) {
                        payload[jMPT(e).data("fieldname")] = jMPT(e).val();
                    });

                    payload.acctToken = acctToken;
                    payload.routing = jMPT('#add-routing-number').val();
                    payload.firstName = jMPT('#billingfirstName').val();
                    payload.lastName = jMPT('#billinglastName').val();
                    payload.default = true;
                    payload.acctType = "ach";

                    let req = new AddBillingProfile(payload);
                    req.send().then(() => {
                        jMPT.createNotification("Success!", "Added billing profile", "success", "fa fa-plus", 3000);
                        mptapi.router.render();
                    });
                }).catch(err => {
                    jMPT.createNotification("Error!", err, "danger");
                });
            }
            else {
                let payload = {};
                MPTRequest.encryptText(jMPT('#cc-number').val(), mptapi.router.data.padKey).then(cc => {
//                delete mptapi.router.data.padKey;
                    jMPT('#newBillingAddress input:not([type=hidden]), #newBillingAddress select').each(function (i, e) {
                        payload[jMPT(e).data("fieldname")] = jMPT(e).val();
                    });
                    //Add Payment info
                    payload.ccToken = cc;
                    payload.ccExp = jMPT('#cc-expiration-month').val() + jMPT('#cc-expiration-year').val();
                    payload.ccCvv = jMPT('#cc-cvv').val();
                    payload.cardholderFirst = jMPT('#billingfirstName').val();
                    payload.cardholderLast = jMPT('#billinglastName').val();
                    payload.default = true;
                    payload.acctType = "credit";

                    let req = new AddBillingProfile(payload);
                    req.send().then(() => {
                        jMPT.createNotification("Success!", "Added billing profile", "success", "fa fa-plus", 3000);
                        mptapi.router.render();
                    });
                });
            }*/
      //});

      function offerHandler() {
         jMPT('#applyOfferCode').attr('disabled', true);
         let codeInput = jMPT('#offerCodeInput');
         let code = codeInput.val();

         if (code.trim() !== '') {
            let req = new AddOfferCode(code);
            req.send()
               .then((x) => {
                  codeInput.addClass('is-valid');
                  console.log(x);
                  mptapi.router.render(customScriptCallback);
               })
               .catch((err) => {
                  jMPT('#applyOfferCode').attr('disabled', false);
                  jMPT('#applyOfferCode').one('click', offerHandler);
                  if (err.hasOwnProperty('error')) {
                     codeInput.addClass('is-invalid');
                     codeInput.generateError(err[0].errorMessage);
                  }
               });
         } else {
            jMPT('#applyOfferCode').attr('disabled', false);
            jMPT('#applyOfferCode').one('click', offerHandler);
            codeInput.removeClass('is-valid').addClass('is-invalid');
         }
      }

      jMPT('#applyOfferCode').one('click', offerHandler);

      jMPT('.remove-offer-code').click(function () {
         let code = jMPT(this).data('offerCode');

         let req = new RemoveOfferCode(code);
         req.send().then((x) => {
            console.log(x);
            mptapi.router.render(customScriptCallback);
         });
      });
      jMPT('#offerCodeInput').keyup(function (e) {
         if (e.key === 'Enter') {
            jMPT('#applyOfferCode').click();
         } else {
            if (jMPT(this).val().trim() === '') {
               jMPT(this).removeClass('is-valid');
               jMPT(this).addClass('is-invalid');
            } else {
               jMPT('#offerCodeInput').removeClass('is-invalid');
            }
         }
      });

      jMPT('#newBillingProfileButton').click(function () {
         jMPT('.billingSection').hide();
         jMPT('#newBillingProfile').fadeIn();
         setTimeout(() => {
            mptapi.router.data.checkout.preferenceStates.updateStates();
         }, 550);
         //profileStateChange();
         //mptapi.router.data.checkout.billingState = "selected";
      });

      new AwaitProperty('crs', window, function () {
         window.crs.init();
         jMPT('.crs-country').val(jMPT('#companyCountry').val()).change().parent().hide();
      });

      jMPT('#same-address').change(function () {
         if (jMPT(this).is(':checked')) {
            //jMPT('#newBillingAddress').slideUp();
            let address = jMPT('#selectedAddress').data();

            jMPT('#billingfirstName').val(address.firstName);
            jMPT('#billinglastName').val(address.lastName);
            jMPT('#billingaddress').val(address.address);
            jMPT('#billingaddress2').val(address.address2);
            jMPT('#billingcity').val(address.city);
            jMPT('#billingcountry').val(jMPT('#companyCountry').val()).change();
            jMPT('#billingregion').val(address.region).change();
            jMPT('#billingzip').val(address.postal);
         } else {
            jMPT('#billingfirstName').val('');
            jMPT('#billinglastName').val('');
            jMPT('#billingaddress').val('');
            jMPT('#billingaddress2').val('');
            jMPT('#billingcity').val('');
            jMPT('#billingcountry').val(jMPT('#companyCountry').val()).change();
            jMPT('#billingregion').val('').change();
            jMPT('#billingzip').val('');
            jMPT('#newBillingAddress').slideDown();
         }
      });

      jMPT('.save-profiles-review').click(function () {
         let saveButton = jMPT(this);
         saveButton.resetError();
         mptapi.router.data.checkout.preferenceStates.updateStates();

         let billingState = mptapi.router.data.checkout.preferenceStates.billingState;
         let shippingState = mptapi.router.data.checkout.preferenceStates.shippingState;
         console.log('shippingState: ' + shippingState);
         console.log('billingState: ' + billingState);

         if (shippingState === 'saved') {
            //do not need to update delivery info
            checkBilling(function () {
               jMPT('#completeCheckoutGroup').fadeIn();
               jMPT('#saveProfilesGroup').fadeOut();
            }, saveBilling);
         } else if (shippingState === 'editing') {
            //cannot update delivery info, selection step is not complete
            saveButton.generateError('Please finish your delivery changes.', false, null, true);
         } //attempt to check and update delivery info
         else {
            checkBilling(saveShipping, function () {
               saveShipping(saveBilling);
            });
         }

         /*if(mptapi.router.data.checkout.preferenceStates.shippingState === "selected") //delivery location has been picked
			{
				if(mptapi.router.data.checkout.preferenceStates.billingState === "selected") { //billing profile has been picked
                    saveShipping(saveBilling);//save shipping, then billing
				}
				else{ //billing is either saved or invalid, save just shipping
					if(billingState !== 'saved')
                    	saveButton.generateError('Please finish your billing changes.', false, null, true);

                    saveShipping();
				}
			}
			else if(mptapi.router.data.checkout.preferenceStates.billingState === "selected") //delivery location is either saved or invalid, save just billing and alert
            {
            	if(shippingState !== 'saved')
                	saveButton.generateError('Please finish your shipping changes.', false, null, true);

                saveBilling();
            }*/
      });

      // Checkout Button
      jMPT('.complete-checkout').click(function () {
         let completeButton = jMPT(this);
         completeButton.waitButton('Processing...');

         let total = 0;

         try {
            total = Math.max(mptapi.cart.totals.filter((x) => x.name.includes('Total')).map((x) => x.amount));
         } catch (err) {
            total = 0;
         }

         let selectedShipping = mptapi.router.data.checkout.selectedShipping.firstOrDefault();
         let selectedSubscriptionId = null;

         try {
            selectedSubscriptionId = jMPT(this).data('subscriptionid');

            if (typeof selectedSubscriptionId === 'undefined') selectedSubscriptionId = null;
         } catch (e) {
            selectedSubscriptionId = null;
         }

         if (selectedShipping != null) {
            if (
               mptapi.router.data.checkout.selectedShipping.filter(
                  (x) => x.location && x.location.type === 'pickup' && (!x.address.firstName || !x.address.lastName),
               ).length > 0
            ) {
               jMPT('#changeShipping').generateError(
                  'Please select a first and last name for pickup.',
                  true,
                  '#setShipping .card-body',
                  true,
               );
               if (jMPT('#changeShipping').is(':visible')) {
                  jMPT('#changeShipping').click(); // Switch to edit location
                  jMPT('#saveShipping').click(); // Hit save to show validation errors
                  jMPT('html, body').animate({ scrollTop: jMPT('#shippingSection')[0].getBoundingClientRect().height });
               }

               return;
            }
         } else {
         }
         if (typeof mptapi.router.data.checkout.selectedBilling === 'undefined') {
            jMPT('#billingSection .card').generateError('Please select and save a billing profile.');
            jMPT('#saveBilling').css({
               transition: 'all 1s',
               transform: 'scale(1.3)',
            });
            jMPT('html, body').animate({ scrollTop: jMPT('#billingSection')[0].getBoundingClientRect().height - 90 });
            return;
         }

         let trackedCartObj = getSafeAPIValue('mptapi.router.data.checkout.cart') || null;
         let trackedShippingObj = getSafeAPIValue('mptapi.router.data.checkout.selectedShipping[0].address') || null;
         let trackedBillingObj = getSafeAPIValue('mptapi.router.data.checkout.selectedBilling') || null;

         let trackingData = {
            cartObj: JSON.stringify(trackedCartObj),
            selectedShippingObj: JSON.stringify({
               firstName: trackedShippingObj.firstName,
               lastName: trackedShippingObj.lastName,
               address: trackedShippingObj.address,
               address2: trackedShippingObj.address2,
               city: trackedShippingObj.city,
               region: trackedShippingObj.region,
               postal: trackedShippingObj.postal,
               phone: trackedShippingObj.phone,
            }),
            selectedBillingObj: JSON.stringify({
               firstName: trackedBillingObj.firstName,
               lastName: trackedBillingObj.lastName,
               address: trackedBillingObj.address,
               address2: trackedBillingObj.address2,
               city: trackedBillingObj.city,
               region: trackedBillingObj.region,
               postal: trackedBillingObj.postal,
            }),
         };

         if (mptapi.companyInfo.createSubAccountIdentifiers) {
            let shippingProfileId = mptapi.cart.deliveries[0].shippingProfileId || null;

            let newSettings = [];
            jMPT('.account-setting-free-form').each(function () {
               let $this = jMPT(this);
               let newSetting = {};
               newSetting.id = $this.attr('id');
               newSetting.options = [];
               newSetting.options.push($this.val());
               newSettings.push(newSetting);
            });
            jMPT('.account-setting-drop-down').each(function () {
               let $this = jMPT(this);
               let newSetting = {};
               newSetting.id = $this.attr('id');
               newSetting.options = [];
               newSetting.options.push($this.val());
               newSettings.push(newSetting);
            });
            jMPT('.account-setting-multiselect').each(function () {
               let $this = jMPT(this);
               let newSetting = {};
               newSetting.id = $this.attr('id');
               newSetting.options = [];
               jMPT('.account-setting-checkbox[data-settingid="' + newSetting.id + '"]:checked').each(function () {
                  let $option = jMPT(this);
                  newSetting.options.push($option.val());
               });
               newSettings.push(newSetting);
            });

            let ASReq = new UpdateAllAccountSettings(newSettings, shippingProfileId);
            ASReq.send().then((asr) => {
               //wait for account settings to be updated prior to checkout
               let req = new Checkout(total, selectedSubscriptionId);
               req.send()
                  .then((x) => checkoutCallback(x))
                  .catch(function (err) {
                     console.warn('CHECKOUT ERROR:', err);
                     completeButton.doneButton('Complete Order');
                  });
            });
         } else {
            //regular checkout
            if (mptapi.companyInfo?.finixObject?.mid) {
               window.Finix.Auth(
                 FINIX_API.finixEnv,
                 mptapi.companyInfo.finixObject.mid,
                 (sessionKey) => {
                    let req = new Checkout(total, selectedSubscriptionId, sessionKey);
                    req.send()
                      .then((x) => checkoutCallback(x))
                      .catch(function (err) {
                         console.warn('CHECKOUT ERROR:', err);
                         completeButton.doneButton('Complete Order');
                      });
                 },
               );
            } else {
               let req = new Checkout(total, selectedSubscriptionId);
               req.send()
                 .then((x) => checkoutCallback(x))
                 .catch(function (err) {
                    console.warn('CHECKOUT ERROR:', err);
                    completeButton.doneButton('Complete Order');
                 });
            }
         }

         function checkoutCallback(x) {
            try {
               mptapi.track('complete-checkout', trackingData);
            } catch (errMessage) {
               console.error(errMessage);
            }

            console.warn('CHECKOUT CALLBACK:', x);
            let subUpdateSuccess = selectedSubscriptionId && x.hasOwnProperty('subscriptionConfirmation');
            if (subUpdateSuccess) {
               if (x.cart.isEmpty) {
                  let orderModel = {
                     success: x.success,
                     cart: x.subscriptionConfirmation,
                     subConfirmation: true,
                     inModal: false,
                  };
                  mptapi.router.changeHash('#confirmation', { prevOrder: orderModel });
               } else {
                  let orderModel = {
                     success: x.success,
                     cart: x.subscriptionConfirmation,
                     subConfirmation: true,
                     inModal: true,
                  };

                  let t = Handlebars.compile(jMPT('#orderConfirmation').html());
                  jMPT('#activeSubscriptionModal > .mpt-modal-body').fadeOut(null, function () {
                     jMPT('#activeSubscriptionModal > .mpt-modal-body').html(t(orderModel));
                     jMPT('#activeSubscriptionModal > .mpt-modal-header > .mpt-modal-title').text(
                        'SUBSCRIPTION UPDATED',
                     );
                     jMPT('#activeSubscriptionModal > .mpt-modal-footer').html('');
                     jMPT('#activeSubscriptionModal > .mpt-modal-body').fadeIn();
                  });
               }
            } else mptapi.router.changeHash('#confirmation', { prevOrder: x });
         }
      });

      jMPT('.select-subscription').click(function () {
         MPTUI.generateModal('#activeSubscriptionModal');
      });

      jMPT('#activeSubscriptionOptions a').click(function () {
         let curVal = jMPT(this).attr('data-active');
         if (curVal === 'true') {
            jMPT(this).removeClass('border-right-selected').attr('data-active', false);
            jMPT(this).children().eq(1).slideUp();
         } else {
            jMPT('#deliveryOptions a')
               .not(this)
               .removeClass('border-right-selected')
               .attr('data-active', false)
               .each(function () {
                  jMPT(this).children().eq(1).slideUp();
               });
            jMPT(this).addClass('border-right-selected').attr('data-active', true);
            jMPT(this)
               .children()
               .eq(1)
               .slideDown({
                  start: function () {
                     jMPT(this).css({
                        display: 'block',
                     });
                  },
               });
         }
      });

      jMPT('.sign-complete').click(function () {
         let total = jMPT('.total')
            .toArray()
            .map((x) => jMPT(x).val())
            .sum();
         let selectedShipping = mptapi.router.data.checkout.selectedShipping.firstOrDefault();
         if (selectedShipping != null) {
            if (
               mptapi.router.data.checkout.selectedShipping.filter(
                  (x) => x.location && x.location.type === 'pickup' && (!x.address.firstName || !x.address.lastName),
               ).length > 0
            ) {
               jMPT('#changeShipping').generateError(
                  'Please select a first and last name for pickup.',
                  true,
                  '#setShipping .card-body',
                  true,
               );
               if (jMPT('#changeShipping').is(':visible')) {
                  jMPT('#changeShipping').click(); // Switch to edit location
                  jMPT('#saveShipping').click(); // Hit save to show validation errors
                  jMPT('html, body').animate({ scrollTop: jMPT('#shippingSection')[0].getBoundingClientRect().height });
               }
               return;
            }
         }
         if (typeof mptapi.router.data.checkout.selectedBilling === 'undefined') {
            jMPT('#billingSection .card').generateError('Please select and save a billing profile.');
            jMPT('#saveBilling').css({
               transition: 'all 1s',
               transform: 'scale(1.3)',
            });
            jMPT('html, body').animate({ scrollTop: jMPT('#billingSection')[0].getBoundingClientRect().height - 90 });

            return;
         }

         mptapi.router.redirect('/agreement', '#sign');
      });

      jMPT('.edit-shipping-profiles').click(function () {
         mptapi.router.redirect('user', '#addresses', {
            'back-button': {
               title: 'Back to Checkout',
               page: 'checkout',
               action: '#review',
            },
         });
      });

      jMPT('.tip-input').keyup(function () {
         jMPT('.tip-status').remove();
         let input = this;
         let value = jMPT(this).val();
         let validCurrency = /^([\d]+\.\d+)$|^(\d+)$/g;
         if (validCurrency.test(value)) {
            clearTimeout(tipTimeout);
            jMPT(this)
               .parent()
               .append(jMPT('<i>', { class: 'fa fa-spin fa-spinner tip-status' }));
            tipTimeout = setTimeout(function () {
               //Update just the tip
               let req = new UpdateTip(parseFloat(value));
               req.send().then(() => {
                  jMPT('.tip-status').remove();
                  jMPT(input)
                     .parent()
                     .append(jMPT('<i>', { class: 'fa text-success fa-check tip-status' }));
                  setTimeout(function () {
                     mptapi.router.render(customScriptCallback);
                  }, 500);
               });
            }, 1000);
         } else if (value === '' || value == null) {
            let req = new UpdateTip(0);
            req.send().then(() => {
               jMPT('.tip-status').remove();
               jMPT(input)
                  .parent()
                  .append(jMPT('<i>', { class: 'fa text-success fa-check tip-status' }));
               setTimeout(function () {
                  mptapi.router.render(customScriptCallback);
               }, 500);
            });
         } else {
            clearTimeout(tipTimeout);
            jMPT(this)
               .parent()
               .append(jMPT('<i>', { class: 'fa fa-close tip-status' }));
            jMPT(this).generateError('Invalid Tip Input.', true);
         }
      });

      jMPT('.check-out-view-more').click(function ($event) {
         const featuredProducts = getSafeAPIValue('mptapi.router.data.checkout.featuredProducts');
         const product = featuredProducts.find((featureProduct) => featureProduct.id === $event.currentTarget?.dataset?.productid);

         let productCatString = null;
         if (product.categories && product.categories.length > 0) {
            productCatString = JSON.stringify(product.categories);
         } else {
            productCatString = JSON.stringify([]);
         }
         try {
            mptapi.track('product-view', {
               productId: product.id,
               productName: product.name,
               price: product.activePrice.toString(),
               categories: productCatString,
               imageURL: product.activeImageUrl,
               productURL: `${window.location.origin}/order/?viewProduct=${product.id}`,
            });
         } catch (errMessage) {
            console.error(errMessage);
         }

         let quickAdd =
            $event &&
            $event.target &&
            ($event.target.classList.contains('quantityUp') ||
               $event.target.classList.contains('quantityDown') ||
               $event.target.classList.contains('ff-order-cart-qty'));

         if (!quickAdd) {
            try {
               mptapi.track('product-view', {
                  productId: product.id,
                  productName: product.name,
                  price: product.activePrice.toString(),
                  categories: productCatString,
                  imageURL: product.activeImageUrl,
                  productURL: `${window.location.origin}/order/?viewProduct=${product.id}`,
               });
            } catch (errMessage) {
               console.error(errMessage);
            }

            //try { mptapi.track('page-view', {productId: product.id}); } catch(errMessage){ console.error(errMessage); }

            mptapi.orderVues.mptProductPage.vueApp.loadProduct(product);

            jMPT('html').css('overflow-y', 'hidden');
            jMPT('body').addClass('mpt-no-scroll');

            jMPT('FFCustomProductDetail .mpt-back-to-store-container').css({
               opacity: 0,
               position: 'fixed',
            });

            jMPT('FFCustomProductDetail').css({
               position: 'fixed',
               top: 0,
               left: 0,
               width: '100vw',
               overflowY: 'scroll',
               zIndex: 9999,
            });

            setTimeout(function () {
               jMPT('FFCustomProductDetail .mpt-back-to-store-container').animate({ opacity: 1 }, 300);
            }, 300);

            //setTimeout(() => {jMPT(document).scrollTop(jMPT('mptproductpage .mpt-btn-link').offset().top);}, 300);

            mptapi.orderVues.mptProductPage.model.reqOptions = Object.assign(
               mptapi.orderVues.mptProductPage.model.reqOptions || {},
               { viewProduct: product.id },
            );

            jMPT(window).on('popstate', function () {
               jMPT('FFCustomProductDetail').css({ left: '-150vw', top: '0' }).removeClass('visible');
               jMPT('html').css('overflow-y', 'auto');
               jMPT('body').removeClass('mpt-no-scroll');
               jMPT('FFCustomProductDetail .mpt-back-to-store-container').css({
                  opacity: 0,
                  position: 'relative',
               });

               jMPT(window).off('popstate');
               thisApp.model.reqOptions.viewProduct = null;
            });
         }
      });

      if (!mptapi.companyInfo.createSubAccountIdentifiers) {
         jMPT('.account-setting-free-form').keyup(function () {
            let $this = jMPT(this);
            clearTimeout(settingTimeout);
            settingTimeout = setTimeout(function () {
               $this.prop('disabled', true);
               jMPT('#settings [data-id=' + $this.attr('id') + '] .saved').hide();
               jMPT('#settings [data-id=' + $this.attr('id') + '] .saving').show();
               let req = new AddUpdateAccountSetting($this.prop('id'), [$this.val()]);
               req.send().then(() => {
                  $this.prop('disabled', false);
                  jMPT('#settings [data-id=' + $this.attr('id') + '] .saving').hide();
                  jMPT('#settings [data-id=' + $this.attr('id') + '] .saved').show();
               });
            }, 1750);
         });

         jMPT('.account-setting-drop-down').change(function () {
            let $this = jMPT(this);
            $this.prop('disabled', true);
            jMPT('#settings [data-id=' + $this.attr('id') + '] .saved').hide();
            jMPT('#settings [data-id=' + $this.attr('id') + '] .saving').show();
            let req = new AddUpdateAccountSetting($this.prop('id'), [$this.val()]);
            req.send().then(() => {
               $this.prop('disabled', false);
               jMPT('#settings [data-id=' + $this.attr('id') + '] .saving').hide();
               jMPT('#settings [data-id=' + $this.attr('id') + '] .saved').show();
            });
         });

         jMPT('.account-setting-multiselect').keyup(function () {
            let $this = jMPT(this);
            $this.prop('disabled', true);
            jMPT('#settings [data-id=' + $this.attr('id') + '] .saved').hide();
            jMPT('#settings [data-id=' + $this.attr('id') + '] .saving').show();

            let newSetting = {};
            newSetting.id = $this.attr('id');
            newSetting.options = [];
            jMPT('.account-setting-checkbox[data-settingid="' + newSetting.id + '"]:checked').each(function () {
               let $option = jMPT(this);
               newSetting.options.push($option.val());
            });

            let req = new AddUpdateAccountSetting(newSetting.id, newSetting.options);
            req.send().then(() => {
               $this.prop('disabled', false);
               jMPT('#settings [data-id=' + $this.attr('id') + '] .saving').hide();
               jMPT('#settings [data-id=' + $this.attr('id') + '] .saved').show();
            });
         });
      }

      //TODO: drop-down and multiselect

      try {
         jQuery('[data-toggle="popover"]').popover();
      } catch (err) {
         console.error(err);
      }

      let settingTimeout = null;
      let tipTimeout = null;

      /*CUSTOM FOR FOODIE*/
      try {
         let clickChangeShipping = false;
         let selectedLocationType = getSafeAPIValue('mptapi.router.data.checkout.selectedShipping[0].location.type');

         if (selectedLocationType) {
            if (!mptapi.savedLocation) {
               jMPT('#setShipping').toggle();
               jMPT('#selectedShipping').toggle();
            } else {
               if (selectedLocationType === 'pickup') {
                  //custom for foodie
                  jMPT('.mpt-account-settings').hide();
                  jMPT('#settings').hide();
               } else {
                  jMPT('.mpt-account-settings').show();
                  jMPT('#settings').show();
               }

               let selectedLocationAddressObj = getSafeAPIValue(
                  'mptapi.router.data.checkout.selectedShipping[0].address',
               );
               if (selectedLocationAddressObj) {
                  let selectedLocationAddressPopulated =
                     selectedLocationAddressObj.address &&
                     selectedLocationAddressObj.city &&
                     selectedLocationAddressObj.postal;
                  let selectedLocationNamePopulated =
                     selectedLocationAddressObj.firstName && selectedLocationAddressObj.lastName;

                  clickChangeShipping =
                     (selectedLocationType === 'home-delivery' &&
                        (!selectedLocationAddressPopulated || !selectedLocationNamePopulated)) ||
                     (selectedLocationType === 'pickup' && !selectedLocationAddressPopulated) ||
                     (selectedLocationType === 'pickup' &&
                        (!selectedLocationAddressObj.firstName || !selectedLocationAddressObj.lastName));
               } else clickChangeShipping = true;
            }
         }

         if (clickChangeShipping) {
            setTimeout(function () {
               jMPT('#changeShipping').click();
            }, 250);
         }
      } catch (cErr) {
         console.error(cErr);
      }

      MPTUI.globals();

      function saveNewShippingProfile(callback) {
         let valObj = {
            '#shippingfirstName': {
               blank: {
                  required: false,
                  message: 'Please enter your First Name.',
               },
            },
            '#shippinglastName': {
               blank: {
                  required: false,
                  message: 'Please enter your Last Name.',
               },
            },
            '#shippingaddress': {
               blank: {
                  required: false,
                  message: 'Please enter an Address.',
               },
            },
            '#shippingcity': {
               blank: {
                  required: false,
                  message: 'Please enter a City.',
               },
            },
            '#shippingregion': {
               blank: {
                  required: false,
                  message: 'Please pick a Region.',
               },
            },
            '#shippingzip': {
               blank: {
                  required: false,
                  message: 'Please enter a postal code.',
               },
            },
            '#shippingPhone': {
               blank: {
                  required: false,
                  message: 'Please enter a phone number.',
               },
            },
         };

         let isGuestAcct = getSafeAPIValue('user.isGuestAcct');
         if (isGuestAcct) {
            valObj['#profileAccountEmail'] = {
               blank: {
                  required: false,
                  message: 'Please enter an email address.',
               },
            };
         }

         jMPT.validateFields(valObj).then(() => {
            let firstName = jMPT('#shippingfirstName').val();
            let lastName = jMPT('#shippinglastName').val();
            let address = jMPT('#shippingaddress').val();
            let address2 = jMPT('#shippingaddress2').val();
            let city = jMPT('#shippingcity').val();
            let region = jMPT('#shippingregion').val();
            let postal = jMPT('#shippingzip').val();
            let country = jMPT('#shippingcountry').val();
            let phone = jMPT('#shippingPhone').val();
            let instructions = jMPT('#deliveryInstructions').val();
            let guestEmail = jMPT('#profileAccountEmail').val();

            let req = new AddShippingProfile({
               firstName: firstName,
               lastName: lastName,
               address: address,
               address2: address2,
               city: city,
               region: region,
               postal: postal,
               country: country,
               phone: phone,
               instructions: instructions,
               guestEmail: guestEmail,
               setAsDefault: true,
            });
            req.send().then(() => {
               if (typeof callback === 'function') {
                  callback();
               } else {
                  mptapi.router.render(customScriptCallback);
               }
            });
         });
      }

      function saveShipping(callback) {
         let deliveryLocation = jMPT('#deliveryLocation option:selected');
         let deliveryLocationId = deliveryLocation.val();
         let validationOptions = {};

         if (deliveryLocation.first().attr('data-type') === 'pickup' && jMPT('#setShipping').is(':visible')) {
            let payload = {
               shippingLocationId: deliveryLocationId,
               shippingFirstName: jMPT('#' + deliveryLocationId + 'firstName').val(),
               shippingLastName: jMPT('#' + deliveryLocationId + 'lastName').val(),
               shippingPhone: jMPT('#' + deliveryLocationId + 'phone').val(),
               updatePresets: true,
            };

            try {
               let acctEmail = jMPT('#pickupAccountEmail').val();
               if (acctEmail) payload.updateEmail = acctEmail;
            } catch (err) {
               console.error(err);
            }

            let req = new UpdateDelivery(payload);

            validationOptions['#' + deliveryLocationId + 'firstName'] = {
               blank: {
                  required: false,
                  message: 'Please enter a first name.',
               },
            };
            validationOptions['#' + deliveryLocationId + 'lastName'] = {
               blank: {
                  required: false,
                  message: 'Please enter a last name.',
               },
            };
            validationOptions['#' + deliveryLocationId + 'phone'] = {
               blank: {
                  required: false,
                  message: 'Please enter a phone number in case we need to contact you.',
               },
            };
            validationOptions['#mpt-disclaimer-checkbox'] = {
               checked: {
                  required: true,
                  errorElem: '.mpt-home-deliver-disclaimer',
                  message: 'Please check the box to acknowledge.',
               },
            };
            jMPT
               .validateFields(validationOptions)
               .then(() => {
                  req.send().then(() => {
                     mptapi.savedLocation = true;
                     if (typeof callback === 'function') {
                        callback();
                     } else mptapi.router.render(customScriptCallback);
                  });
               })
               .catch(() => {
                  let saveButton = jMPT('.save-profiles-review');
                  if (saveButton.is(':visible')) {
                     saveButton.generateError('There are some problems with your delivery info.', false, null, true);
                  }
               });
         } else if (jMPT('.shippingProfile.active').length > 0 && jMPT('#shippingProfileSection').is(':visible')) {
            let selectedProfile = jMPT('.shippingProfile.active');
            let profileId = selectedProfile.attr('data-shippingprofileid');
            let req = new SetShippingProfile({
               shippingLocationId: deliveryLocationId,
               shippingProfileId: profileId,
               updatePresets: true,
            });
            validationOptions['#mpt-disclaimer-checkbox'] = {
               checked: {
                  required: true,
                  errorElem: '.mpt-home-deliver-disclaimer',
                  message: 'Please check the box to acknowledge.',
               },
            };
            jMPT
               .validateFields(validationOptions)
               .then(() => {
                  req.send().then(() => {
                     mptapi.savedLocation = true;
                     if (typeof callback === 'function') {
                        callback();
                     } else mptapi.router.render(customScriptCallback);
                  });
               })
               .catch(() => {
                  let saveButton = jMPT('.save-profiles-review');
                  if (saveButton.is(':visible')) {
                     saveButton.generateError('There are some problems with your delivery info.', false, null, true);
                  }
               });
         } else if (jMPT('#newShippingProfile').is(':visible')) {
            saveNewShippingProfile(callback);
         } else if (
            typeof mptapi.router.data.checkout.selectedShipping === 'undefined' ||
            mptapi.router.data.checkout.selectedShipping.length === 0
         ) {
            jMPT('#shippingSection .card').generateError('Please select and save a shipping option.');
            jMPT('html, body').animate({ scrollTop: jMPT('#shippingSection')[0].getBoundingClientRect().height - 90 });
         } else if (typeof callback === 'function') {
            callback();
         }
      }

      function checkBilling(savedCallback, selectedCallback) {
         let billingState = mptapi.router.data.checkout.preferenceStates.billingState;
         let saveButton = jMPT('.save-profiles-review');

         if (billingState === 'saved')
            //do not need to update billing info
            savedCallback(); //profiles are already saved, execute callback
         else if (billingState === 'editing')
            //selection step not complete
            saveButton.generateError('Please finish your billing changes.', false, null, true);
         //attempt to check and save billing
         else selectedCallback();
      }

      function saveBilling(callback) {
         if (jMPT('#billingProfileSection').is(':visible') && jMPT('.billingProfile.active').length > 0) {
            let billingProfile = jMPT('.billingProfile.active');
            if (billingProfile.length > 0) {
               let profileId = billingProfile.data('billingprofile');
               let req = new SetBillingProfile(profileId);
               req.send().then(() => {
                  if (typeof callback === 'function') {
                     callback();
                  } else mptapi.router.render(customScriptCallback);
               });
            }
         } else if (jMPT('#newBillingProfile').is(':visible')) {
            saveNewBillingProfile(callback);
         } else if (typeof callback === 'function') {
            callback();
         }
      }

      function saveNewBillingProfile(callback) {
         let profileType = jMPT('#newProfileType').data('newprofiletype');

         if (profileType === 'ach') {
            let payload = {};
            MPTRequest.encryptText(jMPT('#add-account-number').val(), mptapi.router.data.padKey)
               .then((acctToken) => {
                  jMPT('#newBillingAddress input:not([type=hidden]), #newBillingAddress select').each(function (i, e) {
                     payload[jMPT(e).data('fieldname')] = jMPT(e).val();
                  });

                  payload.acctToken = acctToken;
                  payload.routing = jMPT('#add-routing-number').val();
                  payload.firstName = jMPT('#billingfirstName').val();
                  payload.lastName = jMPT('#billinglastName').val();
                  payload.default = true;
                  payload.acctType = 'ach';
                  payload.onCheckout = true;

                  let req = new AddBillingProfile(payload);
                  req.send().then(() => {
                     jMPT.createNotification('Success!', 'Added billing profile', 'success', 'fa fa-plus', 3000);
                     if (typeof callback === 'function') {
                        callback();
                     } else mptapi.router.render(customScriptCallback);
                  });
               })
               .catch((err) => {
                  jMPT.createNotification('Error!', err, 'danger');
               });
         } else {
            let payload = {};
            MPTRequest.encryptText(jMPT('#cc-number').val(), mptapi.router.data.padKey).then((cc) => {
               //                delete mptapi.router.data.padKey;
               jMPT('#newBillingAddress input:not([type=hidden]), #newBillingAddress select').each(function (i, e) {
                  payload[jMPT(e).data('fieldname')] = jMPT(e).val();
               });
               //Add Payment info
               payload.ccToken = cc;
               payload.ccExp = jMPT('#cc-expiration-month').val() + jMPT('#cc-expiration-year').val();
               payload.ccCvv = jMPT('#cc-cvv').val();
               payload.cardholderFirst = jMPT('#billingfirstName').val();
               payload.cardholderLast = jMPT('#billinglastName').val();
               payload.default = true;
               payload.acctType = 'credit';
               payload.onCheckout = true;

               let req = new AddBillingProfile(payload);
               req.send().then(() => {
                  jMPT.createNotification('Success!', 'Added billing profile', 'success', 'fa fa-plus', 3000);
                  if (typeof callback === 'function') {
                     callback();
                  } else mptapi.router.render(customScriptCallback);
               });
            });
         }
      }
      setTimeout(function () {
         FINIX_API.initForm();
      }, 250);
   },

   confirmation() {
      jMPT('#hyhau').change(function () {
         let leadSource = jMPT(this).val();
         if (leadSource !== 'N/A') {
            jMPT('#hyhauTextFG').slideDown();
            if (jMPT('#hyhau option[value="' + leadSource + '"][data-text]').length > 0) {
               jMPT('#hyhauTextLabel').text(jMPT('#hyhau option:selected').data('text'));
               jMPT('#hyhauText').show();
               jMPT('.save-hyhau').parent().addClass('input-group-append');
            } else {
               jMPT('#hyhauTextLabel').text(null);
               jMPT('#hyhauText').val(null);
               jMPT('#hyhauText').hide();
               jMPT('.save-hyhau').parent().removeClass('input-group-append');
            }
         } else {
            jMPT('#hyhauText').val(null);
            jMPT('#hyhauTextFG').slideUp();
         }
      });
      jMPT('.save-hyhau').click(function () {
         let $this = jMPT(this);
         $this.attr('disabled', true);
         let orderId = jMPT('.order-id').text();
         let leadSource = jMPT('#hyhau').val();
         let leadDetail = jMPT('#hyhauText').val();
         let req = new UpdateLeadSource(orderId, leadSource, leadDetail);
         req.send().then((x) => {
            jMPT('#hyhau-icon').removeClass('fa-arrow-right').addClass('fa-badge-check');
            $this.closest('.card-body').append('<p>', { class: 'text-success', text: 'Thank you!' });
         });
      });
   },
   //#endregion

   //#region Globals
   /**
    * 4. Globals
    */

   /**
    * 4a. Custombox modals
    * Handles Custombox open close functionality.
    */
   globals() {
      jMPT('[data-toggle=mpt-modal]').off('click.mpt-modal.open');
      jMPT('[data-dismiss=mpt-modal]').off('click.mpt-modal.close');
      jMPT('[data-dismiss=mpt-modal-validate]').off('click.mpt-modal.close');
      jMPT('[data-dismiss=mpt-modal-validate]').on('click.mpt-modal.close', function () {
         let parent = jMPT(this).closest('.mpt-modal');
         let parentData = parent.data();
         if (parentData.hasOwnProperty('valid')) {
            if (parent.data().valid) {
               Custombox.modal.close();
            }
         } else {
            Custombox.modal.close();
         }
      });
      jMPT('[data-toggle=mpt-modal]').on('click.mpt-modal.open', MPTUI.generateModal);
      jMPT('[data-dismiss=mpt-modal]').on('click.mpt-modal.close', function () {
         if (typeof Custombox === 'object') {
            Custombox.modal.close();
         }
         console.log('closing');
      });
   },
   disableModalClose() {
      jMPT('[data-dismiss=mpt-modal]').off('click.mpt-modal.close');
   },
   enableModalClose() {
      jMPT('[data-dismiss=mpt-modal]').on('click.mpt-modal.close', function () {
         if (typeof Custombox === 'object') {
            Custombox.modal.close();
         }
      });
   },
   closeModal() {
      if (typeof Custombox === 'object') {
         Custombox.modal.close();
      } else console.warn('Custombox is not loaded.');
   },
   contactForm() {
      jMPT('.mpt-send-contact-form').click(function () {
         let _this = this;
         let id = jMPT(this).data('id') || '';
         let validationObj = {};
         validationObj[`#firstName${id}`] = {
            blank: {
               required: false,
               message: 'Please enter a first name.',
            },
         };
         validationObj[`#lastName${id}`] = {
            blank: {
               required: false,
               message: 'Please enter a last name.',
            },
         };
         validationObj[`#email${id}`] = {
            blank: {
               required: false,
               message: 'Please enter an email.',
            },
         };
         validationObj[`#subject${id}`] = {
            blank: {
               required: false,
               message: 'Please enter a subject.',
            },
         };
         validationObj[`#content${id}`] = {
            blank: {
               required: false,
               message: 'Message must have content.',
            },
         };

         jMPT.validateFields(validationObj).then((x) => {
            let payload = {
               content: jMPT(`#content${id}`).val().trim(),
               subject: jMPT(`#subject${id}`).val().trim(),
               firstName: jMPT(`#firstName${id}`).val().trim(),
               lastName: jMPT(`#lastName${id}`).val().trim(),
               email: jMPT(`#email${id}`).val().trim(),
               phone: jMPT(`#phone${id}`).val().trim(),
            };
            if (id !== '') {
               payload.subscriptionId = id;
            }
            let req = new ContactForm(payload);
            req.send().then((x) => {
               jMPT(`#contactFormDiv${id}`).html('Contact sent. Please allow for 24-48 hours for a response.');
               jMPT(_this).hide();
            });
         });
      });
   },

   regeneratePageControls(pages, pagePrefix = 'page') {
      let t = Handlebars.compile(jMPT('#pageControllerTemplate').html().decHTML());

      if (mptapi.companyInfo.uiSettings.serverSideShopPage) {
         let currentPageNum = mptapi.router.data.pageNum || 0;
         let locParams = '';
         if (window.location.search) {
            locParams += '&pn=';
         } else {
            locParams = '?pn=';
         }

         let currentUrlPath = window.location.origin + window.location.pathname + window.location.search;

         for (let i = 0; i < pages.length; i++) {
            let params = locParams + i;
            pages[i].url = currentUrlPath + params + window.location.hash;
            if (currentPageNum === i) pages[i].active = true;
         }

         Object.defineProperty(pages, 'prevActive', {
            configurable: false,
            writable: true,
            enumerable: false,
            value: currentPageNum != 0,
         });

         Object.defineProperty(pages, 'nextActive', {
            configurable: false,
            writable: true,
            enumerable: false,
            value: currentPageNum !== pages.length - 1,
         });
      } else {
         pages[0].active = true;
      }

      Object.defineProperty(pages, 'pagePrefix', {
         configurable: false,
         writable: true,
         enumerable: false,
         value: pagePrefix,
      });

      //next page url
      //last page url

      /*let addtlOptions = {
			activePageNum
		};
		pages = Object.assign(pages, addtlOptions);*/

      return t(pages);
   },

   /**
    * 4b. generateModal
    * Function to generate a modal. Allows for custom options per use.
    * @returns {boolean}
    */
   generateModal(element, extra, mobilebox, closed) {
      let small = 799;
      let browserWidth = jMPT(window).width();
      let target = null;
      let extraOptions = null;
      let mobileOptions = null;
      if (typeof element !== 'string') {
         target = jMPT(this).data('target');
         extraOptions = JSON.parse(jMPT(target).attr('data-customsettings') || JSON.stringify(extra || {}));
         mobileOptions = JSON.parse(jMPT(target).attr('data-mobilesettings') || JSON.stringify(mobilebox || {}));
      } else {
         target = element;
         extraOptions = extra || {};
         mobileOptions = mobilebox || {};
      }

      let safeTarget = target.substr(0, 1) === '#' ? target.substr(1) : target;

      let options = {
         content: {
            id: safeTarget,
            effect: 'fadein',
            target: target,
            width: browserWidth <= small ? '90%' : '50%', //90% on mobile
            speedIn: 200,
            speedOut: 200,
            delay: 100,
         },
         loader: {
            active: false,
         },
      };
      if (browserWidth < small) {
         if (mobileOptions) {
            if (mobileOptions.hasOwnProperty('content')) {
               options.content = Object.assign(options.content || {}, mobileOptions.content);
            }
            if (mobileOptions.hasOwnProperty('overlay')) {
               options.overlay = Object.assign(options.overlay || {}, mobileOptions.overlay);
            }
         }
      } else {
         if (extraOptions) {
            if (extraOptions.hasOwnProperty('content')) {
               options.content = Object.assign(options.content || {}, extraOptions.content);
            }
            if (extraOptions.hasOwnProperty('overlay')) {
               options.overlay = Object.assign(options.overlay || {}, extraOptions.overlay);
            }
         }
      }

      let modal = new Custombox.modal(options);
      if (!closed) modal.open(); //mptapi.router.openModal(target.substr(1), modal);
      MPTUI.enableModalClose();

      try {
         let $modal = jMPT(modal.content.element);
         if ($modal.find('.slick-initialized').length > 0) {
            let $thisSlick = jQuery($modal.find('.mpt-product-image-container')[0]);

            setTimeout(function () {
               $thisSlick.slick('resize');
            }, 250);
         }
      } catch (err) {
         console.error(err);
      }

      if (target.startsWith('#addPaymentModal')) {
         setTimeout(function () {
            if (mptapi.companyInfo?.finixObject?.mid) {
               if (mptapi.companyInfo?.currency === 'CAD') {
                  FINIX_API.options.defaultCountry = 'CAN';
                  FINIX_API.options.placeholders = {...FINIX_API.options.placeholders, address_postal_code: 'Postal Code', address_region: 'Region'};
                  FINIX_API.options.labels = {...FINIX_API.options.labels, address_postal_code: 'Postal Code'};
               } else {
                  FINIX_API.options.defaultCountry = 'USA';
                  FINIX_API.options.hideFields.push('address_country');
                  FINIX_API.options.placeholders = {...FINIX_API.options.placeholders, address_postal_code: 'Zip Code'};
               }
               FINIX_API.form = window.Finix.CardTokenForm('addPayment-form', {...FINIX_API.options, submitLabel: 'Save New Payment'});
            }
         }, 250);
      }
      return modal;
   },

   /**
    * Enables Pagination functionality in conjunction with handlebars template
    */
   paginate() {
      if (mptapi.companyInfo.uiSettings && mptapi.companyInfo.uiSettings.serverSideShopPage) {
         jMPT('.page-item:not(.page-next):not(.page-prev)').click(function () {
            let pageid = jMPT(this).data('pageId');
            mptapi.router.changeHash('#products', { pageNum: pageid }, true);
         });
      } else {
         //Numbered Pages
         jMPT('.page-item:not(.page-next):not(.page-prev)').click(function () {
            let target = jMPT(jMPT(this).find('.page-link').data('target'));
            let pageid = jMPT(this).data('pageId');
            jMPT('.page-item.active').removeClass('active');
            jMPT('.paginate.active').removeClass('active');
            jMPT(this).addClass('active');
            jMPT('.page-item[data-page-id=' + pageid + ']').addClass('active');
            target.addClass('active');
            let pageitems = jMPT(this).parent().children().toArray();
            if (pageitems.indexOf(this) > 1) {
               jMPT('.page-prev').removeClass('disabled');
            } else {
               jMPT('.page-prev').addClass('disabled');
            }
            if (pageitems.indexOf(this) < pageitems.length - 2) {
               jMPT('.page-next').removeClass('disabled');
            } else {
               jMPT('.page-next').addClass('disabled');
            }
         });
      }

      // Next Button
      jMPT('.page-next').click(function () {
         if (!jMPT(this).hasClass('disabled')) {
            jMPT('.page-item.active').next().click();
         }
      });

      //Prev Button
      jMPT('.page-prev').click(function () {
         if (!jMPT(this).hasClass('disabled')) {
            jMPT('.page-item.active').prev().click();
         }
      });
   },
   //#endregion
};

/**
 * Global Scripts
 */

if (typeof ajaxurl === 'undefined' && mptapi && mptapi.cartDropdown && !mptapi.cartDropdown.mobileMode) {
   jMPT(window).on('scroll', function () {
      //position shop sidebar
      if (jMPT('#products aside').length > 0) {
         let coords = jMPT('header').first().children()[0].getBoundingClientRect();
         jMPT('#products aside').css({
            position: 'sticky',
            top: coords.bottom,
         });
      }
   });
}

/*Mobile Check*/
let _isMobile = false;
if (
   /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent,
   ) ||
   /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([-\s_agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([\s-\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([\s\/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([-\sov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([\-\s])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
      navigator.userAgent.substr(0, 4),
   )
) {
   _isMobile = true;
}
